/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript';
import {
  Method,
  prepare,
  QueryStringArrayFormat,
  RequestBodyType,
  ResponseBodyType,
} from 'yapi-to-typescript';
// @ts-ignore
import request from '../ajax/index';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_1_0_0 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_0 = '' as any;
const prodUrl_0_1_0_0 = '' as any;
const dataKey_0_1_0_0 = 'data' as any;

/**
 * 接口 [保存报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/229094) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/save`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormSavePostRequest {
  /**
   * 报销单Code
   */
  expenseFormCode?: string;
  /**
   * 报销单业务Code
   */
  businessCode?: string;
  /**
   * 报销单类型
   * 1-差旅；2-会议；3-培训；4-采购；6-公务接待；7-一般事项；9-通用采购；10-政府购买服务；11-办公设备家具购置
   */
  fromType:
    | 'TRAVEL_EXPENSE_FORM'
    | 'MEETING_EXPENSE_FORM'
    | 'TRAINING_EXPENSE_FORM'
    | 'PROCUREMENT_EXPENSE_FORM'
    | 'RECEPTION_EXPENSE_FORM'
    | 'GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GOVERNMENT_EXPENSE_FORM'
    | 'PURCHASE_FURNITURE_EXPENSE_FORM'
    | 'MEETING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'TRAINING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'PUBLIC_BUSINESS_PAYMENT_EXPENSE_FORM'
    | 'INVEST_PAYMENT_EXPENSE_FORM'
    | 'REST_EXPENSE_FORM';
  /**
   * 报销事由
   */
  expenseReason: string;
  /**
   * 部门ID
   */
  deptId: number;
  /**
   * 部门名字
   */
  deptName?: string;
  /**
   * 业务类型
   * 1-普通出差、2-专项/会议/培训出差、3-常驻外地出差；4-一类会议、5-二类会议、6-三类会议、27-其他会议；
   * 7-一类培训、8-二类培训；9-集中采购、10-分散采购、11-非政府采购、12-用印申请、13-公务接待、14-一般事项
   * 、16-通用采购、17-政府购买服务、18-办公设备家具购置
   */
  businessType:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 32
    | 29
    | 30
    | 33
    | 35;
  /**
   * 申请单编号
   */
  applyFormCodeList?: string[];
  /**
   * 申请单编号
   */
  applyFormList?: {
    /**
     * 申请单号
     */
    applyFormCode?: string;
    /**
     * 类型
     */
    formType?: string;
  }[];
  /**
   * 关联的申领单类型
   */
  applyFormType?: string;
  /**
   * 行程数据
   */
  itineraries?: {
    /**
     * 前端生成的编号
     */
    indexNo?: string;
    /**
     * 行程单编号
     * 更新时必填
     */
    itineraryCode?: string;
    /**
     * 原行程单号
     */
    originalItineraryCode?: string;
    /**
     * 出差人列表
     */
    accompanyList: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 开始上下午
     */
    beginTag: number;
    /**
     * 结束时间
     */
    endTime: string;
    /**
     * 结束上下午
     */
    endTag: number;
    /**
     * 出差天数
     */
    travelDay: number;
    /**
     * 是否派车 0不派车 1派车
     */
    arrangeCar: number;
    /**
     * 派车信息
     */
    arrangeCarPO?: {
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag: number;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag: number;
      /**
       * 派车天数
       */
      arrangeCarDay: number;
      /**
       * 乘车人
       */
      passengerList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
    };
    /**
     * 出发城市code
     */
    beginCityCode: string;
    /**
     * 出发城市名称
     */
    beginCityName: string;
    /**
     * 目的城市列表
     */
    endCityList: {
      /**
       * 目的城市code
       */
      endCityCode: string;
      /**
       * 目的城市名称
       */
      endCityName: string;
    }[];
    /**
     * 住宿天数
     */
    accommodationDay: number;
  }[];
  /**
   * 报销收款人数据
   */
  expenseFormReceiverPOS?: {
    /**
     * 操作人ID
     */
    operatorId: number;
    /**
     * 账号code
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount: number;
    /**
     * 原收款金额
     */
    originalAmount?: number;
    /**
     * 收款人姓名
     */
    receiverName: string;
    /**
     * 前端数组下标
     */
    indexNo: string;
    /**
     * 收款人Code
     */
    receiverCode?: string;
    /**
     * 调整原因
     */
    updateReason?: string;
    /**
     * 费用更新金额
     */
    modifyFeeAmountDTO?: {
      /**
       * 原始金额
       */
      originalAmount: number;
      /**
       * 修改后金额
       */
      updateAmount: number;
      /**
       * 修改备注
       */
      updateReason?: string;
      /**
       * 原始账户
       */
      originalAccount?: string;
      /**
       * 修改后账户
       */
      updateAccount?: string;
    };
    /**
     * 人员来源 1-系统内部；2-外部人员
     */
    userSource?: 1 | 2;
    userType?: number;
    /**
     * 用户类型
     */
    type?: number;
    /**
     * 类型
     */
    fundsObjectType?:
      | 1
      | 11
      | 12
      | 13
      | 14
      | 19
      | 2
      | 21
      | 22
      | 23
      | 24
      | 3
      | 31
      | 32
      | 4
      | 41
      | 42;
  }[];
  /**
   * 费用集合
   */
  expenseFeeExtendPOS?: {
    indexNo: string;
    /**
     * 费用集合
     */
    expenseFeePOS: {
      /**
       * 唯一标识
       */
      indexNo: string;
      /**
       * 记录的费用code
       */
      feeCode?: string;
      /**
       * 记录的费用名称，用于自定义
       */
      feeName?: string;
      /**
       * 所属机构id
       */
      operatorOrgId?: number;
      /**
       * 所属机构名称
       */
      operatorOrgName?: string;
      /**
       * 费用类型
       */
      feeType: number;
      /**
       * 费用发生时间
       */
      consumeTime: string;
      /**
       * 货币金额
       */
      amount: number;
      /**
       * 消费城市区划
       */
      districtCode?: string;
      /**
       * 消费城市名称
       */
      districtName?: string;
      /**
       * 关联的发票编号
       */
      invoiceCodes: string[];
      /**
       * 关联的出差人
       */
      accompanyPerson?: {
        /**
         * 人员id
         */
        operatorId: number;
        /**
         * 人员名称
         */
        operatorName: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
         */
        userType?: number;
        userId?: number;
        userName?: string;
        bankCardInfo?: {
          /**
           * 银行代码
           */
          bankCode: string;
          /**
           * 银行名字
           */
          bankName: string;
          /**
           * 账户名称
           */
          accountName: string;
          /**
           * 银行账号
           */
          bankAccount: string;
          /**
           * 银行账号 脱敏
           */
          bankAccountDesc?: string;
          /**
           * 卡号保存的唯一标识
           */
          accountCode?: string;
        };
        /**
         * 同一个人员，绑定的id
         */
        bindOperatorId?: number;
        /**
         * 用户类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type: number;
        /**
         * 用户职级,
         * 内部用户的职级，外部用户关联内部用户，取内部用户职级
         * 否则去外部用户职级
         */
        userRank?: string;
        /**
         * 手机号
         */
        mobile?: string;
        /**
         * 证件号码
         */
        idCard?: string;
        /**
         * 证件类型
         */
        idType?: number;
        /**
         * 性别
         */
        gender?: number;
        /**
         * 同行人费用code
         */
        feeCode?: string;
      }[];
      /**
       * 材料数据
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
          /**
           * 原始金额
           */
          originalAmount?: number;
        }[];
      };
      /**
       * 费用附件
       */
      attachments: {
        fileId: string;
        fileType?: string;
        fileName: string;
        fileSize?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        downloadUrl?: string;
      }[];
      /**
       * 关联的单号
       */
      formCode?: string;
      /**
       * 单据类型：1-申请单，2-报销单
       */
      formType?: number;
      /**
       * 修改金额历史
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 原始的feeRecordId
       */
      originalFeeId?: number;
      /**
       * 平台订单编号
       */
      platformOrderNo?: string;
      /**
       * 明细说明
       */
      remark?: string;
      /**
       * 明细数据
       */
      detailExtendDTO?: {
        /**
         * 详细列表页
         */
        expenseFeeDetailInfoList?: {
          /**
           * 前端需要参数
           */
          indexNo?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          userType?: number;
          type?: number;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 原始信息（当前补贴）
           */
          originalInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
          /**
           * 重复补贴
           */
          conflictInfoList?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          }[];
          /**
           * 费用种类
           */
          feeCategory?: number;
          /**
           * 实际补贴金额
           */
          amount?: number;
          /**
           * 原始计算金额
           */
          originalAmount?: number;
          /**
           * 调整前金额
           */
          beforeChangeAmount?: number;
          /**
           * 冲突的金额
           */
          conflictAmount?: number;
          /**
           * 扣减金额
           */
          reductionAmount?: number;
          /**
           * 最大允许金额
           */
          allowMaxAmount?: number;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否发生变更
           */
          isChanged?: boolean;
        }[];
        /**
         * 冲突展示列表页
         */
        expenseFeeConflictList?: {
          /**
           * 业务编码
           */
          businessCode?: string;
          /**
           * 单据编号
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: number;
          /**
           * 业务类型
           */
          businessType?: number;
          /**
           * 业务类型描述
           */
          businessTypeDesc?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 冲突信息
           */
          conflictInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
        }[];
        /**
         * 调整后金额
         */
        currentAmount?: number;
        /**
         * 原始金额
         */
        originalAmount?: number;
        /**
         * 费用类型
         */
        feeType?: number;
        /**
         * 火车金额
         */
        trainAmount?: number;
        /**
         * 总金额相等
         */
        totalAmountEquals?: boolean;
      };
      /**
       * 交易信息编码 for 会议培训多收款人
       */
      tradeCode?: string;
    }[];
    feeParentType: number;
    totalAmount: number;
    currencyCode?: string;
  }[];
  /**
   * 公共事业缴费账单信息
   */
  expensePublicPaymentBillList?: {
    /**
     * 账单code
     */
    publicBillCode?: string;
    /**
     * 区划code
     */
    districtCode?: string;
    /**
     * 缴费项目
     * 1-水费 2-电费 3-燃气费 4-话费 5-邮费 6-过路费 7-五险一金(作废) 8-个税 9-社保 10-公积金 11-残保金 99-其他
     */
    paymentProjectType: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 99;
    /**
     * 收费单位
     */
    chargeOrgName: string;
    /**
     * 缴费账户
     */
    paymentAccountName: string;
    /**
     * 账单月份
     */
    billMonth: string;
    /**
     * 金额：分
     */
    amount: number;
    /**
     * 扩展字段
     */
    extendFiled?: string;
    /**
     * 账单来源 0手动上传 1自动同步
     */
    origin?: number;
    billAttachmentFileList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  }[];
  /**
   * 费用总金额
   */
  feeTotalAmount?: number;
  /**
   * 综合定额总金额
   */
  mixFeeTotalAmount?: number;
  /**
   * 是否忽略警告
   */
  isIgnoreWarning?: boolean;
  /**
   * 触发原因
   */
  triggerWarningReason?: string;
  /**
   * 超标原因列表
   */
  excessiveReasonPOS?: {
    /**
     * 校验分组code
     */
    excessiveReasonList: {
      /**
       * 校验结果分组code
       */
      checkGroupCode?: string;
      /**
       * 父标题
       */
      parentTitle?: string;
      /**
       * 子标题
       */
      subTitle?: string;
      /**
       * 合并code
       */
      mergeGroupCode?: string;
      /**
       * 是否必填
       */
      isMust?: number;
      /**
       * 备注长度
       */
      remarkLength?: number;
    }[];
    /**
     * 超标原因
     */
    excessiveReason: string;
  }[];
  /**
   * 收款总金额
   */
  totalAmount: number;
  /**
   * 扩展信息
   */
  extendFieldDTO: {
    /**
     * 差旅扩展字段
     */
    travelExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 是否派车：1-派车，2-不派车
       */
      arrangeCar?: string;
      /**
       * 派车天数
       */
      dayCount?: number;
      extra?: string;
      /**
       * 三方拓展字段
       */
      thirdExtend?: string;
      /**
       * 差旅报销方式
       */
      travelExpenseMethod?: '由申请单报销' | '凭票报销';
      /**
       * 工号
       */
      workNo?: string;
      /**
       * 是否项目出差
       */
      isProject?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 所属部门
       */
      depName?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 项目名称
       */
      projectName?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 项目负责人
       */
      projectHeader?: {
        key?: string;
        value?: string;
        label?: string;
      };
    };
    /**
     * 会议扩展字段（包含多收款人）
     */
    meetingExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 1 签掉表 2 签到表附件
       */
      signType?: number;
      /**
       * 签到表
       */
      signForm?: {
        signFormCode?: string;
        /**
         * 签到表名称
         */
        signFormName?: string;
        /**
         * 申请表状态
         * 0-未发布 1-已发布 2-已结束
         */
        formStatus?: number;
        /**
         * 申请表状态名称
         */
        formStatusName?: string;
        /**
         * 结束时间
         */
        endTime?: number;
      };
      /**
       * 1申请单携带 2 手动选择
       */
      isExpenseInit?: number;
      /**
       * 会议名称
       */
      meetingName: string;
      /**
       * 会议地点code
       */
      meetingCityCode?: string;
      /**
       * 会议地点名称
       */
      meetingCityName?: string;
      /**
       * 会议开始日期
       */
      meetingStartDate?: string;
      /**
       * 会议结束日期
       */
      meetingEndDate?: string;
      /**
       * 会议天数
       */
      meetingDayCount?: number;
      /**
       * 会议预计参会人数
       */
      meetingExpectAttendeeCount: number;
      /**
       * 会议实际参会人数
       */
      meetingRealAttendeeCount?: number;
      /**
       * 会议工作人员人数
       */
      meetingWorkerCount?: number;
      /**
       * 参会领导信息
       */
      meetingLeaderInfo?: string;
      /**
       * 会议议程
       */
      meetingAgenda?: string;
      /**
       * 是否纳入预算
       * 1-是，2-否
       */
      isIncludedBudget?: number;
      /**
       * 会议差异内容
       */
      meetingDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal?: number;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 详细地址信息
       */
      detailAddress?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 培训扩展字段（包含多收款人）
     */
    trainingExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 1 签掉表 2 签到表附件
       */
      signType?: number;
      /**
       * 签到表
       */
      signForm?: {
        signFormCode?: string;
        /**
         * 签到表名称
         */
        signFormName?: string;
        /**
         * 申请表状态
         * 0-未发布 1-已发布 2-已结束
         */
        formStatus?: number;
        /**
         * 申请表状态名称
         */
        formStatusName?: string;
        /**
         * 结束时间
         */
        endTime?: number;
      };
      /**
       * 1申请单携带 2 手动选择
       */
      isExpenseInit?: number;
      /**
       * 培训名称
       */
      trainingName?: string;
      /**
       * 培训地点code
       */
      trainingCityCode?: string;
      /**
       * 培训地点名称
       */
      trainingCityName?: string;
      /**
       * 培训开始日期
       */
      trainingStartDate?: string;
      /**
       * 培训结束日期
       */
      trainingEndDate?: string;
      /**
       * 培训天数
       */
      trainingDayCount?: number;
      /**
       * 培训预计参会人数
       */
      trainingExpectAttendeeCount?: number;
      /**
       * 培训实际参会人数
       */
      trainingRealAttendeeCount?: number;
      /**
       * 培训工作人员人数
       */
      trainingWorkerCount?: number;
      /**
       * 培训议程
       */
      trainingAgenda?: string;
      /**
       * 是否纳入预算
       * 1-是，2-否
       */
      isIncludedBudget?: number;
      /**
       * 培训差异内容
       */
      trainingDifferenceContent?: string;
      /**
       * 培训讲师信息
       */
      trainingTeacherInfo?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal?: number;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource?: number;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
      /**
       * 变更支付方式说明
       */
      changePayModeReason?: string;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 详细地址信息
       */
      detailAddress?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 采购扩展字段
     */
    procurementExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 采购内容
       */
      procurementContent?: string;
      /**
       * 采购差异内容
       */
      procurementDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 费用合计
       */
      applyAmount?: number;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 公务接待
     */
    receptionExtendFields?: {
      /**
       * 来访单位
       */
      visitOrgName: string;
      /**
       * 是否同城（宁波场景不需要）
       * 1-是，2-否
       */
      isSameCity?: number;
      /**
       * 来访人员职务
       */
      visitorDuty?: string;
      /**
       * 来访事由
       */
      visitReason: string;
      /**
       * 来访开始日期
       */
      visitStartDate: string;
      /**
       * 来访结束日期
       */
      visitEndDate: string;
      /**
       * 来访人员级别：1-省部级、2-厅局级、99-其他
       */
      visitorLevel: number;
      /**
       * 来访人员级别名称
       */
      visitorLevelName?: string;
      /**
       * 来访人数
       */
      visitorCount: number;
      /**
       * 主宾姓名
       */
      mainGuest?: string;
      /**
       * 接待地点code
       */
      receptionCityCode: string;
      /**
       * 接待地点名称
       */
      receptionCityName: string;
      /**
       * 接待详细地点
       */
      receptionDetailAddress?: string;
      /**
       * 就餐日期
       */
      mealDate: string;
      /**
       * 工作餐形式：1-自助餐、2-桌餐
       */
      mealType: 1 | 2 | 3;
      /**
       * 工作餐形式
       */
      mealTypeName?: string;
      /**
       * 用餐时间：1-早餐，2-中餐，3-晚餐
       */
      mealTimeType?: 1 | 2 | 3;
      /**
       * 用餐时间
       */
      mealTimeTypeName?: string;
      /**
       * 陪餐人数（宁波场景不需要）
       */
      escortCount?: number;
      /**
       * 配餐人员姓名
       */
      escortPerson?: string;
      /**
       * 接待预算金额
       */
      receptionBudgetAmount?: number;
      /**
       * 来访人员信息
       */
      visitorInformation?: {
        /**
         * 访问人员名称
         */
        visitorName?: string;
        /**
         * 访问人员职级
         */
        visitorLevel?: number;
        /**
         * 访问人员职级名称
         */
        visitorLevelName?: string;
        /**
         * 来访人员职务
         */
        visitorDuty?: string;
        /**
         * 来访人员单位名称
         */
        visitorUnitName?: string;
      }[];
      /**
       * 接待人员信息
       */
      receptionistInformation?: {
        /**
         * 接待人员名称
         */
        receptionistName?: string;
        /**
         * 接待人员职级
         */
        receptionistLevel?: number;
        /**
         * 接待人员职级名称
         */
        receptionistLevelName?: string;
      }[];
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 一般事项
     */
    generalExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 事项详细内容
       */
      detailContent: string;
      /**
       * 事项预算
       */
      eventBudget?: number;
      /**
       * 事项详细内容与事前审批的差异
       */
      generalDifferenceContent?: string;
      extra?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 用印申请
     */
    contractExtendFields?: {
      /**
       * 合同版本编号
       */
      contractVersionUniqueCode?: string;
    };
    /**
     * 招标书
     */
    tenderApplyExtendFields?: {
      /**
       * 申请单类型
       */
      applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
      /**
       * 申请事由
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务单据号
       */
      businessCode?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
    };
    /**
     * 通用采购申请拓展字段
     */
    purchaseGeneralFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm?: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * isCreatePurchaseProposal
       * 采购类型
       * 1-政府采购，2-非政府采购
       */
      purchaseType?: 1 | 2;
      /**
       * 采购类型描述
       */
      purchaseTypeDesc?: string;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource?: 1 | 2;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 政府购买服务申请拓展字段
     */
    govermentApplyFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * 采购类型
       * 1-政府采购，2-非政府采购
       */
      purchaseType: 1 | 2;
      /**
       * 采购类型描述
       */
      purchaseTypeDesc?: string;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource: 1 | 2;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 办公家具购置申请拓展字段
     */
    furnitureApplyFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 全链路二期 报销的统一拓展字段
     */
    purchaseGeneralExpenseFieldDTO?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 交易方式：线上；线下
       */
      tradeWay?: string[];
      /**
       * 采购差异内容
       */
      procurementDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 交易方式
       */
      tradeWayName?: string;
      /**
       * 是否有合同
       */
      addContract?: boolean;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 公共事业缴费统一拓展字段
     */
    publicBusinessPaymentFieldDTO?: {
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 无相拓展
     */
    generalExtra?: string;
  };
  /**
   * 单据附件
   */
  formAttachmentDTO: {
    /**
     * 默认附件列表
     */
    normalAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 说明附件列表
     */
    thatAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 通知附件列表
     */
    informAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 合同附件列表
     */
    compactAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 签到附件列表
     */
    signAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 派出单位公函附件列表
     */
    officialLetterAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 接待清单附件列表
     */
    receptionMenuAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 采购意向附件列表
     */
    purchasePurposeAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 资产更新计划
     */
    propertyUpdatePlanAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 集体决策会议纪要
     */
    meetingSummaryAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专家论证意见
     */
    argumentSuggestionAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专项、会议、培训附件列表
     */
    specialAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 银行回单附件
     */
    bankReceiptAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 账单附件
     */
    billAttachmentFileList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  };
  /**
   * 发票列表code
   */
  invoiceCodeS?: string[];
  /**
   * 订单发票关系 for 会议/培训/办公用品采购 todo 订单发票关系也要处理
   */
  orderInvoiceList?: {
    /**
     * 订单号
     */
    orderCode?: string;
    /**
     * 发票单号
     */
    platformInvoiceId: string;
    /**
     * 发票金额
     */
    invoiceAmount?: number;
  }[];
  /**
   * 单据订单 for 会议/培训/办公用品采购
   */
  orderExpenseFormList?: null;
  /**
   * 合同信息 for 会议/培训/办公用品采购
   * 「已废弃」
   */
  contractExpenseFormList?: null;
  /**
   * 备注
   */
  remark?: null;
  /**
   * 采购交易信息 for 采购多收款人报销单
   * 添加交易信息字段包含订单合同发票等信息，之前的订单合同发票字段照常传惨
   */
  tradeInfoList?: null;
  /**
   * 采购结算单编码列表
   */
  purchaseSettleCodeList?: string[];
  /**
   * 单据快照
   */
  formSnapshotCode?: null;
  /**
   * 是否无票报销,采购场景单收款人使用;0非无票报销  1无票报销为补充  2无票报销已补充
   */
  withoutInvoiceStatus?: null;
  /**
   * 工作流数据
   */
  workflowInfo?: {
    /**
     * 业务标识
     */
    bizId?: null;
    /**
     * 必填, 业务场景
     */
    bizType?: null;
    /**
     * 业务编码
     */
    businessCode?: null;
    /**
     * 子类型
     */
    subType?: null;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: null;
    /**
     * 必填, 工作流模型ID
     */
    processModelId?: null;
    /**
     * 必填, 工作流模型版本
     */
    version?: null;
    /**
     * 节点审批信息
     */
    auditInfos?: null;
    /**
     * 扩展条件，for百搭
     */
    extConditions?: null;
    /**
     * 业务上下文
     */
    context?: null;
    /**
     * 当前操作入Id
     */
    operatorId?: null;
    /**
     * 备注
     */
    remark?: null;
  };
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: null;
}

/**
 * 接口 [保存报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/229094) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/save`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/229094) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/save`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/229094) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/save`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormSavePostRequestConfig: ZlbApiExpenseExpenseFormSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/229094) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/save`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormSavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormSavePostResponse>(
    prepare(zlbApiExpenseExpenseFormSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormSavePost.requestConfig = zlbApiExpenseExpenseFormSavePostRequestConfig;

/**
 * 接口 [更新报销单信息-财务审核时调用↗](http://yapi.cai-inc.com/project/3621/interface/api/229126) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/update`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormUpdatePostRequest {
  /**
   * 报销单Code
   */
  expenseFormCode: string;
  /**
   * 报销收款人数据
   */
  expenseFormReceiverPOS: {
    /**
     * 操作人ID
     */
    operatorId: number;
    /**
     * 账号code
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount: number;
    /**
     * 原收款金额
     */
    originalAmount?: number;
    /**
     * 收款人姓名
     */
    receiverName: string;
    /**
     * 前端数组下标
     */
    indexNo: string;
    /**
     * 收款人Code
     */
    receiverCode?: string;
    /**
     * 调整原因
     */
    updateReason?: string;
    /**
     * 费用更新金额
     */
    modifyFeeAmountDTO?: {
      /**
       * 原始金额
       */
      originalAmount: number;
      /**
       * 修改后金额
       */
      updateAmount: number;
      /**
       * 修改备注
       */
      updateReason?: string;
      /**
       * 原始账户
       */
      originalAccount?: string;
      /**
       * 修改后账户
       */
      updateAccount?: string;
    };
    /**
     * 人员来源 1-系统内部；2-外部人员
     */
    userSource?: 1 | 2;
    userType?: number;
    /**
     * 用户类型
     */
    type?: number;
    /**
     * 类型
     */
    fundsObjectType?:
      | 1
      | 11
      | 12
      | 13
      | 14
      | 19
      | 2
      | 21
      | 22
      | 23
      | 24
      | 3
      | 31
      | 32
      | 4
      | 41
      | 42;
  }[];
  /**
   * 付款人数据,当为自有基金支付的时候，付款账户数据不能为空
   */
  expenseFormPayAccountPO?: {
    /**
     * 付款账户accountCode，传递支付系统的银行卡的accountCode
     */
    accountCode: string;
    /**
     * 付款金额
     */
    payAmount: number;
  };
  /**
   * 费用数据列表
   */
  expenseFeeExtendPOS?: {
    indexNo: string;
    /**
     * 费用集合
     */
    expenseFeePOS: {
      /**
       * 唯一标识
       */
      indexNo: string;
      /**
       * 记录的费用code
       */
      feeCode?: string;
      /**
       * 记录的费用名称，用于自定义
       */
      feeName?: string;
      /**
       * 所属机构id
       */
      operatorOrgId?: number;
      /**
       * 所属机构名称
       */
      operatorOrgName?: string;
      /**
       * 费用类型
       */
      feeType: number;
      /**
       * 费用发生时间
       */
      consumeTime: string;
      /**
       * 货币金额
       */
      amount: number;
      /**
       * 消费城市区划
       */
      districtCode?: string;
      /**
       * 消费城市名称
       */
      districtName?: string;
      /**
       * 关联的发票编号
       */
      invoiceCodes: string[];
      /**
       * 关联的出差人
       */
      accompanyPerson?: {
        /**
         * 人员id
         */
        operatorId: number;
        /**
         * 人员名称
         */
        operatorName: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
         */
        userType?: number;
        userId?: number;
        userName?: string;
        bankCardInfo?: {
          /**
           * 银行代码
           */
          bankCode: string;
          /**
           * 银行名字
           */
          bankName: string;
          /**
           * 账户名称
           */
          accountName: string;
          /**
           * 银行账号
           */
          bankAccount: string;
          /**
           * 银行账号 脱敏
           */
          bankAccountDesc?: string;
          /**
           * 卡号保存的唯一标识
           */
          accountCode?: string;
        };
        /**
         * 同一个人员，绑定的id
         */
        bindOperatorId?: number;
        /**
         * 用户类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type: number;
        /**
         * 用户职级,
         * 内部用户的职级，外部用户关联内部用户，取内部用户职级
         * 否则去外部用户职级
         */
        userRank?: string;
        /**
         * 手机号
         */
        mobile?: string;
        /**
         * 证件号码
         */
        idCard?: string;
        /**
         * 证件类型
         */
        idType?: number;
        /**
         * 性别
         */
        gender?: number;
        /**
         * 同行人费用code
         */
        feeCode?: string;
      }[];
      /**
       * 材料数据
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
          /**
           * 原始金额
           */
          originalAmount?: number;
        }[];
      };
      /**
       * 费用附件
       */
      attachments: {
        fileId: string;
        fileType?: string;
        fileName: string;
        fileSize?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        downloadUrl?: string;
      }[];
      /**
       * 关联的单号
       */
      formCode?: string;
      /**
       * 单据类型：1-申请单，2-报销单
       */
      formType?: number;
      /**
       * 修改金额历史
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 原始的feeRecordId
       */
      originalFeeId?: number;
      /**
       * 平台订单编号
       */
      platformOrderNo?: string;
      /**
       * 明细说明
       */
      remark?: string;
      /**
       * 明细数据
       */
      detailExtendDTO?: {
        /**
         * 详细列表页
         */
        expenseFeeDetailInfoList?: {
          /**
           * 前端需要参数
           */
          indexNo?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          userType?: number;
          type?: number;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 原始信息（当前补贴）
           */
          originalInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
          /**
           * 重复补贴
           */
          conflictInfoList?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          }[];
          /**
           * 费用种类
           */
          feeCategory?: number;
          /**
           * 实际补贴金额
           */
          amount?: number;
          /**
           * 原始计算金额
           */
          originalAmount?: number;
          /**
           * 调整前金额
           */
          beforeChangeAmount?: number;
          /**
           * 冲突的金额
           */
          conflictAmount?: number;
          /**
           * 扣减金额
           */
          reductionAmount?: number;
          /**
           * 最大允许金额
           */
          allowMaxAmount?: number;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否发生变更
           */
          isChanged?: boolean;
        }[];
        /**
         * 冲突展示列表页
         */
        expenseFeeConflictList?: {
          /**
           * 业务编码
           */
          businessCode?: string;
          /**
           * 单据编号
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: number;
          /**
           * 业务类型
           */
          businessType?: number;
          /**
           * 业务类型描述
           */
          businessTypeDesc?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 冲突信息
           */
          conflictInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
        }[];
        /**
         * 调整后金额
         */
        currentAmount?: number;
        /**
         * 原始金额
         */
        originalAmount?: number;
        /**
         * 费用类型
         */
        feeType?: number;
        /**
         * 火车金额
         */
        trainAmount?: number;
        /**
         * 总金额相等
         */
        totalAmountEquals?: boolean;
      };
      /**
       * 交易信息编码 for 会议培训多收款人
       */
      tradeCode?: string;
    }[];
    feeParentType: number;
    totalAmount: number;
    currencyCode?: string;
  }[];
  /**
   * 收款总金额
   */
  totalAmount: number;
  /**
   * 预算指标信息
   */
  budgetInfoPO?: {
    /**
     * 主预算编号
     */
    mainBudgetCode: number;
    /**
     * 预算指标编号
     */
    budgetUk: string;
    /**
     * 支付限额经济分类主键
     */
    budgetPlanClassifyUk: string;
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 交易信息 for 会议/培训多收款人
     */
    tradeCode?: string;
    /**
     * 支付记录信息code
     */
    payRecordCode?: string;
  }[];
  /**
   * 预算额度信息
   */
  quotaInfoPO?: {
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 预算额度id
     */
    budgetQuotaId: string;
    /**
     * 交易信息 for 会议/培训多收款人
     */
    tradeCode?: string;
    /**
     * 支付记录信息code
     */
    payRecordCode?: string;
  }[];
  /**
   * 是否忽略警告
   */
  isIgnoreWarning?: boolean;
  /**
   * 费用总金额
   */
  feeTotalAmount: number;
  /**
   * 综合定额费用
   */
  mixFeeTotalAmount?: number;
  /**
   * 是否需要忽略费控校验
   */
  needIgnoreCheckFee?: boolean;
  /**
   * 支付方式(1：国库支付，3：非财政资金网银结算，4：库集中支付+非财政资金结算
   */
  payMode?: number;
  /**
   * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
   * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
   */
  payStrategy?: number;
  /**
   * 变更支付方式说明
   */
  changePayModeReason?: string;
  /**
   * 摘要
   */
  summary?: string;
  /**
   * 单据附件
   */
  formAttachmentDTO?: {
    /**
     * 默认附件列表
     */
    normalAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 说明附件列表
     */
    thatAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 通知附件列表
     */
    informAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 合同附件列表
     */
    compactAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 签到附件列表
     */
    signAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 派出单位公函附件列表
     */
    officialLetterAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 接待清单附件列表
     */
    receptionMenuAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 采购意向附件列表
     */
    purchasePurposeAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 资产更新计划
     */
    propertyUpdatePlanAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 集体决策会议纪要
     */
    meetingSummaryAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专家论证意见
     */
    argumentSuggestionAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专项、会议、培训附件列表
     */
    specialAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 银行回单附件
     */
    bankReceiptAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 账单附件
     */
    billAttachmentFileList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  };
  /**
   * 宁波收款明细PO
   */
  receiverPayInfoQueryList?: {
    /**
     * 收款卡基本信息
     */
    receiverPO?: {
      /**
       * 操作人ID
       */
      operatorId: number;
      /**
       * 账号code
       */
      accountCode?: string;
      /**
       * 收款金额
       */
      amount: number;
      /**
       * 原收款金额
       */
      originalAmount?: number;
      /**
       * 收款人姓名
       */
      receiverName: string;
      /**
       * 前端数组下标
       */
      indexNo: string;
      /**
       * 收款人Code
       */
      receiverCode?: string;
      /**
       * 调整原因
       */
      updateReason?: string;
      /**
       * 费用更新金额
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 人员来源 1-系统内部；2-外部人员
       */
      userSource?: 1 | 2;
      userType?: number;
      /**
       * 用户类型
       */
      type?: number;
      /**
       * 类型
       */
      fundsObjectType?:
        | 1
        | 11
        | 12
        | 13
        | 14
        | 19
        | 2
        | 21
        | 22
        | 23
        | 24
        | 3
        | 31
        | 32
        | 4
        | 41
        | 42;
    };
    /**
     * 个人卡报销
     */
    personalCardExpenseQueryList?: {
      /**
       * 前端下标
       */
      indexNo: string;
      /**
       * 消费金额
       */
      amount?: number;
      /**
       * 拆分的金额
       */
      splitAmount?: number[];
      /**
       * 报销里的消费记录主键
       */
      consumptionRecordCode?: string;
      /**
       * 拆分金额
       */
      splitAmountDetail?: {
        /**
         * 拆分金额
         */
        amount: number;
        /**
         * 支付类型
         */
        payStrategy:
          | 'FINA_ZERO_PAY'
          | 'UNIT_ZERO_PAY'
          | 'UNIT_FUND_PAY'
          | 'FINA_SPLIT_PAY'
          | 'AUTH_NORMAL_PAY'
          | 'DIRECTLY_NORMAL_PAY'
          | 'AUTH_BUSINESS_CARD_PAY'
          | 'AUTH_PERSONAL_BATCH_PAY'
          | 'AUTH_ENTERPRISE_BATCH_PAY'
          | 'FINA_AND_FUND_PAY'
          | 'UNIT_FUND_NORMAL_PAY'
          | 'UNIT_FUND_OFF_CARD_PAY'
          | 'NB_FINA_ZERO_PAY'
          | 'NB_UNIT_ZERO_PAY'
          | 'NB_UNIT_FUND_PAY'
          | 'NB_FINA_SPLIT_PAY'
          | 'CBS_NORMAL_PAY'
          | 'CBS_BATCH_PAY';
        /**
         * 支付类型名称
         */
        payStrategyName?: string;
      }[];
    }[];
  }[];
  /**
   * 预算关联关系
   * 目前存在情况，在财务审核时，预算可以直接与单据关联，也可以与收款人关联（一般事项多收款），后续也有其他关联
   * 注意：当前字段只有在一般事项多收款人（坑中坑注意！！！）
   */
  budgetRelationInfoPOList?: {
    /**
     * 关联预算的Code
     */
    budgetRelationBusinessCode: string;
    /**
     * 关联预算业务数据类型
     * EXPENSE_FORM(1, "报销单"),
     * TRADE(2, "交易"),
     * ACCOUNT(3, "收款账户"),
     */
    relationBusinessType:
      | '报销单'
      | '交易'
      | '收款账户'
      | '工资流水'
      | '夜餐费发放单'
      | '项目支付单';
    /**
     * TRUE使用指标，FALSE使用额度
     */
    budgetFlag: boolean;
    /**
     * 预算指标信息
     */
    budgetInfoPOList?: {
      /**
       * 主预算编号
       */
      mainBudgetCode: number;
      /**
       * 预算指标编号
       */
      budgetUk: string;
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk: string;
      /**
       * 预算金额
       */
      budgetAmount: number;
      /**
       * 交易信息 for 会议/培训多收款人
       */
      tradeCode?: string;
      /**
       * 支付记录信息code
       */
      payRecordCode?: string;
    }[];
    /**
     * 预算额度信息
     */
    quotaInfoPOList?: {
      /**
       * 预算金额
       */
      budgetAmount: number;
      /**
       * 预算额度id
       */
      budgetQuotaId: string;
      /**
       * 交易信息 for 会议/培训多收款人
       */
      tradeCode?: string;
      /**
       * 支付记录信息code
       */
      payRecordCode?: string;
    }[];
  }[];
  /**
   * 工作流业务属性
   */
  workflowBizProperties?: {
    /**
     * 修改费用标记
     */
    editableAmount?: number;
  };
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
    /**
     * 科目级联uk
     */
    subjectUkHierarchy?: string[];
    /**
     * 科目级联
     */
    subjectNameHierarchy?: string[];
  }[];
  /**
   * 包干经费预算
   */
  fundBudget?: {
    /**
     * 是否包干经费 true=是 false=否
     */
    isFundBudget?: null;
    /**
     * 包干经费预算uk
     */
    fundBudgetUk?: null;
    /**
     * 包干经费预算名称
     */
    fundBudgetName?: null;
    /**
     * 经费uk
     */
    fundBudgetItemUk?: null;
    /**
     * 经费名称
     */
    fundBudgetItemName?: null;
    /**
     * 占用金额
     */
    usedAmount?: null;
  };
  /**
   * 通用扩展字段
   */
  generalExtra?: string;
  /**
   * 其他资金明细列表
   */
  restDetailList?: {
    indexNo?: string;
    restDetailCode?: string;
    summary: string;
    deptName?: string;
    deptId?: number;
    actSubjectCode: string;
    actSubjectName: string;
    depEconomicClassifyCode?: string;
    depEconomicClassifyName?: string;
    expendFunctionClassifySubjectCode?: string;
    expendFunctionClassifySubjectName?: string;
    projectCode?: string;
    projectName?: string;
    budgetUk?: string;
    fundAttrType: number;
    budgetAmount: number;
    ledgerFormCode?: string;
  }[];
  /**
   * 会计科目-本方科目
   */
  actSubjectCode?: string;
  /**
   * 会计科目名称-本方科目
   */
  actSubjectName?: string;
  /**
   * 是否启用核算（其他资金，如若扩展则可增加）:0-否,1-是
   */
  isEnableAccount?: number;
}

/**
 * 接口 [更新报销单信息-财务审核时调用↗](http://yapi.cai-inc.com/project/3621/interface/api/229126) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/update`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormUpdatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态 0：通过 1：警告 2：强控 3 提示
     */
    checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
    /**
     * 行程冲突校验结果
     */
    itineraryCheckResultRO?: {
      /**
       * 所有行程是否通过行程校验
       * 通过：0
       */
      checkStatus?: number;
      /**
       * 报销单行程校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 行程数组索引
         */
        indexNo?: string;
        /**
         * 每段行程的提示文案及校验状态
         */
        itineraryCheckResultList?: {
          /**
           * 校验状态
           * 0-通过 1-弱控 2-强控 3-提示
           */
          checkStatus?: 0 | 1 | 2 | 3;
          /**
           * 提示文案
           */
          message?: string;
        }[];
      }[];
      /**
       * 整体提示信息
       * 暂时仅有不足申请单的部分有赋值
       */
      overallCheckResult?: {
        /**
         * 校验状态
         * 0-通过 1-弱控 2-强控 3-提示
         */
        checkStatus?: 0 | 1 | 2 | 3;
        /**
         * 提示文案
         */
        message?: string;
      };
    };
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
            /**
             * 校验结果
             */
            checkStatus?: number;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
              /**
               * 校验结果
               */
              checkStatus?: number;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
            /**
             * 设置结果
             */
            resultInfo?: {
              /**
               * 凭票报销总结果
               */
              expenseFeeInvoiceResult?: {
                /**
                 * 用户id
                 */
                operatorId?: number;
                /**
                 * 用户名称
                 */
                operatorName?: string;
                /**
                 * 报销金额
                 */
                amount?: number;
                /**
                 * 报销金额描述
                 */
                amountDesc?: string;
                /**
                 * 详细信息
                 */
                detailInfoList?: {
                  /**
                   * 发生日期
                   */
                  happenDate?: null;
                  /**
                   * 是否可以报销
                   */
                  canExpense?: null;
                  /**
                   * 表单code
                   */
                  formCode?: string[];
                  /**
                   * 业务code
                   */
                  businessCode?: string[];
                  /**
                   * 冲突描述
                   */
                  conflictDesc?: null;
                  /**
                   * 是否凭票报销冲突
                   */
                  isUseInvoice?: null;
                  /**
                   * 规则描述
                   */
                  ruleDesc?: null;
                  /**
                   * 金额
                   */
                  ruleAmount?: null;
                }[];
              }[];
              /**
               * 凭票报销总结果提示
               */
              expenseFeeInvoiceTips?: string;
              /**
               * 是否展示
               */
              canShow?: boolean;
            };
            /**
             * 是否需要显示
             */
            canShow?: boolean;
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
          /**
           * 校验结果
           */
          checkStatus?: number;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 预算校验结果
     */
    budgetCheckResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
      /**
       * 预算指标ID
       */
      mainBudgetCode?: number;
      /**
       * 预算指标编号
       */
      budgetUk?: string;
      /**
       * 预算编号(展示)
       */
      financialBudgetDetailId?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 额度ID
       */
      budgetQuotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag?: boolean;
      /**
       * 占用总金额
       */
      budgetTotalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 关联预算的业务信息
       */
      budgetExceptionTipsROS?: {
        /**
         * 关联预算的Code
         */
        budgetRelationBusinessCode?: string;
        /**
         * 关联预算的业务名称描述
         */
        budgetRelationBusinessDesc?: string;
        /**
         * 关联交易描述
         */
        tradeDesc?: string;
        /**
         * 关联预算业务数据类型
         * 直接以枚举的名称作为存储，以便在请求中可以直接看出
         */
        relationBusinessType?:
          | '报销单'
          | '交易'
          | '收款账户'
          | '工资流水'
          | '夜餐费发放单'
          | '项目支付单';
        /**
         * 占用的金额
         */
        budgetAmount?: number;
      }[];
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 预算项目校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 科目校验描述
         */
        subjectCheckDesc?: string;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
      }[];
    };
    /**
     * 收款信息校验结果
     */
    receiverCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 收款信息校验详情
       */
      checkResultInfoROS?: {
        /**
         * 是否通过校验
         */
        checkStatus?: number;
        /**
         * 收款人信息数组下标
         */
        indexNo?: string;
        /**
         * 提示消息
         */
        msg?: string[];
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 支付方式校验结果
     */
    payConfigCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 订单校验结果
     */
    orderCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 报销单号
     */
    expenseFormCode?: string;
    /**
     * 合同校验结果
     */
    contractCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 发票校验结果
     */
    invoiceCheckResultROS?: {
      /**
       * 发票ID
       */
      platformInvoiceId?: string;
      /**
       * 状态码
       */
      code?: number;
      /**
       * 是否可报销 true：可以报销 false：不可以报销
       */
      success?: boolean;
      /**
       * 提示消息
       */
      msg?: string;
    }[];
    /**
     * 超标原因配置
     */
    reasonConfigROS?: {
      /**
       * 状态
       */
      checkStatus?: number;
      /**
       * 规则列表
       */
      ruleInfoROS?: {
        /**
         * 规则描述
         */
        ruleDesc?: string;
        /**
         * 规则code
         */
        ruleCode?: string;
        /**
         * 状态
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      }[];
      /**
       * 超标配置列表
       */
      reasonConfigList?: {
        /**
         * 校验结果分组code
         */
        checkGroupCode?: string;
        /**
         * 父标题
         */
        parentTitle?: string;
        /**
         * 子标题
         */
        subTitle?: string;
        /**
         * 合并code
         */
        mergeGroupCode?: string;
        /**
         * 是否必填
         */
        isMust?: number;
        /**
         * 备注长度
         */
        remarkLength?: number;
      }[];
    };
    /**
     * 含有异常申请单的列表（校验通过时为空数组）
     */
    applyFormCheckResultROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 检查结果
       */
      checkResult?: 0 | 1 | 2;
      /**
       * 检查结果描述
       */
      checkResultDesc?: '通过' | '已作废' | '已关联';
      /**
       * 被关联的其他报销单号
       */
      certainExpenseFormCode?: string[];
    }[];
    /**
     * 其他资金校验
     */
    restFundCheckRO?: {
      /**
       * 基础校验
       */
      baseControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string[];
      };
      /**
       * 资金控制校验
       */
      fundControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string;
        /**
         * 校验公共参数
         */
        checkList?: {
          indexNo?: string;
          checkStatus?: number;
          checkMessage?: string;
          extraJson?: string;
          bindCount?: number;
        }[];
      };
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [更新报销单信息-财务审核时调用↗](http://yapi.cai-inc.com/project/3621/interface/api/229126) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/update`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormUpdatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [更新报销单信息-财务审核时调用↗](http://yapi.cai-inc.com/project/3621/interface/api/229126) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/update`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormUpdatePostRequestConfig: ZlbApiExpenseExpenseFormUpdatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/update',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormUpdatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [更新报销单信息-财务审核时调用↗](http://yapi.cai-inc.com/project/3621/interface/api/229126) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/update`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormUpdatePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormUpdatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormUpdatePostResponse>(
    prepare(zlbApiExpenseExpenseFormUpdatePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormUpdatePost.requestConfig = zlbApiExpenseExpenseFormUpdatePostRequestConfig;

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/235350) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasic`
 * @更新时间 `2021-12-30 10:43:58`
 * @项目ID 3621
 */
export type ZlbApiExpenseExpenseFormInitExpenseFormBasicPostRequest = string[];

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/235350) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasic`
 * @更新时间 `2021-12-30 10:43:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormBasicPostResponse {
  success?: boolean;
  result?: {
    /**
     * 单据类型编号
     */
    businessTypeNo?: string;
    /**
     * 单据类型名称
     */
    businessTypeName?: string;
    /**
     * 工作单位ID
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 工作部门ID
     */
    deptId?: number;
    /**
     * 工作部门名称
     */
    deptName?: string;
    /**
     * 申请事由
     */
    applyReason?: string;
    /**
     * 拓展字段
     */
    extendField?: string;
    /**
     * 申请时间
     */
    initiationTime?: string;
    /**
     * 申请人
     */
    applyUserName?: string;
    /**
     * 行程信息
     */
    itinerarySplitROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 0：由原行程生成 1：由原行程拆分 2：用户新增
       */
      sourceType?: number;
      originalItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 城市code
           */
          endCityCode?: string;
          /**
           * 城市名称
           */
          endCityName?: string;
        }[];
      };
      /**
       * 行程拆分结果
       */
      currentItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 城市code
           */
          endCityCode?: string;
          /**
           * 城市名称
           */
          endCityName?: string;
        }[];
      };
    }[];
    /**
     * 收款人信息
     */
    expenseReceiverRO?: {
      /**
       * 收款信息Code
       */
      receiverCode?: string;
      accountCode?: string;
      /**
       * 卡号
       */
      cardNo?: string;
      /**
       * 银行卡或者公务卡 0：银行卡 1：公务卡
       */
      cardType?: number;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 操作人ID
       */
      operatorId?: number;
      /**
       * 收款人姓名
       */
      receiverName?: string;
    };
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/235350) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasic`
 * @更新时间 `2021-12-30 10:43:58`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInitExpenseFormBasicPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/initExpenseFormBasic',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/235350) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasic`
 * @更新时间 `2021-12-30 10:43:58`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInitExpenseFormBasicPostRequestConfig: ZlbApiExpenseExpenseFormInitExpenseFormBasicPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/initExpenseFormBasic',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInitExpenseFormBasicPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/235350) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasic`
 * @更新时间 `2021-12-30 10:43:58`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInitExpenseFormBasicPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInitExpenseFormBasicPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInitExpenseFormBasicPostResponse>(
    prepare(zlbApiExpenseExpenseFormInitExpenseFormBasicPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInitExpenseFormBasicPost.requestConfig =
  zlbApiExpenseExpenseFormInitExpenseFormBasicPostRequestConfig;

/**
 * 接口 [校验预算年度↗](http://yapi.cai-inc.com/project/3621/interface/api/236046) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/checkBudgetYear`
 * @更新时间 `2023-03-08 14:28:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCheckBudgetYearPostRequest {
  budgetId: string;
}

/**
 * 接口 [校验预算年度↗](http://yapi.cai-inc.com/project/3621/interface/api/236046) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/checkBudgetYear`
 * @更新时间 `2023-03-08 14:28:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCheckBudgetYearPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [校验预算年度↗](http://yapi.cai-inc.com/project/3621/interface/api/236046) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/checkBudgetYear`
 * @更新时间 `2023-03-08 14:28:19`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormCheckBudgetYearPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/checkBudgetYear',
    'data',
    string,
    'budgetId',
    false
  >
>;

/**
 * 接口 [校验预算年度↗](http://yapi.cai-inc.com/project/3621/interface/api/236046) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/checkBudgetYear`
 * @更新时间 `2023-03-08 14:28:19`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormCheckBudgetYearPostRequestConfig: ZlbApiExpenseExpenseFormCheckBudgetYearPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/checkBudgetYear',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: ['budgetId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormCheckBudgetYearPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验预算年度↗](http://yapi.cai-inc.com/project/3621/interface/api/236046) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/checkBudgetYear`
 * @更新时间 `2023-03-08 14:28:19`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormCheckBudgetYearPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormCheckBudgetYearPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormCheckBudgetYearPostResponse>(
    prepare(zlbApiExpenseExpenseFormCheckBudgetYearPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormCheckBudgetYearPost.requestConfig =
  zlbApiExpenseExpenseFormCheckBudgetYearPostRequestConfig;

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/236070) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasicInfo`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export type ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoPostRequest = string[];

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/236070) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasicInfo`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单据类型编号
     */
    businessType?: number;
    /**
     * 单据类型名称
     */
    businessTypeName?: string;
    /**
     * 工作单位ID
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 工作部门ID
     */
    deptId?: number;
    /**
     * 申请单数据
     */
    applyFormSimpleInfoROS?: {
      /**
       * 申请原因
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 申请用户姓名
       */
      applyUserName?: string;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 申请时间
       */
      initiationDateTime?: string;
      /**
       * 申请单业务编号
       */
      businessCode?: string;
      /**
       * 申请单状态
       */
      formStatus?: 1 | 2 | 3 | 4 | 5;
      /**
       * 出差开始时间
       */
      travelStartTime?: string;
      /**
       * 业务名称：会议名称，培训名称、采购名称
       */
      businessName?: string;
      /**
       * 剩余金额
       */
      applyRemainingAmount?: number;
      /**
       * 数据来源
       */
      dataSource?: number;
      /**
       * 附件列表
       */
      formAttachmentDTO?: {
        /**
         * 默认附件列表
         */
        normalAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 说明附件列表
         */
        thatAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 通知附件列表
         */
        informAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 合同附件列表
         */
        compactAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 签到附件列表
         */
        signAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 派出单位公函附件列表
         */
        officialLetterAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 接待清单附件列表
         */
        receptionMenuAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 采购意向附件列表
         */
        purchasePurposeAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 资产更新计划
         */
        propertyUpdatePlanAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 集体决策会议纪要
         */
        meetingSummaryAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专家论证意见
         */
        argumentSuggestionAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专项、会议、培训附件列表
         */
        specialAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 银行回单附件
         */
        bankReceiptAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 账单附件
         */
        billAttachmentFileList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
      };
      /**
       * 扩展信息
       */
      extendFieldDTO?: {
        /**
         * 差旅扩展字段
         */
        travelExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 是否派车：1-派车，2-不派车
           */
          arrangeCar?: string;
          /**
           * 派车天数
           */
          dayCount?: number;
          extra?: string;
          /**
           * 三方拓展字段
           */
          thirdExtend?: string;
          /**
           * 差旅报销方式
           */
          travelExpenseMethod?: '由申请单报销' | '凭票报销';
          /**
           * 工号
           */
          workNo?: string;
          /**
           * 是否项目出差
           */
          isProject?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 所属部门
           */
          depName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目名称
           */
          projectName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目负责人
           */
          projectHeader?: {
            key?: string;
            value?: string;
            label?: string;
          };
        };
        /**
         * 会议扩展字段（包含多收款人）
         */
        meetingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 会议名称
           */
          meetingName: string;
          /**
           * 会议地点code
           */
          meetingCityCode?: string;
          /**
           * 会议地点名称
           */
          meetingCityName?: string;
          /**
           * 会议开始日期
           */
          meetingStartDate?: string;
          /**
           * 会议结束日期
           */
          meetingEndDate?: string;
          /**
           * 会议天数
           */
          meetingDayCount?: number;
          /**
           * 会议预计参会人数
           */
          meetingExpectAttendeeCount: number;
          /**
           * 会议实际参会人数
           */
          meetingRealAttendeeCount?: number;
          /**
           * 会议工作人员人数
           */
          meetingWorkerCount?: number;
          /**
           * 参会领导信息
           */
          meetingLeaderInfo?: string;
          /**
           * 会议议程
           */
          meetingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 会议差异内容
           */
          meetingDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 培训扩展字段（包含多收款人）
         */
        trainingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 培训名称
           */
          trainingName?: string;
          /**
           * 培训地点code
           */
          trainingCityCode?: string;
          /**
           * 培训地点名称
           */
          trainingCityName?: string;
          /**
           * 培训开始日期
           */
          trainingStartDate?: string;
          /**
           * 培训结束日期
           */
          trainingEndDate?: string;
          /**
           * 培训天数
           */
          trainingDayCount?: number;
          /**
           * 培训预计参会人数
           */
          trainingExpectAttendeeCount?: number;
          /**
           * 培训实际参会人数
           */
          trainingRealAttendeeCount?: number;
          /**
           * 培训工作人员人数
           */
          trainingWorkerCount?: number;
          /**
           * 培训议程
           */
          trainingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 培训差异内容
           */
          trainingDifferenceContent?: string;
          /**
           * 培训讲师信息
           */
          trainingTeacherInfo?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: number;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 变更支付方式说明
           */
          changePayModeReason?: string;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 采购扩展字段
         */
        procurementExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 采购内容
           */
          procurementContent?: string;
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 费用合计
           */
          applyAmount?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公务接待
         */
        receptionExtendFields?: {
          /**
           * 来访单位
           */
          visitOrgName: string;
          /**
           * 是否同城（宁波场景不需要）
           * 1-是，2-否
           */
          isSameCity?: number;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
          /**
           * 来访事由
           */
          visitReason: string;
          /**
           * 来访开始日期
           */
          visitStartDate: string;
          /**
           * 来访结束日期
           */
          visitEndDate: string;
          /**
           * 来访人员级别：1-省部级、2-厅局级、99-其他
           */
          visitorLevel: number;
          /**
           * 来访人员级别名称
           */
          visitorLevelName?: string;
          /**
           * 来访人数
           */
          visitorCount: number;
          /**
           * 主宾姓名
           */
          mainGuest?: string;
          /**
           * 接待地点code
           */
          receptionCityCode: string;
          /**
           * 接待地点名称
           */
          receptionCityName: string;
          /**
           * 接待详细地点
           */
          receptionDetailAddress?: string;
          /**
           * 就餐日期
           */
          mealDate: string;
          /**
           * 工作餐形式：1-自助餐、2-桌餐
           */
          mealType: 1 | 2 | 3;
          /**
           * 工作餐形式
           */
          mealTypeName?: string;
          /**
           * 用餐时间：1-早餐，2-中餐，3-晚餐
           */
          mealTimeType?: 1 | 2 | 3;
          /**
           * 用餐时间
           */
          mealTimeTypeName?: string;
          /**
           * 陪餐人数（宁波场景不需要）
           */
          escortCount?: number;
          /**
           * 配餐人员姓名
           */
          escortPerson?: string;
          /**
           * 接待预算金额
           */
          receptionBudgetAmount?: number;
          /**
           * 来访人员信息
           */
          visitorInformation?: {
            /**
             * 访问人员名称
             */
            visitorName?: string;
            /**
             * 访问人员职级
             */
            visitorLevel?: number;
            /**
             * 访问人员职级名称
             */
            visitorLevelName?: string;
            /**
             * 来访人员职务
             */
            visitorDuty?: string;
            /**
             * 来访人员单位名称
             */
            visitorUnitName?: string;
          }[];
          /**
           * 接待人员信息
           */
          receptionistInformation?: {
            /**
             * 接待人员名称
             */
            receptionistName?: string;
            /**
             * 接待人员职级
             */
            receptionistLevel?: number;
            /**
             * 接待人员职级名称
             */
            receptionistLevelName?: string;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 一般事项
         */
        generalExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 事项详细内容
           */
          detailContent: string;
          /**
           * 事项预算
           */
          eventBudget?: number;
          /**
           * 事项详细内容与事前审批的差异
           */
          generalDifferenceContent?: string;
          extra?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 用印申请
         */
        contractExtendFields?: {
          /**
           * 合同版本编号
           */
          contractVersionUniqueCode?: string;
        };
        /**
         * 招标书
         */
        tenderApplyExtendFields?: {
          /**
           * 申请单类型
           */
          applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
          /**
           * 申请事由
           */
          applyReason?: string;
          /**
           * 申请单Code
           */
          applyFormCode?: string;
          /**
           * 业务单据号
           */
          businessCode?: string;
          /**
           * 提交时间
           */
          submitTime?: string;
        };
        /**
         * 通用采购申请拓展字段
         */
        purchaseGeneralFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm?: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * isCreatePurchaseProposal
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType?: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 政府购买服务申请拓展字段
         */
        govermentApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 办公家具购置申请拓展字段
         */
        furnitureApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 全链路二期 报销的统一拓展字段
         */
        purchaseGeneralExpenseFieldDTO?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 交易方式：线上；线下
           */
          tradeWay?: string[];
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 交易方式
           */
          tradeWayName?: string;
          /**
           * 是否有合同
           */
          addContract?: boolean;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公共事业缴费统一拓展字段
         */
        publicBusinessPaymentFieldDTO?: {
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 无相拓展
         */
        generalExtra?: string;
      };
      formType?: string;
    }[];
    /**
     * 工作部门名称
     */
    deptName?: string;
    /**
     * 申请事由
     */
    expenseReason?: string;
    /**
     * 扩展信息
     */
    extendFieldDTO?: {
      /**
       * 差旅扩展字段
       */
      travelExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 是否派车：1-派车，2-不派车
         */
        arrangeCar?: string;
        /**
         * 派车天数
         */
        dayCount?: number;
        extra?: string;
        /**
         * 三方拓展字段
         */
        thirdExtend?: string;
        /**
         * 差旅报销方式
         */
        travelExpenseMethod?: '由申请单报销' | '凭票报销';
        /**
         * 工号
         */
        workNo?: string;
        /**
         * 是否项目出差
         */
        isProject?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 所属部门
         */
        depName?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 项目名称
         */
        projectName?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 项目负责人
         */
        projectHeader?: {
          key?: string;
          value?: string;
          label?: string;
        };
      };
      /**
       * 会议扩展字段（包含多收款人）
       */
      meetingExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 1 签掉表 2 签到表附件
         */
        signType?: number;
        /**
         * 签到表
         */
        signForm?: {
          signFormCode?: string;
          /**
           * 签到表名称
           */
          signFormName?: string;
          /**
           * 申请表状态
           * 0-未发布 1-已发布 2-已结束
           */
          formStatus?: number;
          /**
           * 申请表状态名称
           */
          formStatusName?: string;
          /**
           * 结束时间
           */
          endTime?: number;
        };
        /**
         * 1申请单携带 2 手动选择
         */
        isExpenseInit?: number;
        /**
         * 会议名称
         */
        meetingName: string;
        /**
         * 会议地点code
         */
        meetingCityCode?: string;
        /**
         * 会议地点名称
         */
        meetingCityName?: string;
        /**
         * 会议开始日期
         */
        meetingStartDate?: string;
        /**
         * 会议结束日期
         */
        meetingEndDate?: string;
        /**
         * 会议天数
         */
        meetingDayCount?: number;
        /**
         * 会议预计参会人数
         */
        meetingExpectAttendeeCount: number;
        /**
         * 会议实际参会人数
         */
        meetingRealAttendeeCount?: number;
        /**
         * 会议工作人员人数
         */
        meetingWorkerCount?: number;
        /**
         * 参会领导信息
         */
        meetingLeaderInfo?: string;
        /**
         * 会议议程
         */
        meetingAgenda?: string;
        /**
         * 是否纳入预算
         * 1-是，2-否
         */
        isIncludedBudget?: number;
        /**
         * 会议差异内容
         */
        meetingDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal?: number;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 详细地址信息
         */
        detailAddress?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 培训扩展字段（包含多收款人）
       */
      trainingExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 1 签掉表 2 签到表附件
         */
        signType?: number;
        /**
         * 签到表
         */
        signForm?: {
          signFormCode?: string;
          /**
           * 签到表名称
           */
          signFormName?: string;
          /**
           * 申请表状态
           * 0-未发布 1-已发布 2-已结束
           */
          formStatus?: number;
          /**
           * 申请表状态名称
           */
          formStatusName?: string;
          /**
           * 结束时间
           */
          endTime?: number;
        };
        /**
         * 1申请单携带 2 手动选择
         */
        isExpenseInit?: number;
        /**
         * 培训名称
         */
        trainingName?: string;
        /**
         * 培训地点code
         */
        trainingCityCode?: string;
        /**
         * 培训地点名称
         */
        trainingCityName?: string;
        /**
         * 培训开始日期
         */
        trainingStartDate?: string;
        /**
         * 培训结束日期
         */
        trainingEndDate?: string;
        /**
         * 培训天数
         */
        trainingDayCount?: number;
        /**
         * 培训预计参会人数
         */
        trainingExpectAttendeeCount?: number;
        /**
         * 培训实际参会人数
         */
        trainingRealAttendeeCount?: number;
        /**
         * 培训工作人员人数
         */
        trainingWorkerCount?: number;
        /**
         * 培训议程
         */
        trainingAgenda?: string;
        /**
         * 是否纳入预算
         * 1-是，2-否
         */
        isIncludedBudget?: number;
        /**
         * 培训差异内容
         */
        trainingDifferenceContent?: string;
        /**
         * 培训讲师信息
         */
        trainingTeacherInfo?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal?: number;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource?: number;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
        /**
         * 变更支付方式说明
         */
        changePayModeReason?: string;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 详细地址信息
         */
        detailAddress?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 采购扩展字段
       */
      procurementExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 采购内容
         */
        procurementContent?: string;
        /**
         * 采购差异内容
         */
        procurementDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 费用合计
         */
        applyAmount?: number;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 公务接待
       */
      receptionExtendFields?: {
        /**
         * 来访单位
         */
        visitOrgName: string;
        /**
         * 是否同城（宁波场景不需要）
         * 1-是，2-否
         */
        isSameCity?: number;
        /**
         * 来访人员职务
         */
        visitorDuty?: string;
        /**
         * 来访事由
         */
        visitReason: string;
        /**
         * 来访开始日期
         */
        visitStartDate: string;
        /**
         * 来访结束日期
         */
        visitEndDate: string;
        /**
         * 来访人员级别：1-省部级、2-厅局级、99-其他
         */
        visitorLevel: number;
        /**
         * 来访人员级别名称
         */
        visitorLevelName?: string;
        /**
         * 来访人数
         */
        visitorCount: number;
        /**
         * 主宾姓名
         */
        mainGuest?: string;
        /**
         * 接待地点code
         */
        receptionCityCode: string;
        /**
         * 接待地点名称
         */
        receptionCityName: string;
        /**
         * 接待详细地点
         */
        receptionDetailAddress?: string;
        /**
         * 就餐日期
         */
        mealDate: string;
        /**
         * 工作餐形式：1-自助餐、2-桌餐
         */
        mealType: 1 | 2 | 3;
        /**
         * 工作餐形式
         */
        mealTypeName?: string;
        /**
         * 用餐时间：1-早餐，2-中餐，3-晚餐
         */
        mealTimeType?: 1 | 2 | 3;
        /**
         * 用餐时间
         */
        mealTimeTypeName?: string;
        /**
         * 陪餐人数（宁波场景不需要）
         */
        escortCount?: number;
        /**
         * 配餐人员姓名
         */
        escortPerson?: string;
        /**
         * 接待预算金额
         */
        receptionBudgetAmount?: number;
        /**
         * 来访人员信息
         */
        visitorInformation?: {
          /**
           * 访问人员名称
           */
          visitorName?: string;
          /**
           * 访问人员职级
           */
          visitorLevel?: number;
          /**
           * 访问人员职级名称
           */
          visitorLevelName?: string;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
          /**
           * 来访人员单位名称
           */
          visitorUnitName?: string;
        }[];
        /**
         * 接待人员信息
         */
        receptionistInformation?: {
          /**
           * 接待人员名称
           */
          receptionistName?: string;
          /**
           * 接待人员职级
           */
          receptionistLevel?: number;
          /**
           * 接待人员职级名称
           */
          receptionistLevelName?: string;
        }[];
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 一般事项
       */
      generalExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 事项详细内容
         */
        detailContent: string;
        /**
         * 事项预算
         */
        eventBudget?: number;
        /**
         * 事项详细内容与事前审批的差异
         */
        generalDifferenceContent?: string;
        extra?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 用印申请
       */
      contractExtendFields?: {
        /**
         * 合同版本编号
         */
        contractVersionUniqueCode?: string;
      };
      /**
       * 招标书
       */
      tenderApplyExtendFields?: {
        /**
         * 申请单类型
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请事由
         */
        applyReason?: string;
        /**
         * 申请单Code
         */
        applyFormCode?: string;
        /**
         * 业务单据号
         */
        businessCode?: string;
        /**
         * 提交时间
         */
        submitTime?: string;
      };
      /**
       * 通用采购申请拓展字段
       */
      purchaseGeneralFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm?: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * isCreatePurchaseProposal
         * 采购类型
         * 1-政府采购，2-非政府采购
         */
        purchaseType?: 1 | 2;
        /**
         * 采购类型描述
         */
        purchaseTypeDesc?: string;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource?: 1 | 2;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 政府购买服务申请拓展字段
       */
      govermentApplyFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * 采购类型
         * 1-政府采购，2-非政府采购
         */
        purchaseType: 1 | 2;
        /**
         * 采购类型描述
         */
        purchaseTypeDesc?: string;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource: 1 | 2;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 办公家具购置申请拓展字段
       */
      furnitureApplyFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 全链路二期 报销的统一拓展字段
       */
      purchaseGeneralExpenseFieldDTO?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 交易方式：线上；线下
         */
        tradeWay?: string[];
        /**
         * 采购差异内容
         */
        procurementDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 交易方式
         */
        tradeWayName?: string;
        /**
         * 是否有合同
         */
        addContract?: boolean;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 公共事业缴费统一拓展字段
       */
      publicBusinessPaymentFieldDTO?: {
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 无相拓展
       */
      generalExtra?: string;
    };
    /**
     * 行程信息
     */
    itinerarySplitROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
      /**
       * 0：由原行程生成 1：由原行程拆分 2：用户新增
       */
      sourceType?: number;
      /**
       * 校验状态
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 原行程数据
       */
      originalItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程拆分结果
       */
      currentItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程数据校验结果
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
    }[];
    /**
     * 收款人信息
     */
    expenseReceiverROS?: {
      /**
       * 收款信息Code
       */
      receiverCode?: string;
      bankName?: string;
      bankCode?: string;
      accountCode?: string;
      /**
       * 卡号
       */
      cardNo?: string;
      /**
       * 银行卡或者公务卡 1：银行卡 2：公务卡
       */
      cardType?: number;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 操作人ID
       */
      operatorId?: number;
      /**
       * 收款人姓名
       */
      receiverName?: string;
      /**
       * 用户来源：1、系统内部人员；2-外部人员
       */
      userSource?: number;
    }[];
    /**
     * 业务单号
     */
    businessCode?: string;
    /**
     * 数据来源
     */
    dataSource?: number;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 预算项目
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 占用金额
       */
      amount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 操作人，后端使用
       */
      operatorId?: number;
      /**
       * 科目级联uk
       */
      subjectUkHierarchy?: string[];
      /**
       * 科目级联
       */
      subjectNameHierarchy?: string[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/236070) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasicInfo`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/initExpenseFormBasicInfo',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/236070) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasicInfo`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInitExpenseFormBasicInfoPostRequestConfig: ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/initExpenseFormBasicInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInitExpenseFormBasicInfoPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/236070) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/initExpenseFormBasicInfo`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInitExpenseFormBasicInfoPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoPostResponse>(
    prepare(zlbApiExpenseExpenseFormInitExpenseFormBasicInfoPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInitExpenseFormBasicInfoPost.requestConfig =
  zlbApiExpenseExpenseFormInitExpenseFormBasicInfoPostRequestConfig;

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/236198) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/info/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInfoExpenseFormCodeGetRequest {
  expenseFormCode: string;
}

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/236198) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/info/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInfoExpenseFormCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 是否是企业单位
     */
    isEnterprise?: boolean;
    /**
     * 报销单详情
     */
    expenseFormCode?: string;
    /**
     * 申请单数据
     */
    applyFormSimpleInfoROS?: {
      /**
       * 申请原因
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 申请用户姓名
       */
      applyUserName?: string;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 申请时间
       */
      initiationDateTime?: string;
      /**
       * 申请单业务编号
       */
      businessCode?: string;
      /**
       * 申请单状态
       */
      formStatus?: 1 | 2 | 3 | 4 | 5;
      /**
       * 出差开始时间
       */
      travelStartTime?: string;
      /**
       * 业务名称：会议名称，培训名称、采购名称
       */
      businessName?: string;
      /**
       * 剩余金额
       */
      applyRemainingAmount?: number;
      /**
       * 数据来源
       */
      dataSource?: number;
      /**
       * 附件列表
       */
      formAttachmentDTO?: {
        /**
         * 默认附件列表
         */
        normalAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 说明附件列表
         */
        thatAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 通知附件列表
         */
        informAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 合同附件列表
         */
        compactAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 签到附件列表
         */
        signAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 派出单位公函附件列表
         */
        officialLetterAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 接待清单附件列表
         */
        receptionMenuAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 采购意向附件列表
         */
        purchasePurposeAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 资产更新计划
         */
        propertyUpdatePlanAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 集体决策会议纪要
         */
        meetingSummaryAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专家论证意见
         */
        argumentSuggestionAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专项、会议、培训附件列表
         */
        specialAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 银行回单附件
         */
        bankReceiptAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 账单附件
         */
        billAttachmentFileList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
      };
      /**
       * 扩展信息
       */
      extendFieldDTO?: {
        /**
         * 差旅扩展字段
         */
        travelExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 是否派车：1-派车，2-不派车
           */
          arrangeCar?: string;
          /**
           * 派车天数
           */
          dayCount?: number;
          extra?: string;
          /**
           * 三方拓展字段
           */
          thirdExtend?: string;
          /**
           * 差旅报销方式
           */
          travelExpenseMethod?: '由申请单报销' | '凭票报销';
          /**
           * 工号
           */
          workNo?: string;
          /**
           * 是否项目出差
           */
          isProject?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 所属部门
           */
          depName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目名称
           */
          projectName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目负责人
           */
          projectHeader?: {
            key?: string;
            value?: string;
            label?: string;
          };
        };
        /**
         * 会议扩展字段（包含多收款人）
         */
        meetingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 会议名称
           */
          meetingName: string;
          /**
           * 会议地点code
           */
          meetingCityCode?: string;
          /**
           * 会议地点名称
           */
          meetingCityName?: string;
          /**
           * 会议开始日期
           */
          meetingStartDate?: string;
          /**
           * 会议结束日期
           */
          meetingEndDate?: string;
          /**
           * 会议天数
           */
          meetingDayCount?: number;
          /**
           * 会议预计参会人数
           */
          meetingExpectAttendeeCount: number;
          /**
           * 会议实际参会人数
           */
          meetingRealAttendeeCount?: number;
          /**
           * 会议工作人员人数
           */
          meetingWorkerCount?: number;
          /**
           * 参会领导信息
           */
          meetingLeaderInfo?: string;
          /**
           * 会议议程
           */
          meetingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 会议差异内容
           */
          meetingDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 培训扩展字段（包含多收款人）
         */
        trainingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 培训名称
           */
          trainingName?: string;
          /**
           * 培训地点code
           */
          trainingCityCode?: string;
          /**
           * 培训地点名称
           */
          trainingCityName?: string;
          /**
           * 培训开始日期
           */
          trainingStartDate?: string;
          /**
           * 培训结束日期
           */
          trainingEndDate?: string;
          /**
           * 培训天数
           */
          trainingDayCount?: number;
          /**
           * 培训预计参会人数
           */
          trainingExpectAttendeeCount?: number;
          /**
           * 培训实际参会人数
           */
          trainingRealAttendeeCount?: number;
          /**
           * 培训工作人员人数
           */
          trainingWorkerCount?: number;
          /**
           * 培训议程
           */
          trainingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 培训差异内容
           */
          trainingDifferenceContent?: string;
          /**
           * 培训讲师信息
           */
          trainingTeacherInfo?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: number;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 变更支付方式说明
           */
          changePayModeReason?: string;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 采购扩展字段
         */
        procurementExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 采购内容
           */
          procurementContent?: string;
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 费用合计
           */
          applyAmount?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公务接待
         */
        receptionExtendFields?: {
          /**
           * 来访单位
           */
          visitOrgName: string;
          /**
           * 是否同城（宁波场景不需要）
           * 1-是，2-否
           */
          isSameCity?: number;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
          /**
           * 来访事由
           */
          visitReason: string;
          /**
           * 来访开始日期
           */
          visitStartDate: string;
          /**
           * 来访结束日期
           */
          visitEndDate: string;
          /**
           * 来访人员级别：1-省部级、2-厅局级、99-其他
           */
          visitorLevel: number;
          /**
           * 来访人员级别名称
           */
          visitorLevelName?: string;
          /**
           * 来访人数
           */
          visitorCount: number;
          /**
           * 主宾姓名
           */
          mainGuest?: string;
          /**
           * 接待地点code
           */
          receptionCityCode: string;
          /**
           * 接待地点名称
           */
          receptionCityName: string;
          /**
           * 接待详细地点
           */
          receptionDetailAddress?: string;
          /**
           * 就餐日期
           */
          mealDate: string;
          /**
           * 工作餐形式：1-自助餐、2-桌餐
           */
          mealType: 1 | 2 | 3;
          /**
           * 工作餐形式
           */
          mealTypeName?: string;
          /**
           * 用餐时间：1-早餐，2-中餐，3-晚餐
           */
          mealTimeType?: 1 | 2 | 3;
          /**
           * 用餐时间
           */
          mealTimeTypeName?: string;
          /**
           * 陪餐人数（宁波场景不需要）
           */
          escortCount?: number;
          /**
           * 配餐人员姓名
           */
          escortPerson?: string;
          /**
           * 接待预算金额
           */
          receptionBudgetAmount?: number;
          /**
           * 来访人员信息
           */
          visitorInformation?: {
            /**
             * 访问人员名称
             */
            visitorName?: string;
            /**
             * 访问人员职级
             */
            visitorLevel?: number;
            /**
             * 访问人员职级名称
             */
            visitorLevelName?: string;
            /**
             * 来访人员职务
             */
            visitorDuty?: string;
            /**
             * 来访人员单位名称
             */
            visitorUnitName?: string;
          }[];
          /**
           * 接待人员信息
           */
          receptionistInformation?: {
            /**
             * 接待人员名称
             */
            receptionistName?: string;
            /**
             * 接待人员职级
             */
            receptionistLevel?: number;
            /**
             * 接待人员职级名称
             */
            receptionistLevelName?: string;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 一般事项
         */
        generalExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 事项详细内容
           */
          detailContent: string;
          /**
           * 事项预算
           */
          eventBudget?: number;
          /**
           * 事项详细内容与事前审批的差异
           */
          generalDifferenceContent?: string;
          extra?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 用印申请
         */
        contractExtendFields?: {
          /**
           * 合同版本编号
           */
          contractVersionUniqueCode?: string;
        };
        /**
         * 招标书
         */
        tenderApplyExtendFields?: {
          /**
           * 申请单类型
           */
          applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
          /**
           * 申请事由
           */
          applyReason?: string;
          /**
           * 申请单Code
           */
          applyFormCode?: string;
          /**
           * 业务单据号
           */
          businessCode?: string;
          /**
           * 提交时间
           */
          submitTime?: string;
        };
        /**
         * 通用采购申请拓展字段
         */
        purchaseGeneralFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm?: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * isCreatePurchaseProposal
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType?: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 政府购买服务申请拓展字段
         */
        govermentApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 办公家具购置申请拓展字段
         */
        furnitureApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 全链路二期 报销的统一拓展字段
         */
        purchaseGeneralExpenseFieldDTO?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 交易方式：线上；线下
           */
          tradeWay?: string[];
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 交易方式
           */
          tradeWayName?: string;
          /**
           * 是否有合同
           */
          addContract?: boolean;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公共事业缴费统一拓展字段
         */
        publicBusinessPaymentFieldDTO?: {
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 无相拓展
         */
        generalExtra?: string;
      };
      formType?: string;
    }[];
    /**
     * 单据类型
     */
    expenseFormType?: 1 | 2 | 3 | 4 | 6 | 7 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16;
    /**
     * 单据类型
     */
    expenseFormTypeName?:
      | '差旅报销'
      | '会议报销'
      | '培训报销'
      | '办公用品采购报销'
      | '公务接待报销'
      | '一般事项报销'
      | '通用采购报销'
      | '政府购买服务报销'
      | '办公设备家具购置报销'
      | '公共事业缴费报销'
      | '投资支付'
      | '其他资金报销';
    payStatus?: number;
    /**
     * 业务类型
     */
    businessType?:
      | 1
      | 2
      | 19
      | 20
      | 28
      | 4
      | 5
      | 6
      | 27
      | 31
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 21
      | 22
      | 23
      | 24
      | 25
      | 26
      | 32
      | 29
      | 30
      | 33
      | 35;
    /**
     * 业务类型名称
     */
    businessTypeName?:
      | '普通出差'
      | '专项会议培训'
      | '外派'
      | '外出'
      | '外出培训'
      | '一类会议'
      | '二类会议'
      | '三类会议'
      | '其他会议'
      | '线上会议'
      | '一类培训'
      | '二类培训'
      | '集中采购'
      | '分散采购'
      | '办公用品采购'
      | '用印申请'
      | '公务接待'
      | '一般事项'
      | '招标书申请'
      | '通用采购'
      | '政府购买服务'
      | '办公设备家具购置'
      | '公共事业缴费'
      | '办公用品'
      | '政府服务购买'
      | '个人账户'
      | '企业账户'
      | '投资支付'
      | '其他资金';
    /**
     * 行程数据
     */
    itinerarySplitROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
      /**
       * 0：由原行程生成 1：由原行程拆分 2：用户新增
       */
      sourceType?: number;
      /**
       * 校验状态
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 原行程数据
       */
      originalItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程拆分结果
       */
      currentItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程数据校验结果
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
    }[];
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
            /**
             * 校验结果
             */
            checkStatus?: number;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
              /**
               * 校验结果
               */
              checkStatus?: number;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
            /**
             * 设置结果
             */
            resultInfo?: {
              /**
               * 凭票报销总结果
               */
              expenseFeeInvoiceResult?: {
                /**
                 * 用户id
                 */
                operatorId?: number;
                /**
                 * 用户名称
                 */
                operatorName?: string;
                /**
                 * 报销金额
                 */
                amount?: number;
                /**
                 * 报销金额描述
                 */
                amountDesc?: string;
                /**
                 * 详细信息
                 */
                detailInfoList?: {
                  /**
                   * 发生日期
                   */
                  happenDate?: null;
                  /**
                   * 是否可以报销
                   */
                  canExpense?: null;
                  /**
                   * 表单code
                   */
                  formCode?: string[];
                  /**
                   * 业务code
                   */
                  businessCode?: string[];
                  /**
                   * 冲突描述
                   */
                  conflictDesc?: null;
                  /**
                   * 是否凭票报销冲突
                   */
                  isUseInvoice?: null;
                  /**
                   * 规则描述
                   */
                  ruleDesc?: null;
                  /**
                   * 金额
                   */
                  ruleAmount?: null;
                }[];
              }[];
              /**
               * 凭票报销总结果提示
               */
              expenseFeeInvoiceTips?: string;
              /**
               * 是否展示
               */
              canShow?: boolean;
            };
            /**
             * 是否需要显示
             */
            canShow?: boolean;
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
          /**
           * 校验结果
           */
          checkStatus?: number;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 费用数据
     */
    expenseFormFeeROS?: {
      /**
       * 费用父级code
       */
      feeParentType?: number;
      /**
       * 费用父级描述
       */
      feeParentTypeDesc?: string;
      /**
       * 费用总金额
       */
      totalAmount?: number;
      /**
       * 费用列表
       */
      expenseFeeROList?: {
        /**
         * 费用code
         */
        feeCode?: string;
        /**
         * 费用名称
         */
        feeName?: string;
        /**
         * 人员operatorId
         */
        operatorId?: number;
        /**
         * 费用类型
         */
        feeType: number;
        /**
         * 费用类型描述
         */
        feeTypeDesc?: string;
        /**
         * 费用发生时间
         */
        consumeTime?: string;
        /**
         * 费用发生时间
         */
        consumeTimeDesc?: string;
        /**
         * 货币金额
         */
        amount: number;
        /**
         * 允许的最大金额
         */
        allowMaxAmount?: number;
        /**
         * 消费城市区划
         */
        districtCode?: string;
        /**
         * 消费城市三级区划code
         */
        allDistrictCodes?: string[];
        /**
         * 消费城市名称
         */
        districtName?: string;
        /**
         * 消费城市三级区划名称
         */
        allDistrictNames?: string[];
        /**
         * 关联的发票编号
         */
        invoiceCodes?: string[];
        /**
         * 关联发票的url
         */
        imageUrl?: string;
        /**
         * 浙里半票的url
         */
        zlbImageUrl?: string;
        /**
         * 关联的出差人
         */
        accompanyPerson?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 出差人
         */
        travelerName?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 材料数据
         */
        materialInfo?: {
          /**
           * 凭票报销伙食类补贴信息
           */
          allowanceMaterialByInvoiceDTO?: {
            /**
             * 关联行程编号
             */
            associateItineraryList: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
            }[];
            /**
             * 补贴发生日期
             */
            allowanceHappenDates: string[];
            /**
             * 城市名称s(无用，纯属兼容前端，别删除)
             */
            endCityName?: string;
          };
          /**
           * 住宿类材料信息
           */
          hotelMaterialDTO?: {
            /**
             * 酒店入住开始时间
             */
            hotelEnterTime?: string;
            /**
             * 酒店入住结束时间
             */
            hotelLeaveTime?: string;
            /**
             * 住宿天数
             */
            accommodationDays?: number;
          };
          /**
           * 交通类材料信息
           */
          trafficMaterialDTO?: {
            /**
             * 座位类别
             */
            seatType?: number;
            /**
             * 座位枚举描述
             */
            seatDesc?: string;
            /**
             * 出发地区划code
             */
            fromDistrictCode: string;
            /**
             * 出发地区划名称
             */
            fromDistrictName: string;
            /**
             * 结束地区划code
             */
            endDistrictCode: string;
            /**
             * 结束地区划名称
             */
            endDistrictName: string;
            /**
             * 火车时长码
             */
            trainDurationCode?: number;
            /**
             * 火车时长
             */
            trainDurationDesc?: string;
            /**
             * 出发日期
             */
            departureTime: string;
            /**
             * 公里数
             */
            mileage: number;
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
          };
          /**
           * 补贴类材料
           */
          allowanceMaterialDTO?: {
            /**
             * 总的费用金额
             */
            totalAmount?: number;
            /**
             * 费用标准细项
             */
            itemList?: {
              /**
               * 标准金额
               */
              standardAmount?: number;
              /**
               * 时间-天数
               */
              days?: number;
              /**
               * 费用描述
               */
              ruleDesc?: string;
            }[];
            /**
             * 火车补贴伙食费用细项
             */
            trainAllowanceMaterialDTOS?: {
              /**
               * 火车天数
               */
              trainHours?: number;
              /**
               * 火车补贴金额
               */
              trainStanardAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 用户ID
               */
              operatorId?: number;
              /**
               * 人员来源 1-系统内部；2-外部人员
               */
              userSource?: 1 | 2;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
            }[];
            /**
             * 火车总额度
             */
            trainTotalAmount?: number;
            /**
             * 是否派车
             */
            isCar?: boolean;
            /**
             * 派车铺贴计算
             */
            carAllowanceMaterialDTOS?: {
              /**
               * 派车天数
               */
              carDays?: number;
              /**
               * 派车金额
               */
              carStandardtotalAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
            }[];
          };
          /**
           * 通用类材料信息
           */
          meetingOrTrainMaterialDTO?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 会议类型
             */
            meetingType?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
            /**
             * 培训人员
             */
            trainingPerson?: string;
            /**
             * 培训人员职级
             */
            trainingPersonLevel?: number;
            /**
             * 培训人员职级
             */
            trainingPersonLevelDesc?: string;
            /**
             * 培训时长
             */
            trainingHour?: number;
          };
          /**
           * 业务招待材料信息
           */
          businessEntertainingMaterial?: {
            /**
             * 招待日期
             */
            entertainDate?: string;
            /**
             * 招待形式
             */
            entertainForm: 1 | 2 | 3;
            /**
             * 招待形式描述
             */
            entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
            /**
             * 招待人数
             */
            entertainPeopleNum: number;
            /**
             * 招待事由
             */
            entertainReason: string;
          };
          /**
           * 交通费-租车费材料信息
           */
          rentCarFeeMaterial?: {
            /**
             * 租车申请单信息
             */
            rentCarApplyForm?: {
              /**
               * 业务单据号
               */
              businessNo?: string;
              /**
               * 申请编号
               */
              applyFormCode?: string;
              /**
               * 用车人（前端回显）
               */
              carUserList?: {
                /**
                 * 人员id
                 */
                operatorId: number;
                /**
                 * 人员名称
                 */
                operatorName: string;
                /**
                 * 机构id
                 */
                institutionId?: number;
                /**
                 * 机构名称
                 */
                institutionName?: string;
                /**
                 * 外部人员职级
                 * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
                 */
                outerUserRank?: number;
                /**
                 * 人员类型
                 * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
                 */
                userType?: number;
                userId?: number;
                userName?: string;
                bankCardInfo?: {
                  /**
                   * 银行代码
                   */
                  bankCode: string;
                  /**
                   * 银行名字
                   */
                  bankName: string;
                  /**
                   * 账户名称
                   */
                  accountName: string;
                  /**
                   * 银行账号
                   */
                  bankAccount: string;
                  /**
                   * 银行账号 脱敏
                   */
                  bankAccountDesc?: string;
                  /**
                   * 卡号保存的唯一标识
                   */
                  accountCode?: string;
                };
                /**
                 * 同一个人员，绑定的id
                 */
                bindOperatorId?: number;
                /**
                 * 用户类型
                 * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
                 */
                type: number;
                /**
                 * 用户职级,
                 * 内部用户的职级，外部用户关联内部用户，取内部用户职级
                 * 否则去外部用户职级
                 */
                userRank?: string;
                /**
                 * 手机号
                 */
                mobile?: string;
                /**
                 * 证件号码
                 */
                idCard?: string;
                /**
                 * 证件类型
                 */
                idType?: number;
                /**
                 * 性别
                 */
                gender?: number;
                /**
                 * 同行人费用code
                 */
                feeCode?: string;
              }[];
              /**
               * 预计金额（前端回显）
               */
              planAmount?: number;
              /**
               * 申请事由（前端回显）
               */
              applyReason?: string;
              /**
               * 经办人名称（前端回显）
               */
              operatorName?: string;
              /**
               * 目的地列表（前端回显）
               */
              endCityList?: {
                /**
                 * 目的城市code
                 */
                endCityCode: string;
                /**
                 * 目的城市名称
                 */
                endCityName: string;
              }[];
            }[];
            /**
             * 目的地
             */
            destination?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
            /**
             * 消费日期
             */
            consumeDate?: string[];
          };
          /**
           * 基础行程类信息
           */
          batchItineraryMaterialDTO?: {
            /**
             * 行程基本信息
             */
            itineraryMaterialDTOList?: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
              /**
               * 起始区划code
               */
              startDistrictCode: string;
              /**
               * 出发地名称
               */
              startDistrictName?: string;
              /**
               * 结束区划code
               */
              endDistrictCode: string;
              /**
               * 结束地点名称
               */
              endDistrictName?: string;
              /**
               * 人数
               */
              operatorIds?: number[];
            }[];
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
            /**
             * 人数
             */
            operatorIds?: number[];
          };
          /**
           * 修改备注
           */
          remark?: string;
          /**
           * 费用说明
           */
          feeDesc?: string;
          /**
           * 是否多票
           */
          multiInvoice?: boolean;
          /**
           * 关联的单据的编号
           */
          associateFormList?: {
            /**
             * 单据code
             */
            formCode?: string;
            formType?: null;
            originalAmount?: null;
          }[];
        };
        /**
         * 费用附件
         */
        attachments?: null;
        /**
         * 关联的报销单号
         */
        expenseFormCode?: null;
        /**
         * 费用状态描述
         */
        feeStatusDesc?: null;
        /**
         * 费用状态
         */
        feeStatus?: null;
        /**
         * 是否删除
         */
        canDelete?: null;
        /**
         * 机构名称
         */
        orgName?: null;
        /**
         * 发票是否验真
         */
        invoiceIsCheck?: null;
        /**
         * 发票验真描述
         */
        invoiceIsCheckDesc?: null;
        /**
         * 时长
         */
        travelDay?: null;
        /**
         * 时长描述
         */
        travelDayDesc?: null;
        /**
         * 是否费用有修改
         */
        feeModifyStatus?: null;
        /**
         * 费用调整记录
         */
        feeModifyRecordROS?: null;
        /**
         * 打印时使用的fileId
         */
        printFileId?: null;
        /**
         * 费用备注
         */
        remark?: null;
        /**
         * 发票附件类型
         */
        attachmentMimeType?: null;
        /**
         * 发票状态
         */
        realStatus?: null;
        /**
         * 发票状态描述
         */
        realStatusDesc?: null;
        /**
         * 详细扩展信息
         */
        detailExtendDTO?: null;
        /**
         * 是否有版式文件
         */
        hasFormatFile?: null;
        amountDesc?: null;
        beginCity?: null;
        endCity?: null;
        /**
         * 由于beginCity endCity 在票据设置时使用，不清楚具体用来干啥，故不动他
         * 新增 printBeginCity printEndCity
         * 费用代码要优化了，现在掺杂了很多业务
         */
        printBeginCity?: null;
        printEndCity?: null;
        departureTime?: null;
        /**
         * 招待人数
         */
        entertainPeopleNumDesc?: null;
        /**
         * 招待时间
         */
        entertainDateDesc?: null;
        /**
         * 住宿天数
         */
        accommodationDaysDesc?: null;
      }[];
    }[];
    /**
     * 收款人信息
     */
    receiverPOS?: null;
    /**
     * 预算指标数据
     */
    budgetInfoRO?: null;
    /**
     * 预算额度数据
     */
    quotaInfoROS?: null;
    /**
     * TRUE使用指标，FALSE使用额度
     */
    budgetFlag?: null;
    /**
     * 报销事由
     */
    expenseReason?: null;
    /**
     * 操作员ID
     */
    operatorId?: null;
    /**
     * 工作单位ID
     */
    orgId?: null;
    /**
     * 工作单位名称
     */
    orgName?: null;
    /**
     * 工作部门ID
     */
    deptId?: null;
    /**
     * 工作部门名称
     */
    deptName?: null;
    /**
     * 报销单状态描述
     */
    expenseFormStatusDesc?: null;
    /**
     * 报销单状态
     */
    expenseFormStatus?: null;
    /**
     * 申请人
     */
    applyUserName?: null;
    /**
     * 申请人operatorId
     */
    applyOperatorId?: null;
    /**
     * 收款总金额
     */
    totalAmount?: null;
    /**
     * 是否可审核
     */
    canAudit?: null;
    /**
     * 费用总金额
     */
    feeTotalAmount?: null;
    /**
     * 培训-综合定额费用总金额
     */
    mixFeeTotalAmount?: null;
    /**
     * 培训-师资费用总金额
     */
    teacherFeeTotalAmount?: null;
    /**
     * 总冻结预算额度
     */
    frozenBudgetTotalAmount?: null;
    /**
     * 是否可撤回
     */
    canRevoke?: null;
    /**
     * 用户角色
     */
    userRole?: null;
    /**
     * 报销单业务编号
     */
    businessCode?: null;
    /**
     * 支付明细
     */
    expenseFormPayInfos?: null;
    /**
     * 宁波收款明细
     */
    receiverPayInfoDTOS?: null;
    /**
     * 简报列表
     */
    briefReportList?: null;
    /**
     * 扩展信息
     */
    extendFieldDTO?: null;
    /**
     * 单据附件
     */
    formAttachmentDTO?: null;
    /**
     * 单据发票信息列表
     */
    formInvoiceInfoList?: null;
    /**
     * 要打印的发票FileId集合
     */
    printInvoiceFileIds?: null;
    /**
     * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
     */
    processStatus?: null;
    /**
     * 提交时间
     */
    submitTime?: null;
    /**
     * 触发弱控原因列表
     */
    excessiveReasonList?: null;
    /**
     * 报销单订单信息
     */
    orderExpenseFormList?: null;
    /**
     * 报销单合同信息
     */
    contractExpenseFormList?: null;
    /**
     * 合同兑付单详情实体
     */
    contractDeclarationDetailList?: null;
    /**
     * 驳回原因
     */
    rejectReason?: null;
    /**
     * 付款账户信息，当为自有资金支付的时候并且是财务角色的时候才会返回
     */
    expenseFormPayAccountRO?: null;
    /**
     * 是否财政预算资金
     */
    purchaseFundSource?: null;
    /**
     * 支付方式Code
     */
    payMode: null;
    /**
     * 支付类型名，{@link PayModeEnum}
     */
    payModeName?: null;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategy?: null;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategyName?: null;
    /**
     * 备注
     */
    remark?: null;
    /**
     * 摘要
     */
    summary?: null;
    operateButton?: null;
    /**
     * 身份信息
     */
    identity?: null;
    /**
     * 工作流审核人id集合，包含已审核和未审核操作人列表
     */
    workflowAuditorIds?: null;
    /**
     * 采购交易信息 for 会议/培训多收款人报销单
     */
    tradeInfoList?: null;
    /**
     * 结算单简要实体列表
     */
    settlementSimpleList?: null;
    /**
     * 失败支付记录条数
     */
    payFailedTotal?: null;
    /**
     * 公共缴费账单明细
     */
    expensePublicPaymentBillList?: null;
    /**
     * 是否百搭单据
     */
    isBaidaForm?: null;
    /**
     * 是否无票报销,采购场景单收款人使用;0非无票报销  1无票报销为补充  2无票报销已补充
     */
    withoutInvoiceStatus?: null;
    /**
     * 支付变更状态
     * 0-无变更；1-已更正；2-已退款
     */
    payChangeType?: null;
    /**
     * 支付更正记录
     */
    expensePayChangeInfoROList?: null;
    /**
     * 预算关联关系
     * 目前存在情况，在财务审核时，预算可以直接与单据关联，也可以与收款人关联（一般事项多收款），后续也有其他关联
     */
    budgetRelationInfoROList?: null;
    workflowInfo?: null;
    /**
     * 收款账户调整记录数量
     */
    recAdjustNum?: null;
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: null;
    /**
     * 包干经费预算
     */
    fundBudget?: null;
    /**
     * 其他资金明细列表
     */
    restDetailList?: null;
    /**
     * 会计科目-本方科目
     */
    actSubjectCode?: null;
    /**
     * 会计科目名称-本方科目
     */
    actSubjectName?: null;
    /**
     * 是否启用核算（其他资金，如若扩展则可增加）:0-否,1-是
     */
    isEnableAccount?: null;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: null;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: null;
}

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/236198) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/info/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInfoExpenseFormCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/info/{expenseFormCode}',
    'data',
    'expenseFormCode',
    string,
    false
  >
>;

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/236198) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/info/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInfoExpenseFormCodeGetRequestConfig: ZlbApiExpenseExpenseFormInfoExpenseFormCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/info/{expenseFormCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: ['expenseFormCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInfoExpenseFormCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/236198) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/info/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInfoExpenseFormCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInfoExpenseFormCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInfoExpenseFormCodeGetResponse>(
    prepare(zlbApiExpenseExpenseFormInfoExpenseFormCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInfoExpenseFormCodeGet.requestConfig =
  zlbApiExpenseExpenseFormInfoExpenseFormCodeGetRequestConfig;

/**
 * 接口 [删除报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/236342) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/delete/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormDeleteExpenseFormCodePostRequest {
  expenseFormCode: string;
}

/**
 * 接口 [删除报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/236342) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/delete/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormDeleteExpenseFormCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/236342) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/delete/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormDeleteExpenseFormCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/delete/{expenseFormCode}',
    'data',
    'expenseFormCode',
    string,
    false
  >
>;

/**
 * 接口 [删除报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/236342) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/delete/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormDeleteExpenseFormCodePostRequestConfig: ZlbApiExpenseExpenseFormDeleteExpenseFormCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/delete/{expenseFormCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: ['expenseFormCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormDeleteExpenseFormCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/236342) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/delete/{expenseFormCode}`
 * @更新时间 `2024-12-11 15:42:19`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormDeleteExpenseFormCodePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormDeleteExpenseFormCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormDeleteExpenseFormCodePostResponse>(
    prepare(zlbApiExpenseExpenseFormDeleteExpenseFormCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormDeleteExpenseFormCodePost.requestConfig =
  zlbApiExpenseExpenseFormDeleteExpenseFormCodePostRequestConfig;

/**
 * 接口 [报销单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236454) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormListPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 报销单号
   */
  expenseFormCode?: string;
  /**
   * 申请单号
   */
  applyBusinessCode?: string;
  /**
   * 起始时间
   */
  beginTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 报销事由
   */
  expenseReason?: string;
  /**
   * 部门ID
   */
  departmentId?: number;
  /**
   * 报销单类型
   */
  expenseFormType?:
    | 'TRAVEL_EXPENSE_FORM'
    | 'MEETING_EXPENSE_FORM'
    | 'TRAINING_EXPENSE_FORM'
    | 'PROCUREMENT_EXPENSE_FORM'
    | 'RECEPTION_EXPENSE_FORM'
    | 'GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GOVERNMENT_EXPENSE_FORM'
    | 'PURCHASE_FURNITURE_EXPENSE_FORM'
    | 'MEETING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'TRAINING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'PUBLIC_BUSINESS_PAYMENT_EXPENSE_FORM'
    | 'INVEST_PAYMENT_EXPENSE_FORM'
    | 'REST_EXPENSE_FORM';
  /**
   * 报销单状态 1：待处理 2：已处理 3：全部
   */
  expenseFormStatus?:
    | 'UN_COMMITTED'
    | 'IN_AUDIT'
    | 'AUDIT_REJECT'
    | 'IN_SETTLEMENT'
    | 'ALREADY_COMPLETE'
    | 'PAY_FAILED';
  /**
   * table页，1：已完成 2：未完成 3：全部
   */
  tableType?: number;
  /**
   * pc端请求
   */
  pcRequest?: number;
  /**
   * 报销金额起始
   */
  expenseAmountStart?: number;
  /**
   * 报销金额截止
   */
  expenseAmountEnd?: number;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 是否抄送 0-否，1-是
   */
  isCopySend?: number;
}

/**
 * 接口 [报销单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236454) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    total?: number;
    data?: {
      /**
       * 报销单号
       */
      expenseFormCode?: string;
      /**
       * 报销单号
       */
      businessCode?: string;
      /**
       * 报销单类型
       */
      expenseFormType?: number;
      /**
       * 报销单类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 报销缘由
       */
      expenseReason?: string;
      /**
       * 创建人姓名
       */
      operatorName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentId?: number;
      /**
       * 机构ID
       */
      orgId?: number;
      /**
       * 机构名字
       */
      orgName?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 报销单状态
       */
      expenseFormStatus?: number;
      /**
       * 报销单状态
       */
      expenseFormStatusDesc?: string;
      /**
       * 报销金额
       */
      expenseAmount?: number;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 业务类型名称
       */
      businessTypeName?: string;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
       */
      processStatus?: string;
      /**
       * 用户类别
       * 1-本人 2-审核人 3-审批人 4-同行人
       */
      userRole?: number;
      /**
       * 是否百搭单据
       */
      isBaidaForm?: boolean;
      /**
       * 审批人名称
       */
      approvedNames?: string[];
      /**
       * 报销单关联申请单基本信息
       */
      relationApplyInfoROList?: {
        /**
         * 申请单业务单据号
         */
        applyBusinessNo?: string;
        /**
         * 申请单编号
         */
        applyFormCode?: string;
        /**
         * 申请单单据类型编号
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请人姓名
         */
        applyUserName?: string;
        /**
         * 发起时间
         */
        initiationTime?: string;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [报销单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236454) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [报销单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236454) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormListPostRequestConfig: ZlbApiExpenseExpenseFormListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [报销单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236454) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormListPostResponse>(
    prepare(zlbApiExpenseExpenseFormListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormListPost.requestConfig = zlbApiExpenseExpenseFormListPostRequestConfig;

/**
 * 接口 [我的待办列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236462) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/auditList`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormAuditListPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 报销单号
   */
  expenseFormCode?: string;
  /**
   * 申请单号
   */
  applyBusinessCode?: string;
  /**
   * 起始时间
   */
  beginTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 报销事由
   */
  expenseReason?: string;
  /**
   * 部门ID
   */
  departmentId?: number;
  /**
   * 报销单类型
   */
  expenseFormType?:
    | 'TRAVEL_EXPENSE_FORM'
    | 'MEETING_EXPENSE_FORM'
    | 'TRAINING_EXPENSE_FORM'
    | 'PROCUREMENT_EXPENSE_FORM'
    | 'RECEPTION_EXPENSE_FORM'
    | 'GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GOVERNMENT_EXPENSE_FORM'
    | 'PURCHASE_FURNITURE_EXPENSE_FORM'
    | 'MEETING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'TRAINING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'PUBLIC_BUSINESS_PAYMENT_EXPENSE_FORM'
    | 'INVEST_PAYMENT_EXPENSE_FORM'
    | 'REST_EXPENSE_FORM';
  /**
   * 报销单状态 1：待处理 2：已处理 3：全部
   */
  expenseFormStatus?:
    | 'UN_COMMITTED'
    | 'IN_AUDIT'
    | 'AUDIT_REJECT'
    | 'IN_SETTLEMENT'
    | 'ALREADY_COMPLETE'
    | 'PAY_FAILED';
  /**
   * table页，1：已完成 2：未完成 3：全部
   */
  tableType?: number;
  /**
   * pc端请求
   */
  pcRequest?: number;
  /**
   * 报销金额起始
   */
  expenseAmountStart?: number;
  /**
   * 报销金额截止
   */
  expenseAmountEnd?: number;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 是否抄送 0-否，1-是
   */
  isCopySend?: number;
}

/**
 * 接口 [我的待办列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236462) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/auditList`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormAuditListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    total?: number;
    data?: {
      /**
       * 报销单号
       */
      expenseFormCode?: string;
      /**
       * 报销单号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      businessType?: number;
      /**
       * 单据类型名称
       */
      businessTypeName?: string;
      /**
       * 报销单类型
       */
      expenseFormTypeCode?: number;
      /**
       * 报销单类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 报销缘由
       */
      expenseReason?: string;
      /**
       * 创建人姓名
       */
      applyUserName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentId?: number;
      /**
       * 机构ID
       */
      orgId?: number;
      /**
       * 机构名字
       */
      orgName?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 审批时间
       */
      auditTime?: string;
      /**
       * 报销单状态
       */
      formStatusNo?: number;
      /**
       * 报销单状态
       */
      formStatusNoDesc?: string;
      /**
       * 报销金额
       */
      expenseAmount?: number;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
       */
      processStatus?: string;
      /**
       * 是否百搭单据
       */
      isBaidaForm?: boolean;
      /**
       * 报销单关联申请单基本信息
       */
      relationApplyInfoROList?: {
        /**
         * 申请单业务单据号
         */
        applyBusinessNo?: string;
        /**
         * 申请单编号
         */
        applyFormCode?: string;
        /**
         * 申请单单据类型编号
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请人姓名
         */
        applyUserName?: string;
        /**
         * 发起时间
         */
        initiationTime?: string;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [我的待办列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236462) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/auditList`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormAuditListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/auditList',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [我的待办列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236462) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/auditList`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormAuditListPostRequestConfig: ZlbApiExpenseExpenseFormAuditListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/auditList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormAuditListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [我的待办列表↗](http://yapi.cai-inc.com/project/3621/interface/api/236462) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/auditList`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormAuditListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormAuditListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormAuditListPostResponse>(
    prepare(zlbApiExpenseExpenseFormAuditListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormAuditListPost.requestConfig =
  zlbApiExpenseExpenseFormAuditListPostRequestConfig;

/**
 * 接口 [解除申请单绑定关系↗](http://yapi.cai-inc.com/project/3621/interface/api/240470) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/unboundApplyForm`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormUnboundApplyFormPostRequest {
  /**
   * 报销单号
   */
  expenseFormCode: string;
  /**
   * 申请单号
   */
  applyFormCode?: string;
  /**
   * 申请单号列表
   */
  applyFormCodeList?: string[];
}

/**
 * 接口 [解除申请单绑定关系↗](http://yapi.cai-inc.com/project/3621/interface/api/240470) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/unboundApplyForm`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormUnboundApplyFormPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [解除申请单绑定关系↗](http://yapi.cai-inc.com/project/3621/interface/api/240470) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/unboundApplyForm`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormUnboundApplyFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/unboundApplyForm',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [解除申请单绑定关系↗](http://yapi.cai-inc.com/project/3621/interface/api/240470) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/unboundApplyForm`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormUnboundApplyFormPostRequestConfig: ZlbApiExpenseExpenseFormUnboundApplyFormPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/unboundApplyForm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormUnboundApplyFormPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [解除申请单绑定关系↗](http://yapi.cai-inc.com/project/3621/interface/api/240470) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/unboundApplyForm`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormUnboundApplyFormPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormUnboundApplyFormPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormUnboundApplyFormPostResponse>(
    prepare(zlbApiExpenseExpenseFormUnboundApplyFormPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormUnboundApplyFormPost.requestConfig =
  zlbApiExpenseExpenseFormUnboundApplyFormPostRequestConfig;

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242296) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInfoGetRequest {
  expenseFormCode: string;
  referer: string;
  identity: string;
  desensitize: string;
}

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242296) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 是否是企业单位
     */
    isEnterprise?: boolean;
    /**
     * 报销单详情
     */
    expenseFormCode?: string;
    /**
     * 申请单数据
     */
    applyFormSimpleInfoROS?: {
      /**
       * 申请原因
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 申请用户姓名
       */
      applyUserName?: string;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 申请时间
       */
      initiationDateTime?: string;
      /**
       * 申请单业务编号
       */
      businessCode?: string;
      /**
       * 申请单状态
       */
      formStatus?: 1 | 2 | 3 | 4 | 5;
      /**
       * 出差开始时间
       */
      travelStartTime?: string;
      /**
       * 业务名称：会议名称，培训名称、采购名称
       */
      businessName?: string;
      /**
       * 剩余金额
       */
      applyRemainingAmount?: number;
      /**
       * 数据来源
       */
      dataSource?: number;
      /**
       * 附件列表
       */
      formAttachmentDTO?: {
        /**
         * 默认附件列表
         */
        normalAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 说明附件列表
         */
        thatAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 通知附件列表
         */
        informAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 合同附件列表
         */
        compactAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 签到附件列表
         */
        signAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 派出单位公函附件列表
         */
        officialLetterAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 接待清单附件列表
         */
        receptionMenuAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 采购意向附件列表
         */
        purchasePurposeAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 资产更新计划
         */
        propertyUpdatePlanAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 集体决策会议纪要
         */
        meetingSummaryAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专家论证意见
         */
        argumentSuggestionAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专项、会议、培训附件列表
         */
        specialAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 银行回单附件
         */
        bankReceiptAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 账单附件
         */
        billAttachmentFileList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
      };
      /**
       * 扩展信息
       */
      extendFieldDTO?: {
        /**
         * 差旅扩展字段
         */
        travelExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 是否派车：1-派车，2-不派车
           */
          arrangeCar?: string;
          /**
           * 派车天数
           */
          dayCount?: number;
          extra?: string;
          /**
           * 三方拓展字段
           */
          thirdExtend?: string;
          /**
           * 差旅报销方式
           */
          travelExpenseMethod?: '由申请单报销' | '凭票报销';
          /**
           * 工号
           */
          workNo?: string;
          /**
           * 是否项目出差
           */
          isProject?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 所属部门
           */
          depName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目名称
           */
          projectName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目负责人
           */
          projectHeader?: {
            key?: string;
            value?: string;
            label?: string;
          };
        };
        /**
         * 会议扩展字段（包含多收款人）
         */
        meetingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 会议名称
           */
          meetingName: string;
          /**
           * 会议地点code
           */
          meetingCityCode?: string;
          /**
           * 会议地点名称
           */
          meetingCityName?: string;
          /**
           * 会议开始日期
           */
          meetingStartDate?: string;
          /**
           * 会议结束日期
           */
          meetingEndDate?: string;
          /**
           * 会议天数
           */
          meetingDayCount?: number;
          /**
           * 会议预计参会人数
           */
          meetingExpectAttendeeCount: number;
          /**
           * 会议实际参会人数
           */
          meetingRealAttendeeCount?: number;
          /**
           * 会议工作人员人数
           */
          meetingWorkerCount?: number;
          /**
           * 参会领导信息
           */
          meetingLeaderInfo?: string;
          /**
           * 会议议程
           */
          meetingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 会议差异内容
           */
          meetingDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 培训扩展字段（包含多收款人）
         */
        trainingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 培训名称
           */
          trainingName?: string;
          /**
           * 培训地点code
           */
          trainingCityCode?: string;
          /**
           * 培训地点名称
           */
          trainingCityName?: string;
          /**
           * 培训开始日期
           */
          trainingStartDate?: string;
          /**
           * 培训结束日期
           */
          trainingEndDate?: string;
          /**
           * 培训天数
           */
          trainingDayCount?: number;
          /**
           * 培训预计参会人数
           */
          trainingExpectAttendeeCount?: number;
          /**
           * 培训实际参会人数
           */
          trainingRealAttendeeCount?: number;
          /**
           * 培训工作人员人数
           */
          trainingWorkerCount?: number;
          /**
           * 培训议程
           */
          trainingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 培训差异内容
           */
          trainingDifferenceContent?: string;
          /**
           * 培训讲师信息
           */
          trainingTeacherInfo?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: number;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 变更支付方式说明
           */
          changePayModeReason?: string;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 采购扩展字段
         */
        procurementExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 采购内容
           */
          procurementContent?: string;
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 费用合计
           */
          applyAmount?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公务接待
         */
        receptionExtendFields?: {
          /**
           * 来访单位
           */
          visitOrgName: string;
          /**
           * 是否同城（宁波场景不需要）
           * 1-是，2-否
           */
          isSameCity?: number;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
          /**
           * 来访事由
           */
          visitReason: string;
          /**
           * 来访开始日期
           */
          visitStartDate: string;
          /**
           * 来访结束日期
           */
          visitEndDate: string;
          /**
           * 来访人员级别：1-省部级、2-厅局级、99-其他
           */
          visitorLevel: number;
          /**
           * 来访人员级别名称
           */
          visitorLevelName?: string;
          /**
           * 来访人数
           */
          visitorCount: number;
          /**
           * 主宾姓名
           */
          mainGuest?: string;
          /**
           * 接待地点code
           */
          receptionCityCode: string;
          /**
           * 接待地点名称
           */
          receptionCityName: string;
          /**
           * 接待详细地点
           */
          receptionDetailAddress?: string;
          /**
           * 就餐日期
           */
          mealDate: string;
          /**
           * 工作餐形式：1-自助餐、2-桌餐
           */
          mealType: 1 | 2 | 3;
          /**
           * 工作餐形式
           */
          mealTypeName?: string;
          /**
           * 用餐时间：1-早餐，2-中餐，3-晚餐
           */
          mealTimeType?: 1 | 2 | 3;
          /**
           * 用餐时间
           */
          mealTimeTypeName?: string;
          /**
           * 陪餐人数（宁波场景不需要）
           */
          escortCount?: number;
          /**
           * 配餐人员姓名
           */
          escortPerson?: string;
          /**
           * 接待预算金额
           */
          receptionBudgetAmount?: number;
          /**
           * 来访人员信息
           */
          visitorInformation?: {
            /**
             * 访问人员名称
             */
            visitorName?: string;
            /**
             * 访问人员职级
             */
            visitorLevel?: number;
            /**
             * 访问人员职级名称
             */
            visitorLevelName?: string;
            /**
             * 来访人员职务
             */
            visitorDuty?: string;
            /**
             * 来访人员单位名称
             */
            visitorUnitName?: string;
          }[];
          /**
           * 接待人员信息
           */
          receptionistInformation?: {
            /**
             * 接待人员名称
             */
            receptionistName?: string;
            /**
             * 接待人员职级
             */
            receptionistLevel?: number;
            /**
             * 接待人员职级名称
             */
            receptionistLevelName?: string;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 一般事项
         */
        generalExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 事项详细内容
           */
          detailContent: string;
          /**
           * 事项预算
           */
          eventBudget?: number;
          /**
           * 事项详细内容与事前审批的差异
           */
          generalDifferenceContent?: string;
          extra?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 用印申请
         */
        contractExtendFields?: {
          /**
           * 合同版本编号
           */
          contractVersionUniqueCode?: string;
        };
        /**
         * 招标书
         */
        tenderApplyExtendFields?: {
          /**
           * 申请单类型
           */
          applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
          /**
           * 申请事由
           */
          applyReason?: string;
          /**
           * 申请单Code
           */
          applyFormCode?: string;
          /**
           * 业务单据号
           */
          businessCode?: string;
          /**
           * 提交时间
           */
          submitTime?: string;
        };
        /**
         * 通用采购申请拓展字段
         */
        purchaseGeneralFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm?: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * isCreatePurchaseProposal
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType?: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 政府购买服务申请拓展字段
         */
        govermentApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 办公家具购置申请拓展字段
         */
        furnitureApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 全链路二期 报销的统一拓展字段
         */
        purchaseGeneralExpenseFieldDTO?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 交易方式：线上；线下
           */
          tradeWay?: string[];
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 交易方式
           */
          tradeWayName?: string;
          /**
           * 是否有合同
           */
          addContract?: boolean;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公共事业缴费统一拓展字段
         */
        publicBusinessPaymentFieldDTO?: {
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 无相拓展
         */
        generalExtra?: string;
      };
      formType?: string;
    }[];
    /**
     * 单据类型
     */
    expenseFormType?: 1 | 2 | 3 | 4 | 6 | 7 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16;
    /**
     * 单据类型
     */
    expenseFormTypeName?:
      | '差旅报销'
      | '会议报销'
      | '培训报销'
      | '办公用品采购报销'
      | '公务接待报销'
      | '一般事项报销'
      | '通用采购报销'
      | '政府购买服务报销'
      | '办公设备家具购置报销'
      | '公共事业缴费报销'
      | '投资支付'
      | '其他资金报销';
    payStatus?: number;
    /**
     * 业务类型
     */
    businessType?:
      | 1
      | 2
      | 19
      | 20
      | 28
      | 4
      | 5
      | 6
      | 27
      | 31
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 21
      | 22
      | 23
      | 24
      | 25
      | 26
      | 32
      | 29
      | 30
      | 33
      | 35;
    /**
     * 业务类型名称
     */
    businessTypeName?:
      | '普通出差'
      | '专项会议培训'
      | '外派'
      | '外出'
      | '外出培训'
      | '一类会议'
      | '二类会议'
      | '三类会议'
      | '其他会议'
      | '线上会议'
      | '一类培训'
      | '二类培训'
      | '集中采购'
      | '分散采购'
      | '办公用品采购'
      | '用印申请'
      | '公务接待'
      | '一般事项'
      | '招标书申请'
      | '通用采购'
      | '政府购买服务'
      | '办公设备家具购置'
      | '公共事业缴费'
      | '办公用品'
      | '政府服务购买'
      | '个人账户'
      | '企业账户'
      | '投资支付'
      | '其他资金';
    /**
     * 行程数据
     */
    itinerarySplitROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
      /**
       * 0：由原行程生成 1：由原行程拆分 2：用户新增
       */
      sourceType?: number;
      /**
       * 校验状态
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 原行程数据
       */
      originalItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程拆分结果
       */
      currentItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程数据校验结果
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
    }[];
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
            /**
             * 校验结果
             */
            checkStatus?: number;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
              /**
               * 校验结果
               */
              checkStatus?: number;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
            /**
             * 设置结果
             */
            resultInfo?: {
              /**
               * 凭票报销总结果
               */
              expenseFeeInvoiceResult?: {
                /**
                 * 用户id
                 */
                operatorId?: number;
                /**
                 * 用户名称
                 */
                operatorName?: string;
                /**
                 * 报销金额
                 */
                amount?: number;
                /**
                 * 报销金额描述
                 */
                amountDesc?: string;
                /**
                 * 详细信息
                 */
                detailInfoList?: {
                  /**
                   * 发生日期
                   */
                  happenDate?: null;
                  /**
                   * 是否可以报销
                   */
                  canExpense?: null;
                  /**
                   * 表单code
                   */
                  formCode?: string[];
                  /**
                   * 业务code
                   */
                  businessCode?: string[];
                  /**
                   * 冲突描述
                   */
                  conflictDesc?: null;
                  /**
                   * 是否凭票报销冲突
                   */
                  isUseInvoice?: null;
                  /**
                   * 规则描述
                   */
                  ruleDesc?: null;
                  /**
                   * 金额
                   */
                  ruleAmount?: null;
                }[];
              }[];
              /**
               * 凭票报销总结果提示
               */
              expenseFeeInvoiceTips?: string;
              /**
               * 是否展示
               */
              canShow?: boolean;
            };
            /**
             * 是否需要显示
             */
            canShow?: boolean;
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
          /**
           * 校验结果
           */
          checkStatus?: number;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 费用数据
     */
    expenseFormFeeROS?: {
      /**
       * 费用父级code
       */
      feeParentType?: number;
      /**
       * 费用父级描述
       */
      feeParentTypeDesc?: string;
      /**
       * 费用总金额
       */
      totalAmount?: number;
      /**
       * 费用列表
       */
      expenseFeeROList?: {
        /**
         * 费用code
         */
        feeCode?: string;
        /**
         * 费用名称
         */
        feeName?: string;
        /**
         * 人员operatorId
         */
        operatorId?: number;
        /**
         * 费用类型
         */
        feeType: number;
        /**
         * 费用类型描述
         */
        feeTypeDesc?: string;
        /**
         * 费用发生时间
         */
        consumeTime?: string;
        /**
         * 费用发生时间
         */
        consumeTimeDesc?: string;
        /**
         * 货币金额
         */
        amount: number;
        /**
         * 允许的最大金额
         */
        allowMaxAmount?: number;
        /**
         * 消费城市区划
         */
        districtCode?: string;
        /**
         * 消费城市三级区划code
         */
        allDistrictCodes?: string[];
        /**
         * 消费城市名称
         */
        districtName?: string;
        /**
         * 消费城市三级区划名称
         */
        allDistrictNames?: string[];
        /**
         * 关联的发票编号
         */
        invoiceCodes?: string[];
        /**
         * 关联发票的url
         */
        imageUrl?: string;
        /**
         * 浙里半票的url
         */
        zlbImageUrl?: string;
        /**
         * 关联的出差人
         */
        accompanyPerson?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 出差人
         */
        travelerName?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 材料数据
         */
        materialInfo?: {
          /**
           * 凭票报销伙食类补贴信息
           */
          allowanceMaterialByInvoiceDTO?: {
            /**
             * 关联行程编号
             */
            associateItineraryList: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
            }[];
            /**
             * 补贴发生日期
             */
            allowanceHappenDates: string[];
            /**
             * 城市名称s(无用，纯属兼容前端，别删除)
             */
            endCityName?: string;
          };
          /**
           * 住宿类材料信息
           */
          hotelMaterialDTO?: {
            /**
             * 酒店入住开始时间
             */
            hotelEnterTime?: string;
            /**
             * 酒店入住结束时间
             */
            hotelLeaveTime?: string;
            /**
             * 住宿天数
             */
            accommodationDays?: number;
          };
          /**
           * 交通类材料信息
           */
          trafficMaterialDTO?: {
            /**
             * 座位类别
             */
            seatType?: number;
            /**
             * 座位枚举描述
             */
            seatDesc?: string;
            /**
             * 出发地区划code
             */
            fromDistrictCode: string;
            /**
             * 出发地区划名称
             */
            fromDistrictName: string;
            /**
             * 结束地区划code
             */
            endDistrictCode: string;
            /**
             * 结束地区划名称
             */
            endDistrictName: string;
            /**
             * 火车时长码
             */
            trainDurationCode?: number;
            /**
             * 火车时长
             */
            trainDurationDesc?: string;
            /**
             * 出发日期
             */
            departureTime: string;
            /**
             * 公里数
             */
            mileage: number;
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
          };
          /**
           * 补贴类材料
           */
          allowanceMaterialDTO?: {
            /**
             * 总的费用金额
             */
            totalAmount?: number;
            /**
             * 费用标准细项
             */
            itemList?: {
              /**
               * 标准金额
               */
              standardAmount?: number;
              /**
               * 时间-天数
               */
              days?: number;
              /**
               * 费用描述
               */
              ruleDesc?: string;
            }[];
            /**
             * 火车补贴伙食费用细项
             */
            trainAllowanceMaterialDTOS?: {
              /**
               * 火车天数
               */
              trainHours?: number;
              /**
               * 火车补贴金额
               */
              trainStanardAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 用户ID
               */
              operatorId?: number;
              /**
               * 人员来源 1-系统内部；2-外部人员
               */
              userSource?: 1 | 2;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
            }[];
            /**
             * 火车总额度
             */
            trainTotalAmount?: number;
            /**
             * 是否派车
             */
            isCar?: boolean;
            /**
             * 派车铺贴计算
             */
            carAllowanceMaterialDTOS?: {
              /**
               * 派车天数
               */
              carDays?: number;
              /**
               * 派车金额
               */
              carStandardtotalAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
            }[];
          };
          /**
           * 通用类材料信息
           */
          meetingOrTrainMaterialDTO?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 会议类型
             */
            meetingType?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
            /**
             * 培训人员
             */
            trainingPerson?: string;
            /**
             * 培训人员职级
             */
            trainingPersonLevel?: number;
            /**
             * 培训人员职级
             */
            trainingPersonLevelDesc?: string;
            /**
             * 培训时长
             */
            trainingHour?: number;
          };
          /**
           * 业务招待材料信息
           */
          businessEntertainingMaterial?: {
            /**
             * 招待日期
             */
            entertainDate?: string;
            /**
             * 招待形式
             */
            entertainForm: 1 | 2 | 3;
            /**
             * 招待形式描述
             */
            entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
            /**
             * 招待人数
             */
            entertainPeopleNum: number;
            /**
             * 招待事由
             */
            entertainReason: string;
          };
          /**
           * 交通费-租车费材料信息
           */
          rentCarFeeMaterial?: {
            /**
             * 租车申请单信息
             */
            rentCarApplyForm?: {
              /**
               * 业务单据号
               */
              businessNo?: string;
              /**
               * 申请编号
               */
              applyFormCode?: string;
              /**
               * 用车人（前端回显）
               */
              carUserList?: {
                /**
                 * 人员id
                 */
                operatorId: number;
                /**
                 * 人员名称
                 */
                operatorName: string;
                /**
                 * 机构id
                 */
                institutionId?: number;
                /**
                 * 机构名称
                 */
                institutionName?: string;
                /**
                 * 外部人员职级
                 * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
                 */
                outerUserRank?: number;
                /**
                 * 人员类型
                 * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
                 */
                userType?: number;
                userId?: number;
                userName?: string;
                bankCardInfo?: {
                  /**
                   * 银行代码
                   */
                  bankCode: string;
                  /**
                   * 银行名字
                   */
                  bankName: string;
                  /**
                   * 账户名称
                   */
                  accountName: string;
                  /**
                   * 银行账号
                   */
                  bankAccount: string;
                  /**
                   * 银行账号 脱敏
                   */
                  bankAccountDesc?: string;
                  /**
                   * 卡号保存的唯一标识
                   */
                  accountCode?: string;
                };
                /**
                 * 同一个人员，绑定的id
                 */
                bindOperatorId?: number;
                /**
                 * 用户类型
                 * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
                 */
                type: number;
                /**
                 * 用户职级,
                 * 内部用户的职级，外部用户关联内部用户，取内部用户职级
                 * 否则去外部用户职级
                 */
                userRank?: string;
                /**
                 * 手机号
                 */
                mobile?: string;
                /**
                 * 证件号码
                 */
                idCard?: string;
                /**
                 * 证件类型
                 */
                idType?: number;
                /**
                 * 性别
                 */
                gender?: number;
                /**
                 * 同行人费用code
                 */
                feeCode?: string;
              }[];
              /**
               * 预计金额（前端回显）
               */
              planAmount?: number;
              /**
               * 申请事由（前端回显）
               */
              applyReason?: string;
              /**
               * 经办人名称（前端回显）
               */
              operatorName?: string;
              /**
               * 目的地列表（前端回显）
               */
              endCityList?: {
                /**
                 * 目的城市code
                 */
                endCityCode: string;
                /**
                 * 目的城市名称
                 */
                endCityName: string;
              }[];
            }[];
            /**
             * 目的地
             */
            destination?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
            /**
             * 消费日期
             */
            consumeDate?: string[];
          };
          /**
           * 基础行程类信息
           */
          batchItineraryMaterialDTO?: {
            /**
             * 行程基本信息
             */
            itineraryMaterialDTOList?: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
              /**
               * 起始区划code
               */
              startDistrictCode: string;
              /**
               * 出发地名称
               */
              startDistrictName?: string;
              /**
               * 结束区划code
               */
              endDistrictCode: string;
              /**
               * 结束地点名称
               */
              endDistrictName?: string;
              /**
               * 人数
               */
              operatorIds?: number[];
            }[];
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
            /**
             * 人数
             */
            operatorIds?: number[];
          };
          /**
           * 修改备注
           */
          remark?: string;
          /**
           * 费用说明
           */
          feeDesc?: string;
          /**
           * 是否多票
           */
          multiInvoice?: boolean;
          /**
           * 关联的单据的编号
           */
          associateFormList?: {
            /**
             * 单据code
             */
            formCode?: string;
            formType?: null;
            originalAmount?: null;
          }[];
        };
        /**
         * 费用附件
         */
        attachments?: null;
        /**
         * 关联的报销单号
         */
        expenseFormCode?: null;
        /**
         * 费用状态描述
         */
        feeStatusDesc?: null;
        /**
         * 费用状态
         */
        feeStatus?: null;
        /**
         * 是否删除
         */
        canDelete?: null;
        /**
         * 机构名称
         */
        orgName?: null;
        /**
         * 发票是否验真
         */
        invoiceIsCheck?: null;
        /**
         * 发票验真描述
         */
        invoiceIsCheckDesc?: null;
        /**
         * 时长
         */
        travelDay?: null;
        /**
         * 时长描述
         */
        travelDayDesc?: null;
        /**
         * 是否费用有修改
         */
        feeModifyStatus?: null;
        /**
         * 费用调整记录
         */
        feeModifyRecordROS?: null;
        /**
         * 打印时使用的fileId
         */
        printFileId?: null;
        /**
         * 费用备注
         */
        remark?: null;
        /**
         * 发票附件类型
         */
        attachmentMimeType?: null;
        /**
         * 发票状态
         */
        realStatus?: null;
        /**
         * 发票状态描述
         */
        realStatusDesc?: null;
        /**
         * 详细扩展信息
         */
        detailExtendDTO?: null;
        /**
         * 是否有版式文件
         */
        hasFormatFile?: null;
        amountDesc?: null;
        beginCity?: null;
        endCity?: null;
        /**
         * 由于beginCity endCity 在票据设置时使用，不清楚具体用来干啥，故不动他
         * 新增 printBeginCity printEndCity
         * 费用代码要优化了，现在掺杂了很多业务
         */
        printBeginCity?: null;
        printEndCity?: null;
        departureTime?: null;
        /**
         * 招待人数
         */
        entertainPeopleNumDesc?: null;
        /**
         * 招待时间
         */
        entertainDateDesc?: null;
        /**
         * 住宿天数
         */
        accommodationDaysDesc?: null;
      }[];
    }[];
    /**
     * 收款人信息
     */
    receiverPOS?: null;
    /**
     * 预算指标数据
     */
    budgetInfoRO?: null;
    /**
     * 预算额度数据
     */
    quotaInfoROS?: null;
    /**
     * TRUE使用指标，FALSE使用额度
     */
    budgetFlag?: null;
    /**
     * 报销事由
     */
    expenseReason?: null;
    /**
     * 操作员ID
     */
    operatorId?: null;
    /**
     * 工作单位ID
     */
    orgId?: null;
    /**
     * 工作单位名称
     */
    orgName?: null;
    /**
     * 工作部门ID
     */
    deptId?: null;
    /**
     * 工作部门名称
     */
    deptName?: null;
    /**
     * 报销单状态描述
     */
    expenseFormStatusDesc?: null;
    /**
     * 报销单状态
     */
    expenseFormStatus?: null;
    /**
     * 申请人
     */
    applyUserName?: null;
    /**
     * 申请人operatorId
     */
    applyOperatorId?: null;
    /**
     * 收款总金额
     */
    totalAmount?: null;
    /**
     * 是否可审核
     */
    canAudit?: null;
    /**
     * 费用总金额
     */
    feeTotalAmount?: null;
    /**
     * 培训-综合定额费用总金额
     */
    mixFeeTotalAmount?: null;
    /**
     * 培训-师资费用总金额
     */
    teacherFeeTotalAmount?: null;
    /**
     * 总冻结预算额度
     */
    frozenBudgetTotalAmount?: null;
    /**
     * 是否可撤回
     */
    canRevoke?: null;
    /**
     * 用户角色
     */
    userRole?: null;
    /**
     * 报销单业务编号
     */
    businessCode?: null;
    /**
     * 支付明细
     */
    expenseFormPayInfos?: null;
    /**
     * 宁波收款明细
     */
    receiverPayInfoDTOS?: null;
    /**
     * 简报列表
     */
    briefReportList?: null;
    /**
     * 扩展信息
     */
    extendFieldDTO?: null;
    /**
     * 单据附件
     */
    formAttachmentDTO?: null;
    /**
     * 单据发票信息列表
     */
    formInvoiceInfoList?: null;
    /**
     * 要打印的发票FileId集合
     */
    printInvoiceFileIds?: null;
    /**
     * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
     */
    processStatus?: null;
    /**
     * 提交时间
     */
    submitTime?: null;
    /**
     * 触发弱控原因列表
     */
    excessiveReasonList?: null;
    /**
     * 报销单订单信息
     */
    orderExpenseFormList?: null;
    /**
     * 报销单合同信息
     */
    contractExpenseFormList?: null;
    /**
     * 合同兑付单详情实体
     */
    contractDeclarationDetailList?: null;
    /**
     * 驳回原因
     */
    rejectReason?: null;
    /**
     * 付款账户信息，当为自有资金支付的时候并且是财务角色的时候才会返回
     */
    expenseFormPayAccountRO?: null;
    /**
     * 是否财政预算资金
     */
    purchaseFundSource?: null;
    /**
     * 支付方式Code
     */
    payMode: null;
    /**
     * 支付类型名，{@link PayModeEnum}
     */
    payModeName?: null;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategy?: null;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategyName?: null;
    /**
     * 备注
     */
    remark?: null;
    /**
     * 摘要
     */
    summary?: null;
    operateButton?: null;
    /**
     * 身份信息
     */
    identity?: null;
    /**
     * 工作流审核人id集合，包含已审核和未审核操作人列表
     */
    workflowAuditorIds?: null;
    /**
     * 采购交易信息 for 会议/培训多收款人报销单
     */
    tradeInfoList?: null;
    /**
     * 结算单简要实体列表
     */
    settlementSimpleList?: null;
    /**
     * 失败支付记录条数
     */
    payFailedTotal?: null;
    /**
     * 公共缴费账单明细
     */
    expensePublicPaymentBillList?: null;
    /**
     * 是否百搭单据
     */
    isBaidaForm?: null;
    /**
     * 是否无票报销,采购场景单收款人使用;0非无票报销  1无票报销为补充  2无票报销已补充
     */
    withoutInvoiceStatus?: null;
    /**
     * 支付变更状态
     * 0-无变更；1-已更正；2-已退款
     */
    payChangeType?: null;
    /**
     * 支付更正记录
     */
    expensePayChangeInfoROList?: null;
    /**
     * 预算关联关系
     * 目前存在情况，在财务审核时，预算可以直接与单据关联，也可以与收款人关联（一般事项多收款），后续也有其他关联
     */
    budgetRelationInfoROList?: null;
    workflowInfo?: null;
    /**
     * 收款账户调整记录数量
     */
    recAdjustNum?: null;
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: null;
    /**
     * 包干经费预算
     */
    fundBudget?: null;
    /**
     * 其他资金明细列表
     */
    restDetailList?: null;
    /**
     * 会计科目-本方科目
     */
    actSubjectCode?: null;
    /**
     * 会计科目名称-本方科目
     */
    actSubjectName?: null;
    /**
     * 是否启用核算（其他资金，如若扩展则可增加）:0-否,1-是
     */
    isEnableAccount?: null;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: null;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: null;
}

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242296) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/info',
    'data',
    string,
    'expenseFormCode' | 'referer' | 'identity' | 'desensitize',
    false
  >
>;

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242296) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInfoGetRequestConfig: ZlbApiExpenseExpenseFormInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: ['expenseFormCode', 'referer', 'identity', 'desensitize'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242296) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info`
 * @更新时间 `2024-12-11 15:42:20`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInfoGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInfoGetResponse>(
    prepare(zlbApiExpenseExpenseFormInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInfoGet.requestConfig = zlbApiExpenseExpenseFormInfoGetRequestConfig;

/**
 * 接口 [驳回报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/242616) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/reject`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormRejectPostRequest {
  /**
   * 报销单号
   */
  expenseFormCode: string;
  /**
   * 备注
   */
  remark: string;
  /**
   * 大屏监控需要
   */
  businessCode?: string;
}

/**
 * 接口 [驳回报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/242616) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/reject`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormRejectPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [驳回报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/242616) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/reject`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormRejectPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/reject',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [驳回报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/242616) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/reject`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormRejectPostRequestConfig: ZlbApiExpenseExpenseFormRejectPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/reject',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormRejectPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [驳回报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/242616) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/reject`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormRejectPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormRejectPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormRejectPostResponse>(
    prepare(zlbApiExpenseExpenseFormRejectPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormRejectPost.requestConfig = zlbApiExpenseExpenseFormRejectPostRequestConfig;

/**
 * 接口 [更新报销单预算信息↗](http://yapi.cai-inc.com/project/3621/interface/api/242618) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormBudget`
 * @更新时间 `2023-03-08 14:28:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormUpdateExpenseFormBudgetPostRequest {
  /**
   * 报销单号
   */
  expenseFormCode: string;
  /**
   * 预算信息
   */
  budgetInfoPO: {
    /**
     * 主预算编号
     */
    mainBudgetCode: number;
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 预算额度id
     */
    budgetQuotaId?: string;
    /**
     * 交易信息 for 会议/培训多收款人
     */
    tradeCode?: string;
    /**
     * 支付记录信息code
     */
    payRecordCode?: string;
  }[];
  /**
   * 是否忽略弱控
   */
  isIgnoreWarning?: boolean;
}

/**
 * 接口 [更新报销单预算信息↗](http://yapi.cai-inc.com/project/3621/interface/api/242618) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormBudget`
 * @更新时间 `2023-03-08 14:28:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormUpdateExpenseFormBudgetPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态 0：通过 1：警告 2：强控 3 提示
     */
    checkStatus?: number;
    /**
     * 行程冲突校验结果
     */
    itineraryCheckResultRO?: {
      /**
       * 所有行程是否通过行程校验
       * 通过：0
       */
      checkStatus?: number;
      /**
       * 报销单行程校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 行程数组索引
         */
        indexNo?: string;
        /**
         * 每段行程的提示文案及校验状态
         */
        itineraryCheckResultList?: {
          /**
           * 校验状态
           * 0-通过 1-弱控 2-强控 3-提示
           */
          checkStatus?: number;
          /**
           * 提示文案
           */
          message?: string;
        }[];
      }[];
      /**
       * 提示消息，当isPass为true的时候，这里为空
       * 字段已废弃
       */
      msg?: string;
    };
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: number;
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: number;
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: number;
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: number;
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: number;
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: number;
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: number;
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: number;
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: number;
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: number;
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: number;
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: number;
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: number;
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 预算校验结果
     */
    budgetCheckResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
    }[];
    /**
     * 收款信息校验结果
     */
    receiverCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 收款信息校验详情
       */
      checkResultInfoROS?: {
        /**
         * 是否通过校验
         */
        checkStatus?: number;
        /**
         * 收款人信息数组下标
         */
        indexNo?: string;
        /**
         * 提示消息
         */
        msg?: string[];
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 支付方式校验结果
     */
    payConfigCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 订单校验结果
     */
    orderCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 报销单号
     */
    expenseFormCode?: string;
    /**
     * 合同校验结果
     */
    contractCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 发票校验结果
     */
    invoiceCheckResultROS?: {
      /**
       * 发票ID
       */
      platformInvoiceId?: string;
      /**
       * 状态码
       */
      code?: number;
      /**
       * 是否可报销 true：可以报销 false：不可以报销
       */
      success?: boolean;
      /**
       * 提示消息
       */
      msg?: string;
    }[];
    /**
     * 超标原因配置
     */
    reasonConfigROS?: {
      /**
       * 状态
       */
      checkStatus?: number;
      /**
       * 规则列表
       */
      ruleInfoROS?: {
        /**
         * 规则描述
         */
        ruleDesc?: string;
        /**
         * 规则code
         */
        ruleCode?: string;
        /**
         * 状态
         */
        checkcStatus?: number;
      }[];
      /**
       * 超标配置列表
       */
      reasonConfigList?: {
        /**
         * 校验结果分组code
         */
        checkGroupCode?: string;
        /**
         * 父标题
         */
        parentTitle?: string;
        /**
         * 子标题
         */
        subTitle?: string;
        /**
         * 合并code
         */
        mergeGroupCode?: string;
        /**
         * 是否必填
         */
        isMust?: number;
        /**
         * 备注长度
         */
        remarkLength?: number;
      }[];
    };
    /**
     * 含有异常申请单的列表（校验通过时为空数组）
     */
    applyFormCheckResultROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 检查结果
       */
      checkResult?: 0 | 1 | 2;
      /**
       * 检查结果描述
       */
      checkResultDesc?: '通过' | '已作废' | '已关联';
      /**
       * 被关联的其他报销单号
       */
      certainExpenseFormCode?: string[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [更新报销单预算信息↗](http://yapi.cai-inc.com/project/3621/interface/api/242618) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormBudget`
 * @更新时间 `2023-03-08 14:28:18`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormUpdateExpenseFormBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/updateExpenseFormBudget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [更新报销单预算信息↗](http://yapi.cai-inc.com/project/3621/interface/api/242618) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormBudget`
 * @更新时间 `2023-03-08 14:28:18`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormUpdateExpenseFormBudgetPostRequestConfig: ZlbApiExpenseExpenseFormUpdateExpenseFormBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/updateExpenseFormBudget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormUpdateExpenseFormBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [更新报销单预算信息↗](http://yapi.cai-inc.com/project/3621/interface/api/242618) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormBudget`
 * @更新时间 `2023-03-08 14:28:18`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormUpdateExpenseFormBudgetPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormUpdateExpenseFormBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormUpdateExpenseFormBudgetPostResponse>(
    prepare(zlbApiExpenseExpenseFormUpdateExpenseFormBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormUpdateExpenseFormBudgetPost.requestConfig =
  zlbApiExpenseExpenseFormUpdateExpenseFormBudgetPostRequestConfig;

/**
 * 接口 [报销单出纳结算列表筛选查询↗](http://yapi.cai-inc.com/project/3621/interface/api/242838) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCashierPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 完结状态 1-结算中，2-已完结
   */
  completionStatus: number;
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 单据类型编号
   */
  expenseFormType?: number;
  /**
   * 报销事由
   */
  expenseReason?: string;
  /**
   * 开始时间
   */
  beginTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 结算状态编号
   * 1-支付中、2-支付成功、3-支付失败
   */
  cashierStatus?: number;
  /**
   * 部门ID
   */
  departmentId?: number;
  /**
   * 支付方式 1:国库支付 2：自有资金支付
   */
  payMode?: number;
  /**
   * 提交人
   */
  submitName?: string;
  /**
   * 打印状态 0-未打印 1-已打印
   */
  printStatus?: number;
  /**
   * 报销金额起始
   */
  expenseAmountStart?: number;
  /**
   * 报销金额截止
   */
  expenseAmountEnd?: number;
  /**
   * 申请单编号
   */
  applyBusinessCode?: string;
  /**
   * 支付是否更正 0-未更正 1-已更正
   */
  payChangeStatus?: number;
}

/**
 * 接口 [报销单出纳结算列表筛选查询↗](http://yapi.cai-inc.com/project/3621/interface/api/242838) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCashierPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    total?: number;
    data?: {
      /**
       * 单据唯一单号
       */
      expenseFormCode?: string;
      /**
       * 单据类型编号
       */
      expenseFormType?: number;
      businessType?: number;
      /**
       * 单据类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 报销事由
       */
      expenseReason?: string;
      /**
       * 发起人
       */
      operatorName?: string;
      /**
       * 单位ID
       */
      operatorOrgId?: number;
      /**
       * 单位
       */
      operatorOrgName?: string;
      /**
       * 部门ID
       */
      operatorDepartmentId?: number;
      /**
       * 部门
       */
      operatorDepartmentName?: string;
      /**
       * 应付金额
       */
      expenseAmount?: number;
      /**
       * 结算状态编号
       * 0-待支付，1-支付中，2-支付成功，3-支付失败
       */
      cashierStatus?: number;
      /**
       * 结算状态名称
       */
      cashierStatusName?: string;
      /**
       * 结算更新时间
       */
      cashierUpdateTime?: string;
      /**
       * 支付完成时间
       */
      payFinishTime?: string;
      /**
       * 申请支付时间
       */
      payApplyTime?: string;
      /**
       * 报销单关联的预算ID
       */
      mainBudgetCode?: number[];
      /**
       * 支付方式 1:国库支付 2：自有资金支付
       */
      payMode?: number;
      /**
       * 支付方式描述
       */
      payModeDesc?: string;
      /**
       * 打印状态  0-未打印 1-已打印
       */
      printStatus?: number;
      /**
       * 打印状态名称
       */
      printStatusName?: string;
      /**
       * 是否百搭单据
       */
      isBaidaForm?: boolean;
      /**
       * 报销单关联申请单基本信息
       */
      relationApplyInfoROList?: {
        /**
         * 申请单业务单据号
         */
        applyBusinessNo?: string;
        /**
         * 申请单编号
         */
        applyFormCode?: string;
        /**
         * 申请单单据类型编号
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请人姓名
         */
        applyUserName?: string;
        /**
         * 发起时间
         */
        initiationTime?: string;
      }[];
      /**
       * 报销单支付是否变更 0-否，1-是
       */
      payChangeStatus?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [报销单出纳结算列表筛选查询↗](http://yapi.cai-inc.com/project/3621/interface/api/242838) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormCashierPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/cashier',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [报销单出纳结算列表筛选查询↗](http://yapi.cai-inc.com/project/3621/interface/api/242838) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormCashierPostRequestConfig: ZlbApiExpenseExpenseFormCashierPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/cashier',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormCashierPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [报销单出纳结算列表筛选查询↗](http://yapi.cai-inc.com/project/3621/interface/api/242838) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormCashierPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormCashierPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormCashierPostResponse>(
    prepare(zlbApiExpenseExpenseFormCashierPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormCashierPost.requestConfig =
  zlbApiExpenseExpenseFormCashierPostRequestConfig;

/**
 * 接口 [结算页查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242898) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getInfoOnCashier`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormGetInfoOnCashierGetRequest {
  /**
   * 报销单code
   */
  expenseFormCode: string;
  /**
   * 请求端
   */
  referer: string;
  identity: string;
  /**
   * 是否脱敏：0-不脱敏，1-脱敏
   */
  desensitize: string;
  payChangeStatus?: string;
}

/**
 * 接口 [结算页查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242898) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getInfoOnCashier`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormGetInfoOnCashierGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 是否是企业单位
     */
    isEnterprise?: boolean;
    /**
     * 报销单详情
     */
    expenseFormCode?: string;
    /**
     * 申请单数据
     */
    applyFormSimpleInfoROS?: {
      /**
       * 申请原因
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 申请用户姓名
       */
      applyUserName?: string;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 申请时间
       */
      initiationDateTime?: string;
      /**
       * 申请单业务编号
       */
      businessCode?: string;
      /**
       * 申请单状态
       */
      formStatus?: 1 | 2 | 3 | 4 | 5;
      /**
       * 出差开始时间
       */
      travelStartTime?: string;
      /**
       * 业务名称：会议名称，培训名称、采购名称
       */
      businessName?: string;
      /**
       * 剩余金额
       */
      applyRemainingAmount?: number;
      /**
       * 数据来源
       */
      dataSource?: number;
      /**
       * 附件列表
       */
      formAttachmentDTO?: {
        /**
         * 默认附件列表
         */
        normalAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 说明附件列表
         */
        thatAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 通知附件列表
         */
        informAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 合同附件列表
         */
        compactAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 签到附件列表
         */
        signAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 派出单位公函附件列表
         */
        officialLetterAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 接待清单附件列表
         */
        receptionMenuAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 采购意向附件列表
         */
        purchasePurposeAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 资产更新计划
         */
        propertyUpdatePlanAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 集体决策会议纪要
         */
        meetingSummaryAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专家论证意见
         */
        argumentSuggestionAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专项、会议、培训附件列表
         */
        specialAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 银行回单附件
         */
        bankReceiptAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 账单附件
         */
        billAttachmentFileList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
      };
      /**
       * 扩展信息
       */
      extendFieldDTO?: {
        /**
         * 差旅扩展字段
         */
        travelExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 是否派车：1-派车，2-不派车
           */
          arrangeCar?: string;
          /**
           * 派车天数
           */
          dayCount?: number;
          extra?: string;
          /**
           * 三方拓展字段
           */
          thirdExtend?: string;
          /**
           * 差旅报销方式
           */
          travelExpenseMethod?: '由申请单报销' | '凭票报销';
          /**
           * 工号
           */
          workNo?: string;
          /**
           * 是否项目出差
           */
          isProject?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 所属部门
           */
          depName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目名称
           */
          projectName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目负责人
           */
          projectHeader?: {
            key?: string;
            value?: string;
            label?: string;
          };
        };
        /**
         * 会议扩展字段（包含多收款人）
         */
        meetingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 会议名称
           */
          meetingName: string;
          /**
           * 会议地点code
           */
          meetingCityCode?: string;
          /**
           * 会议地点名称
           */
          meetingCityName?: string;
          /**
           * 会议开始日期
           */
          meetingStartDate?: string;
          /**
           * 会议结束日期
           */
          meetingEndDate?: string;
          /**
           * 会议天数
           */
          meetingDayCount?: number;
          /**
           * 会议预计参会人数
           */
          meetingExpectAttendeeCount: number;
          /**
           * 会议实际参会人数
           */
          meetingRealAttendeeCount?: number;
          /**
           * 会议工作人员人数
           */
          meetingWorkerCount?: number;
          /**
           * 参会领导信息
           */
          meetingLeaderInfo?: string;
          /**
           * 会议议程
           */
          meetingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 会议差异内容
           */
          meetingDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 培训扩展字段（包含多收款人）
         */
        trainingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 培训名称
           */
          trainingName?: string;
          /**
           * 培训地点code
           */
          trainingCityCode?: string;
          /**
           * 培训地点名称
           */
          trainingCityName?: string;
          /**
           * 培训开始日期
           */
          trainingStartDate?: string;
          /**
           * 培训结束日期
           */
          trainingEndDate?: string;
          /**
           * 培训天数
           */
          trainingDayCount?: number;
          /**
           * 培训预计参会人数
           */
          trainingExpectAttendeeCount?: number;
          /**
           * 培训实际参会人数
           */
          trainingRealAttendeeCount?: number;
          /**
           * 培训工作人员人数
           */
          trainingWorkerCount?: number;
          /**
           * 培训议程
           */
          trainingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 培训差异内容
           */
          trainingDifferenceContent?: string;
          /**
           * 培训讲师信息
           */
          trainingTeacherInfo?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: number;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 变更支付方式说明
           */
          changePayModeReason?: string;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 采购扩展字段
         */
        procurementExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 采购内容
           */
          procurementContent?: string;
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 费用合计
           */
          applyAmount?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公务接待
         */
        receptionExtendFields?: {
          /**
           * 来访单位
           */
          visitOrgName: string;
          /**
           * 是否同城（宁波场景不需要）
           * 1-是，2-否
           */
          isSameCity?: number;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
          /**
           * 来访事由
           */
          visitReason: string;
          /**
           * 来访开始日期
           */
          visitStartDate: string;
          /**
           * 来访结束日期
           */
          visitEndDate: string;
          /**
           * 来访人员级别：1-省部级、2-厅局级、99-其他
           */
          visitorLevel: number;
          /**
           * 来访人员级别名称
           */
          visitorLevelName?: string;
          /**
           * 来访人数
           */
          visitorCount: number;
          /**
           * 主宾姓名
           */
          mainGuest?: string;
          /**
           * 接待地点code
           */
          receptionCityCode: string;
          /**
           * 接待地点名称
           */
          receptionCityName: string;
          /**
           * 接待详细地点
           */
          receptionDetailAddress?: string;
          /**
           * 就餐日期
           */
          mealDate: string;
          /**
           * 工作餐形式：1-自助餐、2-桌餐
           */
          mealType: 1 | 2 | 3;
          /**
           * 工作餐形式
           */
          mealTypeName?: string;
          /**
           * 用餐时间：1-早餐，2-中餐，3-晚餐
           */
          mealTimeType?: 1 | 2 | 3;
          /**
           * 用餐时间
           */
          mealTimeTypeName?: string;
          /**
           * 陪餐人数（宁波场景不需要）
           */
          escortCount?: number;
          /**
           * 配餐人员姓名
           */
          escortPerson?: string;
          /**
           * 接待预算金额
           */
          receptionBudgetAmount?: number;
          /**
           * 来访人员信息
           */
          visitorInformation?: {
            /**
             * 访问人员名称
             */
            visitorName?: string;
            /**
             * 访问人员职级
             */
            visitorLevel?: number;
            /**
             * 访问人员职级名称
             */
            visitorLevelName?: string;
            /**
             * 来访人员职务
             */
            visitorDuty?: string;
            /**
             * 来访人员单位名称
             */
            visitorUnitName?: string;
          }[];
          /**
           * 接待人员信息
           */
          receptionistInformation?: {
            /**
             * 接待人员名称
             */
            receptionistName?: string;
            /**
             * 接待人员职级
             */
            receptionistLevel?: number;
            /**
             * 接待人员职级名称
             */
            receptionistLevelName?: string;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 一般事项
         */
        generalExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 事项详细内容
           */
          detailContent: string;
          /**
           * 事项预算
           */
          eventBudget?: number;
          /**
           * 事项详细内容与事前审批的差异
           */
          generalDifferenceContent?: string;
          extra?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 用印申请
         */
        contractExtendFields?: {
          /**
           * 合同版本编号
           */
          contractVersionUniqueCode?: string;
        };
        /**
         * 招标书
         */
        tenderApplyExtendFields?: {
          /**
           * 申请单类型
           */
          applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
          /**
           * 申请事由
           */
          applyReason?: string;
          /**
           * 申请单Code
           */
          applyFormCode?: string;
          /**
           * 业务单据号
           */
          businessCode?: string;
          /**
           * 提交时间
           */
          submitTime?: string;
        };
        /**
         * 通用采购申请拓展字段
         */
        purchaseGeneralFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm?: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * isCreatePurchaseProposal
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType?: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 政府购买服务申请拓展字段
         */
        govermentApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 办公家具购置申请拓展字段
         */
        furnitureApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 全链路二期 报销的统一拓展字段
         */
        purchaseGeneralExpenseFieldDTO?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 交易方式：线上；线下
           */
          tradeWay?: string[];
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 交易方式
           */
          tradeWayName?: string;
          /**
           * 是否有合同
           */
          addContract?: boolean;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公共事业缴费统一拓展字段
         */
        publicBusinessPaymentFieldDTO?: {
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 无相拓展
         */
        generalExtra?: string;
      };
      formType?: string;
    }[];
    /**
     * 单据类型
     */
    expenseFormType?: 1 | 2 | 3 | 4 | 6 | 7 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16;
    /**
     * 单据类型
     */
    expenseFormTypeName?:
      | '差旅报销'
      | '会议报销'
      | '培训报销'
      | '办公用品采购报销'
      | '公务接待报销'
      | '一般事项报销'
      | '通用采购报销'
      | '政府购买服务报销'
      | '办公设备家具购置报销'
      | '公共事业缴费报销'
      | '投资支付'
      | '其他资金报销';
    payStatus?: number;
    /**
     * 业务类型
     */
    businessType?:
      | 1
      | 2
      | 19
      | 20
      | 28
      | 4
      | 5
      | 6
      | 27
      | 31
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 21
      | 22
      | 23
      | 24
      | 25
      | 26
      | 32
      | 29
      | 30
      | 33
      | 35;
    /**
     * 业务类型名称
     */
    businessTypeName?:
      | '普通出差'
      | '专项会议培训'
      | '外派'
      | '外出'
      | '外出培训'
      | '一类会议'
      | '二类会议'
      | '三类会议'
      | '其他会议'
      | '线上会议'
      | '一类培训'
      | '二类培训'
      | '集中采购'
      | '分散采购'
      | '办公用品采购'
      | '用印申请'
      | '公务接待'
      | '一般事项'
      | '招标书申请'
      | '通用采购'
      | '政府购买服务'
      | '办公设备家具购置'
      | '公共事业缴费'
      | '办公用品'
      | '政府服务购买'
      | '个人账户'
      | '企业账户'
      | '投资支付'
      | '其他资金';
    /**
     * 行程数据
     */
    itinerarySplitROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
      /**
       * 0：由原行程生成 1：由原行程拆分 2：用户新增
       */
      sourceType?: number;
      /**
       * 校验状态
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 原行程数据
       */
      originalItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程拆分结果
       */
      currentItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程数据校验结果
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
    }[];
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
            /**
             * 校验结果
             */
            checkStatus?: number;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
              /**
               * 校验结果
               */
              checkStatus?: number;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
            /**
             * 设置结果
             */
            resultInfo?: {
              /**
               * 凭票报销总结果
               */
              expenseFeeInvoiceResult?: {
                /**
                 * 用户id
                 */
                operatorId?: number;
                /**
                 * 用户名称
                 */
                operatorName?: string;
                /**
                 * 报销金额
                 */
                amount?: number;
                /**
                 * 报销金额描述
                 */
                amountDesc?: string;
                /**
                 * 详细信息
                 */
                detailInfoList?: {
                  /**
                   * 发生日期
                   */
                  happenDate?: null;
                  /**
                   * 是否可以报销
                   */
                  canExpense?: null;
                  /**
                   * 表单code
                   */
                  formCode?: string[];
                  /**
                   * 业务code
                   */
                  businessCode?: string[];
                  /**
                   * 冲突描述
                   */
                  conflictDesc?: null;
                  /**
                   * 是否凭票报销冲突
                   */
                  isUseInvoice?: null;
                  /**
                   * 规则描述
                   */
                  ruleDesc?: null;
                  /**
                   * 金额
                   */
                  ruleAmount?: null;
                }[];
              }[];
              /**
               * 凭票报销总结果提示
               */
              expenseFeeInvoiceTips?: string;
              /**
               * 是否展示
               */
              canShow?: boolean;
            };
            /**
             * 是否需要显示
             */
            canShow?: boolean;
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
          /**
           * 校验结果
           */
          checkStatus?: number;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 费用数据
     */
    expenseFormFeeROS?: {
      /**
       * 费用父级code
       */
      feeParentType?: number;
      /**
       * 费用父级描述
       */
      feeParentTypeDesc?: string;
      /**
       * 费用总金额
       */
      totalAmount?: number;
      /**
       * 费用列表
       */
      expenseFeeROList?: {
        /**
         * 费用code
         */
        feeCode?: string;
        /**
         * 费用名称
         */
        feeName?: string;
        /**
         * 人员operatorId
         */
        operatorId?: number;
        /**
         * 费用类型
         */
        feeType: number;
        /**
         * 费用类型描述
         */
        feeTypeDesc?: string;
        /**
         * 费用发生时间
         */
        consumeTime?: string;
        /**
         * 费用发生时间
         */
        consumeTimeDesc?: string;
        /**
         * 货币金额
         */
        amount: number;
        /**
         * 允许的最大金额
         */
        allowMaxAmount?: number;
        /**
         * 消费城市区划
         */
        districtCode?: string;
        /**
         * 消费城市三级区划code
         */
        allDistrictCodes?: string[];
        /**
         * 消费城市名称
         */
        districtName?: string;
        /**
         * 消费城市三级区划名称
         */
        allDistrictNames?: string[];
        /**
         * 关联的发票编号
         */
        invoiceCodes?: string[];
        /**
         * 关联发票的url
         */
        imageUrl?: string;
        /**
         * 浙里半票的url
         */
        zlbImageUrl?: string;
        /**
         * 关联的出差人
         */
        accompanyPerson?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 出差人
         */
        travelerName?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 材料数据
         */
        materialInfo?: {
          /**
           * 凭票报销伙食类补贴信息
           */
          allowanceMaterialByInvoiceDTO?: {
            /**
             * 关联行程编号
             */
            associateItineraryList: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
            }[];
            /**
             * 补贴发生日期
             */
            allowanceHappenDates: string[];
            /**
             * 城市名称s(无用，纯属兼容前端，别删除)
             */
            endCityName?: string;
          };
          /**
           * 住宿类材料信息
           */
          hotelMaterialDTO?: {
            /**
             * 酒店入住开始时间
             */
            hotelEnterTime?: string;
            /**
             * 酒店入住结束时间
             */
            hotelLeaveTime?: string;
            /**
             * 住宿天数
             */
            accommodationDays?: number;
          };
          /**
           * 交通类材料信息
           */
          trafficMaterialDTO?: {
            /**
             * 座位类别
             */
            seatType?: number;
            /**
             * 座位枚举描述
             */
            seatDesc?: string;
            /**
             * 出发地区划code
             */
            fromDistrictCode: string;
            /**
             * 出发地区划名称
             */
            fromDistrictName: string;
            /**
             * 结束地区划code
             */
            endDistrictCode: string;
            /**
             * 结束地区划名称
             */
            endDistrictName: string;
            /**
             * 火车时长码
             */
            trainDurationCode?: number;
            /**
             * 火车时长
             */
            trainDurationDesc?: string;
            /**
             * 出发日期
             */
            departureTime: string;
            /**
             * 公里数
             */
            mileage: number;
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
          };
          /**
           * 补贴类材料
           */
          allowanceMaterialDTO?: {
            /**
             * 总的费用金额
             */
            totalAmount?: number;
            /**
             * 费用标准细项
             */
            itemList?: {
              /**
               * 标准金额
               */
              standardAmount?: number;
              /**
               * 时间-天数
               */
              days?: number;
              /**
               * 费用描述
               */
              ruleDesc?: string;
            }[];
            /**
             * 火车补贴伙食费用细项
             */
            trainAllowanceMaterialDTOS?: {
              /**
               * 火车天数
               */
              trainHours?: number;
              /**
               * 火车补贴金额
               */
              trainStanardAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 用户ID
               */
              operatorId?: number;
              /**
               * 人员来源 1-系统内部；2-外部人员
               */
              userSource?: 1 | 2;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
            }[];
            /**
             * 火车总额度
             */
            trainTotalAmount?: number;
            /**
             * 是否派车
             */
            isCar?: boolean;
            /**
             * 派车铺贴计算
             */
            carAllowanceMaterialDTOS?: {
              /**
               * 派车天数
               */
              carDays?: number;
              /**
               * 派车金额
               */
              carStandardtotalAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
            }[];
          };
          /**
           * 通用类材料信息
           */
          meetingOrTrainMaterialDTO?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 会议类型
             */
            meetingType?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
            /**
             * 培训人员
             */
            trainingPerson?: string;
            /**
             * 培训人员职级
             */
            trainingPersonLevel?: number;
            /**
             * 培训人员职级
             */
            trainingPersonLevelDesc?: string;
            /**
             * 培训时长
             */
            trainingHour?: number;
          };
          /**
           * 业务招待材料信息
           */
          businessEntertainingMaterial?: {
            /**
             * 招待日期
             */
            entertainDate?: string;
            /**
             * 招待形式
             */
            entertainForm: 1 | 2 | 3;
            /**
             * 招待形式描述
             */
            entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
            /**
             * 招待人数
             */
            entertainPeopleNum: number;
            /**
             * 招待事由
             */
            entertainReason: string;
          };
          /**
           * 交通费-租车费材料信息
           */
          rentCarFeeMaterial?: {
            /**
             * 租车申请单信息
             */
            rentCarApplyForm?: {
              /**
               * 业务单据号
               */
              businessNo?: string;
              /**
               * 申请编号
               */
              applyFormCode?: string;
              /**
               * 用车人（前端回显）
               */
              carUserList?: {
                /**
                 * 人员id
                 */
                operatorId: number;
                /**
                 * 人员名称
                 */
                operatorName: string;
                /**
                 * 机构id
                 */
                institutionId?: number;
                /**
                 * 机构名称
                 */
                institutionName?: string;
                /**
                 * 外部人员职级
                 * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
                 */
                outerUserRank?: number;
                /**
                 * 人员类型
                 * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
                 */
                userType?: number;
                userId?: number;
                userName?: string;
                bankCardInfo?: {
                  /**
                   * 银行代码
                   */
                  bankCode: string;
                  /**
                   * 银行名字
                   */
                  bankName: string;
                  /**
                   * 账户名称
                   */
                  accountName: string;
                  /**
                   * 银行账号
                   */
                  bankAccount: string;
                  /**
                   * 银行账号 脱敏
                   */
                  bankAccountDesc?: string;
                  /**
                   * 卡号保存的唯一标识
                   */
                  accountCode?: string;
                };
                /**
                 * 同一个人员，绑定的id
                 */
                bindOperatorId?: number;
                /**
                 * 用户类型
                 * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
                 */
                type: number;
                /**
                 * 用户职级,
                 * 内部用户的职级，外部用户关联内部用户，取内部用户职级
                 * 否则去外部用户职级
                 */
                userRank?: string;
                /**
                 * 手机号
                 */
                mobile?: string;
                /**
                 * 证件号码
                 */
                idCard?: string;
                /**
                 * 证件类型
                 */
                idType?: number;
                /**
                 * 性别
                 */
                gender?: number;
                /**
                 * 同行人费用code
                 */
                feeCode?: string;
              }[];
              /**
               * 预计金额（前端回显）
               */
              planAmount?: number;
              /**
               * 申请事由（前端回显）
               */
              applyReason?: string;
              /**
               * 经办人名称（前端回显）
               */
              operatorName?: string;
              /**
               * 目的地列表（前端回显）
               */
              endCityList?: {
                /**
                 * 目的城市code
                 */
                endCityCode: string;
                /**
                 * 目的城市名称
                 */
                endCityName: string;
              }[];
            }[];
            /**
             * 目的地
             */
            destination?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
            /**
             * 消费日期
             */
            consumeDate?: string[];
          };
          /**
           * 基础行程类信息
           */
          batchItineraryMaterialDTO?: {
            /**
             * 行程基本信息
             */
            itineraryMaterialDTOList?: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
              /**
               * 起始区划code
               */
              startDistrictCode: string;
              /**
               * 出发地名称
               */
              startDistrictName?: string;
              /**
               * 结束区划code
               */
              endDistrictCode: string;
              /**
               * 结束地点名称
               */
              endDistrictName?: string;
              /**
               * 人数
               */
              operatorIds?: number[];
            }[];
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
            /**
             * 人数
             */
            operatorIds?: number[];
          };
          /**
           * 修改备注
           */
          remark?: string;
          /**
           * 费用说明
           */
          feeDesc?: string;
          /**
           * 是否多票
           */
          multiInvoice?: boolean;
          /**
           * 关联的单据的编号
           */
          associateFormList?: {
            /**
             * 单据code
             */
            formCode?: string;
            formType?: null;
            originalAmount?: null;
          }[];
        };
        /**
         * 费用附件
         */
        attachments?: null;
        /**
         * 关联的报销单号
         */
        expenseFormCode?: null;
        /**
         * 费用状态描述
         */
        feeStatusDesc?: null;
        /**
         * 费用状态
         */
        feeStatus?: null;
        /**
         * 是否删除
         */
        canDelete?: null;
        /**
         * 机构名称
         */
        orgName?: null;
        /**
         * 发票是否验真
         */
        invoiceIsCheck?: null;
        /**
         * 发票验真描述
         */
        invoiceIsCheckDesc?: null;
        /**
         * 时长
         */
        travelDay?: null;
        /**
         * 时长描述
         */
        travelDayDesc?: null;
        /**
         * 是否费用有修改
         */
        feeModifyStatus?: null;
        /**
         * 费用调整记录
         */
        feeModifyRecordROS?: null;
        /**
         * 打印时使用的fileId
         */
        printFileId?: null;
        /**
         * 费用备注
         */
        remark?: null;
        /**
         * 发票附件类型
         */
        attachmentMimeType?: null;
        /**
         * 发票状态
         */
        realStatus?: null;
        /**
         * 发票状态描述
         */
        realStatusDesc?: null;
        /**
         * 详细扩展信息
         */
        detailExtendDTO?: null;
        /**
         * 是否有版式文件
         */
        hasFormatFile?: null;
        amountDesc?: null;
        beginCity?: null;
        endCity?: null;
        /**
         * 由于beginCity endCity 在票据设置时使用，不清楚具体用来干啥，故不动他
         * 新增 printBeginCity printEndCity
         * 费用代码要优化了，现在掺杂了很多业务
         */
        printBeginCity?: null;
        printEndCity?: null;
        departureTime?: null;
        /**
         * 招待人数
         */
        entertainPeopleNumDesc?: null;
        /**
         * 招待时间
         */
        entertainDateDesc?: null;
        /**
         * 住宿天数
         */
        accommodationDaysDesc?: null;
      }[];
    }[];
    /**
     * 收款人信息
     */
    receiverPOS?: null;
    /**
     * 预算指标数据
     */
    budgetInfoRO?: null;
    /**
     * 预算额度数据
     */
    quotaInfoROS?: null;
    /**
     * TRUE使用指标，FALSE使用额度
     */
    budgetFlag?: null;
    /**
     * 报销事由
     */
    expenseReason?: null;
    /**
     * 操作员ID
     */
    operatorId?: null;
    /**
     * 工作单位ID
     */
    orgId?: null;
    /**
     * 工作单位名称
     */
    orgName?: null;
    /**
     * 工作部门ID
     */
    deptId?: null;
    /**
     * 工作部门名称
     */
    deptName?: null;
    /**
     * 报销单状态描述
     */
    expenseFormStatusDesc?: null;
    /**
     * 报销单状态
     */
    expenseFormStatus?: null;
    /**
     * 申请人
     */
    applyUserName?: null;
    /**
     * 申请人operatorId
     */
    applyOperatorId?: null;
    /**
     * 收款总金额
     */
    totalAmount?: null;
    /**
     * 是否可审核
     */
    canAudit?: null;
    /**
     * 费用总金额
     */
    feeTotalAmount?: null;
    /**
     * 培训-综合定额费用总金额
     */
    mixFeeTotalAmount?: null;
    /**
     * 培训-师资费用总金额
     */
    teacherFeeTotalAmount?: null;
    /**
     * 总冻结预算额度
     */
    frozenBudgetTotalAmount?: null;
    /**
     * 是否可撤回
     */
    canRevoke?: null;
    /**
     * 用户角色
     */
    userRole?: null;
    /**
     * 报销单业务编号
     */
    businessCode?: null;
    /**
     * 支付明细
     */
    expenseFormPayInfos?: null;
    /**
     * 宁波收款明细
     */
    receiverPayInfoDTOS?: null;
    /**
     * 简报列表
     */
    briefReportList?: null;
    /**
     * 扩展信息
     */
    extendFieldDTO?: null;
    /**
     * 单据附件
     */
    formAttachmentDTO?: null;
    /**
     * 单据发票信息列表
     */
    formInvoiceInfoList?: null;
    /**
     * 要打印的发票FileId集合
     */
    printInvoiceFileIds?: null;
    /**
     * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
     */
    processStatus?: null;
    /**
     * 提交时间
     */
    submitTime?: null;
    /**
     * 触发弱控原因列表
     */
    excessiveReasonList?: null;
    /**
     * 报销单订单信息
     */
    orderExpenseFormList?: null;
    /**
     * 报销单合同信息
     */
    contractExpenseFormList?: null;
    /**
     * 合同兑付单详情实体
     */
    contractDeclarationDetailList?: null;
    /**
     * 驳回原因
     */
    rejectReason?: null;
    /**
     * 付款账户信息，当为自有资金支付的时候并且是财务角色的时候才会返回
     */
    expenseFormPayAccountRO?: null;
    /**
     * 是否财政预算资金
     */
    purchaseFundSource?: null;
    /**
     * 支付方式Code
     */
    payMode: null;
    /**
     * 支付类型名，{@link PayModeEnum}
     */
    payModeName?: null;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategy?: null;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategyName?: null;
    /**
     * 备注
     */
    remark?: null;
    /**
     * 摘要
     */
    summary?: null;
    operateButton?: null;
    /**
     * 身份信息
     */
    identity?: null;
    /**
     * 工作流审核人id集合，包含已审核和未审核操作人列表
     */
    workflowAuditorIds?: null;
    /**
     * 采购交易信息 for 会议/培训多收款人报销单
     */
    tradeInfoList?: null;
    /**
     * 结算单简要实体列表
     */
    settlementSimpleList?: null;
    /**
     * 失败支付记录条数
     */
    payFailedTotal?: null;
    /**
     * 公共缴费账单明细
     */
    expensePublicPaymentBillList?: null;
    /**
     * 是否百搭单据
     */
    isBaidaForm?: null;
    /**
     * 是否无票报销,采购场景单收款人使用;0非无票报销  1无票报销为补充  2无票报销已补充
     */
    withoutInvoiceStatus?: null;
    /**
     * 支付变更状态
     * 0-无变更；1-已更正；2-已退款
     */
    payChangeType?: null;
    /**
     * 支付更正记录
     */
    expensePayChangeInfoROList?: null;
    /**
     * 预算关联关系
     * 目前存在情况，在财务审核时，预算可以直接与单据关联，也可以与收款人关联（一般事项多收款），后续也有其他关联
     */
    budgetRelationInfoROList?: null;
    workflowInfo?: null;
    /**
     * 收款账户调整记录数量
     */
    recAdjustNum?: null;
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: null;
    /**
     * 包干经费预算
     */
    fundBudget?: null;
    /**
     * 其他资金明细列表
     */
    restDetailList?: null;
    /**
     * 会计科目-本方科目
     */
    actSubjectCode?: null;
    /**
     * 会计科目名称-本方科目
     */
    actSubjectName?: null;
    /**
     * 是否启用核算（其他资金，如若扩展则可增加）:0-否,1-是
     */
    isEnableAccount?: null;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: null;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: null;
}

/**
 * 接口 [结算页查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242898) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getInfoOnCashier`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormGetInfoOnCashierGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/getInfoOnCashier',
    'data',
    string,
    'expenseFormCode' | 'referer' | 'identity' | 'desensitize' | 'payChangeStatus',
    false
  >
>;

/**
 * 接口 [结算页查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242898) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getInfoOnCashier`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormGetInfoOnCashierGetRequestConfig: ZlbApiExpenseExpenseFormGetInfoOnCashierGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/getInfoOnCashier',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: ['expenseFormCode', 'referer', 'identity', 'desensitize', 'payChangeStatus'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormGetInfoOnCashierGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [结算页查询报销单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/242898) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getInfoOnCashier`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormGetInfoOnCashierGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormGetInfoOnCashierGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormGetInfoOnCashierGetResponse>(
    prepare(zlbApiExpenseExpenseFormGetInfoOnCashierGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormGetInfoOnCashierGet.requestConfig =
  zlbApiExpenseExpenseFormGetInfoOnCashierGetRequestConfig;

/**
 * 接口 [重新支付↗](http://yapi.cai-inc.com/project/3621/interface/api/244626) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/repay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormRepayPostRequest {
  /**
   * 报销单号
   */
  expenseFormCode: string;
  /**
   * 预算指标信息
   */
  budgetInfoPO?: {
    /**
     * 主预算编号
     */
    mainBudgetCode: number;
    /**
     * 预算指标编号
     */
    budgetUk: string;
    /**
     * 支付限额经济分类主键
     */
    budgetPlanClassifyUk: string;
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 交易信息 for 会议/培训多收款人
     */
    tradeCode?: string;
    /**
     * 支付记录信息code
     */
    payRecordCode?: string;
  }[];
  /**
   * 预算额度信息
   */
  quotaInfoPO?: {
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 预算额度id
     */
    budgetQuotaId: string;
    /**
     * 交易信息 for 会议/培训多收款人
     */
    tradeCode?: string;
    /**
     * 支付记录信息code
     */
    payRecordCode?: string;
  }[];
  /**
   * 付款账户唯一code
   */
  payAccountCode?: string;
  /**
   * 收款账户code，当为自有资金支付的时候才有值
   */
  receiverCode?: string;
  /**
   * 是否需要跳过校验
   */
  isIgnoreWarning?: boolean;
  /**
   * 支付渠道，{@link cn.gov.zlb.finance.expense.domain.enums.PayModeEnum}
   */
  payMode?: number;
  /**
   * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
   *       3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
   */
  payStrategy?: number;
  /**
   * 摘要
   */
  summary: string;
  /**
   * 大屏监控需要
   */
  businessCode?: string;
  /**
   * 宁波收款明细PO
   */
  receiverPayInfoQueryList?: {
    /**
     * 收款卡基本信息
     */
    receiverPO?: {
      /**
       * 操作人ID
       */
      operatorId: number;
      /**
       * 账号code
       */
      accountCode?: string;
      /**
       * 收款金额
       */
      amount: number;
      /**
       * 原收款金额
       */
      originalAmount?: number;
      /**
       * 收款人姓名
       */
      receiverName: string;
      /**
       * 前端数组下标
       */
      indexNo: string;
      /**
       * 收款人Code
       */
      receiverCode?: string;
      /**
       * 调整原因
       */
      updateReason?: string;
      /**
       * 费用更新金额
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 人员来源 1-系统内部；2-外部人员
       */
      userSource?: 1 | 2;
      userType?: number;
      /**
       * 用户类型
       */
      type?: number;
      /**
       * 类型
       */
      fundsObjectType?:
        | 1
        | 11
        | 12
        | 13
        | 14
        | 19
        | 2
        | 21
        | 22
        | 23
        | 24
        | 3
        | 31
        | 32
        | 4
        | 41
        | 42;
    };
    /**
     * 个人卡报销
     */
    personalCardExpenseQueryList?: {
      /**
       * 前端下标
       */
      indexNo: string;
      /**
       * 消费金额
       */
      amount?: number;
      /**
       * 拆分的金额
       */
      splitAmount?: number[];
      /**
       * 报销里的消费记录主键
       */
      consumptionRecordCode?: string;
      /**
       * 拆分金额
       */
      splitAmountDetail?: {
        /**
         * 拆分金额
         */
        amount: number;
        /**
         * 支付类型
         */
        payStrategy:
          | 'FINA_ZERO_PAY'
          | 'UNIT_ZERO_PAY'
          | 'UNIT_FUND_PAY'
          | 'FINA_SPLIT_PAY'
          | 'AUTH_NORMAL_PAY'
          | 'DIRECTLY_NORMAL_PAY'
          | 'AUTH_BUSINESS_CARD_PAY'
          | 'AUTH_PERSONAL_BATCH_PAY'
          | 'AUTH_ENTERPRISE_BATCH_PAY'
          | 'FINA_AND_FUND_PAY'
          | 'UNIT_FUND_NORMAL_PAY'
          | 'UNIT_FUND_OFF_CARD_PAY'
          | 'NB_FINA_ZERO_PAY'
          | 'NB_UNIT_ZERO_PAY'
          | 'NB_UNIT_FUND_PAY'
          | 'NB_FINA_SPLIT_PAY'
          | 'CBS_NORMAL_PAY'
          | 'CBS_BATCH_PAY';
        /**
         * 支付类型名称
         */
        payStrategyName?: string;
      }[];
    }[];
  }[];
  /**
   * 报销收款人数据
   * 0831需求：差旅重新支付可以更改收款人
   */
  expenseFormReceiverPOS?: {
    /**
     * 操作人ID
     */
    operatorId: number;
    /**
     * 账号code
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount: number;
    /**
     * 原收款金额
     */
    originalAmount?: number;
    /**
     * 收款人姓名
     */
    receiverName: string;
    /**
     * 前端数组下标
     */
    indexNo: string;
    /**
     * 收款人Code
     */
    receiverCode?: string;
    /**
     * 调整原因
     */
    updateReason?: string;
    /**
     * 费用更新金额
     */
    modifyFeeAmountDTO?: {
      /**
       * 原始金额
       */
      originalAmount: number;
      /**
       * 修改后金额
       */
      updateAmount: number;
      /**
       * 修改备注
       */
      updateReason?: string;
      /**
       * 原始账户
       */
      originalAccount?: string;
      /**
       * 修改后账户
       */
      updateAccount?: string;
    };
    /**
     * 人员来源 1-系统内部；2-外部人员
     */
    userSource?: 1 | 2;
    userType?: number;
    /**
     * 用户类型
     */
    type?: number;
    /**
     * 类型
     */
    fundsObjectType?:
      | 1
      | 11
      | 12
      | 13
      | 14
      | 19
      | 2
      | 21
      | 22
      | 23
      | 24
      | 3
      | 31
      | 32
      | 4
      | 41
      | 42;
  }[];
}

/**
 * 接口 [重新支付↗](http://yapi.cai-inc.com/project/3621/interface/api/244626) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/repay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormRepayPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态 0：通过 1：警告 2：强控 3 提示
     */
    checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
    /**
     * 行程冲突校验结果
     */
    itineraryCheckResultRO?: {
      /**
       * 所有行程是否通过行程校验
       * 通过：0
       */
      checkStatus?: number;
      /**
       * 报销单行程校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 行程数组索引
         */
        indexNo?: string;
        /**
         * 每段行程的提示文案及校验状态
         */
        itineraryCheckResultList?: {
          /**
           * 校验状态
           * 0-通过 1-弱控 2-强控 3-提示
           */
          checkStatus?: 0 | 1 | 2 | 3;
          /**
           * 提示文案
           */
          message?: string;
        }[];
      }[];
      /**
       * 整体提示信息
       * 暂时仅有不足申请单的部分有赋值
       */
      overallCheckResult?: {
        /**
         * 校验状态
         * 0-通过 1-弱控 2-强控 3-提示
         */
        checkStatus?: 0 | 1 | 2 | 3;
        /**
         * 提示文案
         */
        message?: string;
      };
    };
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
            /**
             * 校验结果
             */
            checkStatus?: number;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
              /**
               * 校验结果
               */
              checkStatus?: number;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
            /**
             * 设置结果
             */
            resultInfo?: {
              /**
               * 凭票报销总结果
               */
              expenseFeeInvoiceResult?: {
                /**
                 * 用户id
                 */
                operatorId?: number;
                /**
                 * 用户名称
                 */
                operatorName?: string;
                /**
                 * 报销金额
                 */
                amount?: number;
                /**
                 * 报销金额描述
                 */
                amountDesc?: string;
                /**
                 * 详细信息
                 */
                detailInfoList?: {
                  /**
                   * 发生日期
                   */
                  happenDate?: null;
                  /**
                   * 是否可以报销
                   */
                  canExpense?: null;
                  /**
                   * 表单code
                   */
                  formCode?: string[];
                  /**
                   * 业务code
                   */
                  businessCode?: string[];
                  /**
                   * 冲突描述
                   */
                  conflictDesc?: null;
                  /**
                   * 是否凭票报销冲突
                   */
                  isUseInvoice?: null;
                  /**
                   * 规则描述
                   */
                  ruleDesc?: null;
                  /**
                   * 金额
                   */
                  ruleAmount?: null;
                }[];
              }[];
              /**
               * 凭票报销总结果提示
               */
              expenseFeeInvoiceTips?: string;
              /**
               * 是否展示
               */
              canShow?: boolean;
            };
            /**
             * 是否需要显示
             */
            canShow?: boolean;
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
          /**
           * 校验结果
           */
          checkStatus?: number;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 预算校验结果
     */
    budgetCheckResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
      /**
       * 预算指标ID
       */
      mainBudgetCode?: number;
      /**
       * 预算指标编号
       */
      budgetUk?: string;
      /**
       * 预算编号(展示)
       */
      financialBudgetDetailId?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 额度ID
       */
      budgetQuotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag?: boolean;
      /**
       * 占用总金额
       */
      budgetTotalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 关联预算的业务信息
       */
      budgetExceptionTipsROS?: {
        /**
         * 关联预算的Code
         */
        budgetRelationBusinessCode?: string;
        /**
         * 关联预算的业务名称描述
         */
        budgetRelationBusinessDesc?: string;
        /**
         * 关联交易描述
         */
        tradeDesc?: string;
        /**
         * 关联预算业务数据类型
         * 直接以枚举的名称作为存储，以便在请求中可以直接看出
         */
        relationBusinessType?:
          | '报销单'
          | '交易'
          | '收款账户'
          | '工资流水'
          | '夜餐费发放单'
          | '项目支付单';
        /**
         * 占用的金额
         */
        budgetAmount?: number;
      }[];
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 预算项目校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 科目校验描述
         */
        subjectCheckDesc?: string;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
      }[];
    };
    /**
     * 收款信息校验结果
     */
    receiverCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 收款信息校验详情
       */
      checkResultInfoROS?: {
        /**
         * 是否通过校验
         */
        checkStatus?: number;
        /**
         * 收款人信息数组下标
         */
        indexNo?: string;
        /**
         * 提示消息
         */
        msg?: string[];
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 支付方式校验结果
     */
    payConfigCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 订单校验结果
     */
    orderCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 报销单号
     */
    expenseFormCode?: string;
    /**
     * 合同校验结果
     */
    contractCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 发票校验结果
     */
    invoiceCheckResultROS?: {
      /**
       * 发票ID
       */
      platformInvoiceId?: string;
      /**
       * 状态码
       */
      code?: number;
      /**
       * 是否可报销 true：可以报销 false：不可以报销
       */
      success?: boolean;
      /**
       * 提示消息
       */
      msg?: string;
    }[];
    /**
     * 超标原因配置
     */
    reasonConfigROS?: {
      /**
       * 状态
       */
      checkStatus?: number;
      /**
       * 规则列表
       */
      ruleInfoROS?: {
        /**
         * 规则描述
         */
        ruleDesc?: string;
        /**
         * 规则code
         */
        ruleCode?: string;
        /**
         * 状态
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      }[];
      /**
       * 超标配置列表
       */
      reasonConfigList?: {
        /**
         * 校验结果分组code
         */
        checkGroupCode?: string;
        /**
         * 父标题
         */
        parentTitle?: string;
        /**
         * 子标题
         */
        subTitle?: string;
        /**
         * 合并code
         */
        mergeGroupCode?: string;
        /**
         * 是否必填
         */
        isMust?: number;
        /**
         * 备注长度
         */
        remarkLength?: number;
      }[];
    };
    /**
     * 含有异常申请单的列表（校验通过时为空数组）
     */
    applyFormCheckResultROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 检查结果
       */
      checkResult?: 0 | 1 | 2;
      /**
       * 检查结果描述
       */
      checkResultDesc?: '通过' | '已作废' | '已关联';
      /**
       * 被关联的其他报销单号
       */
      certainExpenseFormCode?: string[];
    }[];
    /**
     * 其他资金校验
     */
    restFundCheckRO?: {
      /**
       * 基础校验
       */
      baseControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string[];
      };
      /**
       * 资金控制校验
       */
      fundControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string;
        /**
         * 校验公共参数
         */
        checkList?: {
          indexNo?: string;
          checkStatus?: number;
          checkMessage?: string;
          extraJson?: string;
          bindCount?: number;
        }[];
      };
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [重新支付↗](http://yapi.cai-inc.com/project/3621/interface/api/244626) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/repay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormRepayPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/repay',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [重新支付↗](http://yapi.cai-inc.com/project/3621/interface/api/244626) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/repay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormRepayPostRequestConfig: ZlbApiExpenseExpenseFormRepayPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/repay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormRepayPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [重新支付↗](http://yapi.cai-inc.com/project/3621/interface/api/244626) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/repay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormRepayPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormRepayPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormRepayPostResponse>(
    prepare(zlbApiExpenseExpenseFormRepayPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormRepayPost.requestConfig = zlbApiExpenseExpenseFormRepayPostRequestConfig;

/**
 * 接口 [发票查询↗](http://yapi.cai-inc.com/project/3621/interface/api/246732) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/invoice/query`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInvoiceQueryGetRequest {
  /**
   * 发票平台id
   */
  platformInvoiceId?: string;
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 单据类型：1-申请单、2-报销单
   */
  formType?: string;
  /**
   * 交易信息编码
   */
  tradeCode?: string;
}

/**
 * 接口 [发票查询↗](http://yapi.cai-inc.com/project/3621/interface/api/246732) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/invoice/query`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInvoiceQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    platformInvoiceId?: string;
    imageUrl?: string;
    zlbImageUrl?: string;
    formatFileId?: string;
    formatFileName?: string;
    invoiceType?: string;
    invoiceSimpleCode?: number;
    invoiceSimpleDesc?: string;
    invoiceTypeDesc?: string;
    invoiceCode?: string;
    invoiceNo?: string;
    issueDate?: string;
    totalAmount?: number;
    pretaxAmount?: number;
    taxAmount?: number;
    deductionTax?: number;
    operatorId?: number;
    reimburseNo?: string;
    realStatus?: number;
    realStatusDesc?: string;
    checkCode?: string;
    fileId?: string;
    fileName?: string;
    attachmentMimeType?: string;
    invoiceDetail?: {
      platformInvoiceId?: string;
      invoiceType?: string;
      invoiceCode?: string;
      invoiceNo?: string;
      issueDate?: string;
      totalAmount?: number;
      pretaxAmount?: number;
      taxAmount?: number;
      checkCode?: string;
      realStatus?: number;
      logId?: string;
      departureCityCode?: string;
      arrivalCityCode?: string;
      departureCity?: string;
      arrivalCity?: string;
      departureTime?: string;
      beginCity?: string;
      endCity?: string;
      itemSpec?: string;
      itemSpecName?: string;
      buyerName?: string;
      buyerOpId?: number;
      buyerType?: number;
      itemName?: string;
      ticketRates?: string;
      premium?: string;
      fuelSurcharge?: string;
      adf?: string;
    };
    downloadFileId?: string;
    buyerTaxNo?: string;
    sellerTaxNo?: string;
    sellerName?: string;
    buyerName?: string;
    dataSource?: string;
    invoiceGoodsInfoROS?: {
      detailNo?: string;
      goodsName?: string;
      detailAmount?: string;
      num?: string;
      taxRate?: string;
      taxAmount?: string;
      taxUnitPrice?: string;
      taxDetailAmount?: string;
      unitPrice?: string;
      specificationModel?: string;
      unit?: string;
    }[];
    invoiceTaxInfoROS?: {
      detailNo?: string;
      goodsName?: string;
      detailAmount?: string;
      num?: string;
      taxRate?: string;
      taxAmount?: string;
      taxUnitPrice?: string;
      taxDetailAmount?: string;
      unitPrice?: string;
      specificationModel?: string;
      unit?: string;
      licensePlateNumber?: string;
      licensePlateType?: string;
      passStartDate?: string;
      passEndDate?: string;
    }[];
    invalidOrNot?: number;
    associateOrNot?: number;
    businessType?: number;
    businessCode?: string;
    hasSignature?: boolean;
    hasFormatFile?: boolean;
    originalFileInfo?: {
      fileId?: string;
      fileName?: string;
      fileType?: string;
    };
    isDeletedInvoice?: number;
    invoiceSubject?: string;
    invoiceStatus?: number;
    enableDeleted?: boolean;
    enableEdited?: boolean;
    formatSupportStatus?: number;
    formatThumbnailUrl?: string;
    formatThumbnailFileId?: string;
    sourceFileId?: string;
    invoiceAttachments?: {
      fileId?: string;
      fileName?: string;
      fileUrl?: string;
      fileType?: string;
      businessType?: number;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [发票查询↗](http://yapi.cai-inc.com/project/3621/interface/api/246732) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/invoice/query`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInvoiceQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/invoice/query',
    'data',
    string,
    'platformInvoiceId' | 'formCode' | 'formType' | 'tradeCode',
    false
  >
>;

/**
 * 接口 [发票查询↗](http://yapi.cai-inc.com/project/3621/interface/api/246732) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/invoice/query`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInvoiceQueryGetRequestConfig: ZlbApiExpenseExpenseFormInvoiceQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/invoice/query',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: ['platformInvoiceId', 'formCode', 'formType', 'tradeCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInvoiceQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [发票查询↗](http://yapi.cai-inc.com/project/3621/interface/api/246732) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/invoice/query`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInvoiceQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInvoiceQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInvoiceQueryGetResponse>(
    prepare(zlbApiExpenseExpenseFormInvoiceQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInvoiceQueryGet.requestConfig =
  zlbApiExpenseExpenseFormInvoiceQueryGetRequestConfig;

/**
 * 接口 [根据报销单类型获取支付渠道↗](http://yapi.cai-inc.com/project/3621/interface/api/252304) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/getPayMode`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormGetPayModeGetRequest {
  /**
   * [报销单类型枚举
   * <p>
   * 申请单类型枚举：{@link ApplyFormTypeEnum}]
   * TRAVEL_EXPENSE_FORM :TRAVEL_EXPENSE_FORM
   * MEETING_EXPENSE_FORM :MEETING_EXPENSE_FORM
   * TRAINING_EXPENSE_FORM :TRAINING_EXPENSE_FORM
   * PROCUREMENT_EXPENSE_FORM :PROCUREMENT_EXPENSE_FORM
   * RECEPTION_EXPENSE_FORM :保持和申请单一致，跳过5编码
   * GENERAL_EXPENSE_FORM :GENERAL_EXPENSE_FORM
   * PURCHASE_GENERAL_EXPENSE_FORM :保持和申请单一致，跳过8编码
   * PURCHASE_GOVERNMENT_EXPENSE_FORM :PURCHASE_GOVERNMENT_EXPENSE_FORM
   * PURCHASE_FURNITURE_EXPENSE_FORM :PURCHASE_FURNITURE_EXPENSE_FORM
   * MEETING_MULTI_RECEIVER_EXPENSE_FORM :会议多收款人报销单
   * TRAINING_MULTI_RECEIVER_EXPENSE_FORM :培训多收款人报销单
   * PUBLIC_BUSINESS_PAYMENT_EXPENSE_FORM :PUBLIC_BUSINESS_PAYMENT_EXPENSE_FORM
   * INVEST_PAYMENT_EXPENSE_FORM :INVEST_PAYMENT_EXPENSE_FORM
   * REST_EXPENSE_FORM :REST_EXPENSE_FORM
   */
  expenseFormType?: string;
  orgId: string;
}

/**
 * 接口 [根据报销单类型获取支付渠道↗](http://yapi.cai-inc.com/project/3621/interface/api/252304) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/getPayMode`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormGetPayModeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 支付方式名，例如国库支付、非财政资金支付
     */
    payModeName?: string;
    /**
     * 支付方式code
     */
    payModeCode?: number;
    /**
     * 子支付方式，例如国库支付区分授权支付和直接支付
     * 如果是非财政资金支付方式，为空集合
     */
    subPayMode?: {
      /**
       * 子支付方式名，例如直接支付或授权支付
       */
      subPayModeName?: string;
      /**
       * 支付方式code
       */
      subPayModeCode?: string;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据报销单类型获取支付渠道↗](http://yapi.cai-inc.com/project/3621/interface/api/252304) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/getPayMode`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormGetPayModeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/getPayMode',
    'data',
    string,
    'expenseFormType' | 'orgId',
    false
  >
>;

/**
 * 接口 [根据报销单类型获取支付渠道↗](http://yapi.cai-inc.com/project/3621/interface/api/252304) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/getPayMode`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormGetPayModeGetRequestConfig: ZlbApiExpenseExpenseFormGetPayModeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/getPayMode',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: ['expenseFormType', 'orgId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormGetPayModeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据报销单类型获取支付渠道↗](http://yapi.cai-inc.com/project/3621/interface/api/252304) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/expense-form/getPayMode`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormGetPayModeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormGetPayModeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormGetPayModeGetResponse>(
    prepare(zlbApiExpenseExpenseFormGetPayModeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormGetPayModeGet.requestConfig =
  zlbApiExpenseExpenseFormGetPayModeGetRequestConfig;

/**
 * 接口 [更新报销单收款人信息↗](http://yapi.cai-inc.com/project/3621/interface/api/253066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormReceiverAccount`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPostRequest {
  /**
   * 报销单号
   */
  expenseFormCode: string;
  accountCode: string;
  receiverCode: string;
}

/**
 * 接口 [更新报销单收款人信息↗](http://yapi.cai-inc.com/project/3621/interface/api/253066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormReceiverAccount`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [更新报销单收款人信息↗](http://yapi.cai-inc.com/project/3621/interface/api/253066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormReceiverAccount`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/updateExpenseFormReceiverAccount',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [更新报销单收款人信息↗](http://yapi.cai-inc.com/project/3621/interface/api/253066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormReceiverAccount`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPostRequestConfig: ZlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/updateExpenseFormReceiverAccount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [更新报销单收款人信息↗](http://yapi.cai-inc.com/project/3621/interface/api/253066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/updateExpenseFormReceiverAccount`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPostResponse>(
    prepare(zlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPost.requestConfig =
  zlbApiExpenseExpenseFormUpdateExpenseFormReceiverAccountPostRequestConfig;

/**
 * 接口 [获取支付渠道和支付类型↗](http://yapi.cai-inc.com/project/3621/interface/api/259562) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getPayModeEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormGetPayModeEnumGetRequest {}

/**
 * 接口 [获取支付渠道和支付类型↗](http://yapi.cai-inc.com/project/3621/interface/api/259562) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getPayModeEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormGetPayModeEnumGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 支付方式名，例如国库支付、非财政资金支付
     */
    payModeName?: string;
    /**
     * 支付方式code
     */
    payModeCode?: number;
    /**
     * 子支付方式，例如国库支付区分授权支付和直接支付
     * 如果是非财政资金支付方式，为空集合
     */
    subPayMode?: {
      /**
       * 子支付方式名，例如直接支付或授权支付
       */
      subPayModeName?: string;
      /**
       * 支付方式code
       */
      subPayModeCode?: string;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取支付渠道和支付类型↗](http://yapi.cai-inc.com/project/3621/interface/api/259562) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getPayModeEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormGetPayModeEnumGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/getPayModeEnum',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取支付渠道和支付类型↗](http://yapi.cai-inc.com/project/3621/interface/api/259562) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getPayModeEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormGetPayModeEnumGetRequestConfig: ZlbApiExpenseExpenseFormGetPayModeEnumGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/getPayModeEnum',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormGetPayModeEnumGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取支付渠道和支付类型↗](http://yapi.cai-inc.com/project/3621/interface/api/259562) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getPayModeEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormGetPayModeEnumGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseExpenseFormGetPayModeEnumGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormGetPayModeEnumGetResponse>(
    prepare(zlbApiExpenseExpenseFormGetPayModeEnumGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormGetPayModeEnumGet.requestConfig =
  zlbApiExpenseExpenseFormGetPayModeEnumGetRequestConfig;

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/306962) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/initExpenseFormBasicInfoV2`
 * @更新时间 `2022-09-22 10:08:01`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2GetRequest {
  /**
   * 申请单列表
   */
  'applyFormCodeList[0]'?: string;
}

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/306962) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/initExpenseFormBasicInfoV2`
 * @更新时间 `2022-09-22 10:08:01`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2GetResponse {
  success?: boolean;
  result?: {
    businessType?: number;
    businessTypeName?: string;
    orgId?: number;
    orgName?: string;
    deptId?: number;
    deptName?: string;
    expenseReason?: string;
    remark?: string;
    /**
     * [{"receiverCode":"","bankName":"","bankCode":"","accountCode":"","cardNo":"","cardType":0,"amount":0,"operatorId":0,"receiverName":"","userSource":0}]
     */
    expenseReceiverList?: {
      receiverCode?: string;
      bankName?: string;
      bankCode?: string;
      accountCode?: string;
      cardNo?: string;
      cardType?: number;
      amount?: number;
      operatorId?: number;
      receiverName?: string;
      userSource?: number;
    }[];
    /**
     * [{"applyReason":"","applyFormCode":"","applyUserName":"","initiationTime":"","businessCode":"","formStatus":0,"travelStartTime":"","associateStatus":false,"businessName":"","applyRemainingAmount":0,"dataSource":0,"formAttachmentDTO":{"normalAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"thatAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"informAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"compactAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"signAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"officialLetterAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"receptionMenuAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"purchasePurposeAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"propertyUpdatePlanAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"meetingSummaryAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"argumentSuggestionAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}],"specialAttachmentList":[{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]},"extendFieldDTO":{"travelExtendFields":{"arrangeCar":"","dayCount":0},"meetingExtendFields":{"meetingName":"","meetingCityCode":"","meetingCityName":"","meetingStartDate":"@datetime","meetingEndDate":"@datetime","meetingDayCount":0,"meetingExpectAttendeeCount":0,"meetingRealAttendeeCount":0,"meetingWorkerCount":0,"meetingLeaderInfo":"","meetingAgenda":"","isIncludedBudget":0,"meetingDifferenceContent":"","remark":"","isCreatePurchaseProposal":0,"contractList":[{"contractId":0,"orderCode":"","contractCode":"","contractName":"","amount":0}]},"trainingExtendFields":{"trainingName":"","trainingCityCode":"","trainingCityName":"","trainingStartDate":"@datetime","trainingEndDate":"@datetime","trainingDayCount":0,"trainingExpectAttendeeCount":0,"trainingRealAttendeeCount":0,"trainingWorkerCount":0,"trainingAgenda":"","isIncludedBudget":0,"trainingDifferenceContent":"","trainingTeacherInfo":"","remark":"","isCreatePurchaseProposal":0,"purchaseFundSource":0,"purchaseFundSourceDesc":"","changePayModeReason":"","contractList":[{"contractId":0,"orderCode":"","contractCode":"","contractName":"","amount":0}]},"procurementExtendFields":{"procurementContent":"","procurementDifferenceContent":"","remark":"","applyAmount":0,"contractList":[{"contractId":0,"orderCode":"","contractCode":"","contractName":"","amount":0}]},"receptionExtendFields":{"visitOrgName":"","isSameCity":0,"visitReason":"","visitStartDate":"@datetime","visitEndDate":"@datetime","visitorLevel":0,"visitorLevelName":"","visitorCount":1,"receptionCityCode":"","receptionCityName":"","mealDate":"@datetime","mealType":0,"mealTypeName":"","escortCount":1},"generalExtendFields":{"detailContent":"","eventBudget":0,"generalDifferenceContent":""},"contractExtendFields":{"uniqueCode":""},"tenderApplyExtendFields":{"applyFormType":"@pick([1,2,3,4,5,6,7,8,9,10,11])","applyReason":"","applyFormCode":"","businessCode":"","submitTime":"@datetime"},"purchaseGeneralFields":{"organizationalForm":"@pick([1,2,3,4])","organizationalFormDesc":"","purchaseMethod":"@pick([1,2,3,4,5,6,7,8])","purchaseMethodDesc":"","isCreatePurchaseProposal":0,"purchaseType":"@pick([1,2])","purchaseTypeDesc":"","purchaseFundSource":"@pick([1,2])","purchaseFundSourceDesc":""},"govermentApplyFields":{"organizationalForm":"@pick([1,2,3,4])","organizationalFormDesc":"","purchaseMethod":"@pick([1,2,3,4,5,6,7,8])","purchaseMethodDesc":"","isCreatePurchaseProposal":0,"purchaseType":"@pick([1,2])","purchaseTypeDesc":"","purchaseFundSource":"@pick([1,2])","purchaseFundSourceDesc":""},"furnitureApplyFields":{"organizationalForm":"@pick([1,2,3,4])","organizationalFormDesc":"","purchaseMethod":"@pick([1,2,3,4,5,6,7,8])","purchaseMethodDesc":"","isCreatePurchaseProposal":0},"purchaseGeneralExpenseFieldDTO":{"tradeWay":[""],"procurementDifferenceContent":"","remark":"","tradeWayName":""}}}]
     */
    applyFormSimpleInfoList?: {
      applyReason?: string;
      applyFormCode?: string;
      applyUserName?: string;
      initiationTime?: string;
      businessCode?: string;
      formStatus?: number;
      travelStartTime?: string;
      associateStatus?: boolean;
      businessName?: string;
      applyRemainingAmount?: number;
      dataSource?: number;
      formAttachmentDTO?: {
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        normalAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        thatAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        informAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        compactAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        signAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        officialLetterAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        receptionMenuAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        purchasePurposeAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        propertyUpdatePlanAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        meetingSummaryAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        argumentSuggestionAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
        /**
         * [{"fileId":"","type":"","name":"","size":0,"bizCode":"","url":""}]
         */
        specialAttachmentList?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
        }[];
      };
      extendFieldDTO?: {
        travelExtendFields?: {
          arrangeCar?: string;
          dayCount?: number;
        };
        meetingExtendFields?: {
          meetingName?: string;
          meetingCityCode?: string;
          meetingCityName?: string;
          /**
           * "@datetime"
           */
          meetingStartDate?: string;
          /**
           * "@datetime"
           */
          meetingEndDate?: string;
          meetingDayCount?: number;
          meetingExpectAttendeeCount?: number;
          meetingRealAttendeeCount?: number;
          meetingWorkerCount?: number;
          meetingLeaderInfo?: string;
          meetingAgenda?: string;
          isIncludedBudget?: number;
          meetingDifferenceContent?: string;
          remark?: string;
          isCreatePurchaseProposal?: number;
          /**
           * [{"contractId":0,"orderCode":"","contractCode":"","contractName":"","amount":0}]
           */
          contractList?: {
            contractId?: number;
            orderCode?: string;
            contractCode?: string;
            contractName?: string;
            amount?: number;
          }[];
        };
        trainingExtendFields?: {
          trainingName?: string;
          trainingCityCode?: string;
          trainingCityName?: string;
          /**
           * "@datetime"
           */
          trainingStartDate?: string;
          /**
           * "@datetime"
           */
          trainingEndDate?: string;
          trainingDayCount?: number;
          trainingExpectAttendeeCount?: number;
          trainingRealAttendeeCount?: number;
          trainingWorkerCount?: number;
          trainingAgenda?: string;
          isIncludedBudget?: number;
          trainingDifferenceContent?: string;
          trainingTeacherInfo?: string;
          remark?: string;
          isCreatePurchaseProposal?: number;
          purchaseFundSource?: number;
          purchaseFundSourceDesc?: string;
          changePayModeReason?: string;
          /**
           * [{"contractId":0,"orderCode":"","contractCode":"","contractName":"","amount":0}]
           */
          contractList?: {
            contractId?: number;
            orderCode?: string;
            contractCode?: string;
            contractName?: string;
            amount?: number;
          }[];
        };
        procurementExtendFields?: {
          procurementContent?: string;
          procurementDifferenceContent?: string;
          remark?: string;
          applyAmount?: number;
          /**
           * [{"contractId":0,"orderCode":"","contractCode":"","contractName":"","amount":0}]
           */
          contractList?: {
            contractId?: number;
            orderCode?: string;
            contractCode?: string;
            contractName?: string;
            amount?: number;
          }[];
        };
        receptionExtendFields?: {
          visitOrgName?: string;
          isSameCity?: number;
          visitReason?: string;
          /**
           * "@datetime"
           */
          visitStartDate?: string;
          /**
           * "@datetime"
           */
          visitEndDate?: string;
          visitorLevel?: number;
          visitorLevelName?: string;
          /**
           * 1
           */
          visitorCount?: number;
          receptionCityCode?: string;
          receptionCityName?: string;
          /**
           * "@datetime"
           */
          mealDate?: string;
          mealType?: number;
          mealTypeName?: string;
          /**
           * 1
           */
          escortCount?: number;
        };
        generalExtendFields?: {
          detailContent?: string;
          eventBudget?: number;
          generalDifferenceContent?: string;
        };
        contractExtendFields?: {
          uniqueCode?: string;
        };
        tenderApplyExtendFields?: {
          /**
           * "@pick([1,2,3,4,5,6,7,8,9,10,11])"
           */
          applyFormType?: string;
          applyReason?: string;
          applyFormCode?: string;
          businessCode?: string;
          /**
           * "@datetime"
           */
          submitTime?: string;
        };
        purchaseGeneralFields?: {
          /**
           * "@pick([1,2,3,4])"
           */
          organizationalForm?: string;
          organizationalFormDesc?: string;
          /**
           * "@pick([1,2,3,4,5,6,7,8])"
           */
          purchaseMethod?: string;
          purchaseMethodDesc?: string;
          isCreatePurchaseProposal?: number;
          /**
           * "@pick([1,2])"
           */
          purchaseType?: string;
          purchaseTypeDesc?: string;
          /**
           * "@pick([1,2])"
           */
          purchaseFundSource?: string;
          purchaseFundSourceDesc?: string;
        };
        govermentApplyFields?: {
          /**
           * "@pick([1,2,3,4])"
           */
          organizationalForm?: string;
          organizationalFormDesc?: string;
          /**
           * "@pick([1,2,3,4,5,6,7,8])"
           */
          purchaseMethod?: string;
          purchaseMethodDesc?: string;
          isCreatePurchaseProposal?: number;
          /**
           * "@pick([1,2])"
           */
          purchaseType?: string;
          purchaseTypeDesc?: string;
          /**
           * "@pick([1,2])"
           */
          purchaseFundSource?: string;
          purchaseFundSourceDesc?: string;
        };
        furnitureApplyFields?: {
          /**
           * "@pick([1,2,3,4])"
           */
          organizationalForm?: string;
          organizationalFormDesc?: string;
          /**
           * "@pick([1,2,3,4,5,6,7,8])"
           */
          purchaseMethod?: string;
          purchaseMethodDesc?: string;
          isCreatePurchaseProposal?: number;
        };
        purchaseGeneralExpenseFieldDTO?: {
          /**
           * [""]
           */
          tradeWay?: string[];
          procurementDifferenceContent?: string;
          remark?: string;
          tradeWayName?: string;
        };
      };
    }[];
    /**
     * [{"applyFormCode":"","businessCode":"","itinerarySplitList":[{"applyFormCode":"","sourceType":0,"checkStatus":"@pick([0,1,2,3])","msg":[""],"originalItinerary":{"indexNo":"","itineraryCode":"","originalItineraryCode":"","accompanyList":[{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}],"beginTime":"@datetime","beginTag":0,"endTime":"@datetime","endTag":0,"travelDay":0,"beginCityCode":"","beginCityName":"","endCityList":[{"endCityCode":"","endCityName":""}],"checkResultMessageRO":{"tipStatus":0,"tipText":"","tipMsg":[""],"tipLists":[{"checkStatusCode":0,"msg":"","ruleCode":""}]},"arrangeCar":0,"arrangeCarRO":{"arrangeCarCode":"","itineraryCode":"","beginTime":"@datetime","endTime":"@datetime","beginTag":0,"endTag":0,"arrangeCarDay":0,"passengerList":[{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}]},"accommodationDay":0},"currentItinerary":{"indexNo":"","itineraryCode":"","originalItineraryCode":"","accompanyList":[{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}],"beginTime":"@datetime","beginTag":0,"endTime":"@datetime","endTag":0,"travelDay":0,"beginCityCode":"","beginCityName":"","endCityList":[{"endCityCode":"","endCityName":""}],"checkResultMessageRO":{"tipStatus":0,"tipText":"","tipMsg":[""],"tipLists":[{"checkStatusCode":0,"msg":"","ruleCode":""}]},"arrangeCar":0,"arrangeCarRO":{"arrangeCarCode":"","itineraryCode":"","beginTime":"@datetime","endTime":"@datetime","beginTag":0,"endTag":0,"arrangeCarDay":0,"passengerList":[{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}]},"accommodationDay":0},"checkResultMessageRO":{"tipStatus":0,"tipText":"","tipMsg":[""],"tipLists":[{"checkStatusCode":0,"msg":"","ruleCode":""}]}}]}]
     */
    applyItinerarySplitList?: {
      applyFormCode?: string;
      businessCode?: string;
      /**
       * [{"applyFormCode":"","sourceType":0,"checkStatus":"@pick([0,1,2,3])","msg":[""],"originalItinerary":{"indexNo":"","itineraryCode":"","originalItineraryCode":"","accompanyList":[{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}],"beginTime":"@datetime","beginTag":0,"endTime":"@datetime","endTag":0,"travelDay":0,"beginCityCode":"","beginCityName":"","endCityList":[{"endCityCode":"","endCityName":""}],"checkResultMessageRO":{"tipStatus":0,"tipText":"","tipMsg":[""],"tipLists":[{"checkStatusCode":0,"msg":"","ruleCode":""}]},"arrangeCar":0,"arrangeCarRO":{"arrangeCarCode":"","itineraryCode":"","beginTime":"@datetime","endTime":"@datetime","beginTag":0,"endTag":0,"arrangeCarDay":0,"passengerList":[{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}]},"accommodationDay":0},"currentItinerary":{"indexNo":"","itineraryCode":"","originalItineraryCode":"","accompanyList":[{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}],"beginTime":"@datetime","beginTag":0,"endTime":"@datetime","endTag":0,"travelDay":0,"beginCityCode":"","beginCityName":"","endCityList":[{"endCityCode":"","endCityName":""}],"checkResultMessageRO":{"tipStatus":0,"tipText":"","tipMsg":[""],"tipLists":[{"checkStatusCode":0,"msg":"","ruleCode":""}]},"arrangeCar":0,"arrangeCarRO":{"arrangeCarCode":"","itineraryCode":"","beginTime":"@datetime","endTime":"@datetime","beginTag":0,"endTag":0,"arrangeCarDay":0,"passengerList":[{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}]},"accommodationDay":0},"checkResultMessageRO":{"tipStatus":0,"tipText":"","tipMsg":[""],"tipLists":[{"checkStatusCode":0,"msg":"","ruleCode":""}]}}]
       */
      itinerarySplitList?: {
        applyFormCode?: string;
        sourceType?: number;
        /**
         * "@pick([0,1,2,3])"
         */
        checkStatus?: string;
        /**
         * [""]
         */
        msg?: string[];
        originalItinerary?: {
          indexNo?: string;
          itineraryCode?: string;
          originalItineraryCode?: string;
          /**
           * [{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}]
           */
          accompanyList?: {
            userId?: number;
            operatorId?: number;
            userName?: string;
            /**
             * "@pick([1,2])"
             */
            userSource?: string;
            outerUserRank?: number;
          }[];
          /**
           * "@datetime"
           */
          beginTime?: string;
          beginTag?: number;
          /**
           * "@datetime"
           */
          endTime?: string;
          endTag?: number;
          travelDay?: number;
          beginCityCode?: string;
          beginCityName?: string;
          /**
           * [{"endCityCode":"","endCityName":""}]
           */
          endCityList?: {
            endCityCode?: string;
            endCityName?: string;
          }[];
          checkResultMessageRO?: {
            tipStatus?: number;
            tipText?: string;
            /**
             * [""]
             */
            tipMsg?: string[];
            /**
             * [{"checkStatusCode":0,"msg":"","ruleCode":""}]
             */
            tipLists?: {
              checkStatusCode?: number;
              msg?: string;
              ruleCode?: string;
            }[];
          };
          arrangeCar?: number;
          arrangeCarRO?: {
            arrangeCarCode?: string;
            itineraryCode?: string;
            /**
             * "@datetime"
             */
            beginTime?: string;
            /**
             * "@datetime"
             */
            endTime?: string;
            beginTag?: number;
            endTag?: number;
            arrangeCarDay?: number;
            /**
             * [{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}]
             */
            passengerList?: {
              userId?: number;
              operatorId?: number;
              userName?: string;
              /**
               * "@pick([1,2])"
               */
              userSource?: string;
              outerUserRank?: number;
            }[];
          };
          accommodationDay?: number;
        };
        currentItinerary?: {
          indexNo?: string;
          itineraryCode?: string;
          originalItineraryCode?: string;
          /**
           * [{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}]
           */
          accompanyList?: {
            userId?: number;
            operatorId?: number;
            userName?: string;
            /**
             * "@pick([1,2])"
             */
            userSource?: string;
            outerUserRank?: number;
          }[];
          /**
           * "@datetime"
           */
          beginTime?: string;
          beginTag?: number;
          /**
           * "@datetime"
           */
          endTime?: string;
          endTag?: number;
          travelDay?: number;
          beginCityCode?: string;
          beginCityName?: string;
          /**
           * [{"endCityCode":"","endCityName":""}]
           */
          endCityList?: {
            endCityCode?: string;
            endCityName?: string;
          }[];
          checkResultMessageRO?: {
            tipStatus?: number;
            tipText?: string;
            /**
             * [""]
             */
            tipMsg?: string[];
            /**
             * [{"checkStatusCode":0,"msg":"","ruleCode":""}]
             */
            tipLists?: {
              checkStatusCode?: number;
              msg?: string;
              ruleCode?: string;
            }[];
          };
          arrangeCar?: number;
          arrangeCarRO?: {
            arrangeCarCode?: string;
            itineraryCode?: string;
            /**
             * "@datetime"
             */
            beginTime?: string;
            /**
             * "@datetime"
             */
            endTime?: string;
            beginTag?: number;
            endTag?: number;
            arrangeCarDay?: number;
            /**
             * [{"userId":0,"operatorId":0,"userName":"","userSource":"@pick([1,2])","outerUserRank":0}]
             */
            passengerList?: {
              userId?: number;
              operatorId?: number;
              userName?: string;
              /**
               * "@pick([1,2])"
               */
              userSource?: string;
              outerUserRank?: number;
            }[];
          };
          accommodationDay?: number;
        };
        checkResultMessageRO?: {
          tipStatus?: number;
          tipText?: string;
          /**
           * [""]
           */
          tipMsg?: string[];
          /**
           * [{"checkStatusCode":0,"msg":"","ruleCode":""}]
           */
          tipLists?: {
            checkStatusCode?: number;
            msg?: string;
            ruleCode?: string;
          }[];
        };
      }[];
    }[];
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/306962) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/initExpenseFormBasicInfoV2`
 * @更新时间 `2022-09-22 10:08:01`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2GetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/initExpenseFormBasicInfoV2',
    'data',
    string,
    'applyFormCodeList[0]',
    false
  >
>;

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/306962) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/initExpenseFormBasicInfoV2`
 * @更新时间 `2022-09-22 10:08:01`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2GetRequestConfig: ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2GetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/initExpenseFormBasicInfoV2',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: ['applyFormCodeList[0]'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2Get',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/306962) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/initExpenseFormBasicInfoV2`
 * @更新时间 `2022-09-22 10:08:01`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2Get = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2GetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2GetResponse>(
    prepare(zlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2GetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2Get.requestConfig =
  zlbApiExpenseExpenseFormInitExpenseFormBasicInfoV2GetRequestConfig;

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/307138) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormPostRequest {
  /**
   * 申请单列表
   */
  applyFormCodeList: string[];
  /**
   * 监控数据用
   */
  applyFormBusinessCode?: string;
}

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/307138) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单据类型编号
     */
    businessType?: number;
    /**
     * 单据类型名称
     */
    businessTypeName?: string;
    /**
     * 工作单位ID
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 工作部门ID
     */
    deptId?: number;
    /**
     * 工作部门名称
     */
    deptName?: string;
    /**
     * 申请事由
     */
    expenseReason?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 是否是企业用户
     */
    isEnterprise?: boolean;
    /**
     * 收款人信息
     */
    expenseReceiverList?: {
      /**
       * 收款信息Code
       */
      receiverCode?: string;
      bankName?: string;
      bankCode?: string;
      accountCode?: string;
      /**
       * 卡号
       */
      cardNo?: string;
      /**
       * 银行卡或者公务卡 1：银行卡 2：公务卡
       */
      cardType?: number;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 操作人ID
       */
      operatorId?: number;
      /**
       * 收款人姓名
       */
      receiverName?: string;
      /**
       * 用户来源：1、系统内部人员；2-外部人员
       */
      userSource?: number;
    }[];
    /**
     * 申请单数据
     */
    applyFormSimpleInfoList?: {
      /**
       * 申请原因
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 申请用户姓名
       */
      applyUserName?: string;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 申请时间
       */
      initiationDateTime?: string;
      /**
       * 申请单业务编号
       */
      businessCode?: string;
      /**
       * 申请单状态
       */
      formStatus?: 1 | 2 | 3 | 4 | 5;
      /**
       * 出差开始时间
       */
      travelStartTime?: string;
      /**
       * 业务名称：会议名称，培训名称、采购名称
       */
      businessName?: string;
      /**
       * 剩余金额
       */
      applyRemainingAmount?: number;
      /**
       * 数据来源
       */
      dataSource?: number;
      /**
       * 附件列表
       */
      formAttachmentDTO?: {
        /**
         * 默认附件列表
         */
        normalAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 说明附件列表
         */
        thatAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 通知附件列表
         */
        informAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 合同附件列表
         */
        compactAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 签到附件列表
         */
        signAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 派出单位公函附件列表
         */
        officialLetterAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 接待清单附件列表
         */
        receptionMenuAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 采购意向附件列表
         */
        purchasePurposeAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 资产更新计划
         */
        propertyUpdatePlanAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 集体决策会议纪要
         */
        meetingSummaryAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专家论证意见
         */
        argumentSuggestionAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专项、会议、培训附件列表
         */
        specialAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 银行回单附件
         */
        bankReceiptAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 账单附件
         */
        billAttachmentFileList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
      };
      /**
       * 扩展信息
       */
      extendFieldDTO?: {
        /**
         * 差旅扩展字段
         */
        travelExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 是否派车：1-派车，2-不派车
           */
          arrangeCar?: string;
          /**
           * 派车天数
           */
          dayCount?: number;
          extra?: string;
          /**
           * 三方拓展字段
           */
          thirdExtend?: string;
          /**
           * 差旅报销方式
           */
          travelExpenseMethod?: '由申请单报销' | '凭票报销';
          /**
           * 工号
           */
          workNo?: string;
          /**
           * 是否项目出差
           */
          isProject?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 所属部门
           */
          depName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目名称
           */
          projectName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目负责人
           */
          projectHeader?: {
            key?: string;
            value?: string;
            label?: string;
          };
        };
        /**
         * 会议扩展字段（包含多收款人）
         */
        meetingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 会议名称
           */
          meetingName: string;
          /**
           * 会议地点code
           */
          meetingCityCode?: string;
          /**
           * 会议地点名称
           */
          meetingCityName?: string;
          /**
           * 会议开始日期
           */
          meetingStartDate?: string;
          /**
           * 会议结束日期
           */
          meetingEndDate?: string;
          /**
           * 会议天数
           */
          meetingDayCount?: number;
          /**
           * 会议预计参会人数
           */
          meetingExpectAttendeeCount: number;
          /**
           * 会议实际参会人数
           */
          meetingRealAttendeeCount?: number;
          /**
           * 会议工作人员人数
           */
          meetingWorkerCount?: number;
          /**
           * 参会领导信息
           */
          meetingLeaderInfo?: string;
          /**
           * 会议议程
           */
          meetingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 会议差异内容
           */
          meetingDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 培训扩展字段（包含多收款人）
         */
        trainingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 培训名称
           */
          trainingName?: string;
          /**
           * 培训地点code
           */
          trainingCityCode?: string;
          /**
           * 培训地点名称
           */
          trainingCityName?: string;
          /**
           * 培训开始日期
           */
          trainingStartDate?: string;
          /**
           * 培训结束日期
           */
          trainingEndDate?: string;
          /**
           * 培训天数
           */
          trainingDayCount?: number;
          /**
           * 培训预计参会人数
           */
          trainingExpectAttendeeCount?: number;
          /**
           * 培训实际参会人数
           */
          trainingRealAttendeeCount?: number;
          /**
           * 培训工作人员人数
           */
          trainingWorkerCount?: number;
          /**
           * 培训议程
           */
          trainingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 培训差异内容
           */
          trainingDifferenceContent?: string;
          /**
           * 培训讲师信息
           */
          trainingTeacherInfo?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: number;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 变更支付方式说明
           */
          changePayModeReason?: string;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 采购扩展字段
         */
        procurementExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 采购内容
           */
          procurementContent?: string;
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 费用合计
           */
          applyAmount?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公务接待
         */
        receptionExtendFields?: {
          /**
           * 来访单位
           */
          visitOrgName: string;
          /**
           * 是否同城（宁波场景不需要）
           * 1-是，2-否
           */
          isSameCity?: number;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
          /**
           * 来访事由
           */
          visitReason: string;
          /**
           * 来访开始日期
           */
          visitStartDate: string;
          /**
           * 来访结束日期
           */
          visitEndDate: string;
          /**
           * 来访人员级别：1-省部级、2-厅局级、99-其他
           */
          visitorLevel: number;
          /**
           * 来访人员级别名称
           */
          visitorLevelName?: string;
          /**
           * 来访人数
           */
          visitorCount: number;
          /**
           * 主宾姓名
           */
          mainGuest?: string;
          /**
           * 接待地点code
           */
          receptionCityCode: string;
          /**
           * 接待地点名称
           */
          receptionCityName: string;
          /**
           * 接待详细地点
           */
          receptionDetailAddress?: string;
          /**
           * 就餐日期
           */
          mealDate: string;
          /**
           * 工作餐形式：1-自助餐、2-桌餐
           */
          mealType: 1 | 2 | 3;
          /**
           * 工作餐形式
           */
          mealTypeName?: string;
          /**
           * 用餐时间：1-早餐，2-中餐，3-晚餐
           */
          mealTimeType?: 1 | 2 | 3;
          /**
           * 用餐时间
           */
          mealTimeTypeName?: string;
          /**
           * 陪餐人数（宁波场景不需要）
           */
          escortCount?: number;
          /**
           * 配餐人员姓名
           */
          escortPerson?: string;
          /**
           * 接待预算金额
           */
          receptionBudgetAmount?: number;
          /**
           * 来访人员信息
           */
          visitorInformation?: {
            /**
             * 访问人员名称
             */
            visitorName?: string;
            /**
             * 访问人员职级
             */
            visitorLevel?: number;
            /**
             * 访问人员职级名称
             */
            visitorLevelName?: string;
            /**
             * 来访人员职务
             */
            visitorDuty?: string;
            /**
             * 来访人员单位名称
             */
            visitorUnitName?: string;
          }[];
          /**
           * 接待人员信息
           */
          receptionistInformation?: {
            /**
             * 接待人员名称
             */
            receptionistName?: string;
            /**
             * 接待人员职级
             */
            receptionistLevel?: number;
            /**
             * 接待人员职级名称
             */
            receptionistLevelName?: string;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 一般事项
         */
        generalExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 事项详细内容
           */
          detailContent: string;
          /**
           * 事项预算
           */
          eventBudget?: number;
          /**
           * 事项详细内容与事前审批的差异
           */
          generalDifferenceContent?: string;
          extra?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 用印申请
         */
        contractExtendFields?: {
          /**
           * 合同版本编号
           */
          contractVersionUniqueCode?: string;
        };
        /**
         * 招标书
         */
        tenderApplyExtendFields?: {
          /**
           * 申请单类型
           */
          applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
          /**
           * 申请事由
           */
          applyReason?: string;
          /**
           * 申请单Code
           */
          applyFormCode?: string;
          /**
           * 业务单据号
           */
          businessCode?: string;
          /**
           * 提交时间
           */
          submitTime?: string;
        };
        /**
         * 通用采购申请拓展字段
         */
        purchaseGeneralFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm?: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * isCreatePurchaseProposal
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType?: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 政府购买服务申请拓展字段
         */
        govermentApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 办公家具购置申请拓展字段
         */
        furnitureApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 全链路二期 报销的统一拓展字段
         */
        purchaseGeneralExpenseFieldDTO?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 交易方式：线上；线下
           */
          tradeWay?: string[];
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 交易方式
           */
          tradeWayName?: string;
          /**
           * 是否有合同
           */
          addContract?: boolean;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公共事业缴费统一拓展字段
         */
        publicBusinessPaymentFieldDTO?: {
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 无相拓展
         */
        generalExtra?: string;
      };
      formType?: string;
    }[];
    /**
     * 差旅场景：申请单行程拆分结果
     */
    itinerarySplitList?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
      /**
       * 0：由原行程生成 1：由原行程拆分 2：用户新增
       */
      sourceType?: number;
      /**
       * 校验状态
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 原行程数据
       */
      originalItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程拆分结果
       */
      currentItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程数据校验结果
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
    }[];
    /**
     * 预算项目
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 占用金额
       */
      amount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 操作人，后端使用
       */
      operatorId?: number;
      /**
       * 科目级联uk
       */
      subjectUkHierarchy?: string[];
      /**
       * 科目级联
       */
      subjectNameHierarchy?: string[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/307138) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInitExpenseFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/init-expense-form',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/307138) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInitExpenseFormPostRequestConfig: ZlbApiExpenseExpenseFormInitExpenseFormPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/init-expense-form',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInitExpenseFormPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化报销单基础信息V2↗](http://yapi.cai-inc.com/project/3621/interface/api/307138) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInitExpenseFormPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInitExpenseFormPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInitExpenseFormPostResponse>(
    prepare(zlbApiExpenseExpenseFormInitExpenseFormPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInitExpenseFormPost.requestConfig =
  zlbApiExpenseExpenseFormInitExpenseFormPostRequestConfig;

/**
 * 接口 [getDocumentSourceEnum↗](http://yapi.cai-inc.com/project/3621/interface/api/307706) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getDocumentSourceEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormGetDocumentSourceEnumGetRequest {}

/**
 * 接口 [getDocumentSourceEnum↗](http://yapi.cai-inc.com/project/3621/interface/api/307706) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getDocumentSourceEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormGetDocumentSourceEnumGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    key?: {};
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [getDocumentSourceEnum↗](http://yapi.cai-inc.com/project/3621/interface/api/307706) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getDocumentSourceEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormGetDocumentSourceEnumGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/getDocumentSourceEnum',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [getDocumentSourceEnum↗](http://yapi.cai-inc.com/project/3621/interface/api/307706) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getDocumentSourceEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormGetDocumentSourceEnumGetRequestConfig: ZlbApiExpenseExpenseFormGetDocumentSourceEnumGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/getDocumentSourceEnum',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormGetDocumentSourceEnumGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getDocumentSourceEnum↗](http://yapi.cai-inc.com/project/3621/interface/api/307706) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/getDocumentSourceEnum`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormGetDocumentSourceEnumGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseExpenseFormGetDocumentSourceEnumGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormGetDocumentSourceEnumGetResponse>(
    prepare(zlbApiExpenseExpenseFormGetDocumentSourceEnumGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormGetDocumentSourceEnumGet.requestConfig =
  zlbApiExpenseExpenseFormGetDocumentSourceEnumGetRequestConfig;

/**
 * 接口 [初始化报销单基础信息V3↗](http://yapi.cai-inc.com/project/3621/interface/api/382770) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v3`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormV3PostRequest {
  /**
   * 申请单列表
   */
  applyFormCodeList?: string[];
  /**
   * 票据列表
   */
  invoiceCodeList?: string[];
  /**
   * 监控数据用
   */
  applyFormBusinessCode?: string;
}

/**
 * 接口 [初始化报销单基础信息V3↗](http://yapi.cai-inc.com/project/3621/interface/api/382770) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v3`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormV3PostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 基础信息
     */
    initBasicInfo?: {
      /**
       * 单据类型编号
       */
      businessType?: number;
      /**
       * 单据类型名称
       */
      businessTypeName?: string;
      /**
       * 工作单位ID
       */
      orgId?: number;
      /**
       * 工作单位名称
       */
      orgName?: string;
      /**
       * 工作部门ID
       */
      deptId?: number;
      /**
       * 工作部门名称
       */
      deptName?: string;
      /**
       * 申请事由
       */
      expenseReason?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否是企业用户
       */
      isEnterprise?: boolean;
    };
    /**
     * 收款人信息
     */
    expenseReceiverList?: {
      /**
       * 收款信息Code
       */
      receiverCode?: string;
      bankName?: string;
      bankCode?: string;
      accountCode?: string;
      /**
       * 卡号
       */
      cardNo?: string;
      /**
       * 银行卡或者公务卡 1：银行卡 2：公务卡
       */
      cardType?: number;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 操作人ID
       */
      operatorId?: number;
      /**
       * 收款人姓名
       */
      receiverName?: string;
      /**
       * 用户来源：1、系统内部人员；2-外部人员
       */
      userSource?: number;
    }[];
    /**
     * 申请单数据
     */
    applyFormSimpleInfoList?: {
      /**
       * 申请原因
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 申请用户姓名
       */
      applyUserName?: string;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 申请时间
       */
      initiationDateTime?: string;
      /**
       * 申请单业务编号
       */
      businessCode?: string;
      /**
       * 申请单状态
       */
      formStatus?: 1 | 2 | 3 | 4 | 5;
      /**
       * 出差开始时间
       */
      travelStartTime?: string;
      /**
       * 业务名称：会议名称，培训名称、采购名称
       */
      businessName?: string;
      /**
       * 剩余金额
       */
      applyRemainingAmount?: number;
      /**
       * 数据来源
       */
      dataSource?: number;
      /**
       * 附件列表
       */
      formAttachmentDTO?: {
        /**
         * 默认附件列表
         */
        normalAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 说明附件列表
         */
        thatAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 通知附件列表
         */
        informAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 合同附件列表
         */
        compactAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 签到附件列表
         */
        signAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 派出单位公函附件列表
         */
        officialLetterAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 接待清单附件列表
         */
        receptionMenuAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 采购意向附件列表
         */
        purchasePurposeAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 资产更新计划
         */
        propertyUpdatePlanAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 集体决策会议纪要
         */
        meetingSummaryAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专家论证意见
         */
        argumentSuggestionAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专项、会议、培训附件列表
         */
        specialAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 银行回单附件
         */
        bankReceiptAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 账单附件
         */
        billAttachmentFileList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
      };
      /**
       * 扩展信息
       */
      extendFieldDTO?: {
        /**
         * 差旅扩展字段
         */
        travelExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 是否派车：1-派车，2-不派车
           */
          arrangeCar?: string;
          /**
           * 派车天数
           */
          dayCount?: number;
          extra?: string;
          /**
           * 三方拓展字段
           */
          thirdExtend?: string;
          /**
           * 差旅报销方式
           */
          travelExpenseMethod?: '由申请单报销' | '凭票报销';
          /**
           * 工号
           */
          workNo?: string;
          /**
           * 是否项目出差
           */
          isProject?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 所属部门
           */
          depName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目名称
           */
          projectName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目负责人
           */
          projectHeader?: {
            key?: string;
            value?: string;
            label?: string;
          };
        };
        /**
         * 会议扩展字段（包含多收款人）
         */
        meetingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 会议名称
           */
          meetingName: string;
          /**
           * 会议地点code
           */
          meetingCityCode?: string;
          /**
           * 会议地点名称
           */
          meetingCityName?: string;
          /**
           * 会议开始日期
           */
          meetingStartDate?: string;
          /**
           * 会议结束日期
           */
          meetingEndDate?: string;
          /**
           * 会议天数
           */
          meetingDayCount?: number;
          /**
           * 会议预计参会人数
           */
          meetingExpectAttendeeCount: number;
          /**
           * 会议实际参会人数
           */
          meetingRealAttendeeCount?: number;
          /**
           * 会议工作人员人数
           */
          meetingWorkerCount?: number;
          /**
           * 参会领导信息
           */
          meetingLeaderInfo?: string;
          /**
           * 会议议程
           */
          meetingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 会议差异内容
           */
          meetingDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 培训扩展字段（包含多收款人）
         */
        trainingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 培训名称
           */
          trainingName?: string;
          /**
           * 培训地点code
           */
          trainingCityCode?: string;
          /**
           * 培训地点名称
           */
          trainingCityName?: string;
          /**
           * 培训开始日期
           */
          trainingStartDate?: string;
          /**
           * 培训结束日期
           */
          trainingEndDate?: string;
          /**
           * 培训天数
           */
          trainingDayCount?: number;
          /**
           * 培训预计参会人数
           */
          trainingExpectAttendeeCount?: number;
          /**
           * 培训实际参会人数
           */
          trainingRealAttendeeCount?: number;
          /**
           * 培训工作人员人数
           */
          trainingWorkerCount?: number;
          /**
           * 培训议程
           */
          trainingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 培训差异内容
           */
          trainingDifferenceContent?: string;
          /**
           * 培训讲师信息
           */
          trainingTeacherInfo?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: number;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 变更支付方式说明
           */
          changePayModeReason?: string;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 采购扩展字段
         */
        procurementExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 采购内容
           */
          procurementContent?: string;
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 费用合计
           */
          applyAmount?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公务接待
         */
        receptionExtendFields?: {
          /**
           * 来访单位
           */
          visitOrgName: string;
          /**
           * 是否同城（宁波场景不需要）
           * 1-是，2-否
           */
          isSameCity?: number;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
          /**
           * 来访事由
           */
          visitReason: string;
          /**
           * 来访开始日期
           */
          visitStartDate: string;
          /**
           * 来访结束日期
           */
          visitEndDate: string;
          /**
           * 来访人员级别：1-省部级、2-厅局级、99-其他
           */
          visitorLevel: number;
          /**
           * 来访人员级别名称
           */
          visitorLevelName?: string;
          /**
           * 来访人数
           */
          visitorCount: number;
          /**
           * 主宾姓名
           */
          mainGuest?: string;
          /**
           * 接待地点code
           */
          receptionCityCode: string;
          /**
           * 接待地点名称
           */
          receptionCityName: string;
          /**
           * 接待详细地点
           */
          receptionDetailAddress?: string;
          /**
           * 就餐日期
           */
          mealDate: string;
          /**
           * 工作餐形式：1-自助餐、2-桌餐
           */
          mealType: 1 | 2 | 3;
          /**
           * 工作餐形式
           */
          mealTypeName?: string;
          /**
           * 用餐时间：1-早餐，2-中餐，3-晚餐
           */
          mealTimeType?: 1 | 2 | 3;
          /**
           * 用餐时间
           */
          mealTimeTypeName?: string;
          /**
           * 陪餐人数（宁波场景不需要）
           */
          escortCount?: number;
          /**
           * 配餐人员姓名
           */
          escortPerson?: string;
          /**
           * 接待预算金额
           */
          receptionBudgetAmount?: number;
          /**
           * 来访人员信息
           */
          visitorInformation?: {
            /**
             * 访问人员名称
             */
            visitorName?: string;
            /**
             * 访问人员职级
             */
            visitorLevel?: number;
            /**
             * 访问人员职级名称
             */
            visitorLevelName?: string;
            /**
             * 来访人员职务
             */
            visitorDuty?: string;
            /**
             * 来访人员单位名称
             */
            visitorUnitName?: string;
          }[];
          /**
           * 接待人员信息
           */
          receptionistInformation?: {
            /**
             * 接待人员名称
             */
            receptionistName?: string;
            /**
             * 接待人员职级
             */
            receptionistLevel?: number;
            /**
             * 接待人员职级名称
             */
            receptionistLevelName?: string;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 一般事项
         */
        generalExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 事项详细内容
           */
          detailContent: string;
          /**
           * 事项预算
           */
          eventBudget?: number;
          /**
           * 事项详细内容与事前审批的差异
           */
          generalDifferenceContent?: string;
          extra?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 用印申请
         */
        contractExtendFields?: {
          /**
           * 合同版本编号
           */
          contractVersionUniqueCode?: string;
        };
        /**
         * 招标书
         */
        tenderApplyExtendFields?: {
          /**
           * 申请单类型
           */
          applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
          /**
           * 申请事由
           */
          applyReason?: string;
          /**
           * 申请单Code
           */
          applyFormCode?: string;
          /**
           * 业务单据号
           */
          businessCode?: string;
          /**
           * 提交时间
           */
          submitTime?: string;
        };
        /**
         * 通用采购申请拓展字段
         */
        purchaseGeneralFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm?: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * isCreatePurchaseProposal
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType?: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 政府购买服务申请拓展字段
         */
        govermentApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 办公家具购置申请拓展字段
         */
        furnitureApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 全链路二期 报销的统一拓展字段
         */
        purchaseGeneralExpenseFieldDTO?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 交易方式：线上；线下
           */
          tradeWay?: string[];
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 交易方式
           */
          tradeWayName?: string;
          /**
           * 是否有合同
           */
          addContract?: boolean;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公共事业缴费统一拓展字段
         */
        publicBusinessPaymentFieldDTO?: {
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 无相拓展
         */
        generalExtra?: string;
      };
      formType?: string;
    }[];
    /**
     * 差旅场景：申请单行程拆分结果
     */
    applyItinerarySplitList?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
      /**
       * 0：由原行程生成 1：由原行程拆分 2：用户新增
       */
      sourceType?: number;
      /**
       * 校验状态
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 原行程数据
       */
      originalItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程拆分结果
       */
      currentItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程数据校验结果
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
    }[];
    /**
     * 差旅场景：票据生成行程结果
     */
    invoiceItinerarySplitList?: {
      /**
       * 出差人列表及其票据信息
       */
      accompanyList?: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
        /**
         * 票据信息列表
         */
        invoiceInfoList?: {
          /**
           * 票据code
           */
          invoiceCode?: string;
          /**
           * 票据编号
           */
          invoiceNo?: string;
          /**
           * 票据类型
           */
          invoiceType?: string;
          /**
           * 票据图片地址
           */
          imageUrl?: string;
          /**
           * 浙里办票地址
           */
          zlbImageUrl?: string;
        }[];
      }[];
      /**
       * 是否派车 0 否 1是
       */
      arrangeCar?: number;
      /**
       * 住宿天数
       */
      accommodationDay?: number;
      /**
       * 开始时间
       */
      beginTime?: string;
      /**
       * 开始上下午
       */
      beginTag?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 结束时间
       */
      endTime?: string;
      /**
       * 结束上下午
       */
      endTag?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 出差天数
       */
      travelDay?: number;
      /**
       * 出发地code
       */
      beginCityCode?: string;
      /**
       * 出发地名称
       */
      beginCityName?: string;
      /**
       * 目的地code
       */
      endCityCode?: string;
      /**
       * 目的地名称
       */
      endCityName?: string;
    }[];
    /**
     * 预算项目
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 占用金额
       */
      amount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 操作人，后端使用
       */
      operatorId?: number;
      /**
       * 科目级联uk
       */
      subjectUkHierarchy?: string[];
      /**
       * 科目级联
       */
      subjectNameHierarchy?: string[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [初始化报销单基础信息V3↗](http://yapi.cai-inc.com/project/3621/interface/api/382770) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v3`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInitExpenseFormV3PostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/init-expense-form/v3',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [初始化报销单基础信息V3↗](http://yapi.cai-inc.com/project/3621/interface/api/382770) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v3`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInitExpenseFormV3PostRequestConfig: ZlbApiExpenseExpenseFormInitExpenseFormV3PostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/init-expense-form/v3',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInitExpenseFormV3Post',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化报销单基础信息V3↗](http://yapi.cai-inc.com/project/3621/interface/api/382770) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v3`
 * @更新时间 `2024-12-11 15:42:24`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInitExpenseFormV3Post = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInitExpenseFormV3PostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInitExpenseFormV3PostResponse>(
    prepare(zlbApiExpenseExpenseFormInitExpenseFormV3PostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInitExpenseFormV3Post.requestConfig =
  zlbApiExpenseExpenseFormInitExpenseFormV3PostRequestConfig;

/**
 * 接口 [提交报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/421538) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/submit`
 * @更新时间 `2024-12-11 15:42:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormSubmitPostRequest {
  /**
   * 报销单Code
   */
  expenseFormCode?: string;
  /**
   * 报销单业务Code
   */
  businessCode?: string;
  /**
   * 报销单类型
   * 1-差旅；2-会议；3-培训；4-采购；6-公务接待；7-一般事项；9-通用采购；10-政府购买服务；11-办公设备家具购置
   */
  fromType:
    | 'TRAVEL_EXPENSE_FORM'
    | 'MEETING_EXPENSE_FORM'
    | 'TRAINING_EXPENSE_FORM'
    | 'PROCUREMENT_EXPENSE_FORM'
    | 'RECEPTION_EXPENSE_FORM'
    | 'GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GOVERNMENT_EXPENSE_FORM'
    | 'PURCHASE_FURNITURE_EXPENSE_FORM'
    | 'MEETING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'TRAINING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'PUBLIC_BUSINESS_PAYMENT_EXPENSE_FORM'
    | 'INVEST_PAYMENT_EXPENSE_FORM'
    | 'REST_EXPENSE_FORM';
  /**
   * 报销事由
   */
  expenseReason: string;
  /**
   * 部门ID
   */
  deptId: number;
  /**
   * 部门名字
   */
  deptName?: string;
  /**
   * 业务类型
   * 1-普通出差、2-专项/会议/培训出差、3-常驻外地出差；4-一类会议、5-二类会议、6-三类会议、27-其他会议；
   * 7-一类培训、8-二类培训；9-集中采购、10-分散采购、11-非政府采购、12-用印申请、13-公务接待、14-一般事项
   * 、16-通用采购、17-政府购买服务、18-办公设备家具购置
   */
  businessType:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 32
    | 29
    | 30
    | 33
    | 35;
  /**
   * 申请单编号
   */
  applyFormCodeList?: string[];
  /**
   * 申请单编号
   */
  applyFormList?: {
    /**
     * 申请单号
     */
    applyFormCode?: string;
    /**
     * 类型
     */
    formType?: string;
  }[];
  /**
   * 关联的申领单类型
   */
  applyFormType?: string;
  /**
   * 行程数据
   */
  itineraries?: {
    /**
     * 前端生成的编号
     */
    indexNo?: string;
    /**
     * 行程单编号
     * 更新时必填
     */
    itineraryCode?: string;
    /**
     * 原行程单号
     */
    originalItineraryCode?: string;
    /**
     * 出差人列表
     */
    accompanyList: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 开始上下午
     */
    beginTag: number;
    /**
     * 结束时间
     */
    endTime: string;
    /**
     * 结束上下午
     */
    endTag: number;
    /**
     * 出差天数
     */
    travelDay: number;
    /**
     * 是否派车 0不派车 1派车
     */
    arrangeCar: number;
    /**
     * 派车信息
     */
    arrangeCarPO?: {
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag: number;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag: number;
      /**
       * 派车天数
       */
      arrangeCarDay: number;
      /**
       * 乘车人
       */
      passengerList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
    };
    /**
     * 出发城市code
     */
    beginCityCode: string;
    /**
     * 出发城市名称
     */
    beginCityName: string;
    /**
     * 目的城市列表
     */
    endCityList: {
      /**
       * 目的城市code
       */
      endCityCode: string;
      /**
       * 目的城市名称
       */
      endCityName: string;
    }[];
    /**
     * 住宿天数
     */
    accommodationDay: number;
  }[];
  /**
   * 报销收款人数据
   */
  expenseFormReceiverPOS?: {
    /**
     * 操作人ID
     */
    operatorId: number;
    /**
     * 账号code
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount: number;
    /**
     * 原收款金额
     */
    originalAmount?: number;
    /**
     * 收款人姓名
     */
    receiverName: string;
    /**
     * 前端数组下标
     */
    indexNo: string;
    /**
     * 收款人Code
     */
    receiverCode?: string;
    /**
     * 调整原因
     */
    updateReason?: string;
    /**
     * 费用更新金额
     */
    modifyFeeAmountDTO?: {
      /**
       * 原始金额
       */
      originalAmount: number;
      /**
       * 修改后金额
       */
      updateAmount: number;
      /**
       * 修改备注
       */
      updateReason?: string;
      /**
       * 原始账户
       */
      originalAccount?: string;
      /**
       * 修改后账户
       */
      updateAccount?: string;
    };
    /**
     * 人员来源 1-系统内部；2-外部人员
     */
    userSource?: 1 | 2;
    userType?: number;
    /**
     * 用户类型
     */
    type?: number;
    /**
     * 类型
     */
    fundsObjectType?:
      | 1
      | 11
      | 12
      | 13
      | 14
      | 19
      | 2
      | 21
      | 22
      | 23
      | 24
      | 3
      | 31
      | 32
      | 4
      | 41
      | 42;
  }[];
  /**
   * 费用集合
   */
  expenseFeeExtendPOS?: {
    indexNo: string;
    /**
     * 费用集合
     */
    expenseFeePOS: {
      /**
       * 唯一标识
       */
      indexNo: string;
      /**
       * 记录的费用code
       */
      feeCode?: string;
      /**
       * 记录的费用名称，用于自定义
       */
      feeName?: string;
      /**
       * 所属机构id
       */
      operatorOrgId?: number;
      /**
       * 所属机构名称
       */
      operatorOrgName?: string;
      /**
       * 费用类型
       */
      feeType: number;
      /**
       * 费用发生时间
       */
      consumeTime: string;
      /**
       * 货币金额
       */
      amount: number;
      /**
       * 消费城市区划
       */
      districtCode?: string;
      /**
       * 消费城市名称
       */
      districtName?: string;
      /**
       * 关联的发票编号
       */
      invoiceCodes: string[];
      /**
       * 关联的出差人
       */
      accompanyPerson?: {
        /**
         * 人员id
         */
        operatorId: number;
        /**
         * 人员名称
         */
        operatorName: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
         */
        userType?: number;
        userId?: number;
        userName?: string;
        bankCardInfo?: {
          /**
           * 银行代码
           */
          bankCode: string;
          /**
           * 银行名字
           */
          bankName: string;
          /**
           * 账户名称
           */
          accountName: string;
          /**
           * 银行账号
           */
          bankAccount: string;
          /**
           * 银行账号 脱敏
           */
          bankAccountDesc?: string;
          /**
           * 卡号保存的唯一标识
           */
          accountCode?: string;
        };
        /**
         * 同一个人员，绑定的id
         */
        bindOperatorId?: number;
        /**
         * 用户类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type: number;
        /**
         * 用户职级,
         * 内部用户的职级，外部用户关联内部用户，取内部用户职级
         * 否则去外部用户职级
         */
        userRank?: string;
        /**
         * 手机号
         */
        mobile?: string;
        /**
         * 证件号码
         */
        idCard?: string;
        /**
         * 证件类型
         */
        idType?: number;
        /**
         * 性别
         */
        gender?: number;
        /**
         * 同行人费用code
         */
        feeCode?: string;
      }[];
      /**
       * 材料数据
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
          /**
           * 原始金额
           */
          originalAmount?: number;
        }[];
      };
      /**
       * 费用附件
       */
      attachments: {
        fileId: string;
        fileType?: string;
        fileName: string;
        fileSize?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        downloadUrl?: string;
      }[];
      /**
       * 关联的单号
       */
      formCode?: string;
      /**
       * 单据类型：1-申请单，2-报销单
       */
      formType?: number;
      /**
       * 修改金额历史
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 原始的feeRecordId
       */
      originalFeeId?: number;
      /**
       * 平台订单编号
       */
      platformOrderNo?: string;
      /**
       * 明细说明
       */
      remark?: string;
      /**
       * 明细数据
       */
      detailExtendDTO?: {
        /**
         * 详细列表页
         */
        expenseFeeDetailInfoList?: {
          /**
           * 前端需要参数
           */
          indexNo?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          userType?: number;
          type?: number;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 原始信息（当前补贴）
           */
          originalInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
          /**
           * 重复补贴
           */
          conflictInfoList?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          }[];
          /**
           * 费用种类
           */
          feeCategory?: number;
          /**
           * 实际补贴金额
           */
          amount?: number;
          /**
           * 原始计算金额
           */
          originalAmount?: number;
          /**
           * 调整前金额
           */
          beforeChangeAmount?: number;
          /**
           * 冲突的金额
           */
          conflictAmount?: number;
          /**
           * 扣减金额
           */
          reductionAmount?: number;
          /**
           * 最大允许金额
           */
          allowMaxAmount?: number;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否发生变更
           */
          isChanged?: boolean;
        }[];
        /**
         * 冲突展示列表页
         */
        expenseFeeConflictList?: {
          /**
           * 业务编码
           */
          businessCode?: string;
          /**
           * 单据编号
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: number;
          /**
           * 业务类型
           */
          businessType?: number;
          /**
           * 业务类型描述
           */
          businessTypeDesc?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 冲突信息
           */
          conflictInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
        }[];
        /**
         * 调整后金额
         */
        currentAmount?: number;
        /**
         * 原始金额
         */
        originalAmount?: number;
        /**
         * 费用类型
         */
        feeType?: number;
        /**
         * 火车金额
         */
        trainAmount?: number;
        /**
         * 总金额相等
         */
        totalAmountEquals?: boolean;
      };
      /**
       * 交易信息编码 for 会议培训多收款人
       */
      tradeCode?: string;
    }[];
    feeParentType: number;
    totalAmount: number;
    currencyCode?: string;
  }[];
  /**
   * 公共事业缴费账单信息
   */
  expensePublicPaymentBillList?: {
    /**
     * 账单code
     */
    publicBillCode?: string;
    /**
     * 区划code
     */
    districtCode?: string;
    /**
     * 缴费项目
     * 1-水费 2-电费 3-燃气费 4-话费 5-邮费 6-过路费 7-五险一金(作废) 8-个税 9-社保 10-公积金 11-残保金 99-其他
     */
    paymentProjectType: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 99;
    /**
     * 收费单位
     */
    chargeOrgName: string;
    /**
     * 缴费账户
     */
    paymentAccountName: string;
    /**
     * 账单月份
     */
    billMonth: string;
    /**
     * 金额：分
     */
    amount: number;
    /**
     * 扩展字段
     */
    extendFiled?: string;
    /**
     * 账单来源 0手动上传 1自动同步
     */
    origin?: number;
    billAttachmentFileList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  }[];
  /**
   * 费用总金额
   */
  feeTotalAmount?: number;
  /**
   * 综合定额总金额
   */
  mixFeeTotalAmount?: number;
  /**
   * 是否忽略警告
   */
  isIgnoreWarning?: boolean;
  /**
   * 触发原因
   */
  triggerWarningReason?: string;
  /**
   * 超标原因列表
   */
  excessiveReasonPOS?: {
    /**
     * 校验分组code
     */
    excessiveReasonList: {
      /**
       * 校验结果分组code
       */
      checkGroupCode?: string;
      /**
       * 父标题
       */
      parentTitle?: string;
      /**
       * 子标题
       */
      subTitle?: string;
      /**
       * 合并code
       */
      mergeGroupCode?: string;
      /**
       * 是否必填
       */
      isMust?: number;
      /**
       * 备注长度
       */
      remarkLength?: number;
    }[];
    /**
     * 超标原因
     */
    excessiveReason: string;
  }[];
  /**
   * 收款总金额
   */
  totalAmount: number;
  /**
   * 扩展信息
   */
  extendFieldDTO: {
    /**
     * 差旅扩展字段
     */
    travelExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 是否派车：1-派车，2-不派车
       */
      arrangeCar?: string;
      /**
       * 派车天数
       */
      dayCount?: number;
      extra?: string;
      /**
       * 三方拓展字段
       */
      thirdExtend?: string;
      /**
       * 差旅报销方式
       */
      travelExpenseMethod?: '由申请单报销' | '凭票报销';
      /**
       * 工号
       */
      workNo?: string;
      /**
       * 是否项目出差
       */
      isProject?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 所属部门
       */
      depName?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 项目名称
       */
      projectName?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 项目负责人
       */
      projectHeader?: {
        key?: string;
        value?: string;
        label?: string;
      };
    };
    /**
     * 会议扩展字段（包含多收款人）
     */
    meetingExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 1 签掉表 2 签到表附件
       */
      signType?: number;
      /**
       * 签到表
       */
      signForm?: {
        signFormCode?: string;
        /**
         * 签到表名称
         */
        signFormName?: string;
        /**
         * 申请表状态
         * 0-未发布 1-已发布 2-已结束
         */
        formStatus?: number;
        /**
         * 申请表状态名称
         */
        formStatusName?: string;
        /**
         * 结束时间
         */
        endTime?: number;
      };
      /**
       * 1申请单携带 2 手动选择
       */
      isExpenseInit?: number;
      /**
       * 会议名称
       */
      meetingName: string;
      /**
       * 会议地点code
       */
      meetingCityCode?: string;
      /**
       * 会议地点名称
       */
      meetingCityName?: string;
      /**
       * 会议开始日期
       */
      meetingStartDate?: string;
      /**
       * 会议结束日期
       */
      meetingEndDate?: string;
      /**
       * 会议天数
       */
      meetingDayCount?: number;
      /**
       * 会议预计参会人数
       */
      meetingExpectAttendeeCount: number;
      /**
       * 会议实际参会人数
       */
      meetingRealAttendeeCount?: number;
      /**
       * 会议工作人员人数
       */
      meetingWorkerCount?: number;
      /**
       * 参会领导信息
       */
      meetingLeaderInfo?: string;
      /**
       * 会议议程
       */
      meetingAgenda?: string;
      /**
       * 是否纳入预算
       * 1-是，2-否
       */
      isIncludedBudget?: number;
      /**
       * 会议差异内容
       */
      meetingDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal?: number;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 详细地址信息
       */
      detailAddress?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 培训扩展字段（包含多收款人）
     */
    trainingExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 1 签掉表 2 签到表附件
       */
      signType?: number;
      /**
       * 签到表
       */
      signForm?: {
        signFormCode?: string;
        /**
         * 签到表名称
         */
        signFormName?: string;
        /**
         * 申请表状态
         * 0-未发布 1-已发布 2-已结束
         */
        formStatus?: number;
        /**
         * 申请表状态名称
         */
        formStatusName?: string;
        /**
         * 结束时间
         */
        endTime?: number;
      };
      /**
       * 1申请单携带 2 手动选择
       */
      isExpenseInit?: number;
      /**
       * 培训名称
       */
      trainingName?: string;
      /**
       * 培训地点code
       */
      trainingCityCode?: string;
      /**
       * 培训地点名称
       */
      trainingCityName?: string;
      /**
       * 培训开始日期
       */
      trainingStartDate?: string;
      /**
       * 培训结束日期
       */
      trainingEndDate?: string;
      /**
       * 培训天数
       */
      trainingDayCount?: number;
      /**
       * 培训预计参会人数
       */
      trainingExpectAttendeeCount?: number;
      /**
       * 培训实际参会人数
       */
      trainingRealAttendeeCount?: number;
      /**
       * 培训工作人员人数
       */
      trainingWorkerCount?: number;
      /**
       * 培训议程
       */
      trainingAgenda?: string;
      /**
       * 是否纳入预算
       * 1-是，2-否
       */
      isIncludedBudget?: number;
      /**
       * 培训差异内容
       */
      trainingDifferenceContent?: string;
      /**
       * 培训讲师信息
       */
      trainingTeacherInfo?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal?: number;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource?: number;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
      /**
       * 变更支付方式说明
       */
      changePayModeReason?: string;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 详细地址信息
       */
      detailAddress?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 采购扩展字段
     */
    procurementExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 采购内容
       */
      procurementContent?: string;
      /**
       * 采购差异内容
       */
      procurementDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 费用合计
       */
      applyAmount?: number;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 公务接待
     */
    receptionExtendFields?: {
      /**
       * 来访单位
       */
      visitOrgName: string;
      /**
       * 是否同城（宁波场景不需要）
       * 1-是，2-否
       */
      isSameCity?: number;
      /**
       * 来访人员职务
       */
      visitorDuty?: string;
      /**
       * 来访事由
       */
      visitReason: string;
      /**
       * 来访开始日期
       */
      visitStartDate: string;
      /**
       * 来访结束日期
       */
      visitEndDate: string;
      /**
       * 来访人员级别：1-省部级、2-厅局级、99-其他
       */
      visitorLevel: number;
      /**
       * 来访人员级别名称
       */
      visitorLevelName?: string;
      /**
       * 来访人数
       */
      visitorCount: number;
      /**
       * 主宾姓名
       */
      mainGuest?: string;
      /**
       * 接待地点code
       */
      receptionCityCode: string;
      /**
       * 接待地点名称
       */
      receptionCityName: string;
      /**
       * 接待详细地点
       */
      receptionDetailAddress?: string;
      /**
       * 就餐日期
       */
      mealDate: string;
      /**
       * 工作餐形式：1-自助餐、2-桌餐
       */
      mealType: 1 | 2 | 3;
      /**
       * 工作餐形式
       */
      mealTypeName?: string;
      /**
       * 用餐时间：1-早餐，2-中餐，3-晚餐
       */
      mealTimeType?: 1 | 2 | 3;
      /**
       * 用餐时间
       */
      mealTimeTypeName?: string;
      /**
       * 陪餐人数（宁波场景不需要）
       */
      escortCount?: number;
      /**
       * 配餐人员姓名
       */
      escortPerson?: string;
      /**
       * 接待预算金额
       */
      receptionBudgetAmount?: number;
      /**
       * 来访人员信息
       */
      visitorInformation?: {
        /**
         * 访问人员名称
         */
        visitorName?: string;
        /**
         * 访问人员职级
         */
        visitorLevel?: number;
        /**
         * 访问人员职级名称
         */
        visitorLevelName?: string;
        /**
         * 来访人员职务
         */
        visitorDuty?: string;
        /**
         * 来访人员单位名称
         */
        visitorUnitName?: string;
      }[];
      /**
       * 接待人员信息
       */
      receptionistInformation?: {
        /**
         * 接待人员名称
         */
        receptionistName?: string;
        /**
         * 接待人员职级
         */
        receptionistLevel?: number;
        /**
         * 接待人员职级名称
         */
        receptionistLevelName?: string;
      }[];
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 一般事项
     */
    generalExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 事项详细内容
       */
      detailContent: string;
      /**
       * 事项预算
       */
      eventBudget?: number;
      /**
       * 事项详细内容与事前审批的差异
       */
      generalDifferenceContent?: string;
      extra?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 用印申请
     */
    contractExtendFields?: {
      /**
       * 合同版本编号
       */
      contractVersionUniqueCode?: string;
    };
    /**
     * 招标书
     */
    tenderApplyExtendFields?: {
      /**
       * 申请单类型
       */
      applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
      /**
       * 申请事由
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务单据号
       */
      businessCode?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
    };
    /**
     * 通用采购申请拓展字段
     */
    purchaseGeneralFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm?: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * isCreatePurchaseProposal
       * 采购类型
       * 1-政府采购，2-非政府采购
       */
      purchaseType?: 1 | 2;
      /**
       * 采购类型描述
       */
      purchaseTypeDesc?: string;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource?: 1 | 2;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 政府购买服务申请拓展字段
     */
    govermentApplyFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * 采购类型
       * 1-政府采购，2-非政府采购
       */
      purchaseType: 1 | 2;
      /**
       * 采购类型描述
       */
      purchaseTypeDesc?: string;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource: 1 | 2;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 办公家具购置申请拓展字段
     */
    furnitureApplyFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 全链路二期 报销的统一拓展字段
     */
    purchaseGeneralExpenseFieldDTO?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 交易方式：线上；线下
       */
      tradeWay?: string[];
      /**
       * 采购差异内容
       */
      procurementDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 交易方式
       */
      tradeWayName?: string;
      /**
       * 是否有合同
       */
      addContract?: boolean;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 公共事业缴费统一拓展字段
     */
    publicBusinessPaymentFieldDTO?: {
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否为重大事项或大额资金：1-是 0-否
       */
      isMajorEvent?: number;
    };
    /**
     * 无相拓展
     */
    generalExtra?: string;
  };
  /**
   * 单据附件
   */
  formAttachmentDTO: {
    /**
     * 默认附件列表
     */
    normalAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 说明附件列表
     */
    thatAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 通知附件列表
     */
    informAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 合同附件列表
     */
    compactAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 签到附件列表
     */
    signAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 派出单位公函附件列表
     */
    officialLetterAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 接待清单附件列表
     */
    receptionMenuAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 采购意向附件列表
     */
    purchasePurposeAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 资产更新计划
     */
    propertyUpdatePlanAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 集体决策会议纪要
     */
    meetingSummaryAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专家论证意见
     */
    argumentSuggestionAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专项、会议、培训附件列表
     */
    specialAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 银行回单附件
     */
    bankReceiptAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 账单附件
     */
    billAttachmentFileList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  };
  /**
   * 发票列表code
   */
  invoiceCodeS?: string[];
  /**
   * 订单发票关系 for 会议/培训/办公用品采购 todo 订单发票关系也要处理
   */
  orderInvoiceList?: {
    /**
     * 订单号
     */
    orderCode?: string;
    /**
     * 发票单号
     */
    platformInvoiceId: string;
    /**
     * 发票金额
     */
    invoiceAmount?: number;
  }[];
  /**
   * 单据订单 for 会议/培训/办公用品采购
   */
  orderExpenseFormList?: null;
  /**
   * 合同信息 for 会议/培训/办公用品采购
   * 「已废弃」
   */
  contractExpenseFormList?: null;
  /**
   * 备注
   */
  remark?: null;
  /**
   * 采购交易信息 for 采购多收款人报销单
   * 添加交易信息字段包含订单合同发票等信息，之前的订单合同发票字段照常传惨
   */
  tradeInfoList?: null;
  /**
   * 采购结算单编码列表
   */
  purchaseSettleCodeList?: string[];
  /**
   * 单据快照
   */
  formSnapshotCode?: null;
  /**
   * 是否无票报销,采购场景单收款人使用;0非无票报销  1无票报销为补充  2无票报销已补充
   */
  withoutInvoiceStatus?: null;
  /**
   * 工作流数据
   */
  workflowInfo?: {
    /**
     * 业务标识
     */
    bizId?: null;
    /**
     * 必填, 业务场景
     */
    bizType?: null;
    /**
     * 业务编码
     */
    businessCode?: null;
    /**
     * 子类型
     */
    subType?: null;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: null;
    /**
     * 必填, 工作流模型ID
     */
    processModelId?: null;
    /**
     * 必填, 工作流模型版本
     */
    version?: null;
    /**
     * 节点审批信息
     */
    auditInfos?: null;
    /**
     * 扩展条件，for百搭
     */
    extConditions?: null;
    /**
     * 业务上下文
     */
    context?: null;
    /**
     * 当前操作入Id
     */
    operatorId?: null;
    /**
     * 备注
     */
    remark?: null;
  };
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: null;
}

/**
 * 接口 [提交报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/421538) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/submit`
 * @更新时间 `2024-12-11 15:42:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态 0：通过 1：警告 2：强控 3 提示
     */
    checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
    /**
     * 行程冲突校验结果
     */
    itineraryCheckResultRO?: {
      /**
       * 所有行程是否通过行程校验
       * 通过：0
       */
      checkStatus?: number;
      /**
       * 报销单行程校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 行程数组索引
         */
        indexNo?: string;
        /**
         * 每段行程的提示文案及校验状态
         */
        itineraryCheckResultList?: {
          /**
           * 校验状态
           * 0-通过 1-弱控 2-强控 3-提示
           */
          checkStatus?: 0 | 1 | 2 | 3;
          /**
           * 提示文案
           */
          message?: string;
        }[];
      }[];
      /**
       * 整体提示信息
       * 暂时仅有不足申请单的部分有赋值
       */
      overallCheckResult?: {
        /**
         * 校验状态
         * 0-通过 1-弱控 2-强控 3-提示
         */
        checkStatus?: 0 | 1 | 2 | 3;
        /**
         * 提示文案
         */
        message?: string;
      };
    };
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
            /**
             * 校验结果
             */
            checkStatus?: number;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
              /**
               * 校验结果
               */
              checkStatus?: number;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
            /**
             * 设置结果
             */
            resultInfo?: {
              /**
               * 凭票报销总结果
               */
              expenseFeeInvoiceResult?: {
                /**
                 * 用户id
                 */
                operatorId?: number;
                /**
                 * 用户名称
                 */
                operatorName?: string;
                /**
                 * 报销金额
                 */
                amount?: number;
                /**
                 * 报销金额描述
                 */
                amountDesc?: string;
                /**
                 * 详细信息
                 */
                detailInfoList?: {
                  /**
                   * 发生日期
                   */
                  happenDate?: null;
                  /**
                   * 是否可以报销
                   */
                  canExpense?: null;
                  /**
                   * 表单code
                   */
                  formCode?: string[];
                  /**
                   * 业务code
                   */
                  businessCode?: string[];
                  /**
                   * 冲突描述
                   */
                  conflictDesc?: null;
                  /**
                   * 是否凭票报销冲突
                   */
                  isUseInvoice?: null;
                  /**
                   * 规则描述
                   */
                  ruleDesc?: null;
                  /**
                   * 金额
                   */
                  ruleAmount?: null;
                }[];
              }[];
              /**
               * 凭票报销总结果提示
               */
              expenseFeeInvoiceTips?: string;
              /**
               * 是否展示
               */
              canShow?: boolean;
            };
            /**
             * 是否需要显示
             */
            canShow?: boolean;
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
          /**
           * 校验结果
           */
          checkStatus?: number;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 预算校验结果
     */
    budgetCheckResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
      /**
       * 预算指标ID
       */
      mainBudgetCode?: number;
      /**
       * 预算指标编号
       */
      budgetUk?: string;
      /**
       * 预算编号(展示)
       */
      financialBudgetDetailId?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 额度ID
       */
      budgetQuotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag?: boolean;
      /**
       * 占用总金额
       */
      budgetTotalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 关联预算的业务信息
       */
      budgetExceptionTipsROS?: {
        /**
         * 关联预算的Code
         */
        budgetRelationBusinessCode?: string;
        /**
         * 关联预算的业务名称描述
         */
        budgetRelationBusinessDesc?: string;
        /**
         * 关联交易描述
         */
        tradeDesc?: string;
        /**
         * 关联预算业务数据类型
         * 直接以枚举的名称作为存储，以便在请求中可以直接看出
         */
        relationBusinessType?:
          | '报销单'
          | '交易'
          | '收款账户'
          | '工资流水'
          | '夜餐费发放单'
          | '项目支付单';
        /**
         * 占用的金额
         */
        budgetAmount?: number;
      }[];
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 预算项目校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 科目校验描述
         */
        subjectCheckDesc?: string;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
      }[];
    };
    /**
     * 收款信息校验结果
     */
    receiverCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 收款信息校验详情
       */
      checkResultInfoROS?: {
        /**
         * 是否通过校验
         */
        checkStatus?: number;
        /**
         * 收款人信息数组下标
         */
        indexNo?: string;
        /**
         * 提示消息
         */
        msg?: string[];
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 支付方式校验结果
     */
    payConfigCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 订单校验结果
     */
    orderCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 报销单号
     */
    expenseFormCode?: string;
    /**
     * 合同校验结果
     */
    contractCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 发票校验结果
     */
    invoiceCheckResultROS?: {
      /**
       * 发票ID
       */
      platformInvoiceId?: string;
      /**
       * 状态码
       */
      code?: number;
      /**
       * 是否可报销 true：可以报销 false：不可以报销
       */
      success?: boolean;
      /**
       * 提示消息
       */
      msg?: string;
    }[];
    /**
     * 超标原因配置
     */
    reasonConfigROS?: {
      /**
       * 状态
       */
      checkStatus?: number;
      /**
       * 规则列表
       */
      ruleInfoROS?: {
        /**
         * 规则描述
         */
        ruleDesc?: string;
        /**
         * 规则code
         */
        ruleCode?: string;
        /**
         * 状态
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      }[];
      /**
       * 超标配置列表
       */
      reasonConfigList?: {
        /**
         * 校验结果分组code
         */
        checkGroupCode?: string;
        /**
         * 父标题
         */
        parentTitle?: string;
        /**
         * 子标题
         */
        subTitle?: string;
        /**
         * 合并code
         */
        mergeGroupCode?: string;
        /**
         * 是否必填
         */
        isMust?: number;
        /**
         * 备注长度
         */
        remarkLength?: number;
      }[];
    };
    /**
     * 含有异常申请单的列表（校验通过时为空数组）
     */
    applyFormCheckResultROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 检查结果
       */
      checkResult?: 0 | 1 | 2;
      /**
       * 检查结果描述
       */
      checkResultDesc?: '通过' | '已作废' | '已关联';
      /**
       * 被关联的其他报销单号
       */
      certainExpenseFormCode?: string[];
    }[];
    /**
     * 其他资金校验
     */
    restFundCheckRO?: {
      /**
       * 基础校验
       */
      baseControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string[];
      };
      /**
       * 资金控制校验
       */
      fundControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string;
        /**
         * 校验公共参数
         */
        checkList?: {
          indexNo?: string;
          checkStatus?: number;
          checkMessage?: string;
          extraJson?: string;
          bindCount?: number;
        }[];
      };
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/421538) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/submit`
 * @更新时间 `2024-12-11 15:42:18`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/421538) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/submit`
 * @更新时间 `2024-12-11 15:42:18`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormSubmitPostRequestConfig: ZlbApiExpenseExpenseFormSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/421538) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/submit`
 * @更新时间 `2024-12-11 15:42:18`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormSubmitPostResponse>(
    prepare(zlbApiExpenseExpenseFormSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormSubmitPost.requestConfig = zlbApiExpenseExpenseFormSubmitPostRequestConfig;

/**
 * 接口 [行程比较(申请单行程与页面行程进行对比)↗](http://yapi.cai-inc.com/project/3621/interface/api/425482) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/itinerary-compare`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormItineraryComparePostRequest {
  /**
   * 申请单号
   */
  applyFormCodeList: string[];
  /**
   * 行程数据
   */
  itineraryPOS?: {
    /**
     * 前端生成的编号
     */
    indexNo?: string;
    /**
     * 行程单编号
     * 更新时必填
     */
    itineraryCode?: string;
    /**
     * 原行程单号
     */
    originalItineraryCode?: string;
    /**
     * 出差人列表
     */
    accompanyList: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 开始上下午
     */
    beginTag: number;
    /**
     * 结束时间
     */
    endTime: string;
    /**
     * 结束上下午
     */
    endTag: number;
    /**
     * 出差天数
     */
    travelDay: number;
    /**
     * 是否派车 0不派车 1派车
     */
    arrangeCar: number;
    /**
     * 派车信息
     */
    arrangeCarPO?: {
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag: number;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag: number;
      /**
       * 派车天数
       */
      arrangeCarDay: number;
      /**
       * 乘车人
       */
      passengerList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
    };
    /**
     * 出发城市code
     */
    beginCityCode: string;
    /**
     * 出发城市名称
     */
    beginCityName: string;
    /**
     * 目的城市列表
     */
    endCityList: {
      /**
       * 目的城市code
       */
      endCityCode: string;
      /**
       * 目的城市名称
       */
      endCityName: string;
    }[];
    /**
     * 住宿天数
     */
    accommodationDay: number;
  }[];
}

/**
 * 接口 [行程比较(申请单行程与页面行程进行对比)↗](http://yapi.cai-inc.com/project/3621/interface/api/425482) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/itinerary-compare`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormItineraryComparePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申请单号
     */
    applyFormCode?: string;
    /**
     * 业务单据号
     */
    businessCode?: string;
    /**
     * 行程拆分结果(包含是否重复字段)
     */
    itineraryRepeatMarkROList?: {
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 行程信息编号
       */
      itineraryCode?: string;
      /**
       * 原行程单号
       */
      originalItineraryCode?: string;
      /**
       * 出差人列表
       */
      accompanyList?: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
      /**
       * 开始时间
       */
      beginTime?: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag?: number;
      /**
       * 结束时间
       */
      endTime?: string;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag?: number;
      /**
       * 出差天数
       */
      travelDay?: number;
      /**
       * 出发地code
       */
      beginCityCode?: string;
      /**
       * 出发地名称
       */
      beginCityName?: string;
      /**
       * 目的地列表
       */
      endCityList?: {
        /**
         * 目的城市code
         */
        endCityCode: string;
        /**
         * 目的城市名称
         */
        endCityName: string;
      }[];
      /**
       * 行程冲突提示语
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 是否派车 0 否 1是
       */
      arrangeCar?: number;
      /**
       * 派车信息
       */
      arrangeCarRO?: {
        /**
         * 派车信息编号
         */
        arrangeCarCode?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 派车天数
         */
        arrangeCarDay?: number;
        /**
         * 乘车人
         */
        passengerList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 司机
         */
        drivers?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
      };
      /**
       * 住宿天数
       */
      accommodationDay?: number;
      /**
       * 是否存在重复
       */
      isRepeat?: boolean;
      /**
       * 重复信息
       */
      repeatMsg?: string;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [行程比较(申请单行程与页面行程进行对比)↗](http://yapi.cai-inc.com/project/3621/interface/api/425482) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/itinerary-compare`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormItineraryComparePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/itinerary-compare',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [行程比较(申请单行程与页面行程进行对比)↗](http://yapi.cai-inc.com/project/3621/interface/api/425482) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/itinerary-compare`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormItineraryComparePostRequestConfig: ZlbApiExpenseExpenseFormItineraryComparePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/itinerary-compare',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormItineraryComparePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [行程比较(申请单行程与页面行程进行对比)↗](http://yapi.cai-inc.com/project/3621/interface/api/425482) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/itinerary-compare`
 * @更新时间 `2024-12-11 15:42:27`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormItineraryComparePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormItineraryComparePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormItineraryComparePostResponse>(
    prepare(zlbApiExpenseExpenseFormItineraryComparePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormItineraryComparePost.requestConfig =
  zlbApiExpenseExpenseFormItineraryComparePostRequestConfig;

/**
 * 接口 [审核报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/486826) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/audit`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormAuditPostRequest {
  /**
   * 单据code
   */
  formCode: string;
  /**
   * 工作流信息
   */
  workflowInfo?: {
    /**
     * 业务单号
     */
    bizId?: string;
    /**
     * 业务场景
     */
    bizType?: string;
    /**
     * 业务子类型
     */
    subType?: string;
    /**
     * 审核意见
     */
    auditRemark?: string;
    /**
     * 审核状态：1-通过；2-驳回；
     */
    executeType: number;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: string;
    /**
     * 当前节点key
     */
    currentNodeKey: string;
    /**
     * 操作人
     */
    operatorId?: number;
    /**
     * 业务字段
     */
    context?: string;
    /**
     * 事件类型：0-审批，1-审核，2-出纳，3-抄送
     */
    eventType: number;
    /**
     * 驳回节点Key
     */
    rejectNodeKey?: string;
    /**
     * 签名附件
     */
    signAttachment?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 业务编号
       */
      bizNo?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
    };
  };
  /**
   * 报销单审核更新入参
   */
  formUpdateInfo?: {
    /**
     * 报销单Code
     */
    expenseFormCode: string;
    /**
     * 报销收款人数据
     */
    expenseFormReceiverPOS: {
      /**
       * 操作人ID
       */
      operatorId: number;
      /**
       * 账号code
       */
      accountCode?: string;
      /**
       * 收款金额
       */
      amount: number;
      /**
       * 原收款金额
       */
      originalAmount?: number;
      /**
       * 收款人姓名
       */
      receiverName: string;
      /**
       * 前端数组下标
       */
      indexNo: string;
      /**
       * 收款人Code
       */
      receiverCode?: string;
      /**
       * 调整原因
       */
      updateReason?: string;
      /**
       * 费用更新金额
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 人员来源 1-系统内部；2-外部人员
       */
      userSource?: 1 | 2;
      userType?: number;
      /**
       * 用户类型
       */
      type?: number;
      /**
       * 类型
       */
      fundsObjectType?:
        | 1
        | 11
        | 12
        | 13
        | 14
        | 19
        | 2
        | 21
        | 22
        | 23
        | 24
        | 3
        | 31
        | 32
        | 4
        | 41
        | 42;
    }[];
    /**
     * 付款人数据,当为自有基金支付的时候，付款账户数据不能为空
     */
    expenseFormPayAccountPO?: {
      /**
       * 付款账户accountCode，传递支付系统的银行卡的accountCode
       */
      accountCode: string;
      /**
       * 付款金额
       */
      payAmount: number;
    };
    /**
     * 费用数据列表
     */
    expenseFeeExtendPOS?: {
      indexNo: string;
      /**
       * 费用集合
       */
      expenseFeePOS: {
        /**
         * 唯一标识
         */
        indexNo: string;
        /**
         * 记录的费用code
         */
        feeCode?: string;
        /**
         * 记录的费用名称，用于自定义
         */
        feeName?: string;
        /**
         * 所属机构id
         */
        operatorOrgId?: number;
        /**
         * 所属机构名称
         */
        operatorOrgName?: string;
        /**
         * 费用类型
         */
        feeType: number;
        /**
         * 费用发生时间
         */
        consumeTime: string;
        /**
         * 货币金额
         */
        amount: number;
        /**
         * 消费城市区划
         */
        districtCode?: string;
        /**
         * 消费城市名称
         */
        districtName?: string;
        /**
         * 关联的发票编号
         */
        invoiceCodes: string[];
        /**
         * 关联的出差人
         */
        accompanyPerson?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 材料数据
         */
        materialInfo?: {
          /**
           * 凭票报销伙食类补贴信息
           */
          allowanceMaterialByInvoiceDTO?: {
            /**
             * 关联行程编号
             */
            associateItineraryList: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
            }[];
            /**
             * 补贴发生日期
             */
            allowanceHappenDates: string[];
            /**
             * 城市名称s(无用，纯属兼容前端，别删除)
             */
            endCityName?: string;
          };
          /**
           * 住宿类材料信息
           */
          hotelMaterialDTO?: {
            /**
             * 酒店入住开始时间
             */
            hotelEnterTime?: string;
            /**
             * 酒店入住结束时间
             */
            hotelLeaveTime?: string;
            /**
             * 住宿天数
             */
            accommodationDays?: number;
          };
          /**
           * 交通类材料信息
           */
          trafficMaterialDTO?: {
            /**
             * 座位类别
             */
            seatType?: number;
            /**
             * 座位枚举描述
             */
            seatDesc?: string;
            /**
             * 出发地区划code
             */
            fromDistrictCode: string;
            /**
             * 出发地区划名称
             */
            fromDistrictName: string;
            /**
             * 结束地区划code
             */
            endDistrictCode: string;
            /**
             * 结束地区划名称
             */
            endDistrictName: string;
            /**
             * 火车时长码
             */
            trainDurationCode?: number;
            /**
             * 火车时长
             */
            trainDurationDesc?: string;
            /**
             * 出发日期
             */
            departureTime: string;
            /**
             * 公里数
             */
            mileage: number;
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
          };
          /**
           * 补贴类材料
           */
          allowanceMaterialDTO?: {
            /**
             * 总的费用金额
             */
            totalAmount?: number;
            /**
             * 费用标准细项
             */
            itemList?: {
              /**
               * 标准金额
               */
              standardAmount?: number;
              /**
               * 时间-天数
               */
              days?: number;
              /**
               * 费用描述
               */
              ruleDesc?: string;
            }[];
            /**
             * 火车补贴伙食费用细项
             */
            trainAllowanceMaterialDTOS?: {
              /**
               * 火车天数
               */
              trainHours?: number;
              /**
               * 火车补贴金额
               */
              trainStanardAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 用户ID
               */
              operatorId?: number;
              /**
               * 人员来源 1-系统内部；2-外部人员
               */
              userSource?: 1 | 2;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
            }[];
            /**
             * 火车总额度
             */
            trainTotalAmount?: number;
            /**
             * 是否派车
             */
            isCar?: boolean;
            /**
             * 派车铺贴计算
             */
            carAllowanceMaterialDTOS?: {
              /**
               * 派车天数
               */
              carDays?: number;
              /**
               * 派车金额
               */
              carStandardtotalAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
            }[];
          };
          /**
           * 通用类材料信息
           */
          meetingOrTrainMaterialDTO?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 会议类型
             */
            meetingType?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
            /**
             * 培训人员
             */
            trainingPerson?: string;
            /**
             * 培训人员职级
             */
            trainingPersonLevel?: number;
            /**
             * 培训人员职级
             */
            trainingPersonLevelDesc?: string;
            /**
             * 培训时长
             */
            trainingHour?: number;
          };
          /**
           * 业务招待材料信息
           */
          businessEntertainingMaterial?: {
            /**
             * 招待日期
             */
            entertainDate?: string;
            /**
             * 招待形式
             */
            entertainForm: 1 | 2 | 3;
            /**
             * 招待形式描述
             */
            entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
            /**
             * 招待人数
             */
            entertainPeopleNum: number;
            /**
             * 招待事由
             */
            entertainReason: string;
          };
          /**
           * 交通费-租车费材料信息
           */
          rentCarFeeMaterial?: {
            /**
             * 租车申请单信息
             */
            rentCarApplyForm?: {
              /**
               * 业务单据号
               */
              businessNo?: string;
              /**
               * 申请编号
               */
              applyFormCode?: string;
              /**
               * 用车人（前端回显）
               */
              carUserList?: {
                /**
                 * 人员id
                 */
                operatorId: number;
                /**
                 * 人员名称
                 */
                operatorName: string;
                /**
                 * 机构id
                 */
                institutionId?: number;
                /**
                 * 机构名称
                 */
                institutionName?: string;
                /**
                 * 外部人员职级
                 * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
                 */
                outerUserRank?: number;
                /**
                 * 人员类型
                 * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
                 */
                userType?: number;
                userId?: number;
                userName?: string;
                bankCardInfo?: {
                  /**
                   * 银行代码
                   */
                  bankCode: string;
                  /**
                   * 银行名字
                   */
                  bankName: string;
                  /**
                   * 账户名称
                   */
                  accountName: string;
                  /**
                   * 银行账号
                   */
                  bankAccount: string;
                  /**
                   * 银行账号 脱敏
                   */
                  bankAccountDesc?: string;
                  /**
                   * 卡号保存的唯一标识
                   */
                  accountCode?: string;
                };
                /**
                 * 同一个人员，绑定的id
                 */
                bindOperatorId?: number;
                /**
                 * 用户类型
                 * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
                 */
                type: number;
                /**
                 * 用户职级,
                 * 内部用户的职级，外部用户关联内部用户，取内部用户职级
                 * 否则去外部用户职级
                 */
                userRank?: string;
                /**
                 * 手机号
                 */
                mobile?: string;
                /**
                 * 证件号码
                 */
                idCard?: string;
                /**
                 * 证件类型
                 */
                idType?: number;
                /**
                 * 性别
                 */
                gender?: number;
                /**
                 * 同行人费用code
                 */
                feeCode?: string;
              }[];
              /**
               * 预计金额（前端回显）
               */
              planAmount?: number;
              /**
               * 申请事由（前端回显）
               */
              applyReason?: string;
              /**
               * 经办人名称（前端回显）
               */
              operatorName?: string;
              /**
               * 目的地列表（前端回显）
               */
              endCityList?: {
                /**
                 * 目的城市code
                 */
                endCityCode: string;
                /**
                 * 目的城市名称
                 */
                endCityName: string;
              }[];
            }[];
            /**
             * 目的地
             */
            destination?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
            /**
             * 消费日期
             */
            consumeDate?: string[];
          };
          /**
           * 基础行程类信息
           */
          batchItineraryMaterialDTO?: {
            /**
             * 行程基本信息
             */
            itineraryMaterialDTOList?: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
              /**
               * 起始区划code
               */
              startDistrictCode: string;
              /**
               * 出发地名称
               */
              startDistrictName?: string;
              /**
               * 结束区划code
               */
              endDistrictCode: string;
              /**
               * 结束地点名称
               */
              endDistrictName?: string;
              /**
               * 人数
               */
              operatorIds?: number[];
            }[];
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
            /**
             * 人数
             */
            operatorIds?: number[];
          };
          /**
           * 修改备注
           */
          remark?: string;
          /**
           * 费用说明
           */
          feeDesc?: string;
          /**
           * 是否多票
           */
          multiInvoice?: boolean;
          /**
           * 关联的单据的编号
           */
          associateFormList?: {
            /**
             * 单据code
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: string;
            /**
             * 原始金额
             */
            originalAmount?: number;
          }[];
        };
        /**
         * 费用附件
         */
        attachments: {
          fileId: string;
          fileType?: string;
          fileName: string;
          fileSize?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          downloadUrl?: string;
        }[];
        /**
         * 关联的单号
         */
        formCode?: string;
        /**
         * 单据类型：1-申请单，2-报销单
         */
        formType?: number;
        /**
         * 修改金额历史
         */
        modifyFeeAmountDTO?: {
          /**
           * 原始金额
           */
          originalAmount: number;
          /**
           * 修改后金额
           */
          updateAmount: number;
          /**
           * 修改备注
           */
          updateReason?: string;
          /**
           * 原始账户
           */
          originalAccount?: string;
          /**
           * 修改后账户
           */
          updateAccount?: string;
        };
        /**
         * 原始的feeRecordId
         */
        originalFeeId?: number;
        /**
         * 平台订单编号
         */
        platformOrderNo?: string;
        /**
         * 明细说明
         */
        remark?: string;
        /**
         * 明细数据
         */
        detailExtendDTO?: {
          /**
           * 详细列表页
           */
          expenseFeeDetailInfoList?: {
            /**
             * 前端需要参数
             */
            indexNo?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            userType?: number;
            type?: number;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 原始信息（当前补贴）
             */
            originalInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
            /**
             * 重复补贴
             */
            conflictInfoList?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            }[];
            /**
             * 费用种类
             */
            feeCategory?: number;
            /**
             * 实际补贴金额
             */
            amount?: number;
            /**
             * 原始计算金额
             */
            originalAmount?: number;
            /**
             * 调整前金额
             */
            beforeChangeAmount?: number;
            /**
             * 冲突的金额
             */
            conflictAmount?: number;
            /**
             * 扣减金额
             */
            reductionAmount?: number;
            /**
             * 最大允许金额
             */
            allowMaxAmount?: number;
            /**
             * 备注
             */
            remark?: string;
            /**
             * 是否发生变更
             */
            isChanged?: boolean;
          }[];
          /**
           * 冲突展示列表页
           */
          expenseFeeConflictList?: {
            /**
             * 业务编码
             */
            businessCode?: string;
            /**
             * 单据编号
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: number;
            /**
             * 业务类型
             */
            businessType?: number;
            /**
             * 业务类型描述
             */
            businessTypeDesc?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 冲突信息
             */
            conflictInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
          }[];
          /**
           * 调整后金额
           */
          currentAmount?: number;
          /**
           * 原始金额
           */
          originalAmount?: number;
          /**
           * 费用类型
           */
          feeType?: number;
          /**
           * 火车金额
           */
          trainAmount?: number;
          /**
           * 总金额相等
           */
          totalAmountEquals?: boolean;
        };
        /**
         * 交易信息编码 for 会议培训多收款人
         */
        tradeCode?: string;
      }[];
      feeParentType: number;
      totalAmount: number;
      currencyCode?: string;
    }[];
    /**
     * 收款总金额
     */
    totalAmount: number;
    /**
     * 预算指标信息
     */
    budgetInfoPO?: {
      /**
       * 主预算编号
       */
      mainBudgetCode: number;
      /**
       * 预算指标编号
       */
      budgetUk: string;
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk: string;
      /**
       * 预算金额
       */
      budgetAmount: number;
      /**
       * 交易信息 for 会议/培训多收款人
       */
      tradeCode?: string;
      /**
       * 支付记录信息code
       */
      payRecordCode?: string;
    }[];
    /**
     * 预算额度信息
     */
    quotaInfoPO?: {
      /**
       * 预算金额
       */
      budgetAmount: number;
      /**
       * 预算额度id
       */
      budgetQuotaId: string;
      /**
       * 交易信息 for 会议/培训多收款人
       */
      tradeCode?: string;
      /**
       * 支付记录信息code
       */
      payRecordCode?: string;
    }[];
    /**
     * 是否忽略警告
     */
    isIgnoreWarning?: boolean;
    /**
     * 费用总金额
     */
    feeTotalAmount: number;
    /**
     * 综合定额费用
     */
    mixFeeTotalAmount?: number;
    /**
     * 是否需要忽略费控校验
     */
    needIgnoreCheckFee?: boolean;
    /**
     * 支付方式(1：国库支付，3：非财政资金网银结算，4：库集中支付+非财政资金结算
     */
    payMode?: number;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategy?: number;
    /**
     * 变更支付方式说明
     */
    changePayModeReason?: string;
    /**
     * 摘要
     */
    summary?: string;
    /**
     * 单据附件
     */
    formAttachmentDTO?: {
      /**
       * 默认附件列表
       */
      normalAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 说明附件列表
       */
      thatAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 通知附件列表
       */
      informAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 合同附件列表
       */
      compactAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 签到附件列表
       */
      signAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 派出单位公函附件列表
       */
      officialLetterAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 接待清单附件列表
       */
      receptionMenuAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 采购意向附件列表
       */
      purchasePurposeAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 资产更新计划
       */
      propertyUpdatePlanAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 集体决策会议纪要
       */
      meetingSummaryAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 专家论证意见
       */
      argumentSuggestionAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 专项、会议、培训附件列表
       */
      specialAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 银行回单附件
       */
      bankReceiptAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 账单附件
       */
      billAttachmentFileList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
    };
    /**
     * 宁波收款明细PO
     */
    receiverPayInfoQueryList?: {
      /**
       * 收款卡基本信息
       */
      receiverPO?: {
        /**
         * 操作人ID
         */
        operatorId: number;
        /**
         * 账号code
         */
        accountCode?: string;
        /**
         * 收款金额
         */
        amount: number;
        /**
         * 原收款金额
         */
        originalAmount?: number;
        /**
         * 收款人姓名
         */
        receiverName: string;
        /**
         * 前端数组下标
         */
        indexNo: string;
        /**
         * 收款人Code
         */
        receiverCode?: string;
        /**
         * 调整原因
         */
        updateReason?: string;
        /**
         * 费用更新金额
         */
        modifyFeeAmountDTO?: {
          /**
           * 原始金额
           */
          originalAmount: number;
          /**
           * 修改后金额
           */
          updateAmount: number;
          /**
           * 修改备注
           */
          updateReason?: string;
          /**
           * 原始账户
           */
          originalAccount?: string;
          /**
           * 修改后账户
           */
          updateAccount?: string;
        };
        /**
         * 人员来源 1-系统内部；2-外部人员
         */
        userSource?: 1 | 2;
        userType?: number;
        /**
         * 用户类型
         */
        type?: number;
        /**
         * 类型
         */
        fundsObjectType?:
          | 1
          | 11
          | 12
          | 13
          | 14
          | 19
          | 2
          | 21
          | 22
          | 23
          | 24
          | 3
          | 31
          | 32
          | 4
          | 41
          | 42;
      };
      /**
       * 个人卡报销
       */
      personalCardExpenseQueryList?: {
        /**
         * 前端下标
         */
        indexNo: string;
        /**
         * 消费金额
         */
        amount?: number;
        /**
         * 拆分的金额
         */
        splitAmount?: number[];
        /**
         * 报销里的消费记录主键
         */
        consumptionRecordCode?: string;
        /**
         * 拆分金额
         */
        splitAmountDetail?: {
          /**
           * 拆分金额
           */
          amount: number;
          /**
           * 支付类型
           */
          payStrategy:
            | 'FINA_ZERO_PAY'
            | 'UNIT_ZERO_PAY'
            | 'UNIT_FUND_PAY'
            | 'FINA_SPLIT_PAY'
            | 'AUTH_NORMAL_PAY'
            | 'DIRECTLY_NORMAL_PAY'
            | 'AUTH_BUSINESS_CARD_PAY'
            | 'AUTH_PERSONAL_BATCH_PAY'
            | 'AUTH_ENTERPRISE_BATCH_PAY'
            | 'FINA_AND_FUND_PAY'
            | 'UNIT_FUND_NORMAL_PAY'
            | 'UNIT_FUND_OFF_CARD_PAY'
            | 'NB_FINA_ZERO_PAY'
            | 'NB_UNIT_ZERO_PAY'
            | 'NB_UNIT_FUND_PAY'
            | 'NB_FINA_SPLIT_PAY'
            | 'CBS_NORMAL_PAY'
            | 'CBS_BATCH_PAY';
          /**
           * 支付类型名称
           */
          payStrategyName?: string;
        }[];
      }[];
    }[];
    /**
     * 预算关联关系
     * 目前存在情况，在财务审核时，预算可以直接与单据关联，也可以与收款人关联（一般事项多收款），后续也有其他关联
     * 注意：当前字段只有在一般事项多收款人（坑中坑注意！！！）
     */
    budgetRelationInfoPOList?: {
      /**
       * 关联预算的Code
       */
      budgetRelationBusinessCode: string;
      /**
       * 关联预算业务数据类型
       * EXPENSE_FORM(1, "报销单"),
       * TRADE(2, "交易"),
       * ACCOUNT(3, "收款账户"),
       */
      relationBusinessType:
        | '报销单'
        | '交易'
        | '收款账户'
        | '工资流水'
        | '夜餐费发放单'
        | '项目支付单';
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag: boolean;
      /**
       * 预算指标信息
       */
      budgetInfoPOList?: {
        /**
         * 主预算编号
         */
        mainBudgetCode: number;
        /**
         * 预算指标编号
         */
        budgetUk: string;
        /**
         * 支付限额经济分类主键
         */
        budgetPlanClassifyUk: string;
        /**
         * 预算金额
         */
        budgetAmount: number;
        /**
         * 交易信息 for 会议/培训多收款人
         */
        tradeCode?: string;
        /**
         * 支付记录信息code
         */
        payRecordCode?: string;
      }[];
      /**
       * 预算额度信息
       */
      quotaInfoPOList?: {
        /**
         * 预算金额
         */
        budgetAmount: number;
        /**
         * 预算额度id
         */
        budgetQuotaId: string;
        /**
         * 交易信息 for 会议/培训多收款人
         */
        tradeCode?: string;
        /**
         * 支付记录信息code
         */
        payRecordCode?: string;
      }[];
    }[];
    /**
     * 工作流业务属性
     */
    workflowBizProperties?: {
      /**
       * 修改费用标记
       */
      editableAmount?: number;
    };
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 占用金额
       */
      amount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 操作人，后端使用
       */
      operatorId?: number;
      /**
       * 科目级联uk
       */
      subjectUkHierarchy?: string[];
      /**
       * 科目级联
       */
      subjectNameHierarchy?: string[];
    }[];
    /**
     * 包干经费预算
     */
    fundBudget?: {
      /**
       * 是否包干经费 true=是 false=否
       */
      isFundBudget?: null;
      /**
       * 包干经费预算uk
       */
      fundBudgetUk?: null;
      /**
       * 包干经费预算名称
       */
      fundBudgetName?: null;
      /**
       * 经费uk
       */
      fundBudgetItemUk?: null;
      /**
       * 经费名称
       */
      fundBudgetItemName?: null;
      /**
       * 占用金额
       */
      usedAmount?: null;
    };
    /**
     * 通用扩展字段
     */
    generalExtra?: string;
    /**
     * 其他资金明细列表
     */
    restDetailList?: {
      indexNo?: string;
      restDetailCode?: string;
      summary: string;
      deptName?: string;
      deptId?: number;
      actSubjectCode: string;
      actSubjectName: string;
      depEconomicClassifyCode?: string;
      depEconomicClassifyName?: string;
      expendFunctionClassifySubjectCode?: string;
      expendFunctionClassifySubjectName?: string;
      projectCode?: string;
      projectName?: string;
      budgetUk?: string;
      fundAttrType: number;
      budgetAmount: number;
      ledgerFormCode?: string;
    }[];
    /**
     * 会计科目-本方科目
     */
    actSubjectCode?: string;
    /**
     * 会计科目名称-本方科目
     */
    actSubjectName?: string;
    /**
     * 是否启用核算（其他资金，如若扩展则可增加）:0-否,1-是
     */
    isEnableAccount?: number;
  };
}

/**
 * 接口 [审核报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/486826) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/audit`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态 0：通过 1：警告 2：强控 3 提示
     */
    checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
    /**
     * 行程冲突校验结果
     */
    itineraryCheckResultRO?: {
      /**
       * 所有行程是否通过行程校验
       * 通过：0
       */
      checkStatus?: number;
      /**
       * 报销单行程校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 行程数组索引
         */
        indexNo?: string;
        /**
         * 每段行程的提示文案及校验状态
         */
        itineraryCheckResultList?: {
          /**
           * 校验状态
           * 0-通过 1-弱控 2-强控 3-提示
           */
          checkStatus?: 0 | 1 | 2 | 3;
          /**
           * 提示文案
           */
          message?: string;
        }[];
      }[];
      /**
       * 整体提示信息
       * 暂时仅有不足申请单的部分有赋值
       */
      overallCheckResult?: {
        /**
         * 校验状态
         * 0-通过 1-弱控 2-强控 3-提示
         */
        checkStatus?: 0 | 1 | 2 | 3;
        /**
         * 提示文案
         */
        message?: string;
      };
    };
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
            /**
             * 校验结果
             */
            checkStatus?: number;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
              /**
               * 校验结果
               */
              checkStatus?: number;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
            /**
             * 设置结果
             */
            resultInfo?: {
              /**
               * 凭票报销总结果
               */
              expenseFeeInvoiceResult?: {
                /**
                 * 用户id
                 */
                operatorId?: number;
                /**
                 * 用户名称
                 */
                operatorName?: string;
                /**
                 * 报销金额
                 */
                amount?: number;
                /**
                 * 报销金额描述
                 */
                amountDesc?: string;
                /**
                 * 详细信息
                 */
                detailInfoList?: {
                  /**
                   * 发生日期
                   */
                  happenDate?: null;
                  /**
                   * 是否可以报销
                   */
                  canExpense?: null;
                  /**
                   * 表单code
                   */
                  formCode?: string[];
                  /**
                   * 业务code
                   */
                  businessCode?: string[];
                  /**
                   * 冲突描述
                   */
                  conflictDesc?: null;
                  /**
                   * 是否凭票报销冲突
                   */
                  isUseInvoice?: null;
                  /**
                   * 规则描述
                   */
                  ruleDesc?: null;
                  /**
                   * 金额
                   */
                  ruleAmount?: null;
                }[];
              }[];
              /**
               * 凭票报销总结果提示
               */
              expenseFeeInvoiceTips?: string;
              /**
               * 是否展示
               */
              canShow?: boolean;
            };
            /**
             * 是否需要显示
             */
            canShow?: boolean;
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
          /**
           * 校验结果
           */
          checkStatus?: number;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 预算校验结果
     */
    budgetCheckResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
      /**
       * 预算指标ID
       */
      mainBudgetCode?: number;
      /**
       * 预算指标编号
       */
      budgetUk?: string;
      /**
       * 预算编号(展示)
       */
      financialBudgetDetailId?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 额度ID
       */
      budgetQuotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag?: boolean;
      /**
       * 占用总金额
       */
      budgetTotalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 关联预算的业务信息
       */
      budgetExceptionTipsROS?: {
        /**
         * 关联预算的Code
         */
        budgetRelationBusinessCode?: string;
        /**
         * 关联预算的业务名称描述
         */
        budgetRelationBusinessDesc?: string;
        /**
         * 关联交易描述
         */
        tradeDesc?: string;
        /**
         * 关联预算业务数据类型
         * 直接以枚举的名称作为存储，以便在请求中可以直接看出
         */
        relationBusinessType?:
          | '报销单'
          | '交易'
          | '收款账户'
          | '工资流水'
          | '夜餐费发放单'
          | '项目支付单';
        /**
         * 占用的金额
         */
        budgetAmount?: number;
      }[];
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 预算项目校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 科目校验描述
         */
        subjectCheckDesc?: string;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
      }[];
    };
    /**
     * 收款信息校验结果
     */
    receiverCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 收款信息校验详情
       */
      checkResultInfoROS?: {
        /**
         * 是否通过校验
         */
        checkStatus?: number;
        /**
         * 收款人信息数组下标
         */
        indexNo?: string;
        /**
         * 提示消息
         */
        msg?: string[];
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 支付方式校验结果
     */
    payConfigCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 订单校验结果
     */
    orderCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 报销单号
     */
    expenseFormCode?: string;
    /**
     * 合同校验结果
     */
    contractCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 发票校验结果
     */
    invoiceCheckResultROS?: {
      /**
       * 发票ID
       */
      platformInvoiceId?: string;
      /**
       * 状态码
       */
      code?: number;
      /**
       * 是否可报销 true：可以报销 false：不可以报销
       */
      success?: boolean;
      /**
       * 提示消息
       */
      msg?: string;
    }[];
    /**
     * 超标原因配置
     */
    reasonConfigROS?: {
      /**
       * 状态
       */
      checkStatus?: number;
      /**
       * 规则列表
       */
      ruleInfoROS?: {
        /**
         * 规则描述
         */
        ruleDesc?: string;
        /**
         * 规则code
         */
        ruleCode?: string;
        /**
         * 状态
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      }[];
      /**
       * 超标配置列表
       */
      reasonConfigList?: {
        /**
         * 校验结果分组code
         */
        checkGroupCode?: string;
        /**
         * 父标题
         */
        parentTitle?: string;
        /**
         * 子标题
         */
        subTitle?: string;
        /**
         * 合并code
         */
        mergeGroupCode?: string;
        /**
         * 是否必填
         */
        isMust?: number;
        /**
         * 备注长度
         */
        remarkLength?: number;
      }[];
    };
    /**
     * 含有异常申请单的列表（校验通过时为空数组）
     */
    applyFormCheckResultROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 检查结果
       */
      checkResult?: 0 | 1 | 2;
      /**
       * 检查结果描述
       */
      checkResultDesc?: '通过' | '已作废' | '已关联';
      /**
       * 被关联的其他报销单号
       */
      certainExpenseFormCode?: string[];
    }[];
    /**
     * 其他资金校验
     */
    restFundCheckRO?: {
      /**
       * 基础校验
       */
      baseControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string[];
      };
      /**
       * 资金控制校验
       */
      fundControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string;
        /**
         * 校验公共参数
         */
        checkList?: {
          indexNo?: string;
          checkStatus?: number;
          checkMessage?: string;
          extraJson?: string;
          bindCount?: number;
        }[];
      };
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [审核报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/486826) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/audit`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审核报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/486826) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/audit`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormAuditPostRequestConfig: ZlbApiExpenseExpenseFormAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审核报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/486826) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/audit`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormAuditPostResponse>(
    prepare(zlbApiExpenseExpenseFormAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormAuditPost.requestConfig = zlbApiExpenseExpenseFormAuditPostRequestConfig;

/**
 * 接口 [发票补充列表↗](http://yapi.cai-inc.com/project/3621/interface/api/491186) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/without-invoice-list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormWithoutInvoiceListPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 1未完成 2已完成
   */
  withoutInvoiceStatus: number;
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 报销单类型
   */
  expenseFormType?:
    | 'TRAVEL_EXPENSE_FORM'
    | 'MEETING_EXPENSE_FORM'
    | 'TRAINING_EXPENSE_FORM'
    | 'PROCUREMENT_EXPENSE_FORM'
    | 'RECEPTION_EXPENSE_FORM'
    | 'GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GENERAL_EXPENSE_FORM'
    | 'PURCHASE_GOVERNMENT_EXPENSE_FORM'
    | 'PURCHASE_FURNITURE_EXPENSE_FORM'
    | 'MEETING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'TRAINING_MULTI_RECEIVER_EXPENSE_FORM'
    | 'PUBLIC_BUSINESS_PAYMENT_EXPENSE_FORM'
    | 'INVEST_PAYMENT_EXPENSE_FORM'
    | 'REST_EXPENSE_FORM';
  /**
   * 报销事由
   */
  expenseReason?: string;
  /**
   * 起始时间
   */
  beginTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 部门ID
   */
  departmentId?: number;
}

/**
 * 接口 [发票补充列表↗](http://yapi.cai-inc.com/project/3621/interface/api/491186) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/without-invoice-list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormWithoutInvoiceListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    total?: number;
    data?: {
      /**
       * 报销单号
       */
      expenseFormCode?: string;
      /**
       * 报销单号
       */
      businessCode?: string;
      /**
       * 报销单类型
       */
      expenseFormType?: number;
      /**
       * 报销单类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 报销缘由
       */
      expenseReason?: string;
      /**
       * 创建人姓名
       */
      operatorName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentId?: number;
      /**
       * 机构ID
       */
      orgId?: number;
      /**
       * 机构名字
       */
      orgName?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 报销单状态
       */
      expenseFormStatus?: number;
      /**
       * 报销单状态
       */
      expenseFormStatusDesc?: string;
      /**
       * 报销金额
       */
      expenseAmount?: number;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 业务类型名称
       */
      businessTypeName?: string;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
       */
      processStatus?: string;
      /**
       * 用户类别
       * 1-本人 2-审核人 3-审批人 4-同行人
       */
      userRole?: number;
      /**
       * 是否百搭单据
       */
      isBaidaForm?: boolean;
      /**
       * 审批人名称
       */
      approvedNames?: string[];
      /**
       * 报销单关联申请单基本信息
       */
      relationApplyInfoROList?: {
        /**
         * 申请单业务单据号
         */
        applyBusinessNo?: string;
        /**
         * 申请单编号
         */
        applyFormCode?: string;
        /**
         * 申请单单据类型编号
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请人姓名
         */
        applyUserName?: string;
        /**
         * 发起时间
         */
        initiationTime?: string;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [发票补充列表↗](http://yapi.cai-inc.com/project/3621/interface/api/491186) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/without-invoice-list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormWithoutInvoiceListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/without-invoice-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [发票补充列表↗](http://yapi.cai-inc.com/project/3621/interface/api/491186) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/without-invoice-list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormWithoutInvoiceListPostRequestConfig: ZlbApiExpenseExpenseFormWithoutInvoiceListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/without-invoice-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormWithoutInvoiceListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [发票补充列表↗](http://yapi.cai-inc.com/project/3621/interface/api/491186) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/without-invoice-list`
 * @更新时间 `2024-12-11 15:42:21`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormWithoutInvoiceListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormWithoutInvoiceListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormWithoutInvoiceListPostResponse>(
    prepare(zlbApiExpenseExpenseFormWithoutInvoiceListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormWithoutInvoiceListPost.requestConfig =
  zlbApiExpenseExpenseFormWithoutInvoiceListPostRequestConfig;

/**
 * 接口 [补充发票↗](http://yapi.cai-inc.com/project/3621/interface/api/491194) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/replenish-invoice`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormReplenishInvoicePostRequest {
  /**
   * 报销单号
   */
  expenseFormCode?: string;
  /**
   * 单收款人发票
   */
  invoiceList?: {
    /**
     * 发票单号
     */
    platformInvoiceId: string;
    /**
     * 发票金额
     */
    invoiceAmount: number;
  }[];
  /**
   * 多收款人发票
   */
  tradeInvoiceList?: {
    /**
     * 发票单号
     */
    platformInvoiceId: string;
    /**
     * 发票金额
     */
    invoiceAmount: number;
    /**
     * 交易编号
     */
    tradeCode: string;
  }[];
}

/**
 * 接口 [补充发票↗](http://yapi.cai-inc.com/project/3621/interface/api/491194) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/replenish-invoice`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormReplenishInvoicePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态 0：通过 1：警告 2：强控 3 提示
     */
    checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
    /**
     * 行程冲突校验结果
     */
    itineraryCheckResultRO?: {
      /**
       * 所有行程是否通过行程校验
       * 通过：0
       */
      checkStatus?: number;
      /**
       * 报销单行程校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 行程数组索引
         */
        indexNo?: string;
        /**
         * 每段行程的提示文案及校验状态
         */
        itineraryCheckResultList?: {
          /**
           * 校验状态
           * 0-通过 1-弱控 2-强控 3-提示
           */
          checkStatus?: 0 | 1 | 2 | 3;
          /**
           * 提示文案
           */
          message?: string;
        }[];
      }[];
      /**
       * 整体提示信息
       * 暂时仅有不足申请单的部分有赋值
       */
      overallCheckResult?: {
        /**
         * 校验状态
         * 0-通过 1-弱控 2-强控 3-提示
         */
        checkStatus?: 0 | 1 | 2 | 3;
        /**
         * 提示文案
         */
        message?: string;
      };
    };
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
            /**
             * 校验结果
             */
            checkStatus?: number;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
              /**
               * 校验结果
               */
              checkStatus?: number;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
            /**
             * 设置结果
             */
            resultInfo?: {
              /**
               * 凭票报销总结果
               */
              expenseFeeInvoiceResult?: {
                /**
                 * 用户id
                 */
                operatorId?: number;
                /**
                 * 用户名称
                 */
                operatorName?: string;
                /**
                 * 报销金额
                 */
                amount?: number;
                /**
                 * 报销金额描述
                 */
                amountDesc?: string;
                /**
                 * 详细信息
                 */
                detailInfoList?: {
                  /**
                   * 发生日期
                   */
                  happenDate?: null;
                  /**
                   * 是否可以报销
                   */
                  canExpense?: null;
                  /**
                   * 表单code
                   */
                  formCode?: string[];
                  /**
                   * 业务code
                   */
                  businessCode?: string[];
                  /**
                   * 冲突描述
                   */
                  conflictDesc?: null;
                  /**
                   * 是否凭票报销冲突
                   */
                  isUseInvoice?: null;
                  /**
                   * 规则描述
                   */
                  ruleDesc?: null;
                  /**
                   * 金额
                   */
                  ruleAmount?: null;
                }[];
              }[];
              /**
               * 凭票报销总结果提示
               */
              expenseFeeInvoiceTips?: string;
              /**
               * 是否展示
               */
              canShow?: boolean;
            };
            /**
             * 是否需要显示
             */
            canShow?: boolean;
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
          /**
           * 校验结果
           */
          checkStatus?: number;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 预算校验结果
     */
    budgetCheckResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
      /**
       * 预算指标ID
       */
      mainBudgetCode?: number;
      /**
       * 预算指标编号
       */
      budgetUk?: string;
      /**
       * 预算编号(展示)
       */
      financialBudgetDetailId?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 额度ID
       */
      budgetQuotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag?: boolean;
      /**
       * 占用总金额
       */
      budgetTotalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 关联预算的业务信息
       */
      budgetExceptionTipsROS?: {
        /**
         * 关联预算的Code
         */
        budgetRelationBusinessCode?: string;
        /**
         * 关联预算的业务名称描述
         */
        budgetRelationBusinessDesc?: string;
        /**
         * 关联交易描述
         */
        tradeDesc?: string;
        /**
         * 关联预算业务数据类型
         * 直接以枚举的名称作为存储，以便在请求中可以直接看出
         */
        relationBusinessType?:
          | '报销单'
          | '交易'
          | '收款账户'
          | '工资流水'
          | '夜餐费发放单'
          | '项目支付单';
        /**
         * 占用的金额
         */
        budgetAmount?: number;
      }[];
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 预算项目校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 科目校验描述
         */
        subjectCheckDesc?: string;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
      }[];
    };
    /**
     * 收款信息校验结果
     */
    receiverCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 收款信息校验详情
       */
      checkResultInfoROS?: {
        /**
         * 是否通过校验
         */
        checkStatus?: number;
        /**
         * 收款人信息数组下标
         */
        indexNo?: string;
        /**
         * 提示消息
         */
        msg?: string[];
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 支付方式校验结果
     */
    payConfigCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 订单校验结果
     */
    orderCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 报销单号
     */
    expenseFormCode?: string;
    /**
     * 合同校验结果
     */
    contractCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 发票校验结果
     */
    invoiceCheckResultROS?: {
      /**
       * 发票ID
       */
      platformInvoiceId?: string;
      /**
       * 状态码
       */
      code?: number;
      /**
       * 是否可报销 true：可以报销 false：不可以报销
       */
      success?: boolean;
      /**
       * 提示消息
       */
      msg?: string;
    }[];
    /**
     * 超标原因配置
     */
    reasonConfigROS?: {
      /**
       * 状态
       */
      checkStatus?: number;
      /**
       * 规则列表
       */
      ruleInfoROS?: {
        /**
         * 规则描述
         */
        ruleDesc?: string;
        /**
         * 规则code
         */
        ruleCode?: string;
        /**
         * 状态
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      }[];
      /**
       * 超标配置列表
       */
      reasonConfigList?: {
        /**
         * 校验结果分组code
         */
        checkGroupCode?: string;
        /**
         * 父标题
         */
        parentTitle?: string;
        /**
         * 子标题
         */
        subTitle?: string;
        /**
         * 合并code
         */
        mergeGroupCode?: string;
        /**
         * 是否必填
         */
        isMust?: number;
        /**
         * 备注长度
         */
        remarkLength?: number;
      }[];
    };
    /**
     * 含有异常申请单的列表（校验通过时为空数组）
     */
    applyFormCheckResultROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 检查结果
       */
      checkResult?: 0 | 1 | 2;
      /**
       * 检查结果描述
       */
      checkResultDesc?: '通过' | '已作废' | '已关联';
      /**
       * 被关联的其他报销单号
       */
      certainExpenseFormCode?: string[];
    }[];
    /**
     * 其他资金校验
     */
    restFundCheckRO?: {
      /**
       * 基础校验
       */
      baseControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string[];
      };
      /**
       * 资金控制校验
       */
      fundControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string;
        /**
         * 校验公共参数
         */
        checkList?: {
          indexNo?: string;
          checkStatus?: number;
          checkMessage?: string;
          extraJson?: string;
          bindCount?: number;
        }[];
      };
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [补充发票↗](http://yapi.cai-inc.com/project/3621/interface/api/491194) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/replenish-invoice`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormReplenishInvoicePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/replenish-invoice',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [补充发票↗](http://yapi.cai-inc.com/project/3621/interface/api/491194) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/replenish-invoice`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormReplenishInvoicePostRequestConfig: ZlbApiExpenseExpenseFormReplenishInvoicePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/replenish-invoice',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormReplenishInvoicePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [补充发票↗](http://yapi.cai-inc.com/project/3621/interface/api/491194) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/replenish-invoice`
 * @更新时间 `2024-12-11 15:42:22`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormReplenishInvoicePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormReplenishInvoicePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormReplenishInvoicePostResponse>(
    prepare(zlbApiExpenseExpenseFormReplenishInvoicePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormReplenishInvoicePost.requestConfig =
  zlbApiExpenseExpenseFormReplenishInvoicePostRequestConfig;

/**
 * 接口 [初始化报销单基础信息V4↗](http://yapi.cai-inc.com/project/3621/interface/api/500466) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v4`
 * @更新时间 `2023-07-12 11:54:12`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormV4PostRequest {
  /**
   * 申请单列表
   */
  applyFormCodeList?: string[];
  /**
   * 票据列表
   */
  invoiceCodeList?: string[];
  /**
   * 监控数据用
   */
  applyFormBusinessCode?: string;
}

/**
 * 接口 [初始化报销单基础信息V4↗](http://yapi.cai-inc.com/project/3621/interface/api/500466) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v4`
 * @更新时间 `2023-07-12 11:54:12`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormV4PostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 基础信息
     */
    basicInfo?: {
      /**
       * 单据类型编号
       */
      businessType?: number;
      /**
       * 单据类型名称
       */
      businessTypeName?: string;
      /**
       * 工作单位ID
       */
      orgId?: number;
      /**
       * 工作单位名称
       */
      orgName?: string;
      /**
       * 工作部门ID
       */
      deptId?: number;
      /**
       * 工作部门名称
       */
      deptName?: string;
      /**
       * 申请事由
       */
      expenseReason?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否是企业用户
       */
      isEnterprise?: boolean;
    };
    /**
     * 收款人信息
     */
    receiverList?: {
      /**
       * 收款记录Code
       */
      receiverCode?: string;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 银行卡信息
       */
      bankCardInfo?: {
        /**
         * 银行卡唯一标识
         */
        accountCode?: string;
        /**
         * 银行代码
         */
        bankCode?: string;
        /**
         * 银行名称
         */
        bankName?: string;
        /**
         * 支行代码
         */
        subBankCode?: string;
        /**
         * 支行名称
         */
        subBankName?: string;
        /**
         * 账户名
         */
        accountName?: string;
        /**
         * 银行账号
         */
        accountNo?: string;
        /**
         * 账号类别
         * 个人卡、公务卡、对公卡
         */
        cardType?: number;
      };
      /**
       * 人员信息
       */
      personInfo?: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId?: number;
        /**
         * 姓名
         */
        userName?: string;
        /**
         * 人员业务类型
         */
        bizType?: 1 | 2 | 3 | 4 | 5 | 6 | 99;
        /**
         * 人员类型
         */
        type?: 0 | 1 | 2 | 3;
        /**
         * 手机号
         */
        mobile?: string;
        /**
         * 人员职级
         */
        userRank?: string;
        /**
         * 人员职级描述
         */
        userRankDesc?: string;
        /**
         * 机构信息
         */
        institution?: {
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
        };
        /**
         * 部门信息
         */
        departmentList?: {
          /**
           * 部门id
           */
          departmentId?: number;
          /**
           * 部门名称
           */
          departmentName?: string;
          /**
           * 子部门信息
           */
          children?: {
            /**
             * 部门id
             */
            departmentId?: number;
            /**
             * 部门名称
             */
            departmentName?: string;
            /**
             * 子部门信息
             */
            children?: {}[];
          }[];
        }[];
      };
      /**
       * 调整信息
       */
      receiverModifyInfo?: {
        /**
         * 调整人名字
         */
        updateOperatorName?: string;
        /**
         * 调整原因
         */
        updateReason?: string;
        /**
         * 调整时间
         */
        updateTime?: string;
        /**
         * 原金额
         */
        originalAmount?: number;
        /**
         * 调整后金额
         */
        updateAmount?: number;
      }[];
    }[];
    /**
     * 申请单数据
     */
    applyFormSimpleInfoList?: {
      /**
       * 申请原因
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 申请用户姓名
       */
      applyUserName?: string;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 申请时间
       */
      initiationDateTime?: string;
      /**
       * 申请单业务编号
       */
      businessCode?: string;
      /**
       * 申请单状态
       */
      formStatus?: 1 | 2 | 3 | 4 | 5;
      /**
       * 出差开始时间
       */
      travelStartTime?: string;
      /**
       * 业务名称：会议名称，培训名称、采购名称
       */
      businessName?: string;
      /**
       * 剩余金额
       */
      applyRemainingAmount?: number;
      /**
       * 数据来源
       */
      dataSource?: number;
      /**
       * 附件列表
       */
      formAttachmentDTO?: {
        /**
         * 默认附件列表
         */
        normalAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 说明附件列表
         */
        thatAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 通知附件列表
         */
        informAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 合同附件列表
         */
        compactAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 签到附件列表
         */
        signAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 派出单位公函附件列表
         */
        officialLetterAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 接待清单附件列表
         */
        receptionMenuAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 采购意向附件列表
         */
        purchasePurposeAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 资产更新计划
         */
        propertyUpdatePlanAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 集体决策会议纪要
         */
        meetingSummaryAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专家论证意见
         */
        argumentSuggestionAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专项、会议、培训附件列表
         */
        specialAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 银行回单附件
         */
        bankReceiptAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 账单附件
         */
        billAttachmentFileList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
      };
      /**
       * 扩展信息
       */
      extendFieldDTO?: {
        /**
         * 差旅扩展字段
         */
        travelExtendFields?: {
          /**
           * 是否派车：1-派车，2-不派车
           */
          arrangeCar?: string;
          /**
           * 派车天数
           */
          dayCount?: number;
          extra?: string;
          /**
           * 差旅报销方式
           */
          travelExpenseMethod?: '由申请单报销' | '凭票报销';
          /**
           * 工号
           */
          workNo?: string;
          /**
           * 是否项目出差
           */
          isProject?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 所属部门
           */
          depName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目名称
           */
          projectName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目负责人
           */
          projectHeader?: {
            key?: string;
            value?: string;
            label?: string;
          };
        };
        /**
         * 会议扩展字段（包含多收款人）
         */
        meetingExtendFields?: {
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 会议名称
           */
          meetingName: string;
          /**
           * 会议地点code
           */
          meetingCityCode?: string;
          /**
           * 会议地点名称
           */
          meetingCityName?: string;
          /**
           * 会议开始日期
           */
          meetingStartDate?: string;
          /**
           * 会议结束日期
           */
          meetingEndDate?: string;
          /**
           * 会议天数
           */
          meetingDayCount?: number;
          /**
           * 会议预计参会人数
           */
          meetingExpectAttendeeCount: number;
          /**
           * 会议实际参会人数
           */
          meetingRealAttendeeCount?: number;
          /**
           * 会议工作人员人数
           */
          meetingWorkerCount?: number;
          /**
           * 参会领导信息
           */
          meetingLeaderInfo?: string;
          /**
           * 会议议程
           */
          meetingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 会议差异内容
           */
          meetingDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
        };
        /**
         * 培训扩展字段（包含多收款人）
         */
        trainingExtendFields?: {
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 培训名称
           */
          trainingName?: string;
          /**
           * 培训地点code
           */
          trainingCityCode?: string;
          /**
           * 培训地点名称
           */
          trainingCityName?: string;
          /**
           * 培训开始日期
           */
          trainingStartDate?: string;
          /**
           * 培训结束日期
           */
          trainingEndDate?: string;
          /**
           * 培训天数
           */
          trainingDayCount?: number;
          /**
           * 培训预计参会人数
           */
          trainingExpectAttendeeCount?: number;
          /**
           * 培训实际参会人数
           */
          trainingRealAttendeeCount?: number;
          /**
           * 培训工作人员人数
           */
          trainingWorkerCount?: number;
          /**
           * 培训议程
           */
          trainingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 培训差异内容
           */
          trainingDifferenceContent?: string;
          /**
           * 培训讲师信息
           */
          trainingTeacherInfo?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: number;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 变更支付方式说明
           */
          changePayModeReason?: string;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
        };
        /**
         * 采购扩展字段
         */
        procurementExtendFields?: {
          /**
           * 采购内容
           */
          procurementContent?: string;
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 费用合计
           */
          applyAmount?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
        };
        /**
         * 公务接待
         */
        receptionExtendFields?: {
          /**
           * 来访单位
           */
          visitOrgName: string;
          /**
           * 是否同城
           * 1-是，2-否
           */
          isSameCity: number;
          /**
           * 来访事由
           */
          visitReason: string;
          /**
           * 来访开始日期
           */
          visitStartDate: string;
          /**
           * 来访结束日期
           */
          visitEndDate: string;
          /**
           * 来访人员级别：1-省部级、2-厅局级、99-其他
           */
          visitorLevel: number;
          /**
           * 来访人员级别名称
           */
          visitorLevelName?: string;
          /**
           * 来访人数
           */
          visitorCount: number;
          /**
           * 接待地点code
           */
          receptionCityCode: string;
          /**
           * 接待地点名称
           */
          receptionCityName: string;
          /**
           * 就餐日期
           */
          mealDate: string;
          /**
           * 工作餐形式：1-自助餐、2-桌餐
           */
          mealType: 1 | 2 | 3;
          /**
           * 工作餐形式
           */
          mealTypeName?: string;
          /**
           * 陪餐人数
           */
          escortCount: number;
        };
        /**
         * 一般事项
         */
        generalExtendFields?: {
          /**
           * 事项详细内容
           */
          detailContent: string;
          /**
           * 事项预算
           */
          eventBudget?: number;
          /**
           * 事项详细内容与事前审批的差异
           */
          generalDifferenceContent?: string;
          extra?: string;
        };
        /**
         * 用印申请
         */
        contractExtendFields?: {
          /**
           * 合同编号
           */
          uniqueCode?: string;
        };
        /**
         * 招标书
         */
        tenderApplyExtendFields?: {
          /**
           * 申请单类型
           */
          applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
          /**
           * 申请事由
           */
          applyReason?: string;
          /**
           * 申请单Code
           */
          applyFormCode?: string;
          /**
           * 业务单据号
           */
          businessCode?: string;
          /**
           * 提交时间
           */
          submitTime?: string;
        };
        /**
         * 通用采购申请拓展字段
         */
        purchaseGeneralFields?: {
          /**
           * 组织形式
           */
          organizationalForm?: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * isCreatePurchaseProposal
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType?: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
        };
        /**
         * 政府购买服务申请拓展字段
         */
        govermentApplyFields?: {
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
        };
        /**
         * 办公家具购置申请拓展字段
         */
        furnitureApplyFields?: {
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
        };
        /**
         * 全链路二期 报销的统一拓展字段
         */
        purchaseGeneralExpenseFieldDTO?: {
          /**
           * 交易方式：线上；线下
           */
          tradeWay?: string[];
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 交易方式
           */
          tradeWayName?: string;
          /**
           * 是否有合同
           */
          addContract?: boolean;
        };
        /**
         * 公共事业缴费统一拓展字段
         */
        publicBusinessPaymentFieldDTO?: {
          /**
           * 备注
           */
          remark?: string;
        };
        generalExtra?: string;
      };
    }[];
    /**
     * 差旅场景：申请单行程拆分结果
     * todo 修改
     */
    applyItinerarySplitList?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
      /**
       * 0：由原行程生成 1：由原行程拆分 2：用户新增
       */
      sourceType?: number;
      /**
       * 校验状态
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 原行程数据
       */
      originalItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: number;
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: number;
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: string;
                /**
                 * 是否可以报销
                 */
                canExpense?: boolean;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: string;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: boolean;
                /**
                 * 规则描述
                 */
                ruleDesc?: string;
                /**
                 * 金额
                 */
                ruleAmount?: number;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程拆分结果
       */
      currentItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: number;
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: number;
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: string;
                /**
                 * 是否可以报销
                 */
                canExpense?: boolean;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: string;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: boolean;
                /**
                 * 规则描述
                 */
                ruleDesc?: string;
                /**
                 * 金额
                 */
                ruleAmount?: number;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程数据校验结果
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: number;
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: number;
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: string;
              /**
               * 是否可以报销
               */
              canExpense?: boolean;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: string;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: boolean;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 金额
               */
              ruleAmount?: number;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
    }[];
    /**
     * 差旅场景：票据生成行程结果
     * todo 修改
     */
    invoiceItinerarySplitList?: {
      /**
       * 出差人列表及其票据信息
       */
      accompanyList?: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 票据信息列表
         */
        invoiceInfoList?: {
          /**
           * 票据code
           */
          invoiceCode?: string;
          /**
           * 票据编号
           */
          invoiceNo?: string;
          /**
           * 票据类型
           */
          invoiceType?: string;
          /**
           * 票据图片地址
           */
          imageUrl?: string;
          /**
           * 浙里办票地址
           */
          zlbImageUrl?: string;
        }[];
      }[];
      /**
       * 是否派车 0 否 1是
       */
      arrangeCar?: number;
      /**
       * 住宿天数
       */
      accommodationDay?: number;
      /**
       * 开始时间
       */
      beginTime?: string;
      /**
       * 开始上下午
       */
      beginTag?: 0 | 1 | 2 | 3;
      /**
       * 结束时间
       */
      endTime?: string;
      /**
       * 结束上下午
       */
      endTag?: 0 | 1 | 2 | 3;
      /**
       * 出差天数
       */
      travelDay?: number;
      /**
       * 出发地code
       */
      beginCityCode?: string;
      /**
       * 出发地名称
       */
      beginCityName?: string;
      /**
       * 出发地code
       */
      endCityCode?: string;
      /**
       * 出发地名称
       */
      endCityName?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [初始化报销单基础信息V4↗](http://yapi.cai-inc.com/project/3621/interface/api/500466) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v4`
 * @更新时间 `2023-07-12 11:54:12`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInitExpenseFormV4PostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/init-expense-form/v4',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [初始化报销单基础信息V4↗](http://yapi.cai-inc.com/project/3621/interface/api/500466) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v4`
 * @更新时间 `2023-07-12 11:54:12`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInitExpenseFormV4PostRequestConfig: ZlbApiExpenseExpenseFormInitExpenseFormV4PostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/init-expense-form/v4',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInitExpenseFormV4Post',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化报销单基础信息V4↗](http://yapi.cai-inc.com/project/3621/interface/api/500466) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/v4`
 * @更新时间 `2023-07-12 11:54:12`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInitExpenseFormV4Post = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInitExpenseFormV4PostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInitExpenseFormV4PostResponse>(
    prepare(zlbApiExpenseExpenseFormInitExpenseFormV4PostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInitExpenseFormV4Post.requestConfig =
  zlbApiExpenseExpenseFormInitExpenseFormV4PostRequestConfig;

/**
 * 接口 [撤回支付↗](http://yapi.cai-inc.com/project/3621/interface/api/502458) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cancel-pay`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCancelPayPostRequest {
  /**
   * 报销单号
   */
  expenseFormCode: string;
  /**
   * 支付记录code(多收款人模式必填)
   */
  payRecordCode?: string;
  /**
   * 收款人code(单收款人模式必填)
   */
  receiverCode?: string;
}

/**
 * 接口 [撤回支付↗](http://yapi.cai-inc.com/project/3621/interface/api/502458) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cancel-pay`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCancelPayPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [撤回支付↗](http://yapi.cai-inc.com/project/3621/interface/api/502458) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cancel-pay`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormCancelPayPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/cancel-pay',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [撤回支付↗](http://yapi.cai-inc.com/project/3621/interface/api/502458) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cancel-pay`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormCancelPayPostRequestConfig: ZlbApiExpenseExpenseFormCancelPayPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/cancel-pay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormCancelPayPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [撤回支付↗](http://yapi.cai-inc.com/project/3621/interface/api/502458) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cancel-pay`
 * @更新时间 `2024-12-11 15:42:26`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormCancelPayPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormCancelPayPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormCancelPayPostResponse>(
    prepare(zlbApiExpenseExpenseFormCancelPayPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormCancelPayPost.requestConfig =
  zlbApiExpenseExpenseFormCancelPayPostRequestConfig;

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515346) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/invoice-page`
 * @更新时间 `2023-08-15 15:51:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInvoicePagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 交易信息编码
   */
  tradeCode?: string;
}

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515346) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/invoice-page`
 * @更新时间 `2023-08-15 15:51:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInvoicePagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 原图
       */
      originalAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 原始图片地址
       */
      originalUrl?: string;
      /**
       * 版式文件
       */
      formatAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 版式文件图片地址
       */
      formatUrl?: string;
      /**
       * 文件类型
       */
      fileType?: string;
      /**
       * 票据种类
       */
      invoiceType?: string;
      /**
       * 票据种类描述
       */
      invoiceTypeDesc?: string;
      /**
       * 开票日期
       */
      issueDate?: string;
      /**
       * 验真状态
       */
      realStatus?: number;
      /**
       * 验真状态描述
       */
      realStatusDesc?: string;
      /**
       * 消费金额
       */
      totalAmount?: number;
      /**
       * 平台发票id
       */
      platformInvoiceId?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderCode?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderId?: number;
      /**
       * 发票代码
       */
      invoiceCode?: string;
      /**
       * 发票号码
       */
      invoiceNo?: string;
      /**
       * 票据来源
       */
      dataSource?: string;
      /**
       * 发票图片地址
       */
      imageUrl?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515346) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/invoice-page`
 * @更新时间 `2023-08-15 15:51:38`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInvoicePagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/invoice-page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515346) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/invoice-page`
 * @更新时间 `2023-08-15 15:51:38`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInvoicePagePostRequestConfig: ZlbApiExpenseExpenseFormInvoicePagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/invoice-page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInvoicePagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515346) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/invoice-page`
 * @更新时间 `2023-08-15 15:51:38`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInvoicePagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInvoicePagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInvoicePagePostResponse>(
    prepare(zlbApiExpenseExpenseFormInvoicePagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInvoicePagePost.requestConfig =
  zlbApiExpenseExpenseFormInvoicePagePostRequestConfig;

/**
 * 接口 [校验报销单是否可以审核-财务审核前调用↗](http://yapi.cai-inc.com/project/3621/interface/api/519002) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/check`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCheckPostRequest {
  /**
   * 报销单Code
   */
  expenseFormCode: string;
  /**
   * 报销收款人数据
   */
  expenseFormReceiverPOS: {
    /**
     * 操作人ID
     */
    operatorId: number;
    /**
     * 账号code
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount: number;
    /**
     * 原收款金额
     */
    originalAmount?: number;
    /**
     * 收款人姓名
     */
    receiverName: string;
    /**
     * 前端数组下标
     */
    indexNo: string;
    /**
     * 收款人Code
     */
    receiverCode?: string;
    /**
     * 调整原因
     */
    updateReason?: string;
    /**
     * 费用更新金额
     */
    modifyFeeAmountDTO?: {
      /**
       * 原始金额
       */
      originalAmount: number;
      /**
       * 修改后金额
       */
      updateAmount: number;
      /**
       * 修改备注
       */
      updateReason?: string;
      /**
       * 原始账户
       */
      originalAccount?: string;
      /**
       * 修改后账户
       */
      updateAccount?: string;
    };
    /**
     * 人员来源 1-系统内部；2-外部人员
     */
    userSource?: 1 | 2;
    userType?: number;
    /**
     * 用户类型
     */
    type?: number;
    /**
     * 类型
     */
    fundsObjectType?:
      | 1
      | 11
      | 12
      | 13
      | 14
      | 19
      | 2
      | 21
      | 22
      | 23
      | 24
      | 3
      | 31
      | 32
      | 4
      | 41
      | 42;
  }[];
  /**
   * 付款人数据,当为自有基金支付的时候，付款账户数据不能为空
   */
  expenseFormPayAccountPO?: {
    /**
     * 付款账户accountCode，传递支付系统的银行卡的accountCode
     */
    accountCode: string;
    /**
     * 付款金额
     */
    payAmount: number;
  };
  /**
   * 费用数据列表
   */
  expenseFeeExtendPOS?: {
    indexNo: string;
    /**
     * 费用集合
     */
    expenseFeePOS: {
      /**
       * 唯一标识
       */
      indexNo: string;
      /**
       * 记录的费用code
       */
      feeCode?: string;
      /**
       * 记录的费用名称，用于自定义
       */
      feeName?: string;
      /**
       * 所属机构id
       */
      operatorOrgId?: number;
      /**
       * 所属机构名称
       */
      operatorOrgName?: string;
      /**
       * 费用类型
       */
      feeType: number;
      /**
       * 费用发生时间
       */
      consumeTime: string;
      /**
       * 货币金额
       */
      amount: number;
      /**
       * 消费城市区划
       */
      districtCode?: string;
      /**
       * 消费城市名称
       */
      districtName?: string;
      /**
       * 关联的发票编号
       */
      invoiceCodes: string[];
      /**
       * 关联的出差人
       */
      accompanyPerson?: {
        /**
         * 人员id
         */
        operatorId: number;
        /**
         * 人员名称
         */
        operatorName: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
         */
        userType?: number;
        userId?: number;
        userName?: string;
        bankCardInfo?: {
          /**
           * 银行代码
           */
          bankCode: string;
          /**
           * 银行名字
           */
          bankName: string;
          /**
           * 账户名称
           */
          accountName: string;
          /**
           * 银行账号
           */
          bankAccount: string;
          /**
           * 银行账号 脱敏
           */
          bankAccountDesc?: string;
          /**
           * 卡号保存的唯一标识
           */
          accountCode?: string;
        };
        /**
         * 同一个人员，绑定的id
         */
        bindOperatorId?: number;
        /**
         * 用户类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type: number;
        /**
         * 用户职级,
         * 内部用户的职级，外部用户关联内部用户，取内部用户职级
         * 否则去外部用户职级
         */
        userRank?: string;
        /**
         * 手机号
         */
        mobile?: string;
        /**
         * 证件号码
         */
        idCard?: string;
        /**
         * 证件类型
         */
        idType?: number;
        /**
         * 性别
         */
        gender?: number;
        /**
         * 同行人费用code
         */
        feeCode?: string;
      }[];
      /**
       * 材料数据
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
          /**
           * 原始金额
           */
          originalAmount?: number;
        }[];
      };
      /**
       * 费用附件
       */
      attachments: {
        fileId: string;
        fileType?: string;
        fileName: string;
        fileSize?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        downloadUrl?: string;
      }[];
      /**
       * 关联的单号
       */
      formCode?: string;
      /**
       * 单据类型：1-申请单，2-报销单
       */
      formType?: number;
      /**
       * 修改金额历史
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 原始的feeRecordId
       */
      originalFeeId?: number;
      /**
       * 平台订单编号
       */
      platformOrderNo?: string;
      /**
       * 明细说明
       */
      remark?: string;
      /**
       * 明细数据
       */
      detailExtendDTO?: {
        /**
         * 详细列表页
         */
        expenseFeeDetailInfoList?: {
          /**
           * 前端需要参数
           */
          indexNo?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          userType?: number;
          type?: number;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 原始信息（当前补贴）
           */
          originalInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
          /**
           * 重复补贴
           */
          conflictInfoList?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          }[];
          /**
           * 费用种类
           */
          feeCategory?: number;
          /**
           * 实际补贴金额
           */
          amount?: number;
          /**
           * 原始计算金额
           */
          originalAmount?: number;
          /**
           * 调整前金额
           */
          beforeChangeAmount?: number;
          /**
           * 冲突的金额
           */
          conflictAmount?: number;
          /**
           * 扣减金额
           */
          reductionAmount?: number;
          /**
           * 最大允许金额
           */
          allowMaxAmount?: number;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否发生变更
           */
          isChanged?: boolean;
        }[];
        /**
         * 冲突展示列表页
         */
        expenseFeeConflictList?: {
          /**
           * 业务编码
           */
          businessCode?: string;
          /**
           * 单据编号
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: number;
          /**
           * 业务类型
           */
          businessType?: number;
          /**
           * 业务类型描述
           */
          businessTypeDesc?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 冲突信息
           */
          conflictInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
        }[];
        /**
         * 调整后金额
         */
        currentAmount?: number;
        /**
         * 原始金额
         */
        originalAmount?: number;
        /**
         * 费用类型
         */
        feeType?: number;
        /**
         * 火车金额
         */
        trainAmount?: number;
        /**
         * 总金额相等
         */
        totalAmountEquals?: boolean;
      };
      /**
       * 交易信息编码 for 会议培训多收款人
       */
      tradeCode?: string;
    }[];
    feeParentType: number;
    totalAmount: number;
    currencyCode?: string;
  }[];
  /**
   * 收款总金额
   */
  totalAmount: number;
  /**
   * 预算指标信息
   */
  budgetInfoPO?: {
    /**
     * 主预算编号
     */
    mainBudgetCode: number;
    /**
     * 预算指标编号
     */
    budgetUk: string;
    /**
     * 支付限额经济分类主键
     */
    budgetPlanClassifyUk: string;
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 交易信息 for 会议/培训多收款人
     */
    tradeCode?: string;
    /**
     * 支付记录信息code
     */
    payRecordCode?: string;
  }[];
  /**
   * 预算额度信息
   */
  quotaInfoPO?: {
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 预算额度id
     */
    budgetQuotaId: string;
    /**
     * 交易信息 for 会议/培训多收款人
     */
    tradeCode?: string;
    /**
     * 支付记录信息code
     */
    payRecordCode?: string;
  }[];
  /**
   * 是否忽略警告
   */
  isIgnoreWarning?: boolean;
  /**
   * 费用总金额
   */
  feeTotalAmount: number;
  /**
   * 综合定额费用
   */
  mixFeeTotalAmount?: number;
  /**
   * 是否需要忽略费控校验
   */
  needIgnoreCheckFee?: boolean;
  /**
   * 支付方式(1：国库支付，3：非财政资金网银结算，4：库集中支付+非财政资金结算
   */
  payMode?: number;
  /**
   * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
   * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
   */
  payStrategy?: number;
  /**
   * 变更支付方式说明
   */
  changePayModeReason?: string;
  /**
   * 摘要
   */
  summary?: string;
  /**
   * 单据附件
   */
  formAttachmentDTO?: {
    /**
     * 默认附件列表
     */
    normalAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 说明附件列表
     */
    thatAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 通知附件列表
     */
    informAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 合同附件列表
     */
    compactAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 签到附件列表
     */
    signAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 派出单位公函附件列表
     */
    officialLetterAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 接待清单附件列表
     */
    receptionMenuAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 采购意向附件列表
     */
    purchasePurposeAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 资产更新计划
     */
    propertyUpdatePlanAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 集体决策会议纪要
     */
    meetingSummaryAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专家论证意见
     */
    argumentSuggestionAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专项、会议、培训附件列表
     */
    specialAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 银行回单附件
     */
    bankReceiptAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 账单附件
     */
    billAttachmentFileList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  };
  /**
   * 宁波收款明细PO
   */
  receiverPayInfoQueryList?: {
    /**
     * 收款卡基本信息
     */
    receiverPO?: {
      /**
       * 操作人ID
       */
      operatorId: number;
      /**
       * 账号code
       */
      accountCode?: string;
      /**
       * 收款金额
       */
      amount: number;
      /**
       * 原收款金额
       */
      originalAmount?: number;
      /**
       * 收款人姓名
       */
      receiverName: string;
      /**
       * 前端数组下标
       */
      indexNo: string;
      /**
       * 收款人Code
       */
      receiverCode?: string;
      /**
       * 调整原因
       */
      updateReason?: string;
      /**
       * 费用更新金额
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 人员来源 1-系统内部；2-外部人员
       */
      userSource?: 1 | 2;
      userType?: number;
      /**
       * 用户类型
       */
      type?: number;
      /**
       * 类型
       */
      fundsObjectType?:
        | 1
        | 11
        | 12
        | 13
        | 14
        | 19
        | 2
        | 21
        | 22
        | 23
        | 24
        | 3
        | 31
        | 32
        | 4
        | 41
        | 42;
    };
    /**
     * 个人卡报销
     */
    personalCardExpenseQueryList?: {
      /**
       * 前端下标
       */
      indexNo: string;
      /**
       * 消费金额
       */
      amount?: number;
      /**
       * 拆分的金额
       */
      splitAmount?: number[];
      /**
       * 报销里的消费记录主键
       */
      consumptionRecordCode?: string;
      /**
       * 拆分金额
       */
      splitAmountDetail?: {
        /**
         * 拆分金额
         */
        amount: number;
        /**
         * 支付类型
         */
        payStrategy:
          | 'FINA_ZERO_PAY'
          | 'UNIT_ZERO_PAY'
          | 'UNIT_FUND_PAY'
          | 'FINA_SPLIT_PAY'
          | 'AUTH_NORMAL_PAY'
          | 'DIRECTLY_NORMAL_PAY'
          | 'AUTH_BUSINESS_CARD_PAY'
          | 'AUTH_PERSONAL_BATCH_PAY'
          | 'AUTH_ENTERPRISE_BATCH_PAY'
          | 'FINA_AND_FUND_PAY'
          | 'UNIT_FUND_NORMAL_PAY'
          | 'UNIT_FUND_OFF_CARD_PAY'
          | 'NB_FINA_ZERO_PAY'
          | 'NB_UNIT_ZERO_PAY'
          | 'NB_UNIT_FUND_PAY'
          | 'NB_FINA_SPLIT_PAY'
          | 'CBS_NORMAL_PAY'
          | 'CBS_BATCH_PAY';
        /**
         * 支付类型名称
         */
        payStrategyName?: string;
      }[];
    }[];
  }[];
  /**
   * 预算关联关系
   * 目前存在情况，在财务审核时，预算可以直接与单据关联，也可以与收款人关联（一般事项多收款），后续也有其他关联
   * 注意：当前字段只有在一般事项多收款人（坑中坑注意！！！）
   */
  budgetRelationInfoPOList?: {
    /**
     * 关联预算的Code
     */
    budgetRelationBusinessCode: string;
    /**
     * 关联预算业务数据类型
     * EXPENSE_FORM(1, "报销单"),
     * TRADE(2, "交易"),
     * ACCOUNT(3, "收款账户"),
     */
    relationBusinessType:
      | '报销单'
      | '交易'
      | '收款账户'
      | '工资流水'
      | '夜餐费发放单'
      | '项目支付单';
    /**
     * TRUE使用指标，FALSE使用额度
     */
    budgetFlag: boolean;
    /**
     * 预算指标信息
     */
    budgetInfoPOList?: {
      /**
       * 主预算编号
       */
      mainBudgetCode: number;
      /**
       * 预算指标编号
       */
      budgetUk: string;
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk: string;
      /**
       * 预算金额
       */
      budgetAmount: number;
      /**
       * 交易信息 for 会议/培训多收款人
       */
      tradeCode?: string;
      /**
       * 支付记录信息code
       */
      payRecordCode?: string;
    }[];
    /**
     * 预算额度信息
     */
    quotaInfoPOList?: {
      /**
       * 预算金额
       */
      budgetAmount: number;
      /**
       * 预算额度id
       */
      budgetQuotaId: string;
      /**
       * 交易信息 for 会议/培训多收款人
       */
      tradeCode?: string;
      /**
       * 支付记录信息code
       */
      payRecordCode?: string;
    }[];
  }[];
  /**
   * 工作流业务属性
   */
  workflowBizProperties?: {
    /**
     * 修改费用标记
     */
    editableAmount?: number;
  };
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
    /**
     * 科目级联uk
     */
    subjectUkHierarchy?: string[];
    /**
     * 科目级联
     */
    subjectNameHierarchy?: string[];
  }[];
  /**
   * 包干经费预算
   */
  fundBudget?: {
    /**
     * 是否包干经费 true=是 false=否
     */
    isFundBudget?: null;
    /**
     * 包干经费预算uk
     */
    fundBudgetUk?: null;
    /**
     * 包干经费预算名称
     */
    fundBudgetName?: null;
    /**
     * 经费uk
     */
    fundBudgetItemUk?: null;
    /**
     * 经费名称
     */
    fundBudgetItemName?: null;
    /**
     * 占用金额
     */
    usedAmount?: null;
  };
  /**
   * 通用扩展字段
   */
  generalExtra?: string;
  /**
   * 其他资金明细列表
   */
  restDetailList?: {
    indexNo?: string;
    restDetailCode?: string;
    summary: string;
    deptName?: string;
    deptId?: number;
    actSubjectCode: string;
    actSubjectName: string;
    depEconomicClassifyCode?: string;
    depEconomicClassifyName?: string;
    expendFunctionClassifySubjectCode?: string;
    expendFunctionClassifySubjectName?: string;
    projectCode?: string;
    projectName?: string;
    budgetUk?: string;
    fundAttrType: number;
    budgetAmount: number;
    ledgerFormCode?: string;
  }[];
  /**
   * 会计科目-本方科目
   */
  actSubjectCode?: string;
  /**
   * 会计科目名称-本方科目
   */
  actSubjectName?: string;
  /**
   * 是否启用核算（其他资金，如若扩展则可增加）:0-否,1-是
   */
  isEnableAccount?: number;
}

/**
 * 接口 [校验报销单是否可以审核-财务审核前调用↗](http://yapi.cai-inc.com/project/3621/interface/api/519002) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/check`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCheckPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态 0：通过 1：警告 2：强控 3 提示
     */
    checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
    /**
     * 行程冲突校验结果
     */
    itineraryCheckResultRO?: {
      /**
       * 所有行程是否通过行程校验
       * 通过：0
       */
      checkStatus?: number;
      /**
       * 报销单行程校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 行程数组索引
         */
        indexNo?: string;
        /**
         * 每段行程的提示文案及校验状态
         */
        itineraryCheckResultList?: {
          /**
           * 校验状态
           * 0-通过 1-弱控 2-强控 3-提示
           */
          checkStatus?: 0 | 1 | 2 | 3;
          /**
           * 提示文案
           */
          message?: string;
        }[];
      }[];
      /**
       * 整体提示信息
       * 暂时仅有不足申请单的部分有赋值
       */
      overallCheckResult?: {
        /**
         * 校验状态
         * 0-通过 1-弱控 2-强控 3-提示
         */
        checkStatus?: 0 | 1 | 2 | 3;
        /**
         * 提示文案
         */
        message?: string;
      };
    };
    /**
     * 费用校验结果
     */
    feeCheckResultRO?: {
      /**
       * 所有费用校验状态
       */
      feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 费控校验详情信息
       */
      checkResultInfoExtendROS?: {
        /**
         * 下标
         */
        indexNo?: string;
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示消息
         */
        msg?: string[];
        /**
         * 分组的整体校验结果
         */
        overallCheckMessageMap?: {
          key?: string[];
        };
        /**
         * 超标文案消息实体 since 20220519 五月迭代一期
         */
        messageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 分组的整体,细项
         */
        overallControlMessageMap?: {
          key?: {
            /**
             * 唯一键
             */
            uniqueKey?: string;
            /**
             * 错误信息
             */
            message?: string;
            /**
             * 规则
             */
            ruleInfo?: string;
            /**
             * 校验结果
             */
            checkStatus?: number;
          }[];
        };
        /**
         * 校验提示语
         */
        checkResultMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 一般校验提示语
         */
        roughHintsMessageList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示信息
           */
          msg?: string;
        }[];
        /**
         * 分组校验结果集合
         */
        expenseFeeCheckResultInfoROList?: {
          /**
           * 费控状态
           */
          feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 费用code
           */
          feeCode?: string;
          /**
           * 费用规则详情
           */
          feeCheckRuleInfo?: string;
          /**
           * 提示消息
           */
          msg?: string[];
          /**
           * 唯一标识
           */
          indexNo?: string;
          /**
           * 细项的整体校验结果
           */
          itemOverallCheckMessageMap?: {
            key?: string;
          };
          /**
           * 细项的整体校验结果
           * <规则，提示文案>
           */
          itemOverallCheckResultMap?: {
            key?: boolean;
          };
          /**
           * 细项规则
           */
          itemOverallControlMessageDTO?: {
            key?: {
              /**
               * 唯一键
               */
              uniqueKey?: string;
              /**
               * 错误信息
               */
              message?: string;
              /**
               * 规则
               */
              ruleInfo?: string;
              /**
               * 校验结果
               */
              checkStatus?: number;
            }[];
          };
          /**
           * 超标文案消息实体 since 20220519 五月迭代一期
           */
          messageRO?: {
            /**
             * 提示状态
             */
            tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 提示文案
             */
            tipText?: string;
            /**
             * 提示消息
             */
            tipMsg?: string[];
            /**
             * 消息和类型
             */
            tipLists?: {
              /**
               * 规则强弱控
               */
              checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
              /**
               * 规则强弱控描述
               */
              msg?: string;
              /**
               * 规则code
               */
              ruleCode?: string;
            }[];
            /**
             * 单独为前端提示方便添加（不要动，虽然很愚蠢）
             */
            invoiceTipMsg?: string[];
            /**
             * 设置结果
             */
            resultInfo?: {
              /**
               * 凭票报销总结果
               */
              expenseFeeInvoiceResult?: {
                /**
                 * 用户id
                 */
                operatorId?: number;
                /**
                 * 用户名称
                 */
                operatorName?: string;
                /**
                 * 报销金额
                 */
                amount?: number;
                /**
                 * 报销金额描述
                 */
                amountDesc?: string;
                /**
                 * 详细信息
                 */
                detailInfoList?: {
                  /**
                   * 发生日期
                   */
                  happenDate?: null;
                  /**
                   * 是否可以报销
                   */
                  canExpense?: null;
                  /**
                   * 表单code
                   */
                  formCode?: string[];
                  /**
                   * 业务code
                   */
                  businessCode?: string[];
                  /**
                   * 冲突描述
                   */
                  conflictDesc?: null;
                  /**
                   * 是否凭票报销冲突
                   */
                  isUseInvoice?: null;
                  /**
                   * 规则描述
                   */
                  ruleDesc?: null;
                  /**
                   * 金额
                   */
                  ruleAmount?: null;
                }[];
              }[];
              /**
               * 凭票报销总结果提示
               */
              expenseFeeInvoiceTips?: string;
              /**
               * 是否展示
               */
              canShow?: boolean;
            };
            /**
             * 是否需要显示
             */
            canShow?: boolean;
          };
        }[];
        /**
         * 费用规则详情
         */
        feeRuleInfoDTO?: {
          /**
           * 金额上线
           */
          maxAmount?: number;
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 规则标准描述
           */
          ruleStandardDesc?: string;
        };
        /**
         * 分组code
         */
        groupCode?: string;
        /**
         * 费用父级code
         */
        feeParentType?: number;
        /**
         * 费用父级描述
         */
        feeParentTypeDesc?: string;
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 费控规则及提示文案
       * Map中的key参见 以下枚举类的code
       */
      overallCheckMessageMap?: {
        key?: string[];
      };
      /**
       * 细项规则
       */
      overallControlMessageMap?: {
        key?: {
          /**
           * 唯一键
           */
          uniqueKey?: string;
          /**
           * 错误信息
           */
          message?: string;
          /**
           * 规则
           */
          ruleInfo?: string;
          /**
           * 校验结果
           */
          checkStatus?: number;
        }[];
      };
      /**
       * 结果数据
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 费用规则详情
       */
      feeRuleInfoDTO?: {
        /**
         * 金额上线
         */
        maxAmount?: number;
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 规则标准描述
         */
        ruleStandardDesc?: string;
      };
      /**
       * 校验提示语
       */
      checkResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
      /**
       * 一般校验提示语
       */
      roughHintsMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示信息
         */
        msg?: string;
      }[];
    };
    /**
     * 预算校验结果
     */
    budgetCheckResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
      /**
       * 预算指标ID
       */
      mainBudgetCode?: number;
      /**
       * 预算指标编号
       */
      budgetUk?: string;
      /**
       * 预算编号(展示)
       */
      financialBudgetDetailId?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 额度ID
       */
      budgetQuotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag?: boolean;
      /**
       * 占用总金额
       */
      budgetTotalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 关联预算的业务信息
       */
      budgetExceptionTipsROS?: {
        /**
         * 关联预算的Code
         */
        budgetRelationBusinessCode?: string;
        /**
         * 关联预算的业务名称描述
         */
        budgetRelationBusinessDesc?: string;
        /**
         * 关联交易描述
         */
        tradeDesc?: string;
        /**
         * 关联预算业务数据类型
         * 直接以枚举的名称作为存储，以便在请求中可以直接看出
         */
        relationBusinessType?:
          | '报销单'
          | '交易'
          | '收款账户'
          | '工资流水'
          | '夜餐费发放单'
          | '项目支付单';
        /**
         * 占用的金额
         */
        budgetAmount?: number;
      }[];
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 预算项目校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 科目校验描述
         */
        subjectCheckDesc?: string;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
      }[];
    };
    /**
     * 收款信息校验结果
     */
    receiverCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 收款信息校验详情
       */
      checkResultInfoROS?: {
        /**
         * 是否通过校验
         */
        checkStatus?: number;
        /**
         * 收款人信息数组下标
         */
        indexNo?: string;
        /**
         * 提示消息
         */
        msg?: string[];
      }[];
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 支付方式校验结果
     */
    payConfigCheckResultRO?: {
      /**
       * 所有收款信息是否通过校验
       */
      checkStatus?: number;
      /**
       * 提示消息
       */
      msg?: string[];
    };
    /**
     * 费控规则提示
     */
    feeCheckRuleROS?: {
      /**
       * 费控状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 提示信息
       */
      msg?: string;
      /**
       * 原因
       */
      reason?: string;
    }[];
    /**
     * 订单校验结果
     */
    orderCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 报销单号
     */
    expenseFormCode?: string;
    /**
     * 合同校验结果
     */
    contractCheckResultROS?: {
      /**
       * 费控状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 提示信息
       */
      msg?: string;
    }[];
    /**
     * 发票校验结果
     */
    invoiceCheckResultROS?: {
      /**
       * 发票ID
       */
      platformInvoiceId?: string;
      /**
       * 状态码
       */
      code?: number;
      /**
       * 是否可报销 true：可以报销 false：不可以报销
       */
      success?: boolean;
      /**
       * 提示消息
       */
      msg?: string;
    }[];
    /**
     * 超标原因配置
     */
    reasonConfigROS?: {
      /**
       * 状态
       */
      checkStatus?: number;
      /**
       * 规则列表
       */
      ruleInfoROS?: {
        /**
         * 规则描述
         */
        ruleDesc?: string;
        /**
         * 规则code
         */
        ruleCode?: string;
        /**
         * 状态
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      }[];
      /**
       * 超标配置列表
       */
      reasonConfigList?: {
        /**
         * 校验结果分组code
         */
        checkGroupCode?: string;
        /**
         * 父标题
         */
        parentTitle?: string;
        /**
         * 子标题
         */
        subTitle?: string;
        /**
         * 合并code
         */
        mergeGroupCode?: string;
        /**
         * 是否必填
         */
        isMust?: number;
        /**
         * 备注长度
         */
        remarkLength?: number;
      }[];
    };
    /**
     * 含有异常申请单的列表（校验通过时为空数组）
     */
    applyFormCheckResultROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 检查结果
       */
      checkResult?: 0 | 1 | 2;
      /**
       * 检查结果描述
       */
      checkResultDesc?: '通过' | '已作废' | '已关联';
      /**
       * 被关联的其他报销单号
       */
      certainExpenseFormCode?: string[];
    }[];
    /**
     * 其他资金校验
     */
    restFundCheckRO?: {
      /**
       * 基础校验
       */
      baseControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string[];
      };
      /**
       * 资金控制校验
       */
      fundControlCheck?: {
        /**
         * 校验状态 0：通过 1：警告 2：强控 3 提示
         */
        checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 校验信息
         */
        checkMessage?: string;
        /**
         * 校验公共参数
         */
        checkList?: {
          indexNo?: string;
          checkStatus?: number;
          checkMessage?: string;
          extraJson?: string;
          bindCount?: number;
        }[];
      };
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [校验报销单是否可以审核-财务审核前调用↗](http://yapi.cai-inc.com/project/3621/interface/api/519002) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/check`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [校验报销单是否可以审核-财务审核前调用↗](http://yapi.cai-inc.com/project/3621/interface/api/519002) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/check`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormCheckPostRequestConfig: ZlbApiExpenseExpenseFormCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验报销单是否可以审核-财务审核前调用↗](http://yapi.cai-inc.com/project/3621/interface/api/519002) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/check`
 * @更新时间 `2024-12-11 15:42:23`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormCheckPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormCheckPostResponse>(
    prepare(zlbApiExpenseExpenseFormCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormCheckPost.requestConfig = zlbApiExpenseExpenseFormCheckPostRequestConfig;

/**
 * 接口 [财务-查询可以订正的收款账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545314) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/cashier-info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGetRequest {
  /**
   * 报销单code
   */
  expenseFormCode: string;
}

/**
 * 接口 [财务-查询可以订正的收款账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545314) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/cashier-info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 订正的账户集合
     */
    corrAcctList?: {
      /**
       * 复核记录唯一编号
       */
      recheckCode?: string;
      /**
       * 户名
       */
      receiverName?: string;
      /**
       * 订正前的账户
       */
      before?: {
        /**
         * 账户唯一编码
         */
        accountCode?: string;
        cardType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 开户行
         */
        bankName?: string;
        /**
         * 行号
         */
        bankNo?: string;
        /**
         * 银行编码
         */
        bankCode?: string;
        /**
         * 账号
         */
        accountNo?: string;
      };
      /**
       * 订正后的账户
       */
      after?: {
        /**
         * 账户唯一编码
         */
        accountCode?: string;
        cardType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 开户行
         */
        bankName?: string;
        /**
         * 行号
         */
        bankNo?: string;
        /**
         * 银行编码
         */
        bankCode?: string;
        /**
         * 账号
         */
        accountNo?: string;
      };
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [财务-查询可以订正的收款账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545314) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/cashier-info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/cashier-info/corr-acct/query',
    'data',
    string,
    'expenseFormCode',
    false
  >
>;

/**
 * 接口 [财务-查询可以订正的收款账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545314) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/cashier-info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGetRequestConfig: ZlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/cashier-info/corr-acct/query',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: ['expenseFormCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [财务-查询可以订正的收款账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545314) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/cashier-info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGetResponse>(
    prepare(zlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGet.requestConfig =
  zlbApiExpenseExpenseFormCashierInfoCorrAcctQueryGetRequestConfig;

/**
 * 接口 [财务-订正账户提交↗](http://yapi.cai-inc.com/project/3621/interface/api/545322) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier-info/corr-acct/submit`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPostRequest {
  /**
   * 必填，报销单号
   */
  expenseFormCode: string;
  /**
   * 必填，可订正的账户集合
   */
  corrAccList?: {
    /**
     * 可选，经办人确认订正必传，复核记录唯一编号
     */
    recheckCode?: string;
    /**
     * 必填，订正前的账户
     */
    before?: {
      /**
       * 必填，账户唯一编码
       */
      accountCode?: string;
    };
    /**
     * 必填，订正后的账户
     */
    after?: {
      cardType?: number;
      /**
       * 必填，开户行
       */
      bankName?: string;
      /**
       * 非供应商账户必填，行号
       */
      bankNo?: string;
      /**
       * 非供应商账户必填，银行编码
       */
      bankCode?: string;
      /**
       * 必填，账号
       */
      accountNo?: string;
    };
  }[];
}

/**
 * 接口 [财务-订正账户提交↗](http://yapi.cai-inc.com/project/3621/interface/api/545322) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier-info/corr-acct/submit`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [财务-订正账户提交↗](http://yapi.cai-inc.com/project/3621/interface/api/545322) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier-info/corr-acct/submit`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/cashier-info/corr-acct/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [财务-订正账户提交↗](http://yapi.cai-inc.com/project/3621/interface/api/545322) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier-info/corr-acct/submit`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPostRequestConfig: ZlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/cashier-info/corr-acct/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [财务-订正账户提交↗](http://yapi.cai-inc.com/project/3621/interface/api/545322) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/cashier-info/corr-acct/submit`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPostResponse>(
    prepare(zlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPost.requestConfig =
  zlbApiExpenseExpenseFormCashierInfoCorrAcctSubmitPostRequestConfig;

/**
 * 接口 [经办人-查询待复核的订正账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545330) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInfoCorrAcctQueryGetRequest {
  /**
   * 报销单code
   */
  expenseFormCode: string;
}

/**
 * 接口 [经办人-查询待复核的订正账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545330) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInfoCorrAcctQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 订正的账户集合
     */
    corrAcctList?: {
      /**
       * 复核记录唯一编号
       */
      recheckCode?: string;
      /**
       * 户名
       */
      receiverName?: string;
      /**
       * 订正前的账户
       */
      before?: {
        /**
         * 账户唯一编码
         */
        accountCode?: string;
        cardType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 开户行
         */
        bankName?: string;
        /**
         * 行号
         */
        bankNo?: string;
        /**
         * 银行编码
         */
        bankCode?: string;
        /**
         * 账号
         */
        accountNo?: string;
      };
      /**
       * 订正后的账户
       */
      after?: {
        /**
         * 账户唯一编码
         */
        accountCode?: string;
        cardType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 开户行
         */
        bankName?: string;
        /**
         * 行号
         */
        bankNo?: string;
        /**
         * 银行编码
         */
        bankCode?: string;
        /**
         * 账号
         */
        accountNo?: string;
      };
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [经办人-查询待复核的订正账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545330) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInfoCorrAcctQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/info/corr-acct/query',
    'data',
    string,
    'expenseFormCode',
    false
  >
>;

/**
 * 接口 [经办人-查询待复核的订正账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545330) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInfoCorrAcctQueryGetRequestConfig: ZlbApiExpenseExpenseFormInfoCorrAcctQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/info/corr-acct/query',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: ['expenseFormCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInfoCorrAcctQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [经办人-查询待复核的订正账户列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545330) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/info/corr-acct/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInfoCorrAcctQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInfoCorrAcctQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInfoCorrAcctQueryGetResponse>(
    prepare(zlbApiExpenseExpenseFormInfoCorrAcctQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInfoCorrAcctQueryGet.requestConfig =
  zlbApiExpenseExpenseFormInfoCorrAcctQueryGetRequestConfig;

/**
 * 接口 [经办人-确认订正信息↗](http://yapi.cai-inc.com/project/3621/interface/api/545338) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/info/corr-acct/confirm`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInfoCorrAcctConfirmPostRequest {
  /**
   * 必填，报销单号
   */
  expenseFormCode: string;
  /**
   * 可订正的账户集合
   */
  corrAccList?: {
    /**
     * 可选，经办人确认订正必传，复核记录唯一编号
     */
    recheckCode?: string;
    /**
     * 必填，订正前的账户
     */
    before?: {
      /**
       * 必填，账户唯一编码
       */
      accountCode?: string;
    };
    /**
     * 必填，订正后的账户
     */
    after?: {
      cardType?: number;
      /**
       * 必填，开户行
       */
      bankName?: string;
      /**
       * 非供应商账户必填，行号
       */
      bankNo?: string;
      /**
       * 非供应商账户必填，银行编码
       */
      bankCode?: string;
      /**
       * 必填，账号
       */
      accountNo?: string;
    };
  }[];
}

/**
 * 接口 [经办人-确认订正信息↗](http://yapi.cai-inc.com/project/3621/interface/api/545338) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/info/corr-acct/confirm`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInfoCorrAcctConfirmPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [经办人-确认订正信息↗](http://yapi.cai-inc.com/project/3621/interface/api/545338) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/info/corr-acct/confirm`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInfoCorrAcctConfirmPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/info/corr-acct/confirm',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [经办人-确认订正信息↗](http://yapi.cai-inc.com/project/3621/interface/api/545338) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/info/corr-acct/confirm`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInfoCorrAcctConfirmPostRequestConfig: ZlbApiExpenseExpenseFormInfoCorrAcctConfirmPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/info/corr-acct/confirm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInfoCorrAcctConfirmPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [经办人-确认订正信息↗](http://yapi.cai-inc.com/project/3621/interface/api/545338) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/info/corr-acct/confirm`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInfoCorrAcctConfirmPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInfoCorrAcctConfirmPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInfoCorrAcctConfirmPostResponse>(
    prepare(zlbApiExpenseExpenseFormInfoCorrAcctConfirmPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInfoCorrAcctConfirmPost.requestConfig =
  zlbApiExpenseExpenseFormInfoCorrAcctConfirmPostRequestConfig;

/**
 * 接口 [（财务\/经办人）查询收款人调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/545346) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/receiver/modify-record/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormReceiverModifyRecordQueryGetRequest {
  /**
   * 报销单号
   */
  expenseFormCode: string;
}

/**
 * 接口 [（财务\/经办人）查询收款人调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/545346) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/receiver/modify-record/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormReceiverModifyRecordQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    modifyRecordList?: {
      /**
       * 调整时间
       */
      modifyTime?: number;
      /**
       * 操作员姓名
       */
      operatorName?: string;
      /**
       * 收款人账号复核状态
       */
      recAcctRecheckStatus?: number;
      /**
       * 审核节点名称
       */
      nodeName?: string;
      modifyHistory?: {
        /**
         * 收款人户名
         */
        receiverName?: string;
        /**
         * 调整原因
         */
        modifyReason?: string;
        /**
         * 订正前的账户
         */
        before?: {
          /**
           * 账户唯一编码
           */
          accountCode?: string;
          cardType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 开户行
           */
          bankName?: string;
          /**
           * 行号
           */
          bankNo?: string;
          /**
           * 银行编码
           */
          bankCode?: string;
          /**
           * 账号
           */
          accountNo?: string;
          /**
           * 金额
           */
          amount?: number;
        };
        /**
         * 订正后的账户
         */
        after?: {
          /**
           * 账户唯一编码
           */
          accountCode?: string;
          cardType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 开户行
           */
          bankName?: string;
          /**
           * 行号
           */
          bankNo?: string;
          /**
           * 银行编码
           */
          bankCode?: string;
          /**
           * 账号
           */
          accountNo?: string;
          /**
           * 金额
           */
          amount?: number;
        };
      }[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [（财务\/经办人）查询收款人调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/545346) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/receiver/modify-record/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormReceiverModifyRecordQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/receiver/modify-record/query',
    'data',
    string,
    'expenseFormCode',
    false
  >
>;

/**
 * 接口 [（财务\/经办人）查询收款人调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/545346) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/receiver/modify-record/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormReceiverModifyRecordQueryGetRequestConfig: ZlbApiExpenseExpenseFormReceiverModifyRecordQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/receiver/modify-record/query',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: ['expenseFormCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormReceiverModifyRecordQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [（财务\/经办人）查询收款人调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/545346) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `GET /zlb/api/expense/expense-form/receiver/modify-record/query`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormReceiverModifyRecordQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormReceiverModifyRecordQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormReceiverModifyRecordQueryGetResponse>(
    prepare(zlbApiExpenseExpenseFormReceiverModifyRecordQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormReceiverModifyRecordQueryGet.requestConfig =
  zlbApiExpenseExpenseFormReceiverModifyRecordQueryGetRequestConfig;

/**
 * 接口 [出纳结算-批量支付↗](http://yapi.cai-inc.com/project/3621/interface/api/649234) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/batch-apply-pay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormBatchApplyPayPostRequest {
  /**
   * 报销单号集合
   */
  expenseFormCodeList: string[];
}

/**
 * 接口 [出纳结算-批量支付↗](http://yapi.cai-inc.com/project/3621/interface/api/649234) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/batch-apply-pay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormBatchApplyPayPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [出纳结算-批量支付↗](http://yapi.cai-inc.com/project/3621/interface/api/649234) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/batch-apply-pay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormBatchApplyPayPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/batch-apply-pay',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [出纳结算-批量支付↗](http://yapi.cai-inc.com/project/3621/interface/api/649234) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/batch-apply-pay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormBatchApplyPayPostRequestConfig: ZlbApiExpenseExpenseFormBatchApplyPayPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/batch-apply-pay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormBatchApplyPayPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [出纳结算-批量支付↗](http://yapi.cai-inc.com/project/3621/interface/api/649234) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/batch-apply-pay`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormBatchApplyPayPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormBatchApplyPayPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormBatchApplyPayPostResponse>(
    prepare(zlbApiExpenseExpenseFormBatchApplyPayPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormBatchApplyPayPost.requestConfig =
  zlbApiExpenseExpenseFormBatchApplyPayPostRequestConfig;

/**
 * 接口 [初始化一般事项报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/660786) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/general`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormGeneralPostRequest {
  /**
   * 申请单号列表
   */
  applyFormCodeList: string[];
  /**
   * 单据类型
   */
  formType:
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'GENERAL_FORM'
    | 'BAIDA_APPLY_FORM'
    | 'BAIDA_EXPENSE_FORM'
    | 'BATCH_DISTRIBUTE'
    | 'OVERTIME_PAY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'OVERTIME_APPLY_FORM'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'UN_KNOWN';
}

/**
 * 接口 [初始化一般事项报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/660786) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/general`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormInitExpenseFormGeneralPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单据类型编号
     */
    businessType?: number;
    /**
     * 单据类型名称
     */
    businessTypeName?: string;
    /**
     * 工作单位ID
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 工作部门ID
     */
    deptId?: number;
    /**
     * 申请单数据
     */
    applyFormSimpleInfoROS?: {
      /**
       * 申请原因
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 申请用户姓名
       */
      applyUserName?: string;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 申请时间
       */
      initiationDateTime?: string;
      /**
       * 申请单业务编号
       */
      businessCode?: string;
      /**
       * 申请单状态
       */
      formStatus?: 1 | 2 | 3 | 4 | 5;
      /**
       * 出差开始时间
       */
      travelStartTime?: string;
      /**
       * 业务名称：会议名称，培训名称、采购名称
       */
      businessName?: string;
      /**
       * 剩余金额
       */
      applyRemainingAmount?: number;
      /**
       * 数据来源
       */
      dataSource?: number;
      /**
       * 附件列表
       */
      formAttachmentDTO?: {
        /**
         * 默认附件列表
         */
        normalAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 说明附件列表
         */
        thatAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 通知附件列表
         */
        informAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 合同附件列表
         */
        compactAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 签到附件列表
         */
        signAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 派出单位公函附件列表
         */
        officialLetterAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 接待清单附件列表
         */
        receptionMenuAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 采购意向附件列表
         */
        purchasePurposeAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 资产更新计划
         */
        propertyUpdatePlanAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 集体决策会议纪要
         */
        meetingSummaryAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专家论证意见
         */
        argumentSuggestionAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 专项、会议、培训附件列表
         */
        specialAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 银行回单附件
         */
        bankReceiptAttachmentList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
        /**
         * 账单附件
         */
        billAttachmentFileList?: {
          /**
           * 附件OssId
           */
          fileId: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
        }[];
      };
      /**
       * 扩展信息
       */
      extendFieldDTO?: {
        /**
         * 差旅扩展字段
         */
        travelExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 是否派车：1-派车，2-不派车
           */
          arrangeCar?: string;
          /**
           * 派车天数
           */
          dayCount?: number;
          extra?: string;
          /**
           * 三方拓展字段
           */
          thirdExtend?: string;
          /**
           * 差旅报销方式
           */
          travelExpenseMethod?: '由申请单报销' | '凭票报销';
          /**
           * 工号
           */
          workNo?: string;
          /**
           * 是否项目出差
           */
          isProject?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 所属部门
           */
          depName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目名称
           */
          projectName?: {
            key?: string;
            value?: string;
            label?: string;
          };
          /**
           * 项目负责人
           */
          projectHeader?: {
            key?: string;
            value?: string;
            label?: string;
          };
        };
        /**
         * 会议扩展字段（包含多收款人）
         */
        meetingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 会议名称
           */
          meetingName: string;
          /**
           * 会议地点code
           */
          meetingCityCode?: string;
          /**
           * 会议地点名称
           */
          meetingCityName?: string;
          /**
           * 会议开始日期
           */
          meetingStartDate?: string;
          /**
           * 会议结束日期
           */
          meetingEndDate?: string;
          /**
           * 会议天数
           */
          meetingDayCount?: number;
          /**
           * 会议预计参会人数
           */
          meetingExpectAttendeeCount: number;
          /**
           * 会议实际参会人数
           */
          meetingRealAttendeeCount?: number;
          /**
           * 会议工作人员人数
           */
          meetingWorkerCount?: number;
          /**
           * 参会领导信息
           */
          meetingLeaderInfo?: string;
          /**
           * 会议议程
           */
          meetingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 会议差异内容
           */
          meetingDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 培训扩展字段（包含多收款人）
         */
        trainingExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 1 签掉表 2 签到表附件
           */
          signType?: number;
          /**
           * 签到表
           */
          signForm?: {
            signFormCode?: string;
            /**
             * 签到表名称
             */
            signFormName?: string;
            /**
             * 申请表状态
             * 0-未发布 1-已发布 2-已结束
             */
            formStatus?: number;
            /**
             * 申请表状态名称
             */
            formStatusName?: string;
            /**
             * 结束时间
             */
            endTime?: number;
          };
          /**
           * 1申请单携带 2 手动选择
           */
          isExpenseInit?: number;
          /**
           * 培训名称
           */
          trainingName?: string;
          /**
           * 培训地点code
           */
          trainingCityCode?: string;
          /**
           * 培训地点名称
           */
          trainingCityName?: string;
          /**
           * 培训开始日期
           */
          trainingStartDate?: string;
          /**
           * 培训结束日期
           */
          trainingEndDate?: string;
          /**
           * 培训天数
           */
          trainingDayCount?: number;
          /**
           * 培训预计参会人数
           */
          trainingExpectAttendeeCount?: number;
          /**
           * 培训实际参会人数
           */
          trainingRealAttendeeCount?: number;
          /**
           * 培训工作人员人数
           */
          trainingWorkerCount?: number;
          /**
           * 培训议程
           */
          trainingAgenda?: string;
          /**
           * 是否纳入预算
           * 1-是，2-否
           */
          isIncludedBudget?: number;
          /**
           * 培训差异内容
           */
          trainingDifferenceContent?: string;
          /**
           * 培训讲师信息
           */
          trainingTeacherInfo?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal?: number;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: number;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 变更支付方式说明
           */
          changePayModeReason?: string;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 详细地址信息
           */
          detailAddress?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 采购扩展字段
         */
        procurementExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 采购内容
           */
          procurementContent?: string;
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 费用合计
           */
          applyAmount?: number;
          /**
           * 合同信息
           */
          contractList?: {
            /**
             * 政采云合同ID，订单拉取的合同填写
             */
            contractId?: number;
            /**
             * 订单编号
             */
            orderCode?: string;
            /**
             * 合同编号
             */
            contractCode?: string;
            /**
             * 合同名称
             */
            contractName?: string;
            /**
             * 合同金额（分）
             */
            amount?: number;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公务接待
         */
        receptionExtendFields?: {
          /**
           * 来访单位
           */
          visitOrgName: string;
          /**
           * 是否同城（宁波场景不需要）
           * 1-是，2-否
           */
          isSameCity?: number;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
          /**
           * 来访事由
           */
          visitReason: string;
          /**
           * 来访开始日期
           */
          visitStartDate: string;
          /**
           * 来访结束日期
           */
          visitEndDate: string;
          /**
           * 来访人员级别：1-省部级、2-厅局级、99-其他
           */
          visitorLevel: number;
          /**
           * 来访人员级别名称
           */
          visitorLevelName?: string;
          /**
           * 来访人数
           */
          visitorCount: number;
          /**
           * 主宾姓名
           */
          mainGuest?: string;
          /**
           * 接待地点code
           */
          receptionCityCode: string;
          /**
           * 接待地点名称
           */
          receptionCityName: string;
          /**
           * 接待详细地点
           */
          receptionDetailAddress?: string;
          /**
           * 就餐日期
           */
          mealDate: string;
          /**
           * 工作餐形式：1-自助餐、2-桌餐
           */
          mealType: 1 | 2 | 3;
          /**
           * 工作餐形式
           */
          mealTypeName?: string;
          /**
           * 用餐时间：1-早餐，2-中餐，3-晚餐
           */
          mealTimeType?: 1 | 2 | 3;
          /**
           * 用餐时间
           */
          mealTimeTypeName?: string;
          /**
           * 陪餐人数（宁波场景不需要）
           */
          escortCount?: number;
          /**
           * 配餐人员姓名
           */
          escortPerson?: string;
          /**
           * 接待预算金额
           */
          receptionBudgetAmount?: number;
          /**
           * 来访人员信息
           */
          visitorInformation?: {
            /**
             * 访问人员名称
             */
            visitorName?: string;
            /**
             * 访问人员职级
             */
            visitorLevel?: number;
            /**
             * 访问人员职级名称
             */
            visitorLevelName?: string;
            /**
             * 来访人员职务
             */
            visitorDuty?: string;
            /**
             * 来访人员单位名称
             */
            visitorUnitName?: string;
          }[];
          /**
           * 接待人员信息
           */
          receptionistInformation?: {
            /**
             * 接待人员名称
             */
            receptionistName?: string;
            /**
             * 接待人员职级
             */
            receptionistLevel?: number;
            /**
             * 接待人员职级名称
             */
            receptionistLevelName?: string;
          }[];
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 一般事项
         */
        generalExtendFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 事项详细内容
           */
          detailContent: string;
          /**
           * 事项预算
           */
          eventBudget?: number;
          /**
           * 事项详细内容与事前审批的差异
           */
          generalDifferenceContent?: string;
          extra?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 用印申请
         */
        contractExtendFields?: {
          /**
           * 合同版本编号
           */
          contractVersionUniqueCode?: string;
        };
        /**
         * 招标书
         */
        tenderApplyExtendFields?: {
          /**
           * 申请单类型
           */
          applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
          /**
           * 申请事由
           */
          applyReason?: string;
          /**
           * 申请单Code
           */
          applyFormCode?: string;
          /**
           * 业务单据号
           */
          businessCode?: string;
          /**
           * 提交时间
           */
          submitTime?: string;
        };
        /**
         * 通用采购申请拓展字段
         */
        purchaseGeneralFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm?: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * isCreatePurchaseProposal
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType?: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource?: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 政府购买服务申请拓展字段
         */
        govermentApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 采购类型
           * 1-政府采购，2-非政府采购
           */
          purchaseType: 1 | 2;
          /**
           * 采购类型描述
           */
          purchaseTypeDesc?: string;
          /**
           * 采购资金来源
           * 1-财政预算资金，2-非财政预算资金
           */
          purchaseFundSource: 1 | 2;
          /**
           * 采购资金来源描述
           */
          purchaseFundSourceDesc?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 办公家具购置申请拓展字段
         */
        furnitureApplyFields?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 组织形式
           */
          organizationalForm: 1 | 2 | 3 | 4;
          /**
           * 组织形式描述
           */
          organizationalFormDesc?: string;
          /**
           * 采购方式
           */
          purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
          /**
           * 采购方式描述
           */
          purchaseMethodDesc?: string;
          /**
           * 是否生成采购建议书草稿
           * 1-是，2-否
           */
          isCreatePurchaseProposal: number;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 全链路二期 报销的统一拓展字段
         */
        purchaseGeneralExpenseFieldDTO?: {
          baidaInfo?: {
            /**
             * 百搭快照编号
             */
            formSnapshotCode?: string;
            /**
             * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
             */
            formData?: string;
          };
          /**
           * 交易方式：线上；线下
           */
          tradeWay?: string[];
          /**
           * 采购差异内容
           */
          procurementDifferenceContent?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 交易方式
           */
          tradeWayName?: string;
          /**
           * 是否有合同
           */
          addContract?: boolean;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 公共事业缴费统一拓展字段
         */
        publicBusinessPaymentFieldDTO?: {
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否为重大事项或大额资金：1-是 0-否
           */
          isMajorEvent?: number;
        };
        /**
         * 无相拓展
         */
        generalExtra?: string;
      };
      formType?: string;
    }[];
    /**
     * 工作部门名称
     */
    deptName?: string;
    /**
     * 申请事由
     */
    expenseReason?: string;
    /**
     * 扩展信息
     */
    extendFieldDTO?: {
      /**
       * 差旅扩展字段
       */
      travelExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 是否派车：1-派车，2-不派车
         */
        arrangeCar?: string;
        /**
         * 派车天数
         */
        dayCount?: number;
        extra?: string;
        /**
         * 三方拓展字段
         */
        thirdExtend?: string;
        /**
         * 差旅报销方式
         */
        travelExpenseMethod?: '由申请单报销' | '凭票报销';
        /**
         * 工号
         */
        workNo?: string;
        /**
         * 是否项目出差
         */
        isProject?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 所属部门
         */
        depName?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 项目名称
         */
        projectName?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 项目负责人
         */
        projectHeader?: {
          key?: string;
          value?: string;
          label?: string;
        };
      };
      /**
       * 会议扩展字段（包含多收款人）
       */
      meetingExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 1 签掉表 2 签到表附件
         */
        signType?: number;
        /**
         * 签到表
         */
        signForm?: {
          signFormCode?: string;
          /**
           * 签到表名称
           */
          signFormName?: string;
          /**
           * 申请表状态
           * 0-未发布 1-已发布 2-已结束
           */
          formStatus?: number;
          /**
           * 申请表状态名称
           */
          formStatusName?: string;
          /**
           * 结束时间
           */
          endTime?: number;
        };
        /**
         * 1申请单携带 2 手动选择
         */
        isExpenseInit?: number;
        /**
         * 会议名称
         */
        meetingName: string;
        /**
         * 会议地点code
         */
        meetingCityCode?: string;
        /**
         * 会议地点名称
         */
        meetingCityName?: string;
        /**
         * 会议开始日期
         */
        meetingStartDate?: string;
        /**
         * 会议结束日期
         */
        meetingEndDate?: string;
        /**
         * 会议天数
         */
        meetingDayCount?: number;
        /**
         * 会议预计参会人数
         */
        meetingExpectAttendeeCount: number;
        /**
         * 会议实际参会人数
         */
        meetingRealAttendeeCount?: number;
        /**
         * 会议工作人员人数
         */
        meetingWorkerCount?: number;
        /**
         * 参会领导信息
         */
        meetingLeaderInfo?: string;
        /**
         * 会议议程
         */
        meetingAgenda?: string;
        /**
         * 是否纳入预算
         * 1-是，2-否
         */
        isIncludedBudget?: number;
        /**
         * 会议差异内容
         */
        meetingDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal?: number;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 详细地址信息
         */
        detailAddress?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 培训扩展字段（包含多收款人）
       */
      trainingExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 1 签掉表 2 签到表附件
         */
        signType?: number;
        /**
         * 签到表
         */
        signForm?: {
          signFormCode?: string;
          /**
           * 签到表名称
           */
          signFormName?: string;
          /**
           * 申请表状态
           * 0-未发布 1-已发布 2-已结束
           */
          formStatus?: number;
          /**
           * 申请表状态名称
           */
          formStatusName?: string;
          /**
           * 结束时间
           */
          endTime?: number;
        };
        /**
         * 1申请单携带 2 手动选择
         */
        isExpenseInit?: number;
        /**
         * 培训名称
         */
        trainingName?: string;
        /**
         * 培训地点code
         */
        trainingCityCode?: string;
        /**
         * 培训地点名称
         */
        trainingCityName?: string;
        /**
         * 培训开始日期
         */
        trainingStartDate?: string;
        /**
         * 培训结束日期
         */
        trainingEndDate?: string;
        /**
         * 培训天数
         */
        trainingDayCount?: number;
        /**
         * 培训预计参会人数
         */
        trainingExpectAttendeeCount?: number;
        /**
         * 培训实际参会人数
         */
        trainingRealAttendeeCount?: number;
        /**
         * 培训工作人员人数
         */
        trainingWorkerCount?: number;
        /**
         * 培训议程
         */
        trainingAgenda?: string;
        /**
         * 是否纳入预算
         * 1-是，2-否
         */
        isIncludedBudget?: number;
        /**
         * 培训差异内容
         */
        trainingDifferenceContent?: string;
        /**
         * 培训讲师信息
         */
        trainingTeacherInfo?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal?: number;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource?: number;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
        /**
         * 变更支付方式说明
         */
        changePayModeReason?: string;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 详细地址信息
         */
        detailAddress?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 采购扩展字段
       */
      procurementExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 采购内容
         */
        procurementContent?: string;
        /**
         * 采购差异内容
         */
        procurementDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 费用合计
         */
        applyAmount?: number;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 公务接待
       */
      receptionExtendFields?: {
        /**
         * 来访单位
         */
        visitOrgName: string;
        /**
         * 是否同城（宁波场景不需要）
         * 1-是，2-否
         */
        isSameCity?: number;
        /**
         * 来访人员职务
         */
        visitorDuty?: string;
        /**
         * 来访事由
         */
        visitReason: string;
        /**
         * 来访开始日期
         */
        visitStartDate: string;
        /**
         * 来访结束日期
         */
        visitEndDate: string;
        /**
         * 来访人员级别：1-省部级、2-厅局级、99-其他
         */
        visitorLevel: number;
        /**
         * 来访人员级别名称
         */
        visitorLevelName?: string;
        /**
         * 来访人数
         */
        visitorCount: number;
        /**
         * 主宾姓名
         */
        mainGuest?: string;
        /**
         * 接待地点code
         */
        receptionCityCode: string;
        /**
         * 接待地点名称
         */
        receptionCityName: string;
        /**
         * 接待详细地点
         */
        receptionDetailAddress?: string;
        /**
         * 就餐日期
         */
        mealDate: string;
        /**
         * 工作餐形式：1-自助餐、2-桌餐
         */
        mealType: 1 | 2 | 3;
        /**
         * 工作餐形式
         */
        mealTypeName?: string;
        /**
         * 用餐时间：1-早餐，2-中餐，3-晚餐
         */
        mealTimeType?: 1 | 2 | 3;
        /**
         * 用餐时间
         */
        mealTimeTypeName?: string;
        /**
         * 陪餐人数（宁波场景不需要）
         */
        escortCount?: number;
        /**
         * 配餐人员姓名
         */
        escortPerson?: string;
        /**
         * 接待预算金额
         */
        receptionBudgetAmount?: number;
        /**
         * 来访人员信息
         */
        visitorInformation?: {
          /**
           * 访问人员名称
           */
          visitorName?: string;
          /**
           * 访问人员职级
           */
          visitorLevel?: number;
          /**
           * 访问人员职级名称
           */
          visitorLevelName?: string;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
          /**
           * 来访人员单位名称
           */
          visitorUnitName?: string;
        }[];
        /**
         * 接待人员信息
         */
        receptionistInformation?: {
          /**
           * 接待人员名称
           */
          receptionistName?: string;
          /**
           * 接待人员职级
           */
          receptionistLevel?: number;
          /**
           * 接待人员职级名称
           */
          receptionistLevelName?: string;
        }[];
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 一般事项
       */
      generalExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 事项详细内容
         */
        detailContent: string;
        /**
         * 事项预算
         */
        eventBudget?: number;
        /**
         * 事项详细内容与事前审批的差异
         */
        generalDifferenceContent?: string;
        extra?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 用印申请
       */
      contractExtendFields?: {
        /**
         * 合同版本编号
         */
        contractVersionUniqueCode?: string;
      };
      /**
       * 招标书
       */
      tenderApplyExtendFields?: {
        /**
         * 申请单类型
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请事由
         */
        applyReason?: string;
        /**
         * 申请单Code
         */
        applyFormCode?: string;
        /**
         * 业务单据号
         */
        businessCode?: string;
        /**
         * 提交时间
         */
        submitTime?: string;
      };
      /**
       * 通用采购申请拓展字段
       */
      purchaseGeneralFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm?: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * isCreatePurchaseProposal
         * 采购类型
         * 1-政府采购，2-非政府采购
         */
        purchaseType?: 1 | 2;
        /**
         * 采购类型描述
         */
        purchaseTypeDesc?: string;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource?: 1 | 2;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 政府购买服务申请拓展字段
       */
      govermentApplyFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * 采购类型
         * 1-政府采购，2-非政府采购
         */
        purchaseType: 1 | 2;
        /**
         * 采购类型描述
         */
        purchaseTypeDesc?: string;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource: 1 | 2;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 办公家具购置申请拓展字段
       */
      furnitureApplyFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 全链路二期 报销的统一拓展字段
       */
      purchaseGeneralExpenseFieldDTO?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 交易方式：线上；线下
         */
        tradeWay?: string[];
        /**
         * 采购差异内容
         */
        procurementDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 交易方式
         */
        tradeWayName?: string;
        /**
         * 是否有合同
         */
        addContract?: boolean;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 公共事业缴费统一拓展字段
       */
      publicBusinessPaymentFieldDTO?: {
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否为重大事项或大额资金：1-是 0-否
         */
        isMajorEvent?: number;
      };
      /**
       * 无相拓展
       */
      generalExtra?: string;
    };
    /**
     * 行程信息
     */
    itinerarySplitROS?: {
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
      /**
       * 0：由原行程生成 1：由原行程拆分 2：用户新增
       */
      sourceType?: number;
      /**
       * 校验状态
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 提示消息
       */
      msg?: string[];
      /**
       * 原行程数据
       */
      originalItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程拆分结果
       */
      currentItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 原行程单号
         */
        originalItineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出差天数
         */
        travelDay?: number;
        /**
         * 出发地code
         */
        beginCityCode?: string;
        /**
         * 出发地名称
         */
        beginCityName?: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 行程冲突提示语
         */
        checkResultMessageRO?: {
          /**
           * 提示状态
           */
          tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 提示文案
           */
          tipText?: string;
          /**
           * 提示消息
           */
          tipMsg?: string[];
          /**
           * 消息和类型
           */
          tipLists?: {
            /**
             * 规则强弱控
             */
            checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
            /**
             * 规则强弱控描述
             */
            msg?: string;
            /**
             * 规则code
             */
            ruleCode?: string;
          }[];
          /**
           * 单独为前端提示方便添加（不要动，虽然很愚蠢）
           */
          invoiceTipMsg?: string[];
          /**
           * 设置结果
           */
          resultInfo?: {
            /**
             * 凭票报销总结果
             */
            expenseFeeInvoiceResult?: {
              /**
               * 用户id
               */
              operatorId?: number;
              /**
               * 用户名称
               */
              operatorName?: string;
              /**
               * 报销金额
               */
              amount?: number;
              /**
               * 报销金额描述
               */
              amountDesc?: string;
              /**
               * 详细信息
               */
              detailInfoList?: {
                /**
                 * 发生日期
                 */
                happenDate?: null;
                /**
                 * 是否可以报销
                 */
                canExpense?: null;
                /**
                 * 表单code
                 */
                formCode?: string[];
                /**
                 * 业务code
                 */
                businessCode?: string[];
                /**
                 * 冲突描述
                 */
                conflictDesc?: null;
                /**
                 * 是否凭票报销冲突
                 */
                isUseInvoice?: null;
                /**
                 * 规则描述
                 */
                ruleDesc?: null;
                /**
                 * 金额
                 */
                ruleAmount?: null;
              }[];
            }[];
            /**
             * 凭票报销总结果提示
             */
            expenseFeeInvoiceTips?: string;
            /**
             * 是否展示
             */
            canShow?: boolean;
          };
          /**
           * 是否需要显示
           */
          canShow?: boolean;
        };
        /**
         * 是否派车 0 否 1是
         */
        arrangeCar?: number;
        /**
         * 派车信息
         */
        arrangeCarRO?: {
          /**
           * 派车信息编号
           */
          arrangeCarCode?: string;
          /**
           * 行程信息编号
           */
          itineraryCode?: string;
          /**
           * 开始时间
           */
          beginTime?: string;
          /**
           * 结束时间
           */
          endTime?: string;
          /**
           * 开始上下午
           * 上午-1，下午-2
           */
          beginTag?: number;
          /**
           * 结束上下午
           * 上午-1，下午-2
           */
          endTag?: number;
          /**
           * 派车天数
           */
          arrangeCarDay?: number;
          /**
           * 乘车人
           */
          passengerList?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
          /**
           * 司机
           */
          drivers?: {
            /**
             * 用户ID
             */
            userId?: number;
            /**
             * 操作员ID
             */
            operatorId: number;
            /**
             * 姓名
             */
            userName: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
             */
            userType?: number;
            /**
             * 类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type?: number;
            /**
             * 是否隐藏人员类型显示
             */
            hideOperatorShowType?: boolean;
          }[];
        };
        /**
         * 住宿天数
         */
        accommodationDay?: number;
      };
      /**
       * 行程数据校验结果
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: null;
              /**
               * 是否可以报销
               */
              canExpense?: null;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: null;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: null;
              /**
               * 规则描述
               */
              ruleDesc?: null;
              /**
               * 金额
               */
              ruleAmount?: null;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
    }[];
    /**
     * 收款人信息
     */
    expenseReceiverROS?: {
      /**
       * 收款信息Code
       */
      receiverCode?: string;
      bankName?: string;
      bankCode?: string;
      accountCode?: string;
      /**
       * 卡号
       */
      cardNo?: string;
      /**
       * 银行卡或者公务卡 1：银行卡 2：公务卡
       */
      cardType?: number;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 操作人ID
       */
      operatorId?: number;
      /**
       * 收款人姓名
       */
      receiverName?: string;
      /**
       * 用户来源：1、系统内部人员；2-外部人员
       */
      userSource?: number;
    }[];
    /**
     * 业务单号
     */
    businessCode?: string;
    /**
     * 数据来源
     */
    dataSource?: number;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 预算项目
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 占用金额
       */
      amount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 操作人，后端使用
       */
      operatorId?: number;
      /**
       * 科目级联uk
       */
      subjectUkHierarchy?: string[];
      /**
       * 科目级联
       */
      subjectNameHierarchy?: string[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [初始化一般事项报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/660786) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/general`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormInitExpenseFormGeneralPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/init-expense-form/general',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [初始化一般事项报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/660786) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/general`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormInitExpenseFormGeneralPostRequestConfig: ZlbApiExpenseExpenseFormInitExpenseFormGeneralPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/init-expense-form/general',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormInitExpenseFormGeneralPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化一般事项报销单基础信息↗](http://yapi.cai-inc.com/project/3621/interface/api/660786) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/init-expense-form/general`
 * @更新时间 `2024-12-11 15:42:25`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormInitExpenseFormGeneralPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormInitExpenseFormGeneralPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormInitExpenseFormGeneralPostResponse>(
    prepare(zlbApiExpenseExpenseFormInitExpenseFormGeneralPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormInitExpenseFormGeneralPost.requestConfig =
  zlbApiExpenseExpenseFormInitExpenseFormGeneralPostRequestConfig;

/**
 * 接口 [重新构建摘要↗](http://yapi.cai-inc.com/project/3621/interface/api/706746) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/rebuild-summary`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormRebuildSummaryPostRequest {
  /**
   * 单据code
   */
  expenseFormCode?: string;
  /**
   * 费用 金额键值对列表
   */
  feeTypeAmountEntry?: {
    /**
     * 费用父类型（大类）
     */
    feeParentType?: string;
    /**
     * 费用对应金额
     */
    amount?: number;
  }[];
}

/**
 * 接口 [重新构建摘要↗](http://yapi.cai-inc.com/project/3621/interface/api/706746) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/rebuild-summary`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export interface ZlbApiExpenseExpenseFormRebuildSummaryPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [重新构建摘要↗](http://yapi.cai-inc.com/project/3621/interface/api/706746) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/rebuild-summary`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
type ZlbApiExpenseExpenseFormRebuildSummaryPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/expense-form/rebuild-summary',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [重新构建摘要↗](http://yapi.cai-inc.com/project/3621/interface/api/706746) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/rebuild-summary`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
const zlbApiExpenseExpenseFormRebuildSummaryPostRequestConfig: ZlbApiExpenseExpenseFormRebuildSummaryPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: '/zlb/api/expense/expense-form/rebuild-summary',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseExpenseFormRebuildSummaryPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [重新构建摘要↗](http://yapi.cai-inc.com/project/3621/interface/api/706746) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35491)
 * @请求头 `POST /zlb/api/expense/expense-form/rebuild-summary`
 * @更新时间 `2024-12-11 15:42:28`
 * @项目ID 3621
 */
export const zlbApiExpenseExpenseFormRebuildSummaryPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseExpenseFormRebuildSummaryPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseExpenseFormRebuildSummaryPostResponse>(
    prepare(zlbApiExpenseExpenseFormRebuildSummaryPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseExpenseFormRebuildSummaryPost.requestConfig =
  zlbApiExpenseExpenseFormRebuildSummaryPostRequestConfig;

const mockUrl_0_1_0_1 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_1 = '' as any;
const prodUrl_0_1_0_1 = '' as any;
const dataKey_0_1_0_1 = 'data' as any;

/**
 * 接口 [查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230878) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/query`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowQueryGetRequest {
  /**
   * 业务单号
   */
  businessNo?: string;
  /**
   * 单据类型：1-申请单，2-报销单，4-工资发放申请单
   */
  formType?: string;
  /**
   * 工作流业务key
   */
  workflowProcessKey: string;
  /**
   * 工作流模型id
   */
  workflowModelId?: string;
  /**
   * 工作流版本号
   */
  workflowVersion?: string;
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 金额
   */
  amount?: string;
  /**
   * 事项预算
   */
  eventBudget?: string;
  /**
   * 部门ID
   */
  departmentId?: string;
  /**
   * 同行人
   */
  'accompanyOperatorIds[0]'?: string;
  /**
   * 是否派车
   */
  arrangeCar?: string;
  /**
   * 查询类型
   * 1：获取模版
   * 2：获取实例
   */
  queryType?: string;
}

/**
 * 接口 [查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230878) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/query`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 审核节点列表
     */
    auditNodeList?: {
      auditOperatorList?: {
        operatorId?: number;
        operatorName?: string;
        institutionId?: number;
        institutionName?: string;
        auditRemark?: string;
        auditStatus?: number;
        auditTime?: string;
        signAttachment?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        oneselfHistorySignAttachment?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        addAuditWay?: number;
        addAuditOperator?: string;
        comment?: {
          commentContent?: string;
          operatorId?: number;
          operatorName?: string;
          commentCode?: string;
          commentTime?: number;
          pictureAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          otherAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          remove?: boolean;
        };
        operatorType?: number;
      }[];
      userRangeType?: number;
      userRangeTypeNew?: number;
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      personCount?: number;
      auditStatus?: number;
      auditTime?: string;
      auditDesc?: string;
      auditType?: number;
      eventType?: number;
      nodeType?: number;
      nodeKey?: string;
      nodeName?: string;
      checkStrategy?: number;
      departmentId?: number;
      institutionSelfDtos?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      commonAuditorList?: {
        displayName?: string;
        userId?: number;
        operatorId?: number;
        code?: string;
        gender?: number;
        institutionId?: number;
        institution?: {
          id?: number;
          createdAt?: number;
          updatedAt?: number;
          creatorId?: string;
          modifierId?: string;
          extFields?: string;
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string;
          tags?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          divisionCode?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
        };
        deptName?: string;
      }[];
      bizProperty?: string;
      comment?: {
        commentContent?: string;
        operatorId?: number;
        operatorName?: string;
        commentCode?: string;
        commentTime?: number;
        pictureAttachments?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        }[];
        otherAttachments?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        }[];
        remove?: boolean;
      };
    }[];
    /**
     * 当前节点可驳回节点列表
     */
    availableRejectNodeList?: {
      nodeName?: string;
      nodeKey?: string;
      operatorNames?: string[];
    }[];
    /**
     * 工作流的唯一key
     */
    workflowProcessKey?: string;
    /**
     * 工作流模型id
     */
    workflowModelId?: number;
    /**
     * 工作流版本
     */
    workflowVersion?: number;
    /**
     * 申请人操作人id
     */
    applyOperatorId?: number;
    /**
     * 申请人名称
     */
    applyOperatorName?: string;
    /**
     * 申请时间
     */
    applyTime?: string;
    /**
     * 申请备注
     */
    applyRemark?: string;
    /**
     * 是否能加签 0-否 1-是
     */
    isAddTaskAccess?: number;
    /**
     * 单据类型
     */
    formType?: number;
    /**
     * 工作流是否开启签名：true-开启；false-未开启
     */
    isEnableSign?: boolean;
    /**
     * 签名配置：0-使用上次签名；1-每次重新签名；
     */
    signConfig?: number;
    /**
     * 实例当前节点业务属性
     */
    currentBizProperty?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230878) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/query`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/query',
    'data',
    string,
    | 'businessNo'
    | 'formType'
    | 'workflowProcessKey'
    | 'workflowModelId'
    | 'workflowVersion'
    | 'formCode'
    | 'amount'
    | 'eventBudget'
    | 'departmentId'
    | 'accompanyOperatorIds[0]'
    | 'arrangeCar'
    | 'queryType',
    false
  >
>;

/**
 * 接口 [查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230878) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/query`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowQueryGetRequestConfig: ZlbApiExpenseWorkflowQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/query',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [
      'businessNo',
      'formType',
      'workflowProcessKey',
      'workflowModelId',
      'workflowVersion',
      'formCode',
      'amount',
      'eventBudget',
      'departmentId',
      'accompanyOperatorIds[0]',
      'arrangeCar',
      'queryType',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230878) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/query`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowQueryGetResponse>(
    prepare(zlbApiExpenseWorkflowQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowQueryGet.requestConfig = zlbApiExpenseWorkflowQueryGetRequestConfig;

/**
 * 接口 [提交工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230886) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/submit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowSubmitPostRequest {
  /**
   * 业务单号
   */
  businessNo?: string;
  /**
   * 单据类型：1-申请单，2-报销单，4-工资发放申请单
   */
  formType?: number;
  /**
   * 工作流业务key
   */
  workflowProcessKey: string;
  /**
   * 工作流模型id
   */
  workflowModelId?: number;
  /**
   * 工作流版本号
   */
  workflowVersion?: number;
  /**
   * 金额
   */
  amount?: number;
  /**
   * 部门id
   */
  departmentId?: number;
  /**
   * 同行人
   */
  accompanyOperatorIds?: number[];
  /**
   * 工作流审核节点信息
   */
  auditNodeList: {
    auditOperatorList?: {
      operatorId?: number;
      operatorName?: string;
      institutionId?: number;
      institutionName?: string;
      auditRemark?: string;
      auditStatus?: number;
      auditTime?: string;
      signAttachment?: {
        fileId?: string;
        type?: string;
        bizNo?: string;
        name?: string;
        size?: number;
        bizCode?: string;
        url?: string;
        sizeDesc?: string;
      };
      oneselfHistorySignAttachment?: {
        fileId?: string;
        type?: string;
        bizNo?: string;
        name?: string;
        size?: number;
        bizCode?: string;
        url?: string;
        sizeDesc?: string;
      };
      addAuditWay?: number;
      addAuditOperator?: string;
      comment?: {
        commentContent?: string;
        operatorId?: number;
        operatorName?: string;
        commentCode?: string;
        commentTime?: number;
        pictureAttachments?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        }[];
        otherAttachments?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        }[];
        remove?: boolean;
      };
      operatorType?: number;
    }[];
    userRangeType?: number;
    userRangeTypeNew?: number;
    userRangeValues?: string[];
    userRangeValuesNew?: string[];
    personCount?: number;
    auditStatus?: number;
    auditTime?: string;
    auditDesc?: string;
    auditType?: number;
    eventType?: number;
    nodeType?: number;
    nodeKey?: string;
    nodeName?: string;
    checkStrategy?: number;
    departmentId?: number;
    institutionSelfDtos?: {
      code?: string;
      name?: string;
      userType?: string;
      tenantCode?: string;
      tenantName?: string;
      uniqueKey?: string;
      parentInstitution?: {
        parentCode?: number;
        parentName?: string;
      };
    }[];
    commonAuditorList?: {
      displayName?: string;
      userId?: number;
      operatorId?: number;
      code?: string;
      gender?: number;
      institutionId?: number;
      institution?: {
        id?: number;
        createdAt?: number;
        updatedAt?: number;
        creatorId?: string;
        modifierId?: string;
        extFields?: string;
        name?: string;
        shortName?: string;
        orgCode?: string;
        creditCode?: string;
        bizAttaches?: string;
        tags?: string;
        provinceCode?: string;
        provinceName?: string;
        cityCode?: string;
        cityName?: string;
        regionCode?: string;
        regionName?: string;
        address?: string;
        status?: number;
        displayOrder?: number;
        outCreatedAt?: string;
        divisionCode?: string;
        fullName?: string;
        postalCode?: string;
        source?: number;
        organizationCode?: string;
        institutionLevel?: number;
      };
      deptName?: string;
    }[];
    bizProperty?: string;
    comment?: {
      commentContent?: string;
      operatorId?: number;
      operatorName?: string;
      commentCode?: string;
      commentTime?: number;
      pictureAttachments?: {
        fileId?: string;
        type?: string;
        bizNo?: string;
        name?: string;
        size?: number;
        bizCode?: string;
        url?: string;
        sizeDesc?: string;
      }[];
      otherAttachments?: {
        fileId?: string;
        type?: string;
        bizNo?: string;
        name?: string;
        size?: number;
        bizCode?: string;
        url?: string;
        sizeDesc?: string;
      }[];
      remove?: boolean;
    };
  }[];
  operatorId?: number;
}

/**
 * 接口 [提交工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230886) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/submit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230886) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/submit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230886) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/submit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowSubmitPostRequestConfig: ZlbApiExpenseWorkflowSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/230886) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/submit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowSubmitPostResponse>(
    prepare(zlbApiExpenseWorkflowSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowSubmitPost.requestConfig = zlbApiExpenseWorkflowSubmitPostRequestConfig;

/**
 * 接口 [工作流审批，老接口后续要替换掉，现在真线在使用中↗](http://yapi.cai-inc.com/project/3621/interface/api/230894) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/audit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowAuditPostRequest {
  /**
   * 业务单号
   */
  businessNo?: string;
  /**
   * 单据类型：1-申请单，2-报销单，4-工资发放申请单
   */
  formType?: number;
  /**
   * 工作流业务key
   */
  workflowProcessKey: string;
  /**
   * 工作流模型id
   */
  workflowModelId?: number;
  /**
   * 工作流版本号
   */
  workflowVersion?: number;
  /**
   * 审核意见
   */
  auditRemark?: string;
  /**
   * 审核状态：1-通过；2-驳回；
   */
  auditStatus: number;
  /**
   * 当前节点key
   */
  currentNodeKey: string;
  /**
   * 节点key：驳回时，需驳回到固定节点时填写；不填写直接工作流结束
   */
  rejectNodeKey?: string;
  /**
   * 事件类型：0-审批，1-审核，2-出纳
   */
  eventType: number;
  /**
   * 签名附件
   */
  signAttachment?: {
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
    /**
     * 附件业务类型
     */
    subBizType?:
      | 1
      | 2
      | 3
      | 4
      | 5
      | 6
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 19
      | 20
      | 21
      | 22;
  };
  /**
   * 业务单号
   */
  bizCode?: string;
}

/**
 * 接口 [工作流审批，老接口后续要替换掉，现在真线在使用中↗](http://yapi.cai-inc.com/project/3621/interface/api/230894) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/audit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [工作流审批，老接口后续要替换掉，现在真线在使用中↗](http://yapi.cai-inc.com/project/3621/interface/api/230894) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/audit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [工作流审批，老接口后续要替换掉，现在真线在使用中↗](http://yapi.cai-inc.com/project/3621/interface/api/230894) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/audit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowAuditPostRequestConfig: ZlbApiExpenseWorkflowAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [工作流审批，老接口后续要替换掉，现在真线在使用中↗](http://yapi.cai-inc.com/project/3621/interface/api/230894) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/audit`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowAuditPostResponse>(
    prepare(zlbApiExpenseWorkflowAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowAuditPost.requestConfig = zlbApiExpenseWorkflowAuditPostRequestConfig;

/**
 * 接口 [查询单据历史审核节点↗](http://yapi.cai-inc.com/project/3621/interface/api/231606) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history/node/query`
 * @更新时间 `2023-03-08 11:32:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowHistoryNodeQueryGetRequest {
  /**
   * 单据code
   */
  formCode?: string;
}

/**
 * 接口 [查询单据历史审核节点↗](http://yapi.cai-inc.com/project/3621/interface/api/231606) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history/node/query`
 * @更新时间 `2023-03-08 11:32:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowHistoryNodeQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 审核历史
     */
    workflowQueryRO?: {
      /**
       * 审核节点列表
       */
      auditNodeList?: {
        /**
         * 审核人列表
         */
        auditOperatorList: {
          /**
           * 审批意见
           */
          auditRemark?: string;
          /**
           * 审批状态：0-待审批，1-审批通过，2-审批驳回
           */
          auditStatus?: number;
          /**
           * 审核时间
           */
          auditTime?: string;
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
        }[];
        /**
         * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
         */
        userRangeType?: number;
        /**
         * 动态审核人类型
         */
        userRangeValues?: string[];
        /**
         * 审核人数(总人数)
         */
        personCount?: number;
        /**
         * 审核状态：0-待审批，1-已审批，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 审核描述
         */
        auditDesc?: string;
        /**
         * 审批类型：0-或签，1-会签，2-依次审批
         */
        auditType?: number;
        /**
         * 事件类型：0-审批，1-审核，2-出纳
         */
        eventType?: number;
        /**
         * 是否自选:0-指定，1-自选
         */
        nodeType?: number;
        /**
         * 节点key
         */
        nodeKey?: string;
        /**
         * 节点名称
         */
        nodeName?: string;
        /**
         * 策略
         * cn.gov.zcy.workflow.enums.CheckStrategyEnum
         */
        checkStrategy?: number;
      }[];
      /**
       * 工作流的唯一key
       */
      workflowProcessKey?: string;
      /**
       * 工作流模型id
       */
      workflowModelId?: number;
      /**
       * 工作流版本
       */
      workflowVersion?: number;
      /**
       * 申请人操作人id
       */
      applyOperatorId?: number;
      /**
       * 申请人名称
       */
      applyOperatorName?: string;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 申请备注
       */
      applyRemark?: string;
      /**
       * 是否能加签 0-否 1-是
       */
      isAddTaskAccess?: number;
    };
    /**
     * 申请时间
     */
    auditTime?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单据历史审核节点↗](http://yapi.cai-inc.com/project/3621/interface/api/231606) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history/node/query`
 * @更新时间 `2023-03-08 11:32:38`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowHistoryNodeQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/history/node/query',
    'data',
    string,
    'formCode',
    false
  >
>;

/**
 * 接口 [查询单据历史审核节点↗](http://yapi.cai-inc.com/project/3621/interface/api/231606) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history/node/query`
 * @更新时间 `2023-03-08 11:32:38`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowHistoryNodeQueryGetRequestConfig: ZlbApiExpenseWorkflowHistoryNodeQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/history/node/query',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: ['formCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowHistoryNodeQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单据历史审核节点↗](http://yapi.cai-inc.com/project/3621/interface/api/231606) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history/node/query`
 * @更新时间 `2023-03-08 11:32:38`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowHistoryNodeQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowHistoryNodeQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowHistoryNodeQueryGetResponse>(
    prepare(zlbApiExpenseWorkflowHistoryNodeQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowHistoryNodeQueryGet.requestConfig =
  zlbApiExpenseWorkflowHistoryNodeQueryGetRequestConfig;

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/234790) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/stop`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowStopPostRequest {
  /**
   * 业务单号
   */
  businessNo?: string;
  /**
   * 单据类型：1-申请单，2-报销单，4-工资发放申请单
   */
  formType?: number;
  /**
   * 工作流业务key
   */
  workflowProcessKey: string;
  /**
   * 工作流模型id
   */
  workflowModelId?: number;
  /**
   * 工作流版本号
   */
  workflowVersion?: number;
  /**
   * 停止备注
   */
  stopRemark?: string;
}

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/234790) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/stop`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowStopPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/234790) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/stop`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowStopPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/stop',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/234790) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/stop`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowStopPostRequestConfig: ZlbApiExpenseWorkflowStopPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/stop',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowStopPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [停止工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/234790) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/stop`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowStopPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowStopPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowStopPostResponse>(
    prepare(zlbApiExpenseWorkflowStopPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowStopPost.requestConfig = zlbApiExpenseWorkflowStopPostRequestConfig;

/**
 * 接口 [审批历史↗](http://yapi.cai-inc.com/project/3621/interface/api/239638) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history`
 * @更新时间 `2023-03-08 11:32:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowHistoryGetRequest {
  /**
   * 业务编号
   */
  businessNo: string;
  /**
   * 表单类型1-申请单,2-报销单
   */
  formType: string;
}

/**
 * 接口 [审批历史↗](http://yapi.cai-inc.com/project/3621/interface/api/239638) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history`
 * @更新时间 `2023-03-08 11:32:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowHistoryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 审批历史
     */
    approveTime?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [审批历史↗](http://yapi.cai-inc.com/project/3621/interface/api/239638) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history`
 * @更新时间 `2023-03-08 11:32:40`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowHistoryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/history',
    'data',
    string,
    'businessNo' | 'formType',
    false
  >
>;

/**
 * 接口 [审批历史↗](http://yapi.cai-inc.com/project/3621/interface/api/239638) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history`
 * @更新时间 `2023-03-08 11:32:40`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowHistoryGetRequestConfig: ZlbApiExpenseWorkflowHistoryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/history',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: ['businessNo', 'formType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowHistoryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审批历史↗](http://yapi.cai-inc.com/project/3621/interface/api/239638) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/history`
 * @更新时间 `2023-03-08 11:32:40`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowHistoryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowHistoryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowHistoryGetResponse>(
    prepare(zlbApiExpenseWorkflowHistoryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowHistoryGet.requestConfig = zlbApiExpenseWorkflowHistoryGetRequestConfig;

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242532) 的 **请求类型**
 *
 * @状态 未完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2022-05-30 09:48:11`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowGetCommonAuditorGetRequest {
  /**
   * 查询类型，0：按部门，1：按全机构，2：全平台，3-按岗位
   */
  userRangeType: string;
  /**
   * 所需要查询的部门或者岗位列表
   */
  jobCodes?: string;
}

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242532) 的 **返回类型**
 *
 * @状态 未完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2022-05-30 09:48:11`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowGetCommonAuditorGetResponse {
  success?: boolean;
  /**
   * [{"auditorId":0,"auditorName":"@string"}]
   */
  result?: {
    auditorId?: number;
    /**
     * "@string"
     */
    auditorName?: string;
  }[];
  /**
   * "@string"
   */
  code?: string;
  /**
   * "@string"
   */
  message?: string;
}

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242532) 的 **请求配置的类型**
 *
 * @状态 未完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2022-05-30 09:48:11`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowGetCommonAuditorGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/getCommonAuditor',
    'data',
    string,
    'userRangeType' | 'jobCodes',
    false
  >
>;

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242532) 的 **请求配置**
 *
 * @状态 未完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2022-05-30 09:48:11`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowGetCommonAuditorGetRequestConfig: ZlbApiExpenseWorkflowGetCommonAuditorGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/getCommonAuditor',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: ['userRangeType', 'jobCodes'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowGetCommonAuditorGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242532) 的 **请求函数**
 *
 * @状态 未完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2022-05-30 09:48:11`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowGetCommonAuditorGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowGetCommonAuditorGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowGetCommonAuditorGetResponse>(
    prepare(zlbApiExpenseWorkflowGetCommonAuditorGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowGetCommonAuditorGet.requestConfig =
  zlbApiExpenseWorkflowGetCommonAuditorGetRequestConfig;

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242772) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowGetCommonAuditorPostRequest {
  /**
   * 查询类型
   */
  userRangeType: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 所需要查询的部门或者岗位列表
   */
  userRangeValues?: string[];
  /**
   * 新查询类型
   */
  userRangeTypeNew?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 新所需要查询的部门或者岗位列表
   */
  userRangeValuesNew?: string[];
  departmentId?: number;
  organizationId?: number;
}

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242772) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowGetCommonAuditorPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    displayName?: string;
    userId?: number;
    operatorId?: number;
    institution?: {
      id?: number;
      createdAt?: number;
      updatedAt?: number;
      creatorId?: string;
      modifierId?: string;
      extFields?: string;
      name?: string;
      shortName?: string;
      orgCode?: string;
      creditCode?: string;
      bizAttaches?: string;
      tags?: string;
      provinceCode?: string;
      provinceName?: string;
      cityCode?: string;
      cityName?: string;
      regionCode?: string;
      regionName?: string;
      address?: string;
      status?: number;
      displayOrder?: number;
      outCreatedAt?: string;
      divisionCode?: string;
      fullName?: string;
      postalCode?: string;
      source?: number;
      organizationCode?: string;
      institutionLevel?: number;
    };
    code?: string;
    gender?: number;
    institutionId?: number;
    deptName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242772) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowGetCommonAuditorPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/getCommonAuditor',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242772) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowGetCommonAuditorPostRequestConfig: ZlbApiExpenseWorkflowGetCommonAuditorPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/getCommonAuditor',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowGetCommonAuditorPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询常用审核人↗](http://yapi.cai-inc.com/project/3621/interface/api/242772) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getCommonAuditor`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowGetCommonAuditorPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowGetCommonAuditorPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowGetCommonAuditorPostResponse>(
    prepare(zlbApiExpenseWorkflowGetCommonAuditorPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowGetCommonAuditorPost.requestConfig =
  zlbApiExpenseWorkflowGetCommonAuditorPostRequestConfig;

/**
 * 接口 [运营机构查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/246836) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/operateQuery`
 * @更新时间 `2022-03-24 19:48:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowOperateQueryGetRequest {
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 单据类型
   * 1 :1-申请单、2-报销单
   * 2 :报销单
   */
  formType?: string;
  /**
   * 部门id
   */
  depId?: string;
  /**
   * 金额
   */
  amount?: string;
  /**
   * 业务单号
   */
  businessNo?: string;
  /**
   * 工作流业务key
   */
  workflowProcessKey: string;
  /**
   * 工作流模型id
   */
  workflowModelId?: string;
  /**
   * 工作流版本号
   */
  workflowVersion?: string;
}

/**
 * 接口 [运营机构查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/246836) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/operateQuery`
 * @更新时间 `2022-03-24 19:48:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowOperateQueryGetResponse {
  success?: boolean;
  result?: {
    /**
     * [{"auditOperatorList":[{"auditRemark":"","auditStatus":0,"auditTime":"@datetime","operatorId":0,"operatorName":"","institutionId":0,"institutionName":""}],"userRangeType":0,"userRangeValues":[""],"personCount":0,"auditStatus":0,"auditTime":"@datetime","auditDesc":"","auditType":0,"eventType":0,"nodeType":0,"nodeKey":"","nodeName":""}]
     */
    auditNodeList?: {
      /**
       * [{"auditRemark":"","auditStatus":0,"auditTime":"@datetime","operatorId":0,"operatorName":"","institutionId":0,"institutionName":""}]
       */
      auditOperatorList?: {
        auditRemark?: string;
        auditStatus?: number;
        /**
         * "@datetime"
         */
        auditTime?: string;
        operatorId?: number;
        operatorName?: string;
        institutionId?: number;
        institutionName?: string;
      }[];
      userRangeType?: number;
      /**
       * [""]
       */
      userRangeValues?: string[];
      personCount?: number;
      auditStatus?: number;
      /**
       * "@datetime"
       */
      auditTime?: string;
      auditDesc?: string;
      auditType?: number;
      eventType?: number;
      nodeType?: number;
      nodeKey?: string;
      nodeName?: string;
    }[];
    workflowProcessKey?: string;
    workflowModelId?: number;
    workflowVersion?: number;
    applyOperatorId?: number;
    applyOperatorName?: string;
    /**
     * "@datetime"
     */
    applyTime?: string;
    applyRemark?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [运营机构查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/246836) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/operateQuery`
 * @更新时间 `2022-03-24 19:48:18`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowOperateQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/operateQuery',
    'data',
    string,
    | 'formCode'
    | 'formType'
    | 'depId'
    | 'amount'
    | 'businessNo'
    | 'workflowProcessKey'
    | 'workflowModelId'
    | 'workflowVersion',
    false
  >
>;

/**
 * 接口 [运营机构查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/246836) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/operateQuery`
 * @更新时间 `2022-03-24 19:48:18`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowOperateQueryGetRequestConfig: ZlbApiExpenseWorkflowOperateQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/operateQuery',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [
      'formCode',
      'formType',
      'depId',
      'amount',
      'businessNo',
      'workflowProcessKey',
      'workflowModelId',
      'workflowVersion',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowOperateQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [运营机构查询工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/246836) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/operateQuery`
 * @更新时间 `2022-03-24 19:48:18`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowOperateQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowOperateQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowOperateQueryGetResponse>(
    prepare(zlbApiExpenseWorkflowOperateQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowOperateQueryGet.requestConfig =
  zlbApiExpenseWorkflowOperateQueryGetRequestConfig;

/**
 * 接口 [驳回原因↗](http://yapi.cai-inc.com/project/3621/interface/api/248080) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/refuseReason`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowRefuseReasonGetRequest {
  /**
   * 业务编号
   */
  businessNo: string;
  /**
   * 表单类型1-申请单,2-报销单
   */
  formType: string;
}

/**
 * 接口 [驳回原因↗](http://yapi.cai-inc.com/project/3621/interface/api/248080) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/refuseReason`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowRefuseReasonGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    refuseReason?: string;
    refuseUser?: string;
    isRefuse?: boolean;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [驳回原因↗](http://yapi.cai-inc.com/project/3621/interface/api/248080) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/refuseReason`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowRefuseReasonGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/refuseReason',
    'data',
    string,
    'businessNo' | 'formType',
    false
  >
>;

/**
 * 接口 [驳回原因↗](http://yapi.cai-inc.com/project/3621/interface/api/248080) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/refuseReason`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowRefuseReasonGetRequestConfig: ZlbApiExpenseWorkflowRefuseReasonGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/refuseReason',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: ['businessNo', 'formType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowRefuseReasonGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [驳回原因↗](http://yapi.cai-inc.com/project/3621/interface/api/248080) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/refuseReason`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowRefuseReasonGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowRefuseReasonGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowRefuseReasonGetResponse>(
    prepare(zlbApiExpenseWorkflowRefuseReasonGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowRefuseReasonGet.requestConfig =
  zlbApiExpenseWorkflowRefuseReasonGetRequestConfig;

/**
 * 接口 [查询单据驳回记录↗](http://yapi.cai-inc.com/project/3621/interface/api/251774) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/reject/history`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowRejectHistoryGetRequest {
  /**
   * 单据code
   */
  formCode?: string;
}

/**
 * 接口 [查询单据驳回记录↗](http://yapi.cai-inc.com/project/3621/interface/api/251774) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/reject/history`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowRejectHistoryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    workflowQueryRO?: {
      auditNodeList?: {
        auditOperatorList?: {
          operatorId?: number;
          operatorName?: string;
          institutionId?: number;
          institutionName?: string;
          auditRemark?: string;
          auditStatus?: number;
          auditTime?: string;
          signAttachment?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          oneselfHistorySignAttachment?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          addAuditWay?: number;
          addAuditOperator?: string;
          comment?: {
            commentContent?: string;
            operatorId?: number;
            operatorName?: string;
            commentCode?: string;
            commentTime?: number;
            pictureAttachments?: {
              fileId?: string;
              type?: string;
              bizNo?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            otherAttachments?: {
              fileId?: string;
              type?: string;
              bizNo?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            remove?: boolean;
          };
          operatorType?: number;
        }[];
        userRangeType?: number;
        userRangeTypeNew?: number;
        userRangeValues?: string[];
        userRangeValuesNew?: string[];
        personCount?: number;
        auditStatus?: number;
        auditTime?: string;
        auditDesc?: string;
        auditType?: number;
        eventType?: number;
        nodeType?: number;
        nodeKey?: string;
        nodeName?: string;
        checkStrategy?: number;
        departmentId?: number;
        institutionSelfDtos?: {
          code?: string;
          name?: string;
          userType?: string;
          tenantCode?: string;
          tenantName?: string;
          uniqueKey?: string;
          parentInstitution?: {
            parentCode?: number;
            parentName?: string;
          };
        }[];
        commonAuditorList?: {
          displayName?: string;
          userId?: number;
          operatorId?: number;
          code?: string;
          gender?: number;
          institutionId?: number;
          institution?: {
            id?: number;
            createdAt?: number;
            updatedAt?: number;
            creatorId?: string;
            modifierId?: string;
            extFields?: string;
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string;
            tags?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            divisionCode?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
          };
          deptName?: string;
        }[];
        bizProperty?: string;
        comment?: {
          commentContent?: string;
          operatorId?: number;
          operatorName?: string;
          commentCode?: string;
          commentTime?: number;
          pictureAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          otherAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          remove?: boolean;
        };
      }[];
      workflowProcessKey?: string;
      workflowModelId?: number;
      workflowVersion?: number;
      applyOperatorId?: number;
      applyOperatorName?: string;
      applyTime?: string;
      applyRemark?: string;
      isAddTaskAccess?: number;
      formType?: number;
      isEnableSign?: boolean;
      signConfig?: number;
    };
    auditTime?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单据驳回记录↗](http://yapi.cai-inc.com/project/3621/interface/api/251774) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/reject/history`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowRejectHistoryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/reject/history',
    'data',
    string,
    'formCode',
    false
  >
>;

/**
 * 接口 [查询单据驳回记录↗](http://yapi.cai-inc.com/project/3621/interface/api/251774) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/reject/history`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowRejectHistoryGetRequestConfig: ZlbApiExpenseWorkflowRejectHistoryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/reject/history',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: ['formCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowRejectHistoryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单据驳回记录↗](http://yapi.cai-inc.com/project/3621/interface/api/251774) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/reject/history`
 * @更新时间 `2024-09-11 14:56:07`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowRejectHistoryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowRejectHistoryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowRejectHistoryGetResponse>(
    prepare(zlbApiExpenseWorkflowRejectHistoryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowRejectHistoryGet.requestConfig =
  zlbApiExpenseWorkflowRejectHistoryGetRequestConfig;

/**
 * 接口 [加签老接口↗](http://yapi.cai-inc.com/project/3621/interface/api/254132) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/addTask`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowAddTaskPostRequest {
  /**
   * 业务单号
   */
  businessNo?: string;
  /**
   * 单据类型：1-申请单，2-报销单，4-工资发放申请单
   */
  formType?: number;
  /**
   * 工作流业务key
   */
  workflowProcessKey: string;
  /**
   * 工作流模型id
   */
  workflowModelId?: number;
  /**
   * 工作流版本号
   */
  workflowVersion?: number;
  /**
   * 加签方式 1-前加签 2-后加签
   */
  addTaskWay?: number;
  /**
   * 加签原因
   */
  addTaskReason?: string;
  /**
   * 当前节点key
   */
  currentNodeKey: string;
  /**
   * 加签人员列表不能为空
   */
  auditOperatorList: {
    operatorId?: number;
    operatorName?: string;
    institutionId?: number;
    institutionName?: string;
    auditRemark?: string;
    auditStatus?: number;
    auditTime?: string;
    signAttachment?: {
      fileId?: string;
      type?: string;
      bizNo?: string;
      name?: string;
      size?: number;
      bizCode?: string;
      url?: string;
      sizeDesc?: string;
    };
    oneselfHistorySignAttachment?: {
      fileId?: string;
      type?: string;
      bizNo?: string;
      name?: string;
      size?: number;
      bizCode?: string;
      url?: string;
      sizeDesc?: string;
    };
    addAuditWay?: number;
    addAuditOperator?: string;
    comment?: {
      commentContent?: string;
      operatorId?: number;
      operatorName?: string;
      commentCode?: string;
      commentTime?: number;
      pictureAttachments?: {
        fileId?: string;
        type?: string;
        bizNo?: string;
        name?: string;
        size?: number;
        bizCode?: string;
        url?: string;
        sizeDesc?: string;
      }[];
      otherAttachments?: {
        fileId?: string;
        type?: string;
        bizNo?: string;
        name?: string;
        size?: number;
        bizCode?: string;
        url?: string;
        sizeDesc?: string;
      }[];
      remove?: boolean;
    };
    operatorType?: number;
  }[];
  /**
   * 签名类型 1-加签 3-加抄送签
   */
  operatorType?: number;
}

/**
 * 接口 [加签老接口↗](http://yapi.cai-inc.com/project/3621/interface/api/254132) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/addTask`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowAddTaskPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [加签老接口↗](http://yapi.cai-inc.com/project/3621/interface/api/254132) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/addTask`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowAddTaskPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/addTask',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加签老接口↗](http://yapi.cai-inc.com/project/3621/interface/api/254132) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/addTask`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowAddTaskPostRequestConfig: ZlbApiExpenseWorkflowAddTaskPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/addTask',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowAddTaskPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加签老接口↗](http://yapi.cai-inc.com/project/3621/interface/api/254132) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/workflow/addTask`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowAddTaskPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowAddTaskPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowAddTaskPostResponse>(
    prepare(zlbApiExpenseWorkflowAddTaskPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowAddTaskPost.requestConfig = zlbApiExpenseWorkflowAddTaskPostRequestConfig;

/**
 * 接口 [恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/312690) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowResumePostRequest {
  /**
   * 业务单号
   */
  businessNo: string;
  /**
   * 单据类型：1-申请单，2-报销单
   */
  formType: number;
  /**
   * 操作人员类别
   * 1-运营人员，2-普通用户
   */
  operatorType?: number;
  /**
   * 恢复备注
   */
  resumeRemark: string;
}

/**
 * 接口 [恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/312690) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowResumePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/312690) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowResumePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/resume',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/312690) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowResumePostRequestConfig: ZlbApiExpenseWorkflowResumePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/resume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowResumePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/312690) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowResumePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowResumePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowResumePostResponse>(
    prepare(zlbApiExpenseWorkflowResumePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowResumePost.requestConfig = zlbApiExpenseWorkflowResumePostRequestConfig;

/**
 * 接口 [getTemplate↗](http://yapi.cai-inc.com/project/3621/interface/api/461034) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowGetTemplateGetRequest {
  processDefineKey?: string;
  bizId?: string;
  bizType?: string;
  subType?: string;
  'extConditions.key.key'?: string;
  amount?: string;
  eventBudget?: string;
  departmentId?: string;
  operatorId?: string;
  'accompanyOperatorIds[0]'?: string;
  arrangeCar?: string;
  travelType?: string;
  'projectUks[0]'?: string;
}

/**
 * 接口 [getTemplate↗](http://yapi.cai-inc.com/project/3621/interface/api/461034) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowGetTemplateGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    auditNodeList?: {
      auditOperatorList?: {
        operatorId?: number;
        operatorName?: string;
        institutionId?: number;
        institutionName?: string;
        auditRemark?: string;
        auditStatus?: number;
        auditTime?: string;
        signAttachment?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        oneselfHistorySignAttachment?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        addAuditWay?: number;
        addAuditOperator?: string;
        comment?: {
          commentContent?: string;
          operatorId?: number;
          operatorName?: string;
          commentCode?: string;
          commentTime?: number;
          pictureAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          otherAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          remove?: boolean;
        };
        operatorType?: number;
      }[];
      userRangeType?: number;
      userRangeTypeNew?: number;
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      personCount?: number;
      auditStatus?: number;
      auditTime?: string;
      auditDesc?: string;
      auditType?: number;
      eventType?: number;
      nodeType?: number;
      nodeKey?: string;
      nodeName?: string;
      checkStrategy?: number;
      departmentId?: number;
      institutionSelfDtos?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      commonAuditorList?: {
        displayName?: string;
        userId?: number;
        operatorId?: number;
        code?: string;
        gender?: number;
        institutionId?: number;
        institution?: {
          id?: number;
          createdAt?: number;
          updatedAt?: number;
          creatorId?: string;
          modifierId?: string;
          extFields?: string;
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string;
          tags?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          divisionCode?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
        };
        deptName?: string;
      }[];
      bizProperty?: string;
      comment?: {
        commentContent?: string;
        operatorId?: number;
        operatorName?: string;
        commentCode?: string;
        commentTime?: number;
        pictureAttachments?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        }[];
        otherAttachments?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        }[];
        remove?: boolean;
      };
    }[];
    workflowProcessKey?: string;
    workflowModelId?: number;
    workflowVersion?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [getTemplate↗](http://yapi.cai-inc.com/project/3621/interface/api/461034) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowGetTemplateGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/getTemplate',
    'data',
    string,
    | 'processDefineKey'
    | 'bizId'
    | 'bizType'
    | 'subType'
    | 'extConditions.key.key'
    | 'amount'
    | 'eventBudget'
    | 'departmentId'
    | 'operatorId'
    | 'accompanyOperatorIds[0]'
    | 'arrangeCar'
    | 'travelType'
    | 'projectUks[0]',
    false
  >
>;

/**
 * 接口 [getTemplate↗](http://yapi.cai-inc.com/project/3621/interface/api/461034) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowGetTemplateGetRequestConfig: ZlbApiExpenseWorkflowGetTemplateGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/getTemplate',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [
      'processDefineKey',
      'bizId',
      'bizType',
      'subType',
      'extConditions.key.key',
      'amount',
      'eventBudget',
      'departmentId',
      'operatorId',
      'accompanyOperatorIds[0]',
      'arrangeCar',
      'travelType',
      'projectUks[0]',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowGetTemplateGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getTemplate↗](http://yapi.cai-inc.com/project/3621/interface/api/461034) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `GET /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowGetTemplateGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowGetTemplateGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowGetTemplateGetResponse>(
    prepare(zlbApiExpenseWorkflowGetTemplateGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowGetTemplateGet.requestConfig =
  zlbApiExpenseWorkflowGetTemplateGetRequestConfig;

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/3621/interface/api/465626) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/addCounterSign`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowAddCounterSignPostRequest {
  bizId: string;
  curTaskDefineKey?: string;
  operatorIds?: number[];
  bizType: string;
  subType?: string;
  countersignType?: number;
  remark?: string;
  context?: string;
  operatorId?: number;
  operatorType?: number;
}

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/3621/interface/api/465626) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/addCounterSign`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowAddCounterSignPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/3621/interface/api/465626) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/addCounterSign`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowAddCounterSignPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/addCounterSign',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/3621/interface/api/465626) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/addCounterSign`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowAddCounterSignPostRequestConfig: ZlbApiExpenseWorkflowAddCounterSignPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/addCounterSign',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowAddCounterSignPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加签↗](http://yapi.cai-inc.com/project/3621/interface/api/465626) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/addCounterSign`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowAddCounterSignPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowAddCounterSignPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowAddCounterSignPostResponse>(
    prepare(zlbApiExpenseWorkflowAddCounterSignPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowAddCounterSignPost.requestConfig =
  zlbApiExpenseWorkflowAddCounterSignPostRequestConfig;

/**
 * 接口 [财务岗恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/488058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/cashier/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowCashierResumePostRequest {
  /**
   * 业务单号
   */
  businessNo: string;
  /**
   * 单据类型：1-申请单，2-报销单
   */
  formType: number;
  /**
   * 操作人员类别
   * 1-运营人员，2-普通用户
   */
  operatorType?: number;
  /**
   * 恢复备注
   */
  resumeRemark: string;
}

/**
 * 接口 [财务岗恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/488058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/cashier/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowCashierResumePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [财务岗恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/488058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/cashier/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowCashierResumePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/cashier/resume',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [财务岗恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/488058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/cashier/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowCashierResumePostRequestConfig: ZlbApiExpenseWorkflowCashierResumePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/cashier/resume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowCashierResumePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [财务岗恢复为未提交状态（单据逆流程）↗](http://yapi.cai-inc.com/project/3621/interface/api/488058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/cashier/resume`
 * @更新时间 `2024-09-11 14:56:09`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowCashierResumePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowCashierResumePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowCashierResumePostResponse>(
    prepare(zlbApiExpenseWorkflowCashierResumePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowCashierResumePost.requestConfig =
  zlbApiExpenseWorkflowCashierResumePostRequestConfig;

/**
 * 接口 [工作流审批新接口，后续可直接使用组件中的接口定义替换↗](http://yapi.cai-inc.com/project/3621/interface/api/620362) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/auditV2`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowAuditV2PostRequest {
  bizId?: string;
  bizType?: string;
  subType?: string;
  auditRemark?: string;
  executeType: number;
  processDefineKey?: string;
  currentNodeKey: string;
  operatorId?: number;
  context?: string;
  eventType: number;
  rejectNodeKey?: string;
  signAttachment?: {
    fileId?: string;
    type?: string;
    bizNo?: string;
    name?: string;
    size?: number;
    bizCode?: string;
    url?: string;
    sizeDesc?: string;
  };
}

/**
 * 接口 [工作流审批新接口，后续可直接使用组件中的接口定义替换↗](http://yapi.cai-inc.com/project/3621/interface/api/620362) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/auditV2`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowAuditV2PostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [工作流审批新接口，后续可直接使用组件中的接口定义替换↗](http://yapi.cai-inc.com/project/3621/interface/api/620362) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/auditV2`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowAuditV2PostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/auditV2',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [工作流审批新接口，后续可直接使用组件中的接口定义替换↗](http://yapi.cai-inc.com/project/3621/interface/api/620362) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/auditV2`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowAuditV2PostRequestConfig: ZlbApiExpenseWorkflowAuditV2PostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/auditV2',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowAuditV2Post',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [工作流审批新接口，后续可直接使用组件中的接口定义替换↗](http://yapi.cai-inc.com/project/3621/interface/api/620362) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/auditV2`
 * @更新时间 `2024-09-11 14:56:08`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowAuditV2Post = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowAuditV2PostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowAuditV2PostResponse>(
    prepare(zlbApiExpenseWorkflowAuditV2PostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowAuditV2Post.requestConfig = zlbApiExpenseWorkflowAuditV2PostRequestConfig;

/**
 * 接口 [getTemplateV2↗](http://yapi.cai-inc.com/project/3621/interface/api/667690) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowGetTemplatePostRequest {
  processDefineKey?: string;
  bizId?: string;
  bizType?: string;
  subType?: string;
  extConditions?: {
    key?: {};
  };
  amount?: number;
  eventBudget?: number;
  departmentId?: number;
  operatorId?: number;
  accompanyOperatorIds?: number[];
  arrangeCar?: string;
  travelType?: number;
  projectUks?: string[];
}

/**
 * 接口 [getTemplateV2↗](http://yapi.cai-inc.com/project/3621/interface/api/667690) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkflowGetTemplatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    auditNodeList?: {
      auditOperatorList?: {
        operatorId?: number;
        operatorName?: string;
        institutionId?: number;
        institutionName?: string;
        auditRemark?: string;
        auditStatus?: number;
        auditTime?: string;
        signAttachment?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        oneselfHistorySignAttachment?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        addAuditWay?: number;
        addAuditOperator?: string;
        comment?: {
          commentContent?: string;
          operatorId?: number;
          operatorName?: string;
          commentCode?: string;
          commentTime?: number;
          pictureAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          otherAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          remove?: boolean;
        };
        operatorType?: number;
      }[];
      userRangeType?: number;
      userRangeTypeNew?: number;
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      personCount?: number;
      auditStatus?: number;
      auditTime?: string;
      auditDesc?: string;
      auditType?: number;
      eventType?: number;
      nodeType?: number;
      nodeKey?: string;
      nodeName?: string;
      checkStrategy?: number;
      departmentId?: number;
      institutionSelfDtos?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      commonAuditorList?: {
        displayName?: string;
        userId?: number;
        operatorId?: number;
        code?: string;
        gender?: number;
        institutionId?: number;
        institution?: {
          id?: number;
          createdAt?: number;
          updatedAt?: number;
          creatorId?: string;
          modifierId?: string;
          extFields?: string;
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string;
          tags?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          divisionCode?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
        };
        deptName?: string;
      }[];
      bizProperty?: string;
      comment?: {
        commentContent?: string;
        operatorId?: number;
        operatorName?: string;
        commentCode?: string;
        commentTime?: number;
        pictureAttachments?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        }[];
        otherAttachments?: {
          fileId?: string;
          type?: string;
          bizNo?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        }[];
        remove?: boolean;
      };
    }[];
    workflowProcessKey?: string;
    workflowModelId?: number;
    workflowVersion?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [getTemplateV2↗](http://yapi.cai-inc.com/project/3621/interface/api/667690) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkflowGetTemplatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/workflow/getTemplate',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [getTemplateV2↗](http://yapi.cai-inc.com/project/3621/interface/api/667690) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
const zlbApiExpenseWorkflowGetTemplatePostRequestConfig: ZlbApiExpenseWorkflowGetTemplatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: '/zlb/api/expense/workflow/getTemplate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkflowGetTemplatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getTemplateV2↗](http://yapi.cai-inc.com/project/3621/interface/api/667690) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35955)
 * @请求头 `POST /zlb/api/expense/workflow/getTemplate`
 * @更新时间 `2024-09-11 14:56:06`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkflowGetTemplatePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkflowGetTemplatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkflowGetTemplatePostResponse>(
    prepare(zlbApiExpenseWorkflowGetTemplatePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkflowGetTemplatePost.requestConfig =
  zlbApiExpenseWorkflowGetTemplatePostRequestConfig;

const mockUrl_0_1_0_2 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_2 = '' as any;
const prodUrl_0_1_0_2 = '' as any;
const dataKey_0_1_0_2 = 'data' as any;

/**
 * 接口 [获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231886) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFeeTypeGetGetRequest {}

/**
 * 接口 [获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231886) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFeeTypeGetGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 费用主类型枚举
     */
    feeMainType?: number;
    /**
     * 主类型描述
     */
    feeMainTypeDesc?: string;
    /**
     * 费用类别
     */
    feeTypes?: {
      /**
       * 通用key
       */
      key?: number;
      /**
       * 配置中心-配置code专用
       */
      code?: string;
      /**
       * 通用描述
       */
      desc?: string;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231886) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonFeeTypeGetGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/feeType/get',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231886) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
const zlbApiExpenseCommonFeeTypeGetGetRequestConfig: ZlbApiExpenseCommonFeeTypeGetGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/feeType/get',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonFeeTypeGetGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231886) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonFeeTypeGetGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseCommonFeeTypeGetGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonFeeTypeGetGetResponse>(
    prepare(zlbApiExpenseCommonFeeTypeGetGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonFeeTypeGetGet.requestConfig = zlbApiExpenseCommonFeeTypeGetGetRequestConfig;

/**
 * 接口 [根据费用类型获取座位类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231894) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/seatType`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFeeTypeSeatTypeGetRequest {
  feeType?: string;
}

/**
 * 接口 [根据费用类型获取座位类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231894) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/seatType`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFeeTypeSeatTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 通用key
     */
    key?: number;
    /**
     * 配置中心-配置code专用
     */
    code?: string;
    /**
     * 通用描述
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据费用类型获取座位类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231894) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/seatType`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonFeeTypeSeatTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/feeType/seatType',
    'data',
    string,
    'feeType',
    false
  >
>;

/**
 * 接口 [根据费用类型获取座位类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231894) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/seatType`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
const zlbApiExpenseCommonFeeTypeSeatTypeGetRequestConfig: ZlbApiExpenseCommonFeeTypeSeatTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/feeType/seatType',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['feeType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonFeeTypeSeatTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据费用类型获取座位类型↗](http://yapi.cai-inc.com/project/3621/interface/api/231894) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/seatType`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonFeeTypeSeatTypeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonFeeTypeSeatTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonFeeTypeSeatTypeGetResponse>(
    prepare(zlbApiExpenseCommonFeeTypeSeatTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonFeeTypeSeatTypeGet.requestConfig =
  zlbApiExpenseCommonFeeTypeSeatTypeGetRequestConfig;

/**
 * 接口 [根据添加方式获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/233758) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get/addType/{addType}`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGetRequest {
  addType: string;
}

/**
 * 接口 [根据添加方式获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/233758) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get/addType/{addType}`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 通用key
     */
    key?: number;
    /**
     * 配置中心-配置code专用
     */
    code?: string;
    /**
     * 通用描述
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据添加方式获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/233758) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get/addType/{addType}`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/feeType/get/addType/{addType}',
    'data',
    'addType',
    string,
    false
  >
>;

/**
 * 接口 [根据添加方式获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/233758) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get/addType/{addType}`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
const zlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGetRequestConfig: ZlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/feeType/get/addType/{addType}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: ['addType'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据添加方式获取费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/233758) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/get/addType/{addType}`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGetResponse>(
    prepare(zlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGet.requestConfig =
  zlbApiExpenseCommonFeeTypeGetAddTypeAddTypeGetRequestConfig;

/**
 * 接口 [生成费用添加方式↗](http://yapi.cai-inc.com/project/3621/interface/api/233766) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/addType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonAddTypeGetGetRequest {}

/**
 * 接口 [生成费用添加方式↗](http://yapi.cai-inc.com/project/3621/interface/api/233766) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/addType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonAddTypeGetGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 通用key
     */
    key?: number;
    /**
     * 配置中心-配置code专用
     */
    code?: string;
    /**
     * 通用描述
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [生成费用添加方式↗](http://yapi.cai-inc.com/project/3621/interface/api/233766) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/addType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonAddTypeGetGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/addType/get',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [生成费用添加方式↗](http://yapi.cai-inc.com/project/3621/interface/api/233766) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/addType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
const zlbApiExpenseCommonAddTypeGetGetRequestConfig: ZlbApiExpenseCommonAddTypeGetGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/addType/get',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonAddTypeGetGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [生成费用添加方式↗](http://yapi.cai-inc.com/project/3621/interface/api/233766) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/addType/get`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonAddTypeGetGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseCommonAddTypeGetGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonAddTypeGetGetResponse>(
    prepare(zlbApiExpenseCommonAddTypeGetGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonAddTypeGetGet.requestConfig = zlbApiExpenseCommonAddTypeGetGetRequestConfig;

/**
 * 接口 [获取费用搜索类型↗](http://yapi.cai-inc.com/project/3621/interface/api/236254) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/searchType`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFeeTypeSearchTypeGetRequest {}

/**
 * 接口 [获取费用搜索类型↗](http://yapi.cai-inc.com/project/3621/interface/api/236254) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/searchType`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFeeTypeSearchTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 通用key
     */
    key?: number;
    /**
     * 配置中心-配置code专用
     */
    code?: string;
    /**
     * 通用描述
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取费用搜索类型↗](http://yapi.cai-inc.com/project/3621/interface/api/236254) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/searchType`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonFeeTypeSearchTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/feeType/searchType',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取费用搜索类型↗](http://yapi.cai-inc.com/project/3621/interface/api/236254) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/searchType`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
const zlbApiExpenseCommonFeeTypeSearchTypeGetRequestConfig: ZlbApiExpenseCommonFeeTypeSearchTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/feeType/searchType',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonFeeTypeSearchTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取费用搜索类型↗](http://yapi.cai-inc.com/project/3621/interface/api/236254) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/feeType/searchType`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonFeeTypeSearchTypeGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseCommonFeeTypeSearchTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonFeeTypeSearchTypeGetResponse>(
    prepare(zlbApiExpenseCommonFeeTypeSearchTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonFeeTypeSearchTypeGet.requestConfig =
  zlbApiExpenseCommonFeeTypeSearchTypeGetRequestConfig;

/**
 * 接口 [火车时长枚举↗](http://yapi.cai-inc.com/project/3621/interface/api/236854) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/trainTimeHour`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTrainTimeHourGetRequest {}

/**
 * 接口 [火车时长枚举↗](http://yapi.cai-inc.com/project/3621/interface/api/236854) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/trainTimeHour`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTrainTimeHourGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 通用key
     */
    key?: number;
    /**
     * 配置中心-配置code专用
     */
    code?: string;
    /**
     * 通用描述
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [火车时长枚举↗](http://yapi.cai-inc.com/project/3621/interface/api/236854) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/trainTimeHour`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonTrainTimeHourGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/trainTimeHour',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [火车时长枚举↗](http://yapi.cai-inc.com/project/3621/interface/api/236854) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/trainTimeHour`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
const zlbApiExpenseCommonTrainTimeHourGetRequestConfig: ZlbApiExpenseCommonTrainTimeHourGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/trainTimeHour',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonTrainTimeHourGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [火车时长枚举↗](http://yapi.cai-inc.com/project/3621/interface/api/236854) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/trainTimeHour`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonTrainTimeHourGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseCommonTrainTimeHourGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonTrainTimeHourGetResponse>(
    prepare(zlbApiExpenseCommonTrainTimeHourGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonTrainTimeHourGet.requestConfig =
  zlbApiExpenseCommonTrainTimeHourGetRequestConfig;

/**
 * 接口 [我的审批↗](http://yapi.cai-inc.com/project/3621/interface/api/238198) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-approval`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonMyApprovalGetRequest {
  /**
   * 需要展示的单据数量
   */
  count?: string;
}

/**
 * 接口 [我的审批↗](http://yapi.cai-inc.com/project/3621/interface/api/238198) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-approval`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonMyApprovalGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单据列表
     */
    list?: {
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 业务单据号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?: number;
      /**
       * 单据类型
       */
      formTypeName?: string;
      /**
       * 业务单据类型
       */
      businessFormType?: number;
      /**
       * 业务单据类型
       */
      businessFormTypeName?: string;
      /**
       * 申请/报销事由
       */
      reason?: string;
      /**
       * 申请人/报销人operatorId
       */
      operatorId?: number;
      /**
       * 申请人/报销人姓名
       */
      userName?: string;
      /**
       * 申请人/报销人所在单位
       */
      orgName?: string;
      /**
       * 申请人/报销人所在部门
       */
      deptName?: string;
      /**
       * 创建时间
       */
      initiationTime?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 报销金额
       */
      expenseAmount?: number;
      /**
       * 单据状态
       */
      formStatus?: number;
      /**
       * 单据状态名称
       */
      formStatusName?: string;
      /**
       * 处理中状态：IN_APPROVAL-审核；IN_AUDIT-审核中
       */
      processStatus?: string;
    }[];
    /**
     * 剩余单据数量
     */
    count?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [我的审批↗](http://yapi.cai-inc.com/project/3621/interface/api/238198) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-approval`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonMyApprovalGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/my-approval',
    'data',
    string,
    'count',
    false
  >
>;

/**
 * 接口 [我的审批↗](http://yapi.cai-inc.com/project/3621/interface/api/238198) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-approval`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
const zlbApiExpenseCommonMyApprovalGetRequestConfig: ZlbApiExpenseCommonMyApprovalGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/my-approval',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['count'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonMyApprovalGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [我的审批↗](http://yapi.cai-inc.com/project/3621/interface/api/238198) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-approval`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonMyApprovalGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonMyApprovalGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonMyApprovalGetResponse>(
    prepare(zlbApiExpenseCommonMyApprovalGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonMyApprovalGet.requestConfig = zlbApiExpenseCommonMyApprovalGetRequestConfig;

/**
 * 接口 [我的单据↗](http://yapi.cai-inc.com/project/3621/interface/api/238374) 的 **请求类型**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-form`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonMyFormGetRequest {
  /**
   * 需要展示的单据数量
   */
  count?: string;
}

/**
 * 接口 [我的单据↗](http://yapi.cai-inc.com/project/3621/interface/api/238374) 的 **返回类型**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-form`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonMyFormGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单据列表
     */
    list?: {
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 业务单据号
       */
      businessCode?: string;
      /**
       * 单据状态
       * 申请单：1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
       * 报销单：0-未提交、1-审核中、2-已驳回、3-结算中、4-已完成
       */
      formStatus?: number;
      /**
       * 单据状态名称
       * 申请单：1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
       * 报销单：0-未提交、1-审核中、2-已驳回、3-结算中、4-已完成
       */
      formStatusName?: string;
      /**
       * 单据类型
       * 1-申请单、2-报销单、3-外部申请单
       */
      formType?: number;
      /**
       * 单据类型名称
       * 1-申请单、2-报销单、3-外部申请单
       */
      formTypeName?: string;
      /**
       * 申请单业务单据类型
       * 1-差旅、2-会议、3-培训、4-办公用品采购、5-用印、6-公务接待、7-一般事项
       */
      businessFormType?: number;
      /**
       * 申请单业务单据类型名称
       * 1-差旅、2-会议、3-培训、4-办公用品采购、5-用印、6-公务接待、7-一般事项
       */
      businessFormTypeName?: string;
      /**
       * 申请/报销事由
       */
      reason?: string;
      /**
       * 创建时间
       */
      initiationTime?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 报销金额
       */
      expenseAmount?: number;
      /**
       * 用户类别
       * 1-本人、2-审核人、3-审批人、4-同行人
       */
      userRole?: number;
      /**
       * 处理中状态
       * IN_APPROVAL-审批中、IN_AUDIT-审核中
       */
      processStatus?: string;
      /**
       * 待审批、 待审核
       */
      auditStatusName?: string;
    }[];
    /**
     * 剩余单据数量
     */
    count?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [我的单据↗](http://yapi.cai-inc.com/project/3621/interface/api/238374) 的 **请求配置的类型**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-form`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonMyFormGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/my-form',
    'data',
    string,
    'count',
    false
  >
>;

/**
 * 接口 [我的单据↗](http://yapi.cai-inc.com/project/3621/interface/api/238374) 的 **请求配置**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-form`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
const zlbApiExpenseCommonMyFormGetRequestConfig: ZlbApiExpenseCommonMyFormGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/my-form',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['count'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonMyFormGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [我的单据↗](http://yapi.cai-inc.com/project/3621/interface/api/238374) 的 **请求函数**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/my-form`
 * @更新时间 `2025-01-07 09:58:42`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonMyFormGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonMyFormGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonMyFormGetResponse>(
    prepare(zlbApiExpenseCommonMyFormGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonMyFormGet.requestConfig = zlbApiExpenseCommonMyFormGetRequestConfig;

/**
 * 接口 [根据不同字典编码查询相关类型↗](http://yapi.cai-inc.com/project/3621/interface/api/242884) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/dic/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export type ZlbApiExpenseCommonDicGetPostRequest = {
  /**
   * 类型编码
   */
  typeCode?: string;
  /**
   * 子类型编码列表
   */
  subTypeCodeList?: string[];
}[];

/**
 * 接口 [根据不同字典编码查询相关类型↗](http://yapi.cai-inc.com/project/3621/interface/api/242884) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/dic/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonDicGetPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 类型code
     */
    typeCode?: string;
    /**
     * 类型名称
     */
    typeName?: string;
    /**
     * 子类型code
     */
    subTypeCode?: string;
    /**
     * 子类型名称
     */
    subTypeName?: string;
    /**
     * 值列表
     */
    values?: {
      /**
       * 通用key
       */
      key?: number;
      /**
       * 配置中心-配置code专用
       */
      code?: string;
      /**
       * 通用描述
       */
      desc?: string;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据不同字典编码查询相关类型↗](http://yapi.cai-inc.com/project/3621/interface/api/242884) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/dic/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonDicGetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/dic/get',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据不同字典编码查询相关类型↗](http://yapi.cai-inc.com/project/3621/interface/api/242884) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/dic/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
const zlbApiExpenseCommonDicGetPostRequestConfig: ZlbApiExpenseCommonDicGetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/dic/get',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonDicGetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据不同字典编码查询相关类型↗](http://yapi.cai-inc.com/project/3621/interface/api/242884) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/dic/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonDicGetPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonDicGetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonDicGetPostResponse>(
    prepare(zlbApiExpenseCommonDicGetPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonDicGetPost.requestConfig = zlbApiExpenseCommonDicGetPostRequestConfig;

/**
 * 接口 [打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/242946) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/print`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPrintGetRequest {
  /**
   * 单据类型
   */
  type: string;
  /**
   * 单据编号
   */
  code: string;
  /**
   * 是否需要发票
   */
  needInvoice: string;
  /**
   * 打印模板
   */
  printTemplate?: string;
  /**
   * 模板code
   */
  templateCode?: string;
}

/**
 * 接口 [打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/242946) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/print`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPrintGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 使用的模板codePrintRO
     */
    templateCode?: string;
    /**
     * 单据文件的fileId
     */
    formFileId?: string;
    /**
     * 发票文件的fileId
     */
    invoiceFileIdList?: string[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/242946) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/print`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonPrintGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/print',
    'data',
    string,
    'type' | 'code' | 'needInvoice' | 'printTemplate' | 'templateCode',
    false
  >
>;

/**
 * 接口 [打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/242946) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/print`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
const zlbApiExpenseCommonPrintGetRequestConfig: ZlbApiExpenseCommonPrintGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/print',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['type', 'code', 'needInvoice', 'printTemplate', 'templateCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonPrintGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/242946) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/print`
 * @更新时间 `2025-01-07 09:58:41`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonPrintGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonPrintGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonPrintGetResponse>(
    prepare(zlbApiExpenseCommonPrintGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonPrintGet.requestConfig = zlbApiExpenseCommonPrintGetRequestConfig;

/**
 * 接口 [运营机构列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/245650) 的 **请求类型**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operateQuery`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonOperateQueryGetRequest {
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * Tab页
   * 1-申请单、2-报销单
   */
  pageType: string;
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 单据类型
   * 1-差旅、2-会议、3-培训、4-办公用品、6-公务接待、7-一般事项
   */
  'formType[0]'?: string;
  /**
   * 申请事由
   */
  reason?: string;
  /**
   * 开始时间
   */
  beginTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 单据状态
   * 申请单：1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
   * 报销单：0-未提交、1-审核中、2-已驳回、3-结算中、4-已完成、5-支付失败
   */
  'formStatus[0]'?: string;
  /**
   * 区划code
   */
  divisionCode?: string;
  /**
   * 单位ID
   * 运营人员查看必传
   */
  'orgId[0]'?: string;
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 人员类别
   *
   * 1-运营人员
   * 2-单位财务人员
   */
  userType?: string;
  /**
   * 提交人姓名
   */
  applyUserName?: string;
  /**
   * 支付状态
   */
  payStatus?: string;
  /**
   * 测试单据
   * 1-是，2-否
   */
  isTestForm?: string;
  /**
   * 是否已打印
   */
  printStatus?: string;
  /**
   * 报销金额起始
   */
  expenseAmountStart?: string;
  /**
   * 报销金额截止
   */
  expenseAmountEnd?: string;
  /**
   * 来源 1：财务侧 2：运营侧
   */
  source?: string;
  /**
   * 申请单编号
   */
  applyBusinessCode?: string;
}

/**
 * 接口 [运营机构列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/245650) 的 **返回类型**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operateQuery`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonOperateQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据code
       */
      formCode?: string;
      /**
       * 单据类型
       * 1-差旅、2-会议、3-培训、4-办公用品、6-公务接待、7-一般事项
       */
      formType?: number;
      /**
       * 单据类型名称
       * 差旅申请、差旅报销
       */
      formTypeName?: string;
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 申请事由
       */
      reason?: string;
      /**
       * 发起人
       */
      applyUserName?: string;
      /**
       * 发起人ID
       */
      applyOperatorId?: number;
      /**
       * 机构ID
       */
      orgId?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 发起时间
       */
      initiationTime?: string;
      /**
       * 单据状态
       * 申请单：1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
       * 报销单：0-未提交、1-审核中、2-已驳回、3-结算中、4-已完成、5-支付失败
       */
      formStatus?: number;
      /**
       * 单据状态名称
       * 申请单：1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
       * 报销单：0-未提交、1-审核中、2-已驳回、3-结算中、4-已完成、5-支付失败
       */
      formStatusName?: string;
      /**
       * 处理中状态
       * IN_APPROVAL-审批中、IN_AUDIT-审核中
       */
      processStatus?: string;
      /**
       * 支付状态(报销单)
       * -1-无支付状态(返回的支付状态名称为'-')、0-待支付、1-支付中、2-支付成功、3-支付失败
       */
      payStatus?: number;
      /**
       * 支付状态名称(报销单)
       * -1-无支付状态(返回的支付状态名称为'-')、0-待支付、1-支付中、2-支付成功、3-支付失败
       */
      payStatusName?: string;
      /**
       * 支付方式Code
       */
      payMode: number;
      /**
       * 子支付方式Code
       * 当为国库支付时，必须选择是授权支付还是直接支付
       * 当为非财政资金支付时，为空
       */
      subPayMode?: number;
      /**
       * 是否是测试单据
       * 1-是，2-否
       */
      isTestForm?: number;
      /**
       * 是否已打印
       * 0-未打印 1-已打印
       */
      printStatus?: number;
      /**
       * 是否已打印名称
       * 0-未打印 1-已打印
       */
      printStatusName?: string;
      /**
       * 报销金额
       */
      expenseAmount?: number;
      /**
       * 是否百搭单据
       */
      isBaidaForm?: boolean;
      /**
       * 报销单关联申请单基本信息
       */
      relationApplyInfoROList?: {
        /**
         * 申请单业务单据号
         */
        applyBusinessNo?: string;
        /**
         * 申请单编号
         */
        applyFormCode?: string;
        /**
         * 申请单单据类型编号
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请人姓名
         */
        applyUserName?: string;
        /**
         * 发起时间
         */
        initiationTime?: string;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [运营机构列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/245650) 的 **请求配置的类型**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operateQuery`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonOperateQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/operateQuery',
    'data',
    string,
    | 'pageSize'
    | 'pageNo'
    | 'sortField'
    | 'sortBy'
    | 'pageType'
    | 'businessCode'
    | 'formType[0]'
    | 'reason'
    | 'beginTime'
    | 'endTime'
    | 'formStatus[0]'
    | 'divisionCode'
    | 'orgId[0]'
    | 'creditCode'
    | 'userType'
    | 'applyUserName'
    | 'payStatus'
    | 'isTestForm'
    | 'printStatus'
    | 'expenseAmountStart'
    | 'expenseAmountEnd'
    | 'source'
    | 'applyBusinessCode',
    false
  >
>;

/**
 * 接口 [运营机构列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/245650) 的 **请求配置**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operateQuery`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
const zlbApiExpenseCommonOperateQueryGetRequestConfig: ZlbApiExpenseCommonOperateQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/operateQuery',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [
      'pageSize',
      'pageNo',
      'sortField',
      'sortBy',
      'pageType',
      'businessCode',
      'formType[0]',
      'reason',
      'beginTime',
      'endTime',
      'formStatus[0]',
      'divisionCode',
      'orgId[0]',
      'creditCode',
      'userType',
      'applyUserName',
      'payStatus',
      'isTestForm',
      'printStatus',
      'expenseAmountStart',
      'expenseAmountEnd',
      'source',
      'applyBusinessCode',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonOperateQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [运营机构列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/245650) 的 **请求函数**
 *
 * @状态 未完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operateQuery`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonOperateQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonOperateQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonOperateQueryGetResponse>(
    prepare(zlbApiExpenseCommonOperateQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonOperateQueryGet.requestConfig = zlbApiExpenseCommonOperateQueryGetRequestConfig;

/**
 * 接口 [消息通知具有单据查看权限接口↗](http://yapi.cai-inc.com/project/3621/interface/api/246186) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form-operator/get`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFormOperatorGetGetRequest {
  /**
   * 当前用户操作人列表
   */
  'operatorIds[0]'?: string;
  /**
   * 单号
   */
  formCode?: string;
  /**
   * 单据类型
   */
  formType?: string;
}

/**
 * 接口 [消息通知具有单据查看权限接口↗](http://yapi.cai-inc.com/project/3621/interface/api/246186) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form-operator/get`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFormOperatorGetGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [消息通知具有单据查看权限接口↗](http://yapi.cai-inc.com/project/3621/interface/api/246186) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form-operator/get`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonFormOperatorGetGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/form-operator/get',
    'data',
    string,
    'operatorIds[0]' | 'formCode' | 'formType',
    false
  >
>;

/**
 * 接口 [消息通知具有单据查看权限接口↗](http://yapi.cai-inc.com/project/3621/interface/api/246186) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form-operator/get`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
const zlbApiExpenseCommonFormOperatorGetGetRequestConfig: ZlbApiExpenseCommonFormOperatorGetGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/form-operator/get',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['operatorIds[0]', 'formCode', 'formType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonFormOperatorGetGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [消息通知具有单据查看权限接口↗](http://yapi.cai-inc.com/project/3621/interface/api/246186) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form-operator/get`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonFormOperatorGetGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonFormOperatorGetGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonFormOperatorGetGetResponse>(
    prepare(zlbApiExpenseCommonFormOperatorGetGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonFormOperatorGetGet.requestConfig =
  zlbApiExpenseCommonFormOperatorGetGetRequestConfig;

/**
 * 接口 [根据前端模板打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/248124) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printByFront`
 * @更新时间 `2023-06-20 15:24:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPrintByFrontPostRequest {
  /**
   * 单据类型
   */
  type: number;
  /**
   * 单据编号
   */
  code: string;
  /**
   * 是否需要发票
   */
  needInvoice: boolean;
  /**
   * 打印模板
   */
  printTemplate?: string;
  /**
   * 模板code
   */
  templateCode?: string;
}

/**
 * 接口 [根据前端模板打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/248124) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printByFront`
 * @更新时间 `2023-06-20 15:24:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPrintByFrontPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 使用的模板codePrintRO
     */
    templateCode?: string;
    /**
     * 单据文件的fileId
     */
    formFileId?: string;
    /**
     * 发票文件的fileId
     */
    invoiceFileIdList?: string[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据前端模板打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/248124) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printByFront`
 * @更新时间 `2023-06-20 15:24:40`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonPrintByFrontPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/printByFront',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据前端模板打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/248124) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printByFront`
 * @更新时间 `2023-06-20 15:24:40`
 * @项目ID 3621
 */
const zlbApiExpenseCommonPrintByFrontPostRequestConfig: ZlbApiExpenseCommonPrintByFrontPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/printByFront',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonPrintByFrontPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据前端模板打印单据↗](http://yapi.cai-inc.com/project/3621/interface/api/248124) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printByFront`
 * @更新时间 `2023-06-20 15:24:40`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonPrintByFrontPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonPrintByFrontPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonPrintByFrontPostResponse>(
    prepare(zlbApiExpenseCommonPrintByFrontPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonPrintByFrontPost.requestConfig =
  zlbApiExpenseCommonPrintByFrontPostRequestConfig;

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/253194) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/getCatalog`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonDicGetCatalogGetRequest {
  /**
   * :TRADE_WAY(交易方式);
   */
  typeCode?: string;
}

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/253194) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/getCatalog`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonDicGetCatalogGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * code
     */
    typeCode?: string;
    /**
     * 类型名称
     */
    typeName?: string;
    /**
     * 父code
     */
    parentTypeCode?: string;
    /**
     * 子目录
     */
    children?: {
      /**
       * code
       */
      typeCode?: string;
      /**
       * 类型名称
       */
      typeName?: string;
      /**
       * 父code
       */
      parentTypeCode?: string;
      /**
       * 子目录
       */
      children?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/253194) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/getCatalog`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonDicGetCatalogGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/dic/getCatalog',
    'data',
    string,
    'typeCode',
    false
  >
>;

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/253194) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/getCatalog`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
const zlbApiExpenseCommonDicGetCatalogGetRequestConfig: ZlbApiExpenseCommonDicGetCatalogGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/dic/getCatalog',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['typeCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonDicGetCatalogGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据不同字典编码查询类型（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/253194) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/getCatalog`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonDicGetCatalogGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonDicGetCatalogGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonDicGetCatalogGetResponse>(
    prepare(zlbApiExpenseCommonDicGetCatalogGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonDicGetCatalogGet.requestConfig =
  zlbApiExpenseCommonDicGetCatalogGetRequestConfig;

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/253966) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/printInfo`
 * @更新时间 `2024-12-06 15:15:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPrintInfoGetRequest {
  formCode?: string;
  formType?: string;
}

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/253966) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/printInfo`
 * @更新时间 `2024-12-06 15:15:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPrintInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 报销单打印信息
     */
    expensePrintInfo?: {
      /**
       * 文件信息
       */
      attachmentDTO?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      };
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'generalForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'BATCH_DISTRIBUTE'
        | 'OVERTIME_PAY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'OVERTIME_APPLY_FORM'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'UN_KNOWN';
      /**
       * 表单名称
       */
      formName?: string;
    }[];
    /**
     * 申请单打印信息
     */
    applyPrintInfo?: {
      /**
       * 文件信息
       */
      attachmentDTO?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      };
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'generalForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'BATCH_DISTRIBUTE'
        | 'OVERTIME_PAY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'OVERTIME_APPLY_FORM'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'UN_KNOWN';
      /**
       * 表单名称
       */
      formName?: string;
    }[];
    /**
     * 发票打印信息
     * 「已废弃」
     */
    invoicePrintInfo?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22;
      /**
       * 发票类型描述
       */
      invoiceTypeDesc?: string;
      /**
       * 是否为板式文件
       */
      isFormatFile?: boolean;
    }[];
    /**
     * 发票打印信息
     * 新增票据费用类型、票据号码等信息，票据文件类型增加排序
     */
    invoicePrintExtendRO?: {
      /**
       * 票据标识ID
       */
      platformInvoiceId?: string;
      /**
       * 票据金额
       */
      totalAmount?: number;
      /**
       * 票据消费类型
       */
      invoiceSubject?: string;
      /**
       * 票据消费类型描述
       */
      invoiceSubjectDesc?: string;
      /**
       * 票据号码
       */
      invoiceNo?: string;
      /**
       * 票据附件信息
       * 按用户上传文件、票据源文件、版式文件排序
       */
      attachmentPrintInfo?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      }[];
    }[];
    /**
     * 附件打印信息
     */
    attachmentPrintInfo?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22;
    }[];
    /**
     * 专项、会议、培训附件列表
     */
    specialAttachmentPrintInfo?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22;
    }[];
    /**
     * 夜餐费发放单打印信息
     */
    nightMealPrintInfo?: {
      /**
       * 文件信息
       */
      attachmentDTO?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      };
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'generalForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'BATCH_DISTRIBUTE'
        | 'OVERTIME_PAY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'OVERTIME_APPLY_FORM'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'UN_KNOWN';
      /**
       * 表单名称
       */
      formName?: string;
    };
    /**
     * 项目支付单打印信息
     */
    investPaymentPrintInfo?: {
      /**
       * 文件信息
       */
      attachmentDTO?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      };
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'generalForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'BATCH_DISTRIBUTE'
        | 'OVERTIME_PAY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'OVERTIME_APPLY_FORM'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'UN_KNOWN';
      /**
       * 表单名称
       */
      formName?: string;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/253966) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/printInfo`
 * @更新时间 `2024-12-06 15:15:38`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonPrintInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/printInfo',
    'data',
    string,
    'formCode' | 'formType',
    false
  >
>;

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/253966) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/printInfo`
 * @更新时间 `2024-12-06 15:15:38`
 * @项目ID 3621
 */
const zlbApiExpenseCommonPrintInfoGetRequestConfig: ZlbApiExpenseCommonPrintInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/printInfo',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['formCode', 'formType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonPrintInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/253966) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/printInfo`
 * @更新时间 `2024-12-06 15:15:38`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonPrintInfoGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonPrintInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonPrintInfoGetResponse>(
    prepare(zlbApiExpenseCommonPrintInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonPrintInfoGet.requestConfig = zlbApiExpenseCommonPrintInfoGetRequestConfig;

/**
 * 接口 [app端首页可滑动消息↗](http://yapi.cai-inc.com/project/3621/interface/api/260034) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/message`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonMessageGetRequest {}

/**
 * 接口 [app端首页可滑动消息↗](http://yapi.cai-inc.com/project/3621/interface/api/260034) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/message`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonMessageGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 业务主键
     */
    code?: string;
    /**
     * 消息标题
     */
    title?: string;
    /**
     * 消息内容
     */
    content?: string;
    /**
     * 按钮显示内容
     */
    operate?: string;
    /**
     * 类型:1-行程提醒   2-工资条
     */
    type?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [app端首页可滑动消息↗](http://yapi.cai-inc.com/project/3621/interface/api/260034) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/message`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonMessageGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/message',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [app端首页可滑动消息↗](http://yapi.cai-inc.com/project/3621/interface/api/260034) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/message`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
const zlbApiExpenseCommonMessageGetRequestConfig: ZlbApiExpenseCommonMessageGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/message',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonMessageGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [app端首页可滑动消息↗](http://yapi.cai-inc.com/project/3621/interface/api/260034) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/message`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonMessageGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseCommonMessageGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonMessageGetResponse>(
    prepare(zlbApiExpenseCommonMessageGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonMessageGet.requestConfig = zlbApiExpenseCommonMessageGetRequestConfig;

/**
 * 接口 [查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/264146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operate-record`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonOperateRecordGetRequest {
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 业务类别
   * 1-申请单，2-报销单
   */
  bizType?: string;
}

/**
 * 接口 [查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/264146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operate-record`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonOperateRecordGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 操作记录code
       */
      recordCode?: string;
      /**
       * 操作类型
       */
      operateType?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
      /**
       * 操作类型名称
       */
      operateTypeName?:
        | '删除测试单'
        | '重置工作流'
        | '接口推送加班信息'
        | '冲突校验'
        | '创建夜餐费发放单'
        | '支付成功'
        | '支付失败';
      /**
       * 操作人
       */
      operateName?: string;
      /**
       * 操作人ID
       */
      operateId?: number;
      /**
       * 操作时间
       */
      operateDate?: string;
      /**
       * 操作原因
       */
      operateReason?: string;
      /**
       * 单据code
       */
      formCode?: string;
      /**
       * 单据类型
       * 1-申请单，2-报销单
       */
      formType?: number;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据所在机构id
       */
      orgId?: number;
      /**
       * 单据所在机构
       */
      orgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/264146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operate-record`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonOperateRecordGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/operate-record',
    'data',
    string,
    'pageSize' | 'pageNo' | 'sortField' | 'sortBy' | 'bizType',
    false
  >
>;

/**
 * 接口 [查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/264146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operate-record`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
const zlbApiExpenseCommonOperateRecordGetRequestConfig: ZlbApiExpenseCommonOperateRecordGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/operate-record',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['pageSize', 'pageNo', 'sortField', 'sortBy', 'bizType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonOperateRecordGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/264146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/operate-record`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonOperateRecordGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonOperateRecordGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonOperateRecordGetResponse>(
    prepare(zlbApiExpenseCommonOperateRecordGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonOperateRecordGet.requestConfig =
  zlbApiExpenseCommonOperateRecordGetRequestConfig;

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/3621/interface/api/264154) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/test-form/delete`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTestFormDeletePostRequest {
  /**
   * 申请单code
   */
  applyCodeList?: string[];
  /**
   * 报销单code
   */
  expenseCodeList?: string[];
  /**
   * 是否同步移除票据
   */
  isRemoveInvoice?: boolean;
  /**
   * 删除原因
   */
  deleteReason: string;
}

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/3621/interface/api/264154) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/test-form/delete`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTestFormDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/3621/interface/api/264154) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/test-form/delete`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonTestFormDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/test-form/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/3621/interface/api/264154) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/test-form/delete`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
const zlbApiExpenseCommonTestFormDeletePostRequestConfig: ZlbApiExpenseCommonTestFormDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/test-form/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonTestFormDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/3621/interface/api/264154) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/test-form/delete`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonTestFormDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonTestFormDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonTestFormDeletePostResponse>(
    prepare(zlbApiExpenseCommonTestFormDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonTestFormDeletePost.requestConfig =
  zlbApiExpenseCommonTestFormDeletePostRequestConfig;

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/3621/interface/api/266098) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/form-operator/list`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFormOperatorListPostRequest {
  /**
   * 当前用户操作人列表
   */
  operatorIds?: number[];
  /**
   * 单号
   */
  formCode?: string;
  /**
   * 单据类型
   */
  formType?: number;
}

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/3621/interface/api/266098) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/form-operator/list`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFormOperatorListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/3621/interface/api/266098) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/form-operator/list`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonFormOperatorListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/form-operator/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/3621/interface/api/266098) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/form-operator/list`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
const zlbApiExpenseCommonFormOperatorListPostRequestConfig: ZlbApiExpenseCommonFormOperatorListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/form-operator/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonFormOperatorListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/3621/interface/api/266098) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/form-operator/list`
 * @更新时间 `2025-01-07 09:58:43`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonFormOperatorListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonFormOperatorListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonFormOperatorListPostResponse>(
    prepare(zlbApiExpenseCommonFormOperatorListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonFormOperatorListPost.requestConfig =
  zlbApiExpenseCommonFormOperatorListPostRequestConfig;

/**
 * 接口 [getBankInfo↗](http://yapi.cai-inc.com/project/3621/interface/api/310378) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/getBankInfo`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonGetBankInfoPostRequest {
  expenseFormCode?: string;
  accountCode: string;
  /**
   * 2快照 1 最新数据
   */
  isSnapshot: number;
  /**
   * 司机id
   */
  driverId?: number;
  isDriver?: boolean;
  /**
   * 是否脱敏 1不脱敏
   */
  desensitize?: number;
}

/**
 * 接口 [getBankInfo↗](http://yapi.cai-inc.com/project/3621/interface/api/310378) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/getBankInfo`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonGetBankInfoPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 银行卡号
     */
    cardNo?: string;
    /**
     * 银行名字
     */
    bankBranchAliasName?: string;
    accountCode?: string;
    /**
     * 供应商名称
     */
    userName?: string;
    /**
     * 收款人姓名
     */
    accountName?: string;
    bankName?: string;
    cardType?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [getBankInfo↗](http://yapi.cai-inc.com/project/3621/interface/api/310378) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/getBankInfo`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonGetBankInfoPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/getBankInfo',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [getBankInfo↗](http://yapi.cai-inc.com/project/3621/interface/api/310378) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/getBankInfo`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
const zlbApiExpenseCommonGetBankInfoPostRequestConfig: ZlbApiExpenseCommonGetBankInfoPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/getBankInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonGetBankInfoPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getBankInfo↗](http://yapi.cai-inc.com/project/3621/interface/api/310378) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/getBankInfo`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonGetBankInfoPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonGetBankInfoPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonGetBankInfoPostResponse>(
    prepare(zlbApiExpenseCommonGetBankInfoPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonGetBankInfoPost.requestConfig = zlbApiExpenseCommonGetBankInfoPostRequestConfig;

/**
 * 接口 [费用类型树（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/320858) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/fee-type-tree/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonDicFeeTypeTreeGetGetRequest {
  /**
   * 类型编码
   */
  typeCode: string;
  /**
   * 子场景类型编码
   */
  subTypeCode?: string;
  /**
   * 默认是有票费用
   */
  isHasInvoice?: string;
  /**
   * 类型编码
   */
  'excludeCode[0]'?: string;
}

/**
 * 接口 [费用类型树（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/320858) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/fee-type-tree/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonDicFeeTypeTreeGetGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    parentFeeShowLabel?: string;
    label?: string;
    value?: number;
    isLeaf?: boolean;
    sort?: number;
    children?: {
      parentFeeShowLabel?: string;
      label?: string;
      value?: number;
      isLeaf?: boolean;
      sort?: number;
      children?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [费用类型树（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/320858) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/fee-type-tree/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonDicFeeTypeTreeGetGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/dic/fee-type-tree/get',
    'data',
    string,
    'typeCode' | 'subTypeCode' | 'isHasInvoice' | 'excludeCode[0]',
    false
  >
>;

/**
 * 接口 [费用类型树（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/320858) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/fee-type-tree/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
const zlbApiExpenseCommonDicFeeTypeTreeGetGetRequestConfig: ZlbApiExpenseCommonDicFeeTypeTreeGetGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/dic/fee-type-tree/get',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['typeCode', 'subTypeCode', 'isHasInvoice', 'excludeCode[0]'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonDicFeeTypeTreeGetGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [费用类型树（多级，级联显示）↗](http://yapi.cai-inc.com/project/3621/interface/api/320858) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/fee-type-tree/get`
 * @更新时间 `2025-01-07 09:58:40`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonDicFeeTypeTreeGetGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonDicFeeTypeTreeGetGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonDicFeeTypeTreeGetGetResponse>(
    prepare(zlbApiExpenseCommonDicFeeTypeTreeGetGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonDicFeeTypeTreeGetGet.requestConfig =
  zlbApiExpenseCommonDicFeeTypeTreeGetGetRequestConfig;

/**
 * 接口 [订正用户关系数据↗](http://yapi.cai-inc.com/project/3621/interface/api/332714) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/deleteUserRepeat`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonDeleteUserRepeatPostRequest {
  /**
   * 时间
   */
  time?: string;
  /**
   * 秘钥
   */
  secretKey?: string;
}

/**
 * 接口 [订正用户关系数据↗](http://yapi.cai-inc.com/project/3621/interface/api/332714) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/deleteUserRepeat`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonDeleteUserRepeatPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [订正用户关系数据↗](http://yapi.cai-inc.com/project/3621/interface/api/332714) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/deleteUserRepeat`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonDeleteUserRepeatPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/deleteUserRepeat',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [订正用户关系数据↗](http://yapi.cai-inc.com/project/3621/interface/api/332714) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/deleteUserRepeat`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
const zlbApiExpenseCommonDeleteUserRepeatPostRequestConfig: ZlbApiExpenseCommonDeleteUserRepeatPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/deleteUserRepeat',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonDeleteUserRepeatPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [订正用户关系数据↗](http://yapi.cai-inc.com/project/3621/interface/api/332714) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/deleteUserRepeat`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonDeleteUserRepeatPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonDeleteUserRepeatPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonDeleteUserRepeatPostResponse>(
    prepare(zlbApiExpenseCommonDeleteUserRepeatPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonDeleteUserRepeatPost.requestConfig =
  zlbApiExpenseCommonDeleteUserRepeatPostRequestConfig;

/**
 * 接口 [修改单据为已打印接口↗](http://yapi.cai-inc.com/project/3621/interface/api/332722) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/updatePrinted`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonUpdatePrintedPostRequest {
  /**
   * 单据编号
   */
  formCode?: string;
  /**
   * 单据类型
   */
  formType?: number;
  /**
   * 人员身份
   */
  identity?: string;
}

/**
 * 接口 [修改单据为已打印接口↗](http://yapi.cai-inc.com/project/3621/interface/api/332722) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/updatePrinted`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonUpdatePrintedPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [修改单据为已打印接口↗](http://yapi.cai-inc.com/project/3621/interface/api/332722) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/updatePrinted`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonUpdatePrintedPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/updatePrinted',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [修改单据为已打印接口↗](http://yapi.cai-inc.com/project/3621/interface/api/332722) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/updatePrinted`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
const zlbApiExpenseCommonUpdatePrintedPostRequestConfig: ZlbApiExpenseCommonUpdatePrintedPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/updatePrinted',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonUpdatePrintedPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [修改单据为已打印接口↗](http://yapi.cai-inc.com/project/3621/interface/api/332722) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/updatePrinted`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonUpdatePrintedPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonUpdatePrintedPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonUpdatePrintedPostResponse>(
    prepare(zlbApiExpenseCommonUpdatePrintedPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonUpdatePrintedPost.requestConfig =
  zlbApiExpenseCommonUpdatePrintedPostRequestConfig;

/**
 * 接口 [财务管理-单据导出↗](http://yapi.cai-inc.com/project/3621/interface/api/341034) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/exportForm`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonExportFormPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * Tab页
   * 1-申请单、2-报销单
   */
  pageType: number;
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 单据类型
   * 1-差旅、2-会议、3-培训、4-办公用品、6-公务接待、7-一般事项
   */
  formType?: number[];
  /**
   * 申请事由
   */
  reason?: string;
  /**
   * 开始时间
   */
  beginTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 单据状态
   * 申请单：1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
   * 报销单：0-未提交、1-审核中、2-已驳回、3-结算中、4-已完成、5-支付失败
   */
  formStatus?: number[];
  /**
   * 区划code
   */
  divisionCode?: string;
  /**
   * 单位ID
   * 运营人员查看必传
   */
  orgId?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 人员类别
   *
   * 1-运营人员
   * 2-单位财务人员
   */
  userType?: number;
  /**
   * 提交人姓名
   */
  applyUserName?: string;
  /**
   * 支付状态
   */
  payStatus?: number;
  /**
   * 测试单据
   * 1-是，2-否
   */
  isTestForm?: number;
  /**
   * 是否已打印
   */
  printStatus?: number;
  /**
   * 报销金额起始
   */
  expenseAmountStart?: number;
  /**
   * 报销金额截止
   */
  expenseAmountEnd?: number;
  /**
   * 来源 1：财务侧 2：运营侧
   */
  source?: number;
  /**
   * 申请单编号
   */
  applyBusinessCode?: string;
}

/**
 * 接口 [财务管理-单据导出↗](http://yapi.cai-inc.com/project/3621/interface/api/341034) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/exportForm`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonExportFormPostResponse {}

/**
 * 接口 [财务管理-单据导出↗](http://yapi.cai-inc.com/project/3621/interface/api/341034) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/exportForm`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonExportFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/exportForm',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [财务管理-单据导出↗](http://yapi.cai-inc.com/project/3621/interface/api/341034) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/exportForm`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
const zlbApiExpenseCommonExportFormPostRequestConfig: ZlbApiExpenseCommonExportFormPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/exportForm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonExportFormPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [财务管理-单据导出↗](http://yapi.cai-inc.com/project/3621/interface/api/341034) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/exportForm`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonExportFormPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonExportFormPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonExportFormPostResponse>(
    prepare(zlbApiExpenseCommonExportFormPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonExportFormPost.requestConfig = zlbApiExpenseCommonExportFormPostRequestConfig;

/**
 * 接口 [根据前缀生成唯一业务编码↗](http://yapi.cai-inc.com/project/3621/interface/api/349986) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/getBusinessCode/{prefix}`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonGetBusinessCodePrefixGetRequest {
  prefix: string;
}

/**
 * 接口 [根据前缀生成唯一业务编码↗](http://yapi.cai-inc.com/project/3621/interface/api/349986) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/getBusinessCode/{prefix}`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonGetBusinessCodePrefixGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据前缀生成唯一业务编码↗](http://yapi.cai-inc.com/project/3621/interface/api/349986) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/getBusinessCode/{prefix}`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonGetBusinessCodePrefixGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/getBusinessCode/{prefix}',
    'data',
    'prefix',
    string,
    false
  >
>;

/**
 * 接口 [根据前缀生成唯一业务编码↗](http://yapi.cai-inc.com/project/3621/interface/api/349986) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/getBusinessCode/{prefix}`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
const zlbApiExpenseCommonGetBusinessCodePrefixGetRequestConfig: ZlbApiExpenseCommonGetBusinessCodePrefixGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/getBusinessCode/{prefix}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: ['prefix'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonGetBusinessCodePrefixGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据前缀生成唯一业务编码↗](http://yapi.cai-inc.com/project/3621/interface/api/349986) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/getBusinessCode/{prefix}`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonGetBusinessCodePrefixGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonGetBusinessCodePrefixGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonGetBusinessCodePrefixGetResponse>(
    prepare(zlbApiExpenseCommonGetBusinessCodePrefixGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonGetBusinessCodePrefixGet.requestConfig =
  zlbApiExpenseCommonGetBusinessCodePrefixGetRequestConfig;

/**
 * 接口 [查询打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query/print-config`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonQueryPrintConfigGetRequest {}

/**
 * 接口 [查询打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query/print-config`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonQueryPrintConfigGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 是否启用新模版：1是、0否
     */
    enableNewTemplate?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query/print-config`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonQueryPrintConfigGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/query/print-config',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query/print-config`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
const zlbApiExpenseCommonQueryPrintConfigGetRequestConfig: ZlbApiExpenseCommonQueryPrintConfigGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/query/print-config',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonQueryPrintConfigGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query/print-config`
 * @更新时间 `2025-01-07 09:58:46`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonQueryPrintConfigGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseCommonQueryPrintConfigGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonQueryPrintConfigGetResponse>(
    prepare(zlbApiExpenseCommonQueryPrintConfigGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonQueryPrintConfigGet.requestConfig =
  zlbApiExpenseCommonQueryPrintConfigGetRequestConfig;

/**
 * 接口 [更新个人打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371226) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/update/print-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonUpdatePrintConfigPostRequest {
  /**
   * 是否启用新模版：1是、0否
   */
  enableNewTemplate?: number;
}

/**
 * 接口 [更新个人打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371226) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/update/print-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonUpdatePrintConfigPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [更新个人打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371226) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/update/print-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonUpdatePrintConfigPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/update/print-config',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [更新个人打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371226) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/update/print-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
const zlbApiExpenseCommonUpdatePrintConfigPostRequestConfig: ZlbApiExpenseCommonUpdatePrintConfigPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/update/print-config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonUpdatePrintConfigPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [更新个人打印配置(是否启用新模版)↗](http://yapi.cai-inc.com/project/3621/interface/api/371226) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/update/print-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonUpdatePrintConfigPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonUpdatePrintConfigPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonUpdatePrintConfigPostResponse>(
    prepare(zlbApiExpenseCommonUpdatePrintConfigPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonUpdatePrintConfigPost.requestConfig =
  zlbApiExpenseCommonUpdatePrintConfigPostRequestConfig;

/**
 * 接口 [数据比对↗](http://yapi.cai-inc.com/project/3621/interface/api/372938) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/isChange`
 * @更新时间 `2023-01-10 17:19:56`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonIsChangePostRequest {
  /**
   * 初始数据
   */
  oldData?: string;
  /**
   * 离开页面的数据
   */
  newData?: string;
}

/**
 * 接口 [数据比对↗](http://yapi.cai-inc.com/project/3621/interface/api/372938) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/isChange`
 * @更新时间 `2023-01-10 17:19:56`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonIsChangePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [数据比对↗](http://yapi.cai-inc.com/project/3621/interface/api/372938) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/isChange`
 * @更新时间 `2023-01-10 17:19:56`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonIsChangePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/isChange',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [数据比对↗](http://yapi.cai-inc.com/project/3621/interface/api/372938) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/isChange`
 * @更新时间 `2023-01-10 17:19:56`
 * @项目ID 3621
 */
const zlbApiExpenseCommonIsChangePostRequestConfig: ZlbApiExpenseCommonIsChangePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/isChange',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonIsChangePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [数据比对↗](http://yapi.cai-inc.com/project/3621/interface/api/372938) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/isChange`
 * @更新时间 `2023-01-10 17:19:56`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonIsChangePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonIsChangePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonIsChangePostResponse>(
    prepare(zlbApiExpenseCommonIsChangePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonIsChangePost.requestConfig = zlbApiExpenseCommonIsChangePostRequestConfig;

/**
 * 接口 [查询无相表单项目控件扩展信息↗](http://yapi.cai-inc.com/project/3621/interface/api/412458) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/queryControlExtendView`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonQueryControlExtendViewGetRequest {
  /**
   * 差旅业务类型 1:差旅  20：外出
   */
  businessType?: string;
  /**
   * isProject
   */
  field?: string;
  parentId?: string;
}

/**
 * 接口 [查询无相表单项目控件扩展信息↗](http://yapi.cai-inc.com/project/3621/interface/api/412458) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/queryControlExtendView`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonQueryControlExtendViewGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    /**
     * 控件字段 例：isProject
     */
    field?: string;
    /**
     * 控件标题名称： 例：是否项目出差
     */
    fieldName?: string;
    /**
     * 控件项目名称 例：是
     */
    label?: string;
    /**
     * 控件项目值 例如：1
     */
    key?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询无相表单项目控件扩展信息↗](http://yapi.cai-inc.com/project/3621/interface/api/412458) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/queryControlExtendView`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonQueryControlExtendViewGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/queryControlExtendView',
    'data',
    string,
    'businessType' | 'field' | 'parentId',
    false
  >
>;

/**
 * 接口 [查询无相表单项目控件扩展信息↗](http://yapi.cai-inc.com/project/3621/interface/api/412458) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/queryControlExtendView`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
const zlbApiExpenseCommonQueryControlExtendViewGetRequestConfig: ZlbApiExpenseCommonQueryControlExtendViewGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/queryControlExtendView',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['businessType', 'field', 'parentId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonQueryControlExtendViewGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询无相表单项目控件扩展信息↗](http://yapi.cai-inc.com/project/3621/interface/api/412458) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/queryControlExtendView`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonQueryControlExtendViewGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonQueryControlExtendViewGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonQueryControlExtendViewGetResponse>(
    prepare(zlbApiExpenseCommonQueryControlExtendViewGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonQueryControlExtendViewGet.requestConfig =
  zlbApiExpenseCommonQueryControlExtendViewGetRequestConfig;

/**
 * 接口 [获取人员信息接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415234) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/page/operatorInfo/list`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPageOperatorInfoListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 用户类型
   */
  type?: number;
  /**
   * 机构id
   */
  deptId?: number;
}

/**
 * 接口 [获取人员信息接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415234) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/page/operatorInfo/list`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPageOperatorInfoListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 用户id
       */
      operatorId?: number;
      /**
       * 用户名称
       */
      operatorName?: string;
      /**
       * 职级:1-“省级及相当职级人员”、2-“正副厅长及相等职级人员”、3-“其余人员”
       */
      userRank?: string;
      /**
       * 职级描述
       */
      userRankDesc?: string;
      /**
       * 手机号 脱敏的
       */
      phoneDesc?: string;
      /**
       * 身份证号
       */
      idCard?: string;
      /**
       * 性别：1男、0女
       */
      gender?: number;
      /**
       * 类型
       */
      type?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取人员信息接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415234) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/page/operatorInfo/list`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonPageOperatorInfoListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/page/operatorInfo/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [获取人员信息接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415234) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/page/operatorInfo/list`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
const zlbApiExpenseCommonPageOperatorInfoListPostRequestConfig: ZlbApiExpenseCommonPageOperatorInfoListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/page/operatorInfo/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonPageOperatorInfoListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取人员信息接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415234) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/page/operatorInfo/list`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonPageOperatorInfoListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonPageOperatorInfoListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonPageOperatorInfoListPostResponse>(
    prepare(zlbApiExpenseCommonPageOperatorInfoListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonPageOperatorInfoListPost.requestConfig =
  zlbApiExpenseCommonPageOperatorInfoListPostRequestConfig;

/**
 * 接口 [数据信息输入↗](http://yapi.cai-inc.com/project/3621/interface/api/436050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/gen/operatorInfo/file`
 * @更新时间 `2023-04-12 10:20:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonGenOperatorInfoFileGetRequest {
  startId?: string;
  endId?: string;
}

/**
 * 接口 [数据信息输入↗](http://yapi.cai-inc.com/project/3621/interface/api/436050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/gen/operatorInfo/file`
 * @更新时间 `2023-04-12 10:20:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonGenOperatorInfoFileGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [数据信息输入↗](http://yapi.cai-inc.com/project/3621/interface/api/436050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/gen/operatorInfo/file`
 * @更新时间 `2023-04-12 10:20:15`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonGenOperatorInfoFileGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/gen/operatorInfo/file',
    'data',
    string,
    'startId' | 'endId',
    false
  >
>;

/**
 * 接口 [数据信息输入↗](http://yapi.cai-inc.com/project/3621/interface/api/436050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/gen/operatorInfo/file`
 * @更新时间 `2023-04-12 10:20:15`
 * @项目ID 3621
 */
const zlbApiExpenseCommonGenOperatorInfoFileGetRequestConfig: ZlbApiExpenseCommonGenOperatorInfoFileGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/gen/operatorInfo/file',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['startId', 'endId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonGenOperatorInfoFileGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [数据信息输入↗](http://yapi.cai-inc.com/project/3621/interface/api/436050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/gen/operatorInfo/file`
 * @更新时间 `2023-04-12 10:20:15`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonGenOperatorInfoFileGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonGenOperatorInfoFileGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonGenOperatorInfoFileGetResponse>(
    prepare(zlbApiExpenseCommonGenOperatorInfoFileGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonGenOperatorInfoFileGet.requestConfig =
  zlbApiExpenseCommonGenOperatorInfoFileGetRequestConfig;

/**
 * 接口 [根据名称获取租户信息↗](http://yapi.cai-inc.com/project/3621/interface/api/436058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant/search-by-name`
 * @更新时间 `2023-03-28 09:53:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTenantSearchByNameGetRequest {
  name?: string;
}

/**
 * 接口 [根据名称获取租户信息↗](http://yapi.cai-inc.com/project/3621/interface/api/436058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant/search-by-name`
 * @更新时间 `2023-03-28 09:53:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTenantSearchByNameGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 租户编码
     */
    code?: string;
    /**
     * 租户状态
     */
    status?: number;
    /**
     * 行政区划类型
     */
    type?: string;
    /**
     * 订阅状态
     */
    subscribe?: boolean;
    /**
     * 主键ID
     */
    id?: number;
    /**
     * 名称
     */
    name?: string;
    /**
     * 上级ID
     */
    parentId?: number;
    /**
     * 是否为叶子节点
     */
    leaf?: boolean;
    /**
     * 孩子节点
     */
    children?: {
      /**
       * 租户编码
       */
      code?: string;
      /**
       * 租户状态
       */
      status?: number;
      /**
       * 行政区划类型
       */
      type?: string;
      /**
       * 订阅状态
       */
      subscribe?: boolean;
      /**
       * 主键ID
       */
      id?: number;
      /**
       * 名称
       */
      name?: string;
      /**
       * 上级ID
       */
      parentId?: number;
      /**
       * 是否为叶子节点
       */
      leaf?: boolean;
      /**
       * 孩子节点
       */
      children?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据名称获取租户信息↗](http://yapi.cai-inc.com/project/3621/interface/api/436058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant/search-by-name`
 * @更新时间 `2023-03-28 09:53:33`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonTenantSearchByNameGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/tenant/search-by-name',
    'data',
    string,
    'name',
    false
  >
>;

/**
 * 接口 [根据名称获取租户信息↗](http://yapi.cai-inc.com/project/3621/interface/api/436058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant/search-by-name`
 * @更新时间 `2023-03-28 09:53:33`
 * @项目ID 3621
 */
const zlbApiExpenseCommonTenantSearchByNameGetRequestConfig: ZlbApiExpenseCommonTenantSearchByNameGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/tenant/search-by-name',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['name'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonTenantSearchByNameGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据名称获取租户信息↗](http://yapi.cai-inc.com/project/3621/interface/api/436058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant/search-by-name`
 * @更新时间 `2023-03-28 09:53:33`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonTenantSearchByNameGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonTenantSearchByNameGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonTenantSearchByNameGetResponse>(
    prepare(zlbApiExpenseCommonTenantSearchByNameGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonTenantSearchByNameGet.requestConfig =
  zlbApiExpenseCommonTenantSearchByNameGetRequestConfig;

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3621/interface/api/436066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-tree`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTenantTreeGetRequest {
  /**
   * 可选，不传返回全量租户树，传了只返回对应节点和直属一层节点
   */
  tenantCode?: string;
  /**
   * 可选，使用name在tenantCode下模糊搜索，会返回全部节点
   */
  name?: string;
  isAll?: string;
}

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3621/interface/api/436066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-tree`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTenantTreeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    name?: string;
    parentId?: number;
    leaf?: boolean;
    children?: {
      id?: number;
      name?: string;
      parentId?: number;
      leaf?: boolean;
      children?: {}[];
      code?: string;
      status?: number;
      type?: string;
      subscribe?: boolean;
    }[];
    code?: string;
    status?: number;
    type?: string;
    subscribe?: boolean;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3621/interface/api/436066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-tree`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonTenantTreeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/tenant-tree',
    'data',
    string,
    'tenantCode' | 'name' | 'isAll',
    false
  >
>;

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3621/interface/api/436066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-tree`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
const zlbApiExpenseCommonTenantTreeGetRequestConfig: ZlbApiExpenseCommonTenantTreeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/tenant-tree',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['tenantCode', 'name', 'isAll'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonTenantTreeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取租户树↗](http://yapi.cai-inc.com/project/3621/interface/api/436066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-tree`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonTenantTreeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonTenantTreeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonTenantTreeGetResponse>(
    prepare(zlbApiExpenseCommonTenantTreeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonTenantTreeGet.requestConfig = zlbApiExpenseCommonTenantTreeGetRequestConfig;

/**
 * 接口 [判断当前单据，当前人员是否是审批完成↗](http://yapi.cai-inc.com/project/3621/interface/api/451474) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form/audit-complete`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFormAuditCompleteGetRequest {
  formCode?: string;
  formType?: string;
}

/**
 * 接口 [判断当前单据，当前人员是否是审批完成↗](http://yapi.cai-inc.com/project/3621/interface/api/451474) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form/audit-complete`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonFormAuditCompleteGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [判断当前单据，当前人员是否是审批完成↗](http://yapi.cai-inc.com/project/3621/interface/api/451474) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form/audit-complete`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonFormAuditCompleteGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/form/audit-complete',
    'data',
    string,
    'formCode' | 'formType',
    false
  >
>;

/**
 * 接口 [判断当前单据，当前人员是否是审批完成↗](http://yapi.cai-inc.com/project/3621/interface/api/451474) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form/audit-complete`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
const zlbApiExpenseCommonFormAuditCompleteGetRequestConfig: ZlbApiExpenseCommonFormAuditCompleteGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/form/audit-complete',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['formCode', 'formType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonFormAuditCompleteGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [判断当前单据，当前人员是否是审批完成↗](http://yapi.cai-inc.com/project/3621/interface/api/451474) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/form/audit-complete`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonFormAuditCompleteGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonFormAuditCompleteGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonFormAuditCompleteGetResponse>(
    prepare(zlbApiExpenseCommonFormAuditCompleteGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonFormAuditCompleteGet.requestConfig =
  zlbApiExpenseCommonFormAuditCompleteGetRequestConfig;

/**
 * 接口 [获取常用Top10同行人↗](http://yapi.cai-inc.com/project/3621/interface/api/461938) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query-accompany`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonQueryAccompanyGetRequest {}

/**
 * 接口 [获取常用Top10同行人↗](http://yapi.cai-inc.com/project/3621/interface/api/461938) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query-accompany`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonQueryAccompanyGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 用户ID
     */
    userId?: number;
    /**
     * 操作员ID
     */
    operatorId?: number;
    /**
     * 姓名
     */
    userName?: string;
    /**
     * 人员业务类型
     */
    bizType?: 1 | 2 | 3 | 4 | 5 | 6 | 99;
    /**
     * 人员类型
     */
    type?: 0 | 1 | 2 | 3;
    /**
     * 是否隐藏人员显示
     */
    hideOperatorShowType?: boolean;
    /**
     * 手机号
     */
    mobile?: string;
    /**
     * 人员职级
     */
    userRank?: string;
    /**
     * 人员职级描述
     */
    userRankDesc?: string;
    /**
     * 机构信息
     */
    institution?: {
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
    };
    /**
     * 部门信息
     */
    departmentList?: {
      /**
       * 部门id
       */
      departmentId?: number;
      /**
       * 部门名称
       */
      departmentName?: string;
      /**
       * 子部门信息
       */
      children?: {
        /**
         * 部门id
         */
        departmentId?: number;
        /**
         * 部门名称
         */
        departmentName?: string;
        /**
         * 子部门信息
         */
        children?: {}[];
      }[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取常用Top10同行人↗](http://yapi.cai-inc.com/project/3621/interface/api/461938) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query-accompany`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonQueryAccompanyGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/query-accompany',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取常用Top10同行人↗](http://yapi.cai-inc.com/project/3621/interface/api/461938) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query-accompany`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
const zlbApiExpenseCommonQueryAccompanyGetRequestConfig: ZlbApiExpenseCommonQueryAccompanyGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/query-accompany',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonQueryAccompanyGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取常用Top10同行人↗](http://yapi.cai-inc.com/project/3621/interface/api/461938) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/query-accompany`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonQueryAccompanyGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseCommonQueryAccompanyGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonQueryAccompanyGetResponse>(
    prepare(zlbApiExpenseCommonQueryAccompanyGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonQueryAccompanyGet.requestConfig =
  zlbApiExpenseCommonQueryAccompanyGetRequestConfig;

/**
 * 接口 [计算两个时间相差天数↗](http://yapi.cai-inc.com/project/3621/interface/api/463290) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/time-diff`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTimeDiffGetRequest {
  /**
   * 开始时间
   */
  beginTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
}

/**
 * 接口 [计算两个时间相差天数↗](http://yapi.cai-inc.com/project/3621/interface/api/463290) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/time-diff`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTimeDiffGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [计算两个时间相差天数↗](http://yapi.cai-inc.com/project/3621/interface/api/463290) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/time-diff`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonTimeDiffGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/time-diff',
    'data',
    string,
    'beginTime' | 'endTime',
    false
  >
>;

/**
 * 接口 [计算两个时间相差天数↗](http://yapi.cai-inc.com/project/3621/interface/api/463290) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/time-diff`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
const zlbApiExpenseCommonTimeDiffGetRequestConfig: ZlbApiExpenseCommonTimeDiffGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/time-diff',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['beginTime', 'endTime'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonTimeDiffGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [计算两个时间相差天数↗](http://yapi.cai-inc.com/project/3621/interface/api/463290) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/time-diff`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonTimeDiffGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonTimeDiffGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonTimeDiffGetResponse>(
    prepare(zlbApiExpenseCommonTimeDiffGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonTimeDiffGet.requestConfig = zlbApiExpenseCommonTimeDiffGetRequestConfig;

/**
 * 接口 [刷新用户关系表↗](http://yapi.cai-inc.com/project/3621/interface/api/472066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/refresh/user-relation`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonRefreshUserRelationGetRequest {
  startId?: string;
  endId?: string;
}

/**
 * 接口 [刷新用户关系表↗](http://yapi.cai-inc.com/project/3621/interface/api/472066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/refresh/user-relation`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonRefreshUserRelationGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: null;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [刷新用户关系表↗](http://yapi.cai-inc.com/project/3621/interface/api/472066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/refresh/user-relation`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonRefreshUserRelationGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/refresh/user-relation',
    'data',
    string,
    'startId' | 'endId',
    false
  >
>;

/**
 * 接口 [刷新用户关系表↗](http://yapi.cai-inc.com/project/3621/interface/api/472066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/refresh/user-relation`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
const zlbApiExpenseCommonRefreshUserRelationGetRequestConfig: ZlbApiExpenseCommonRefreshUserRelationGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/refresh/user-relation',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['startId', 'endId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonRefreshUserRelationGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [刷新用户关系表↗](http://yapi.cai-inc.com/project/3621/interface/api/472066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/refresh/user-relation`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonRefreshUserRelationGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonRefreshUserRelationGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonRefreshUserRelationGetResponse>(
    prepare(zlbApiExpenseCommonRefreshUserRelationGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonRefreshUserRelationGet.requestConfig =
  zlbApiExpenseCommonRefreshUserRelationGetRequestConfig;

/**
 * 接口 [通用灰度接口↗](http://yapi.cai-inc.com/project/3621/interface/api/478658) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export type ZlbApiExpenseCommonGrayPostRequest = string[];

/**
 * 接口 [通用灰度接口↗](http://yapi.cai-inc.com/project/3621/interface/api/478658) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonGrayPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    key?: boolean;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [通用灰度接口↗](http://yapi.cai-inc.com/project/3621/interface/api/478658) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonGrayPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/gray',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [通用灰度接口↗](http://yapi.cai-inc.com/project/3621/interface/api/478658) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
const zlbApiExpenseCommonGrayPostRequestConfig: ZlbApiExpenseCommonGrayPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/gray',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonGrayPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [通用灰度接口↗](http://yapi.cai-inc.com/project/3621/interface/api/478658) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonGrayPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonGrayPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonGrayPostResponse>(
    prepare(zlbApiExpenseCommonGrayPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonGrayPost.requestConfig = zlbApiExpenseCommonGrayPostRequestConfig;

/**
 * 接口 [财务岗查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/488050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/cashier/operate-record`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonCashierOperateRecordGetRequest {
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 业务类别
   * 1-申请单，2-报销单
   */
  bizType?: string;
}

/**
 * 接口 [财务岗查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/488050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/cashier/operate-record`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonCashierOperateRecordGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 操作记录code
       */
      recordCode?: string;
      /**
       * 操作类型
       */
      operateType?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
      /**
       * 操作类型名称
       */
      operateTypeName?:
        | '删除测试单'
        | '重置工作流'
        | '接口推送加班信息'
        | '冲突校验'
        | '创建夜餐费发放单'
        | '支付成功'
        | '支付失败';
      /**
       * 操作人
       */
      operateName?: string;
      /**
       * 操作人ID
       */
      operateId?: number;
      /**
       * 操作时间
       */
      operateDate?: string;
      /**
       * 操作原因
       */
      operateReason?: string;
      /**
       * 单据code
       */
      formCode?: string;
      /**
       * 单据类型
       * 1-申请单，2-报销单
       */
      formType?: number;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据所在机构id
       */
      orgId?: number;
      /**
       * 单据所在机构
       */
      orgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [财务岗查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/488050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/cashier/operate-record`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonCashierOperateRecordGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/cashier/operate-record',
    'data',
    string,
    'pageSize' | 'pageNo' | 'sortField' | 'sortBy' | 'bizType',
    false
  >
>;

/**
 * 接口 [财务岗查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/488050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/cashier/operate-record`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
const zlbApiExpenseCommonCashierOperateRecordGetRequestConfig: ZlbApiExpenseCommonCashierOperateRecordGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/cashier/operate-record',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['pageSize', 'pageNo', 'sortField', 'sortBy', 'bizType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonCashierOperateRecordGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [财务岗查询操作记录↗](http://yapi.cai-inc.com/project/3621/interface/api/488050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/cashier/operate-record`
 * @更新时间 `2025-01-07 09:58:45`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonCashierOperateRecordGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonCashierOperateRecordGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonCashierOperateRecordGetResponse>(
    prepare(zlbApiExpenseCommonCashierOperateRecordGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonCashierOperateRecordGet.requestConfig =
  zlbApiExpenseCommonCashierOperateRecordGetRequestConfig;

/**
 * 接口 [企业标签↗](http://yapi.cai-inc.com/project/3621/interface/api/593434) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/common/enterprise-tag`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export type ZlbApiExpenseCommonEnterpriseTagPostRequest = string[];

/**
 * 接口 [企业标签↗](http://yapi.cai-inc.com/project/3621/interface/api/593434) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/common/enterprise-tag`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonEnterpriseTagPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    key?: boolean;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [企业标签↗](http://yapi.cai-inc.com/project/3621/interface/api/593434) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/common/enterprise-tag`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonEnterpriseTagPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/enterprise-tag',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [企业标签↗](http://yapi.cai-inc.com/project/3621/interface/api/593434) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/common/enterprise-tag`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
const zlbApiExpenseCommonEnterpriseTagPostRequestConfig: ZlbApiExpenseCommonEnterpriseTagPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/enterprise-tag',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonEnterpriseTagPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [企业标签↗](http://yapi.cai-inc.com/project/3621/interface/api/593434) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/common/enterprise-tag`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonEnterpriseTagPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonEnterpriseTagPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonEnterpriseTagPostResponse>(
    prepare(zlbApiExpenseCommonEnterpriseTagPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonEnterpriseTagPost.requestConfig =
  zlbApiExpenseCommonEnterpriseTagPostRequestConfig;

/**
 * 接口 [获取多票费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/593450) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/multi-invoice-fee/get`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonDicMultiInvoiceFeeGetGetRequest {
  businessType?: string;
}

/**
 * 接口 [获取多票费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/593450) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/multi-invoice-fee/get`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonDicMultiInvoiceFeeGetGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 通用key
     */
    key?: number;
    /**
     * 配置中心-配置code专用
     */
    code?: string;
    /**
     * 通用描述
     */
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取多票费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/593450) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/multi-invoice-fee/get`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonDicMultiInvoiceFeeGetGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/dic/multi-invoice-fee/get',
    'data',
    string,
    'businessType',
    false
  >
>;

/**
 * 接口 [获取多票费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/593450) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/multi-invoice-fee/get`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
const zlbApiExpenseCommonDicMultiInvoiceFeeGetGetRequestConfig: ZlbApiExpenseCommonDicMultiInvoiceFeeGetGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/dic/multi-invoice-fee/get',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['businessType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonDicMultiInvoiceFeeGetGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取多票费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/593450) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/dic/multi-invoice-fee/get`
 * @更新时间 `2025-01-07 09:58:48`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonDicMultiInvoiceFeeGetGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonDicMultiInvoiceFeeGetGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonDicMultiInvoiceFeeGetGetResponse>(
    prepare(zlbApiExpenseCommonDicMultiInvoiceFeeGetGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonDicMultiInvoiceFeeGetGet.requestConfig =
  zlbApiExpenseCommonDicMultiInvoiceFeeGetGetRequestConfig;

/**
 * 接口 [年度账单↗](http://yapi.cai-inc.com/project/3621/interface/api/603234) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/annual/financial/statement`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonAnnualFinancialStatementGetRequest {}

/**
 * 接口 [年度账单↗](http://yapi.cai-inc.com/project/3621/interface/api/603234) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/annual/financial/statement`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonAnnualFinancialStatementGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 用户姓名
     */
    userName?: string;
    /**
     * 第一次使用时间
     */
    firstUseTime?: string;
    /**
     * 使用天数
     */
    useDays?: number;
    /**
     * 申请单数量
     */
    applyFormNum?: number;
    /**
     * 报销单数量
     */
    expenseFormNum?: number;
    /**
     * 所有单据数量
     */
    allFormNum?: number;
    /**
     * 平均每月报销次数
     */
    formAverageMonth?: string;
    /**
     * 超过人员百分比
     */
    excessiveUserPercent?: string;
    /**
     * 最忙碌月份
     */
    busiestMonth?: number;
    /**
     * 最晚使用时间
     */
    lastUseTime?: string;
    /**
     * 审批单据数量
     */
    approveFormNum?: number;
    /**
     * 最晚审批时间
     */
    lastApproveTime?: string;
    /**
     * 公务出行次数
     */
    officialTravelNum?: number;
    /**
     * 到达城市个数
     */
    arriveCityNum?: number;
    /**
     * 公务出行天数
     */
    officialTravelDays?: number;
    /**
     * 采购申请单数量
     */
    purchaseApplyFormNum?: number;
    /**
     * 采购报销单数量
     */
    purchaseExpenseFormNum?: number;
    /**
     * 采购供应商数量
     */
    purchaseSupplierNum?: number;
    /**
     * 场景使用频率
     */
    sceneUsageFrequency?: {
      name?: string;
      value?: number;
    }[];
    /**
     * 场景使用描述
     */
    sceneUsageDesc?: string[];
    /**
     * 关键词
     */
    keyWord?: string;
    /**
     * 关键词描述
     */
    desc?: string;
    /**
     * 关键词底图url
     */
    keyUnderlayUrl?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [年度账单↗](http://yapi.cai-inc.com/project/3621/interface/api/603234) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/annual/financial/statement`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonAnnualFinancialStatementGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/annual/financial/statement',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [年度账单↗](http://yapi.cai-inc.com/project/3621/interface/api/603234) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/annual/financial/statement`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
const zlbApiExpenseCommonAnnualFinancialStatementGetRequestConfig: ZlbApiExpenseCommonAnnualFinancialStatementGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/annual/financial/statement',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonAnnualFinancialStatementGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [年度账单↗](http://yapi.cai-inc.com/project/3621/interface/api/603234) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/annual/financial/statement`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonAnnualFinancialStatementGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseCommonAnnualFinancialStatementGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonAnnualFinancialStatementGetResponse>(
    prepare(zlbApiExpenseCommonAnnualFinancialStatementGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonAnnualFinancialStatementGet.requestConfig =
  zlbApiExpenseCommonAnnualFinancialStatementGetRequestConfig;

/**
 * 接口 [查询业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/632690) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export type ZlbApiExpenseCommonQueryBusinessConfigPostRequest = {
  /**
   * 配置key
   */
  key: string;
}[];

/**
 * 接口 [查询业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/632690) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonQueryBusinessConfigPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    key?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/632690) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonQueryBusinessConfigPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/query/business-config',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/632690) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
const zlbApiExpenseCommonQueryBusinessConfigPostRequestConfig: ZlbApiExpenseCommonQueryBusinessConfigPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/query/business-config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonQueryBusinessConfigPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/632690) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonQueryBusinessConfigPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonQueryBusinessConfigPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonQueryBusinessConfigPostResponse>(
    prepare(zlbApiExpenseCommonQueryBusinessConfigPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonQueryBusinessConfigPost.requestConfig =
  zlbApiExpenseCommonQueryBusinessConfigPostRequestConfig;

/**
 * 接口 [电话格式校验↗](http://yapi.cai-inc.com/project/3621/interface/api/635226) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/phone-format/check`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPhoneFormatCheckGetRequest {
  /**
   * 电话号码
   */
  phone?: string;
  /**
   * 校验类型：0-固定电话||手机号，1-只支持手机号，2-只支持固定电话
   */
  checkType?: string;
}

/**
 * 接口 [电话格式校验↗](http://yapi.cai-inc.com/project/3621/interface/api/635226) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/phone-format/check`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPhoneFormatCheckGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [电话格式校验↗](http://yapi.cai-inc.com/project/3621/interface/api/635226) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/phone-format/check`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonPhoneFormatCheckGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/phone-format/check',
    'data',
    string,
    'phone' | 'checkType',
    false
  >
>;

/**
 * 接口 [电话格式校验↗](http://yapi.cai-inc.com/project/3621/interface/api/635226) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/phone-format/check`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
const zlbApiExpenseCommonPhoneFormatCheckGetRequestConfig: ZlbApiExpenseCommonPhoneFormatCheckGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/phone-format/check',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['phone', 'checkType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonPhoneFormatCheckGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [电话格式校验↗](http://yapi.cai-inc.com/project/3621/interface/api/635226) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/phone-format/check`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonPhoneFormatCheckGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonPhoneFormatCheckGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonPhoneFormatCheckGetResponse>(
    prepare(zlbApiExpenseCommonPhoneFormatCheckGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonPhoneFormatCheckGet.requestConfig =
  zlbApiExpenseCommonPhoneFormatCheckGetRequestConfig;

/**
 * 接口 [是否需要报销设置接口↗](http://yapi.cai-inc.com/project/3621/interface/api/685778) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/need-expense`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonNeedExpensePostRequest {
  /**
   * 单据编号
   */
  formCode: string;
  /**
   * 单据类型
   */
  formType?: string;
  /**
   * 是否需要报销
   * true-是，false-否
   */
  needExpense: boolean;
}

/**
 * 接口 [是否需要报销设置接口↗](http://yapi.cai-inc.com/project/3621/interface/api/685778) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/need-expense`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonNeedExpensePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [是否需要报销设置接口↗](http://yapi.cai-inc.com/project/3621/interface/api/685778) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/need-expense`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonNeedExpensePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/need-expense',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [是否需要报销设置接口↗](http://yapi.cai-inc.com/project/3621/interface/api/685778) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/need-expense`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
const zlbApiExpenseCommonNeedExpensePostRequestConfig: ZlbApiExpenseCommonNeedExpensePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/need-expense',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonNeedExpensePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [是否需要报销设置接口↗](http://yapi.cai-inc.com/project/3621/interface/api/685778) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/need-expense`
 * @更新时间 `2025-01-07 09:58:49`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonNeedExpensePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonNeedExpensePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonNeedExpensePostResponse>(
    prepare(zlbApiExpenseCommonNeedExpensePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonNeedExpensePost.requestConfig = zlbApiExpenseCommonNeedExpensePostRequestConfig;

/**
 * 接口 [租户机构查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728634) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-org/query`
 * @更新时间 `2025-01-07 09:58:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTenantOrgQueryGetRequest {
  orgName: string;
}

/**
 * 接口 [租户机构查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728634) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-org/query`
 * @更新时间 `2025-01-07 09:58:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonTenantOrgQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    createdAt?: string;
    updatedAt?: string;
    creatorId?: number;
    modifierId?: number;
    extFields?: string;
    extMap?: {
      key?: string;
    };
    name?: string;
    shortName?: string;
    orgCode?: string;
    creditCode?: string;
    bizAttaches?: string[];
    tags?: string[];
    provinceCode?: string;
    provinceName?: string;
    cityCode?: string;
    cityName?: string;
    regionCode?: string;
    regionName?: string;
    address?: string;
    status?: number;
    displayOrder?: number;
    outCreatedAt?: string;
    fullName?: string;
    postalCode?: string;
    source?: number;
    organizationCode?: string;
    institutionLevel?: number;
    tagCodes?: string;
    consistencyCheck?: number;
    budgetCheck?: number;
    costControlCheck?: number;
    workflowCheck?: number;
    tenantCode?: string;
    tenantName?: string;
    userType?: string;
    userTypes?: string[];
    operators?: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      creatorId?: number;
      modifierId?: number;
      extFields?: string;
      extMap?: {
        key?: string;
      };
      displayName?: string;
      userId?: number;
      institutionId?: number;
      userType?: string;
      tenantCode?: string;
      userStatus?: number;
      status?: number;
      operatorType?: number;
      email?: string;
      mobile?: string;
      code?: string;
    }[];
    operatorCount?: number;
    departments?: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      creatorId?: number;
      modifierId?: number;
      extFields?: string;
      extMap?: {
        key?: string;
      };
      name?: string;
      institutionId?: number;
      parentId?: number;
      hierarchy?: string;
      isLeaf?: number;
      status?: number;
      type?: number;
      description?: string;
      shortName?: string;
      address?: string;
      level?: number;
      operators?: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        creatorId?: number;
        modifierId?: number;
        extFields?: string;
        extMap?: {
          key?: string;
        };
        userId?: number;
        code?: string;
        displayName?: string;
        userStatus?: number;
        institutionId?: number;
        departmentId?: number;
        userType?: string;
        tenantCode?: string;
        status?: number;
        operatorType?: number;
        IsDefault?: number;
        mainJob?: number;
        order?: number;
        email?: string;
        phone?: string;
        mobile?: string;
        gender?: number;
        fax?: string;
        user?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          displayName?: string;
          realName?: string;
          password?: string;
          loginId?: string;
          mobile?: string;
          email?: string;
          tag?: number;
          idType?: number;
          idNo?: string;
          avatar?: string;
          gender?: number;
          active?: string;
          birthday?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          postCode?: string;
          description?: string;
          encryptionType?: string;
          infoPerfectLevel?: number;
          status?: number;
          userTypes?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            code?: string;
            name?: string;
            type?: number;
            status?: number;
            hierarchy?: string;
            parentCode?: string;
            isLeaf?: boolean;
            descp?: string;
            tenantCode?: string;
            tenantId?: number;
          }[];
          operators?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            userId?: number;
            code?: string;
            displayName?: string;
            userStatus?: number;
            institutionId?: number;
            departmentId?: number;
            userType?: string;
            tenantCode?: string;
            status?: number;
            operatorType?: number;
            IsDefault?: number;
            mainJob?: number;
            order?: number;
            email?: string;
            phone?: string;
            mobile?: string;
            gender?: number;
            fax?: string;
            user?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {}[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            };
            uniqueIdentifier?: string;
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            departments?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              institutionId?: number;
              parentId?: number;
              hierarchy?: string;
              isLeaf?: number;
              status?: number;
              type?: number;
              description?: string;
              shortName?: string;
              address?: string;
              level?: number;
              operators?: {}[];
              managerOperators?: {}[];
              managerUsers?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {}[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              }[];
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              tenantCode?: string;
              tenant?: {
                id?: number;
                source?: number;
                code?: string;
                name?: string;
                parentId?: number;
                type?: string;
                hierarchy?: string;
                leaf?: boolean;
                effectiveDate?: string;
                expirationDate?: string;
                status?: number;
              };
              children?: {}[];
              striplineCodes?: string;
              organizationCode?: string;
              source?: number;
              order?: number;
            }[];
            tiles?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              abbreviation?: string;
              name?: string;
              code?: string;
              institutionId?: number;
              tenantCode?: string;
              tenantName?: string;
              userType?: string;
              userTypeName?: string;
              tag?: string;
              status?: number;
              parentId?: number;
              parentTitle?: {};
              organizationType?: number;
              uniqueKey?: string;
            }[];
            source?: number;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            jobAttributesCode?: string;
            remark?: string;
            ifSetJob?: boolean;
            operatorProfessionType?: number;
            outAccountId?: string;
            syncStatus?: number;
            tenantName?: string;
            jobAttributes?: {
              organizationId?: number;
              organizationType?: number;
              jobAttributesCode?: string;
            }[];
          }[];
          recentlyOperator?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            displayName?: string;
            userId?: number;
            institutionId?: number;
            userType?: string;
            tenantCode?: string;
            userStatus?: number;
            status?: number;
            operatorType?: number;
            email?: string;
            mobile?: string;
            code?: string;
          };
          workStatus?: number;
          employeeCode?: string;
          outAccountId?: string;
          openId?: string;
          /**
           * 「已废弃」
           * 「已废弃」
           */
          userExtFieldsDto?: {
            verifyMobile?: number;
            verifyIdNo?: number;
          };
          politicsStatus?: string;
          source?: number;
          jobLevelCode?: string;
          budgetedPostCode?: string;
          lock?: number;
        };
        uniqueIdentifier?: string;
        institution?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string[];
          tags?: string[];
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
          tagCodes?: string;
          consistencyCheck?: number;
          budgetCheck?: number;
          costControlCheck?: number;
          workflowCheck?: number;
        };
        departments?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          name?: string;
          institutionId?: number;
          parentId?: number;
          hierarchy?: string;
          isLeaf?: number;
          status?: number;
          type?: number;
          description?: string;
          shortName?: string;
          address?: string;
          level?: number;
          operators?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            userId?: number;
            code?: string;
            displayName?: string;
            userStatus?: number;
            institutionId?: number;
            departmentId?: number;
            userType?: string;
            tenantCode?: string;
            status?: number;
            operatorType?: number;
            IsDefault?: number;
            mainJob?: number;
            order?: number;
            email?: string;
            phone?: string;
            mobile?: string;
            gender?: number;
            fax?: string;
            user?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                userId?: number;
                code?: string;
                displayName?: string;
                userStatus?: number;
                institutionId?: number;
                departmentId?: number;
                userType?: string;
                tenantCode?: string;
                status?: number;
                operatorType?: number;
                IsDefault?: number;
                mainJob?: number;
                order?: number;
                email?: string;
                phone?: string;
                mobile?: string;
                gender?: number;
                fax?: string;
                user?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                };
                uniqueIdentifier?: string;
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                departments?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  institutionId?: number;
                  parentId?: number;
                  hierarchy?: string;
                  isLeaf?: number;
                  status?: number;
                  type?: number;
                  description?: string;
                  shortName?: string;
                  address?: string;
                  level?: number;
                  operators?: {}[];
                  managerOperators?: {}[];
                  managerUsers?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  }[];
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  tenantCode?: string;
                  tenant?: {
                    id?: number;
                    source?: number;
                    code?: string;
                    name?: string;
                    parentId?: number;
                    type?: string;
                    hierarchy?: string;
                    leaf?: boolean;
                    effectiveDate?: string;
                    expirationDate?: string;
                    status?: number;
                  };
                  children?: {}[];
                  striplineCodes?: string;
                  organizationCode?: string;
                  source?: number;
                  order?: number;
                }[];
                tiles?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  abbreviation?: string;
                  name?: string;
                  code?: string;
                  institutionId?: number;
                  tenantCode?: string;
                  tenantName?: string;
                  userType?: string;
                  userTypeName?: string;
                  tag?: string;
                  status?: number;
                  parentId?: number;
                  parentTitle?: {};
                  organizationType?: number;
                  uniqueKey?: string;
                }[];
                source?: number;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                jobAttributesCode?: string;
                remark?: string;
                ifSetJob?: boolean;
                operatorProfessionType?: number;
                outAccountId?: string;
                syncStatus?: number;
                tenantName?: string;
                jobAttributes?: {
                  organizationId?: number;
                  organizationType?: number;
                  jobAttributesCode?: string;
                }[];
              }[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            };
            uniqueIdentifier?: string;
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            departments?: {}[];
            tiles?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              abbreviation?: string;
              name?: string;
              code?: string;
              institutionId?: number;
              tenantCode?: string;
              tenantName?: string;
              userType?: string;
              userTypeName?: string;
              tag?: string;
              status?: number;
              parentId?: number;
              parentTitle?: {};
              organizationType?: number;
              uniqueKey?: string;
            }[];
            source?: number;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            jobAttributesCode?: string;
            remark?: string;
            ifSetJob?: boolean;
            operatorProfessionType?: number;
            outAccountId?: string;
            syncStatus?: number;
            tenantName?: string;
            jobAttributes?: {
              organizationId?: number;
              organizationType?: number;
              jobAttributesCode?: string;
            }[];
          }[];
          managerOperators?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            userId?: number;
            code?: string;
            displayName?: string;
            userStatus?: number;
            institutionId?: number;
            departmentId?: number;
            userType?: string;
            tenantCode?: string;
            status?: number;
            operatorType?: number;
            IsDefault?: number;
            mainJob?: number;
            order?: number;
            email?: string;
            phone?: string;
            mobile?: string;
            gender?: number;
            fax?: string;
            user?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                userId?: number;
                code?: string;
                displayName?: string;
                userStatus?: number;
                institutionId?: number;
                departmentId?: number;
                userType?: string;
                tenantCode?: string;
                status?: number;
                operatorType?: number;
                IsDefault?: number;
                mainJob?: number;
                order?: number;
                email?: string;
                phone?: string;
                mobile?: string;
                gender?: number;
                fax?: string;
                user?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                };
                uniqueIdentifier?: string;
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                departments?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  institutionId?: number;
                  parentId?: number;
                  hierarchy?: string;
                  isLeaf?: number;
                  status?: number;
                  type?: number;
                  description?: string;
                  shortName?: string;
                  address?: string;
                  level?: number;
                  operators?: {}[];
                  managerOperators?: {}[];
                  managerUsers?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  }[];
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  tenantCode?: string;
                  tenant?: {
                    id?: number;
                    source?: number;
                    code?: string;
                    name?: string;
                    parentId?: number;
                    type?: string;
                    hierarchy?: string;
                    leaf?: boolean;
                    effectiveDate?: string;
                    expirationDate?: string;
                    status?: number;
                  };
                  children?: {}[];
                  striplineCodes?: string;
                  organizationCode?: string;
                  source?: number;
                  order?: number;
                }[];
                tiles?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  abbreviation?: string;
                  name?: string;
                  code?: string;
                  institutionId?: number;
                  tenantCode?: string;
                  tenantName?: string;
                  userType?: string;
                  userTypeName?: string;
                  tag?: string;
                  status?: number;
                  parentId?: number;
                  parentTitle?: {};
                  organizationType?: number;
                  uniqueKey?: string;
                }[];
                source?: number;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                jobAttributesCode?: string;
                remark?: string;
                ifSetJob?: boolean;
                operatorProfessionType?: number;
                outAccountId?: string;
                syncStatus?: number;
                tenantName?: string;
                jobAttributes?: {
                  organizationId?: number;
                  organizationType?: number;
                  jobAttributesCode?: string;
                }[];
              }[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            };
            uniqueIdentifier?: string;
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            departments?: {}[];
            tiles?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              abbreviation?: string;
              name?: string;
              code?: string;
              institutionId?: number;
              tenantCode?: string;
              tenantName?: string;
              userType?: string;
              userTypeName?: string;
              tag?: string;
              status?: number;
              parentId?: number;
              parentTitle?: {};
              organizationType?: number;
              uniqueKey?: string;
            }[];
            source?: number;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            jobAttributesCode?: string;
            remark?: string;
            ifSetJob?: boolean;
            operatorProfessionType?: number;
            outAccountId?: string;
            syncStatus?: number;
            tenantName?: string;
            jobAttributes?: {
              organizationId?: number;
              organizationType?: number;
              jobAttributesCode?: string;
            }[];
          }[];
          managerUsers?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            displayName?: string;
            realName?: string;
            password?: string;
            loginId?: string;
            mobile?: string;
            email?: string;
            tag?: number;
            idType?: number;
            idNo?: string;
            avatar?: string;
            gender?: number;
            active?: string;
            birthday?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            postCode?: string;
            description?: string;
            encryptionType?: string;
            infoPerfectLevel?: number;
            status?: number;
            userTypes?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              code?: string;
              name?: string;
              type?: number;
              status?: number;
              hierarchy?: string;
              parentCode?: string;
              isLeaf?: boolean;
              descp?: string;
              tenantCode?: string;
              tenantId?: number;
            }[];
            operators?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              userId?: number;
              code?: string;
              displayName?: string;
              userStatus?: number;
              institutionId?: number;
              departmentId?: number;
              userType?: string;
              tenantCode?: string;
              status?: number;
              operatorType?: number;
              IsDefault?: number;
              mainJob?: number;
              order?: number;
              email?: string;
              phone?: string;
              mobile?: string;
              gender?: number;
              fax?: string;
              user?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {}[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              };
              uniqueIdentifier?: string;
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              departments?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                institutionId?: number;
                parentId?: number;
                hierarchy?: string;
                isLeaf?: number;
                status?: number;
                type?: number;
                description?: string;
                shortName?: string;
                address?: string;
                level?: number;
                operators?: {}[];
                managerOperators?: {}[];
                managerUsers?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                }[];
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                tenantCode?: string;
                tenant?: {
                  id?: number;
                  source?: number;
                  code?: string;
                  name?: string;
                  parentId?: number;
                  type?: string;
                  hierarchy?: string;
                  leaf?: boolean;
                  effectiveDate?: string;
                  expirationDate?: string;
                  status?: number;
                };
                children?: {}[];
                striplineCodes?: string;
                organizationCode?: string;
                source?: number;
                order?: number;
              }[];
              tiles?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                abbreviation?: string;
                name?: string;
                code?: string;
                institutionId?: number;
                tenantCode?: string;
                tenantName?: string;
                userType?: string;
                userTypeName?: string;
                tag?: string;
                status?: number;
                parentId?: number;
                parentTitle?: {};
                organizationType?: number;
                uniqueKey?: string;
              }[];
              source?: number;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              jobAttributesCode?: string;
              remark?: string;
              ifSetJob?: boolean;
              operatorProfessionType?: number;
              outAccountId?: string;
              syncStatus?: number;
              tenantName?: string;
              jobAttributes?: {
                organizationId?: number;
                organizationType?: number;
                jobAttributesCode?: string;
              }[];
            }[];
            recentlyOperator?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              userId?: number;
              institutionId?: number;
              userType?: string;
              tenantCode?: string;
              userStatus?: number;
              status?: number;
              operatorType?: number;
              email?: string;
              mobile?: string;
              code?: string;
            };
            workStatus?: number;
            employeeCode?: string;
            outAccountId?: string;
            openId?: string;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            userExtFieldsDto?: {
              verifyMobile?: number;
              verifyIdNo?: number;
            };
            politicsStatus?: string;
            source?: number;
            jobLevelCode?: string;
            budgetedPostCode?: string;
            lock?: number;
          }[];
          institution?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string[];
            tags?: string[];
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
            tagCodes?: string;
            consistencyCheck?: number;
            budgetCheck?: number;
            costControlCheck?: number;
            workflowCheck?: number;
          };
          tenantCode?: string;
          tenant?: {
            id?: number;
            source?: number;
            code?: string;
            name?: string;
            parentId?: number;
            type?: string;
            hierarchy?: string;
            leaf?: boolean;
            effectiveDate?: string;
            expirationDate?: string;
            status?: number;
          };
          children?: {}[];
          striplineCodes?: string;
          organizationCode?: string;
          source?: number;
          order?: number;
        }[];
        tiles?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          abbreviation?: string;
          name?: string;
          code?: string;
          institutionId?: number;
          tenantCode?: string;
          tenantName?: string;
          userType?: string;
          userTypeName?: string;
          tag?: string;
          status?: number;
          parentId?: number;
          parentTitle?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            abbreviation?: string;
            name?: string;
            code?: string;
            institutionId?: number;
            tenantCode?: string;
            tenantName?: string;
            userType?: string;
            userTypeName?: string;
            tag?: string;
            status?: number;
            parentId?: number;
            parentTitle?: {};
            organizationType?: number;
            uniqueKey?: string;
          };
          organizationType?: number;
          uniqueKey?: string;
        }[];
        source?: number;
        /**
         * 「已废弃」
         * 「已废弃」
         */
        jobAttributesCode?: string;
        remark?: string;
        ifSetJob?: boolean;
        operatorProfessionType?: number;
        outAccountId?: string;
        syncStatus?: number;
        tenantName?: string;
        jobAttributes?: {
          organizationId?: number;
          organizationType?: number;
          jobAttributesCode?: string;
        }[];
      }[];
      managerOperators?: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        creatorId?: number;
        modifierId?: number;
        extFields?: string;
        extMap?: {
          key?: string;
        };
        userId?: number;
        code?: string;
        displayName?: string;
        userStatus?: number;
        institutionId?: number;
        departmentId?: number;
        userType?: string;
        tenantCode?: string;
        status?: number;
        operatorType?: number;
        IsDefault?: number;
        mainJob?: number;
        order?: number;
        email?: string;
        phone?: string;
        mobile?: string;
        gender?: number;
        fax?: string;
        user?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          displayName?: string;
          realName?: string;
          password?: string;
          loginId?: string;
          mobile?: string;
          email?: string;
          tag?: number;
          idType?: number;
          idNo?: string;
          avatar?: string;
          gender?: number;
          active?: string;
          birthday?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          postCode?: string;
          description?: string;
          encryptionType?: string;
          infoPerfectLevel?: number;
          status?: number;
          userTypes?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            code?: string;
            name?: string;
            type?: number;
            status?: number;
            hierarchy?: string;
            parentCode?: string;
            isLeaf?: boolean;
            descp?: string;
            tenantCode?: string;
            tenantId?: number;
          }[];
          operators?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            userId?: number;
            code?: string;
            displayName?: string;
            userStatus?: number;
            institutionId?: number;
            departmentId?: number;
            userType?: string;
            tenantCode?: string;
            status?: number;
            operatorType?: number;
            IsDefault?: number;
            mainJob?: number;
            order?: number;
            email?: string;
            phone?: string;
            mobile?: string;
            gender?: number;
            fax?: string;
            user?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {}[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            };
            uniqueIdentifier?: string;
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            departments?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              institutionId?: number;
              parentId?: number;
              hierarchy?: string;
              isLeaf?: number;
              status?: number;
              type?: number;
              description?: string;
              shortName?: string;
              address?: string;
              level?: number;
              operators?: {}[];
              managerOperators?: {}[];
              managerUsers?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {}[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              }[];
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              tenantCode?: string;
              tenant?: {
                id?: number;
                source?: number;
                code?: string;
                name?: string;
                parentId?: number;
                type?: string;
                hierarchy?: string;
                leaf?: boolean;
                effectiveDate?: string;
                expirationDate?: string;
                status?: number;
              };
              children?: {}[];
              striplineCodes?: string;
              organizationCode?: string;
              source?: number;
              order?: number;
            }[];
            tiles?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              abbreviation?: string;
              name?: string;
              code?: string;
              institutionId?: number;
              tenantCode?: string;
              tenantName?: string;
              userType?: string;
              userTypeName?: string;
              tag?: string;
              status?: number;
              parentId?: number;
              parentTitle?: {};
              organizationType?: number;
              uniqueKey?: string;
            }[];
            source?: number;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            jobAttributesCode?: string;
            remark?: string;
            ifSetJob?: boolean;
            operatorProfessionType?: number;
            outAccountId?: string;
            syncStatus?: number;
            tenantName?: string;
            jobAttributes?: {
              organizationId?: number;
              organizationType?: number;
              jobAttributesCode?: string;
            }[];
          }[];
          recentlyOperator?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            displayName?: string;
            userId?: number;
            institutionId?: number;
            userType?: string;
            tenantCode?: string;
            userStatus?: number;
            status?: number;
            operatorType?: number;
            email?: string;
            mobile?: string;
            code?: string;
          };
          workStatus?: number;
          employeeCode?: string;
          outAccountId?: string;
          openId?: string;
          /**
           * 「已废弃」
           * 「已废弃」
           */
          userExtFieldsDto?: {
            verifyMobile?: number;
            verifyIdNo?: number;
          };
          politicsStatus?: string;
          source?: number;
          jobLevelCode?: string;
          budgetedPostCode?: string;
          lock?: number;
        };
        uniqueIdentifier?: string;
        institution?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string[];
          tags?: string[];
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
          tagCodes?: string;
          consistencyCheck?: number;
          budgetCheck?: number;
          costControlCheck?: number;
          workflowCheck?: number;
        };
        departments?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          name?: string;
          institutionId?: number;
          parentId?: number;
          hierarchy?: string;
          isLeaf?: number;
          status?: number;
          type?: number;
          description?: string;
          shortName?: string;
          address?: string;
          level?: number;
          operators?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            userId?: number;
            code?: string;
            displayName?: string;
            userStatus?: number;
            institutionId?: number;
            departmentId?: number;
            userType?: string;
            tenantCode?: string;
            status?: number;
            operatorType?: number;
            IsDefault?: number;
            mainJob?: number;
            order?: number;
            email?: string;
            phone?: string;
            mobile?: string;
            gender?: number;
            fax?: string;
            user?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                userId?: number;
                code?: string;
                displayName?: string;
                userStatus?: number;
                institutionId?: number;
                departmentId?: number;
                userType?: string;
                tenantCode?: string;
                status?: number;
                operatorType?: number;
                IsDefault?: number;
                mainJob?: number;
                order?: number;
                email?: string;
                phone?: string;
                mobile?: string;
                gender?: number;
                fax?: string;
                user?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                };
                uniqueIdentifier?: string;
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                departments?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  institutionId?: number;
                  parentId?: number;
                  hierarchy?: string;
                  isLeaf?: number;
                  status?: number;
                  type?: number;
                  description?: string;
                  shortName?: string;
                  address?: string;
                  level?: number;
                  operators?: {}[];
                  managerOperators?: {}[];
                  managerUsers?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  }[];
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  tenantCode?: string;
                  tenant?: {
                    id?: number;
                    source?: number;
                    code?: string;
                    name?: string;
                    parentId?: number;
                    type?: string;
                    hierarchy?: string;
                    leaf?: boolean;
                    effectiveDate?: string;
                    expirationDate?: string;
                    status?: number;
                  };
                  children?: {}[];
                  striplineCodes?: string;
                  organizationCode?: string;
                  source?: number;
                  order?: number;
                }[];
                tiles?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  abbreviation?: string;
                  name?: string;
                  code?: string;
                  institutionId?: number;
                  tenantCode?: string;
                  tenantName?: string;
                  userType?: string;
                  userTypeName?: string;
                  tag?: string;
                  status?: number;
                  parentId?: number;
                  parentTitle?: {};
                  organizationType?: number;
                  uniqueKey?: string;
                }[];
                source?: number;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                jobAttributesCode?: string;
                remark?: string;
                ifSetJob?: boolean;
                operatorProfessionType?: number;
                outAccountId?: string;
                syncStatus?: number;
                tenantName?: string;
                jobAttributes?: {
                  organizationId?: number;
                  organizationType?: number;
                  jobAttributesCode?: string;
                }[];
              }[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            };
            uniqueIdentifier?: string;
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            departments?: {}[];
            tiles?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              abbreviation?: string;
              name?: string;
              code?: string;
              institutionId?: number;
              tenantCode?: string;
              tenantName?: string;
              userType?: string;
              userTypeName?: string;
              tag?: string;
              status?: number;
              parentId?: number;
              parentTitle?: {};
              organizationType?: number;
              uniqueKey?: string;
            }[];
            source?: number;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            jobAttributesCode?: string;
            remark?: string;
            ifSetJob?: boolean;
            operatorProfessionType?: number;
            outAccountId?: string;
            syncStatus?: number;
            tenantName?: string;
            jobAttributes?: {
              organizationId?: number;
              organizationType?: number;
              jobAttributesCode?: string;
            }[];
          }[];
          managerOperators?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            userId?: number;
            code?: string;
            displayName?: string;
            userStatus?: number;
            institutionId?: number;
            departmentId?: number;
            userType?: string;
            tenantCode?: string;
            status?: number;
            operatorType?: number;
            IsDefault?: number;
            mainJob?: number;
            order?: number;
            email?: string;
            phone?: string;
            mobile?: string;
            gender?: number;
            fax?: string;
            user?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                userId?: number;
                code?: string;
                displayName?: string;
                userStatus?: number;
                institutionId?: number;
                departmentId?: number;
                userType?: string;
                tenantCode?: string;
                status?: number;
                operatorType?: number;
                IsDefault?: number;
                mainJob?: number;
                order?: number;
                email?: string;
                phone?: string;
                mobile?: string;
                gender?: number;
                fax?: string;
                user?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                };
                uniqueIdentifier?: string;
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                departments?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  institutionId?: number;
                  parentId?: number;
                  hierarchy?: string;
                  isLeaf?: number;
                  status?: number;
                  type?: number;
                  description?: string;
                  shortName?: string;
                  address?: string;
                  level?: number;
                  operators?: {}[];
                  managerOperators?: {}[];
                  managerUsers?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  }[];
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  tenantCode?: string;
                  tenant?: {
                    id?: number;
                    source?: number;
                    code?: string;
                    name?: string;
                    parentId?: number;
                    type?: string;
                    hierarchy?: string;
                    leaf?: boolean;
                    effectiveDate?: string;
                    expirationDate?: string;
                    status?: number;
                  };
                  children?: {}[];
                  striplineCodes?: string;
                  organizationCode?: string;
                  source?: number;
                  order?: number;
                }[];
                tiles?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  abbreviation?: string;
                  name?: string;
                  code?: string;
                  institutionId?: number;
                  tenantCode?: string;
                  tenantName?: string;
                  userType?: string;
                  userTypeName?: string;
                  tag?: string;
                  status?: number;
                  parentId?: number;
                  parentTitle?: {};
                  organizationType?: number;
                  uniqueKey?: string;
                }[];
                source?: number;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                jobAttributesCode?: string;
                remark?: string;
                ifSetJob?: boolean;
                operatorProfessionType?: number;
                outAccountId?: string;
                syncStatus?: number;
                tenantName?: string;
                jobAttributes?: {
                  organizationId?: number;
                  organizationType?: number;
                  jobAttributesCode?: string;
                }[];
              }[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            };
            uniqueIdentifier?: string;
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            departments?: {}[];
            tiles?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              abbreviation?: string;
              name?: string;
              code?: string;
              institutionId?: number;
              tenantCode?: string;
              tenantName?: string;
              userType?: string;
              userTypeName?: string;
              tag?: string;
              status?: number;
              parentId?: number;
              parentTitle?: {};
              organizationType?: number;
              uniqueKey?: string;
            }[];
            source?: number;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            jobAttributesCode?: string;
            remark?: string;
            ifSetJob?: boolean;
            operatorProfessionType?: number;
            outAccountId?: string;
            syncStatus?: number;
            tenantName?: string;
            jobAttributes?: {
              organizationId?: number;
              organizationType?: number;
              jobAttributesCode?: string;
            }[];
          }[];
          managerUsers?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            displayName?: string;
            realName?: string;
            password?: string;
            loginId?: string;
            mobile?: string;
            email?: string;
            tag?: number;
            idType?: number;
            idNo?: string;
            avatar?: string;
            gender?: number;
            active?: string;
            birthday?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            postCode?: string;
            description?: string;
            encryptionType?: string;
            infoPerfectLevel?: number;
            status?: number;
            userTypes?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              code?: string;
              name?: string;
              type?: number;
              status?: number;
              hierarchy?: string;
              parentCode?: string;
              isLeaf?: boolean;
              descp?: string;
              tenantCode?: string;
              tenantId?: number;
            }[];
            operators?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              userId?: number;
              code?: string;
              displayName?: string;
              userStatus?: number;
              institutionId?: number;
              departmentId?: number;
              userType?: string;
              tenantCode?: string;
              status?: number;
              operatorType?: number;
              IsDefault?: number;
              mainJob?: number;
              order?: number;
              email?: string;
              phone?: string;
              mobile?: string;
              gender?: number;
              fax?: string;
              user?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {}[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              };
              uniqueIdentifier?: string;
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              departments?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                institutionId?: number;
                parentId?: number;
                hierarchy?: string;
                isLeaf?: number;
                status?: number;
                type?: number;
                description?: string;
                shortName?: string;
                address?: string;
                level?: number;
                operators?: {}[];
                managerOperators?: {}[];
                managerUsers?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                }[];
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                tenantCode?: string;
                tenant?: {
                  id?: number;
                  source?: number;
                  code?: string;
                  name?: string;
                  parentId?: number;
                  type?: string;
                  hierarchy?: string;
                  leaf?: boolean;
                  effectiveDate?: string;
                  expirationDate?: string;
                  status?: number;
                };
                children?: {}[];
                striplineCodes?: string;
                organizationCode?: string;
                source?: number;
                order?: number;
              }[];
              tiles?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                abbreviation?: string;
                name?: string;
                code?: string;
                institutionId?: number;
                tenantCode?: string;
                tenantName?: string;
                userType?: string;
                userTypeName?: string;
                tag?: string;
                status?: number;
                parentId?: number;
                parentTitle?: {};
                organizationType?: number;
                uniqueKey?: string;
              }[];
              source?: number;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              jobAttributesCode?: string;
              remark?: string;
              ifSetJob?: boolean;
              operatorProfessionType?: number;
              outAccountId?: string;
              syncStatus?: number;
              tenantName?: string;
              jobAttributes?: {
                organizationId?: number;
                organizationType?: number;
                jobAttributesCode?: string;
              }[];
            }[];
            recentlyOperator?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              userId?: number;
              institutionId?: number;
              userType?: string;
              tenantCode?: string;
              userStatus?: number;
              status?: number;
              operatorType?: number;
              email?: string;
              mobile?: string;
              code?: string;
            };
            workStatus?: number;
            employeeCode?: string;
            outAccountId?: string;
            openId?: string;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            userExtFieldsDto?: {
              verifyMobile?: number;
              verifyIdNo?: number;
            };
            politicsStatus?: string;
            source?: number;
            jobLevelCode?: string;
            budgetedPostCode?: string;
            lock?: number;
          }[];
          institution?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string[];
            tags?: string[];
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
            tagCodes?: string;
            consistencyCheck?: number;
            budgetCheck?: number;
            costControlCheck?: number;
            workflowCheck?: number;
          };
          tenantCode?: string;
          tenant?: {
            id?: number;
            source?: number;
            code?: string;
            name?: string;
            parentId?: number;
            type?: string;
            hierarchy?: string;
            leaf?: boolean;
            effectiveDate?: string;
            expirationDate?: string;
            status?: number;
          };
          children?: {}[];
          striplineCodes?: string;
          organizationCode?: string;
          source?: number;
          order?: number;
        }[];
        tiles?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          abbreviation?: string;
          name?: string;
          code?: string;
          institutionId?: number;
          tenantCode?: string;
          tenantName?: string;
          userType?: string;
          userTypeName?: string;
          tag?: string;
          status?: number;
          parentId?: number;
          parentTitle?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            abbreviation?: string;
            name?: string;
            code?: string;
            institutionId?: number;
            tenantCode?: string;
            tenantName?: string;
            userType?: string;
            userTypeName?: string;
            tag?: string;
            status?: number;
            parentId?: number;
            parentTitle?: {};
            organizationType?: number;
            uniqueKey?: string;
          };
          organizationType?: number;
          uniqueKey?: string;
        }[];
        source?: number;
        /**
         * 「已废弃」
         * 「已废弃」
         */
        jobAttributesCode?: string;
        remark?: string;
        ifSetJob?: boolean;
        operatorProfessionType?: number;
        outAccountId?: string;
        syncStatus?: number;
        tenantName?: string;
        jobAttributes?: {
          organizationId?: number;
          organizationType?: number;
          jobAttributesCode?: string;
        }[];
      }[];
      managerUsers?: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        creatorId?: number;
        modifierId?: number;
        extFields?: string;
        extMap?: {
          key?: string;
        };
        displayName?: string;
        realName?: string;
        password?: string;
        loginId?: string;
        mobile?: string;
        email?: string;
        tag?: number;
        idType?: number;
        idNo?: string;
        avatar?: string;
        gender?: number;
        active?: string;
        birthday?: string;
        provinceCode?: string;
        provinceName?: string;
        cityCode?: string;
        cityName?: string;
        regionCode?: string;
        regionName?: string;
        address?: string;
        postCode?: string;
        description?: string;
        encryptionType?: string;
        infoPerfectLevel?: number;
        status?: number;
        userTypes?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          code?: string;
          name?: string;
          type?: number;
          status?: number;
          hierarchy?: string;
          parentCode?: string;
          isLeaf?: boolean;
          descp?: string;
          tenantCode?: string;
          tenantId?: number;
        }[];
        operators?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          userId?: number;
          code?: string;
          displayName?: string;
          userStatus?: number;
          institutionId?: number;
          departmentId?: number;
          userType?: string;
          tenantCode?: string;
          status?: number;
          operatorType?: number;
          IsDefault?: number;
          mainJob?: number;
          order?: number;
          email?: string;
          phone?: string;
          mobile?: string;
          gender?: number;
          fax?: string;
          user?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            displayName?: string;
            realName?: string;
            password?: string;
            loginId?: string;
            mobile?: string;
            email?: string;
            tag?: number;
            idType?: number;
            idNo?: string;
            avatar?: string;
            gender?: number;
            active?: string;
            birthday?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            postCode?: string;
            description?: string;
            encryptionType?: string;
            infoPerfectLevel?: number;
            status?: number;
            userTypes?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              code?: string;
              name?: string;
              type?: number;
              status?: number;
              hierarchy?: string;
              parentCode?: string;
              isLeaf?: boolean;
              descp?: string;
              tenantCode?: string;
              tenantId?: number;
            }[];
            operators?: {}[];
            recentlyOperator?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              userId?: number;
              institutionId?: number;
              userType?: string;
              tenantCode?: string;
              userStatus?: number;
              status?: number;
              operatorType?: number;
              email?: string;
              mobile?: string;
              code?: string;
            };
            workStatus?: number;
            employeeCode?: string;
            outAccountId?: string;
            openId?: string;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            userExtFieldsDto?: {
              verifyMobile?: number;
              verifyIdNo?: number;
            };
            politicsStatus?: string;
            source?: number;
            jobLevelCode?: string;
            budgetedPostCode?: string;
            lock?: number;
          };
          uniqueIdentifier?: string;
          institution?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string[];
            tags?: string[];
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
            tagCodes?: string;
            consistencyCheck?: number;
            budgetCheck?: number;
            costControlCheck?: number;
            workflowCheck?: number;
          };
          departments?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            name?: string;
            institutionId?: number;
            parentId?: number;
            hierarchy?: string;
            isLeaf?: number;
            status?: number;
            type?: number;
            description?: string;
            shortName?: string;
            address?: string;
            level?: number;
            operators?: {}[];
            managerOperators?: {}[];
            managerUsers?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {}[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            }[];
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            tenantCode?: string;
            tenant?: {
              id?: number;
              source?: number;
              code?: string;
              name?: string;
              parentId?: number;
              type?: string;
              hierarchy?: string;
              leaf?: boolean;
              effectiveDate?: string;
              expirationDate?: string;
              status?: number;
            };
            children?: {}[];
            striplineCodes?: string;
            organizationCode?: string;
            source?: number;
            order?: number;
          }[];
          tiles?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            abbreviation?: string;
            name?: string;
            code?: string;
            institutionId?: number;
            tenantCode?: string;
            tenantName?: string;
            userType?: string;
            userTypeName?: string;
            tag?: string;
            status?: number;
            parentId?: number;
            parentTitle?: {};
            organizationType?: number;
            uniqueKey?: string;
          }[];
          source?: number;
          /**
           * 「已废弃」
           * 「已废弃」
           */
          jobAttributesCode?: string;
          remark?: string;
          ifSetJob?: boolean;
          operatorProfessionType?: number;
          outAccountId?: string;
          syncStatus?: number;
          tenantName?: string;
          jobAttributes?: {
            organizationId?: number;
            organizationType?: number;
            jobAttributesCode?: string;
          }[];
        }[];
        recentlyOperator?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          displayName?: string;
          userId?: number;
          institutionId?: number;
          userType?: string;
          tenantCode?: string;
          userStatus?: number;
          status?: number;
          operatorType?: number;
          email?: string;
          mobile?: string;
          code?: string;
        };
        workStatus?: number;
        employeeCode?: string;
        outAccountId?: string;
        openId?: string;
        /**
         * 「已废弃」
         * 「已废弃」
         */
        userExtFieldsDto?: {
          verifyMobile?: number;
          verifyIdNo?: number;
        };
        politicsStatus?: string;
        source?: number;
        jobLevelCode?: string;
        budgetedPostCode?: string;
        lock?: number;
      }[];
      institution?: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        creatorId?: number;
        modifierId?: number;
        extFields?: string;
        extMap?: {
          key?: string;
        };
        name?: string;
        shortName?: string;
        orgCode?: string;
        creditCode?: string;
        bizAttaches?: string[];
        tags?: string[];
        provinceCode?: string;
        provinceName?: string;
        cityCode?: string;
        cityName?: string;
        regionCode?: string;
        regionName?: string;
        address?: string;
        status?: number;
        displayOrder?: number;
        outCreatedAt?: string;
        fullName?: string;
        postalCode?: string;
        source?: number;
        organizationCode?: string;
        institutionLevel?: number;
        tagCodes?: string;
        consistencyCheck?: number;
        budgetCheck?: number;
        costControlCheck?: number;
        workflowCheck?: number;
      };
      tenantCode?: string;
      tenant?: {
        id?: number;
        source?: number;
        code?: string;
        name?: string;
        parentId?: number;
        type?: string;
        hierarchy?: string;
        leaf?: boolean;
        effectiveDate?: string;
        expirationDate?: string;
        status?: number;
      };
      children?: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        creatorId?: number;
        modifierId?: number;
        extFields?: string;
        extMap?: {
          key?: string;
        };
        name?: string;
        institutionId?: number;
        parentId?: number;
        hierarchy?: string;
        isLeaf?: number;
        status?: number;
        type?: number;
        description?: string;
        shortName?: string;
        address?: string;
        level?: number;
        operators?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          userId?: number;
          code?: string;
          displayName?: string;
          userStatus?: number;
          institutionId?: number;
          departmentId?: number;
          userType?: string;
          tenantCode?: string;
          status?: number;
          operatorType?: number;
          IsDefault?: number;
          mainJob?: number;
          order?: number;
          email?: string;
          phone?: string;
          mobile?: string;
          gender?: number;
          fax?: string;
          user?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            displayName?: string;
            realName?: string;
            password?: string;
            loginId?: string;
            mobile?: string;
            email?: string;
            tag?: number;
            idType?: number;
            idNo?: string;
            avatar?: string;
            gender?: number;
            active?: string;
            birthday?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            postCode?: string;
            description?: string;
            encryptionType?: string;
            infoPerfectLevel?: number;
            status?: number;
            userTypes?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              code?: string;
              name?: string;
              type?: number;
              status?: number;
              hierarchy?: string;
              parentCode?: string;
              isLeaf?: boolean;
              descp?: string;
              tenantCode?: string;
              tenantId?: number;
            }[];
            operators?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              userId?: number;
              code?: string;
              displayName?: string;
              userStatus?: number;
              institutionId?: number;
              departmentId?: number;
              userType?: string;
              tenantCode?: string;
              status?: number;
              operatorType?: number;
              IsDefault?: number;
              mainJob?: number;
              order?: number;
              email?: string;
              phone?: string;
              mobile?: string;
              gender?: number;
              fax?: string;
              user?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {}[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              };
              uniqueIdentifier?: string;
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              departments?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                institutionId?: number;
                parentId?: number;
                hierarchy?: string;
                isLeaf?: number;
                status?: number;
                type?: number;
                description?: string;
                shortName?: string;
                address?: string;
                level?: number;
                operators?: {}[];
                managerOperators?: {}[];
                managerUsers?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                }[];
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                tenantCode?: string;
                tenant?: {
                  id?: number;
                  source?: number;
                  code?: string;
                  name?: string;
                  parentId?: number;
                  type?: string;
                  hierarchy?: string;
                  leaf?: boolean;
                  effectiveDate?: string;
                  expirationDate?: string;
                  status?: number;
                };
                children?: {}[];
                striplineCodes?: string;
                organizationCode?: string;
                source?: number;
                order?: number;
              }[];
              tiles?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                abbreviation?: string;
                name?: string;
                code?: string;
                institutionId?: number;
                tenantCode?: string;
                tenantName?: string;
                userType?: string;
                userTypeName?: string;
                tag?: string;
                status?: number;
                parentId?: number;
                parentTitle?: {};
                organizationType?: number;
                uniqueKey?: string;
              }[];
              source?: number;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              jobAttributesCode?: string;
              remark?: string;
              ifSetJob?: boolean;
              operatorProfessionType?: number;
              outAccountId?: string;
              syncStatus?: number;
              tenantName?: string;
              jobAttributes?: {
                organizationId?: number;
                organizationType?: number;
                jobAttributesCode?: string;
              }[];
            }[];
            recentlyOperator?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              userId?: number;
              institutionId?: number;
              userType?: string;
              tenantCode?: string;
              userStatus?: number;
              status?: number;
              operatorType?: number;
              email?: string;
              mobile?: string;
              code?: string;
            };
            workStatus?: number;
            employeeCode?: string;
            outAccountId?: string;
            openId?: string;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            userExtFieldsDto?: {
              verifyMobile?: number;
              verifyIdNo?: number;
            };
            politicsStatus?: string;
            source?: number;
            jobLevelCode?: string;
            budgetedPostCode?: string;
            lock?: number;
          };
          uniqueIdentifier?: string;
          institution?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string[];
            tags?: string[];
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
            tagCodes?: string;
            consistencyCheck?: number;
            budgetCheck?: number;
            costControlCheck?: number;
            workflowCheck?: number;
          };
          departments?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            name?: string;
            institutionId?: number;
            parentId?: number;
            hierarchy?: string;
            isLeaf?: number;
            status?: number;
            type?: number;
            description?: string;
            shortName?: string;
            address?: string;
            level?: number;
            operators?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              userId?: number;
              code?: string;
              displayName?: string;
              userStatus?: number;
              institutionId?: number;
              departmentId?: number;
              userType?: string;
              tenantCode?: string;
              status?: number;
              operatorType?: number;
              IsDefault?: number;
              mainJob?: number;
              order?: number;
              email?: string;
              phone?: string;
              mobile?: string;
              gender?: number;
              fax?: string;
              user?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  userId?: number;
                  code?: string;
                  displayName?: string;
                  userStatus?: number;
                  institutionId?: number;
                  departmentId?: number;
                  userType?: string;
                  tenantCode?: string;
                  status?: number;
                  operatorType?: number;
                  IsDefault?: number;
                  mainJob?: number;
                  order?: number;
                  email?: string;
                  phone?: string;
                  mobile?: string;
                  gender?: number;
                  fax?: string;
                  user?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  };
                  uniqueIdentifier?: string;
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  departments?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    institutionId?: number;
                    parentId?: number;
                    hierarchy?: string;
                    isLeaf?: number;
                    status?: number;
                    type?: number;
                    description?: string;
                    shortName?: string;
                    address?: string;
                    level?: number;
                    operators?: {}[];
                    managerOperators?: {}[];
                    managerUsers?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      realName?: string;
                      password?: string;
                      loginId?: string;
                      mobile?: string;
                      email?: string;
                      tag?: number;
                      idType?: number;
                      idNo?: string;
                      avatar?: string;
                      gender?: number;
                      active?: string;
                      birthday?: string;
                      provinceCode?: string;
                      provinceName?: string;
                      cityCode?: string;
                      cityName?: string;
                      regionCode?: string;
                      regionName?: string;
                      address?: string;
                      postCode?: string;
                      description?: string;
                      encryptionType?: string;
                      infoPerfectLevel?: number;
                      status?: number;
                      userTypes?: {
                        id?: number;
                        createdAt?: string;
                        updatedAt?: string;
                        creatorId?: number;
                        modifierId?: number;
                        extFields?: string;
                        extMap?: {
                          key?: string;
                        };
                        code?: string;
                        name?: string;
                        type?: number;
                        status?: number;
                        hierarchy?: string;
                        parentCode?: string;
                        isLeaf?: boolean;
                        descp?: string;
                        tenantCode?: string;
                        tenantId?: number;
                      }[];
                      operators?: {}[];
                      recentlyOperator?: {
                        id?: number;
                        createdAt?: string;
                        updatedAt?: string;
                        creatorId?: number;
                        modifierId?: number;
                        extFields?: string;
                        extMap?: {
                          key?: string;
                        };
                        displayName?: string;
                        userId?: number;
                        institutionId?: number;
                        userType?: string;
                        tenantCode?: string;
                        userStatus?: number;
                        status?: number;
                        operatorType?: number;
                        email?: string;
                        mobile?: string;
                        code?: string;
                      };
                      workStatus?: number;
                      employeeCode?: string;
                      outAccountId?: string;
                      openId?: string;
                      /**
                       * 「已废弃」
                       * 「已废弃」
                       */
                      userExtFieldsDto?: {
                        verifyMobile?: number;
                        verifyIdNo?: number;
                      };
                      politicsStatus?: string;
                      source?: number;
                      jobLevelCode?: string;
                      budgetedPostCode?: string;
                      lock?: number;
                    }[];
                    institution?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      name?: string;
                      shortName?: string;
                      orgCode?: string;
                      creditCode?: string;
                      bizAttaches?: string[];
                      tags?: string[];
                      provinceCode?: string;
                      provinceName?: string;
                      cityCode?: string;
                      cityName?: string;
                      regionCode?: string;
                      regionName?: string;
                      address?: string;
                      status?: number;
                      displayOrder?: number;
                      outCreatedAt?: string;
                      fullName?: string;
                      postalCode?: string;
                      source?: number;
                      organizationCode?: string;
                      institutionLevel?: number;
                      tagCodes?: string;
                      consistencyCheck?: number;
                      budgetCheck?: number;
                      costControlCheck?: number;
                      workflowCheck?: number;
                    };
                    tenantCode?: string;
                    tenant?: {
                      id?: number;
                      source?: number;
                      code?: string;
                      name?: string;
                      parentId?: number;
                      type?: string;
                      hierarchy?: string;
                      leaf?: boolean;
                      effectiveDate?: string;
                      expirationDate?: string;
                      status?: number;
                    };
                    children?: {}[];
                    striplineCodes?: string;
                    organizationCode?: string;
                    source?: number;
                    order?: number;
                  }[];
                  tiles?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    abbreviation?: string;
                    name?: string;
                    code?: string;
                    institutionId?: number;
                    tenantCode?: string;
                    tenantName?: string;
                    userType?: string;
                    userTypeName?: string;
                    tag?: string;
                    status?: number;
                    parentId?: number;
                    parentTitle?: {};
                    organizationType?: number;
                    uniqueKey?: string;
                  }[];
                  source?: number;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  jobAttributesCode?: string;
                  remark?: string;
                  ifSetJob?: boolean;
                  operatorProfessionType?: number;
                  outAccountId?: string;
                  syncStatus?: number;
                  tenantName?: string;
                  jobAttributes?: {
                    organizationId?: number;
                    organizationType?: number;
                    jobAttributesCode?: string;
                  }[];
                }[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              };
              uniqueIdentifier?: string;
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              departments?: {}[];
              tiles?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                abbreviation?: string;
                name?: string;
                code?: string;
                institutionId?: number;
                tenantCode?: string;
                tenantName?: string;
                userType?: string;
                userTypeName?: string;
                tag?: string;
                status?: number;
                parentId?: number;
                parentTitle?: {};
                organizationType?: number;
                uniqueKey?: string;
              }[];
              source?: number;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              jobAttributesCode?: string;
              remark?: string;
              ifSetJob?: boolean;
              operatorProfessionType?: number;
              outAccountId?: string;
              syncStatus?: number;
              tenantName?: string;
              jobAttributes?: {
                organizationId?: number;
                organizationType?: number;
                jobAttributesCode?: string;
              }[];
            }[];
            managerOperators?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              userId?: number;
              code?: string;
              displayName?: string;
              userStatus?: number;
              institutionId?: number;
              departmentId?: number;
              userType?: string;
              tenantCode?: string;
              status?: number;
              operatorType?: number;
              IsDefault?: number;
              mainJob?: number;
              order?: number;
              email?: string;
              phone?: string;
              mobile?: string;
              gender?: number;
              fax?: string;
              user?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  userId?: number;
                  code?: string;
                  displayName?: string;
                  userStatus?: number;
                  institutionId?: number;
                  departmentId?: number;
                  userType?: string;
                  tenantCode?: string;
                  status?: number;
                  operatorType?: number;
                  IsDefault?: number;
                  mainJob?: number;
                  order?: number;
                  email?: string;
                  phone?: string;
                  mobile?: string;
                  gender?: number;
                  fax?: string;
                  user?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  };
                  uniqueIdentifier?: string;
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  departments?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    institutionId?: number;
                    parentId?: number;
                    hierarchy?: string;
                    isLeaf?: number;
                    status?: number;
                    type?: number;
                    description?: string;
                    shortName?: string;
                    address?: string;
                    level?: number;
                    operators?: {}[];
                    managerOperators?: {}[];
                    managerUsers?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      realName?: string;
                      password?: string;
                      loginId?: string;
                      mobile?: string;
                      email?: string;
                      tag?: number;
                      idType?: number;
                      idNo?: string;
                      avatar?: string;
                      gender?: number;
                      active?: string;
                      birthday?: string;
                      provinceCode?: string;
                      provinceName?: string;
                      cityCode?: string;
                      cityName?: string;
                      regionCode?: string;
                      regionName?: string;
                      address?: string;
                      postCode?: string;
                      description?: string;
                      encryptionType?: string;
                      infoPerfectLevel?: number;
                      status?: number;
                      userTypes?: {
                        id?: number;
                        createdAt?: string;
                        updatedAt?: string;
                        creatorId?: number;
                        modifierId?: number;
                        extFields?: string;
                        extMap?: {
                          key?: string;
                        };
                        code?: string;
                        name?: string;
                        type?: number;
                        status?: number;
                        hierarchy?: string;
                        parentCode?: string;
                        isLeaf?: boolean;
                        descp?: string;
                        tenantCode?: string;
                        tenantId?: number;
                      }[];
                      operators?: {}[];
                      recentlyOperator?: {
                        id?: number;
                        createdAt?: string;
                        updatedAt?: string;
                        creatorId?: number;
                        modifierId?: number;
                        extFields?: string;
                        extMap?: {
                          key?: string;
                        };
                        displayName?: string;
                        userId?: number;
                        institutionId?: number;
                        userType?: string;
                        tenantCode?: string;
                        userStatus?: number;
                        status?: number;
                        operatorType?: number;
                        email?: string;
                        mobile?: string;
                        code?: string;
                      };
                      workStatus?: number;
                      employeeCode?: string;
                      outAccountId?: string;
                      openId?: string;
                      /**
                       * 「已废弃」
                       * 「已废弃」
                       */
                      userExtFieldsDto?: {
                        verifyMobile?: number;
                        verifyIdNo?: number;
                      };
                      politicsStatus?: string;
                      source?: number;
                      jobLevelCode?: string;
                      budgetedPostCode?: string;
                      lock?: number;
                    }[];
                    institution?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      name?: string;
                      shortName?: string;
                      orgCode?: string;
                      creditCode?: string;
                      bizAttaches?: string[];
                      tags?: string[];
                      provinceCode?: string;
                      provinceName?: string;
                      cityCode?: string;
                      cityName?: string;
                      regionCode?: string;
                      regionName?: string;
                      address?: string;
                      status?: number;
                      displayOrder?: number;
                      outCreatedAt?: string;
                      fullName?: string;
                      postalCode?: string;
                      source?: number;
                      organizationCode?: string;
                      institutionLevel?: number;
                      tagCodes?: string;
                      consistencyCheck?: number;
                      budgetCheck?: number;
                      costControlCheck?: number;
                      workflowCheck?: number;
                    };
                    tenantCode?: string;
                    tenant?: {
                      id?: number;
                      source?: number;
                      code?: string;
                      name?: string;
                      parentId?: number;
                      type?: string;
                      hierarchy?: string;
                      leaf?: boolean;
                      effectiveDate?: string;
                      expirationDate?: string;
                      status?: number;
                    };
                    children?: {}[];
                    striplineCodes?: string;
                    organizationCode?: string;
                    source?: number;
                    order?: number;
                  }[];
                  tiles?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    abbreviation?: string;
                    name?: string;
                    code?: string;
                    institutionId?: number;
                    tenantCode?: string;
                    tenantName?: string;
                    userType?: string;
                    userTypeName?: string;
                    tag?: string;
                    status?: number;
                    parentId?: number;
                    parentTitle?: {};
                    organizationType?: number;
                    uniqueKey?: string;
                  }[];
                  source?: number;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  jobAttributesCode?: string;
                  remark?: string;
                  ifSetJob?: boolean;
                  operatorProfessionType?: number;
                  outAccountId?: string;
                  syncStatus?: number;
                  tenantName?: string;
                  jobAttributes?: {
                    organizationId?: number;
                    organizationType?: number;
                    jobAttributesCode?: string;
                  }[];
                }[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              };
              uniqueIdentifier?: string;
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              departments?: {}[];
              tiles?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                abbreviation?: string;
                name?: string;
                code?: string;
                institutionId?: number;
                tenantCode?: string;
                tenantName?: string;
                userType?: string;
                userTypeName?: string;
                tag?: string;
                status?: number;
                parentId?: number;
                parentTitle?: {};
                organizationType?: number;
                uniqueKey?: string;
              }[];
              source?: number;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              jobAttributesCode?: string;
              remark?: string;
              ifSetJob?: boolean;
              operatorProfessionType?: number;
              outAccountId?: string;
              syncStatus?: number;
              tenantName?: string;
              jobAttributes?: {
                organizationId?: number;
                organizationType?: number;
                jobAttributesCode?: string;
              }[];
            }[];
            managerUsers?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                userId?: number;
                code?: string;
                displayName?: string;
                userStatus?: number;
                institutionId?: number;
                departmentId?: number;
                userType?: string;
                tenantCode?: string;
                status?: number;
                operatorType?: number;
                IsDefault?: number;
                mainJob?: number;
                order?: number;
                email?: string;
                phone?: string;
                mobile?: string;
                gender?: number;
                fax?: string;
                user?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                };
                uniqueIdentifier?: string;
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                departments?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  institutionId?: number;
                  parentId?: number;
                  hierarchy?: string;
                  isLeaf?: number;
                  status?: number;
                  type?: number;
                  description?: string;
                  shortName?: string;
                  address?: string;
                  level?: number;
                  operators?: {}[];
                  managerOperators?: {}[];
                  managerUsers?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  }[];
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  tenantCode?: string;
                  tenant?: {
                    id?: number;
                    source?: number;
                    code?: string;
                    name?: string;
                    parentId?: number;
                    type?: string;
                    hierarchy?: string;
                    leaf?: boolean;
                    effectiveDate?: string;
                    expirationDate?: string;
                    status?: number;
                  };
                  children?: {}[];
                  striplineCodes?: string;
                  organizationCode?: string;
                  source?: number;
                  order?: number;
                }[];
                tiles?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  abbreviation?: string;
                  name?: string;
                  code?: string;
                  institutionId?: number;
                  tenantCode?: string;
                  tenantName?: string;
                  userType?: string;
                  userTypeName?: string;
                  tag?: string;
                  status?: number;
                  parentId?: number;
                  parentTitle?: {};
                  organizationType?: number;
                  uniqueKey?: string;
                }[];
                source?: number;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                jobAttributesCode?: string;
                remark?: string;
                ifSetJob?: boolean;
                operatorProfessionType?: number;
                outAccountId?: string;
                syncStatus?: number;
                tenantName?: string;
                jobAttributes?: {
                  organizationId?: number;
                  organizationType?: number;
                  jobAttributesCode?: string;
                }[];
              }[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            }[];
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            tenantCode?: string;
            tenant?: {
              id?: number;
              source?: number;
              code?: string;
              name?: string;
              parentId?: number;
              type?: string;
              hierarchy?: string;
              leaf?: boolean;
              effectiveDate?: string;
              expirationDate?: string;
              status?: number;
            };
            children?: {}[];
            striplineCodes?: string;
            organizationCode?: string;
            source?: number;
            order?: number;
          }[];
          tiles?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            abbreviation?: string;
            name?: string;
            code?: string;
            institutionId?: number;
            tenantCode?: string;
            tenantName?: string;
            userType?: string;
            userTypeName?: string;
            tag?: string;
            status?: number;
            parentId?: number;
            parentTitle?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              abbreviation?: string;
              name?: string;
              code?: string;
              institutionId?: number;
              tenantCode?: string;
              tenantName?: string;
              userType?: string;
              userTypeName?: string;
              tag?: string;
              status?: number;
              parentId?: number;
              parentTitle?: {};
              organizationType?: number;
              uniqueKey?: string;
            };
            organizationType?: number;
            uniqueKey?: string;
          }[];
          source?: number;
          /**
           * 「已废弃」
           * 「已废弃」
           */
          jobAttributesCode?: string;
          remark?: string;
          ifSetJob?: boolean;
          operatorProfessionType?: number;
          outAccountId?: string;
          syncStatus?: number;
          tenantName?: string;
          jobAttributes?: {
            organizationId?: number;
            organizationType?: number;
            jobAttributesCode?: string;
          }[];
        }[];
        managerOperators?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          userId?: number;
          code?: string;
          displayName?: string;
          userStatus?: number;
          institutionId?: number;
          departmentId?: number;
          userType?: string;
          tenantCode?: string;
          status?: number;
          operatorType?: number;
          IsDefault?: number;
          mainJob?: number;
          order?: number;
          email?: string;
          phone?: string;
          mobile?: string;
          gender?: number;
          fax?: string;
          user?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            displayName?: string;
            realName?: string;
            password?: string;
            loginId?: string;
            mobile?: string;
            email?: string;
            tag?: number;
            idType?: number;
            idNo?: string;
            avatar?: string;
            gender?: number;
            active?: string;
            birthday?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            postCode?: string;
            description?: string;
            encryptionType?: string;
            infoPerfectLevel?: number;
            status?: number;
            userTypes?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              code?: string;
              name?: string;
              type?: number;
              status?: number;
              hierarchy?: string;
              parentCode?: string;
              isLeaf?: boolean;
              descp?: string;
              tenantCode?: string;
              tenantId?: number;
            }[];
            operators?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              userId?: number;
              code?: string;
              displayName?: string;
              userStatus?: number;
              institutionId?: number;
              departmentId?: number;
              userType?: string;
              tenantCode?: string;
              status?: number;
              operatorType?: number;
              IsDefault?: number;
              mainJob?: number;
              order?: number;
              email?: string;
              phone?: string;
              mobile?: string;
              gender?: number;
              fax?: string;
              user?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {}[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              };
              uniqueIdentifier?: string;
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              departments?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                institutionId?: number;
                parentId?: number;
                hierarchy?: string;
                isLeaf?: number;
                status?: number;
                type?: number;
                description?: string;
                shortName?: string;
                address?: string;
                level?: number;
                operators?: {}[];
                managerOperators?: {}[];
                managerUsers?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                }[];
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                tenantCode?: string;
                tenant?: {
                  id?: number;
                  source?: number;
                  code?: string;
                  name?: string;
                  parentId?: number;
                  type?: string;
                  hierarchy?: string;
                  leaf?: boolean;
                  effectiveDate?: string;
                  expirationDate?: string;
                  status?: number;
                };
                children?: {}[];
                striplineCodes?: string;
                organizationCode?: string;
                source?: number;
                order?: number;
              }[];
              tiles?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                abbreviation?: string;
                name?: string;
                code?: string;
                institutionId?: number;
                tenantCode?: string;
                tenantName?: string;
                userType?: string;
                userTypeName?: string;
                tag?: string;
                status?: number;
                parentId?: number;
                parentTitle?: {};
                organizationType?: number;
                uniqueKey?: string;
              }[];
              source?: number;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              jobAttributesCode?: string;
              remark?: string;
              ifSetJob?: boolean;
              operatorProfessionType?: number;
              outAccountId?: string;
              syncStatus?: number;
              tenantName?: string;
              jobAttributes?: {
                organizationId?: number;
                organizationType?: number;
                jobAttributesCode?: string;
              }[];
            }[];
            recentlyOperator?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              userId?: number;
              institutionId?: number;
              userType?: string;
              tenantCode?: string;
              userStatus?: number;
              status?: number;
              operatorType?: number;
              email?: string;
              mobile?: string;
              code?: string;
            };
            workStatus?: number;
            employeeCode?: string;
            outAccountId?: string;
            openId?: string;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            userExtFieldsDto?: {
              verifyMobile?: number;
              verifyIdNo?: number;
            };
            politicsStatus?: string;
            source?: number;
            jobLevelCode?: string;
            budgetedPostCode?: string;
            lock?: number;
          };
          uniqueIdentifier?: string;
          institution?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string[];
            tags?: string[];
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
            tagCodes?: string;
            consistencyCheck?: number;
            budgetCheck?: number;
            costControlCheck?: number;
            workflowCheck?: number;
          };
          departments?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            name?: string;
            institutionId?: number;
            parentId?: number;
            hierarchy?: string;
            isLeaf?: number;
            status?: number;
            type?: number;
            description?: string;
            shortName?: string;
            address?: string;
            level?: number;
            operators?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              userId?: number;
              code?: string;
              displayName?: string;
              userStatus?: number;
              institutionId?: number;
              departmentId?: number;
              userType?: string;
              tenantCode?: string;
              status?: number;
              operatorType?: number;
              IsDefault?: number;
              mainJob?: number;
              order?: number;
              email?: string;
              phone?: string;
              mobile?: string;
              gender?: number;
              fax?: string;
              user?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  userId?: number;
                  code?: string;
                  displayName?: string;
                  userStatus?: number;
                  institutionId?: number;
                  departmentId?: number;
                  userType?: string;
                  tenantCode?: string;
                  status?: number;
                  operatorType?: number;
                  IsDefault?: number;
                  mainJob?: number;
                  order?: number;
                  email?: string;
                  phone?: string;
                  mobile?: string;
                  gender?: number;
                  fax?: string;
                  user?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  };
                  uniqueIdentifier?: string;
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  departments?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    institutionId?: number;
                    parentId?: number;
                    hierarchy?: string;
                    isLeaf?: number;
                    status?: number;
                    type?: number;
                    description?: string;
                    shortName?: string;
                    address?: string;
                    level?: number;
                    operators?: {}[];
                    managerOperators?: {}[];
                    managerUsers?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      realName?: string;
                      password?: string;
                      loginId?: string;
                      mobile?: string;
                      email?: string;
                      tag?: number;
                      idType?: number;
                      idNo?: string;
                      avatar?: string;
                      gender?: number;
                      active?: string;
                      birthday?: string;
                      provinceCode?: string;
                      provinceName?: string;
                      cityCode?: string;
                      cityName?: string;
                      regionCode?: string;
                      regionName?: string;
                      address?: string;
                      postCode?: string;
                      description?: string;
                      encryptionType?: string;
                      infoPerfectLevel?: number;
                      status?: number;
                      userTypes?: {
                        id?: number;
                        createdAt?: string;
                        updatedAt?: string;
                        creatorId?: number;
                        modifierId?: number;
                        extFields?: string;
                        extMap?: {
                          key?: string;
                        };
                        code?: string;
                        name?: string;
                        type?: number;
                        status?: number;
                        hierarchy?: string;
                        parentCode?: string;
                        isLeaf?: boolean;
                        descp?: string;
                        tenantCode?: string;
                        tenantId?: number;
                      }[];
                      operators?: {}[];
                      recentlyOperator?: {
                        id?: number;
                        createdAt?: string;
                        updatedAt?: string;
                        creatorId?: number;
                        modifierId?: number;
                        extFields?: string;
                        extMap?: {
                          key?: string;
                        };
                        displayName?: string;
                        userId?: number;
                        institutionId?: number;
                        userType?: string;
                        tenantCode?: string;
                        userStatus?: number;
                        status?: number;
                        operatorType?: number;
                        email?: string;
                        mobile?: string;
                        code?: string;
                      };
                      workStatus?: number;
                      employeeCode?: string;
                      outAccountId?: string;
                      openId?: string;
                      /**
                       * 「已废弃」
                       * 「已废弃」
                       */
                      userExtFieldsDto?: {
                        verifyMobile?: number;
                        verifyIdNo?: number;
                      };
                      politicsStatus?: string;
                      source?: number;
                      jobLevelCode?: string;
                      budgetedPostCode?: string;
                      lock?: number;
                    }[];
                    institution?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      name?: string;
                      shortName?: string;
                      orgCode?: string;
                      creditCode?: string;
                      bizAttaches?: string[];
                      tags?: string[];
                      provinceCode?: string;
                      provinceName?: string;
                      cityCode?: string;
                      cityName?: string;
                      regionCode?: string;
                      regionName?: string;
                      address?: string;
                      status?: number;
                      displayOrder?: number;
                      outCreatedAt?: string;
                      fullName?: string;
                      postalCode?: string;
                      source?: number;
                      organizationCode?: string;
                      institutionLevel?: number;
                      tagCodes?: string;
                      consistencyCheck?: number;
                      budgetCheck?: number;
                      costControlCheck?: number;
                      workflowCheck?: number;
                    };
                    tenantCode?: string;
                    tenant?: {
                      id?: number;
                      source?: number;
                      code?: string;
                      name?: string;
                      parentId?: number;
                      type?: string;
                      hierarchy?: string;
                      leaf?: boolean;
                      effectiveDate?: string;
                      expirationDate?: string;
                      status?: number;
                    };
                    children?: {}[];
                    striplineCodes?: string;
                    organizationCode?: string;
                    source?: number;
                    order?: number;
                  }[];
                  tiles?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    abbreviation?: string;
                    name?: string;
                    code?: string;
                    institutionId?: number;
                    tenantCode?: string;
                    tenantName?: string;
                    userType?: string;
                    userTypeName?: string;
                    tag?: string;
                    status?: number;
                    parentId?: number;
                    parentTitle?: {};
                    organizationType?: number;
                    uniqueKey?: string;
                  }[];
                  source?: number;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  jobAttributesCode?: string;
                  remark?: string;
                  ifSetJob?: boolean;
                  operatorProfessionType?: number;
                  outAccountId?: string;
                  syncStatus?: number;
                  tenantName?: string;
                  jobAttributes?: {
                    organizationId?: number;
                    organizationType?: number;
                    jobAttributesCode?: string;
                  }[];
                }[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              };
              uniqueIdentifier?: string;
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              departments?: {}[];
              tiles?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                abbreviation?: string;
                name?: string;
                code?: string;
                institutionId?: number;
                tenantCode?: string;
                tenantName?: string;
                userType?: string;
                userTypeName?: string;
                tag?: string;
                status?: number;
                parentId?: number;
                parentTitle?: {};
                organizationType?: number;
                uniqueKey?: string;
              }[];
              source?: number;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              jobAttributesCode?: string;
              remark?: string;
              ifSetJob?: boolean;
              operatorProfessionType?: number;
              outAccountId?: string;
              syncStatus?: number;
              tenantName?: string;
              jobAttributes?: {
                organizationId?: number;
                organizationType?: number;
                jobAttributesCode?: string;
              }[];
            }[];
            managerOperators?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              userId?: number;
              code?: string;
              displayName?: string;
              userStatus?: number;
              institutionId?: number;
              departmentId?: number;
              userType?: string;
              tenantCode?: string;
              status?: number;
              operatorType?: number;
              IsDefault?: number;
              mainJob?: number;
              order?: number;
              email?: string;
              phone?: string;
              mobile?: string;
              gender?: number;
              fax?: string;
              user?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  userId?: number;
                  code?: string;
                  displayName?: string;
                  userStatus?: number;
                  institutionId?: number;
                  departmentId?: number;
                  userType?: string;
                  tenantCode?: string;
                  status?: number;
                  operatorType?: number;
                  IsDefault?: number;
                  mainJob?: number;
                  order?: number;
                  email?: string;
                  phone?: string;
                  mobile?: string;
                  gender?: number;
                  fax?: string;
                  user?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  };
                  uniqueIdentifier?: string;
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  departments?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    institutionId?: number;
                    parentId?: number;
                    hierarchy?: string;
                    isLeaf?: number;
                    status?: number;
                    type?: number;
                    description?: string;
                    shortName?: string;
                    address?: string;
                    level?: number;
                    operators?: {}[];
                    managerOperators?: {}[];
                    managerUsers?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      realName?: string;
                      password?: string;
                      loginId?: string;
                      mobile?: string;
                      email?: string;
                      tag?: number;
                      idType?: number;
                      idNo?: string;
                      avatar?: string;
                      gender?: number;
                      active?: string;
                      birthday?: string;
                      provinceCode?: string;
                      provinceName?: string;
                      cityCode?: string;
                      cityName?: string;
                      regionCode?: string;
                      regionName?: string;
                      address?: string;
                      postCode?: string;
                      description?: string;
                      encryptionType?: string;
                      infoPerfectLevel?: number;
                      status?: number;
                      userTypes?: {
                        id?: number;
                        createdAt?: string;
                        updatedAt?: string;
                        creatorId?: number;
                        modifierId?: number;
                        extFields?: string;
                        extMap?: {
                          key?: string;
                        };
                        code?: string;
                        name?: string;
                        type?: number;
                        status?: number;
                        hierarchy?: string;
                        parentCode?: string;
                        isLeaf?: boolean;
                        descp?: string;
                        tenantCode?: string;
                        tenantId?: number;
                      }[];
                      operators?: {}[];
                      recentlyOperator?: {
                        id?: number;
                        createdAt?: string;
                        updatedAt?: string;
                        creatorId?: number;
                        modifierId?: number;
                        extFields?: string;
                        extMap?: {
                          key?: string;
                        };
                        displayName?: string;
                        userId?: number;
                        institutionId?: number;
                        userType?: string;
                        tenantCode?: string;
                        userStatus?: number;
                        status?: number;
                        operatorType?: number;
                        email?: string;
                        mobile?: string;
                        code?: string;
                      };
                      workStatus?: number;
                      employeeCode?: string;
                      outAccountId?: string;
                      openId?: string;
                      /**
                       * 「已废弃」
                       * 「已废弃」
                       */
                      userExtFieldsDto?: {
                        verifyMobile?: number;
                        verifyIdNo?: number;
                      };
                      politicsStatus?: string;
                      source?: number;
                      jobLevelCode?: string;
                      budgetedPostCode?: string;
                      lock?: number;
                    }[];
                    institution?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      name?: string;
                      shortName?: string;
                      orgCode?: string;
                      creditCode?: string;
                      bizAttaches?: string[];
                      tags?: string[];
                      provinceCode?: string;
                      provinceName?: string;
                      cityCode?: string;
                      cityName?: string;
                      regionCode?: string;
                      regionName?: string;
                      address?: string;
                      status?: number;
                      displayOrder?: number;
                      outCreatedAt?: string;
                      fullName?: string;
                      postalCode?: string;
                      source?: number;
                      organizationCode?: string;
                      institutionLevel?: number;
                      tagCodes?: string;
                      consistencyCheck?: number;
                      budgetCheck?: number;
                      costControlCheck?: number;
                      workflowCheck?: number;
                    };
                    tenantCode?: string;
                    tenant?: {
                      id?: number;
                      source?: number;
                      code?: string;
                      name?: string;
                      parentId?: number;
                      type?: string;
                      hierarchy?: string;
                      leaf?: boolean;
                      effectiveDate?: string;
                      expirationDate?: string;
                      status?: number;
                    };
                    children?: {}[];
                    striplineCodes?: string;
                    organizationCode?: string;
                    source?: number;
                    order?: number;
                  }[];
                  tiles?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    abbreviation?: string;
                    name?: string;
                    code?: string;
                    institutionId?: number;
                    tenantCode?: string;
                    tenantName?: string;
                    userType?: string;
                    userTypeName?: string;
                    tag?: string;
                    status?: number;
                    parentId?: number;
                    parentTitle?: {};
                    organizationType?: number;
                    uniqueKey?: string;
                  }[];
                  source?: number;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  jobAttributesCode?: string;
                  remark?: string;
                  ifSetJob?: boolean;
                  operatorProfessionType?: number;
                  outAccountId?: string;
                  syncStatus?: number;
                  tenantName?: string;
                  jobAttributes?: {
                    organizationId?: number;
                    organizationType?: number;
                    jobAttributesCode?: string;
                  }[];
                }[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              };
              uniqueIdentifier?: string;
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              departments?: {}[];
              tiles?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                abbreviation?: string;
                name?: string;
                code?: string;
                institutionId?: number;
                tenantCode?: string;
                tenantName?: string;
                userType?: string;
                userTypeName?: string;
                tag?: string;
                status?: number;
                parentId?: number;
                parentTitle?: {};
                organizationType?: number;
                uniqueKey?: string;
              }[];
              source?: number;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              jobAttributesCode?: string;
              remark?: string;
              ifSetJob?: boolean;
              operatorProfessionType?: number;
              outAccountId?: string;
              syncStatus?: number;
              tenantName?: string;
              jobAttributes?: {
                organizationId?: number;
                organizationType?: number;
                jobAttributesCode?: string;
              }[];
            }[];
            managerUsers?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                userId?: number;
                code?: string;
                displayName?: string;
                userStatus?: number;
                institutionId?: number;
                departmentId?: number;
                userType?: string;
                tenantCode?: string;
                status?: number;
                operatorType?: number;
                IsDefault?: number;
                mainJob?: number;
                order?: number;
                email?: string;
                phone?: string;
                mobile?: string;
                gender?: number;
                fax?: string;
                user?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  realName?: string;
                  password?: string;
                  loginId?: string;
                  mobile?: string;
                  email?: string;
                  tag?: number;
                  idType?: number;
                  idNo?: string;
                  avatar?: string;
                  gender?: number;
                  active?: string;
                  birthday?: string;
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  postCode?: string;
                  description?: string;
                  encryptionType?: string;
                  infoPerfectLevel?: number;
                  status?: number;
                  userTypes?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    code?: string;
                    name?: string;
                    type?: number;
                    status?: number;
                    hierarchy?: string;
                    parentCode?: string;
                    isLeaf?: boolean;
                    descp?: string;
                    tenantCode?: string;
                    tenantId?: number;
                  }[];
                  operators?: {}[];
                  recentlyOperator?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    userId?: number;
                    institutionId?: number;
                    userType?: string;
                    tenantCode?: string;
                    userStatus?: number;
                    status?: number;
                    operatorType?: number;
                    email?: string;
                    mobile?: string;
                    code?: string;
                  };
                  workStatus?: number;
                  employeeCode?: string;
                  outAccountId?: string;
                  openId?: string;
                  /**
                   * 「已废弃」
                   * 「已废弃」
                   */
                  userExtFieldsDto?: {
                    verifyMobile?: number;
                    verifyIdNo?: number;
                  };
                  politicsStatus?: string;
                  source?: number;
                  jobLevelCode?: string;
                  budgetedPostCode?: string;
                  lock?: number;
                };
                uniqueIdentifier?: string;
                institution?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  shortName?: string;
                  orgCode?: string;
                  creditCode?: string;
                  bizAttaches?: string[];
                  tags?: string[];
                  provinceCode?: string;
                  provinceName?: string;
                  cityCode?: string;
                  cityName?: string;
                  regionCode?: string;
                  regionName?: string;
                  address?: string;
                  status?: number;
                  displayOrder?: number;
                  outCreatedAt?: string;
                  fullName?: string;
                  postalCode?: string;
                  source?: number;
                  organizationCode?: string;
                  institutionLevel?: number;
                  tagCodes?: string;
                  consistencyCheck?: number;
                  budgetCheck?: number;
                  costControlCheck?: number;
                  workflowCheck?: number;
                };
                departments?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  name?: string;
                  institutionId?: number;
                  parentId?: number;
                  hierarchy?: string;
                  isLeaf?: number;
                  status?: number;
                  type?: number;
                  description?: string;
                  shortName?: string;
                  address?: string;
                  level?: number;
                  operators?: {}[];
                  managerOperators?: {}[];
                  managerUsers?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    displayName?: string;
                    realName?: string;
                    password?: string;
                    loginId?: string;
                    mobile?: string;
                    email?: string;
                    tag?: number;
                    idType?: number;
                    idNo?: string;
                    avatar?: string;
                    gender?: number;
                    active?: string;
                    birthday?: string;
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    postCode?: string;
                    description?: string;
                    encryptionType?: string;
                    infoPerfectLevel?: number;
                    status?: number;
                    userTypes?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      code?: string;
                      name?: string;
                      type?: number;
                      status?: number;
                      hierarchy?: string;
                      parentCode?: string;
                      isLeaf?: boolean;
                      descp?: string;
                      tenantCode?: string;
                      tenantId?: number;
                    }[];
                    operators?: {}[];
                    recentlyOperator?: {
                      id?: number;
                      createdAt?: string;
                      updatedAt?: string;
                      creatorId?: number;
                      modifierId?: number;
                      extFields?: string;
                      extMap?: {
                        key?: string;
                      };
                      displayName?: string;
                      userId?: number;
                      institutionId?: number;
                      userType?: string;
                      tenantCode?: string;
                      userStatus?: number;
                      status?: number;
                      operatorType?: number;
                      email?: string;
                      mobile?: string;
                      code?: string;
                    };
                    workStatus?: number;
                    employeeCode?: string;
                    outAccountId?: string;
                    openId?: string;
                    /**
                     * 「已废弃」
                     * 「已废弃」
                     */
                    userExtFieldsDto?: {
                      verifyMobile?: number;
                      verifyIdNo?: number;
                    };
                    politicsStatus?: string;
                    source?: number;
                    jobLevelCode?: string;
                    budgetedPostCode?: string;
                    lock?: number;
                  }[];
                  institution?: {
                    id?: number;
                    createdAt?: string;
                    updatedAt?: string;
                    creatorId?: number;
                    modifierId?: number;
                    extFields?: string;
                    extMap?: {
                      key?: string;
                    };
                    name?: string;
                    shortName?: string;
                    orgCode?: string;
                    creditCode?: string;
                    bizAttaches?: string[];
                    tags?: string[];
                    provinceCode?: string;
                    provinceName?: string;
                    cityCode?: string;
                    cityName?: string;
                    regionCode?: string;
                    regionName?: string;
                    address?: string;
                    status?: number;
                    displayOrder?: number;
                    outCreatedAt?: string;
                    fullName?: string;
                    postalCode?: string;
                    source?: number;
                    organizationCode?: string;
                    institutionLevel?: number;
                    tagCodes?: string;
                    consistencyCheck?: number;
                    budgetCheck?: number;
                    costControlCheck?: number;
                    workflowCheck?: number;
                  };
                  tenantCode?: string;
                  tenant?: {
                    id?: number;
                    source?: number;
                    code?: string;
                    name?: string;
                    parentId?: number;
                    type?: string;
                    hierarchy?: string;
                    leaf?: boolean;
                    effectiveDate?: string;
                    expirationDate?: string;
                    status?: number;
                  };
                  children?: {}[];
                  striplineCodes?: string;
                  organizationCode?: string;
                  source?: number;
                  order?: number;
                }[];
                tiles?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  abbreviation?: string;
                  name?: string;
                  code?: string;
                  institutionId?: number;
                  tenantCode?: string;
                  tenantName?: string;
                  userType?: string;
                  userTypeName?: string;
                  tag?: string;
                  status?: number;
                  parentId?: number;
                  parentTitle?: {};
                  organizationType?: number;
                  uniqueKey?: string;
                }[];
                source?: number;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                jobAttributesCode?: string;
                remark?: string;
                ifSetJob?: boolean;
                operatorProfessionType?: number;
                outAccountId?: string;
                syncStatus?: number;
                tenantName?: string;
                jobAttributes?: {
                  organizationId?: number;
                  organizationType?: number;
                  jobAttributesCode?: string;
                }[];
              }[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            }[];
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            tenantCode?: string;
            tenant?: {
              id?: number;
              source?: number;
              code?: string;
              name?: string;
              parentId?: number;
              type?: string;
              hierarchy?: string;
              leaf?: boolean;
              effectiveDate?: string;
              expirationDate?: string;
              status?: number;
            };
            children?: {}[];
            striplineCodes?: string;
            organizationCode?: string;
            source?: number;
            order?: number;
          }[];
          tiles?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            abbreviation?: string;
            name?: string;
            code?: string;
            institutionId?: number;
            tenantCode?: string;
            tenantName?: string;
            userType?: string;
            userTypeName?: string;
            tag?: string;
            status?: number;
            parentId?: number;
            parentTitle?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              abbreviation?: string;
              name?: string;
              code?: string;
              institutionId?: number;
              tenantCode?: string;
              tenantName?: string;
              userType?: string;
              userTypeName?: string;
              tag?: string;
              status?: number;
              parentId?: number;
              parentTitle?: {};
              organizationType?: number;
              uniqueKey?: string;
            };
            organizationType?: number;
            uniqueKey?: string;
          }[];
          source?: number;
          /**
           * 「已废弃」
           * 「已废弃」
           */
          jobAttributesCode?: string;
          remark?: string;
          ifSetJob?: boolean;
          operatorProfessionType?: number;
          outAccountId?: string;
          syncStatus?: number;
          tenantName?: string;
          jobAttributes?: {
            organizationId?: number;
            organizationType?: number;
            jobAttributesCode?: string;
          }[];
        }[];
        managerUsers?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          displayName?: string;
          realName?: string;
          password?: string;
          loginId?: string;
          mobile?: string;
          email?: string;
          tag?: number;
          idType?: number;
          idNo?: string;
          avatar?: string;
          gender?: number;
          active?: string;
          birthday?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          postCode?: string;
          description?: string;
          encryptionType?: string;
          infoPerfectLevel?: number;
          status?: number;
          userTypes?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            code?: string;
            name?: string;
            type?: number;
            status?: number;
            hierarchy?: string;
            parentCode?: string;
            isLeaf?: boolean;
            descp?: string;
            tenantCode?: string;
            tenantId?: number;
          }[];
          operators?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            userId?: number;
            code?: string;
            displayName?: string;
            userStatus?: number;
            institutionId?: number;
            departmentId?: number;
            userType?: string;
            tenantCode?: string;
            status?: number;
            operatorType?: number;
            IsDefault?: number;
            mainJob?: number;
            order?: number;
            email?: string;
            phone?: string;
            mobile?: string;
            gender?: number;
            fax?: string;
            user?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              displayName?: string;
              realName?: string;
              password?: string;
              loginId?: string;
              mobile?: string;
              email?: string;
              tag?: number;
              idType?: number;
              idNo?: string;
              avatar?: string;
              gender?: number;
              active?: string;
              birthday?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              postCode?: string;
              description?: string;
              encryptionType?: string;
              infoPerfectLevel?: number;
              status?: number;
              userTypes?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                code?: string;
                name?: string;
                type?: number;
                status?: number;
                hierarchy?: string;
                parentCode?: string;
                isLeaf?: boolean;
                descp?: string;
                tenantCode?: string;
                tenantId?: number;
              }[];
              operators?: {}[];
              recentlyOperator?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                userId?: number;
                institutionId?: number;
                userType?: string;
                tenantCode?: string;
                userStatus?: number;
                status?: number;
                operatorType?: number;
                email?: string;
                mobile?: string;
                code?: string;
              };
              workStatus?: number;
              employeeCode?: string;
              outAccountId?: string;
              openId?: string;
              /**
               * 「已废弃」
               * 「已废弃」
               */
              userExtFieldsDto?: {
                verifyMobile?: number;
                verifyIdNo?: number;
              };
              politicsStatus?: string;
              source?: number;
              jobLevelCode?: string;
              budgetedPostCode?: string;
              lock?: number;
            };
            uniqueIdentifier?: string;
            institution?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string[];
              tags?: string[];
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
              tagCodes?: string;
              consistencyCheck?: number;
              budgetCheck?: number;
              costControlCheck?: number;
              workflowCheck?: number;
            };
            departments?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              name?: string;
              institutionId?: number;
              parentId?: number;
              hierarchy?: string;
              isLeaf?: number;
              status?: number;
              type?: number;
              description?: string;
              shortName?: string;
              address?: string;
              level?: number;
              operators?: {}[];
              managerOperators?: {}[];
              managerUsers?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                displayName?: string;
                realName?: string;
                password?: string;
                loginId?: string;
                mobile?: string;
                email?: string;
                tag?: number;
                idType?: number;
                idNo?: string;
                avatar?: string;
                gender?: number;
                active?: string;
                birthday?: string;
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                postCode?: string;
                description?: string;
                encryptionType?: string;
                infoPerfectLevel?: number;
                status?: number;
                userTypes?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  code?: string;
                  name?: string;
                  type?: number;
                  status?: number;
                  hierarchy?: string;
                  parentCode?: string;
                  isLeaf?: boolean;
                  descp?: string;
                  tenantCode?: string;
                  tenantId?: number;
                }[];
                operators?: {}[];
                recentlyOperator?: {
                  id?: number;
                  createdAt?: string;
                  updatedAt?: string;
                  creatorId?: number;
                  modifierId?: number;
                  extFields?: string;
                  extMap?: {
                    key?: string;
                  };
                  displayName?: string;
                  userId?: number;
                  institutionId?: number;
                  userType?: string;
                  tenantCode?: string;
                  userStatus?: number;
                  status?: number;
                  operatorType?: number;
                  email?: string;
                  mobile?: string;
                  code?: string;
                };
                workStatus?: number;
                employeeCode?: string;
                outAccountId?: string;
                openId?: string;
                /**
                 * 「已废弃」
                 * 「已废弃」
                 */
                userExtFieldsDto?: {
                  verifyMobile?: number;
                  verifyIdNo?: number;
                };
                politicsStatus?: string;
                source?: number;
                jobLevelCode?: string;
                budgetedPostCode?: string;
                lock?: number;
              }[];
              institution?: {
                id?: number;
                createdAt?: string;
                updatedAt?: string;
                creatorId?: number;
                modifierId?: number;
                extFields?: string;
                extMap?: {
                  key?: string;
                };
                name?: string;
                shortName?: string;
                orgCode?: string;
                creditCode?: string;
                bizAttaches?: string[];
                tags?: string[];
                provinceCode?: string;
                provinceName?: string;
                cityCode?: string;
                cityName?: string;
                regionCode?: string;
                regionName?: string;
                address?: string;
                status?: number;
                displayOrder?: number;
                outCreatedAt?: string;
                fullName?: string;
                postalCode?: string;
                source?: number;
                organizationCode?: string;
                institutionLevel?: number;
                tagCodes?: string;
                consistencyCheck?: number;
                budgetCheck?: number;
                costControlCheck?: number;
                workflowCheck?: number;
              };
              tenantCode?: string;
              tenant?: {
                id?: number;
                source?: number;
                code?: string;
                name?: string;
                parentId?: number;
                type?: string;
                hierarchy?: string;
                leaf?: boolean;
                effectiveDate?: string;
                expirationDate?: string;
                status?: number;
              };
              children?: {}[];
              striplineCodes?: string;
              organizationCode?: string;
              source?: number;
              order?: number;
            }[];
            tiles?: {
              id?: number;
              createdAt?: string;
              updatedAt?: string;
              creatorId?: number;
              modifierId?: number;
              extFields?: string;
              extMap?: {
                key?: string;
              };
              abbreviation?: string;
              name?: string;
              code?: string;
              institutionId?: number;
              tenantCode?: string;
              tenantName?: string;
              userType?: string;
              userTypeName?: string;
              tag?: string;
              status?: number;
              parentId?: number;
              parentTitle?: {};
              organizationType?: number;
              uniqueKey?: string;
            }[];
            source?: number;
            /**
             * 「已废弃」
             * 「已废弃」
             */
            jobAttributesCode?: string;
            remark?: string;
            ifSetJob?: boolean;
            operatorProfessionType?: number;
            outAccountId?: string;
            syncStatus?: number;
            tenantName?: string;
            jobAttributes?: {
              organizationId?: number;
              organizationType?: number;
              jobAttributesCode?: string;
            }[];
          }[];
          recentlyOperator?: {
            id?: number;
            createdAt?: string;
            updatedAt?: string;
            creatorId?: number;
            modifierId?: number;
            extFields?: string;
            extMap?: {
              key?: string;
            };
            displayName?: string;
            userId?: number;
            institutionId?: number;
            userType?: string;
            tenantCode?: string;
            userStatus?: number;
            status?: number;
            operatorType?: number;
            email?: string;
            mobile?: string;
            code?: string;
          };
          workStatus?: number;
          employeeCode?: string;
          outAccountId?: string;
          openId?: string;
          /**
           * 「已废弃」
           * 「已废弃」
           */
          userExtFieldsDto?: {
            verifyMobile?: number;
            verifyIdNo?: number;
          };
          politicsStatus?: string;
          source?: number;
          jobLevelCode?: string;
          budgetedPostCode?: string;
          lock?: number;
        }[];
        institution?: {
          id?: number;
          createdAt?: string;
          updatedAt?: string;
          creatorId?: number;
          modifierId?: number;
          extFields?: string;
          extMap?: {
            key?: string;
          };
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string[];
          tags?: string[];
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
          tagCodes?: string;
          consistencyCheck?: number;
          budgetCheck?: number;
          costControlCheck?: number;
          workflowCheck?: number;
        };
        tenantCode?: string;
        tenant?: {
          id?: number;
          source?: number;
          code?: string;
          name?: string;
          parentId?: number;
          type?: string;
          hierarchy?: string;
          leaf?: boolean;
          effectiveDate?: string;
          expirationDate?: string;
          status?: number;
        };
        children?: {}[];
        striplineCodes?: string;
        organizationCode?: string;
        source?: number;
        order?: number;
      }[];
      striplineCodes?: string;
      organizationCode?: string;
      source?: number;
      order?: number;
    }[];
    departmentCount?: number;
    contacts?: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      creatorId?: number;
      modifierId?: number;
      extFields?: string;
      extMap?: {
        key?: string;
      };
      organizationId?: number;
      name?: string;
      phone?: string;
      mobile?: string;
      email?: string;
      address?: string;
      type?: number;
      contactEmployeeCode?: string;
    }[];
    parentInstitution?: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      creatorId?: number;
      modifierId?: number;
      extFields?: string;
      extMap?: {
        key?: string;
      };
      name?: string;
      shortName?: string;
      orgCode?: string;
      creditCode?: string;
      bizAttaches?: string[];
      tags?: string[];
      provinceCode?: string;
      provinceName?: string;
      cityCode?: string;
      cityName?: string;
      regionCode?: string;
      regionName?: string;
      address?: string;
      status?: number;
      displayOrder?: number;
      outCreatedAt?: string;
      fullName?: string;
      postalCode?: string;
      source?: number;
      organizationCode?: string;
      institutionLevel?: number;
      tagCodes?: string;
      consistencyCheck?: number;
      budgetCheck?: number;
      costControlCheck?: number;
      workflowCheck?: number;
    };
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [租户机构查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728634) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-org/query`
 * @更新时间 `2025-01-07 09:58:50`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonTenantOrgQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/tenant-org/query',
    'data',
    string,
    'orgName',
    false
  >
>;

/**
 * 接口 [租户机构查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728634) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-org/query`
 * @更新时间 `2025-01-07 09:58:50`
 * @项目ID 3621
 */
const zlbApiExpenseCommonTenantOrgQueryGetRequestConfig: ZlbApiExpenseCommonTenantOrgQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/tenant-org/query',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['orgName'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonTenantOrgQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [租户机构查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728634) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/tenant-org/query`
 * @更新时间 `2025-01-07 09:58:50`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonTenantOrgQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonTenantOrgQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonTenantOrgQueryGetResponse>(
    prepare(zlbApiExpenseCommonTenantOrgQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonTenantOrgQueryGet.requestConfig =
  zlbApiExpenseCommonTenantOrgQueryGetRequestConfig;

/**
 * 接口 [接口灰度查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728650) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/api-gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonApiGrayGetRequest {
  /**
   * 新接口路径
   */
  newApi?: string;
}

/**
 * 接口 [接口灰度查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728650) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/api-gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonApiGrayGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [接口灰度查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728650) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/api-gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonApiGrayGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/api-gray',
    'data',
    string,
    'newApi',
    false
  >
>;

/**
 * 接口 [接口灰度查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728650) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/api-gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
const zlbApiExpenseCommonApiGrayGetRequestConfig: ZlbApiExpenseCommonApiGrayGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/api-gray',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ['newApi'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonApiGrayGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [接口灰度查询↗](http://yapi.cai-inc.com/project/3621/interface/api/728650) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `GET /zlb/api/expense/common/api-gray`
 * @更新时间 `2025-01-07 09:58:39`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonApiGrayGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonApiGrayGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonApiGrayGetResponse>(
    prepare(zlbApiExpenseCommonApiGrayGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonApiGrayGet.requestConfig = zlbApiExpenseCommonApiGrayGetRequestConfig;

/**
 * 接口 [查询单位业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/735554) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/org-business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonQueryOrgBusinessConfigPostRequest {
  /**
   * 配置key
   */
  keyList: string[];
  /**
   * 单位ID
   */
  orgId: number;
}

/**
 * 接口 [查询单位业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/735554) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/org-business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonQueryOrgBusinessConfigPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    key?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单位业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/735554) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/org-business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonQueryOrgBusinessConfigPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/query/org-business-config',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询单位业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/735554) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/org-business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
const zlbApiExpenseCommonQueryOrgBusinessConfigPostRequestConfig: ZlbApiExpenseCommonQueryOrgBusinessConfigPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/query/org-business-config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonQueryOrgBusinessConfigPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单位业务配置↗](http://yapi.cai-inc.com/project/3621/interface/api/735554) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/query/org-business-config`
 * @更新时间 `2025-01-07 09:58:47`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonQueryOrgBusinessConfigPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonQueryOrgBusinessConfigPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonQueryOrgBusinessConfigPostResponse>(
    prepare(zlbApiExpenseCommonQueryOrgBusinessConfigPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonQueryOrgBusinessConfigPost.requestConfig =
  zlbApiExpenseCommonQueryOrgBusinessConfigPostRequestConfig;

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/745450) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printInfo`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPrintInfoPostRequest {
  /**
   * 单据编码
   */
  formCode: string;
  /**
   * 单据类型
   */
  formType: number;
  /**
   * 模板类型：
   * 子户转账单据：打印时固定传3，套打时固定传递4
   */
  templateType?: number;
}

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/745450) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printInfo`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseCommonPrintInfoPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 报销单打印信息
     */
    expensePrintInfo?: {
      /**
       * 文件信息
       */
      attachmentDTO?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22
          | 91
          | 92
          | 93
          | 94
          | 95;
      };
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'generalForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'BATCH_DISTRIBUTE'
        | 'OVERTIME_PAY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'OVERTIME_APPLY_FORM'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'UN_KNOWN';
      /**
       * 表单名称
       */
      formName?: string;
    }[];
    /**
     * 申请单打印信息
     */
    applyPrintInfo?: {
      /**
       * 文件信息
       */
      attachmentDTO?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22
          | 91
          | 92
          | 93
          | 94
          | 95;
      };
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'generalForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'BATCH_DISTRIBUTE'
        | 'OVERTIME_PAY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'OVERTIME_APPLY_FORM'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'UN_KNOWN';
      /**
       * 表单名称
       */
      formName?: string;
    }[];
    /**
     * 发票打印信息
     * 「已废弃」
     */
    invoicePrintInfo?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22
        | 91
        | 92
        | 93
        | 94
        | 95;
      /**
       * 发票类型描述
       */
      invoiceTypeDesc?: string;
      /**
       * 是否为板式文件
       */
      isFormatFile?: boolean;
    }[];
    /**
     * 发票打印信息
     * 新增票据费用类型、票据号码等信息，票据文件类型增加排序
     */
    invoicePrintExtendRO?: {
      /**
       * 票据标识ID
       */
      platformInvoiceId?: string;
      /**
       * 票据金额
       */
      totalAmount?: number;
      /**
       * 票据消费类型
       */
      invoiceSubject?: string;
      /**
       * 票据消费类型描述
       */
      invoiceSubjectDesc?: string;
      /**
       * 票据号码
       */
      invoiceNo?: string;
      /**
       * 票据附件信息
       * 按用户上传文件、票据源文件、版式文件排序
       */
      attachmentPrintInfo?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22
          | 91
          | 92
          | 93
          | 94
          | 95;
      }[];
    }[];
    /**
     * 附件打印信息
     */
    attachmentPrintInfo?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22
        | 91
        | 92
        | 93
        | 94
        | 95;
    }[];
    /**
     * 专项、会议、培训附件列表
     */
    specialAttachmentPrintInfo?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22
        | 91
        | 92
        | 93
        | 94
        | 95;
    }[];
    /**
     * 夜餐费发放单打印信息
     */
    nightMealPrintInfo?: {
      /**
       * 文件信息
       */
      attachmentDTO?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22
          | 91
          | 92
          | 93
          | 94
          | 95;
      };
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'generalForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'BATCH_DISTRIBUTE'
        | 'OVERTIME_PAY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'OVERTIME_APPLY_FORM'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'UN_KNOWN';
      /**
       * 表单名称
       */
      formName?: string;
    };
    /**
     * 项目支付单打印信息
     */
    investPaymentPrintInfo?: {
      /**
       * 文件信息
       */
      attachmentDTO?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22
          | 91
          | 92
          | 93
          | 94
          | 95;
      };
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据编号
       */
      formCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'generalForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'BATCH_DISTRIBUTE'
        | 'OVERTIME_PAY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'OVERTIME_APPLY_FORM'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'UN_KNOWN';
      /**
       * 表单名称
       */
      formName?: string;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/745450) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printInfo`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
type ZlbApiExpenseCommonPrintInfoPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/common/printInfo',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/745450) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printInfo`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
const zlbApiExpenseCommonPrintInfoPostRequestConfig: ZlbApiExpenseCommonPrintInfoPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: '/zlb/api/expense/common/printInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseCommonPrintInfoPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单据打印生成接口↗](http://yapi.cai-inc.com/project/3621/interface/api/745450) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [通用控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_35987)
 * @请求头 `POST /zlb/api/expense/common/printInfo`
 * @更新时间 `2025-01-07 09:58:44`
 * @项目ID 3621
 */
export const zlbApiExpenseCommonPrintInfoPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseCommonPrintInfoPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseCommonPrintInfoPostResponse>(
    prepare(zlbApiExpenseCommonPrintInfoPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseCommonPrintInfoPost.requestConfig = zlbApiExpenseCommonPrintInfoPostRequestConfig;

const mockUrl_0_1_0_3 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_3 = '' as any;
const prodUrl_0_1_0_3 = '' as any;
const dataKey_0_1_0_3 = 'data' as any;

/**
 * 接口 [报销类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233462) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/expense-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormExpenseTypeGetRequest {}

/**
 * 接口 [报销类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233462) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/expense-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormExpenseTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 类型编号
     */
    businessType?: number;
    /**
     * 类型名称
     */
    businessTypeName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [报销类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233462) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/expense-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormExpenseTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/expense-type',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [报销类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233462) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/expense-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormExpenseTypeGetRequestConfig: ZlbApiExpenseApplyFormExpenseTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/expense-type',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormExpenseTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [报销类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233462) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/expense-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormExpenseTypeGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseApplyFormExpenseTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormExpenseTypeGetResponse>(
    prepare(zlbApiExpenseApplyFormExpenseTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormExpenseTypeGet.requestConfig =
  zlbApiExpenseApplyFormExpenseTypeGetRequestConfig;

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233470) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/company-info`
 * @更新时间 `2022-08-11 17:23:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormCompanyInfoGetRequest {
  /**
   * 1-差旅，2-会议，3-培训，4-办公用品采购,9-通用采购；10-政府购买服务；11-办公设备家具购置
   */
  formBizType?: string;
}

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233470) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/company-info`
 * @更新时间 `2022-08-11 17:23:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormCompanyInfoGetResponse {
  success?: boolean;
  result?: {
    /**
     * 工作单位id
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 所在部门列表
     */
    departmentList?: {
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
    }[];
    /**
     * 单位所在省地址编码
     */
    provinceCode?: string;
    /**
     * 单位所在省地址名称
     */
    provinceName?: string;
    /**
     * 单位所在市地址编码
     */
    cityCode?: string;
    /**
     * 单位所在市地址名称
     */
    cityName?: string;
    /**
     * 单位所在区地址编码
     */
    regionCode?: string;
    /**
     * 单位所在区地址名称
     */
    regionName?: string;
    /**
     * 单位开始结束时间类型策略(时间、日期、上下午等)
     */
    periodType?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233470) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/company-info`
 * @更新时间 `2022-08-11 17:23:33`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormCompanyInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/company-info',
    'data',
    string,
    'formBizType',
    false
  >
>;

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233470) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/company-info`
 * @更新时间 `2022-08-11 17:23:33`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormCompanyInfoGetRequestConfig: ZlbApiExpenseApplyFormCompanyInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/company-info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ['formBizType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormCompanyInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233470) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/company-info`
 * @更新时间 `2022-08-11 17:23:33`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormCompanyInfoGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormCompanyInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormCompanyInfoGetResponse>(
    prepare(zlbApiExpenseApplyFormCompanyInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormCompanyInfoGet.requestConfig =
  zlbApiExpenseApplyFormCompanyInfoGetRequestConfig;

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233478) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/save`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormSavePostRequest {
  /**
   * 申请单类型
   */
  applyFormType: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
  /**
   * 报销类型
   */
  businessType:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 32
    | 29
    | 30
    | 33;
  /**
   * 工作单位id
   */
  orgId: number;
  /**
   * 工作单位名称
   */
  orgName: string;
  /**
   * 工作部门id
   */
  deptId: number;
  /**
   * 工作部门名称
   */
  deptName?: string;
  /**
   * 申请事由
   */
  applyReason: string;
  /**
   * 后补申请原因
   */
  replenishReason?: string;
  /**
   * 申请时间
   * 线下差旅申请提交时间
   */
  applyTime?: string;
  /**
   * 扩展信息
   */
  extendFieldDTO?: {
    /**
     * 差旅扩展字段
     */
    travelExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 是否派车：1-派车，2-不派车
       */
      arrangeCar?: string;
      /**
       * 派车天数
       */
      dayCount?: number;
      extra?: string;
      /**
       * 三方拓展字段
       */
      thirdExtend?: string;
      /**
       * 差旅报销方式
       */
      travelExpenseMethod?: '由申请单报销' | '凭票报销';
      /**
       * 工号
       */
      workNo?: string;
      /**
       * 是否项目出差
       */
      isProject?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 所属部门
       */
      depName?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 项目名称
       */
      projectName?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 项目负责人
       */
      projectHeader?: {
        key?: string;
        value?: string;
        label?: string;
      };
    };
    /**
     * 会议扩展字段（包含多收款人）
     */
    meetingExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 1 签掉表 2 签到表附件
       */
      signType?: number;
      /**
       * 签到表
       */
      signForm?: {
        signFormCode?: string;
        /**
         * 签到表名称
         */
        signFormName?: string;
        /**
         * 申请表状态
         * 0-未发布 1-已发布 2-已结束
         */
        formStatus?: number;
        /**
         * 申请表状态名称
         */
        formStatusName?: string;
        /**
         * 结束时间
         */
        endTime?: number;
      };
      /**
       * 1申请单携带 2 手动选择
       */
      isExpenseInit?: number;
      /**
       * 会议名称
       */
      meetingName: string;
      /**
       * 会议地点code
       */
      meetingCityCode?: string;
      /**
       * 会议地点名称
       */
      meetingCityName?: string;
      /**
       * 会议开始日期
       */
      meetingStartDate?: string;
      /**
       * 会议结束日期
       */
      meetingEndDate?: string;
      /**
       * 会议天数
       */
      meetingDayCount?: number;
      /**
       * 会议预计参会人数
       */
      meetingExpectAttendeeCount: number;
      /**
       * 会议实际参会人数
       */
      meetingRealAttendeeCount?: number;
      /**
       * 会议工作人员人数
       */
      meetingWorkerCount?: number;
      /**
       * 参会领导信息
       */
      meetingLeaderInfo?: string;
      /**
       * 会议议程
       */
      meetingAgenda?: string;
      /**
       * 是否纳入预算
       * 1-是，2-否
       */
      isIncludedBudget?: number;
      /**
       * 会议差异内容
       */
      meetingDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal?: number;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 详细地址信息
       */
      detailAddress?: string;
    };
    /**
     * 培训扩展字段（包含多收款人）
     */
    trainingExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 1 签掉表 2 签到表附件
       */
      signType?: number;
      /**
       * 签到表
       */
      signForm?: {
        signFormCode?: string;
        /**
         * 签到表名称
         */
        signFormName?: string;
        /**
         * 申请表状态
         * 0-未发布 1-已发布 2-已结束
         */
        formStatus?: number;
        /**
         * 申请表状态名称
         */
        formStatusName?: string;
        /**
         * 结束时间
         */
        endTime?: number;
      };
      /**
       * 1申请单携带 2 手动选择
       */
      isExpenseInit?: number;
      /**
       * 培训名称
       */
      trainingName?: string;
      /**
       * 培训地点code
       */
      trainingCityCode?: string;
      /**
       * 培训地点名称
       */
      trainingCityName?: string;
      /**
       * 培训开始日期
       */
      trainingStartDate?: string;
      /**
       * 培训结束日期
       */
      trainingEndDate?: string;
      /**
       * 培训天数
       */
      trainingDayCount?: number;
      /**
       * 培训预计参会人数
       */
      trainingExpectAttendeeCount?: number;
      /**
       * 培训实际参会人数
       */
      trainingRealAttendeeCount?: number;
      /**
       * 培训工作人员人数
       */
      trainingWorkerCount?: number;
      /**
       * 培训议程
       */
      trainingAgenda?: string;
      /**
       * 是否纳入预算
       * 1-是，2-否
       */
      isIncludedBudget?: number;
      /**
       * 培训差异内容
       */
      trainingDifferenceContent?: string;
      /**
       * 培训讲师信息
       */
      trainingTeacherInfo?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal?: number;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource?: number;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
      /**
       * 变更支付方式说明
       */
      changePayModeReason?: string;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 详细地址信息
       */
      detailAddress?: string;
    };
    /**
     * 采购扩展字段
     */
    procurementExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 采购内容
       */
      procurementContent?: string;
      /**
       * 采购差异内容
       */
      procurementDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 费用合计
       */
      applyAmount?: number;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
    };
    /**
     * 公务接待
     */
    receptionExtendFields?: {
      /**
       * 来访单位
       */
      visitOrgName: string;
      /**
       * 是否同城（宁波场景不需要）
       * 1-是，2-否
       */
      isSameCity?: number;
      /**
       * 来访人员职务
       */
      visitorDuty?: string;
      /**
       * 来访事由
       */
      visitReason: string;
      /**
       * 来访开始日期
       */
      visitStartDate: string;
      /**
       * 来访结束日期
       */
      visitEndDate: string;
      /**
       * 来访人员级别：1-省部级、2-厅局级、99-其他
       */
      visitorLevel: number;
      /**
       * 来访人员级别名称
       */
      visitorLevelName?: string;
      /**
       * 来访人数
       */
      visitorCount: number;
      /**
       * 主宾姓名
       */
      mainGuest?: string;
      /**
       * 接待地点code
       */
      receptionCityCode: string;
      /**
       * 接待地点名称
       */
      receptionCityName: string;
      /**
       * 接待详细地点
       */
      receptionDetailAddress?: string;
      /**
       * 就餐日期
       */
      mealDate: string;
      /**
       * 工作餐形式：1-自助餐、2-桌餐
       */
      mealType: 1 | 2 | 3;
      /**
       * 工作餐形式
       */
      mealTypeName?: string;
      /**
       * 用餐时间：1-早餐，2-中餐，3-晚餐
       */
      mealTimeType?: 1 | 2 | 3;
      /**
       * 用餐时间
       */
      mealTimeTypeName?: string;
      /**
       * 陪餐人数（宁波场景不需要）
       */
      escortCount?: number;
      /**
       * 配餐人员姓名
       */
      escortPerson?: string;
      /**
       * 接待预算金额
       */
      receptionBudgetAmount?: number;
      /**
       * 来访人员信息
       */
      visitorInformation?: {
        /**
         * 访问人员名称
         */
        visitorName?: string;
        /**
         * 访问人员职级
         */
        visitorLevel?: number;
        /**
         * 访问人员职级名称
         */
        visitorLevelName?: string;
        /**
         * 来访人员职务
         */
        visitorDuty?: string;
      }[];
      /**
       * 接待人员信息
       */
      receptionistInformation?: {
        /**
         * 接待人员名称
         */
        receptionistName?: string;
        /**
         * 接待人员职级
         */
        receptionistLevel?: number;
        /**
         * 接待人员职级名称
         */
        receptionistLevelName?: string;
      }[];
    };
    /**
     * 一般事项
     */
    generalExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 事项详细内容
       */
      detailContent: string;
      /**
       * 事项预算
       */
      eventBudget?: number;
      /**
       * 事项详细内容与事前审批的差异
       */
      generalDifferenceContent?: string;
      extra?: string;
    };
    /**
     * 用印申请
     */
    contractExtendFields?: {
      /**
       * 合同编号
       */
      uniqueCode?: string;
    };
    /**
     * 招标书
     */
    tenderApplyExtendFields?: {
      /**
       * 申请单类型
       */
      applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
      /**
       * 申请事由
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务单据号
       */
      businessCode?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
    };
    /**
     * 通用采购申请拓展字段
     */
    purchaseGeneralFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm?: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * isCreatePurchaseProposal
       * 采购类型
       * 1-政府采购，2-非政府采购
       */
      purchaseType?: 1 | 2;
      /**
       * 采购类型描述
       */
      purchaseTypeDesc?: string;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource?: 1 | 2;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
    };
    /**
     * 政府购买服务申请拓展字段
     */
    govermentApplyFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * 采购类型
       * 1-政府采购，2-非政府采购
       */
      purchaseType: 1 | 2;
      /**
       * 采购类型描述
       */
      purchaseTypeDesc?: string;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource: 1 | 2;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
    };
    /**
     * 办公家具购置申请拓展字段
     */
    furnitureApplyFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
    };
    /**
     * 全链路二期 报销的统一拓展字段
     */
    purchaseGeneralExpenseFieldDTO?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 交易方式：线上；线下
       */
      tradeWay?: string[];
      /**
       * 采购差异内容
       */
      procurementDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 交易方式
       */
      tradeWayName?: string;
      /**
       * 是否有合同
       */
      addContract?: boolean;
    };
    /**
     * 公共事业缴费统一拓展字段
     */
    publicBusinessPaymentFieldDTO?: {
      /**
       * 备注
       */
      remark?: string;
    };
    /**
     * 无相拓展
     */
    generalExtra?: string;
  };
  /**
   * 行程信息列表
   */
  itineraryList?: {
    /**
     * 前端生成的编号
     */
    indexNo?: string;
    /**
     * 行程单编号
     * 更新时必填
     */
    itineraryCode?: string;
    /**
     * 原行程单号
     */
    originalItineraryCode?: string;
    /**
     * 出差人列表
     */
    accompanyList: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 开始上下午
     */
    beginTag: number;
    /**
     * 结束时间
     */
    endTime: string;
    /**
     * 结束上下午
     */
    endTag: number;
    /**
     * 出差天数
     */
    travelDay: number;
    /**
     * 是否派车 0不派车 1派车
     */
    arrangeCar: number;
    /**
     * 派车信息
     */
    arrangeCarPO?: {
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag: number;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag: number;
      /**
       * 派车天数
       */
      arrangeCarDay: number;
      /**
       * 乘车人
       */
      passengerList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
    };
    /**
     * 出发城市code
     */
    beginCityCode: string;
    /**
     * 出发城市名称
     */
    beginCityName: string;
    /**
     * 目的城市列表
     */
    endCityList: {
      /**
       * 目的城市code
       */
      endCityCode: string;
      /**
       * 目的城市名称
       */
      endCityName: string;
    }[];
    /**
     * 住宿天数
     */
    accommodationDay: number;
  }[];
  /**
   * 单据附件
   */
  formAttachmentDTO?: {
    /**
     * 默认附件列表
     */
    normalAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 说明附件列表
     */
    thatAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 通知附件列表
     */
    informAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 合同附件列表
     */
    compactAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 签到附件列表
     */
    signAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 派出单位公函附件列表
     */
    officialLetterAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 接待清单附件列表
     */
    receptionMenuAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 采购意向附件列表
     */
    purchasePurposeAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 资产更新计划
     */
    propertyUpdatePlanAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 集体决策会议纪要
     */
    meetingSummaryAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专家论证意见
     */
    argumentSuggestionAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专项、会议、培训附件列表
     */
    specialAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 银行回单附件
     */
    bankReceiptAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 账单附件
     */
    billAttachmentFileList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  };
  /**
   * 费用记录列表
   */
  feeRecordList?: {
    /**
     * 费用编码
     */
    feeCode?: string;
    /**
     * 费用金额
     */
    feeAmount?: number;
    /**
     * 费用类型编码：1001-住宿，1002-午休，2001-火车，2002-飞机，2003-轮船，2004-短途包干，2005-退票/改签，3001-伙食费，4001-公杂费，5001-其他费用，9999-总费用
     */
    feeType?:
      | 1001
      | 1002
      | 2001
      | 2002
      | 2003
      | 2004
      | 2005
      | 2006
      | 2007
      | 2008
      | 2009
      | 3001
      | 300101
      | 3002
      | 4001
      | 5001
      | 5000
      | 5002
      | 5003
      | 5004
      | 5005
      | 5006
      | 5007
      | 5008
      | 5009
      | 5010
      | 5011
      | 5012
      | 6000
      | 6001
      | 6002
      | 6003
      | 7000
      | 7001
      | 7002
      | 7003
      | 7004
      | 7005
      | 8888
      | 8001
      | 8002
      | 8003
      | 9999;
    /**
     * 费用大类
     */
    parentFeeType?:
      | 10
      | 10
      | 20
      | 20
      | 20
      | 20
      | 20
      | 20
      | 20
      | 20
      | 20
      | 30
      | 30
      | 30
      | 40
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 60
      | 60
      | 60
      | 60
      | 70
      | 70
      | 70
      | 70
      | 70
      | 70
      | 88
      | 80
      | 80
      | 80
      | 99;
    /**
     * 调整金额
     */
    modifyFeeAmountDTO?: {
      /**
       * 原始金额
       */
      originalAmount: number;
      /**
       * 修改后金额
       */
      updateAmount: number;
      /**
       * 修改备注
       */
      updateReason?: string;
      /**
       * 原始账户
       */
      originalAccount?: string;
      /**
       * 修改后账户
       */
      updateAccount?: string;
    };
    /**
     * 有无调整历史
     * true-有，false-无
     */
    haveFeeAdjustHistory?: boolean;
    /**
     * 是否超标：true-是，false-否
     */
    isExcessive?: boolean;
  }[];
  /**
   * 商品PO for 办公用品采购、通用采购、政府购买服务、办公设备家具购置
   */
  commodityList?: {
    /**
     * 费控校验编码
     */
    checkCode?: string;
    /**
     * 政采云商品编号
     */
    commodityCode?: string;
    /**
     * 供应商ID
     */
    supplierId?: number;
    /**
     * 供应商名称
     */
    supplierName?: string;
    /**
     * 商品名称
     */
    commodityName: string;
    /**
     * 规则描述
     */
    specification?: string;
    /**
     * 单价（分）
     */
    unitPrice: number;
    /**
     * 小记（分）
     */
    totalPrice: number;
    /**
     * 数量
     */
    amount: number;
    /**
     * 商品数据来源：0-浙里报 1-政采云
     */
    commoditySource?: number;
    /**
     * 商品拓展字段
     */
    extendDataDTO?: {
      /**
       * 实例名称
       */
      instanceName?: string;
      /**
       * 品牌
       */
      brandName?: string;
      /**
       * 型号
       */
      model?: string;
      /**
       * 商品详情页url
       */
      detailPageUrl?: string;
      /**
       * 所有服务商品单价和
       */
      serviceTotalPrice?: number;
      /**
       * 服务单价和
       */
      sumServiceTotalPrice?: number;
      /**
       * 计量单位
       */
      unit?: string;
      /**
       * 是否进口：1是、0否
       */
      isImport?: number;
      /**
       * 是否适宜中小企业：1是、0否
       */
      isSuit?: number;
      /**
       * 不适宜中小企业理由
       */
      noSuitReason?: string;
      /**
       * 采购目录code（选择的）
       */
      catalogCodeList?: string[];
      /**
       * First catalogCodeList
       */
      category?: string;
      /**
       * 采购目录name（选择的）
       */
      catalogNameList?: string[];
      /**
       * 政府购买服务目录code（选择的）
       */
      serviceCodeList?: string[];
      /**
       * 政府购买服务目录name（选择的）
       */
      serviceNameList?: string[];
      /**
       * 采购目录信息(从购物车取的数据)
       */
      catalogList?: {
        /**
         * 采购目录编码
         */
        catalogCode?: string;
        /**
         * 采购目录名称
         */
        catalogName?: string;
      }[];
      /**
       * 商品属性信息
       */
      attributeList?: {
        /**
         * 属性名称
         */
        attributeName?: string;
        /**
         * 属性值
         */
        attributeValue?: string;
      }[];
      /**
       * 商品服务项信息
       */
      standards?: {
        /**
         * 服务商品ID
         */
        standardId?: number;
        /**
         * 服务名称
         */
        standardName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 品牌名称
         */
        brandName?: string;
        /**
         * 数量
         */
        amount?: number;
        /**
         * 服务价格
         */
        price?: number;
        /**
         * 单位
         */
        unit?: string;
      }[];
      /**
       * 商品服务信息
       */
      services?: {
        /**
         * 服务名称
         */
        serviceName?: string;
        /**
         * 服务属性
         */
        serviceAttribute?: string;
        /**
         * 服务id
         */
        serviceId?: number;
        /**
         * 单价
         */
        price?: number;
        /**
         * 单位
         */
        unit?: string;
        /**
         * 数量 随着商品增加
         */
        amount?: number;
      }[];
      /**
       * 选配信息
       */
      news?: {
        /**
         * 购物车配件主键 id
         */
        newsId?: number;
        /**
         * 数量
         */
        amount?: number;
        /**
         * 品牌名称
         */
        newsName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 品牌名称
         */
        brandName?: string;
        /**
         * 配件单价，单位：分
         */
        price?: number;
        /**
         * 单位
         */
        unit?: string;
      }[];
      /**
       * 使用人信息
       */
      userInfo?: {
        /**
         * 职级
         * 1-厅级 2-处级 3-处级以下
         */
        userRank: 1 | 2 | 3;
        /**
         * 职级描述
         */
        userRankDesc?: string;
        /**
         * 使用人姓名
         */
        userName: string;
      };
      /**
       * 资产类型
       * 1-办公家具 2-办公设备
       */
      propertyType?: string;
      /**
       * 资产类型描述
       */
      propertyTypeDesc?: string;
      /**
       * 资产品目
       */
      propertyItem?: string;
      /**
       * 资产品目类型
       */
      propertyItemDesc?: string;
      /**
       * 商品类目
       */
      itemCatalogName?: string;
      /**
       * 会议桌容纳人数
       */
      userCount?: number;
      /**
       * 政采云商品链接，用户填写，自动解析出商品数据
       */
      zcyUrl?: string;
      /**
       * 是否国产，资产类别为办公设备时可填，如果为是，不进行费控  1是、0否
       */
      domestic?: number;
      /**
       * 商品主图
       */
      mainImage?: string;
    };
    /**
     * 型号
     */
    model?: string;
    /**
     * 政采云商品图片附件
     */
    attachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  }[];
  /**
   * 备注
   */
  remark?: string;
  /**
   * 业务编码
   */
  businessNo?: string;
  /**
   * 申请金额，采购申请单需要
   */
  applyAmount?: number;
  /**
   * 单据快照
   */
  formSnapshotCode?: string;
  /**
   * 工作计划Code列表
   */
  workPlanCodeList?: string[];
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
    /**
     * 科目uk 级联
     */
    subjectUkHierarchy?: string[];
    /**
     * 科目名称级联
     */
    subjectNameHierarchy?: string[];
  }[];
  /**
   * 申请单code
   */
  applyFormCode?: string;
  /**
   * 工作流数据
   */
  workflowInfo?: {
    bizId?: string;
    bizType?: string;
    businessCode?: string;
    subType?: string;
    processDefineKey?: string;
    processModelId?: number;
    version?: number;
    auditInfos?: {
      taskDefineKey?: string;
      nodeName?: string;
      operatorIds?: number[];
      nodeType?: number;
      eventType?: number;
      auditType?: number;
      departmentId?: number;
      bizProperty?: string;
      auditStatus?: number;
    }[];
    extConditions?: {
      key?: {};
    };
    context?: string;
    operatorId?: number;
    remark?: string;
  };
}

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233478) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/save`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233478) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/save`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233478) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/save`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormSavePostRequestConfig: ZlbApiExpenseApplyFormSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233478) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/save`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormSavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormSavePostResponse>(
    prepare(zlbApiExpenseApplyFormSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormSavePost.requestConfig = zlbApiExpenseApplyFormSavePostRequestConfig;

/**
 * 接口 [删除申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233486) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/delete/{code}`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormDeleteCodePostRequest {
  /**
   * 申请单code
   */
  code: string;
}

/**
 * 接口 [删除申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233486) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/delete/{code}`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormDeleteCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233486) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/delete/{code}`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormDeleteCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/delete/{code}',
    'data',
    'code',
    string,
    false
  >
>;

/**
 * 接口 [删除申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233486) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/delete/{code}`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormDeleteCodePostRequestConfig: ZlbApiExpenseApplyFormDeleteCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/delete/{code}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: ['code'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormDeleteCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233486) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/delete/{code}`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormDeleteCodePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormDeleteCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormDeleteCodePostResponse>(
    prepare(zlbApiExpenseApplyFormDeleteCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormDeleteCodePost.requestConfig =
  zlbApiExpenseApplyFormDeleteCodePostRequestConfig;

/**
 * 接口 [提交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233494) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/submit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormSubmitPostRequest {
  /**
   * 申请单类型
   */
  applyFormType: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
  /**
   * 报销类型
   */
  businessType:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 32
    | 29
    | 30
    | 33;
  /**
   * 工作单位id
   */
  orgId: number;
  /**
   * 工作单位名称
   */
  orgName: string;
  /**
   * 工作部门id
   */
  deptId: number;
  /**
   * 工作部门名称
   */
  deptName?: string;
  /**
   * 申请事由
   */
  applyReason: string;
  /**
   * 后补申请原因
   */
  replenishReason?: string;
  /**
   * 申请时间
   * 线下差旅申请提交时间
   */
  applyTime?: string;
  /**
   * 扩展信息
   */
  extendFieldDTO?: {
    /**
     * 差旅扩展字段
     */
    travelExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 是否派车：1-派车，2-不派车
       */
      arrangeCar?: string;
      /**
       * 派车天数
       */
      dayCount?: number;
      extra?: string;
      /**
       * 三方拓展字段
       */
      thirdExtend?: string;
      /**
       * 差旅报销方式
       */
      travelExpenseMethod?: '由申请单报销' | '凭票报销';
      /**
       * 工号
       */
      workNo?: string;
      /**
       * 是否项目出差
       */
      isProject?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 所属部门
       */
      depName?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 项目名称
       */
      projectName?: {
        key?: string;
        value?: string;
        label?: string;
      };
      /**
       * 项目负责人
       */
      projectHeader?: {
        key?: string;
        value?: string;
        label?: string;
      };
    };
    /**
     * 会议扩展字段（包含多收款人）
     */
    meetingExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 1 签掉表 2 签到表附件
       */
      signType?: number;
      /**
       * 签到表
       */
      signForm?: {
        signFormCode?: string;
        /**
         * 签到表名称
         */
        signFormName?: string;
        /**
         * 申请表状态
         * 0-未发布 1-已发布 2-已结束
         */
        formStatus?: number;
        /**
         * 申请表状态名称
         */
        formStatusName?: string;
        /**
         * 结束时间
         */
        endTime?: number;
      };
      /**
       * 1申请单携带 2 手动选择
       */
      isExpenseInit?: number;
      /**
       * 会议名称
       */
      meetingName: string;
      /**
       * 会议地点code
       */
      meetingCityCode?: string;
      /**
       * 会议地点名称
       */
      meetingCityName?: string;
      /**
       * 会议开始日期
       */
      meetingStartDate?: string;
      /**
       * 会议结束日期
       */
      meetingEndDate?: string;
      /**
       * 会议天数
       */
      meetingDayCount?: number;
      /**
       * 会议预计参会人数
       */
      meetingExpectAttendeeCount: number;
      /**
       * 会议实际参会人数
       */
      meetingRealAttendeeCount?: number;
      /**
       * 会议工作人员人数
       */
      meetingWorkerCount?: number;
      /**
       * 参会领导信息
       */
      meetingLeaderInfo?: string;
      /**
       * 会议议程
       */
      meetingAgenda?: string;
      /**
       * 是否纳入预算
       * 1-是，2-否
       */
      isIncludedBudget?: number;
      /**
       * 会议差异内容
       */
      meetingDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal?: number;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 详细地址信息
       */
      detailAddress?: string;
    };
    /**
     * 培训扩展字段（包含多收款人）
     */
    trainingExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 1 签掉表 2 签到表附件
       */
      signType?: number;
      /**
       * 签到表
       */
      signForm?: {
        signFormCode?: string;
        /**
         * 签到表名称
         */
        signFormName?: string;
        /**
         * 申请表状态
         * 0-未发布 1-已发布 2-已结束
         */
        formStatus?: number;
        /**
         * 申请表状态名称
         */
        formStatusName?: string;
        /**
         * 结束时间
         */
        endTime?: number;
      };
      /**
       * 1申请单携带 2 手动选择
       */
      isExpenseInit?: number;
      /**
       * 培训名称
       */
      trainingName?: string;
      /**
       * 培训地点code
       */
      trainingCityCode?: string;
      /**
       * 培训地点名称
       */
      trainingCityName?: string;
      /**
       * 培训开始日期
       */
      trainingStartDate?: string;
      /**
       * 培训结束日期
       */
      trainingEndDate?: string;
      /**
       * 培训天数
       */
      trainingDayCount?: number;
      /**
       * 培训预计参会人数
       */
      trainingExpectAttendeeCount?: number;
      /**
       * 培训实际参会人数
       */
      trainingRealAttendeeCount?: number;
      /**
       * 培训工作人员人数
       */
      trainingWorkerCount?: number;
      /**
       * 培训议程
       */
      trainingAgenda?: string;
      /**
       * 是否纳入预算
       * 1-是，2-否
       */
      isIncludedBudget?: number;
      /**
       * 培训差异内容
       */
      trainingDifferenceContent?: string;
      /**
       * 培训讲师信息
       */
      trainingTeacherInfo?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal?: number;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource?: number;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
      /**
       * 变更支付方式说明
       */
      changePayModeReason?: string;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
      /**
       * 详细地址信息
       */
      detailAddress?: string;
    };
    /**
     * 采购扩展字段
     */
    procurementExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 采购内容
       */
      procurementContent?: string;
      /**
       * 采购差异内容
       */
      procurementDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 费用合计
       */
      applyAmount?: number;
      /**
       * 合同信息
       */
      contractList?: {
        /**
         * 政采云合同ID，订单拉取的合同填写
         */
        contractId?: number;
        /**
         * 订单编号
         */
        orderCode?: string;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
      }[];
    };
    /**
     * 公务接待
     */
    receptionExtendFields?: {
      /**
       * 来访单位
       */
      visitOrgName: string;
      /**
       * 是否同城（宁波场景不需要）
       * 1-是，2-否
       */
      isSameCity?: number;
      /**
       * 来访人员职务
       */
      visitorDuty?: string;
      /**
       * 来访事由
       */
      visitReason: string;
      /**
       * 来访开始日期
       */
      visitStartDate: string;
      /**
       * 来访结束日期
       */
      visitEndDate: string;
      /**
       * 来访人员级别：1-省部级、2-厅局级、99-其他
       */
      visitorLevel: number;
      /**
       * 来访人员级别名称
       */
      visitorLevelName?: string;
      /**
       * 来访人数
       */
      visitorCount: number;
      /**
       * 主宾姓名
       */
      mainGuest?: string;
      /**
       * 接待地点code
       */
      receptionCityCode: string;
      /**
       * 接待地点名称
       */
      receptionCityName: string;
      /**
       * 接待详细地点
       */
      receptionDetailAddress?: string;
      /**
       * 就餐日期
       */
      mealDate: string;
      /**
       * 工作餐形式：1-自助餐、2-桌餐
       */
      mealType: 1 | 2 | 3;
      /**
       * 工作餐形式
       */
      mealTypeName?: string;
      /**
       * 用餐时间：1-早餐，2-中餐，3-晚餐
       */
      mealTimeType?: 1 | 2 | 3;
      /**
       * 用餐时间
       */
      mealTimeTypeName?: string;
      /**
       * 陪餐人数（宁波场景不需要）
       */
      escortCount?: number;
      /**
       * 配餐人员姓名
       */
      escortPerson?: string;
      /**
       * 接待预算金额
       */
      receptionBudgetAmount?: number;
      /**
       * 来访人员信息
       */
      visitorInformation?: {
        /**
         * 访问人员名称
         */
        visitorName?: string;
        /**
         * 访问人员职级
         */
        visitorLevel?: number;
        /**
         * 访问人员职级名称
         */
        visitorLevelName?: string;
        /**
         * 来访人员职务
         */
        visitorDuty?: string;
      }[];
      /**
       * 接待人员信息
       */
      receptionistInformation?: {
        /**
         * 接待人员名称
         */
        receptionistName?: string;
        /**
         * 接待人员职级
         */
        receptionistLevel?: number;
        /**
         * 接待人员职级名称
         */
        receptionistLevelName?: string;
      }[];
    };
    /**
     * 一般事项
     */
    generalExtendFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 事项详细内容
       */
      detailContent: string;
      /**
       * 事项预算
       */
      eventBudget?: number;
      /**
       * 事项详细内容与事前审批的差异
       */
      generalDifferenceContent?: string;
      extra?: string;
    };
    /**
     * 用印申请
     */
    contractExtendFields?: {
      /**
       * 合同编号
       */
      uniqueCode?: string;
    };
    /**
     * 招标书
     */
    tenderApplyExtendFields?: {
      /**
       * 申请单类型
       */
      applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
      /**
       * 申请事由
       */
      applyReason?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 业务单据号
       */
      businessCode?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
    };
    /**
     * 通用采购申请拓展字段
     */
    purchaseGeneralFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm?: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * isCreatePurchaseProposal
       * 采购类型
       * 1-政府采购，2-非政府采购
       */
      purchaseType?: 1 | 2;
      /**
       * 采购类型描述
       */
      purchaseTypeDesc?: string;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource?: 1 | 2;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
    };
    /**
     * 政府购买服务申请拓展字段
     */
    govermentApplyFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
      /**
       * 采购类型
       * 1-政府采购，2-非政府采购
       */
      purchaseType: 1 | 2;
      /**
       * 采购类型描述
       */
      purchaseTypeDesc?: string;
      /**
       * 采购资金来源
       * 1-财政预算资金，2-非财政预算资金
       */
      purchaseFundSource: 1 | 2;
      /**
       * 采购资金来源描述
       */
      purchaseFundSourceDesc?: string;
    };
    /**
     * 办公家具购置申请拓展字段
     */
    furnitureApplyFields?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 组织形式
       */
      organizationalForm: 1 | 2 | 3 | 4;
      /**
       * 组织形式描述
       */
      organizationalFormDesc?: string;
      /**
       * 采购方式
       */
      purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
      /**
       * 采购方式描述
       */
      purchaseMethodDesc?: string;
      /**
       * 是否生成采购建议书草稿
       * 1-是，2-否
       */
      isCreatePurchaseProposal: number;
    };
    /**
     * 全链路二期 报销的统一拓展字段
     */
    purchaseGeneralExpenseFieldDTO?: {
      baidaInfo?: {
        /**
         * 百搭快照编号
         */
        formSnapshotCode?: string;
        /**
         * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
         */
        formData?: string;
      };
      /**
       * 交易方式：线上；线下
       */
      tradeWay?: string[];
      /**
       * 采购差异内容
       */
      procurementDifferenceContent?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 交易方式
       */
      tradeWayName?: string;
      /**
       * 是否有合同
       */
      addContract?: boolean;
    };
    /**
     * 公共事业缴费统一拓展字段
     */
    publicBusinessPaymentFieldDTO?: {
      /**
       * 备注
       */
      remark?: string;
    };
    /**
     * 无相拓展
     */
    generalExtra?: string;
  };
  /**
   * 行程信息列表
   */
  itineraryList?: {
    /**
     * 前端生成的编号
     */
    indexNo?: string;
    /**
     * 行程单编号
     * 更新时必填
     */
    itineraryCode?: string;
    /**
     * 原行程单号
     */
    originalItineraryCode?: string;
    /**
     * 出差人列表
     */
    accompanyList: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 开始上下午
     */
    beginTag: number;
    /**
     * 结束时间
     */
    endTime: string;
    /**
     * 结束上下午
     */
    endTag: number;
    /**
     * 出差天数
     */
    travelDay: number;
    /**
     * 是否派车 0不派车 1派车
     */
    arrangeCar: number;
    /**
     * 派车信息
     */
    arrangeCarPO?: {
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag: number;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag: number;
      /**
       * 派车天数
       */
      arrangeCarDay: number;
      /**
       * 乘车人
       */
      passengerList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
    };
    /**
     * 出发城市code
     */
    beginCityCode: string;
    /**
     * 出发城市名称
     */
    beginCityName: string;
    /**
     * 目的城市列表
     */
    endCityList: {
      /**
       * 目的城市code
       */
      endCityCode: string;
      /**
       * 目的城市名称
       */
      endCityName: string;
    }[];
    /**
     * 住宿天数
     */
    accommodationDay: number;
  }[];
  /**
   * 单据附件
   */
  formAttachmentDTO?: {
    /**
     * 默认附件列表
     */
    normalAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 说明附件列表
     */
    thatAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 通知附件列表
     */
    informAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 合同附件列表
     */
    compactAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 签到附件列表
     */
    signAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 派出单位公函附件列表
     */
    officialLetterAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 接待清单附件列表
     */
    receptionMenuAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 采购意向附件列表
     */
    purchasePurposeAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 资产更新计划
     */
    propertyUpdatePlanAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 集体决策会议纪要
     */
    meetingSummaryAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专家论证意见
     */
    argumentSuggestionAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 专项、会议、培训附件列表
     */
    specialAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 银行回单附件
     */
    bankReceiptAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 账单附件
     */
    billAttachmentFileList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  };
  /**
   * 费用记录列表
   */
  feeRecordList?: {
    /**
     * 费用编码
     */
    feeCode?: string;
    /**
     * 费用金额
     */
    feeAmount?: number;
    /**
     * 费用类型编码：1001-住宿，1002-午休，2001-火车，2002-飞机，2003-轮船，2004-短途包干，2005-退票/改签，3001-伙食费，4001-公杂费，5001-其他费用，9999-总费用
     */
    feeType?:
      | 1001
      | 1002
      | 2001
      | 2002
      | 2003
      | 2004
      | 2005
      | 2006
      | 2007
      | 2008
      | 2009
      | 3001
      | 300101
      | 3002
      | 4001
      | 5001
      | 5000
      | 5002
      | 5003
      | 5004
      | 5005
      | 5006
      | 5007
      | 5008
      | 5009
      | 5010
      | 5011
      | 5012
      | 6000
      | 6001
      | 6002
      | 6003
      | 7000
      | 7001
      | 7002
      | 7003
      | 7004
      | 7005
      | 8888
      | 8001
      | 8002
      | 8003
      | 9999;
    /**
     * 费用大类
     */
    parentFeeType?:
      | 10
      | 10
      | 20
      | 20
      | 20
      | 20
      | 20
      | 20
      | 20
      | 20
      | 20
      | 30
      | 30
      | 30
      | 40
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 50
      | 60
      | 60
      | 60
      | 60
      | 70
      | 70
      | 70
      | 70
      | 70
      | 70
      | 88
      | 80
      | 80
      | 80
      | 99;
    /**
     * 调整金额
     */
    modifyFeeAmountDTO?: {
      /**
       * 原始金额
       */
      originalAmount: number;
      /**
       * 修改后金额
       */
      updateAmount: number;
      /**
       * 修改备注
       */
      updateReason?: string;
      /**
       * 原始账户
       */
      originalAccount?: string;
      /**
       * 修改后账户
       */
      updateAccount?: string;
    };
    /**
     * 有无调整历史
     * true-有，false-无
     */
    haveFeeAdjustHistory?: boolean;
    /**
     * 是否超标：true-是，false-否
     */
    isExcessive?: boolean;
  }[];
  /**
   * 商品PO for 办公用品采购、通用采购、政府购买服务、办公设备家具购置
   */
  commodityList?: {
    /**
     * 费控校验编码
     */
    checkCode?: string;
    /**
     * 政采云商品编号
     */
    commodityCode?: string;
    /**
     * 供应商ID
     */
    supplierId?: number;
    /**
     * 供应商名称
     */
    supplierName?: string;
    /**
     * 商品名称
     */
    commodityName: string;
    /**
     * 规则描述
     */
    specification?: string;
    /**
     * 单价（分）
     */
    unitPrice: number;
    /**
     * 小记（分）
     */
    totalPrice: number;
    /**
     * 数量
     */
    amount: number;
    /**
     * 商品数据来源：0-浙里报 1-政采云
     */
    commoditySource?: number;
    /**
     * 商品拓展字段
     */
    extendDataDTO?: {
      /**
       * 实例名称
       */
      instanceName?: string;
      /**
       * 品牌
       */
      brandName?: string;
      /**
       * 型号
       */
      model?: string;
      /**
       * 商品详情页url
       */
      detailPageUrl?: string;
      /**
       * 所有服务商品单价和
       */
      serviceTotalPrice?: number;
      /**
       * 服务单价和
       */
      sumServiceTotalPrice?: number;
      /**
       * 计量单位
       */
      unit?: string;
      /**
       * 是否进口：1是、0否
       */
      isImport?: number;
      /**
       * 是否适宜中小企业：1是、0否
       */
      isSuit?: number;
      /**
       * 不适宜中小企业理由
       */
      noSuitReason?: string;
      /**
       * 采购目录code（选择的）
       */
      catalogCodeList?: string[];
      /**
       * First catalogCodeList
       */
      category?: string;
      /**
       * 采购目录name（选择的）
       */
      catalogNameList?: string[];
      /**
       * 政府购买服务目录code（选择的）
       */
      serviceCodeList?: string[];
      /**
       * 政府购买服务目录name（选择的）
       */
      serviceNameList?: string[];
      /**
       * 采购目录信息(从购物车取的数据)
       */
      catalogList?: {
        /**
         * 采购目录编码
         */
        catalogCode?: string;
        /**
         * 采购目录名称
         */
        catalogName?: string;
      }[];
      /**
       * 商品属性信息
       */
      attributeList?: {
        /**
         * 属性名称
         */
        attributeName?: string;
        /**
         * 属性值
         */
        attributeValue?: string;
      }[];
      /**
       * 商品服务项信息
       */
      standards?: {
        /**
         * 服务商品ID
         */
        standardId?: number;
        /**
         * 服务名称
         */
        standardName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 品牌名称
         */
        brandName?: string;
        /**
         * 数量
         */
        amount?: number;
        /**
         * 服务价格
         */
        price?: number;
        /**
         * 单位
         */
        unit?: string;
      }[];
      /**
       * 商品服务信息
       */
      services?: {
        /**
         * 服务名称
         */
        serviceName?: string;
        /**
         * 服务属性
         */
        serviceAttribute?: string;
        /**
         * 服务id
         */
        serviceId?: number;
        /**
         * 单价
         */
        price?: number;
        /**
         * 单位
         */
        unit?: string;
        /**
         * 数量 随着商品增加
         */
        amount?: number;
      }[];
      /**
       * 选配信息
       */
      news?: {
        /**
         * 购物车配件主键 id
         */
        newsId?: number;
        /**
         * 数量
         */
        amount?: number;
        /**
         * 品牌名称
         */
        newsName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 品牌名称
         */
        brandName?: string;
        /**
         * 配件单价，单位：分
         */
        price?: number;
        /**
         * 单位
         */
        unit?: string;
      }[];
      /**
       * 使用人信息
       */
      userInfo?: {
        /**
         * 职级
         * 1-厅级 2-处级 3-处级以下
         */
        userRank: 1 | 2 | 3;
        /**
         * 职级描述
         */
        userRankDesc?: string;
        /**
         * 使用人姓名
         */
        userName: string;
      };
      /**
       * 资产类型
       * 1-办公家具 2-办公设备
       */
      propertyType?: string;
      /**
       * 资产类型描述
       */
      propertyTypeDesc?: string;
      /**
       * 资产品目
       */
      propertyItem?: string;
      /**
       * 资产品目类型
       */
      propertyItemDesc?: string;
      /**
       * 商品类目
       */
      itemCatalogName?: string;
      /**
       * 会议桌容纳人数
       */
      userCount?: number;
      /**
       * 政采云商品链接，用户填写，自动解析出商品数据
       */
      zcyUrl?: string;
      /**
       * 是否国产，资产类别为办公设备时可填，如果为是，不进行费控  1是、0否
       */
      domestic?: number;
      /**
       * 商品主图
       */
      mainImage?: string;
    };
    /**
     * 型号
     */
    model?: string;
    /**
     * 政采云商品图片附件
     */
    attachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
  }[];
  /**
   * 备注
   */
  remark?: string;
  /**
   * 业务编码
   */
  businessNo?: string;
  /**
   * 申请金额，采购申请单需要
   */
  applyAmount?: number;
  /**
   * 单据快照
   */
  formSnapshotCode?: string;
  /**
   * 工作计划Code列表
   */
  workPlanCodeList?: string[];
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
    /**
     * 科目uk 级联
     */
    subjectUkHierarchy?: string[];
    /**
     * 科目名称级联
     */
    subjectNameHierarchy?: string[];
  }[];
  /**
   * 申请单code
   */
  applyFormCode?: string;
  /**
   * 是否跳过弱控
   * true：跳过，false：不跳过
   */
  isIgnoreWarning?: boolean;
  /**
   * 工作流数据
   */
  workflowInfo?: {
    bizId?: string;
    bizType?: string;
    businessCode?: string;
    subType?: string;
    processDefineKey?: string;
    processModelId?: number;
    version?: number;
    auditInfos?: {
      taskDefineKey?: string;
      nodeName?: string;
      operatorIds?: number[];
      nodeType?: number;
      eventType?: number;
      auditType?: number;
      departmentId?: number;
      bizProperty?: string;
      auditStatus?: number;
    }[];
    extConditions?: {
      key?: {};
    };
    context?: string;
    operatorId?: number;
    remark?: string;
  };
}

/**
 * 接口 [提交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233494) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/submit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验是否成功
     */
    isSuccess?: boolean;
    /**
     * 校验失败信息列表
     * isSuccess为false时必填
     */
    checkInfoList?: {
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 校验状态,目前默认为弱控
       * 0-通过 1-弱控 2-强控 3-提示
       */
      checkStatus?: number;
      /**
       * 警告信息
       */
      warningInfo?: string;
      /**
       * 是否参与校验
       * true-校验，false-不校验
       */
      isCheck?: boolean;
    }[];
    /**
     * 单据编号
     */
    applyFormCode?: string;
    /**
     * 申请单采购限额校验结果 for 办公用品采购
     */
    checkResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 校验描述
       */
      message?: string;
      /**
       * 费用限额
       */
      amount?: number;
      /**
       * 费控校验编码
       */
      checkCode?: string;
    };
    /**
     * 申请单采购限额校验结果 for 办公设备家具购置
     */
    furnitureCheckList?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 校验描述
       */
      message?: string;
      /**
       * 费用限额
       */
      amount?: number;
      /**
       * 费控校验编码
       */
      checkCode?: string;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 报销单预算项目校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 科目校验描述
         */
        subjectCheckDesc?: string;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233494) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/submit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233494) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/submit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormSubmitPostRequestConfig: ZlbApiExpenseApplyFormSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233494) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/submit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormSubmitPostResponse>(
    prepare(zlbApiExpenseApplyFormSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormSubmitPost.requestConfig = zlbApiExpenseApplyFormSubmitPostRequestConfig;

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233502) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/nullify/{code}`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormNullifyCodePostRequest {
  /**
   * 申请单code
   */
  code: string;
}

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233502) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/nullify/{code}`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormNullifyCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233502) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/nullify/{code}`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormNullifyCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/nullify/{code}',
    'data',
    'code',
    string,
    false
  >
>;

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233502) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/nullify/{code}`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormNullifyCodePostRequestConfig: ZlbApiExpenseApplyFormNullifyCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/nullify/{code}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: ['code'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormNullifyCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233502) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/nullify/{code}`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormNullifyCodePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormNullifyCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormNullifyCodePostResponse>(
    prepare(zlbApiExpenseApplyFormNullifyCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormNullifyCodePost.requestConfig =
  zlbApiExpenseApplyFormNullifyCodePostRequestConfig;

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/233510) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/page`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 完成状态，1：已处理，2：未处理，3-全部
   */
  completionStatus?: number;
  /**
   * 业务单据号
   */
  businessCode?: string;
  /**
   * 单据类型
   */
  businessType?:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 32
    | 29
    | 30
    | 33;
  /**
   * 申请单类型编号
   */
  applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
  /**
   * 申请单类型编号
   */
  applyFormTypeList?: number[];
  /**
   * 申请事由
   */
  applyReason?: string;
  /**
   * 起始时间
   */
  beginTime?: number;
  /**
   * 结束时间
   */
  endTime?: number;
  /**
   * 单据状态
   */
  formStatus?: number;
  /**
   * 部门id
   */
  departmentId?: number;
  /**
   * 是否关联报销单
   */
  associateExpense?: boolean;
  /**
   * 是否需要已关联报销单的单据
   * true-需要，false-不需要
   */
  needAssociate?: boolean;
  /**
   * pc端请求
   */
  pcRequest?: number;
  /**
   * 数据来源
   */
  dataSource?: number;
  /**
   * 是否查询采购类订单（会议/培训/办公用品采购）
   * true-是
   */
  purchase?: boolean;
  /**
   * 是否有可报销金额
   * 1-是 0-否
   */
  isRemaining?: number;
  /**
   * 关联机构ID
   */
  orgId?: number;
  /**
   * 人员业务类别
   */
  userRelationTypeList?: (1 | 2 | 3 | 4 | 5 | 6 | 99)[];
  /**
   * 是否抄送 0-否，1-是
   */
  isCopySend?: number;
}

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/233510) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/page`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 申请单编号
       */
      applyFormCode?: string;
      /**
       * 业务单据号
       */
      businessCode?: string;
      /**
       * 申请单类型编号
       */
      applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
      /**
       * 申请单类型名称
       */
      applyFormTypeName?:
        | '差旅申请'
        | '会议申请'
        | '培训申请'
        | '办公用品采购申请'
        | '用印申请'
        | '公务接待申请'
        | '一般事项申请'
        | '招标书申请'
        | '通用采购申请'
        | '政府购买服务申请'
        | '办公设备家具购置申请'
        | '公共事业缴费申请';
      /**
       * 报销类型编号
       */
      businessType?:
        | 1
        | 2
        | 19
        | 20
        | 28
        | 4
        | 5
        | 6
        | 27
        | 31
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 21
        | 22
        | 23
        | 24
        | 25
        | 26
        | 32
        | 29
        | 30
        | 33;
      /**
       * 报销类型名称
       */
      businessTypeName?:
        | '普通出差'
        | '专项会议培训'
        | '外派'
        | '外出'
        | '外出培训'
        | '一类会议'
        | '二类会议'
        | '三类会议'
        | '其他会议'
        | '线上会议'
        | '一类培训'
        | '二类培训'
        | '集中采购'
        | '分散采购'
        | '办公用品采购'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书申请'
        | '通用采购'
        | '政府购买服务'
        | '办公设备家具购置'
        | '公共事业缴费'
        | '办公用品'
        | '通用采购'
        | '政府服务购买'
        | '办公设备家具购置'
        | '一般事项'
        | '公务接待'
        | '个人账户'
        | '企业账户'
        | '投资支付';
      /**
       * 申请事由
       */
      applyReason?: string;
      /**
       * 申请人ID
       */
      applyOperatorId?: number;
      /**
       * 申请人姓名
       */
      applyUserName?: string;
      /**
       * 申请人所在单位
       */
      orgName?: string;
      /**
       * 申请人所在部门
       */
      deptName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 是否报销
       */
      isExpense?: boolean;
      /**
       * 单据状态编号
       * 1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
       */
      formStatus?: number;
      /**
       * 单据状态名称
       * 1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
       */
      formStatusName?: string;
      /**
       * 是否是本人提交
       * true：是本人，false：不是本人
       */
      isHimself?: boolean;
      /**
       * 是否是可撤回状态
       * true：可撤回，false：不可撤回
       */
      withdrawn?: boolean;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 是否已经关联
       * true-关联，false-未关联
       */
      isAssociate?: boolean;
      /**
       * 处理中状态：IN_APPROVAL-审核；IN_AUDIT-审核中
       */
      processStatus?: string;
      /**
       * 用户类别
       * 1-本人 2-审核人 3-审批人 4-同行人 5-转交人
       */
      userRole?: number;
      /**
       * 数据来源
       */
      dataSource?: number;
      /**
       * 总金额
       */
      applyAmount?: number;
      /**
       * 剩余报销金额 for 通用采购、政府购买服务、办公设备家具购置
       */
      remainingAmount?: number;
      /**
       * 操作
       */
      operateButton?: {
        /**
         * 查看
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        delete?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 提交经办人
         */
        addPerson?: boolean;
      };
      /**
       * 是否是百搭
       */
      isBaidaForm?: boolean;
      /**
       * 是否是后补单据
       * true-是，false-不是
       */
      isSubsequent?: boolean;
      /**
       * 后补时间
       * 是后补单据-有值
       * 非后补单据-空值
       */
      subsequentTime?: string;
      /**
       * 审批人名称
       */
      approvedNames?: string[];
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/233510) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/page`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/233510) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/page`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormPagePostRequestConfig: ZlbApiExpenseApplyFormPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/233510) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/page`
 * @更新时间 `2024-08-19 14:39:08`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormPagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormPagePostResponse>(
    prepare(zlbApiExpenseApplyFormPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormPagePost.requestConfig = zlbApiExpenseApplyFormPagePostRequestConfig;

/**
 * 接口 [转交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233526) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/forward`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormForwardPostRequest {
  /**
   * 申请单code
   */
  applyFormCode: string;
  /**
   * 转交接收人列表
   */
  accompanyList?: {
    /**
     * 用户ID
     */
    userId?: number;
    /**
     * 操作员ID
     */
    operatorId: number;
    /**
     * 姓名
     */
    userName: string;
    /**
     * 外部人员职级
     * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
     */
    outerUserRank?: number;
    /**
     * 人员类型
     * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
     */
    userType?: number;
    /**
     * 类型
     * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
     */
    type?: number;
    /**
     * 是否隐藏人员类型显示
     */
    hideOperatorShowType?: boolean;
  }[];
}

/**
 * 接口 [转交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233526) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/forward`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormForwardPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [转交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233526) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/forward`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormForwardPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/forward',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [转交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233526) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/forward`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormForwardPostRequestConfig: ZlbApiExpenseApplyFormForwardPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/forward',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormForwardPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [转交申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/233526) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/forward`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormForwardPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormForwardPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormForwardPostResponse>(
    prepare(zlbApiExpenseApplyFormForwardPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormForwardPost.requestConfig = zlbApiExpenseApplyFormForwardPostRequestConfig;

/**
 * 接口 [申请单代办列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233542) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/to-do-list`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormToDoListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 完成状态，1：已处理，2：未处理，3-全部
   */
  completionStatus?: number;
  /**
   * 业务单据号
   */
  businessCode?: string;
  /**
   * 单据类型
   */
  businessType?:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 32
    | 29
    | 30
    | 33;
  /**
   * 申请单类型编号
   */
  applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
  /**
   * 申请单类型编号
   */
  applyFormTypeList?: number[];
  /**
   * 申请事由
   */
  applyReason?: string;
  /**
   * 起始时间
   */
  beginTime?: number;
  /**
   * 结束时间
   */
  endTime?: number;
  /**
   * 单据状态
   */
  formStatus?: number;
  /**
   * 部门id
   */
  departmentId?: number;
  /**
   * 是否关联报销单
   */
  associateExpense?: boolean;
  /**
   * 是否需要已关联报销单的单据
   * true-需要，false-不需要
   */
  needAssociate?: boolean;
  /**
   * pc端请求
   */
  pcRequest?: number;
  /**
   * 数据来源
   */
  dataSource?: number;
  /**
   * 是否查询采购类订单（会议/培训/办公用品采购）
   * true-是
   */
  purchase?: boolean;
  /**
   * 是否有可报销金额
   * 1-是 0-否
   */
  isRemaining?: number;
  /**
   * 关联机构ID
   */
  orgId?: number;
  /**
   * 人员业务类别
   */
  userRelationTypeList?: (1 | 2 | 3 | 4 | 5 | 6 | 99)[];
  /**
   * 是否抄送 0-否，1-是
   */
  isCopySend?: number;
}

/**
 * 接口 [申请单代办列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233542) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/to-do-list`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormToDoListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 申请单编号
       */
      applyFormCode?: string;
      /**
       * 业务单据号
       */
      businessCode?: string;
      /**
       * 报销类型编号
       */
      businessType?:
        | 1
        | 2
        | 19
        | 20
        | 28
        | 4
        | 5
        | 6
        | 27
        | 31
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 21
        | 22
        | 23
        | 24
        | 25
        | 26
        | 32
        | 29
        | 30
        | 33;
      /**
       * 报销类型名称
       */
      businessTypeName?:
        | '普通出差'
        | '专项会议培训'
        | '外派'
        | '外出'
        | '外出培训'
        | '一类会议'
        | '二类会议'
        | '三类会议'
        | '其他会议'
        | '线上会议'
        | '一类培训'
        | '二类培训'
        | '集中采购'
        | '分散采购'
        | '办公用品采购'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书申请'
        | '通用采购'
        | '政府购买服务'
        | '办公设备家具购置'
        | '公共事业缴费'
        | '办公用品'
        | '通用采购'
        | '政府服务购买'
        | '办公设备家具购置'
        | '一般事项'
        | '公务接待'
        | '个人账户'
        | '企业账户'
        | '投资支付';
      /**
       * 申请单类型编号
       */
      applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
      /**
       * 申请单类型名称
       */
      applyFormTypeName?:
        | '差旅申请'
        | '会议申请'
        | '培训申请'
        | '办公用品采购申请'
        | '用印申请'
        | '公务接待申请'
        | '一般事项申请'
        | '招标书申请'
        | '通用采购申请'
        | '政府购买服务申请'
        | '办公设备家具购置申请'
        | '公共事业缴费申请';
      /**
       * 申请事由
       */
      applyReason?: string;
      /**
       * 申请人ID
       */
      applyOperatorId?: number;
      /**
       * 申请人姓名
       */
      applyUserName?: string;
      /**
       * 申请人所在单位
       */
      orgName?: string;
      /**
       * 申请人所在部门
       */
      deptName?: string;
      /**
       * 申请时间
       */
      initiationTime?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 审批时间
       */
      auditTime?: string;
      /**
       * 单据状态编号
       * 1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
       */
      formStatus?: number;
      /**
       * 单据状态名称
       * 1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
       */
      formStatusName?: string;
      /**
       * 是否可审批
       * true 可以
       * false 不可以
       */
      approvalAuth?: boolean;
      /**
       * 前端循环需要一个唯一值，动态生成UUID塞入,没有任何业务含义，数据库不保存
       */
      uniqueId?: string;
      /**
       * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
       */
      processStatus?: string;
      /**
       * 是否百搭单据
       */
      isBaidaForm?: boolean;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申请单代办列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233542) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/to-do-list`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormToDoListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/to-do-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申请单代办列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233542) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/to-do-list`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormToDoListPostRequestConfig: ZlbApiExpenseApplyFormToDoListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/to-do-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormToDoListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申请单代办列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/233542) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/to-do-list`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormToDoListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormToDoListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormToDoListPostResponse>(
    prepare(zlbApiExpenseApplyFormToDoListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormToDoListPost.requestConfig = zlbApiExpenseApplyFormToDoListPostRequestConfig;

/**
 * 接口 [差旅类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/236230) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/travel-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormTravelTypeGetRequest {}

/**
 * 接口 [差旅类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/236230) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/travel-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormTravelTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 类型编号
     */
    businessType?: number;
    /**
     * 类型名称
     */
    businessTypeName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [差旅类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/236230) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/travel-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormTravelTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/travel-type',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [差旅类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/236230) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/travel-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormTravelTypeGetRequestConfig: ZlbApiExpenseApplyFormTravelTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/travel-type',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormTravelTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [差旅类型查询↗](http://yapi.cai-inc.com/project/3621/interface/api/236230) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/travel-type`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormTravelTypeGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseApplyFormTravelTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormTravelTypeGetResponse>(
    prepare(zlbApiExpenseApplyFormTravelTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormTravelTypeGet.requestConfig =
  zlbApiExpenseApplyFormTravelTypeGetRequestConfig;

/**
 * 接口 [首页预定入口↗](http://yapi.cai-inc.com/project/3621/interface/api/242940) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/recentApplyFormInfo`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormRecentApplyFormInfoGetRequest {}

/**
 * 接口 [首页预定入口↗](http://yapi.cai-inc.com/project/3621/interface/api/242940) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/recentApplyFormInfo`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormRecentApplyFormInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申请编号
     */
    applyFormCode?: string;
    /**
     * 申请信息
     */
    recentApplyInfo?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [首页预定入口↗](http://yapi.cai-inc.com/project/3621/interface/api/242940) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/recentApplyFormInfo`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormRecentApplyFormInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/recentApplyFormInfo',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [首页预定入口↗](http://yapi.cai-inc.com/project/3621/interface/api/242940) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/recentApplyFormInfo`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormRecentApplyFormInfoGetRequestConfig: ZlbApiExpenseApplyFormRecentApplyFormInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/recentApplyFormInfo',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormRecentApplyFormInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [首页预定入口↗](http://yapi.cai-inc.com/project/3621/interface/api/242940) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/recentApplyFormInfo`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormRecentApplyFormInfoGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseApplyFormRecentApplyFormInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormRecentApplyFormInfoGetResponse>(
    prepare(zlbApiExpenseApplyFormRecentApplyFormInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormRecentApplyFormInfoGet.requestConfig =
  zlbApiExpenseApplyFormRecentApplyFormInfoGetRequestConfig;

/**
 * 接口 [关联申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/242942) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/notAssociate/applyForm`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormNotAssociateApplyFormGetRequest {}

/**
 * 接口 [关联申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/242942) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/notAssociate/applyForm`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormNotAssociateApplyFormGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申请事由
     */
    applyReason?: string;
    /**
     * 业务单据号
     */
    businessNo?: string;
    /**
     * 申请编号
     */
    applyFormCode?: string;
    /**
     * 申请人姓名
     */
    applyUserName?: string;
    /**
     * 申请时间
     */
    initiationTime?: string;
    /**
     * 申请单状态
     */
    formStatus?: number;
    /**
     * 数据来源
     */
    dataSource?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 99;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [关联申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/242942) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/notAssociate/applyForm`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormNotAssociateApplyFormGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/notAssociate/applyForm',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [关联申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/242942) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/notAssociate/applyForm`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormNotAssociateApplyFormGetRequestConfig: ZlbApiExpenseApplyFormNotAssociateApplyFormGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/notAssociate/applyForm',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormNotAssociateApplyFormGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [关联申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/242942) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/notAssociate/applyForm`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormNotAssociateApplyFormGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseApplyFormNotAssociateApplyFormGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormNotAssociateApplyFormGetResponse>(
    prepare(zlbApiExpenseApplyFormNotAssociateApplyFormGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormNotAssociateApplyFormGet.requestConfig =
  zlbApiExpenseApplyFormNotAssociateApplyFormGetRequestConfig;

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/245144) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/query`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormQueryGetRequest {
  /**
   * 申请单code
   *                     //@param needAuth    是否鉴权：0-不鉴权，1-鉴权
   */
  formCode?: string;
  identity: string;
  needAuth: string;
  /**
   * 是否脱敏：0-不脱敏，1-脱敏
   */
  desensitize: string;
}

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/245144) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/query`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申请单编号
     */
    applyFormCode?: string;
    /**
     * 业务单据号
     */
    businessCode?: string;
    /**
     * 报销单类型编号
     */
    businessType?:
      | 1
      | 2
      | 19
      | 20
      | 28
      | 4
      | 5
      | 6
      | 27
      | 31
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 21
      | 22
      | 23
      | 24
      | 25
      | 26
      | 32
      | 29
      | 30
      | 33;
    /**
     * 报销单类型编号名称
     */
    businessTypeName?:
      | '普通出差'
      | '专项会议培训'
      | '外派'
      | '外出'
      | '外出培训'
      | '一类会议'
      | '二类会议'
      | '三类会议'
      | '其他会议'
      | '线上会议'
      | '一类培训'
      | '二类培训'
      | '集中采购'
      | '分散采购'
      | '办公用品采购'
      | '用印申请'
      | '公务接待'
      | '一般事项'
      | '招标书申请'
      | '通用采购'
      | '政府购买服务'
      | '办公设备家具购置'
      | '公共事业缴费'
      | '办公用品'
      | '政府服务购买'
      | '个人账户'
      | '企业账户'
      | '投资支付';
    /**
     * 单据类型编号
     */
    applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
    /**
     * 单据类型名称
     */
    applyFormTypeName?:
      | '差旅申请'
      | '会议申请'
      | '培训申请'
      | '办公用品采购申请'
      | '用印申请'
      | '公务接待申请'
      | '一般事项申请'
      | '招标书申请'
      | '通用采购申请'
      | '政府购买服务申请'
      | '办公设备家具购置申请'
      | '公共事业缴费申请';
    /**
     * 是否已经关联报销单
     * true-关联，false-未关联
     */
    isAssociate?: boolean;
    /**
     * 申请人
     */
    applyUserName?: string;
    /**
     * 申请人operatorId
     */
    applyOperatorId?: number;
    /**
     * 工作单位ID
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 工作部门ID
     */
    deptId?: number;
    /**
     * 工作部门名称
     */
    deptName?: string;
    /**
     * 申请事由
     */
    applyReason?: string;
    /**
     * 行程信息列表
     */
    itineraryList?: {
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 行程信息编号
       */
      itineraryCode?: string;
      /**
       * 原行程单号
       */
      originalItineraryCode?: string;
      /**
       * 出差人列表
       */
      accompanyList?: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
      /**
       * 开始时间
       */
      beginTime?: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag?: number;
      /**
       * 结束时间
       */
      endTime?: string;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag?: number;
      /**
       * 出差天数
       */
      travelDay?: number;
      /**
       * 出发地code
       */
      beginCityCode?: string;
      /**
       * 出发地名称
       */
      beginCityName?: string;
      /**
       * 目的地列表
       */
      endCityList?: {
        /**
         * 目的城市code
         */
        endCityCode: string;
        /**
         * 目的城市名称
         */
        endCityName: string;
      }[];
      /**
       * 行程冲突提示语
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: number;
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: number;
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: string;
              /**
               * 是否可以报销
               */
              canExpense?: boolean;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: string;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: boolean;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 金额
               */
              ruleAmount?: number;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 是否派车 0 否 1是
       */
      arrangeCar?: number;
      /**
       * 派车信息
       */
      arrangeCarRO?: {
        /**
         * 派车信息编号
         */
        arrangeCarCode?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 派车天数
         */
        arrangeCarDay?: number;
        /**
         * 乘车人
         */
        passengerList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 司机
         */
        drivers?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
      };
      /**
       * 住宿天数
       */
      accommodationDay?: number;
    }[];
    /**
     * 扩展信息
     */
    extendFieldDTO?: {
      /**
       * 差旅扩展字段
       */
      travelExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 是否派车：1-派车，2-不派车
         */
        arrangeCar?: string;
        /**
         * 派车天数
         */
        dayCount?: number;
        extra?: string;
        /**
         * 三方拓展字段
         */
        thirdExtend?: string;
        /**
         * 差旅报销方式
         */
        travelExpenseMethod?: '由申请单报销' | '凭票报销';
        /**
         * 工号
         */
        workNo?: string;
        /**
         * 是否项目出差
         */
        isProject?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 所属部门
         */
        depName?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 项目名称
         */
        projectName?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 项目负责人
         */
        projectHeader?: {
          key?: string;
          value?: string;
          label?: string;
        };
      };
      /**
       * 会议扩展字段（包含多收款人）
       */
      meetingExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 1 签掉表 2 签到表附件
         */
        signType?: number;
        /**
         * 签到表
         */
        signForm?: {
          signFormCode?: string;
          /**
           * 签到表名称
           */
          signFormName?: string;
          /**
           * 申请表状态
           * 0-未发布 1-已发布 2-已结束
           */
          formStatus?: number;
          /**
           * 申请表状态名称
           */
          formStatusName?: string;
          /**
           * 结束时间
           */
          endTime?: number;
        };
        /**
         * 1申请单携带 2 手动选择
         */
        isExpenseInit?: number;
        /**
         * 会议名称
         */
        meetingName: string;
        /**
         * 会议地点code
         */
        meetingCityCode?: string;
        /**
         * 会议地点名称
         */
        meetingCityName?: string;
        /**
         * 会议开始日期
         */
        meetingStartDate?: string;
        /**
         * 会议结束日期
         */
        meetingEndDate?: string;
        /**
         * 会议天数
         */
        meetingDayCount?: number;
        /**
         * 会议预计参会人数
         */
        meetingExpectAttendeeCount: number;
        /**
         * 会议实际参会人数
         */
        meetingRealAttendeeCount?: number;
        /**
         * 会议工作人员人数
         */
        meetingWorkerCount?: number;
        /**
         * 参会领导信息
         */
        meetingLeaderInfo?: string;
        /**
         * 会议议程
         */
        meetingAgenda?: string;
        /**
         * 是否纳入预算
         * 1-是，2-否
         */
        isIncludedBudget?: number;
        /**
         * 会议差异内容
         */
        meetingDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal?: number;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 详细地址信息
         */
        detailAddress?: string;
      };
      /**
       * 培训扩展字段（包含多收款人）
       */
      trainingExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 1 签掉表 2 签到表附件
         */
        signType?: number;
        /**
         * 签到表
         */
        signForm?: {
          signFormCode?: string;
          /**
           * 签到表名称
           */
          signFormName?: string;
          /**
           * 申请表状态
           * 0-未发布 1-已发布 2-已结束
           */
          formStatus?: number;
          /**
           * 申请表状态名称
           */
          formStatusName?: string;
          /**
           * 结束时间
           */
          endTime?: number;
        };
        /**
         * 1申请单携带 2 手动选择
         */
        isExpenseInit?: number;
        /**
         * 培训名称
         */
        trainingName?: string;
        /**
         * 培训地点code
         */
        trainingCityCode?: string;
        /**
         * 培训地点名称
         */
        trainingCityName?: string;
        /**
         * 培训开始日期
         */
        trainingStartDate?: string;
        /**
         * 培训结束日期
         */
        trainingEndDate?: string;
        /**
         * 培训天数
         */
        trainingDayCount?: number;
        /**
         * 培训预计参会人数
         */
        trainingExpectAttendeeCount?: number;
        /**
         * 培训实际参会人数
         */
        trainingRealAttendeeCount?: number;
        /**
         * 培训工作人员人数
         */
        trainingWorkerCount?: number;
        /**
         * 培训议程
         */
        trainingAgenda?: string;
        /**
         * 是否纳入预算
         * 1-是，2-否
         */
        isIncludedBudget?: number;
        /**
         * 培训差异内容
         */
        trainingDifferenceContent?: string;
        /**
         * 培训讲师信息
         */
        trainingTeacherInfo?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal?: number;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource?: number;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
        /**
         * 变更支付方式说明
         */
        changePayModeReason?: string;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 详细地址信息
         */
        detailAddress?: string;
      };
      /**
       * 采购扩展字段
       */
      procurementExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 采购内容
         */
        procurementContent?: string;
        /**
         * 采购差异内容
         */
        procurementDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 费用合计
         */
        applyAmount?: number;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
      };
      /**
       * 公务接待
       */
      receptionExtendFields?: {
        /**
         * 来访单位
         */
        visitOrgName: string;
        /**
         * 是否同城（宁波场景不需要）
         * 1-是，2-否
         */
        isSameCity?: number;
        /**
         * 来访人员职务
         */
        visitorDuty?: string;
        /**
         * 来访事由
         */
        visitReason: string;
        /**
         * 来访开始日期
         */
        visitStartDate: string;
        /**
         * 来访结束日期
         */
        visitEndDate: string;
        /**
         * 来访人员级别：1-省部级、2-厅局级、99-其他
         */
        visitorLevel: number;
        /**
         * 来访人员级别名称
         */
        visitorLevelName?: string;
        /**
         * 来访人数
         */
        visitorCount: number;
        /**
         * 主宾姓名
         */
        mainGuest?: string;
        /**
         * 接待地点code
         */
        receptionCityCode: string;
        /**
         * 接待地点名称
         */
        receptionCityName: string;
        /**
         * 接待详细地点
         */
        receptionDetailAddress?: string;
        /**
         * 就餐日期
         */
        mealDate: string;
        /**
         * 工作餐形式：1-自助餐、2-桌餐
         */
        mealType: 1 | 2 | 3;
        /**
         * 工作餐形式
         */
        mealTypeName?: string;
        /**
         * 用餐时间：1-早餐，2-中餐，3-晚餐
         */
        mealTimeType?: 1 | 2 | 3;
        /**
         * 用餐时间
         */
        mealTimeTypeName?: string;
        /**
         * 陪餐人数（宁波场景不需要）
         */
        escortCount?: number;
        /**
         * 配餐人员姓名
         */
        escortPerson?: string;
        /**
         * 接待预算金额
         */
        receptionBudgetAmount?: number;
        /**
         * 来访人员信息
         */
        visitorInformation?: {
          /**
           * 访问人员名称
           */
          visitorName?: string;
          /**
           * 访问人员职级
           */
          visitorLevel?: number;
          /**
           * 访问人员职级名称
           */
          visitorLevelName?: string;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
        }[];
        /**
         * 接待人员信息
         */
        receptionistInformation?: {
          /**
           * 接待人员名称
           */
          receptionistName?: string;
          /**
           * 接待人员职级
           */
          receptionistLevel?: number;
          /**
           * 接待人员职级名称
           */
          receptionistLevelName?: string;
        }[];
      };
      /**
       * 一般事项
       */
      generalExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 事项详细内容
         */
        detailContent: string;
        /**
         * 事项预算
         */
        eventBudget?: number;
        /**
         * 事项详细内容与事前审批的差异
         */
        generalDifferenceContent?: string;
        extra?: string;
      };
      /**
       * 用印申请
       */
      contractExtendFields?: {
        /**
         * 合同编号
         */
        uniqueCode?: string;
      };
      /**
       * 招标书
       */
      tenderApplyExtendFields?: {
        /**
         * 申请单类型
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请事由
         */
        applyReason?: string;
        /**
         * 申请单Code
         */
        applyFormCode?: string;
        /**
         * 业务单据号
         */
        businessCode?: string;
        /**
         * 提交时间
         */
        submitTime?: string;
      };
      /**
       * 通用采购申请拓展字段
       */
      purchaseGeneralFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm?: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * isCreatePurchaseProposal
         * 采购类型
         * 1-政府采购，2-非政府采购
         */
        purchaseType?: 1 | 2;
        /**
         * 采购类型描述
         */
        purchaseTypeDesc?: string;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource?: 1 | 2;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
      };
      /**
       * 政府购买服务申请拓展字段
       */
      govermentApplyFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * 采购类型
         * 1-政府采购，2-非政府采购
         */
        purchaseType: 1 | 2;
        /**
         * 采购类型描述
         */
        purchaseTypeDesc?: string;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource: 1 | 2;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
      };
      /**
       * 办公家具购置申请拓展字段
       */
      furnitureApplyFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
      };
      /**
       * 全链路二期 报销的统一拓展字段
       */
      purchaseGeneralExpenseFieldDTO?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 交易方式：线上；线下
         */
        tradeWay?: string[];
        /**
         * 采购差异内容
         */
        procurementDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 交易方式
         */
        tradeWayName?: string;
        /**
         * 是否有合同
         */
        addContract?: boolean;
      };
      /**
       * 公共事业缴费统一拓展字段
       */
      publicBusinessPaymentFieldDTO?: {
        /**
         * 备注
         */
        remark?: string;
      };
      /**
       * 无相拓展
       */
      generalExtra?: string;
    };
    /**
     * 申请时间
     */
    initiationDate?: string;
    /**
     * 申请时间
     */
    initiationTime?: string;
    /**
     * 申请单状态
     * 1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
     */
    formStatus?: number;
    /**
     * 用户角色
     * 1：本人 2：审核人 3：审批人
     */
    userRole?: number;
    /**
     * 是否是行程参与人
     * true：是本人，false：不是本人
     */
    isAccompany?: boolean;
    /**
     * 是否是接收人
     * true：是本人，false：不是本人
     */
    isReceiver?: boolean;
    /**
     * 是否是本人
     * true：是本人，false：不是本人
     */
    isHimself?: boolean;
    /**
     * 是否是可撤回状态
     * true：可撤回，false：不可撤回
     */
    withdrawn?: boolean;
    /**
     * 是否可审批
     * true：可以，false：不可以
     */
    approvalAuth?: boolean;
    /**
     * 工作流审核人id集合，包含已审核和未审核操作人列表
     */
    workflowAuditorIds?: number[];
    /**
     * 转交历史
     */
    accompanyHistoryList?: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 附件列表
     */
    formAttachmentDTO?: {
      /**
       * 默认附件列表
       */
      normalAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 说明附件列表
       */
      thatAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 通知附件列表
       */
      informAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 合同附件列表
       */
      compactAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 签到附件列表
       */
      signAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 派出单位公函附件列表
       */
      officialLetterAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 接待清单附件列表
       */
      receptionMenuAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 采购意向附件列表
       */
      purchasePurposeAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 资产更新计划
       */
      propertyUpdatePlanAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 集体决策会议纪要
       */
      meetingSummaryAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 专家论证意见
       */
      argumentSuggestionAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 专项、会议、培训附件列表
       */
      specialAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 银行回单附件
       */
      bankReceiptAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 账单附件
       */
      billAttachmentFileList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
    };
    /**
     * 简报列表
     */
    briefReportList?: {
      /**
       * 简报状态
       */
      briefStatus?: number;
      /**
       * 简报文字
       */
      briefReport?: string;
      /**
       * 简报原因
       */
      briefReason?: string;
      /**
       * 定位锚点
       */
      position?: 1 | 2 | 3;
    }[];
    /**
     * 表单费用列表
     */
    feeRecordDTOS?: {
      /**
       * 费用编码
       */
      feeCode?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 费用类型编码：1001-住宿，1002-午休，2001-火车，2002-飞机，2003-轮船，2004-短途包干，2005-退票/改签，3001-伙食费，4001-公杂费，5001-其他费用，9999-总费用
       */
      feeType?:
        | 1001
        | 1002
        | 2001
        | 2002
        | 2003
        | 2004
        | 2005
        | 2006
        | 2007
        | 2008
        | 2009
        | 3001
        | 300101
        | 3002
        | 4001
        | 5001
        | 5000
        | 5002
        | 5003
        | 5004
        | 5005
        | 5006
        | 5007
        | 5008
        | 5009
        | 5010
        | 5011
        | 5012
        | 6000
        | 6001
        | 6002
        | 6003
        | 7000
        | 7001
        | 7002
        | 7003
        | 7004
        | 7005
        | 8888
        | 8001
        | 8002
        | 8003
        | 9999;
      /**
       * 费用大类
       */
      parentFeeType?:
        | 10
        | 10
        | 20
        | 20
        | 20
        | 20
        | 20
        | 20
        | 20
        | 20
        | 20
        | 30
        | 30
        | 30
        | 40
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 60
        | 60
        | 60
        | 60
        | 70
        | 70
        | 70
        | 70
        | 70
        | 70
        | 88
        | 80
        | 80
        | 80
        | 99;
      /**
       * 调整金额
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 有无调整历史
       * true-有，false-无
       */
      haveFeeAdjustHistory?: boolean;
      /**
       * 是否超标：true-是，false-否
       */
      isExcessive?: boolean;
    }[];
    /**
     * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
     */
    processStatus?: string;
    /**
     * 数据来源
     */
    dataSource?: number;
    /**
     * 驳回原因
     */
    rejectReason?: string;
    /**
     * 商品信息 for 办公用品采购、通用采购、政府购买服务、办公设备家具购置
     */
    commodityList?: {
      /**
       * 唯一编码
       */
      uniqueCode?: string;
      /**
       * 商品编号
       */
      commodityCode?: string;
      /**
       * 商品名称
       */
      commodityName?: string;
      /**
       * 供应商ID
       */
      supplierId?: number;
      /**
       * 供应商名称
       */
      supplierName?: string;
      /**
       * 规则描述
       */
      specification?: string;
      /**
       * 单价（分）
       */
      unitPrice?: number;
      /**
       * 小记（分）
       */
      totalPrice?: number;
      /**
       * 数量
       */
      amount?: number;
      /**
       * 商品数据来源：0-浙里报 1-政采云
       */
      commoditySource?: number;
      /**
       * 拓展字段
       */
      extendDataDTO?: {
        /**
         * 实例名称
         */
        instanceName?: string;
        /**
         * 品牌
         */
        brandName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 商品详情页url
         */
        detailPageUrl?: string;
        /**
         * 所有服务商品单价和
         */
        serviceTotalPrice?: number;
        /**
         * 服务单价和
         */
        sumServiceTotalPrice?: number;
        /**
         * 计量单位
         */
        unit?: string;
        /**
         * 是否进口：1是、0否
         */
        isImport?: number;
        /**
         * 是否适宜中小企业：1是、0否
         */
        isSuit?: number;
        /**
         * 不适宜中小企业理由
         */
        noSuitReason?: string;
        /**
         * 采购目录code（选择的）
         */
        catalogCodeList?: string[];
        /**
         * First catalogCodeList
         */
        category?: string;
        /**
         * 采购目录name（选择的）
         */
        catalogNameList?: string[];
        /**
         * 政府购买服务目录code（选择的）
         */
        serviceCodeList?: string[];
        /**
         * 政府购买服务目录name（选择的）
         */
        serviceNameList?: string[];
        /**
         * 采购目录信息(从购物车取的数据)
         */
        catalogList?: {
          /**
           * 采购目录编码
           */
          catalogCode?: string;
          /**
           * 采购目录名称
           */
          catalogName?: string;
        }[];
        /**
         * 商品属性信息
         */
        attributeList?: {
          /**
           * 属性名称
           */
          attributeName?: string;
          /**
           * 属性值
           */
          attributeValue?: string;
        }[];
        /**
         * 商品服务项信息
         */
        standards?: {
          /**
           * 服务商品ID
           */
          standardId?: number;
          /**
           * 服务名称
           */
          standardName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 服务价格
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 商品服务信息
         */
        services?: {
          /**
           * 服务名称
           */
          serviceName?: string;
          /**
           * 服务属性
           */
          serviceAttribute?: string;
          /**
           * 服务id
           */
          serviceId?: number;
          /**
           * 单价
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
          /**
           * 数量 随着商品增加
           */
          amount?: number;
        }[];
        /**
         * 选配信息
         */
        news?: {
          /**
           * 购物车配件主键 id
           */
          newsId?: number;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 品牌名称
           */
          newsName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 配件单价，单位：分
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 使用人信息
         */
        userInfo?: {
          /**
           * 职级
           * 1-厅级 2-处级 3-处级以下
           */
          userRank: 1 | 2 | 3;
          /**
           * 职级描述
           */
          userRankDesc?: string;
          /**
           * 使用人姓名
           */
          userName: string;
        };
        /**
         * 资产类型
         * 1-办公家具 2-办公设备
         */
        propertyType?: string;
        /**
         * 资产类型描述
         */
        propertyTypeDesc?: string;
        /**
         * 资产品目
         */
        propertyItem?: string;
        /**
         * 资产品目类型
         */
        propertyItemDesc?: string;
        /**
         * 商品类目
         */
        itemCatalogName?: string;
        /**
         * 会议桌容纳人数
         */
        userCount?: number;
        /**
         * 政采云商品链接，用户填写，自动解析出商品数据
         */
        zcyUrl?: string;
        /**
         * 是否国产，资产类别为办公设备时可填，如果为是，不进行费控  1是、0否
         */
        domestic?: number;
        /**
         * 商品主图
         */
        mainImage?: string;
      };
      /**
       * 外部sku
       */
      skuCode?: number;
      /**
       * 商品附件
       */
      attachmentList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      }[];
    }[];
    /**
     * 是否关联订单
     */
    isUnitOrder?: boolean;
    /**
     * 订单列表 采购6大场景
     */
    orderList?: {
      /**
       * 订单ID
       */
      orderId?: number;
      /**
       * 订单号
       */
      orderCode?: string;
      /**
       * 实际支付金额
       */
      realPrice?: number;
      /**
       * 订单类别名称
       */
      orderCategoryDesc?: string;
      /**
       * 支付方式
       */
      paymentMethod?: 0 | 1 | 2 | 3 | 4;
      /**
       * 支付方式名称
       */
      paymentMethodDesc?: string;
      /**
       * 收货人
       */
      receiver?: string;
      /**
       * 供应名称
       */
      supplierName?: string;
      /**
       * 供应商ID
       */
      supplierId?: number;
      /**
       * 订单状态
       */
      orderStatus?: number;
      /**
       * 订单状态名称
       */
      orderStatusDesc?: string;
      /**
       * 下单时间
       */
      orderTime?: string;
      /**
       * 是否关联申请单
       */
      unitApplyFormCode?: boolean;
      /**
       * 申请单编号
       */
      applyFormCode?: string;
      /**
       * 申请单业务编号
       */
      applyFormBusinessCode?: string;
      /**
       * 申请单类型
       * 2-会议申请；3-培训申请；4-采购申请
       */
      applyFormType?: number;
      /**
       * 是否关联报销单
       */
      unitExpenseFormCode?: boolean;
      expenseFromList?: {
        /**
         * 报销单编号
         */
        expenseFormCode?: string;
        /**
         * 报销单业务编号
         */
        expenseFormBusinessCode?: string;
        /**
         * 报销单类型
         * 2-会议申请；3-培训申请；4-采购申请
         */
        expenseFormType?: number;
      }[];
      /**
       * 是否必须关联申请单
       */
      necessaryUnitApplyForm?: boolean;
      /**
       * 操作
       */
      operateButton?: {
        /**
         * 订单详情
         */
        detail?: boolean;
        /**
         * 关联申请单
         */
        unitApplyForm?: boolean;
        /**
         * 取消关联申请单
         */
        undoApplyForm?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 是否可选
         * 报销单类型与订单关联的申请单类型判断是否可选
         */
        checkbox?: boolean;
      };
      /**
       * operatorId(个人账号或授权账号)
       */
      operatorId?: number;
      /**
       * 查询类别 1-我的账号 2-授权给我的账号
       */
      queryOperatorType?: number;
      /**
       * 订单剩余可报销金额
       */
      orderRemainingAmount?: number;
      /**
       * 已报销金额记录
       */
      expenseAmountRecordDTOS?: {
        /**
         * 报销单businessCode
         */
        businessCode?: string;
        /**
         * 报销金额记录
         */
        expenseAmountRecord?: number;
      }[];
    }[];
    /**
     * 申请金额
     */
    applyAmount?: number;
    /**
     * 剩余金额
     */
    applyRemainingAmount?: number;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 是否包含外部人员
     * true：可撤回，false：不可撤回
     */
    isIncludeOuter?: boolean;
    /**
     * 后补原因
     */
    replenishReason?: string;
    /**
     * 报销单信息
     */
    expenseFormList?: {
      /**
       * 报销单号
       */
      expenseFormCode?: string;
      /**
       * 报销单号
       */
      businessCode?: string;
      /**
       * 报销单类型
       */
      expenseFormType?: number;
      /**
       * 报销单类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 报销缘由
       */
      expenseReason?: string;
      /**
       * 创建人姓名
       */
      operatorName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentId?: number;
      /**
       * 机构ID
       */
      orgId?: number;
      /**
       * 机构名字
       */
      orgName?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 报销单状态
       */
      expenseFormStatus?: number;
      /**
       * 报销单状态
       */
      expenseFormStatusDesc?: string;
      /**
       * 报销金额
       */
      expenseAmount?: number;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 业务类型名称
       */
      businessTypeName?: string;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
       */
      processStatus?: string;
      /**
       * 用户类别
       * 1-本人 2-审核人 3-审批人 4-同行人
       */
      userRole?: number;
      /**
       * 是否百搭单据
       */
      isBaidaForm?: boolean;
      /**
       * 审批人名称
       */
      approvedNames?: string[];
      /**
       * 报销单关联申请单基本信息
       */
      relationApplyInfoROList?: {
        /**
         * 申请单业务单据号
         */
        applyBusinessNo?: string;
        /**
         * 申请单编号
         */
        applyFormCode?: string;
        /**
         * 申请单单据类型编号
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请人姓名
         */
        applyUserName?: string;
        /**
         * 发起时间
         */
        initiationTime?: string;
      }[];
    }[];
    operateButton?: {
      /**
       * 删除
       */
      remove?: boolean;
      /**
       * 作废
       */
      discard?: boolean;
      /**
       * 撤回
       */
      withdrawn?: boolean;
      /**
       * 加签
       */
      signature?: boolean;
      /**
       * 通过
       */
      pass?: boolean;
      /**
       * 重新发起
       */
      restart?: boolean;
      /**
       * 驳回
       */
      reject?: boolean;
      /**
       * 打印
       */
      print?: boolean;
      /**
       * 转交
       */
      transfer?: boolean;
      comment?: boolean;
      needExpense?: boolean;
    };
    /**
     * 身份信息
     */
    identity?: string;
    /**
     * 是否是百搭
     */
    isBaidaForm?: boolean;
    /**
     * 会议培训申请单校验结果
     */
    applyCheckResultROList?: {
      /**
       * 费控状态
       */
      feeCheckStatus?: number;
      /**
       * 提示语
       */
      applyFeeCheckResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: number;
        /**
         * 提示信息
         */
        msg?: string;
        /**
         * 费控标准提示信息
         */
        rule?: string;
      }[];
      /**
       * 分组code
       */
      groupCode?: string;
      /**
       * 费用父级code
       */
      feeParentType?: number;
      /**
       * 费用父级描述
       */
      feeParentTypeDesc?: string;
    }[];
    /**
     * 工作计划列表
     */
    workPlanList?: {
      /**
       * 标题
       */
      title?: string;
      /**
       * 工作计划code
       */
      workPlanCode?: string;
      /**
       * 缘由
       */
      reason?: string;
      /**
       * 工作计划编号
       */
      businessCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
    }[];
    /**
     * 预算项目
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 占用金额
       */
      amount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 操作人，后端使用
       */
      operatorId?: number;
      /**
       * 科目uk 级联
       */
      subjectUkHierarchy?: string[];
      /**
       * 科目名称级联
       */
      subjectNameHierarchy?: string[];
    }[];
    workflowInfo?: {
      workflowProcessKey?: string;
      workflowModelId?: number;
      workflowVersion?: number;
      auditNodeList?: {
        auditOperatorList?: {
          operatorId?: number;
          operatorName?: string;
          institutionId?: number;
          institutionName?: string;
          auditRemark?: string;
          auditStatus?: number;
          auditTime?: string;
          signAttachment?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          oneselfHistorySignAttachment?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          addAuditWay?: number;
          addAuditOperator?: string;
          comment?: {
            commentContent?: string;
            operatorId?: number;
            operatorName?: string;
            commentCode?: string;
            commentTime?: number;
            pictureAttachments?: {
              fileId?: string;
              type?: string;
              bizNo?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            otherAttachments?: {
              fileId?: string;
              type?: string;
              bizNo?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            remove?: boolean;
          };
          operatorType?: number;
        }[];
        userRangeType?: number;
        userRangeTypeNew?: number;
        userRangeValues?: string[];
        userRangeValuesNew?: string[];
        personCount?: number;
        auditStatus?: number;
        auditTime?: string;
        auditDesc?: string;
        auditType?: number;
        eventType?: number;
        nodeType?: number;
        nodeKey?: string;
        nodeName?: string;
        checkStrategy?: number;
        departmentId?: number;
        institutionSelfDtos?: {
          code?: string;
          name?: string;
          userType?: string;
          tenantCode?: string;
          tenantName?: string;
          uniqueKey?: string;
          parentInstitution?: {
            parentCode?: number;
            parentName?: string;
          };
        }[];
        commonAuditorList?: {
          displayName?: string;
          userId?: number;
          operatorId?: number;
          code?: string;
          gender?: number;
          institutionId?: number;
          institution?: {
            id?: number;
            createdAt?: number;
            updatedAt?: number;
            creatorId?: string;
            modifierId?: string;
            extFields?: string;
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string;
            tags?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            divisionCode?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
          };
          deptName?: string;
        }[];
        bizProperty?: string;
        comment?: {
          commentContent?: string;
          operatorId?: number;
          operatorName?: string;
          commentCode?: string;
          commentTime?: number;
          pictureAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          otherAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          remove?: boolean;
        };
      }[];
      applyOperatorId?: number;
      applyOperatorName?: string;
      applyTime?: string;
      applyRemark?: string;
      isAddTaskAccess?: number;
      isEnableSign?: boolean;
      signConfig?: number;
      availableRejectNodeList?: {
        nodeName?: string;
        nodeKey?: string;
        operatorNames?: string[];
      }[];
      currentBizProperty?: string;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/245144) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/query`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/query',
    'data',
    string,
    'formCode' | 'identity' | 'needAuth' | 'desensitize',
    false
  >
>;

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/245144) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/query`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormQueryGetRequestConfig: ZlbApiExpenseApplyFormQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/query',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ['formCode', 'identity', 'needAuth', 'desensitize'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/245144) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/query`
 * @更新时间 `2024-08-19 14:39:09`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormQueryGetResponse>(
    prepare(zlbApiExpenseApplyFormQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormQueryGet.requestConfig = zlbApiExpenseApplyFormQueryGetRequestConfig;

/**
 * 接口 [modifyExpenseFormStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/251042) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/modifyStatus`
 * @更新时间 `2022-05-18 14:57:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormModifyStatusPostRequest {
  formCode: string;
}

/**
 * 接口 [modifyExpenseFormStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/251042) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/modifyStatus`
 * @更新时间 `2022-05-18 14:57:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormModifyStatusPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [modifyExpenseFormStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/251042) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/modifyStatus`
 * @更新时间 `2022-05-18 14:57:05`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormModifyStatusPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/modifyStatus',
    'data',
    string,
    'formCode',
    false
  >
>;

/**
 * 接口 [modifyExpenseFormStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/251042) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/modifyStatus`
 * @更新时间 `2022-05-18 14:57:05`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormModifyStatusPostRequestConfig: ZlbApiExpenseApplyFormModifyStatusPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/modifyStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ['formCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormModifyStatusPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [modifyExpenseFormStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/251042) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/modifyStatus`
 * @更新时间 `2022-05-18 14:57:05`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormModifyStatusPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormModifyStatusPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormModifyStatusPostResponse>(
    prepare(zlbApiExpenseApplyFormModifyStatusPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormModifyStatusPost.requestConfig =
  zlbApiExpenseApplyFormModifyStatusPostRequestConfig;

/**
 * 接口 [常用出发地、常用目的地↗](http://yapi.cai-inc.com/project/3621/interface/api/285514) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/common-place`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormCommonPlaceGetRequest {
  /**
   * ：1-出发地；2-目的地
   */
  cityType?: string;
  /**
   * 单据类型 1-差旅 2-会议 3-培训 @see ExpenseFormTypeEnum
   */
  formType?: string;
}

/**
 * 接口 [常用出发地、常用目的地↗](http://yapi.cai-inc.com/project/3621/interface/api/285514) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/common-place`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormCommonPlaceGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 出发地code
     */
    cityCode?: string;
    /**
     * 出发地名称
     */
    cityName?: string[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [常用出发地、常用目的地↗](http://yapi.cai-inc.com/project/3621/interface/api/285514) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/common-place`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormCommonPlaceGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/common-place',
    'data',
    string,
    'cityType' | 'formType',
    false
  >
>;

/**
 * 接口 [常用出发地、常用目的地↗](http://yapi.cai-inc.com/project/3621/interface/api/285514) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/common-place`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormCommonPlaceGetRequestConfig: ZlbApiExpenseApplyFormCommonPlaceGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/common-place',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ['cityType', 'formType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormCommonPlaceGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [常用出发地、常用目的地↗](http://yapi.cai-inc.com/project/3621/interface/api/285514) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/common-place`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormCommonPlaceGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormCommonPlaceGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormCommonPlaceGetResponse>(
    prepare(zlbApiExpenseApplyFormCommonPlaceGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormCommonPlaceGet.requestConfig =
  zlbApiExpenseApplyFormCommonPlaceGetRequestConfig;

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/291570) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/default-info`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormDefaultInfoGetRequest {
  /**
   * 业务场景 1-报销 2-工资 3-批量发放
   */
  bizType?: string;
  /**
   * 1-差旅，2-会议，3-培训，4-办公用品采购,6-公务接待申请,7-一般事项申请,
   *                       9-通用采购；10-政府购买服务；11-办公设备家具购置,
   *                       1-工资发放
   *                       1-批量发放
   */
  formBizType?: string;
  /**
   * 报销单关联审第一个申请单的code，如果传了，说明是报销单
   */
  applyFormCode?: string;
}

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/291570) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/default-info`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormDefaultInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 工作单位id
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 经办人电话
     */
    operatorMobile?: string;
    /**
     * 所在部门列表
     */
    departmentList?: {
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 父级部门ID
       */
      parentDeptId?: number;
      /**
       * 父级部门名称
       */
      parentDeptName?: string;
    }[];
    /**
     * 单位部门树
     */
    departmentTree?: {
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 父级部门ID
       */
      parentDeptId?: number;
      /**
       * 父级部门名称
       */
      parentDeptName?: string;
      /**
       * 是否可选
       */
      available?: boolean;
      children?: {
        /**
         * 部门ID
         */
        deptId?: number;
        /**
         * 部门名称
         */
        deptName?: string;
        /**
         * 父级部门ID
         */
        parentDeptId?: number;
        /**
         * 父级部门名称
         */
        parentDeptName?: string;
        /**
         * 是否可选
         */
        available?: boolean;
        children?: {}[];
      }[];
    };
    /**
     * 是否展示单位部门树
     */
    treeFlag?: boolean;
    /**
     * 默认选中的部门
     */
    deptId?: number;
    /**
     * 部门名字
     */
    deptName?: string;
    /**
     * 默认城市code
     */
    cityCode?: string;
    /**
     * 默认城市name
     */
    cityName?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/291570) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/default-info`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormDefaultInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/default-info',
    'data',
    string,
    'bizType' | 'formBizType' | 'applyFormCode',
    false
  >
>;

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/291570) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/default-info`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormDefaultInfoGetRequestConfig: ZlbApiExpenseApplyFormDefaultInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/default-info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ['bizType', 'formBizType', 'applyFormCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormDefaultInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单据默认信息查询↗](http://yapi.cai-inc.com/project/3621/interface/api/291570) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/default-info`
 * @更新时间 `2024-08-19 14:39:05`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormDefaultInfoGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormDefaultInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormDefaultInfoGetResponse>(
    prepare(zlbApiExpenseApplyFormDefaultInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormDefaultInfoGet.requestConfig =
  zlbApiExpenseApplyFormDefaultInfoGetRequestConfig;

/**
 * 接口 [查询外部申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/298842) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/page`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormOutPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 外部申请单号
   */
  outFormCode?: string;
  /**
   * 发起人名称
   */
  accountName?: string;
  /**
   * 数据来源
   */
  dataSource?: string;
  /**
   * 提交开始时间
   */
  startSubmitTime?: string;
  /**
   * 提交结束时间
   */
  endSubmitTime?: string;
  /**
   * 业务类型：1-差旅申请
   */
  formType?: number;
  /**
   * 处理状态：0-待处理，1-已处理
   */
  dealStatus?: number;
}

/**
 * 接口 [查询外部申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/298842) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/page`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormOutPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 申请单编码
       */
      applyFormCode?: string;
      /**
       * 单据类型
       */
      formType?: number;
      /**
       * 单据类型描述
       */
      formTypeDesc?: string;
      /**
       * 外部单据编码
       */
      outFormCode?: string;
      /**
       * 申请事由
       */
      applyReason?: string;
      /**
       * 发起人id
       */
      operatorId?: number;
      /**
       * 浙政钉id
       */
      accountId?: string;
      /**
       * 发起人名
       */
      accountName?: string;
      /**
       * 部门id
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 发起时间
       */
      submitTime?: string;
      /**
       * 处理状态（0-未处理，1-已处理）
       */
      dealStatus?: number;
      /**
       * 处理状态描述
       */
      dealStatusDesc?: string;
      /**
       * 处理人名称
       */
      dealOperatorName?: string;
      /**
       * 处理人id
       */
      dealOperatorId?: number;
      /**
       * 处理时间
       */
      dealTime?: string;
      /**
       * 记录类型：1-未完成单据，2-已完成单据
       */
      recordType?: number;
      /**
       * 数据来源
       */
      dataSource?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询外部申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/298842) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/page`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormOutPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/out/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询外部申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/298842) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/page`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormOutPagePostRequestConfig: ZlbApiExpenseApplyFormOutPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/out/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormOutPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询外部申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/298842) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/page`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormOutPagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormOutPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormOutPagePostResponse>(
    prepare(zlbApiExpenseApplyFormOutPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormOutPagePost.requestConfig = zlbApiExpenseApplyFormOutPagePostRequestConfig;

/**
 * 接口 [根据浙政钉id查询用户机构信息↗](http://yapi.cai-inc.com/project/3621/interface/api/298858) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/zzd-org/query`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormZzdOrgQueryGetRequest {
  accountId: string;
}

/**
 * 接口 [根据浙政钉id查询用户机构信息↗](http://yapi.cai-inc.com/project/3621/interface/api/298858) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/zzd-org/query`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormZzdOrgQueryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 机构id
     */
    orgId?: number;
    /**
     * 机构名称
     */
    orgName?: string;
    /**
     * 部门列表
     */
    deptList?: {
      /**
       * 部门id
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
    }[];
    /**
     * 浙政钉id
     */
    accountId?: string;
    /**
     * 操作人名称
     */
    operatorName?: string;
    /**
     * 操作人id
     */
    operatorId?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据浙政钉id查询用户机构信息↗](http://yapi.cai-inc.com/project/3621/interface/api/298858) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/zzd-org/query`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormZzdOrgQueryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/zzd-org/query',
    'data',
    string,
    'accountId',
    false
  >
>;

/**
 * 接口 [根据浙政钉id查询用户机构信息↗](http://yapi.cai-inc.com/project/3621/interface/api/298858) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/zzd-org/query`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormZzdOrgQueryGetRequestConfig: ZlbApiExpenseApplyFormZzdOrgQueryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/zzd-org/query',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ['accountId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormZzdOrgQueryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据浙政钉id查询用户机构信息↗](http://yapi.cai-inc.com/project/3621/interface/api/298858) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/zzd-org/query`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormZzdOrgQueryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormZzdOrgQueryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormZzdOrgQueryGetResponse>(
    prepare(zlbApiExpenseApplyFormZzdOrgQueryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormZzdOrgQueryGet.requestConfig =
  zlbApiExpenseApplyFormZzdOrgQueryGetRequestConfig;

/**
 * 接口 [外部申请单机构设置↗](http://yapi.cai-inc.com/project/3621/interface/api/298890) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/org/set`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormOutOrgSetPostRequest {
  /**
   * 申请单code
   */
  applyFormCode: string;
  /**
   * 消息类型：1-提交；2-同步
   */
  recordType: number;
  /**
   * 机构id
   */
  orgId: number;
  /**
   * 机构名称
   */
  orgName: string;
  /**
   * 操作人id
   */
  operatorId: number;
  /**
   * 操作人名称
   */
  operatorName: string;
  /**
   * 部门id
   */
  deptId: number;
  /**
   * 部门名称
   */
  deptName: string;
}

/**
 * 接口 [外部申请单机构设置↗](http://yapi.cai-inc.com/project/3621/interface/api/298890) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/org/set`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormOutOrgSetPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [外部申请单机构设置↗](http://yapi.cai-inc.com/project/3621/interface/api/298890) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/org/set`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormOutOrgSetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/out/org/set',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [外部申请单机构设置↗](http://yapi.cai-inc.com/project/3621/interface/api/298890) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/org/set`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormOutOrgSetPostRequestConfig: ZlbApiExpenseApplyFormOutOrgSetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/out/org/set',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormOutOrgSetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [外部申请单机构设置↗](http://yapi.cai-inc.com/project/3621/interface/api/298890) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/out/org/set`
 * @更新时间 `2024-08-19 14:39:10`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormOutOrgSetPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormOutOrgSetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormOutOrgSetPostResponse>(
    prepare(zlbApiExpenseApplyFormOutOrgSetPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormOutOrgSetPost.requestConfig =
  zlbApiExpenseApplyFormOutOrgSetPostRequestConfig;

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/3621/interface/api/460954) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/audit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormAuditPostRequest {
  /**
   * TODO 业务入参....
   */
  applyFormCode?: string;
  /**
   * 数据大屏需要
   */
  businessNo?: string;
  /**
   * 费用修改入参
   */
  modifyFeeInfo?: {
    /**
     * 批量修改历史记录
     */
    modifyFeeAmountPOList: {
      /**
       * 费用code
       */
      feeCode: string;
      /**
       * 原始金额
       */
      originalAmount?: number;
      /**
       * 修改后金额
       */
      updateAmount?: number;
      /**
       * 修改备注
       */
      remark?: string;
    }[];
  };
  /**
   * 工作流
   */
  workflowInfo?: {
    bizId?: string;
    bizType?: string;
    subType?: string;
    auditRemark?: string;
    executeType: number;
    processDefineKey?: string;
    currentNodeKey: string;
    operatorId?: number;
    context?: string;
    eventType: number;
    rejectNodeKey?: string;
    signAttachment?: {
      fileId?: string;
      type?: string;
      bizNo?: string;
      name?: string;
      size?: number;
      bizCode?: string;
      url?: string;
      sizeDesc?: string;
    };
  };
  /**
   * 预算填报记录编号
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
    /**
     * 科目uk 级联
     */
    subjectUkHierarchy?: string[];
    /**
     * 科目名称级联
     */
    subjectNameHierarchy?: string[];
  }[];
}

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/3621/interface/api/460954) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/audit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验是否成功
     */
    isSuccess?: boolean;
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 报销单预算项目校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 科目校验描述
         */
        subjectCheckDesc?: string;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/3621/interface/api/460954) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/audit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/3621/interface/api/460954) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/audit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormAuditPostRequestConfig: ZlbApiExpenseApplyFormAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/3621/interface/api/460954) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/audit`
 * @更新时间 `2024-08-19 14:39:07`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormAuditPostResponse>(
    prepare(zlbApiExpenseApplyFormAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormAuditPost.requestConfig = zlbApiExpenseApplyFormAuditPostRequestConfig;

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/482346) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/institution/query-cashier`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormInstitutionQueryCashierGetRequest {
  /**
   * 申请单code
   */
  formCode?: string;
  identity: string;
  /**
   * 是否脱敏：0-不脱敏，1-脱敏
   */
  desensitize: string;
}

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/482346) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/institution/query-cashier`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormInstitutionQueryCashierGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申请单编号
     */
    applyFormCode?: string;
    /**
     * 业务单据号
     */
    businessCode?: string;
    /**
     * 报销单类型编号
     */
    businessType?:
      | 1
      | 2
      | 19
      | 20
      | 28
      | 4
      | 5
      | 6
      | 27
      | 31
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 21
      | 22
      | 23
      | 24
      | 25
      | 26
      | 32
      | 29
      | 30
      | 33;
    /**
     * 报销单类型编号名称
     */
    businessTypeName?:
      | '普通出差'
      | '专项会议培训'
      | '外派'
      | '外出'
      | '外出培训'
      | '一类会议'
      | '二类会议'
      | '三类会议'
      | '其他会议'
      | '线上会议'
      | '一类培训'
      | '二类培训'
      | '集中采购'
      | '分散采购'
      | '办公用品采购'
      | '用印申请'
      | '公务接待'
      | '一般事项'
      | '招标书申请'
      | '通用采购'
      | '政府购买服务'
      | '办公设备家具购置'
      | '公共事业缴费'
      | '办公用品'
      | '政府服务购买'
      | '个人账户'
      | '企业账户'
      | '投资支付';
    /**
     * 单据类型编号
     */
    applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
    /**
     * 单据类型名称
     */
    applyFormTypeName?:
      | '差旅申请'
      | '会议申请'
      | '培训申请'
      | '办公用品采购申请'
      | '用印申请'
      | '公务接待申请'
      | '一般事项申请'
      | '招标书申请'
      | '通用采购申请'
      | '政府购买服务申请'
      | '办公设备家具购置申请'
      | '公共事业缴费申请';
    /**
     * 是否已经关联报销单
     * true-关联，false-未关联
     */
    isAssociate?: boolean;
    /**
     * 申请人
     */
    applyUserName?: string;
    /**
     * 申请人operatorId
     */
    applyOperatorId?: number;
    /**
     * 工作单位ID
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 工作部门ID
     */
    deptId?: number;
    /**
     * 工作部门名称
     */
    deptName?: string;
    /**
     * 申请事由
     */
    applyReason?: string;
    /**
     * 行程信息列表
     */
    itineraryList?: {
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 行程信息编号
       */
      itineraryCode?: string;
      /**
       * 原行程单号
       */
      originalItineraryCode?: string;
      /**
       * 出差人列表
       */
      accompanyList?: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
      /**
       * 开始时间
       */
      beginTime?: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag?: number;
      /**
       * 结束时间
       */
      endTime?: string;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag?: number;
      /**
       * 出差天数
       */
      travelDay?: number;
      /**
       * 出发地code
       */
      beginCityCode?: string;
      /**
       * 出发地名称
       */
      beginCityName?: string;
      /**
       * 目的地列表
       */
      endCityList?: {
        /**
         * 目的城市code
         */
        endCityCode: string;
        /**
         * 目的城市名称
         */
        endCityName: string;
      }[];
      /**
       * 行程冲突提示语
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: number;
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: number;
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: string;
              /**
               * 是否可以报销
               */
              canExpense?: boolean;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: string;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: boolean;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 金额
               */
              ruleAmount?: number;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 是否派车 0 否 1是
       */
      arrangeCar?: number;
      /**
       * 派车信息
       */
      arrangeCarRO?: {
        /**
         * 派车信息编号
         */
        arrangeCarCode?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 派车天数
         */
        arrangeCarDay?: number;
        /**
         * 乘车人
         */
        passengerList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 司机
         */
        drivers?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
      };
      /**
       * 住宿天数
       */
      accommodationDay?: number;
    }[];
    /**
     * 扩展信息
     */
    extendFieldDTO?: {
      /**
       * 差旅扩展字段
       */
      travelExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 是否派车：1-派车，2-不派车
         */
        arrangeCar?: string;
        /**
         * 派车天数
         */
        dayCount?: number;
        extra?: string;
        /**
         * 三方拓展字段
         */
        thirdExtend?: string;
        /**
         * 差旅报销方式
         */
        travelExpenseMethod?: '由申请单报销' | '凭票报销';
        /**
         * 工号
         */
        workNo?: string;
        /**
         * 是否项目出差
         */
        isProject?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 所属部门
         */
        depName?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 项目名称
         */
        projectName?: {
          key?: string;
          value?: string;
          label?: string;
        };
        /**
         * 项目负责人
         */
        projectHeader?: {
          key?: string;
          value?: string;
          label?: string;
        };
      };
      /**
       * 会议扩展字段（包含多收款人）
       */
      meetingExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 1 签掉表 2 签到表附件
         */
        signType?: number;
        /**
         * 签到表
         */
        signForm?: {
          signFormCode?: string;
          /**
           * 签到表名称
           */
          signFormName?: string;
          /**
           * 申请表状态
           * 0-未发布 1-已发布 2-已结束
           */
          formStatus?: number;
          /**
           * 申请表状态名称
           */
          formStatusName?: string;
          /**
           * 结束时间
           */
          endTime?: number;
        };
        /**
         * 1申请单携带 2 手动选择
         */
        isExpenseInit?: number;
        /**
         * 会议名称
         */
        meetingName: string;
        /**
         * 会议地点code
         */
        meetingCityCode?: string;
        /**
         * 会议地点名称
         */
        meetingCityName?: string;
        /**
         * 会议开始日期
         */
        meetingStartDate?: string;
        /**
         * 会议结束日期
         */
        meetingEndDate?: string;
        /**
         * 会议天数
         */
        meetingDayCount?: number;
        /**
         * 会议预计参会人数
         */
        meetingExpectAttendeeCount: number;
        /**
         * 会议实际参会人数
         */
        meetingRealAttendeeCount?: number;
        /**
         * 会议工作人员人数
         */
        meetingWorkerCount?: number;
        /**
         * 参会领导信息
         */
        meetingLeaderInfo?: string;
        /**
         * 会议议程
         */
        meetingAgenda?: string;
        /**
         * 是否纳入预算
         * 1-是，2-否
         */
        isIncludedBudget?: number;
        /**
         * 会议差异内容
         */
        meetingDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal?: number;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 详细地址信息
         */
        detailAddress?: string;
      };
      /**
       * 培训扩展字段（包含多收款人）
       */
      trainingExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 1 签掉表 2 签到表附件
         */
        signType?: number;
        /**
         * 签到表
         */
        signForm?: {
          signFormCode?: string;
          /**
           * 签到表名称
           */
          signFormName?: string;
          /**
           * 申请表状态
           * 0-未发布 1-已发布 2-已结束
           */
          formStatus?: number;
          /**
           * 申请表状态名称
           */
          formStatusName?: string;
          /**
           * 结束时间
           */
          endTime?: number;
        };
        /**
         * 1申请单携带 2 手动选择
         */
        isExpenseInit?: number;
        /**
         * 培训名称
         */
        trainingName?: string;
        /**
         * 培训地点code
         */
        trainingCityCode?: string;
        /**
         * 培训地点名称
         */
        trainingCityName?: string;
        /**
         * 培训开始日期
         */
        trainingStartDate?: string;
        /**
         * 培训结束日期
         */
        trainingEndDate?: string;
        /**
         * 培训天数
         */
        trainingDayCount?: number;
        /**
         * 培训预计参会人数
         */
        trainingExpectAttendeeCount?: number;
        /**
         * 培训实际参会人数
         */
        trainingRealAttendeeCount?: number;
        /**
         * 培训工作人员人数
         */
        trainingWorkerCount?: number;
        /**
         * 培训议程
         */
        trainingAgenda?: string;
        /**
         * 是否纳入预算
         * 1-是，2-否
         */
        isIncludedBudget?: number;
        /**
         * 培训差异内容
         */
        trainingDifferenceContent?: string;
        /**
         * 培训讲师信息
         */
        trainingTeacherInfo?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal?: number;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource?: number;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
        /**
         * 变更支付方式说明
         */
        changePayModeReason?: string;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
        /**
         * 详细地址信息
         */
        detailAddress?: string;
      };
      /**
       * 采购扩展字段
       */
      procurementExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 采购内容
         */
        procurementContent?: string;
        /**
         * 采购差异内容
         */
        procurementDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 费用合计
         */
        applyAmount?: number;
        /**
         * 合同信息
         */
        contractList?: {
          /**
           * 政采云合同ID，订单拉取的合同填写
           */
          contractId?: number;
          /**
           * 订单编号
           */
          orderCode?: string;
          /**
           * 合同编号
           */
          contractCode?: string;
          /**
           * 合同名称
           */
          contractName?: string;
          /**
           * 合同金额（分）
           */
          amount?: number;
        }[];
      };
      /**
       * 公务接待
       */
      receptionExtendFields?: {
        /**
         * 来访单位
         */
        visitOrgName: string;
        /**
         * 是否同城（宁波场景不需要）
         * 1-是，2-否
         */
        isSameCity?: number;
        /**
         * 来访人员职务
         */
        visitorDuty?: string;
        /**
         * 来访事由
         */
        visitReason: string;
        /**
         * 来访开始日期
         */
        visitStartDate: string;
        /**
         * 来访结束日期
         */
        visitEndDate: string;
        /**
         * 来访人员级别：1-省部级、2-厅局级、99-其他
         */
        visitorLevel: number;
        /**
         * 来访人员级别名称
         */
        visitorLevelName?: string;
        /**
         * 来访人数
         */
        visitorCount: number;
        /**
         * 主宾姓名
         */
        mainGuest?: string;
        /**
         * 接待地点code
         */
        receptionCityCode: string;
        /**
         * 接待地点名称
         */
        receptionCityName: string;
        /**
         * 接待详细地点
         */
        receptionDetailAddress?: string;
        /**
         * 就餐日期
         */
        mealDate: string;
        /**
         * 工作餐形式：1-自助餐、2-桌餐
         */
        mealType: 1 | 2 | 3;
        /**
         * 工作餐形式
         */
        mealTypeName?: string;
        /**
         * 用餐时间：1-早餐，2-中餐，3-晚餐
         */
        mealTimeType?: 1 | 2 | 3;
        /**
         * 用餐时间
         */
        mealTimeTypeName?: string;
        /**
         * 陪餐人数（宁波场景不需要）
         */
        escortCount?: number;
        /**
         * 配餐人员姓名
         */
        escortPerson?: string;
        /**
         * 接待预算金额
         */
        receptionBudgetAmount?: number;
        /**
         * 来访人员信息
         */
        visitorInformation?: {
          /**
           * 访问人员名称
           */
          visitorName?: string;
          /**
           * 访问人员职级
           */
          visitorLevel?: number;
          /**
           * 访问人员职级名称
           */
          visitorLevelName?: string;
          /**
           * 来访人员职务
           */
          visitorDuty?: string;
        }[];
        /**
         * 接待人员信息
         */
        receptionistInformation?: {
          /**
           * 接待人员名称
           */
          receptionistName?: string;
          /**
           * 接待人员职级
           */
          receptionistLevel?: number;
          /**
           * 接待人员职级名称
           */
          receptionistLevelName?: string;
        }[];
      };
      /**
       * 一般事项
       */
      generalExtendFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 事项详细内容
         */
        detailContent: string;
        /**
         * 事项预算
         */
        eventBudget?: number;
        /**
         * 事项详细内容与事前审批的差异
         */
        generalDifferenceContent?: string;
        extra?: string;
      };
      /**
       * 用印申请
       */
      contractExtendFields?: {
        /**
         * 合同编号
         */
        uniqueCode?: string;
      };
      /**
       * 招标书
       */
      tenderApplyExtendFields?: {
        /**
         * 申请单类型
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请事由
         */
        applyReason?: string;
        /**
         * 申请单Code
         */
        applyFormCode?: string;
        /**
         * 业务单据号
         */
        businessCode?: string;
        /**
         * 提交时间
         */
        submitTime?: string;
      };
      /**
       * 通用采购申请拓展字段
       */
      purchaseGeneralFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm?: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * isCreatePurchaseProposal
         * 采购类型
         * 1-政府采购，2-非政府采购
         */
        purchaseType?: 1 | 2;
        /**
         * 采购类型描述
         */
        purchaseTypeDesc?: string;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource?: 1 | 2;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
      };
      /**
       * 政府购买服务申请拓展字段
       */
      govermentApplyFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
        /**
         * 采购类型
         * 1-政府采购，2-非政府采购
         */
        purchaseType: 1 | 2;
        /**
         * 采购类型描述
         */
        purchaseTypeDesc?: string;
        /**
         * 采购资金来源
         * 1-财政预算资金，2-非财政预算资金
         */
        purchaseFundSource: 1 | 2;
        /**
         * 采购资金来源描述
         */
        purchaseFundSourceDesc?: string;
      };
      /**
       * 办公家具购置申请拓展字段
       */
      furnitureApplyFields?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 组织形式
         */
        organizationalForm: 1 | 2 | 3 | 4;
        /**
         * 组织形式描述
         */
        organizationalFormDesc?: string;
        /**
         * 采购方式
         */
        purchaseMethod: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
        /**
         * 采购方式描述
         */
        purchaseMethodDesc?: string;
        /**
         * 是否生成采购建议书草稿
         * 1-是，2-否
         */
        isCreatePurchaseProposal: number;
      };
      /**
       * 全链路二期 报销的统一拓展字段
       */
      purchaseGeneralExpenseFieldDTO?: {
        baidaInfo?: {
          /**
           * 百搭快照编号
           */
          formSnapshotCode?: string;
          /**
           * 百搭模块内容，JSON字符串，百搭灵活扩展，后端原样存储
           */
          formData?: string;
        };
        /**
         * 交易方式：线上；线下
         */
        tradeWay?: string[];
        /**
         * 采购差异内容
         */
        procurementDifferenceContent?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 交易方式
         */
        tradeWayName?: string;
        /**
         * 是否有合同
         */
        addContract?: boolean;
      };
      /**
       * 公共事业缴费统一拓展字段
       */
      publicBusinessPaymentFieldDTO?: {
        /**
         * 备注
         */
        remark?: string;
      };
      /**
       * 无相拓展
       */
      generalExtra?: string;
    };
    /**
     * 申请时间
     */
    initiationDate?: string;
    /**
     * 申请时间
     */
    initiationTime?: string;
    /**
     * 申请单状态
     * 1-未提交、2-审批中、3-已驳回、4-已完成、5-已作废
     */
    formStatus?: number;
    /**
     * 用户角色
     * 1：本人 2：审核人 3：审批人
     */
    userRole?: number;
    /**
     * 是否是行程参与人
     * true：是本人，false：不是本人
     */
    isAccompany?: boolean;
    /**
     * 是否是接收人
     * true：是本人，false：不是本人
     */
    isReceiver?: boolean;
    /**
     * 是否是本人
     * true：是本人，false：不是本人
     */
    isHimself?: boolean;
    /**
     * 是否是可撤回状态
     * true：可撤回，false：不可撤回
     */
    withdrawn?: boolean;
    /**
     * 是否可审批
     * true：可以，false：不可以
     */
    approvalAuth?: boolean;
    /**
     * 工作流审核人id集合，包含已审核和未审核操作人列表
     */
    workflowAuditorIds?: number[];
    /**
     * 转交历史
     */
    accompanyHistoryList?: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 附件列表
     */
    formAttachmentDTO?: {
      /**
       * 默认附件列表
       */
      normalAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 说明附件列表
       */
      thatAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 通知附件列表
       */
      informAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 合同附件列表
       */
      compactAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 签到附件列表
       */
      signAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 派出单位公函附件列表
       */
      officialLetterAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 接待清单附件列表
       */
      receptionMenuAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 采购意向附件列表
       */
      purchasePurposeAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 资产更新计划
       */
      propertyUpdatePlanAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 集体决策会议纪要
       */
      meetingSummaryAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 专家论证意见
       */
      argumentSuggestionAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 专项、会议、培训附件列表
       */
      specialAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 银行回单附件
       */
      bankReceiptAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 账单附件
       */
      billAttachmentFileList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
    };
    /**
     * 简报列表
     */
    briefReportList?: {
      /**
       * 简报状态
       */
      briefStatus?: number;
      /**
       * 简报文字
       */
      briefReport?: string;
      /**
       * 简报原因
       */
      briefReason?: string;
      /**
       * 定位锚点
       */
      position?: 1 | 2 | 3;
    }[];
    /**
     * 表单费用列表
     */
    feeRecordDTOS?: {
      /**
       * 费用编码
       */
      feeCode?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 费用类型编码：1001-住宿，1002-午休，2001-火车，2002-飞机，2003-轮船，2004-短途包干，2005-退票/改签，3001-伙食费，4001-公杂费，5001-其他费用，9999-总费用
       */
      feeType?:
        | 1001
        | 1002
        | 2001
        | 2002
        | 2003
        | 2004
        | 2005
        | 2006
        | 2007
        | 2008
        | 2009
        | 3001
        | 300101
        | 3002
        | 4001
        | 5001
        | 5000
        | 5002
        | 5003
        | 5004
        | 5005
        | 5006
        | 5007
        | 5008
        | 5009
        | 5010
        | 5011
        | 5012
        | 6000
        | 6001
        | 6002
        | 6003
        | 7000
        | 7001
        | 7002
        | 7003
        | 7004
        | 7005
        | 8888
        | 8001
        | 8002
        | 8003
        | 9999;
      /**
       * 费用大类
       */
      parentFeeType?:
        | 10
        | 10
        | 20
        | 20
        | 20
        | 20
        | 20
        | 20
        | 20
        | 20
        | 20
        | 30
        | 30
        | 30
        | 40
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 50
        | 60
        | 60
        | 60
        | 60
        | 70
        | 70
        | 70
        | 70
        | 70
        | 70
        | 88
        | 80
        | 80
        | 80
        | 99;
      /**
       * 调整金额
       */
      modifyFeeAmountDTO?: {
        /**
         * 原始金额
         */
        originalAmount: number;
        /**
         * 修改后金额
         */
        updateAmount: number;
        /**
         * 修改备注
         */
        updateReason?: string;
        /**
         * 原始账户
         */
        originalAccount?: string;
        /**
         * 修改后账户
         */
        updateAccount?: string;
      };
      /**
       * 有无调整历史
       * true-有，false-无
       */
      haveFeeAdjustHistory?: boolean;
      /**
       * 是否超标：true-是，false-否
       */
      isExcessive?: boolean;
    }[];
    /**
     * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
     */
    processStatus?: string;
    /**
     * 数据来源
     */
    dataSource?: number;
    /**
     * 驳回原因
     */
    rejectReason?: string;
    /**
     * 商品信息 for 办公用品采购、通用采购、政府购买服务、办公设备家具购置
     */
    commodityList?: {
      /**
       * 唯一编码
       */
      uniqueCode?: string;
      /**
       * 商品编号
       */
      commodityCode?: string;
      /**
       * 商品名称
       */
      commodityName?: string;
      /**
       * 供应商ID
       */
      supplierId?: number;
      /**
       * 供应商名称
       */
      supplierName?: string;
      /**
       * 规则描述
       */
      specification?: string;
      /**
       * 单价（分）
       */
      unitPrice?: number;
      /**
       * 小记（分）
       */
      totalPrice?: number;
      /**
       * 数量
       */
      amount?: number;
      /**
       * 商品数据来源：0-浙里报 1-政采云
       */
      commoditySource?: number;
      /**
       * 拓展字段
       */
      extendDataDTO?: {
        /**
         * 实例名称
         */
        instanceName?: string;
        /**
         * 品牌
         */
        brandName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 商品详情页url
         */
        detailPageUrl?: string;
        /**
         * 所有服务商品单价和
         */
        serviceTotalPrice?: number;
        /**
         * 服务单价和
         */
        sumServiceTotalPrice?: number;
        /**
         * 计量单位
         */
        unit?: string;
        /**
         * 是否进口：1是、0否
         */
        isImport?: number;
        /**
         * 是否适宜中小企业：1是、0否
         */
        isSuit?: number;
        /**
         * 不适宜中小企业理由
         */
        noSuitReason?: string;
        /**
         * 采购目录code（选择的）
         */
        catalogCodeList?: string[];
        /**
         * First catalogCodeList
         */
        category?: string;
        /**
         * 采购目录name（选择的）
         */
        catalogNameList?: string[];
        /**
         * 政府购买服务目录code（选择的）
         */
        serviceCodeList?: string[];
        /**
         * 政府购买服务目录name（选择的）
         */
        serviceNameList?: string[];
        /**
         * 采购目录信息(从购物车取的数据)
         */
        catalogList?: {
          /**
           * 采购目录编码
           */
          catalogCode?: string;
          /**
           * 采购目录名称
           */
          catalogName?: string;
        }[];
        /**
         * 商品属性信息
         */
        attributeList?: {
          /**
           * 属性名称
           */
          attributeName?: string;
          /**
           * 属性值
           */
          attributeValue?: string;
        }[];
        /**
         * 商品服务项信息
         */
        standards?: {
          /**
           * 服务商品ID
           */
          standardId?: number;
          /**
           * 服务名称
           */
          standardName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 服务价格
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 商品服务信息
         */
        services?: {
          /**
           * 服务名称
           */
          serviceName?: string;
          /**
           * 服务属性
           */
          serviceAttribute?: string;
          /**
           * 服务id
           */
          serviceId?: number;
          /**
           * 单价
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
          /**
           * 数量 随着商品增加
           */
          amount?: number;
        }[];
        /**
         * 选配信息
         */
        news?: {
          /**
           * 购物车配件主键 id
           */
          newsId?: number;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 品牌名称
           */
          newsName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 配件单价，单位：分
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 使用人信息
         */
        userInfo?: {
          /**
           * 职级
           * 1-厅级 2-处级 3-处级以下
           */
          userRank: 1 | 2 | 3;
          /**
           * 职级描述
           */
          userRankDesc?: string;
          /**
           * 使用人姓名
           */
          userName: string;
        };
        /**
         * 资产类型
         * 1-办公家具 2-办公设备
         */
        propertyType?: string;
        /**
         * 资产类型描述
         */
        propertyTypeDesc?: string;
        /**
         * 资产品目
         */
        propertyItem?: string;
        /**
         * 资产品目类型
         */
        propertyItemDesc?: string;
        /**
         * 商品类目
         */
        itemCatalogName?: string;
        /**
         * 会议桌容纳人数
         */
        userCount?: number;
        /**
         * 政采云商品链接，用户填写，自动解析出商品数据
         */
        zcyUrl?: string;
        /**
         * 是否国产，资产类别为办公设备时可填，如果为是，不进行费控  1是、0否
         */
        domestic?: number;
        /**
         * 商品主图
         */
        mainImage?: string;
      };
      /**
       * 外部sku
       */
      skuCode?: number;
      /**
       * 商品附件
       */
      attachmentList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      }[];
    }[];
    /**
     * 是否关联订单
     */
    isUnitOrder?: boolean;
    /**
     * 订单列表 采购6大场景
     */
    orderList?: {
      /**
       * 订单ID
       */
      orderId?: number;
      /**
       * 订单号
       */
      orderCode?: string;
      /**
       * 实际支付金额
       */
      realPrice?: number;
      /**
       * 订单类别名称
       */
      orderCategoryDesc?: string;
      /**
       * 支付方式
       */
      paymentMethod?: 0 | 1 | 2 | 3 | 4;
      /**
       * 支付方式名称
       */
      paymentMethodDesc?: string;
      /**
       * 收货人
       */
      receiver?: string;
      /**
       * 供应名称
       */
      supplierName?: string;
      /**
       * 供应商ID
       */
      supplierId?: number;
      /**
       * 订单状态
       */
      orderStatus?: number;
      /**
       * 订单状态名称
       */
      orderStatusDesc?: string;
      /**
       * 下单时间
       */
      orderTime?: string;
      /**
       * 是否关联申请单
       */
      unitApplyFormCode?: boolean;
      /**
       * 申请单编号
       */
      applyFormCode?: string;
      /**
       * 申请单业务编号
       */
      applyFormBusinessCode?: string;
      /**
       * 申请单类型
       * 2-会议申请；3-培训申请；4-采购申请
       */
      applyFormType?: number;
      /**
       * 是否关联报销单
       */
      unitExpenseFormCode?: boolean;
      expenseFromList?: {
        /**
         * 报销单编号
         */
        expenseFormCode?: string;
        /**
         * 报销单业务编号
         */
        expenseFormBusinessCode?: string;
        /**
         * 报销单类型
         * 2-会议申请；3-培训申请；4-采购申请
         */
        expenseFormType?: number;
      }[];
      /**
       * 是否必须关联申请单
       */
      necessaryUnitApplyForm?: boolean;
      /**
       * 操作
       */
      operateButton?: {
        /**
         * 订单详情
         */
        detail?: boolean;
        /**
         * 关联申请单
         */
        unitApplyForm?: boolean;
        /**
         * 取消关联申请单
         */
        undoApplyForm?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 是否可选
         * 报销单类型与订单关联的申请单类型判断是否可选
         */
        checkbox?: boolean;
      };
      /**
       * operatorId(个人账号或授权账号)
       */
      operatorId?: number;
      /**
       * 查询类别 1-我的账号 2-授权给我的账号
       */
      queryOperatorType?: number;
      /**
       * 订单剩余可报销金额
       */
      orderRemainingAmount?: number;
      /**
       * 已报销金额记录
       */
      expenseAmountRecordDTOS?: {
        /**
         * 报销单businessCode
         */
        businessCode?: string;
        /**
         * 报销金额记录
         */
        expenseAmountRecord?: number;
      }[];
    }[];
    /**
     * 申请金额
     */
    applyAmount?: number;
    /**
     * 剩余金额
     */
    applyRemainingAmount?: number;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 是否包含外部人员
     * true：可撤回，false：不可撤回
     */
    isIncludeOuter?: boolean;
    /**
     * 后补原因
     */
    replenishReason?: string;
    /**
     * 报销单信息
     */
    expenseFormList?: {
      /**
       * 报销单号
       */
      expenseFormCode?: string;
      /**
       * 报销单号
       */
      businessCode?: string;
      /**
       * 报销单类型
       */
      expenseFormType?: number;
      /**
       * 报销单类型名称
       */
      expenseFormTypeName?: string;
      /**
       * 报销缘由
       */
      expenseReason?: string;
      /**
       * 创建人姓名
       */
      operatorName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentName?: string;
      /**
       * 部门名字 机构名 + 部门名
       */
      departmentId?: number;
      /**
       * 机构ID
       */
      orgId?: number;
      /**
       * 机构名字
       */
      orgName?: string;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 报销单状态
       */
      expenseFormStatus?: number;
      /**
       * 报销单状态
       */
      expenseFormStatusDesc?: string;
      /**
       * 报销金额
       */
      expenseAmount?: number;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 业务类型名称
       */
      businessTypeName?: string;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 处理中状态：IN_APPROVAL-审批中；IN_AUDIT-审核中
       */
      processStatus?: string;
      /**
       * 用户类别
       * 1-本人 2-审核人 3-审批人 4-同行人
       */
      userRole?: number;
      /**
       * 是否百搭单据
       */
      isBaidaForm?: boolean;
      /**
       * 审批人名称
       */
      approvedNames?: string[];
      /**
       * 报销单关联申请单基本信息
       */
      relationApplyInfoROList?: {
        /**
         * 申请单业务单据号
         */
        applyBusinessNo?: string;
        /**
         * 申请单编号
         */
        applyFormCode?: string;
        /**
         * 申请单单据类型编号
         */
        applyFormType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 14;
        /**
         * 申请人姓名
         */
        applyUserName?: string;
        /**
         * 发起时间
         */
        initiationTime?: string;
      }[];
    }[];
    operateButton?: {
      /**
       * 删除
       */
      remove?: boolean;
      /**
       * 作废
       */
      discard?: boolean;
      /**
       * 撤回
       */
      withdrawn?: boolean;
      /**
       * 加签
       */
      signature?: boolean;
      /**
       * 通过
       */
      pass?: boolean;
      /**
       * 重新发起
       */
      restart?: boolean;
      /**
       * 驳回
       */
      reject?: boolean;
      /**
       * 打印
       */
      print?: boolean;
      /**
       * 转交
       */
      transfer?: boolean;
      comment?: boolean;
      needExpense?: boolean;
    };
    /**
     * 身份信息
     */
    identity?: string;
    /**
     * 是否是百搭
     */
    isBaidaForm?: boolean;
    /**
     * 会议培训申请单校验结果
     */
    applyCheckResultROList?: {
      /**
       * 费控状态
       */
      feeCheckStatus?: number;
      /**
       * 提示语
       */
      applyFeeCheckResultMessageList?: {
        /**
         * 费控状态
         */
        feeCheckStatus?: number;
        /**
         * 提示信息
         */
        msg?: string;
        /**
         * 费控标准提示信息
         */
        rule?: string;
      }[];
      /**
       * 分组code
       */
      groupCode?: string;
      /**
       * 费用父级code
       */
      feeParentType?: number;
      /**
       * 费用父级描述
       */
      feeParentTypeDesc?: string;
    }[];
    /**
     * 工作计划列表
     */
    workPlanList?: {
      /**
       * 标题
       */
      title?: string;
      /**
       * 工作计划code
       */
      workPlanCode?: string;
      /**
       * 缘由
       */
      reason?: string;
      /**
       * 工作计划编号
       */
      businessCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
    }[];
    /**
     * 预算项目
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 占用金额
       */
      amount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 操作人，后端使用
       */
      operatorId?: number;
      /**
       * 科目uk 级联
       */
      subjectUkHierarchy?: string[];
      /**
       * 科目名称级联
       */
      subjectNameHierarchy?: string[];
    }[];
    workflowInfo?: {
      workflowProcessKey?: string;
      workflowModelId?: number;
      workflowVersion?: number;
      auditNodeList?: {
        auditOperatorList?: {
          operatorId?: number;
          operatorName?: string;
          institutionId?: number;
          institutionName?: string;
          auditRemark?: string;
          auditStatus?: number;
          auditTime?: string;
          signAttachment?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          oneselfHistorySignAttachment?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          addAuditWay?: number;
          addAuditOperator?: string;
          comment?: {
            commentContent?: string;
            operatorId?: number;
            operatorName?: string;
            commentCode?: string;
            commentTime?: number;
            pictureAttachments?: {
              fileId?: string;
              type?: string;
              bizNo?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            otherAttachments?: {
              fileId?: string;
              type?: string;
              bizNo?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            remove?: boolean;
          };
          operatorType?: number;
        }[];
        userRangeType?: number;
        userRangeTypeNew?: number;
        userRangeValues?: string[];
        userRangeValuesNew?: string[];
        personCount?: number;
        auditStatus?: number;
        auditTime?: string;
        auditDesc?: string;
        auditType?: number;
        eventType?: number;
        nodeType?: number;
        nodeKey?: string;
        nodeName?: string;
        checkStrategy?: number;
        departmentId?: number;
        institutionSelfDtos?: {
          code?: string;
          name?: string;
          userType?: string;
          tenantCode?: string;
          tenantName?: string;
          uniqueKey?: string;
          parentInstitution?: {
            parentCode?: number;
            parentName?: string;
          };
        }[];
        commonAuditorList?: {
          displayName?: string;
          userId?: number;
          operatorId?: number;
          code?: string;
          gender?: number;
          institutionId?: number;
          institution?: {
            id?: number;
            createdAt?: number;
            updatedAt?: number;
            creatorId?: string;
            modifierId?: string;
            extFields?: string;
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string;
            tags?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            divisionCode?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
          };
          deptName?: string;
        }[];
        bizProperty?: string;
        comment?: {
          commentContent?: string;
          operatorId?: number;
          operatorName?: string;
          commentCode?: string;
          commentTime?: number;
          pictureAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          otherAttachments?: {
            fileId?: string;
            type?: string;
            bizNo?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          remove?: boolean;
        };
      }[];
      applyOperatorId?: number;
      applyOperatorName?: string;
      applyTime?: string;
      applyRemark?: string;
      isAddTaskAccess?: number;
      isEnableSign?: boolean;
      signConfig?: number;
      availableRejectNodeList?: {
        nodeName?: string;
        nodeKey?: string;
        operatorNames?: string[];
      }[];
      currentBizProperty?: string;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/482346) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/institution/query-cashier`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormInstitutionQueryCashierGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/institution/query-cashier',
    'data',
    string,
    'formCode' | 'identity' | 'desensitize',
    false
  >
>;

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/482346) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/institution/query-cashier`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormInstitutionQueryCashierGetRequestConfig: ZlbApiExpenseApplyFormInstitutionQueryCashierGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/institution/query-cashier',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ['formCode', 'identity', 'desensitize'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormInstitutionQueryCashierGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单个申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/482346) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/institution/query-cashier`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormInstitutionQueryCashierGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormInstitutionQueryCashierGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormInstitutionQueryCashierGetResponse>(
    prepare(zlbApiExpenseApplyFormInstitutionQueryCashierGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormInstitutionQueryCashierGet.requestConfig =
  zlbApiExpenseApplyFormInstitutionQueryCashierGetRequestConfig;

/**
 * 接口 [行程管理页面↗](http://yapi.cai-inc.com/project/3621/interface/api/516866) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/itinerary/management/page`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormItineraryManagementPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 起始时间
   */
  beginTime: number;
  /**
   * 结束时间
   */
  endTime: number;
}

/**
 * 接口 [行程管理页面↗](http://yapi.cai-inc.com/project/3621/interface/api/516866) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/itinerary/management/page`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormItineraryManagementPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 开始时间
       */
      beginTime?: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag?: number;
      /**
       * 结束时间
       */
      endTime?: string;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag?: number;
      /**
       * 出差天数
       */
      travelDay?: number;
      /**
       * 出发地名称
       */
      beginCityName?: string;
      /**
       * 目的地列表
       */
      endCityNameList?: string[];
      /**
       * 出差人列表
       */
      accompanyList?: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [行程管理页面↗](http://yapi.cai-inc.com/project/3621/interface/api/516866) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/itinerary/management/page`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormItineraryManagementPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/itinerary/management/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [行程管理页面↗](http://yapi.cai-inc.com/project/3621/interface/api/516866) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/itinerary/management/page`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormItineraryManagementPagePostRequestConfig: ZlbApiExpenseApplyFormItineraryManagementPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/itinerary/management/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormItineraryManagementPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [行程管理页面↗](http://yapi.cai-inc.com/project/3621/interface/api/516866) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/itinerary/management/page`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormItineraryManagementPagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormItineraryManagementPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormItineraryManagementPagePostResponse>(
    prepare(zlbApiExpenseApplyFormItineraryManagementPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormItineraryManagementPagePost.requestConfig =
  zlbApiExpenseApplyFormItineraryManagementPagePostRequestConfig;

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579122) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan-default-info`
 * @更新时间 `2023-11-22 17:27:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormInitWorkPlanDefaultInfoGetRequest {
  /**
   * 工作计划code集合
   */
  workPlanFormCodes: string;
}

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579122) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan-default-info`
 * @更新时间 `2023-11-22 17:27:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormInitWorkPlanDefaultInfoGetResponse {
  success?: boolean;
  result?: {
    /**
     * 申请事由
     */
    applyReason?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 工作计划列表
     */
    workPlanList?: {
      /**
       * 标题
       */
      title?: string;
      /**
       * 工作计划code
       */
      workPlanCode?: string;
      /**
       * 缘由
       */
      reason?: string;
      /**
       * 工作计划编号
       */
      businessCode?: string;
    }[];
    /**
     * 工作计划行程列表
     */
    itineraryList?: {
      tag?: string;
      /**
       * 工作计划code
       */
      workPlanCode?: string;
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 行程信息编号
       */
      itineraryCode?: string;
      /**
       * 原行程单号
       */
      originalItineraryCode?: string;
      /**
       * 出差人列表
       */
      accompanyList?: {
        /**
         * 用户ID
         * @NotNull(message = "用户ID不能为空")
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
      /**
       * 开始时间
       */
      beginTime?: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag?: number;
      /**
       * 结束时间
       */
      endTime?: string;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag?: number;
      /**
       * 出差天数
       */
      travelDay?: number;
      /**
       * 出发地code
       */
      beginCityCode?: string;
      /**
       * 出发地名称
       */
      beginCityName?: string;
      /**
       * 目的地列表
       */
      endCityList?: {
        /**
         * 目的城市code
         */
        endCityCode: string;
        /**
         * 目的城市名称
         */
        endCityName: string;
      }[];
      /**
       * 行程冲突提示语
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: string;
              /**
               * 是否可以报销
               */
              canExpense?: boolean;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: string;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: boolean;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 金额
               */
              ruleAmount?: number;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 是否派车 0 否 1是
       */
      arrangeCar?: number;
      /**
       * 派车信息
       */
      arrangeCarRO?: {
        /**
         * 派车信息编号
         */
        arrangeCarCode?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 派车天数
         */
        arrangeCarDay?: number;
        /**
         * 乘车人
         */
        passengerList?: {
          /**
           * 用户ID
           * @NotNull(message = "用户ID不能为空")
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 司机
         */
        drivers?: {
          /**
           * 用户ID
           * @NotNull(message = "用户ID不能为空")
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
      };
      /**
       * 住宿天数
       */
      accommodationDay?: number;
    }[];
    /**
     * 差旅类型
     */
    businessType?: number;
    /**
     * 是否派车 0 否 1是
     */
    arrangeCar?: number;
    /**
     * 工作单位id
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 所在部门列表
     */
    departmentList?: {
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 父级部门ID
       */
      parentDeptId?: number;
      /**
       * 父级部门名称
       */
      parentDeptName?: string;
    }[];
    /**
     * 单位部门树
     */
    departmentTree?: {
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 父级部门ID
       */
      parentDeptId?: number;
      /**
       * 父级部门名称
       */
      parentDeptName?: string;
      /**
       * 是否可选
       */
      available?: boolean;
      children?: {
        /**
         * 部门ID
         */
        deptId?: number;
        /**
         * 部门名称
         */
        deptName?: string;
        /**
         * 父级部门ID
         */
        parentDeptId?: number;
        /**
         * 父级部门名称
         */
        parentDeptName?: string;
        /**
         * 是否可选
         */
        available?: boolean;
        children?: {
          /**
           * 部门ID
           */
          deptId?: number;
          /**
           * 部门名称
           */
          deptName?: string;
          /**
           * 父级部门ID
           */
          parentDeptId?: number;
          /**
           * 父级部门名称
           */
          parentDeptName?: string;
          /**
           * 是否可选
           */
          available?: boolean;
          children?: {}[];
        }[];
      }[];
    };
    /**
     * 是否展示单位部门树
     */
    treeFlag?: boolean;
    /**
     * 默认选中的部门
     */
    deptId?: number;
    /**
     * 默认城市code
     */
    cityCode?: string;
    /**
     * 默认城市name
     */
    cityName?: string;
    /**
     * 单位开始结束时间类型策略(时间、日期、上下午等)
     */
    periodType?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579122) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan-default-info`
 * @更新时间 `2023-11-22 17:27:38`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormInitWorkPlanDefaultInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/init-work-plan-default-info',
    'data',
    string,
    'workPlanFormCodes',
    false
  >
>;

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579122) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan-default-info`
 * @更新时间 `2023-11-22 17:27:38`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormInitWorkPlanDefaultInfoGetRequestConfig: ZlbApiExpenseApplyFormInitWorkPlanDefaultInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/init-work-plan-default-info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ['workPlanFormCodes'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormInitWorkPlanDefaultInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579122) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan-default-info`
 * @更新时间 `2023-11-22 17:27:38`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormInitWorkPlanDefaultInfoGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormInitWorkPlanDefaultInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormInitWorkPlanDefaultInfoGetResponse>(
    prepare(zlbApiExpenseApplyFormInitWorkPlanDefaultInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormInitWorkPlanDefaultInfoGet.requestConfig =
  zlbApiExpenseApplyFormInitWorkPlanDefaultInfoGetRequestConfig;

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579810) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan`
 * @更新时间 `2024-08-19 14:39:06`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormInitWorkPlanGetRequest {
  /**
   * 工作计划code集合
   */
  workPlanFormCodes: string;
}

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579810) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan`
 * @更新时间 `2024-08-19 14:39:06`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormInitWorkPlanGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 工作单位id
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 经办人电话
     */
    operatorMobile?: string;
    /**
     * 所在部门列表
     */
    departmentList?: {
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 父级部门ID
       */
      parentDeptId?: number;
      /**
       * 父级部门名称
       */
      parentDeptName?: string;
    }[];
    /**
     * 单位部门树
     */
    departmentTree?: {
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 父级部门ID
       */
      parentDeptId?: number;
      /**
       * 父级部门名称
       */
      parentDeptName?: string;
      /**
       * 是否可选
       */
      available?: boolean;
      children?: {
        /**
         * 部门ID
         */
        deptId?: number;
        /**
         * 部门名称
         */
        deptName?: string;
        /**
         * 父级部门ID
         */
        parentDeptId?: number;
        /**
         * 父级部门名称
         */
        parentDeptName?: string;
        /**
         * 是否可选
         */
        available?: boolean;
        children?: {}[];
      }[];
    };
    /**
     * 是否展示单位部门树
     */
    treeFlag?: boolean;
    /**
     * 默认选中的部门
     */
    deptId?: number;
    /**
     * 部门名字
     */
    deptName?: string;
    /**
     * 默认城市code
     */
    cityCode?: string;
    /**
     * 默认城市name
     */
    cityName?: string;
    /**
     * 申请事由
     */
    applyReason?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 工作计划列表
     */
    workPlanList?: {
      /**
       * 标题
       */
      title?: string;
      /**
       * 工作计划code
       */
      workPlanCode?: string;
      /**
       * 缘由
       */
      reason?: string;
      /**
       * 工作计划编号
       */
      businessCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
    }[];
    /**
     * 工作计划行程列表
     */
    itineraryList?: {
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 行程信息编号
       */
      itineraryCode?: string;
      /**
       * 原行程单号
       */
      originalItineraryCode?: string;
      /**
       * 出差人列表
       */
      accompanyList?: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
      /**
       * 开始时间
       */
      beginTime?: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag?: number;
      /**
       * 结束时间
       */
      endTime?: string;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag?: number;
      /**
       * 出差天数
       */
      travelDay?: number;
      /**
       * 出发地code
       */
      beginCityCode?: string;
      /**
       * 出发地名称
       */
      beginCityName?: string;
      /**
       * 目的地列表
       */
      endCityList?: {
        /**
         * 目的城市code
         */
        endCityCode: string;
        /**
         * 目的城市名称
         */
        endCityName: string;
      }[];
      /**
       * 行程冲突提示语
       */
      checkResultMessageRO?: {
        /**
         * 提示状态
         */
        tipStatus?: number;
        /**
         * 提示文案
         */
        tipText?: string;
        /**
         * 提示消息
         */
        tipMsg?: string[];
        /**
         * 消息和类型
         */
        tipLists?: {
          /**
           * 规则强弱控
           */
          checkStatusCode?: number;
          /**
           * 规则强弱控描述
           */
          msg?: string;
          /**
           * 规则code
           */
          ruleCode?: string;
        }[];
        /**
         * 单独为前端提示方便添加（不要动，虽然很愚蠢）
         */
        invoiceTipMsg?: string[];
        /**
         * 设置结果
         */
        resultInfo?: {
          /**
           * 凭票报销总结果
           */
          expenseFeeInvoiceResult?: {
            /**
             * 用户id
             */
            operatorId?: number;
            /**
             * 用户名称
             */
            operatorName?: string;
            /**
             * 报销金额
             */
            amount?: number;
            /**
             * 报销金额描述
             */
            amountDesc?: string;
            /**
             * 详细信息
             */
            detailInfoList?: {
              /**
               * 发生日期
               */
              happenDate?: string;
              /**
               * 是否可以报销
               */
              canExpense?: boolean;
              /**
               * 表单code
               */
              formCode?: string[];
              /**
               * 业务code
               */
              businessCode?: string[];
              /**
               * 冲突描述
               */
              conflictDesc?: string;
              /**
               * 是否凭票报销冲突
               */
              isUseInvoice?: boolean;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 金额
               */
              ruleAmount?: number;
            }[];
          }[];
          /**
           * 凭票报销总结果提示
           */
          expenseFeeInvoiceTips?: string;
          /**
           * 是否展示
           */
          canShow?: boolean;
        };
        /**
         * 是否需要显示
         */
        canShow?: boolean;
      };
      /**
       * 是否派车 0 否 1是
       */
      arrangeCar?: number;
      /**
       * 派车信息
       */
      arrangeCarRO?: {
        /**
         * 派车信息编号
         */
        arrangeCarCode?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 开始时间
         */
        beginTime?: string;
        /**
         * 结束时间
         */
        endTime?: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 派车天数
         */
        arrangeCarDay?: number;
        /**
         * 乘车人
         */
        passengerList?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 司机
         */
        drivers?: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
      };
      /**
       * 住宿天数
       */
      accommodationDay?: number;
      tag?: string;
      /**
       * 工作计划code
       */
      workPlanCode?: string;
    }[];
    /**
     * 差旅类型
     */
    businessType?: number;
    /**
     * 是否派车 0 否 1是
     */
    arrangeCar?: number;
    /**
     * 附件列表
     */
    attachmentList?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579810) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan`
 * @更新时间 `2024-08-19 14:39:06`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormInitWorkPlanGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/init-work-plan',
    'data',
    string,
    'workPlanFormCodes',
    false
  >
>;

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579810) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan`
 * @更新时间 `2024-08-19 14:39:06`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormInitWorkPlanGetRequestConfig: ZlbApiExpenseApplyFormInitWorkPlanGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/init-work-plan',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ['workPlanFormCodes'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormInitWorkPlanGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化工作计划申请单默认数据↗](http://yapi.cai-inc.com/project/3621/interface/api/579810) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `GET /zlb/api/expense/apply-form/init-work-plan`
 * @更新时间 `2024-08-19 14:39:06`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormInitWorkPlanGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormInitWorkPlanGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormInitWorkPlanGetResponse>(
    prepare(zlbApiExpenseApplyFormInitWorkPlanGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormInitWorkPlanGet.requestConfig =
  zlbApiExpenseApplyFormInitWorkPlanGetRequestConfig;

/**
 * 接口 [智能报销，获取差旅行程时间↗](http://yapi.cai-inc.com/project/3621/interface/api/697994) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/smart-expense/get-itinerary-time`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormSmartExpenseGetItineraryTimePostRequest {
  /**
   * 申请单列表
   */
  applyFormCodeList: string[];
  /**
   * 业务类型(1-普通出差，2-专项会议培训)
   */
  businessType:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 32
    | 29
    | 30
    | 33;
}

/**
 * 接口 [智能报销，获取差旅行程时间↗](http://yapi.cai-inc.com/project/3621/interface/api/697994) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/smart-expense/get-itinerary-time`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApplyFormSmartExpenseGetItineraryTimePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 开始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [智能报销，获取差旅行程时间↗](http://yapi.cai-inc.com/project/3621/interface/api/697994) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/smart-expense/get-itinerary-time`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
type ZlbApiExpenseApplyFormSmartExpenseGetItineraryTimePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/apply-form/smart-expense/get-itinerary-time',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [智能报销，获取差旅行程时间↗](http://yapi.cai-inc.com/project/3621/interface/api/697994) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/smart-expense/get-itinerary-time`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
const zlbApiExpenseApplyFormSmartExpenseGetItineraryTimePostRequestConfig: ZlbApiExpenseApplyFormSmartExpenseGetItineraryTimePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/zlb/api/expense/apply-form/smart-expense/get-itinerary-time',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApplyFormSmartExpenseGetItineraryTimePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [智能报销，获取差旅行程时间↗](http://yapi.cai-inc.com/project/3621/interface/api/697994) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的申请↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36251)
 * @请求头 `POST /zlb/api/expense/apply-form/smart-expense/get-itinerary-time`
 * @更新时间 `2024-08-19 14:39:11`
 * @项目ID 3621
 */
export const zlbApiExpenseApplyFormSmartExpenseGetItineraryTimePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApplyFormSmartExpenseGetItineraryTimePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApplyFormSmartExpenseGetItineraryTimePostResponse>(
    prepare(zlbApiExpenseApplyFormSmartExpenseGetItineraryTimePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApplyFormSmartExpenseGetItineraryTimePost.requestConfig =
  zlbApiExpenseApplyFormSmartExpenseGetItineraryTimePostRequestConfig;

const mockUrl_0_1_0_4 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_4 = '' as any;
const prodUrl_0_1_0_4 = '' as any;
const dataKey_0_1_0_4 = 'data' as any;

/**
 * 接口 [获取地址树↗](http://yapi.cai-inc.com/project/3621/interface/api/234734) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressGetRequest {}

/**
 * 接口 [获取地址树↗](http://yapi.cai-inc.com/project/3621/interface/api/234734) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    name?: string;
    parentId?: number;
    leaf?: boolean;
    children?: {
      id?: number;
      name?: string;
      parentId?: number;
      leaf?: boolean;
      children?: {}[];
      code?: string;
      status?: number;
    }[];
    code?: string;
    status?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取地址树↗](http://yapi.cai-inc.com/project/3621/interface/api/234734) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
type ZlbApiExpenseAddressGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/address',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取地址树↗](http://yapi.cai-inc.com/project/3621/interface/api/234734) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
const zlbApiExpenseAddressGetRequestConfig: ZlbApiExpenseAddressGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_4,
  devUrl: devUrl_0_1_0_4,
  prodUrl: prodUrl_0_1_0_4,
  path: '/zlb/api/expense/address',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbApiExpenseAddressGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [获取地址树↗](http://yapi.cai-inc.com/project/3621/interface/api/234734) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export const zlbApiExpenseAddressGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseAddressGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseAddressGetResponse>(
    prepare(zlbApiExpenseAddressGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseAddressGet.requestConfig = zlbApiExpenseAddressGetRequestConfig;

/**
 * 接口 [获取模糊匹配区划名称↗](http://yapi.cai-inc.com/project/3621/interface/api/234742) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/name`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressNameGetRequest {
  /**
   * 地址名称
   */
  name?: string;
}

/**
 * 接口 [获取模糊匹配区划名称↗](http://yapi.cai-inc.com/project/3621/interface/api/234742) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/name`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressNameGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 区划描述
     */
    districtDesc?: string;
    /**
     * 展示的列表集合每个区
     */
    districtROList?: {
      /**
       * 区划名称
       */
      name?: string;
      /**
       * 区划层级
       */
      level?: number;
      /**
       * id
       */
      id?: number;
      /**
       * code
       */
      code?: string;
      /**
       * 父级id
       */
      parentId?: number;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取模糊匹配区划名称↗](http://yapi.cai-inc.com/project/3621/interface/api/234742) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/name`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
type ZlbApiExpenseAddressNameGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/address/name',
    'data',
    string,
    'name',
    false
  >
>;

/**
 * 接口 [获取模糊匹配区划名称↗](http://yapi.cai-inc.com/project/3621/interface/api/234742) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/name`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
const zlbApiExpenseAddressNameGetRequestConfig: ZlbApiExpenseAddressNameGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: '/zlb/api/expense/address/name',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: ['name'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseAddressNameGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取模糊匹配区划名称↗](http://yapi.cai-inc.com/project/3621/interface/api/234742) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/name`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export const zlbApiExpenseAddressNameGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseAddressNameGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseAddressNameGetResponse>(
    prepare(zlbApiExpenseAddressNameGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseAddressNameGet.requestConfig = zlbApiExpenseAddressNameGetRequestConfig;

/**
 * 接口 [获取地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234750) 的 **请求类型**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseHistoryGetRequest {}

/**
 * 接口 [获取地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234750) 的 **返回类型**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseHistoryGetResponse {
  success?: boolean;
  /**
   * [{"id":0,"code":"","name":"","parentId":"","leaf":false,"status":0,"level":0}]
   */
  result?: {
    id?: number;
    code?: string;
    name?: string;
    parentId?: string;
    leaf?: boolean;
    status?: number;
    level?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234750) 的 **请求配置的类型**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
type ZlbApiExpenseHistoryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/history',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234750) 的 **请求配置**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
const zlbApiExpenseHistoryGetRequestConfig: ZlbApiExpenseHistoryGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_4,
  devUrl: devUrl_0_1_0_4,
  prodUrl: prodUrl_0_1_0_4,
  path: '/zlb/api/expense/history',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbApiExpenseHistoryGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [获取地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234750) 的 **请求函数**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
export const zlbApiExpenseHistoryGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseHistoryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseHistoryGetResponse>(
    prepare(zlbApiExpenseHistoryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseHistoryGet.requestConfig = zlbApiExpenseHistoryGetRequestConfig;

/**
 * 接口 [删除地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234758) 的 **请求类型**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `POST /zlb/api/expense/delete/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeleteHistoryPostRequest {}

/**
 * 接口 [删除地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234758) 的 **返回类型**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `POST /zlb/api/expense/delete/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeleteHistoryPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234758) 的 **请求配置的类型**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `POST /zlb/api/expense/delete/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
type ZlbApiExpenseDeleteHistoryPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/delete/history',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [删除地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234758) 的 **请求配置**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `POST /zlb/api/expense/delete/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
const zlbApiExpenseDeleteHistoryPostRequestConfig: ZlbApiExpenseDeleteHistoryPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: '/zlb/api/expense/delete/history',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeleteHistoryPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除地址查询历史↗](http://yapi.cai-inc.com/project/3621/interface/api/234758) 的 **请求函数**
 *
 * @状态 未完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `POST /zlb/api/expense/delete/history`
 * @更新时间 `2022-01-07 16:03:18`
 * @项目ID 3621
 */
export const zlbApiExpenseDeleteHistoryPost = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseDeleteHistoryPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeleteHistoryPostResponse>(
    prepare(zlbApiExpenseDeleteHistoryPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeleteHistoryPost.requestConfig = zlbApiExpenseDeleteHistoryPostRequestConfig;

/**
 * 接口 [获取省内城市↗](http://yapi.cai-inc.com/project/3621/interface/api/237614) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/city-in-province`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressCityInProvinceGetRequest {
  /**
   * 省级code
   */
  code?: string;
}

/**
 * 接口 [获取省内城市↗](http://yapi.cai-inc.com/project/3621/interface/api/237614) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/city-in-province`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressCityInProvinceGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 区划名称
     */
    name?: string;
    /**
     * 区划层级
     */
    level?: number;
    /**
     * id
     */
    id?: number;
    /**
     * code
     */
    code?: string;
    /**
     * 父级id
     */
    parentId?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取省内城市↗](http://yapi.cai-inc.com/project/3621/interface/api/237614) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/city-in-province`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
type ZlbApiExpenseAddressCityInProvinceGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/address/city-in-province',
    'data',
    string,
    'code',
    false
  >
>;

/**
 * 接口 [获取省内城市↗](http://yapi.cai-inc.com/project/3621/interface/api/237614) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/city-in-province`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
const zlbApiExpenseAddressCityInProvinceGetRequestConfig: ZlbApiExpenseAddressCityInProvinceGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: '/zlb/api/expense/address/city-in-province',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: ['code'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseAddressCityInProvinceGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取省内城市↗](http://yapi.cai-inc.com/project/3621/interface/api/237614) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/city-in-province`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
export const zlbApiExpenseAddressCityInProvinceGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseAddressCityInProvinceGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseAddressCityInProvinceGetResponse>(
    prepare(zlbApiExpenseAddressCityInProvinceGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseAddressCityInProvinceGet.requestConfig =
  zlbApiExpenseAddressCityInProvinceGetRequestConfig;

/**
 * 接口 [获取最新的地址树文件↗](http://yapi.cai-inc.com/project/3621/interface/api/368738) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/file`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressFileGetRequest {}

/**
 * 接口 [获取最新的地址树文件↗](http://yapi.cai-inc.com/project/3621/interface/api/368738) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/file`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressFileGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 地址文件的id
     */
    fileId?: string;
    /**
     * 最新修改时间
     */
    lastModifyTime?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取最新的地址树文件↗](http://yapi.cai-inc.com/project/3621/interface/api/368738) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/file`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
type ZlbApiExpenseAddressFileGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/address/file',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取最新的地址树文件↗](http://yapi.cai-inc.com/project/3621/interface/api/368738) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/file`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
const zlbApiExpenseAddressFileGetRequestConfig: ZlbApiExpenseAddressFileGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: '/zlb/api/expense/address/file',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseAddressFileGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取最新的地址树文件↗](http://yapi.cai-inc.com/project/3621/interface/api/368738) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/file`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
export const zlbApiExpenseAddressFileGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseAddressFileGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseAddressFileGetResponse>(
    prepare(zlbApiExpenseAddressFileGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseAddressFileGet.requestConfig = zlbApiExpenseAddressFileGetRequestConfig;

/**
 * 接口 [获取当前区划的选择的level↗](http://yapi.cai-inc.com/project/3621/interface/api/372210) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/level`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressLevelGetRequest {
  formType?: string;
}

/**
 * 接口 [获取当前区划的选择的level↗](http://yapi.cai-inc.com/project/3621/interface/api/372210) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/level`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseAddressLevelGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取当前区划的选择的level↗](http://yapi.cai-inc.com/project/3621/interface/api/372210) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/level`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
type ZlbApiExpenseAddressLevelGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/address/level',
    'data',
    string,
    'formType',
    false
  >
>;

/**
 * 接口 [获取当前区划的选择的level↗](http://yapi.cai-inc.com/project/3621/interface/api/372210) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/level`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
const zlbApiExpenseAddressLevelGetRequestConfig: ZlbApiExpenseAddressLevelGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: '/zlb/api/expense/address/level',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: ['formType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseAddressLevelGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取当前区划的选择的level↗](http://yapi.cai-inc.com/project/3621/interface/api/372210) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [地址↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_36419)
 * @请求头 `GET /zlb/api/expense/address/level`
 * @更新时间 `2024-02-26 09:44:54`
 * @项目ID 3621
 */
export const zlbApiExpenseAddressLevelGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseAddressLevelGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseAddressLevelGetResponse>(
    prepare(zlbApiExpenseAddressLevelGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseAddressLevelGet.requestConfig = zlbApiExpenseAddressLevelGetRequestConfig;

const mockUrl_0_1_0_5 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_5 = '' as any;
const prodUrl_0_1_0_5 = '' as any;
const dataKey_0_1_0_5 = 'data' as any;

/**
 * 接口 [订单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/247802) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/list`
 * @更新时间 `2024-11-16 11:01:41`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 供应商
   */
  supplierName?: string;
  /**
   * 商品名称
   */
  commodityName?: string;
  /**
   * 政采云订单ID
   */
  orderId?: number;
  /**
   * 订单号
   */
  orderCode?: string;
  /**
   * 订单状态
   */
  orderStatus?: number;
  /**
   * 申请单类型
   * 2-会议申请；3-培训申请；4-采购申请
   */
  applyFormType?: number;
  /**
   * 创建时间开始
   */
  createTimeStart?: string;
  /**
   * 创建时间结束
   */
  createTimeEnd?: string;
  /**
   * 是否已完成
   * 0-未完成 1-已完成 2-所有
   */
  complete?: number;
  /**
   * 申请单编号（全链路二期场景需要判断订单是否关联了此申请单）
   */
  applyFormCode?: string;
  /**
   * operatorId(个人账号或授权账号)
   */
  operatorId: number;
  /**
   * 查询类别 1-我的账号 2-授权给我的账号
   */
  queryOperatorType: number;
  associateStatus?: number;
  /**
   * 报销单号
   */
  expenseFormCode?: string;
  /**
   * 是否是搜索
   */
  isSearch?: boolean;
}

/**
 * 接口 [订单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/247802) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/list`
 * @更新时间 `2024-11-16 11:01:41`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 订单ID
       */
      orderId?: number;
      /**
       * 订单号
       */
      orderCode?: string;
      /**
       * 实际支付金额
       */
      orderAmount?: number;
      /**
       * 订单类别名称
       */
      orderCategoryDesc?: string;
      /**
       * 支付方式
       */
      paymentMethod?: 0 | 1 | 2 | 3 | 4;
      /**
       * 支付方式名称
       */
      paymentMethodDesc?: string;
      /**
       * 收货人
       */
      receiver?: string;
      /**
       * 供应名称
       */
      supplierName?: string;
      /**
       * 供应商ID
       */
      supplierId?: number;
      /**
       * 订单状态
       */
      orderStatus?: number;
      /**
       * 订单状态名称
       */
      orderStatusDesc?: string;
      /**
       * 下单时间
       */
      orderCreateTime?: string;
      /**
       * 是否关联申请单
       */
      unitApplyFormCode?: boolean;
      /**
       * 申请单编号
       */
      applyFormCode?: string;
      /**
       * 申请单业务编号
       */
      applyFormBusinessCode?: string;
      /**
       * 申请单类型
       * 2-会议申请；3-培训申请；4-采购申请
       */
      applyFormType?: number;
      /**
       * 是否关联报销单
       */
      unitExpenseFormCode?: boolean;
      expenseFromList?: {
        /**
         * 报销单编号
         */
        expenseFormCode?: string;
        /**
         * 报销单业务编号
         */
        expenseFormBusinessCode?: string;
        /**
         * 报销单类型
         * 2-会议申请；3-培训申请；4-采购申请
         */
        expenseFormType?: number;
      }[];
      /**
       * 是否必须关联申请单
       */
      necessaryUnitApplyForm?: boolean;
      /**
       * 操作
       */
      operateButton?: {
        /**
         * 订单详情
         */
        detail?: boolean;
        /**
         * 关联申请单
         */
        unitApplyForm?: boolean;
        /**
         * 取消关联申请单
         */
        undoApplyForm?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 是否可选
         * 报销单类型与订单关联的申请单类型判断是否可选
         */
        checkbox?: boolean;
      };
      /**
       * operatorId(个人账号或授权账号)
       */
      operatorId?: number;
      /**
       * 查询类别 1-我的账号 2-授权给我的账号
       */
      queryOperatorType?: number;
      /**
       * 订单剩余可报销金额
       */
      orderRemainingAmount?: number;
      /**
       * 已报销金额记录
       */
      expenseAmountRecordDTOS?: {
        /**
         * 报销单businessCode
         */
        businessCode?: string;
        /**
         * 报销金额记录
         */
        expenseAmountRecord?: number;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [订单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/247802) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/list`
 * @更新时间 `2024-11-16 11:01:41`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseOrderListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/order/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [订单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/247802) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/list`
 * @更新时间 `2024-11-16 11:01:41`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseOrderListPostRequestConfig: ZlbApiExpensePurchaseOrderListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: '/zlb/api/expense/purchase/order/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseOrderListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [订单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/247802) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/list`
 * @更新时间 `2024-11-16 11:01:41`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseOrderListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseOrderListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseOrderListPostResponse>(
    prepare(zlbApiExpensePurchaseOrderListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseOrderListPost.requestConfig = zlbApiExpensePurchaseOrderListPostRequestConfig;

/**
 * 接口 [关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/247804) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/uniteApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderUniteApplyFormPostRequest {
  /**
   * 订单号
   */
  orderCode: string;
  /**
   * 申请单号
   */
  applyFormCode: string;
  /**
   * 订单金额（分），关联申请单填写
   */
  orderAmount?: number;
}

/**
 * 接口 [关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/247804) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/uniteApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderUniteApplyFormPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/247804) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/uniteApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseOrderUniteApplyFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/order/uniteApplyForm',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/247804) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/uniteApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseOrderUniteApplyFormPostRequestConfig: ZlbApiExpensePurchaseOrderUniteApplyFormPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: '/zlb/api/expense/purchase/order/uniteApplyForm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseOrderUniteApplyFormPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/247804) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/uniteApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseOrderUniteApplyFormPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseOrderUniteApplyFormPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseOrderUniteApplyFormPostResponse>(
    prepare(zlbApiExpensePurchaseOrderUniteApplyFormPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseOrderUniteApplyFormPost.requestConfig =
  zlbApiExpensePurchaseOrderUniteApplyFormPostRequestConfig;

/**
 * 接口 [订单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/249106) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info`
 * @更新时间 `2024-06-11 13:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderInfoPostRequest {
  orderList: {
    /**
     * 订单编号
     */
    orderCode?: string;
    /**
     * operatorId(个人账号或授权账号)
     */
    operatorId?: number;
    /**
     * 查询类别 1-我的账号 2-授权给我的账号
     */
    queryOperatorType?: number;
  }[];
}

/**
 * 接口 [订单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/249106) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info`
 * @更新时间 `2024-06-11 13:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderInfoPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 结算单信息（当结算单存在时不需要关注合同信息）
     */
    payeeInfoList?: {
      /**
       * 供应商账号
       */
      account?: string;
      /**
       * 供应商账号明文，多收款人需要根据账户+收款人+收款银行聚合
       */
      accountPlaintext?: string;
      /**
       * 供应商地址
       */
      address?: string;
      /**
       * 供应商收款银行
       */
      bankName?: string;
      /**
       * 供应商名称
       */
      company?: string;
      /**
       * 结算单id
       */
      finalStatementId?: string;
      /**
       * 结算单状态
       */
      finalStatementStatus?: string;
      /**
       * 订单id
       */
      orderId?: string;
      /**
       * 收款账号名称
       */
      payeeAccountName?: string;
      /**
       * 账号code
       */
      accountCode?: string;
    }[];
    /**
     * 合同列表
     */
    contractList?: {
      /**
       * 订单号
       */
      orderCode?: string;
      /**
       * 订单编号列表 适用于办公设备家具购置报销单、政府购买服务、通用采购
       */
      orderCodeList?: string[];
      /**
       * 订单唯一编号
       */
      uniqueCode?: string;
      /**
       * 合同id
       */
      contractId?: number;
      /**
       * 合同编号
       */
      contractCode?: string;
      /**
       * 合同名称
       */
      contractName?: string;
      /**
       * 申请单编号（用印申请当做申请单）
       */
      applyFormCode?: string;
      /**
       * 报销单编号（报销单合同）
       */
      expenseFormCode?: string;
      /**
       * 合同金额（分）
       */
      amount?: number;
      /**
       * 甲方名称(采购单位)
       */
      firstPartyName?: string;
      /**
       * 甲方联系人姓名
       */
      firstPartyContact?: string;
      /**
       * 甲方联系人电话
       */
      firstPartyPhone?: string;
      /**
       * 乙方姓名(供应商)
       */
      secondPartyName?: string;
      /**
       * 乙方联系人姓名
       */
      secondPartyContact?: string;
      /**
       * 乙方联系人电话
       */
      secondPartyPhone?: string;
      /**
       * 合同内容明细
       */
      detail?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
       */
      status?: number;
      /**
       * 合同状态名称
       */
      statusDesc?: string;
      /**
       * 数据源来源：0手动添加 1政采云 3报销单
       */
      dataSource?: number;
      /**
       * 附件信息
       */
      attachment?: {
        /**
         * 1 文档信息 2 附件 3
         */
        contractType?: number;
        /**
         * 文件id
         */
        fileId?: string;
        /**
         * 文件名称
         */
        name?: string;
        /**
         * 文件类型
         */
        type?: string;
        /**
         * 文件URL
         */
        url?: string;
      }[];
      /**
       * 分期类型  1 一次性付款 2分期付款
       */
      stagingType?: number;
      /**
       * 支付期数
       */
      stagingContractList?: {
        /**
         * 支付期数
         */
        stagingCount: number;
        /**
         * 金额
         */
        amount: number;
        /**
         * 支付时间
         */
        payTime?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 支付比例
         */
        payProportion?: string;
      }[];
      /**
       * 订单编号（ID字符串）
       */
      orderNo?: string;
      /**
       * 供应商银行账号
       */
      supBankAccount?: string;
      /**
       * 供应商银行账号，多收款人需要根据账户+收款人+收款银行聚合
       */
      supBankAccountPlaintext?: string;
      /**
       * 供应商银行名称
       */
      supBankName?: string;
      /**
       * 供应商银行开户人名称
       */
      supBankPerson?: string;
      /**
       * 账户code，采购场景从合同获取的供应商收款信息入库支付账户表，返回accountCode
       */
      accountCode?: string;
      /**
       * 履约保证金
       */
      performanceBond?: number;
      /**
       * 资产管理条款
       */
      managementTerms?: number;
      /**
       * 已报销金额记录
       */
      expenseAmountRecordDTOS?: {
        /**
         * 报销单businessCode
         */
        businessCode?: string;
        /**
         * 报销金额记录
         */
        expenseAmountRecord?: number;
      }[];
      /**
       * 合同剩余可报销金额
       */
      contractRemainingAmount?: number;
    }[];
    /**
     * 发票信息
     */
    invoiceList?: {
      /**
       * 原图
       */
      originalAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 原始图片地址
       */
      originalUrl?: string;
      /**
       * 版式文件
       */
      formatAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 版式文件图片地址
       */
      formatUrl?: string;
      /**
       * 文件类型
       */
      fileType?: string;
      /**
       * 票据种类
       */
      invoiceType?: string;
      /**
       * 票据种类描述
       */
      invoiceTypeDesc?: string;
      /**
       * 开票日期
       */
      issueDate?: string;
      /**
       * 验真状态
       */
      realStatus?: number;
      /**
       * 验真状态描述
       */
      realStatusDesc?: string;
      /**
       * 消费金额
       */
      totalAmount?: number;
      /**
       * 平台发票id
       */
      platformInvoiceId?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderCode?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderId?: number;
      /**
       * 发票代码
       */
      invoiceCode?: string;
      /**
       * 发票号码
       */
      invoiceNo?: string;
      /**
       * 票据来源
       */
      dataSource?: string;
      /**
       * 发票图片地址
       */
      imageUrl?: string;
      /**
       * 政采云发票ID
       */
      zcyId?: string;
    }[];
    /**
     * 商品详情
     */
    itemList?: {
      /**
       * 商品id/协议商品id
       */
      id?: number;
      /**
       * 商品类目名称
       */
      itemCatalogName?: string;
      /**
       * 采购目录名称集合
       */
      categoryNodes?: string[];
      /**
       * 采购目录编码集合
       */
      catalogCodes?: string[];
      catalogDtos?: {
        /**
         * 采购目录编码
         */
        catalogCode?: string;
        /**
         * 采购目录名称
         */
        catalogName?: string;
      }[];
      /**
       * 商品类目id
       */
      categoryId?: number;
      /**
       * 是否必须计划书支付，默认为false
       */
      pplanMust?: boolean;
      /**
       * 商品图片url
       */
      itemImage?: string;
      /**
       * 商品名称
       */
      itemName?: string;
      /**
       * 商品类型 1基础商品 2协议商品
       */
      itemType?: number;
      /**
       * 商品id 协议供货下单使用这个
       */
      goodsId?: number;
      /**
       * 店铺id
       */
      shopId?: number;
      /**
       * 供货商id
       */
      supplierId?: number;
      /**
       * 是否是子公司,true-是子公司
       */
      isChildShop?: boolean;
      /**
       * 店铺名称
       */
      shopName?: string;
      /**
       * 商品状态
       */
      status?: number;
      /**
       * sku id
       */
      skuId?: number;
      /**
       * 商品单价，如分销的阶梯价；协议商品的sku价（或供货商二次报价）
       * 该字段目前仅在分组下单接口中使用
       */
      unitPrice?: number;
      /**
       * 商品数量
       */
      quantity?: number;
      /**
       * 协议id
       */
      protocolId?: number;
      /**
       * 协议是否有效
       */
      protocolValid?: boolean;
      /**
       * 商品渠道
       */
      layer?: number;
      /**
       * 商品本身的tag信息
       */
      tags?: {
        key?: string;
      };
      /**
       * 卖家用户id
       */
      sellerId?: number;
      /**
       * 通用行业馆域名
       */
      domain?: string;
      /**
       * app域名
       */
      appDomain?: string;
      /**
       * 商品单价
       */
      price?: number;
      /**
       * 业务实例编码
       */
      instanceCode?: string;
      /**
       * 单位
       */
      unit?: string;
      /**
       * 品牌名称
       */
      brandName?: string;
      /**
       * 品牌id
       */
      brandId?: number;
      /**
       * 型号
       */
      specification?: string;
      /**
       * 商品详情页url
       */
      detailPageUrl?: string;
      /**
       * 商品关联套装在购物车数据的主键id
       */
      cartSuitId?: number;
      /**
       * 套装id
       */
      suitId?: number;
      /**
       * 是否是套餐主商品
       */
      isSuitMaster?: boolean;
      /**
       * 套装价格
       */
      suitPrice?: number;
      /**
       * 套装价格
       */
      suitQuantity?: number;
      /**
       * 旗舰店、专卖店名称
       */
      shopFlagName?: string;
      /**
       * 类目参考价信息
       */
      categoryReferencePrice?: {
        /**
         * 商品id
         */
        itemId?: number;
        /**
         * 是否启用参考价配置价
         */
        enabled?: boolean;
        /**
         * 参考价获取方式（人工、爬虫）
         */
        source?: string;
        /**
         * 类目参考价名称
         */
        categoryPriceName?: string;
        /**
         * 类目平均参考价
         */
        referPriceDTOList?: {
          /**
           * 销售规格
           */
          salesUnit?: string;
          /**
           * 计量单位
           */
          unit?: string;
          /**
           * 平均参考价
           */
          avgReferencePrice?: number;
          /**
           * 合成标准计量单位
           */
          standardUnit?: string;
          /**
           * 合成价格
           */
          standardReferencePrice?: number;
        }[];
      };
      /**
       * 商品单位换算关系
       */
      unitConvert?: {
        /**
         * 默认选择单位
         */
        defaultUnit?: string;
        /**
         * 原单位倍数 只会传整数
         */
        originMultiple?: number;
        /**
         * 可换算单位
         */
        backUpUnit?: string;
        /**
         * 转化后单位倍数 只会传整数
         */
        convertMultiple?: number;
        /**
         * 1:等于、2:约等于
         */
        equalWay?: number;
        /**
         * 单位转换具体描述
         */
        unitConvertDesc?: string;
      };
      /**
       * 价格是否包含标配价格
       */
      priceIncludeStandardPart?: boolean;
      /**
       * 订单商品价格
       */
      skuPrice?: number;
      /**
       * 订单商品属性
       */
      attribute?: string;
      /**
       * 商品金额
       */
      fee?: number;
      /**
       * 政府采购分类编码
       */
      gpCatalogCode?: string;
    }[];
    /**
     * 合同编号
     */
    orderCode?: string;
    /**
     * 申请单Code
     */
    applyFormCode?: string;
    /**
     * 申请单业务Code
     */
    businessCode?: string;
    /**
     * 是否是用车租赁订单
     */
    isCarRentalOrder?: boolean;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [订单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/249106) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info`
 * @更新时间 `2024-06-11 13:46:09`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseOrderInfoPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/order/info',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [订单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/249106) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info`
 * @更新时间 `2024-06-11 13:46:09`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseOrderInfoPostRequestConfig: ZlbApiExpensePurchaseOrderInfoPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: '/zlb/api/expense/purchase/order/info',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseOrderInfoPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [订单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/249106) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info`
 * @更新时间 `2024-06-11 13:46:09`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseOrderInfoPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseOrderInfoPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseOrderInfoPostResponse>(
    prepare(zlbApiExpensePurchaseOrderInfoPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseOrderInfoPost.requestConfig = zlbApiExpensePurchaseOrderInfoPostRequestConfig;

/**
 * 接口 [取消关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/249108) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/undoApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderUndoApplyFormPostRequest {
  /**
   * 订单号
   */
  orderCode: string;
  /**
   * 申请单号
   */
  applyFormCode: string;
  /**
   * 订单金额（分），关联申请单填写
   */
  orderAmount?: number;
}

/**
 * 接口 [取消关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/249108) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/undoApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderUndoApplyFormPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [取消关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/249108) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/undoApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseOrderUndoApplyFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/order/undoApplyForm',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [取消关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/249108) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/undoApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseOrderUndoApplyFormPostRequestConfig: ZlbApiExpensePurchaseOrderUndoApplyFormPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: '/zlb/api/expense/purchase/order/undoApplyForm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseOrderUndoApplyFormPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [取消关联申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/249108) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/undoApplyForm`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseOrderUndoApplyFormPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseOrderUndoApplyFormPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseOrderUndoApplyFormPostResponse>(
    prepare(zlbApiExpensePurchaseOrderUndoApplyFormPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseOrderUndoApplyFormPost.requestConfig =
  zlbApiExpensePurchaseOrderUndoApplyFormPostRequestConfig;

/**
 * 接口 [跟据申请单号查询关联订单↗](http://yapi.cai-inc.com/project/3621/interface/api/250644) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/getUnitOrder/{code}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderGetUnitOrderCodeGetRequest {
  code: string;
}

/**
 * 接口 [跟据申请单号查询关联订单↗](http://yapi.cai-inc.com/project/3621/interface/api/250644) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/getUnitOrder/{code}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderGetUnitOrderCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 订单号
     */
    orderCode?: string;
    /**
     * 实际支付金额
     */
    orderAmount?: number;
    /**
     * 订单剩余可报销金额
     */
    orderRemainingAmount?: number;
    /**
     * 订单这次报销金额
     */
    orderExpenseAmount?: number;
    /**
     * 是否关联申请单
     */
    unitApplyFormCode?: boolean;
    /**
     * 申请单编号
     */
    applyFormCode?: string;
    /**
     * 申请单类型
     */
    applyFormType?: number;
    /**
     * 申请单业务编号
     */
    applyFormBusinessCode?: string;
    /**
     * 支付方式
     */
    paymentMethod?: number;
    /**
     * 支付方式描述
     */
    paymentMethodDesc?: string;
    /**
     * 供应商id
     */
    supplierId?: number;
    /**
     * 供应商名称
     */
    supplierName?: string;
    /**
     * 订单创建时间
     */
    orderCreateTime?: string;
    /**
     * 收货人
     */
    receiver?: string;
    /**
     * 订单类别
     */
    orderCategoryDesc?: string;
    /**
     * 订单状态
     */
    orderStatus?: number;
    /**
     * 订单状态描述
     */
    orderStatusDesc?: string;
    /**
     * 已报销金额记录
     */
    expenseAmountRecordDTOS?: {
      /**
       * 报销单businessCode
       */
      businessCode?: string;
      /**
       * 报销金额记录
       */
      expenseAmountRecord?: number;
    }[];
    /**
     * operatorId(个人账号或授权账号)
     */
    operatorId?: number;
    /**
     * 查询类别 1-我的账号 2-授权给我的账号
     */
    queryOperatorType?: number;
    /**
     * 是否是用车租赁订单
     */
    isCarRentalOrder?: boolean;
    /**
     * 发票附件列表
     */
    invoiceAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [跟据申请单号查询关联订单↗](http://yapi.cai-inc.com/project/3621/interface/api/250644) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/getUnitOrder/{code}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseOrderGetUnitOrderCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/order/getUnitOrder/{code}',
    'data',
    'code',
    string,
    false
  >
>;

/**
 * 接口 [跟据申请单号查询关联订单↗](http://yapi.cai-inc.com/project/3621/interface/api/250644) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/getUnitOrder/{code}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseOrderGetUnitOrderCodeGetRequestConfig: ZlbApiExpensePurchaseOrderGetUnitOrderCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: '/zlb/api/expense/purchase/order/getUnitOrder/{code}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: ['code'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseOrderGetUnitOrderCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [跟据申请单号查询关联订单↗](http://yapi.cai-inc.com/project/3621/interface/api/250644) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/getUnitOrder/{code}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseOrderGetUnitOrderCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseOrderGetUnitOrderCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseOrderGetUnitOrderCodeGetResponse>(
    prepare(zlbApiExpensePurchaseOrderGetUnitOrderCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseOrderGetUnitOrderCodeGet.requestConfig =
  zlbApiExpensePurchaseOrderGetUnitOrderCodeGetRequestConfig;

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/252042) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}`
 * @更新时间 `2023-03-09 20:07:34`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderApproveInfoOrderCodeGetRequest {
  orderCode: string;
}

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/252042) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}`
 * @更新时间 `2023-03-09 20:07:34`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderApproveInfoOrderCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 订单ID
     */
    orderId?: number;
    /**
     * 订单号
     */
    orderCode?: string;
    /**
     * 订单总金额
     */
    realPrice?: number;
    /**
     * 订单状态
     */
    orderStatus?:
      | 'SUPPLIER_REJECT'
      | 'APPLY_CANCEL'
      | 'CANCEL'
      | 'ALL_BACKED'
      | 'ANNOUNCE_NOT_PASS'
      | 'AUTO_REJECT'
      | 'WAITING_FOR_RECEIVED'
      | 'RECEIVED'
      | 'DELIVER_PART'
      | 'DELIVER_ALL'
      | 'WAITING_FOR_ACCEPTANCE'
      | 'WAITING_FOR_SETTLE'
      | 'STARTING_SETTLE'
      | 'DONE'
      | 'PAY_ONLINE'
      | 'RETURN'
      | 'PURCHASER_CONFIRM'
      | 'PURCHASER_REJECT_CONFIRM'
      | 'CONTRACT_SIGN'
      | 'PURCHASER_WAIT_PAY'
      | 'RECEIVED_WAIT_QUOTE'
      | 'ANNOUNCE'
      | 'NEGOTIATE_WAIT_QUOTE';
    /**
     * 订单状态名称
     */
    orderStatusDesc?: string;
    /**
     * 供应名称
     */
    supplierName?: string;
    /**
     * 供应商ID
     */
    supplierId?: number;
    /**
     * 商品信息
     */
    commodityList?: {
      /**
       * 唯一编码
       */
      uniqueCode?: string;
      /**
       * 商品编号
       */
      commodityCode?: string;
      /**
       * 商品名称
       */
      commodityName?: string;
      /**
       * 供应商ID
       */
      supplierId?: number;
      /**
       * 供应商名称
       */
      supplierName?: string;
      /**
       * 规则描述
       */
      specification?: string;
      /**
       * 单价（分）
       */
      unitPrice?: number;
      /**
       * 小记（分）
       */
      totalPrice?: number;
      /**
       * 数量
       */
      amount?: number;
      /**
       * 商品数据来源：0-浙里报 1-政采云
       */
      commoditySource?: number;
      /**
       * 拓展字段
       */
      extendDataDTO?: {
        /**
         * 实例名称
         */
        instanceName?: string;
        /**
         * 品牌
         */
        brandName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 商品详情页url
         */
        detailPageUrl?: string;
        /**
         * 所有服务商品单价和
         */
        serviceTotalPrice?: number;
        /**
         * 服务单价和
         */
        sumServiceTotalPrice?: number;
        /**
         * 计量单位
         */
        unit?: string;
        /**
         * 是否进口：1是、0否
         */
        isImport?: number;
        /**
         * 是否适宜中小企业：1是、0否
         */
        isSuit?: number;
        /**
         * 采购目录code（选择的）
         */
        catalogCodeList?: string[];
        /**
         * First catalogCodeList
         */
        category?: string;
        /**
         * 采购目录name（选择的）
         */
        catalogNameList?: string[];
        /**
         * 政府购买服务目录code（选择的）
         */
        serviceCodeList?: string[];
        /**
         * 政府购买服务目录name（选择的）
         */
        serviceNameList?: string[];
        /**
         * 采购目录信息(从购物车取的数据)
         */
        catalogList?: {
          /**
           * 采购目录编码
           */
          catalogCode?: string;
          /**
           * 采购目录名称
           */
          catalogName?: string;
        }[];
        /**
         * 商品属性信息
         */
        attributeList?: {
          /**
           * 属性名称
           */
          attributeName?: string;
          /**
           * 属性值
           */
          attributeValue?: string;
        }[];
        /**
         * 商品服务项信息
         */
        standards?: {
          /**
           * 服务商品ID
           */
          standardId?: number;
          /**
           * 服务名称
           */
          standardName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 服务价格
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 商品服务信息
         */
        services?: {
          /**
           * 服务名称
           */
          serviceName?: string;
          /**
           * 服务属性
           */
          serviceAttribute?: string;
          /**
           * 服务id
           */
          serviceId?: number;
          /**
           * 单价
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
          /**
           * 数量 随着商品增加
           */
          amount?: number;
        }[];
        /**
         * 选配信息
         */
        news?: {
          /**
           * 购物车配件主键 id
           */
          newsId?: number;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 品牌名称
           */
          newsName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 配件单价，单位：分
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 使用人信息
         */
        userInfo?: {
          /**
           * 职级
           * 1-厅级 2-处级 3-处级以下
           */
          userRank: 'USER_RANK_TJ' | 'USER_RANK_CJ' | 'USER_RANK_CJYX';
          /**
           * 职级描述
           */
          userRankDesc?: string;
          /**
           * 使用人姓名
           */
          userName: string;
        };
        /**
         * 资产类型
         * 1-办公家具 2-办公设备
         */
        propertyType?: string;
        /**
         * 资产类型描述
         */
        propertyTypeDesc?: string;
        /**
         * 资产品目
         */
        propertyItem?: string;
        /**
         * 资产品目类型
         */
        propertyItemDesc?: string;
        /**
         * 商品类目
         */
        itemCatalogName?: string;
      };
      /**
       * 外部sku
       */
      skuCode?: number;
      /**
       * 商品附件
       */
      attachmentList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      }[];
    }[];
    /**
     * 报销单合同信息
     */
    contractExpenseFormList?: {
      /**
       * 合同唯一编号
       */
      uniqueCode?: string;
      /**
       * 政采云合同id
       */
      contractId?: number;
      /**
       * 合同编号
       */
      contractCode?: string;
      /**
       * 合同名称
       */
      contractName?: string;
      /**
       * 订单编号
       */
      orderCode?: string;
      /**
       * 订单编号列表 适用于办公设备家具购置报销单、政府购买服务、通用采购
       */
      orderCodeList?: string[];
      /**
       * 合同金额（分）
       */
      amount?: number;
      /**
       * 此次报销金额（分）
       */
      contractExpenseAmount?: number;
      /**
       * 合同剩余可报销金额
       */
      contractRemainingAmount?: number;
      /**
       * 数据源来源：2报销单订单 3报销单手动添加
       */
      dataSource?: number;
      /**
       * 合同创建时间
       */
      contractCreateTime?: string;
      /**
       * 附件信息
       */
      attachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      }[];
      normalAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      }[];
      /**
       * 合同报销方式
       */
      expenseType?: number;
      /**
       * 支付方式
       */
      paymentMethod?: number;
      /**
       * 分期数
       */
      paymentPeriod?: number;
      /**
       * 已报销金额记录
       */
      expenseAmountRecordDTOS?: {
        /**
         * 报销单businessCode
         */
        businessCode?: string;
        /**
         * 报销金额记录
         */
        expenseAmountRecord?: number;
      }[];
      /**
       * 合同分期记录
       */
      stagingContractList?: {
        /**
         * 支付期数
         */
        stagingCount: number;
        /**
         * 金额
         */
        amount: number;
        /**
         * 支付时间
         */
        payTime?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 支付比例
         */
        payProportion?: string;
      }[];
    }[];
    /**
     * 单据发票信息列表
     */
    formInvoiceInfoList?: {
      /**
       * 原图
       */
      originalAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 原始图片地址
       */
      originalUrl?: string;
      /**
       * 版式文件
       */
      formatAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 版式文件图片地址
       */
      formatUrl?: string;
      /**
       * 文件类型
       */
      fileType?: string;
      /**
       * 票据种类
       */
      invoiceType?: string;
      /**
       * 票据种类描述
       */
      invoiceTypeDesc?: string;
      /**
       * 开票日期
       */
      issueDate?: string;
      /**
       * 验真状态
       */
      realStatus?: number;
      /**
       * 验真状态描述
       */
      realStatusDesc?: string;
      /**
       * 消费金额
       */
      totalAmount?: number;
      /**
       * 平台发票id
       */
      platformInvoiceId?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderCode?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderId?: number;
      /**
       * 发票代码
       */
      invoiceCode?: string;
      /**
       * 发票号码
       */
      invoiceNo?: string;
      /**
       * 票据来源
       */
      dataSource?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/252042) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}`
 * @更新时间 `2023-03-09 20:07:34`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseOrderApproveInfoOrderCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/order/approve/info/{orderCode}',
    'data',
    'orderCode',
    string,
    false
  >
>;

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/252042) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}`
 * @更新时间 `2023-03-09 20:07:34`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseOrderApproveInfoOrderCodeGetRequestConfig: ZlbApiExpensePurchaseOrderApproveInfoOrderCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: '/zlb/api/expense/purchase/order/approve/info/{orderCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: ['orderCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseOrderApproveInfoOrderCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/252042) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}`
 * @更新时间 `2023-03-09 20:07:34`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseOrderApproveInfoOrderCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseOrderApproveInfoOrderCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseOrderApproveInfoOrderCodeGetResponse>(
    prepare(zlbApiExpensePurchaseOrderApproveInfoOrderCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseOrderApproveInfoOrderCodeGet.requestConfig =
  zlbApiExpensePurchaseOrderApproveInfoOrderCodeGetRequestConfig;

/**
 * 接口 [orderDetailMulti↗](http://yapi.cai-inc.com/project/3621/interface/api/407834) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info-multi`
 * @更新时间 `2024-06-11 13:46:10`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderInfoMultiPostRequest {
  orderList: {
    /**
     * 订单编号
     */
    orderCode?: string;
    /**
     * operatorId(个人账号或授权账号)
     */
    operatorId?: number;
    /**
     * 查询类别 1-我的账号 2-授权给我的账号
     */
    queryOperatorType?: number;
  }[];
}

/**
 * 接口 [orderDetailMulti↗](http://yapi.cai-inc.com/project/3621/interface/api/407834) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info-multi`
 * @更新时间 `2024-06-11 13:46:10`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderInfoMultiPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    orderDetail?: {
      /**
       * 结算单信息（当结算单存在时不需要关注合同信息）
       */
      payeeInfoList?: {
        /**
         * 供应商账号
         */
        account?: string;
        /**
         * 供应商账号明文，多收款人需要根据账户+收款人+收款银行聚合
         */
        accountPlaintext?: string;
        /**
         * 供应商地址
         */
        address?: string;
        /**
         * 供应商收款银行
         */
        bankName?: string;
        /**
         * 供应商名称
         */
        company?: string;
        /**
         * 结算单id
         */
        finalStatementId?: string;
        /**
         * 结算单状态
         */
        finalStatementStatus?: string;
        /**
         * 订单id
         */
        orderId?: string;
        /**
         * 收款账号名称
         */
        payeeAccountName?: string;
        /**
         * 账号code
         */
        accountCode?: string;
      }[];
      /**
       * 合同列表
       */
      contractList?: {
        /**
         * 订单号
         */
        orderCode?: string;
        /**
         * 订单编号列表 适用于办公设备家具购置报销单、政府购买服务、通用采购
         */
        orderCodeList?: string[];
        /**
         * 订单唯一编号
         */
        uniqueCode?: string;
        /**
         * 合同id
         */
        contractId?: number;
        /**
         * 合同编号
         */
        contractCode?: string;
        /**
         * 合同名称
         */
        contractName?: string;
        /**
         * 申请单编号（用印申请当做申请单）
         */
        applyFormCode?: string;
        /**
         * 报销单编号（报销单合同）
         */
        expenseFormCode?: string;
        /**
         * 合同金额（分）
         */
        amount?: number;
        /**
         * 甲方名称(采购单位)
         */
        firstPartyName?: string;
        /**
         * 甲方联系人姓名
         */
        firstPartyContact?: string;
        /**
         * 甲方联系人电话
         */
        firstPartyPhone?: string;
        /**
         * 乙方姓名(供应商)
         */
        secondPartyName?: string;
        /**
         * 乙方联系人姓名
         */
        secondPartyContact?: string;
        /**
         * 乙方联系人电话
         */
        secondPartyPhone?: string;
        /**
         * 合同内容明细
         */
        detail?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
         */
        status?: number;
        /**
         * 合同状态名称
         */
        statusDesc?: string;
        /**
         * 数据源来源：0手动添加 1政采云 3报销单
         */
        dataSource?: number;
        /**
         * 附件信息
         */
        attachment?: {
          /**
           * 1 文档信息 2 附件 3
           */
          contractType?: number;
          /**
           * 文件id
           */
          fileId?: string;
          /**
           * 文件名称
           */
          name?: string;
          /**
           * 文件类型
           */
          type?: string;
          /**
           * 文件URL
           */
          url?: string;
        }[];
        /**
         * 分期类型  1 一次性付款 2分期付款
         */
        stagingType?: number;
        /**
         * 支付期数
         */
        stagingContractList?: {
          /**
           * 支付期数
           */
          stagingCount: number;
          /**
           * 金额
           */
          amount: number;
          /**
           * 支付时间
           */
          payTime?: string;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 支付比例
           */
          payProportion?: string;
        }[];
        /**
         * 订单编号（ID字符串）
         */
        orderNo?: string;
        /**
         * 供应商银行账号
         */
        supBankAccount?: string;
        /**
         * 供应商银行账号，多收款人需要根据账户+收款人+收款银行聚合
         */
        supBankAccountPlaintext?: string;
        /**
         * 供应商银行名称
         */
        supBankName?: string;
        /**
         * 供应商银行开户人名称
         */
        supBankPerson?: string;
        /**
         * 账户code，采购场景从合同获取的供应商收款信息入库支付账户表，返回accountCode
         */
        accountCode?: string;
        /**
         * 履约保证金
         */
        performanceBond?: number;
        /**
         * 资产管理条款
         */
        managementTerms?: number;
        /**
         * 已报销金额记录
         */
        expenseAmountRecordDTOS?: {
          /**
           * 报销单businessCode
           */
          businessCode?: string;
          /**
           * 报销金额记录
           */
          expenseAmountRecord?: number;
        }[];
        /**
         * 合同剩余可报销金额
         */
        contractRemainingAmount?: number;
      }[];
      /**
       * 发票信息
       */
      invoiceList?: {
        /**
         * 原图
         */
        originalAttachment?: {
          /**
           * 附件OssId
           */
          fileId?: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
          /**
           * 文件大小描述
           */
          sizeDesc?: string;
        };
        /**
         * 原始图片地址
         */
        originalUrl?: string;
        /**
         * 版式文件
         */
        formatAttachment?: {
          /**
           * 附件OssId
           */
          fileId?: string;
          /**
           * 附件类型
           */
          type?: string;
          /**
           * 附件名称
           */
          name?: string;
          /**
           * 附件大小
           */
          size?: number;
          /**
           * 桶的key
           */
          bizCode?: string;
          /**
           * 下载文件的url
           */
          url?: string;
          /**
           * 文件大小描述
           */
          sizeDesc?: string;
        };
        /**
         * 版式文件图片地址
         */
        formatUrl?: string;
        /**
         * 文件类型
         */
        fileType?: string;
        /**
         * 票据种类
         */
        invoiceType?: string;
        /**
         * 票据种类描述
         */
        invoiceTypeDesc?: string;
        /**
         * 开票日期
         */
        issueDate?: string;
        /**
         * 验真状态
         */
        realStatus?: number;
        /**
         * 验真状态描述
         */
        realStatusDesc?: string;
        /**
         * 消费金额
         */
        totalAmount?: number;
        /**
         * 平台发票id
         */
        platformInvoiceId?: string;
        /**
         * 订单编号 for 会议/培训/办公用品采购
         */
        orderCode?: string;
        /**
         * 订单编号 for 会议/培训/办公用品采购
         */
        orderId?: number;
        /**
         * 发票代码
         */
        invoiceCode?: string;
        /**
         * 发票号码
         */
        invoiceNo?: string;
        /**
         * 票据来源
         */
        dataSource?: string;
        /**
         * 发票图片地址
         */
        imageUrl?: string;
        /**
         * 政采云发票ID
         */
        zcyId?: string;
      }[];
      /**
       * 商品详情
       */
      itemList?: {
        /**
         * 商品id/协议商品id
         */
        id?: number;
        /**
         * 商品类目名称
         */
        itemCatalogName?: string;
        /**
         * 采购目录名称集合
         */
        categoryNodes?: string[];
        /**
         * 采购目录编码集合
         */
        catalogCodes?: string[];
        catalogDtos?: {
          /**
           * 采购目录编码
           */
          catalogCode?: string;
          /**
           * 采购目录名称
           */
          catalogName?: string;
        }[];
        /**
         * 商品类目id
         */
        categoryId?: number;
        /**
         * 是否必须计划书支付，默认为false
         */
        pplanMust?: boolean;
        /**
         * 商品图片url
         */
        itemImage?: string;
        /**
         * 商品名称
         */
        itemName?: string;
        /**
         * 商品类型 1基础商品 2协议商品
         */
        itemType?: number;
        /**
         * 商品id 协议供货下单使用这个
         */
        goodsId?: number;
        /**
         * 店铺id
         */
        shopId?: number;
        /**
         * 供货商id
         */
        supplierId?: number;
        /**
         * 是否是子公司,true-是子公司
         */
        isChildShop?: boolean;
        /**
         * 店铺名称
         */
        shopName?: string;
        /**
         * 商品状态
         */
        status?: number;
        /**
         * sku id
         */
        skuId?: number;
        /**
         * 商品单价，如分销的阶梯价；协议商品的sku价（或供货商二次报价）
         * 该字段目前仅在分组下单接口中使用
         */
        unitPrice?: number;
        /**
         * 商品数量
         */
        quantity?: number;
        /**
         * 协议id
         */
        protocolId?: number;
        /**
         * 协议是否有效
         */
        protocolValid?: boolean;
        /**
         * 商品渠道
         */
        layer?: number;
        /**
         * 商品本身的tag信息
         */
        tags?: {
          key?: string;
        };
        /**
         * 卖家用户id
         */
        sellerId?: number;
        /**
         * 通用行业馆域名
         */
        domain?: string;
        /**
         * app域名
         */
        appDomain?: string;
        /**
         * 商品单价
         */
        price?: number;
        /**
         * 业务实例编码
         */
        instanceCode?: string;
        /**
         * 单位
         */
        unit?: string;
        /**
         * 品牌名称
         */
        brandName?: string;
        /**
         * 品牌id
         */
        brandId?: number;
        /**
         * 型号
         */
        specification?: string;
        /**
         * 商品详情页url
         */
        detailPageUrl?: string;
        /**
         * 商品关联套装在购物车数据的主键id
         */
        cartSuitId?: number;
        /**
         * 套装id
         */
        suitId?: number;
        /**
         * 是否是套餐主商品
         */
        isSuitMaster?: boolean;
        /**
         * 套装价格
         */
        suitPrice?: number;
        /**
         * 套装价格
         */
        suitQuantity?: number;
        /**
         * 旗舰店、专卖店名称
         */
        shopFlagName?: string;
        /**
         * 类目参考价信息
         */
        categoryReferencePrice?: {
          /**
           * 商品id
           */
          itemId?: number;
          /**
           * 是否启用参考价配置价
           */
          enabled?: boolean;
          /**
           * 参考价获取方式（人工、爬虫）
           */
          source?: string;
          /**
           * 类目参考价名称
           */
          categoryPriceName?: string;
          /**
           * 类目平均参考价
           */
          referPriceDTOList?: {
            /**
             * 销售规格
             */
            salesUnit?: string;
            /**
             * 计量单位
             */
            unit?: string;
            /**
             * 平均参考价
             */
            avgReferencePrice?: number;
            /**
             * 合成标准计量单位
             */
            standardUnit?: string;
            /**
             * 合成价格
             */
            standardReferencePrice?: number;
          }[];
        };
        /**
         * 商品单位换算关系
         */
        unitConvert?: {
          /**
           * 默认选择单位
           */
          defaultUnit?: string;
          /**
           * 原单位倍数 只会传整数
           */
          originMultiple?: number;
          /**
           * 可换算单位
           */
          backUpUnit?: string;
          /**
           * 转化后单位倍数 只会传整数
           */
          convertMultiple?: number;
          /**
           * 1:等于、2:约等于
           */
          equalWay?: number;
          /**
           * 单位转换具体描述
           */
          unitConvertDesc?: string;
        };
        /**
         * 价格是否包含标配价格
         */
        priceIncludeStandardPart?: boolean;
        /**
         * 订单商品价格
         */
        skuPrice?: number;
        /**
         * 订单商品属性
         */
        attribute?: string;
        /**
         * 商品金额
         */
        fee?: number;
        /**
         * 政府采购分类编码
         */
        gpCatalogCode?: string;
      }[];
      /**
       * 合同编号
       */
      orderCode?: string;
      /**
       * 申请单Code
       */
      applyFormCode?: string;
      /**
       * 申请单业务Code
       */
      businessCode?: string;
      /**
       * 是否是用车租赁订单
       */
      isCarRentalOrder?: boolean;
    }[];
    /**
     * 是否有错误订单
     */
    isError?: boolean;
    /**
     * 错误订单信息
     */
    orderErrorDetails?: {
      orderCode?: string;
      errorMessage?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [orderDetailMulti↗](http://yapi.cai-inc.com/project/3621/interface/api/407834) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info-multi`
 * @更新时间 `2024-06-11 13:46:10`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseOrderInfoMultiPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/order/info-multi',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [orderDetailMulti↗](http://yapi.cai-inc.com/project/3621/interface/api/407834) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info-multi`
 * @更新时间 `2024-06-11 13:46:10`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseOrderInfoMultiPostRequestConfig: ZlbApiExpensePurchaseOrderInfoMultiPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: '/zlb/api/expense/purchase/order/info-multi',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseOrderInfoMultiPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [orderDetailMulti↗](http://yapi.cai-inc.com/project/3621/interface/api/407834) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/info-multi`
 * @更新时间 `2024-06-11 13:46:10`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseOrderInfoMultiPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseOrderInfoMultiPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseOrderInfoMultiPostResponse>(
    prepare(zlbApiExpensePurchaseOrderInfoMultiPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseOrderInfoMultiPost.requestConfig =
  zlbApiExpensePurchaseOrderInfoMultiPostRequestConfig;

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/620346) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}/{operatorId}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGetRequest {
  orderCode: string;
  operatorId: string;
}

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/620346) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}/{operatorId}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 订单ID
     */
    orderId?: number;
    /**
     * 订单号
     */
    orderCode?: string;
    /**
     * 订单总金额
     */
    realPrice?: number;
    /**
     * 订单状态
     */
    orderStatus?: number;
    /**
     * 订单状态名称
     */
    orderStatusDesc?: string;
    /**
     * 供应名称
     */
    supplierName?: string;
    /**
     * 供应商ID
     */
    supplierId?: number;
    /**
     * 商品信息
     */
    commodityList?: {
      /**
       * 唯一编码
       */
      uniqueCode?: string;
      /**
       * 商品编号
       */
      commodityCode?: string;
      /**
       * 商品名称
       */
      commodityName?: string;
      /**
       * 供应商ID
       */
      supplierId?: number;
      /**
       * 供应商名称
       */
      supplierName?: string;
      /**
       * 规则描述
       */
      specification?: string;
      /**
       * 单价（分）
       */
      unitPrice?: number;
      /**
       * 小记（分）
       */
      totalPrice?: number;
      /**
       * 数量
       */
      amount?: number;
      /**
       * 商品数据来源：0-浙里报 1-政采云
       */
      commoditySource?: number;
      /**
       * 拓展字段
       */
      extendDataDTO?: {
        /**
         * 实例名称
         */
        instanceName?: string;
        /**
         * 品牌
         */
        brandName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 商品详情页url
         */
        detailPageUrl?: string;
        /**
         * 所有服务商品单价和
         */
        serviceTotalPrice?: number;
        /**
         * 服务单价和
         */
        sumServiceTotalPrice?: number;
        /**
         * 计量单位
         */
        unit?: string;
        /**
         * 是否进口：1是、0否
         */
        isImport?: number;
        /**
         * 是否适宜中小企业：1是、0否
         */
        isSuit?: number;
        /**
         * 不适宜中小企业理由
         */
        noSuitReason?: string;
        /**
         * 采购目录code（选择的）
         */
        catalogCodeList?: string[];
        /**
         * First catalogCodeList
         */
        category?: string;
        /**
         * 采购目录name（选择的）
         */
        catalogNameList?: string[];
        /**
         * 政府购买服务目录code（选择的）
         */
        serviceCodeList?: string[];
        /**
         * 政府购买服务目录name（选择的）
         */
        serviceNameList?: string[];
        /**
         * 采购目录信息(从购物车取的数据)
         */
        catalogList?: {
          /**
           * 采购目录编码
           */
          catalogCode?: string;
          /**
           * 采购目录名称
           */
          catalogName?: string;
        }[];
        /**
         * 商品属性信息
         */
        attributeList?: {
          /**
           * 属性名称
           */
          attributeName?: string;
          /**
           * 属性值
           */
          attributeValue?: string;
        }[];
        /**
         * 商品服务项信息
         */
        standards?: {
          /**
           * 服务商品ID
           */
          standardId?: number;
          /**
           * 服务名称
           */
          standardName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 服务价格
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 商品服务信息
         */
        services?: {
          /**
           * 服务名称
           */
          serviceName?: string;
          /**
           * 服务属性
           */
          serviceAttribute?: string;
          /**
           * 服务id
           */
          serviceId?: number;
          /**
           * 单价
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
          /**
           * 数量 随着商品增加
           */
          amount?: number;
        }[];
        /**
         * 选配信息
         */
        news?: {
          /**
           * 购物车配件主键 id
           */
          newsId?: number;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 品牌名称
           */
          newsName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 配件单价，单位：分
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 使用人信息
         */
        userInfo?: {
          /**
           * 职级
           * 1-厅级 2-处级 3-处级以下
           */
          userRank: 1 | 2 | 3;
          /**
           * 职级描述
           */
          userRankDesc?: string;
          /**
           * 使用人姓名
           */
          userName: string;
        };
        /**
         * 资产类型
         * 1-办公家具 2-办公设备
         */
        propertyType?: string;
        /**
         * 资产类型描述
         */
        propertyTypeDesc?: string;
        /**
         * 资产品目
         */
        propertyItem?: string;
        /**
         * 资产品目类型
         */
        propertyItemDesc?: string;
        /**
         * 商品类目
         */
        itemCatalogName?: string;
        /**
         * 会议桌容纳人数
         */
        userCount?: number;
        /**
         * 政采云商品链接，用户填写，自动解析出商品数据
         */
        zcyUrl?: string;
        /**
         * 是否国产，资产类别为办公设备时可填，如果为是，不进行费控  1是、0否
         */
        domestic?: number;
        /**
         * 商品主图
         */
        mainImage?: string;
      };
      /**
       * 外部sku
       */
      skuCode?: number;
      /**
       * 商品附件
       */
      attachmentList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      }[];
    }[];
    /**
     * 报销单合同信息
     */
    contractExpenseFormList?: {
      /**
       * 政采云合同id
       */
      contractId?: number;
      /**
       * 订单编号
       */
      orderCode?: string;
      /**
       * 订单编号列表 适用于办公设备家具购置报销单、政府购买服务、通用采购
       * 「已废弃」
       */
      orderCodeList?: string[];
      /**
       * 支付申请编码
       */
      paymentApplyCodeList?: string[];
      /**
       * 合同版本编号
       */
      contractVersionUniqueCode?: string;
      /**
       * 合同编号
       */
      contractCode?: string;
      /**
       * 合同名称
       */
      contractName?: string;
      /**
       * 合同金额（分）
       */
      amount?: number;
      /**
       * 此次报销金额（分）
       */
      contractExpenseAmount?: number;
      /**
       * 合同剩余可报销金额
       */
      contractRemainingAmount?: number;
      /**
       * 数据源来源：2报销单订单 3报销单手动添加
       */
      dataSource?: number;
      /**
       * 合同创建时间
       */
      contractCreateTime?: string;
      /**
       * 合同附件信息
       */
      attachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      }[];
      /**
       * 普通附件
       */
      normalAttachmentList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      }[];
      /**
       * 合同报销方式
       * 「已废弃」
       */
      expenseType?: number;
      /**
       * 支付方式
       * 「已废弃」
       */
      paymentMethod?: number;
      /**
       * 已报销金额记录
       * 「已废弃」
       */
      expenseAmountRecordDTOS?: {
        /**
         * 报销单businessCode
         */
        businessCode?: string;
        /**
         * 报销金额记录
         */
        expenseAmountRecord?: number;
      }[];
      /**
       * 支付方式：1-一次性支付，2-分期支付
       */
      stagingType?: number;
      /**
       * 分期数
       */
      paymentPeriod?: number;
      /**
       * 合同分期记录
       */
      stagingContractList?: {
        /**
         * 支付期数编码
         */
        periodCode?: string;
        /**
         * 支付期数
         */
        stagingCount?: number;
        /**
         * 金额
         */
        amount?: number;
        /**
         * 支付时间
         */
        payTime?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 支付比例
         */
        payProportion?: string;
        /**
         * 报销单唯一编码（主键）
         */
        expenseFormCode?: string;
        /**
         * 报销单业务编码
         */
        expenseBusinesssCode?: string;
      }[];
    }[];
    /**
     * 单据发票信息列表
     */
    formInvoiceInfoList?: {
      /**
       * 原图
       */
      originalAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      };
      /**
       * 原始图片地址
       */
      originalUrl?: string;
      /**
       * 版式文件
       */
      formatAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 附件业务类型
         */
        subBizType?:
          | 1
          | 2
          | 3
          | 4
          | 5
          | 6
          | 7
          | 8
          | 9
          | 10
          | 11
          | 12
          | 13
          | 14
          | 15
          | 16
          | 17
          | 18
          | 19
          | 20
          | 21
          | 22;
      };
      /**
       * 版式文件图片地址
       */
      formatUrl?: string;
      /**
       * 文件类型
       */
      fileType?: string;
      /**
       * 票据种类
       */
      invoiceType?: string;
      /**
       * 票据种类描述
       */
      invoiceTypeDesc?: string;
      /**
       * 开票日期
       */
      issueDate?: string;
      /**
       * 验真状态
       */
      realStatus?: number;
      /**
       * 验真状态描述
       */
      realStatusDesc?: string;
      /**
       * 消费金额
       */
      totalAmount?: number;
      /**
       * 平台发票id
       */
      platformInvoiceId?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderCode?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderId?: number;
      /**
       * 发票代码
       */
      invoiceCode?: string;
      /**
       * 发票号码
       */
      invoiceNo?: string;
      /**
       * 票据来源
       */
      dataSource?: string;
      /**
       * 发票图片地址
       */
      imageUrl?: string;
      /**
       * 政采云发票ID
       */
      zcyId?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/620346) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}/{operatorId}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/order/approve/info/{orderCode}/{operatorId}',
    'data',
    'orderCode' | 'operatorId',
    string,
    false
  >
>;

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/620346) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}/{operatorId}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGetRequestConfig: ZlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: '/zlb/api/expense/purchase/order/approve/info/{orderCode}/{operatorId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: ['orderCode', 'operatorId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [订单详情(审核)↗](http://yapi.cai-inc.com/project/3621/interface/api/620346) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `GET /zlb/api/expense/purchase/order/approve/info/{orderCode}/{operatorId}`
 * @更新时间 `2024-11-16 11:01:42`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGet = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGetResponse>(
    prepare(zlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGet.requestConfig =
  zlbApiExpensePurchaseOrderApproveInfoOrderCodeOperatorIdGetRequestConfig;

/**
 * 接口 [报销记录↗](http://yapi.cai-inc.com/project/3621/interface/api/730258) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/expense-records`
 * @更新时间 `2024-11-16 11:01:43`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderExpenseRecordsPostRequest {
  /**
   * 合同编号
   */
  businessCode: string;
  /**
   * 合同金额（分）
   */
  amount: number;
}

/**
 * 接口 [报销记录↗](http://yapi.cai-inc.com/project/3621/interface/api/730258) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/expense-records`
 * @更新时间 `2024-11-16 11:01:43`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseOrderExpenseRecordsPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 剩余金额
     */
    balanceAmount?: number;
    /**
     * 报销记录
     */
    contractRemainingList?: {
      /**
       * 发起人姓名
       */
      userName?: string;
      /**
       * 报销订单号
       */
      businessCode?: string;
      /**
       * 本次报销金额
       */
      remainingAmount?: number;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [报销记录↗](http://yapi.cai-inc.com/project/3621/interface/api/730258) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/expense-records`
 * @更新时间 `2024-11-16 11:01:43`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseOrderExpenseRecordsPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/order/expense-records',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [报销记录↗](http://yapi.cai-inc.com/project/3621/interface/api/730258) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/expense-records`
 * @更新时间 `2024-11-16 11:01:43`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseOrderExpenseRecordsPostRequestConfig: ZlbApiExpensePurchaseOrderExpenseRecordsPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: '/zlb/api/expense/purchase/order/expense-records',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseOrderExpenseRecordsPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [报销记录↗](http://yapi.cai-inc.com/project/3621/interface/api/730258) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的订单↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_41712)
 * @请求头 `POST /zlb/api/expense/purchase/order/expense-records`
 * @更新时间 `2024-11-16 11:01:43`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseOrderExpenseRecordsPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseOrderExpenseRecordsPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseOrderExpenseRecordsPostResponse>(
    prepare(zlbApiExpensePurchaseOrderExpenseRecordsPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseOrderExpenseRecordsPost.requestConfig =
  zlbApiExpensePurchaseOrderExpenseRecordsPostRequestConfig;

const mockUrl_0_1_0_6 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_6 = '' as any;
const prodUrl_0_1_0_6 = '' as any;
const dataKey_0_1_0_6 = 'data' as any;

/**
 * 接口 [购物车列表↗](http://yapi.cai-inc.com/project/3621/interface/api/288042) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `POST /zlb/api/expense/purchase/commodity/list`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseCommodityListPostRequest {
  /**
   * operatorId(个人账号或授权账号)
   */
  operatorId: number;
  /**
   * 查询类别 1-我的账号 2-授权给我的账号
   */
  queryOperatorType: number;
}

/**
 * 接口 [购物车列表↗](http://yapi.cai-inc.com/project/3621/interface/api/288042) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `POST /zlb/api/expense/purchase/commodity/list`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseCommodityListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 供应商ID
     */
    supplierId?: number;
    /**
     * 供应商名称
     */
    supplierName?: string;
    /**
     * 商品信息
     */
    itemList?: {
      /**
       * 唯一编码
       */
      uniqueCode?: string;
      /**
       * 商品编号
       */
      commodityCode?: string;
      /**
       * 商品名称
       */
      commodityName?: string;
      /**
       * 供应商ID
       */
      supplierId?: number;
      /**
       * 供应商名称
       */
      supplierName?: string;
      /**
       * 规则描述
       */
      specification?: string;
      /**
       * 单价（分）
       */
      unitPrice?: number;
      /**
       * 小记（分）
       */
      totalPrice?: number;
      /**
       * 数量
       */
      amount?: number;
      /**
       * 商品数据来源：0-浙里报 1-政采云
       */
      commoditySource?: number;
      /**
       * 拓展字段
       */
      extendDataDTO?: {
        /**
         * 实例名称
         */
        instanceName?: string;
        /**
         * 品牌
         */
        brandName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 商品详情页url
         */
        detailPageUrl?: string;
        /**
         * 所有服务商品单价和
         */
        serviceTotalPrice?: number;
        /**
         * 服务单价和
         */
        sumServiceTotalPrice?: number;
        /**
         * 计量单位
         */
        unit?: string;
        /**
         * 是否进口：1是、0否
         */
        isImport?: number;
        /**
         * 是否适宜中小企业：1是、0否
         */
        isSuit?: number;
        /**
         * 不适宜中小企业理由
         */
        noSuitReason?: string;
        /**
         * 采购目录code（选择的）
         */
        catalogCodeList?: string[];
        /**
         * First catalogCodeList
         */
        category?: string;
        /**
         * 采购目录name（选择的）
         */
        catalogNameList?: string[];
        /**
         * 政府购买服务目录code（选择的）
         */
        serviceCodeList?: string[];
        /**
         * 政府购买服务目录name（选择的）
         */
        serviceNameList?: string[];
        /**
         * 采购目录信息(从购物车取的数据)
         */
        catalogList?: {
          /**
           * 采购目录编码
           */
          catalogCode?: string;
          /**
           * 采购目录名称
           */
          catalogName?: string;
        }[];
        /**
         * 商品属性信息
         */
        attributeList?: {
          /**
           * 属性名称
           */
          attributeName?: string;
          /**
           * 属性值
           */
          attributeValue?: string;
        }[];
        /**
         * 商品服务项信息
         */
        standards?: {
          /**
           * 服务商品ID
           */
          standardId?: number;
          /**
           * 服务名称
           */
          standardName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 服务价格
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 商品服务信息
         */
        services?: {
          /**
           * 服务名称
           */
          serviceName?: string;
          /**
           * 服务属性
           */
          serviceAttribute?: string;
          /**
           * 服务id
           */
          serviceId?: number;
          /**
           * 单价
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
          /**
           * 数量 随着商品增加
           */
          amount?: number;
        }[];
        /**
         * 选配信息
         */
        news?: {
          /**
           * 购物车配件主键 id
           */
          newsId?: number;
          /**
           * 数量
           */
          amount?: number;
          /**
           * 品牌名称
           */
          newsName?: string;
          /**
           * 型号
           */
          model?: string;
          /**
           * 品牌名称
           */
          brandName?: string;
          /**
           * 配件单价，单位：分
           */
          price?: number;
          /**
           * 单位
           */
          unit?: string;
        }[];
        /**
         * 使用人信息
         */
        userInfo?: {
          /**
           * 职级
           * 1-厅级 2-处级 3-处级以下
           */
          userRank: 1 | 2 | 3;
          /**
           * 职级描述
           */
          userRankDesc?: string;
          /**
           * 使用人姓名
           */
          userName: string;
        };
        /**
         * 资产类型
         * 1-办公家具 2-办公设备
         */
        propertyType?: string;
        /**
         * 资产类型描述
         */
        propertyTypeDesc?: string;
        /**
         * 资产品目
         */
        propertyItem?: string;
        /**
         * 资产品目类型
         */
        propertyItemDesc?: string;
        /**
         * 商品类目
         */
        itemCatalogName?: string;
        /**
         * 会议桌容纳人数
         */
        userCount?: number;
        /**
         * 政采云商品链接，用户填写，自动解析出商品数据
         */
        zcyUrl?: string;
        /**
         * 是否国产，资产类别为办公设备时可填，如果为是，不进行费控  1是、0否
         */
        domestic?: number;
        /**
         * 商品主图
         */
        mainImage?: string;
      };
      /**
       * 外部sku
       */
      skuCode?: number;
      /**
       * 商品附件
       */
      attachmentList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      }[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [购物车列表↗](http://yapi.cai-inc.com/project/3621/interface/api/288042) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `POST /zlb/api/expense/purchase/commodity/list`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseCommodityListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/commodity/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [购物车列表↗](http://yapi.cai-inc.com/project/3621/interface/api/288042) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `POST /zlb/api/expense/purchase/commodity/list`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseCommodityListPostRequestConfig: ZlbApiExpensePurchaseCommodityListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_6,
    devUrl: devUrl_0_1_0_6,
    prodUrl: prodUrl_0_1_0_6,
    path: '/zlb/api/expense/purchase/commodity/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseCommodityListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [购物车列表↗](http://yapi.cai-inc.com/project/3621/interface/api/288042) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `POST /zlb/api/expense/purchase/commodity/list`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseCommodityListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseCommodityListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseCommodityListPostResponse>(
    prepare(zlbApiExpensePurchaseCommodityListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseCommodityListPost.requestConfig =
  zlbApiExpensePurchaseCommodityListPostRequestConfig;

/**
 * 接口 [解析政采云商品链接↗](http://yapi.cai-inc.com/project/3621/interface/api/443314) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `GET /zlb/api/expense/purchase/commodity/query-by-url`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseCommodityQueryByUrlGetRequest {
  url: string;
}

/**
 * 接口 [解析政采云商品链接↗](http://yapi.cai-inc.com/project/3621/interface/api/443314) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `GET /zlb/api/expense/purchase/commodity/query-by-url`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseCommodityQueryByUrlGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 唯一编码
     */
    uniqueCode?: string;
    /**
     * 商品编号
     */
    commodityCode?: string;
    /**
     * 商品名称
     */
    commodityName?: string;
    /**
     * 供应商ID
     */
    supplierId?: number;
    /**
     * 供应商名称
     */
    supplierName?: string;
    /**
     * 规则描述
     */
    specification?: string;
    /**
     * 单价（分）
     */
    unitPrice?: number;
    /**
     * 小记（分）
     */
    totalPrice?: number;
    /**
     * 数量
     */
    amount?: number;
    /**
     * 商品数据来源：0-浙里报 1-政采云
     */
    commoditySource?: number;
    /**
     * 拓展字段
     */
    extendDataDTO?: {
      /**
       * 实例名称
       */
      instanceName?: string;
      /**
       * 品牌
       */
      brandName?: string;
      /**
       * 型号
       */
      model?: string;
      /**
       * 商品详情页url
       */
      detailPageUrl?: string;
      /**
       * 所有服务商品单价和
       */
      serviceTotalPrice?: number;
      /**
       * 服务单价和
       */
      sumServiceTotalPrice?: number;
      /**
       * 计量单位
       */
      unit?: string;
      /**
       * 是否进口：1是、0否
       */
      isImport?: number;
      /**
       * 是否适宜中小企业：1是、0否
       */
      isSuit?: number;
      /**
       * 不适宜中小企业理由
       */
      noSuitReason?: string;
      /**
       * 采购目录code（选择的）
       */
      catalogCodeList?: string[];
      /**
       * First catalogCodeList
       */
      category?: string;
      /**
       * 采购目录name（选择的）
       */
      catalogNameList?: string[];
      /**
       * 政府购买服务目录code（选择的）
       */
      serviceCodeList?: string[];
      /**
       * 政府购买服务目录name（选择的）
       */
      serviceNameList?: string[];
      /**
       * 采购目录信息(从购物车取的数据)
       */
      catalogList?: {
        /**
         * 采购目录编码
         */
        catalogCode?: string;
        /**
         * 采购目录名称
         */
        catalogName?: string;
      }[];
      /**
       * 商品属性信息
       */
      attributeList?: {
        /**
         * 属性名称
         */
        attributeName?: string;
        /**
         * 属性值
         */
        attributeValue?: string;
      }[];
      /**
       * 商品服务项信息
       */
      standards?: {
        /**
         * 服务商品ID
         */
        standardId?: number;
        /**
         * 服务名称
         */
        standardName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 品牌名称
         */
        brandName?: string;
        /**
         * 数量
         */
        amount?: number;
        /**
         * 服务价格
         */
        price?: number;
        /**
         * 单位
         */
        unit?: string;
      }[];
      /**
       * 商品服务信息
       */
      services?: {
        /**
         * 服务名称
         */
        serviceName?: string;
        /**
         * 服务属性
         */
        serviceAttribute?: string;
        /**
         * 服务id
         */
        serviceId?: number;
        /**
         * 单价
         */
        price?: number;
        /**
         * 单位
         */
        unit?: string;
        /**
         * 数量 随着商品增加
         */
        amount?: number;
      }[];
      /**
       * 选配信息
       */
      news?: {
        /**
         * 购物车配件主键 id
         */
        newsId?: number;
        /**
         * 数量
         */
        amount?: number;
        /**
         * 品牌名称
         */
        newsName?: string;
        /**
         * 型号
         */
        model?: string;
        /**
         * 品牌名称
         */
        brandName?: string;
        /**
         * 配件单价，单位：分
         */
        price?: number;
        /**
         * 单位
         */
        unit?: string;
      }[];
      /**
       * 使用人信息
       */
      userInfo?: {
        /**
         * 职级
         * 1-厅级 2-处级 3-处级以下
         */
        userRank: 1 | 2 | 3;
        /**
         * 职级描述
         */
        userRankDesc?: string;
        /**
         * 使用人姓名
         */
        userName: string;
      };
      /**
       * 资产类型
       * 1-办公家具 2-办公设备
       */
      propertyType?: string;
      /**
       * 资产类型描述
       */
      propertyTypeDesc?: string;
      /**
       * 资产品目
       */
      propertyItem?: string;
      /**
       * 资产品目类型
       */
      propertyItemDesc?: string;
      /**
       * 商品类目
       */
      itemCatalogName?: string;
      /**
       * 会议桌容纳人数
       */
      userCount?: number;
      /**
       * 政采云商品链接，用户填写，自动解析出商品数据
       */
      zcyUrl?: string;
      /**
       * 是否国产，资产类别为办公设备时可填，如果为是，不进行费控  1是、0否
       */
      domestic?: number;
      /**
       * 商品主图
       */
      mainImage?: string;
    };
    /**
     * 外部sku
     */
    skuCode?: number;
    /**
     * 商品附件
     */
    attachmentList?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [解析政采云商品链接↗](http://yapi.cai-inc.com/project/3621/interface/api/443314) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `GET /zlb/api/expense/purchase/commodity/query-by-url`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseCommodityQueryByUrlGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/commodity/query-by-url',
    'data',
    string,
    'url',
    false
  >
>;

/**
 * 接口 [解析政采云商品链接↗](http://yapi.cai-inc.com/project/3621/interface/api/443314) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `GET /zlb/api/expense/purchase/commodity/query-by-url`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseCommodityQueryByUrlGetRequestConfig: ZlbApiExpensePurchaseCommodityQueryByUrlGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_6,
    devUrl: devUrl_0_1_0_6,
    prodUrl: prodUrl_0_1_0_6,
    path: '/zlb/api/expense/purchase/commodity/query-by-url',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_6,
    paramNames: [],
    queryNames: ['url'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseCommodityQueryByUrlGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [解析政采云商品链接↗](http://yapi.cai-inc.com/project/3621/interface/api/443314) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [购物车↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_43188)
 * @请求头 `GET /zlb/api/expense/purchase/commodity/query-by-url`
 * @更新时间 `2024-02-26 09:45:18`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseCommodityQueryByUrlGet = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseCommodityQueryByUrlGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseCommodityQueryByUrlGetResponse>(
    prepare(zlbApiExpensePurchaseCommodityQueryByUrlGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseCommodityQueryByUrlGet.requestConfig =
  zlbApiExpensePurchaseCommodityQueryByUrlGetRequestConfig;

const mockUrl_0_1_0_7 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_7 = '' as any;
const prodUrl_0_1_0_7 = '' as any;
const dataKey_0_1_0_7 = 'data' as any;

/**
 * 接口 [我的合同列表↗](http://yapi.cai-inc.com/project/3621/interface/api/250332) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/list`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 合同编号
   */
  contractCode?: string;
  /**
   * 合同名称
   */
  contractName?: string;
  /**
   * 数据源来源：0手动添加 1政采云 3报销单
   */
  dataSource?: number;
  /**
   * 数据源来源：0手动添加 1政采云 3报销单
   */
  dataSourceList?: ('ZERO' | 'ONE' | 'TWO' | 'TREE' | 'FOUR' | 'FIVE' | 'SIX')[];
  status?:
    | 0
    | 10
    | 20
    | 100
    | 300
    | 290
    | 310
    | 400
    | 1000
    | 2000
    | 99999
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 11
    | 12;
  /**
   * 合同状态
   */
  statusList?: number[];
  /**
   * 创建时间开始
   */
  startTime?: string;
  /**
   * 创建时间结束
   */
  endTime?: string;
  /**
   * zcy导入 默认不传  1 是政采云
   */
  morph?: number;
  /**
   * operatorId(个人账号或授权账号)
   */
  operatorId?: number;
  /**
   * 查询类别 1-我的账号 2-授权给我的账号
   */
  queryOperatorType?: number;
  /**
   * 单位id
   */
  operatorOrgId?: number;
  /**
   * 是否查看附件
   */
  showAttachment?: boolean;
}

/**
 * 接口 [我的合同列表↗](http://yapi.cai-inc.com/project/3621/interface/api/250332) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/list`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 合同唯一编码
       */
      uniqueCode?: string;
      /**
       * 合同编号
       */
      contractCode?: string;
      /**
       * 合同id
       */
      contractId?: number;
      /**
       * 合同名称
       */
      contractName?: string;
      /**
       * 数据源来源：0这里报 1政采云 2报销单
       */
      dataSource?: number;
      /**
       * 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
       */
      status?: number;
      /**
       * 合同状态描述
       */
      statusDesc?: string;
      /**
       * 合同金额（分）
       */
      amount?: number;
      /**
       * 创建时间
       */
      rAddTime?: string;
      /**
       * 申请单编号（用印申请当做申请单）
       */
      applyFormCode?: string;
      /**
       * 合同报销方式  默认为全部 1 全部 2 分期报销
       */
      expenseType?: number;
      /**
       * 政采云合同信息
       */
      zcyContractList?: {
        /**
         * 行业类别编码
         */
        industryCode?: string;
        /**
         * 行业类别名称
         */
        industryName?: string;
        /**
         * 实例编码
         */
        instanceCode?: string;
        /**
         * 实例名称
         */
        instanceName?: string;
        /**
         * 项目金额(分)
         */
        projectAmount?: number;
        /**
         * 项目名称
         */
        projectName?: string;
        /**
         * 项目编号
         */
        projectNo?: string;
        /**
         * 采购单位联系人
         */
        purchaserContact?: string;
        /**
         * 采购单位id
         */
        purchaserId?: number;
        /**
         * 采购单位名称
         */
        purchaserName?: string;
        /**
         * 采购单位联系人电话
         */
        purchaserPhone?: string;
        /**
         * 供应商联系人
         */
        supContact?: string;
        /**
         * 供应商id
         */
        supId?: number;
        /**
         * 供应商名称
         */
        supName?: string;
        /**
         * 供应商联系人电话
         */
        supPhone?: string;
        /**
         * 创建人
         */
        userCreated?: number;
        /**
         * 创建人名称
         */
        userCreatedName?: string;
        /**
         * 合同唯一标识
         */
        id?: number;
        /**
         * 是否存在
         */
        isExist?: boolean;
        /**
         * 支付方式（1一次性支付，2：分期支付）
         */
        paymentType?: number;
      };
      /**
       * 按钮显示
       */
      contractButtonShow?: {
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 用印申请
         */
        yysqOn?: boolean;
        /**
         * 详情
         */
        detail?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 作废
         */
        voidOn?: boolean;
        /**
         * 审批进度
         */
        spjdOn?: boolean;
        /**
         * 撤回
         */
        withdraw?: boolean;
        /**
         * 上传盖章
         */
        uploadStamp?: boolean;
        /**
         * 打印
         */
        print?: boolean;
      };
      /**
       * 附件信息
       */
      attachmentList?: {
        /**
         * 1 文档信息 2 附件 3
         */
        contractType?: number;
        /**
         * 文件id
         */
        fileId?: string;
        /**
         * 文件名称
         */
        name?: string;
        /**
         * 文件类型
         */
        type?: string;
        /**
         * 文件URL
         */
        url?: string;
      }[];
      /**
       * 报销单code
       */
      expenseFormCode?: string;
      /**
       * 报销单业务编号
       */
      expenseBusinessCode?: string;
      /**
       * 报销单状态
       */
      expenseFormStatus?: number;
      /**
       * 报销单状态描述
       */
      expenseFormStatusDesc?: string;
      /**
       * 【合同接收结果信息收集表】百搭单据信息
       */
      contractAcceptanceBaidaFormInfo?: {
        /**
         * 合同唯一编号
         */
        contractUniqueCode?: string;
        /**
         * 百搭单据唯一编号
         */
        baidaFormUniqueCode?: string;
        /**
         * 百搭单据场景编码
         */
        baidaFormDefineCode?: string;
        /**
         * 百搭单据最新状态
         */
        baidaFormStatus?: number;
      };
      /**
       * 【非政府采购过程信息表】百搭单据信息
       */
      noGovPurchaseProgressBaidaFormInfo?: {
        /**
         * 合同唯一编号
         */
        contractUniqueCode?: string;
        /**
         * 百搭单据唯一编号
         */
        baidaFormUniqueCode?: string;
        /**
         * 百搭单据场景编码
         */
        baidaFormDefineCode?: string;
        /**
         * 百搭单据最新状态
         */
        baidaFormStatus?: number;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [我的合同列表↗](http://yapi.cai-inc.com/project/3621/interface/api/250332) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/list`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [我的合同列表↗](http://yapi.cai-inc.com/project/3621/interface/api/250332) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/list`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractListPostRequestConfig: ZlbApiExpensePurchaseContractListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [我的合同列表↗](http://yapi.cai-inc.com/project/3621/interface/api/250332) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/list`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractListPostResponse>(
    prepare(zlbApiExpensePurchaseContractListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractListPost.requestConfig =
  zlbApiExpensePurchaseContractListPostRequestConfig;

/**
 * 接口 [合同详情↗](http://yapi.cai-inc.com/project/3621/interface/api/250334) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractDetailGetRequest {
  uniqueCode: string;
  typeCode: string;
}

/**
 * 接口 [合同详情↗](http://yapi.cai-inc.com/project/3621/interface/api/250334) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractDetailGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 订单号
     */
    orderCode?: string;
    /**
     * 订单编号列表 适用于办公设备家具购置报销单、政府购买服务、通用采购
     */
    orderCodeList?: string[];
    /**
     * 订单唯一编号
     */
    uniqueCode?: string;
    /**
     * 合同id
     */
    contractId?: number;
    /**
     * 合同编号
     */
    contractCode?: string;
    /**
     * 合同名称
     */
    contractName?: string;
    /**
     * 申请单编号（用印申请当做申请单）
     */
    applyFormCode?: string;
    /**
     * 报销单编号（报销单合同）
     */
    expenseFormCode?: string;
    /**
     * 合同金额（分）
     */
    amount?: number;
    /**
     * 甲方名称(采购单位)
     */
    firstPartyName?: string;
    /**
     * 甲方联系人姓名
     */
    firstPartyContact?: string;
    /**
     * 甲方联系人电话
     */
    firstPartyPhone?: string;
    /**
     * 乙方姓名(供应商)
     */
    secondPartyName?: string;
    /**
     * 乙方联系人姓名
     */
    secondPartyContact?: string;
    /**
     * 乙方联系人电话
     */
    secondPartyPhone?: string;
    /**
     * 合同内容明细
     */
    detail?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
     */
    status?: number;
    /**
     * 合同状态名称
     */
    statusDesc?: string;
    /**
     * 数据源来源：0手动添加 1政采云 3报销单
     */
    dataSource?: number;
    /**
     * 附件信息
     */
    attachment?: {
      /**
       * 1 文档信息 2 附件 3
       */
      contractType?: number;
      /**
       * 文件id
       */
      fileId?: string;
      /**
       * 文件名称
       */
      name?: string;
      /**
       * 文件类型
       */
      type?: string;
      /**
       * 文件URL
       */
      url?: string;
    }[];
    /**
     * 分期类型  1 一次性付款 2分期付款
     */
    stagingType?: number;
    /**
     * 支付期数
     */
    stagingContractList?: {
      /**
       * 支付期数编码
       */
      periodCode?: string;
      /**
       * 支付期数
       */
      stagingCount?: number;
      /**
       * 金额
       */
      amount?: number;
      /**
       * 支付时间
       */
      payTime?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 支付比例
       */
      payProportion?: string;
      /**
       * 报销单唯一编码（主键）（未报销为空）
       */
      expenseFormCode?: string;
      /**
       * 报销单业务编码（未报销为空）
       */
      expenseBusinesssCode?: string;
      /**
       * 报销类型
       * -1:百搭单据 其他：报销单类型
       */
      expenseFormType?: number;
    }[];
    /**
     * 订单编号（ID字符串）
     */
    orderNo?: string;
    /**
     * 供应商银行账号
     */
    supBankAccount?: string;
    /**
     * 供应商银行账号，多收款人需要根据账户+收款人+收款银行聚合
     */
    supBankAccountPlaintext?: string;
    /**
     * 供应商银行名称
     */
    supBankName?: string;
    /**
     * 供应商银行开户人名称
     */
    supBankPerson?: string;
    /**
     * 账户code，采购场景从合同获取的供应商收款信息入库支付账户表，返回accountCode
     */
    accountCode?: string;
    /**
     * 履约保证金
     */
    performanceBond?: number;
    /**
     * 资产管理条款
     */
    managementTerms?: number;
    /**
     * 已报销金额记录
     */
    expenseAmountRecordDTOS?: {
      /**
       * 报销单businessCode
       */
      businessCode?: string;
      /**
       * 报销金额记录
       */
      expenseAmountRecord?: number;
    }[];
    /**
     * 合同剩余可报销金额
     */
    contractRemainingAmount?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [合同详情↗](http://yapi.cai-inc.com/project/3621/interface/api/250334) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractDetailGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/detail',
    'data',
    string,
    'uniqueCode' | 'typeCode',
    false
  >
>;

/**
 * 接口 [合同详情↗](http://yapi.cai-inc.com/project/3621/interface/api/250334) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractDetailGetRequestConfig: ZlbApiExpensePurchaseContractDetailGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/detail',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: ['uniqueCode', 'typeCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractDetailGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [合同详情↗](http://yapi.cai-inc.com/project/3621/interface/api/250334) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail`
 * @更新时间 `2024-08-12 17:43:05`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractDetailGet = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractDetailGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractDetailGetResponse>(
    prepare(zlbApiExpensePurchaseContractDetailGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractDetailGet.requestConfig =
  zlbApiExpensePurchaseContractDetailGetRequestConfig;

/**
 * 接口 [合同创建↗](http://yapi.cai-inc.com/project/3621/interface/api/250336) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/create`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractCreatePostRequest {
  /**
   * 合同编号
   */
  contractCode?: string;
  /**
   * 合同名称
   */
  contractName: string;
  /**
   * 合同金额（分）
   */
  amount?: number;
  /**
   * 甲方名称
   */
  firstPartyName: string;
  /**
   * 甲方联系人姓名
   */
  firstPartyContact: string;
  /**
   * 甲方联系人电话
   */
  firstPartyPhone: string;
  /**
   * 乙方名称
   */
  secondPartyName: string;
  /**
   * 乙方联系人姓名
   */
  secondPartyContact: string;
  /**
   * 乙方联系人电话
   */
  secondPartyPhone: string;
  /**
   * 合同内容明细
   */
  detail?: string;
  /**
   * 备注
   */
  remark?: string;
  attachmentList: {
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
    /**
     * 1 文档信息 2 附件
     */
    contractType: number;
  }[];
  /**
   * 分期类型  1 一次性付款 2分期付款
   */
  stagingType?: number;
  /**
   * 履约保证金
   */
  performanceBond?: number;
  /**
   * 资产管理条款
   */
  managementTerms?: number;
  /**
   * 订单编号（ID字符串）
   */
  orderNo?: string;
  stagingContractList?: {
    /**
     * 支付期数编码
     */
    periodCode?: string;
    /**
     * 支付期数
     */
    stagingCount: number;
    /**
     * 金额
     */
    amount: number;
    /**
     * 支付时间
     */
    payTime?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 支付比例
     */
    payProportion?: string;
  }[];
}

/**
 * 接口 [合同创建↗](http://yapi.cai-inc.com/project/3621/interface/api/250336) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/create`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractCreatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [合同创建↗](http://yapi.cai-inc.com/project/3621/interface/api/250336) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/create`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractCreatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/create',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [合同创建↗](http://yapi.cai-inc.com/project/3621/interface/api/250336) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/create`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractCreatePostRequestConfig: ZlbApiExpensePurchaseContractCreatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/create',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractCreatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [合同创建↗](http://yapi.cai-inc.com/project/3621/interface/api/250336) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/create`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractCreatePost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractCreatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractCreatePostResponse>(
    prepare(zlbApiExpensePurchaseContractCreatePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractCreatePost.requestConfig =
  zlbApiExpensePurchaseContractCreatePostRequestConfig;

/**
 * 接口 [合同导入↗](http://yapi.cai-inc.com/project/3621/interface/api/250338) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/batch-import`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export type ZlbApiExpensePurchaseContractBatchImportPostRequest = number[];

/**
 * 接口 [合同导入↗](http://yapi.cai-inc.com/project/3621/interface/api/250338) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/batch-import`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractBatchImportPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [合同导入↗](http://yapi.cai-inc.com/project/3621/interface/api/250338) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/batch-import`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractBatchImportPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/batch-import',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [合同导入↗](http://yapi.cai-inc.com/project/3621/interface/api/250338) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/batch-import`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractBatchImportPostRequestConfig: ZlbApiExpensePurchaseContractBatchImportPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/batch-import',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractBatchImportPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [合同导入↗](http://yapi.cai-inc.com/project/3621/interface/api/250338) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/batch-import`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractBatchImportPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractBatchImportPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractBatchImportPostResponse>(
    prepare(zlbApiExpensePurchaseContractBatchImportPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractBatchImportPost.requestConfig =
  zlbApiExpensePurchaseContractBatchImportPostRequestConfig;

/**
 * 接口 [删除合同 or 作废合同↗](http://yapi.cai-inc.com/project/3621/interface/api/250340) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `DELETE /zlb/api/expense/purchase/contract/delete/{uniqueCode}`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractDeleteUniqueCodeDeleteRequest {
  /**
   * 合同编号
   *                    删除类型  如果是草稿状态的 直接删除 如果是完结状态的 作废处理
   */
  uniqueCode: string;
}

/**
 * 接口 [删除合同 or 作废合同↗](http://yapi.cai-inc.com/project/3621/interface/api/250340) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `DELETE /zlb/api/expense/purchase/contract/delete/{uniqueCode}`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractDeleteUniqueCodeDeleteResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除合同 or 作废合同↗](http://yapi.cai-inc.com/project/3621/interface/api/250340) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `DELETE /zlb/api/expense/purchase/contract/delete/{uniqueCode}`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractDeleteUniqueCodeDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/delete/{uniqueCode}',
    'data',
    'uniqueCode',
    string,
    false
  >
>;

/**
 * 接口 [删除合同 or 作废合同↗](http://yapi.cai-inc.com/project/3621/interface/api/250340) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `DELETE /zlb/api/expense/purchase/contract/delete/{uniqueCode}`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractDeleteUniqueCodeDeleteRequestConfig: ZlbApiExpensePurchaseContractDeleteUniqueCodeDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/delete/{uniqueCode}',
    method: Method.DELETE,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: ['uniqueCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractDeleteUniqueCodeDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除合同 or 作废合同↗](http://yapi.cai-inc.com/project/3621/interface/api/250340) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `DELETE /zlb/api/expense/purchase/contract/delete/{uniqueCode}`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractDeleteUniqueCodeDelete = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractDeleteUniqueCodeDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractDeleteUniqueCodeDeleteResponse>(
    prepare(zlbApiExpensePurchaseContractDeleteUniqueCodeDeleteRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractDeleteUniqueCodeDelete.requestConfig =
  zlbApiExpensePurchaseContractDeleteUniqueCodeDeleteRequestConfig;

/**
 * 接口 [合同编辑↗](http://yapi.cai-inc.com/project/3621/interface/api/250342) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/edit`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractEditPostRequest {
  /**
   * 合同编号
   */
  contractCode?: string;
  /**
   * 合同名称
   */
  contractName: string;
  /**
   * 合同金额（分）
   */
  amount?: number;
  /**
   * 甲方名称
   */
  firstPartyName: string;
  /**
   * 甲方联系人姓名
   */
  firstPartyContact: string;
  /**
   * 甲方联系人电话
   */
  firstPartyPhone: string;
  /**
   * 乙方名称
   */
  secondPartyName: string;
  /**
   * 乙方联系人姓名
   */
  secondPartyContact: string;
  /**
   * 乙方联系人电话
   */
  secondPartyPhone: string;
  /**
   * 合同内容明细
   */
  detail?: string;
  /**
   * 备注
   */
  remark?: string;
  attachmentList: {
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
    /**
     * 1 文档信息 2 附件
     */
    contractType: number;
  }[];
  /**
   * 分期类型  1 一次性付款 2分期付款
   */
  stagingType?: number;
  /**
   * 履约保证金
   */
  performanceBond?: number;
  /**
   * 资产管理条款
   */
  managementTerms?: number;
  /**
   * 订单编号（ID字符串）
   */
  orderNo?: string;
  stagingContractList?: {
    /**
     * 支付期数编码
     */
    periodCode?: string;
    /**
     * 支付期数
     */
    stagingCount: number;
    /**
     * 金额
     */
    amount: number;
    /**
     * 支付时间
     */
    payTime?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 支付比例
     */
    payProportion?: string;
  }[];
  /**
   * 合同唯一编号
   */
  uniqueCode?: string;
}

/**
 * 接口 [合同编辑↗](http://yapi.cai-inc.com/project/3621/interface/api/250342) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/edit`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractEditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [合同编辑↗](http://yapi.cai-inc.com/project/3621/interface/api/250342) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/edit`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractEditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/edit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [合同编辑↗](http://yapi.cai-inc.com/project/3621/interface/api/250342) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/edit`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractEditPostRequestConfig: ZlbApiExpensePurchaseContractEditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/edit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractEditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [合同编辑↗](http://yapi.cai-inc.com/project/3621/interface/api/250342) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/edit`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractEditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractEditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractEditPostResponse>(
    prepare(zlbApiExpensePurchaseContractEditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractEditPost.requestConfig =
  zlbApiExpensePurchaseContractEditPostRequestConfig;

/**
 * 接口 [校验是否已报销↗](http://yapi.cai-inc.com/project/3621/interface/api/250682) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/checkExpense`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractCheckExpensePostRequest {
  /**
   * 合同唯一编号
   */
  uniqueCodeList?: string[];
  /**
   * 合同业务编号
   */
  contractCodeList?: string[];
}

/**
 * 接口 [校验是否已报销↗](http://yapi.cai-inc.com/project/3621/interface/api/250682) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/checkExpense`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractCheckExpensePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 是否已报销
     */
    expensed?: boolean;
    /**
     * 已报销合同编号
     */
    expensedContractCode?: string[];
    /**
     * 提示信息
     */
    message?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [校验是否已报销↗](http://yapi.cai-inc.com/project/3621/interface/api/250682) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/checkExpense`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractCheckExpensePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/checkExpense',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [校验是否已报销↗](http://yapi.cai-inc.com/project/3621/interface/api/250682) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/checkExpense`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractCheckExpensePostRequestConfig: ZlbApiExpensePurchaseContractCheckExpensePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/checkExpense',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractCheckExpensePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验是否已报销↗](http://yapi.cai-inc.com/project/3621/interface/api/250682) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/checkExpense`
 * @更新时间 `2024-08-12 17:43:07`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractCheckExpensePost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractCheckExpensePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractCheckExpensePostResponse>(
    prepare(zlbApiExpensePurchaseContractCheckExpensePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractCheckExpensePost.requestConfig =
  zlbApiExpensePurchaseContractCheckExpensePostRequestConfig;

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/258994) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export type ZlbApiExpensePurchaseContractDetailZcyPostRequest = number[];

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/258994) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractDetailZcyPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 订单号
     */
    orderCode?: string;
    /**
     * 订单编号列表 适用于办公设备家具购置报销单、政府购买服务、通用采购
     */
    orderCodeList?: string[];
    /**
     * 订单唯一编号
     */
    uniqueCode?: string;
    /**
     * 合同id
     */
    contractId?: number;
    /**
     * 合同编号
     */
    contractCode?: string;
    /**
     * 合同名称
     */
    contractName?: string;
    /**
     * 申请单编号（用印申请当做申请单）
     */
    applyFormCode?: string;
    /**
     * 报销单编号（报销单合同）
     */
    expenseFormCode?: string;
    /**
     * 合同金额（分）
     */
    amount?: number;
    /**
     * 甲方名称(采购单位)
     */
    firstPartyName?: string;
    /**
     * 甲方联系人姓名
     */
    firstPartyContact?: string;
    /**
     * 甲方联系人电话
     */
    firstPartyPhone?: string;
    /**
     * 乙方姓名(供应商)
     */
    secondPartyName?: string;
    /**
     * 乙方联系人姓名
     */
    secondPartyContact?: string;
    /**
     * 乙方联系人电话
     */
    secondPartyPhone?: string;
    /**
     * 合同内容明细
     */
    detail?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
     */
    status?: number;
    /**
     * 合同状态名称
     */
    statusDesc?: string;
    /**
     * 数据源来源：0手动添加 1政采云 3报销单
     */
    dataSource?: number;
    /**
     * 附件信息
     */
    attachment?: {
      /**
       * 1 文档信息 2 附件 3
       */
      contractType?: number;
      /**
       * 文件id
       */
      fileId?: string;
      /**
       * 文件名称
       */
      name?: string;
      /**
       * 文件类型
       */
      type?: string;
      /**
       * 文件URL
       */
      url?: string;
    }[];
    /**
     * 分期类型  1 一次性付款 2分期付款
     */
    stagingType?: number;
    /**
     * 支付期数
     */
    stagingContractList?: {
      /**
       * 支付期数编码
       */
      periodCode?: string;
      /**
       * 支付期数
       */
      stagingCount?: number;
      /**
       * 金额
       */
      amount?: number;
      /**
       * 支付时间
       */
      payTime?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 支付比例
       */
      payProportion?: string;
      /**
       * 报销单唯一编码（主键）（未报销为空）
       */
      expenseFormCode?: string;
      /**
       * 报销单业务编码（未报销为空）
       */
      expenseBusinesssCode?: string;
      /**
       * 报销类型
       * -1:百搭单据 其他：报销单类型
       */
      expenseFormType?: number;
    }[];
    /**
     * 订单编号（ID字符串）
     */
    orderNo?: string;
    /**
     * 供应商银行账号
     */
    supBankAccount?: string;
    /**
     * 供应商银行账号，多收款人需要根据账户+收款人+收款银行聚合
     */
    supBankAccountPlaintext?: string;
    /**
     * 供应商银行名称
     */
    supBankName?: string;
    /**
     * 供应商银行开户人名称
     */
    supBankPerson?: string;
    /**
     * 账户code，采购场景从合同获取的供应商收款信息入库支付账户表，返回accountCode
     */
    accountCode?: string;
    /**
     * 履约保证金
     */
    performanceBond?: number;
    /**
     * 资产管理条款
     */
    managementTerms?: number;
    /**
     * 已报销金额记录
     */
    expenseAmountRecordDTOS?: {
      /**
       * 报销单businessCode
       */
      businessCode?: string;
      /**
       * 报销金额记录
       */
      expenseAmountRecord?: number;
    }[];
    /**
     * 合同剩余可报销金额
     */
    contractRemainingAmount?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/258994) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractDetailZcyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/detail-zcy',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/258994) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractDetailZcyPostRequestConfig: ZlbApiExpensePurchaseContractDetailZcyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/detail-zcy',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractDetailZcyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/258994) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractDetailZcyPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractDetailZcyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractDetailZcyPostResponse>(
    prepare(zlbApiExpensePurchaseContractDetailZcyPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractDetailZcyPost.requestConfig =
  zlbApiExpensePurchaseContractDetailZcyPostRequestConfig;

/**
 * 接口 [报销时候，手动添加的合同，以合同编号为参数，返回合同剩余金额↗](http://yapi.cai-inc.com/project/3621/interface/api/259002) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/queryContractRemainingAmount`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractQueryContractRemainingAmountPostRequest {
  /**
   * 合同编号
   */
  contractCode: string;
  /**
   * 合同金额（分）
   */
  amount: number;
}

/**
 * 接口 [报销时候，手动添加的合同，以合同编号为参数，返回合同剩余金额↗](http://yapi.cai-inc.com/project/3621/interface/api/259002) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/queryContractRemainingAmount`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractQueryContractRemainingAmountPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [报销时候，手动添加的合同，以合同编号为参数，返回合同剩余金额↗](http://yapi.cai-inc.com/project/3621/interface/api/259002) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/queryContractRemainingAmount`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractQueryContractRemainingAmountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/queryContractRemainingAmount',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [报销时候，手动添加的合同，以合同编号为参数，返回合同剩余金额↗](http://yapi.cai-inc.com/project/3621/interface/api/259002) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/queryContractRemainingAmount`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractQueryContractRemainingAmountPostRequestConfig: ZlbApiExpensePurchaseContractQueryContractRemainingAmountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/queryContractRemainingAmount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractQueryContractRemainingAmountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [报销时候，手动添加的合同，以合同编号为参数，返回合同剩余金额↗](http://yapi.cai-inc.com/project/3621/interface/api/259002) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/queryContractRemainingAmount`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractQueryContractRemainingAmountPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractQueryContractRemainingAmountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractQueryContractRemainingAmountPostResponse>(
    prepare(
      zlbApiExpensePurchaseContractQueryContractRemainingAmountPostRequestConfig,
      requestData,
    ),
    ...args,
  );
};

zlbApiExpensePurchaseContractQueryContractRemainingAmountPost.requestConfig =
  zlbApiExpensePurchaseContractQueryContractRemainingAmountPostRequestConfig;

/**
 * 接口 [从政采云导入合同（全链路二期报销单使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/262410) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/listFromZCY`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractListFromZcyPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 合同编号
   */
  contractCode?: string;
  /**
   * 合同名称
   */
  contractName?: string;
  /**
   * 数据源来源：0手动添加 1政采云 3报销单
   */
  dataSource?: number;
  /**
   * 数据源来源：0手动添加 1政采云 3报销单
   */
  dataSourceList?: ('ZERO' | 'ONE' | 'TWO' | 'TREE' | 'FOUR' | 'FIVE' | 'SIX')[];
  status?:
    | 0
    | 10
    | 20
    | 100
    | 300
    | 290
    | 310
    | 400
    | 1000
    | 2000
    | 99999
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 11
    | 12;
  /**
   * 合同状态
   */
  statusList?: number[];
  /**
   * 创建时间开始
   */
  startTime?: string;
  /**
   * 创建时间结束
   */
  endTime?: string;
  /**
   * zcy导入 默认不传  1 是政采云
   */
  morph?: number;
  /**
   * operatorId(个人账号或授权账号)
   */
  operatorId?: number;
  /**
   * 查询类别 1-我的账号 2-授权给我的账号
   */
  queryOperatorType?: number;
  /**
   * 单位id
   */
  operatorOrgId?: number;
  /**
   * 是否查看附件
   */
  showAttachment?: boolean;
}

/**
 * 接口 [从政采云导入合同（全链路二期报销单使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/262410) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/listFromZCY`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractListFromZcyPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 合同唯一编码
       */
      uniqueCode?: string;
      /**
       * 合同编号
       */
      contractCode?: string;
      /**
       * 合同id
       */
      contractId?: number;
      /**
       * 合同名称
       */
      contractName?: string;
      /**
       * 数据源来源：0这里报 1政采云 2报销单
       */
      dataSource?: number;
      /**
       * 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
       */
      status?: number;
      /**
       * 合同状态描述
       */
      statusDesc?: string;
      /**
       * 合同金额（分）
       */
      amount?: number;
      /**
       * 创建时间
       */
      rAddTime?: string;
      /**
       * 申请单编号（用印申请当做申请单）
       */
      applyFormCode?: string;
      /**
       * 合同报销方式  默认为全部 1 全部 2 分期报销
       */
      expenseType?: number;
      /**
       * 政采云合同信息
       */
      zcyContractList?: {
        /**
         * 行业类别编码
         */
        industryCode?: string;
        /**
         * 行业类别名称
         */
        industryName?: string;
        /**
         * 实例编码
         */
        instanceCode?: string;
        /**
         * 实例名称
         */
        instanceName?: string;
        /**
         * 项目金额(分)
         */
        projectAmount?: number;
        /**
         * 项目名称
         */
        projectName?: string;
        /**
         * 项目编号
         */
        projectNo?: string;
        /**
         * 采购单位联系人
         */
        purchaserContact?: string;
        /**
         * 采购单位id
         */
        purchaserId?: number;
        /**
         * 采购单位名称
         */
        purchaserName?: string;
        /**
         * 采购单位联系人电话
         */
        purchaserPhone?: string;
        /**
         * 供应商联系人
         */
        supContact?: string;
        /**
         * 供应商id
         */
        supId?: number;
        /**
         * 供应商名称
         */
        supName?: string;
        /**
         * 供应商联系人电话
         */
        supPhone?: string;
        /**
         * 创建人
         */
        userCreated?: number;
        /**
         * 创建人名称
         */
        userCreatedName?: string;
        /**
         * 合同唯一标识
         */
        id?: number;
        /**
         * 是否存在
         */
        isExist?: boolean;
        /**
         * 支付方式（1一次性支付，2：分期支付）
         */
        paymentType?: number;
      };
      /**
       * 按钮显示
       */
      contractButtonShow?: {
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 用印申请
         */
        yysqOn?: boolean;
        /**
         * 详情
         */
        detail?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 作废
         */
        voidOn?: boolean;
        /**
         * 审批进度
         */
        spjdOn?: boolean;
        /**
         * 撤回
         */
        withdraw?: boolean;
        /**
         * 上传盖章
         */
        uploadStamp?: boolean;
        /**
         * 打印
         */
        print?: boolean;
      };
      /**
       * 附件信息
       */
      attachmentList?: {
        /**
         * 1 文档信息 2 附件 3
         */
        contractType?: number;
        /**
         * 文件id
         */
        fileId?: string;
        /**
         * 文件名称
         */
        name?: string;
        /**
         * 文件类型
         */
        type?: string;
        /**
         * 文件URL
         */
        url?: string;
      }[];
      /**
       * 报销单code
       */
      expenseFormCode?: string;
      /**
       * 报销单业务编号
       */
      expenseBusinessCode?: string;
      /**
       * 报销单状态
       */
      expenseFormStatus?: number;
      /**
       * 报销单状态描述
       */
      expenseFormStatusDesc?: string;
      /**
       * 【合同接收结果信息收集表】百搭单据信息
       */
      contractAcceptanceBaidaFormInfo?: {
        /**
         * 合同唯一编号
         */
        contractUniqueCode?: string;
        /**
         * 百搭单据唯一编号
         */
        baidaFormUniqueCode?: string;
        /**
         * 百搭单据场景编码
         */
        baidaFormDefineCode?: string;
        /**
         * 百搭单据最新状态
         */
        baidaFormStatus?: number;
      };
      /**
       * 【非政府采购过程信息表】百搭单据信息
       */
      noGovPurchaseProgressBaidaFormInfo?: {
        /**
         * 合同唯一编号
         */
        contractUniqueCode?: string;
        /**
         * 百搭单据唯一编号
         */
        baidaFormUniqueCode?: string;
        /**
         * 百搭单据场景编码
         */
        baidaFormDefineCode?: string;
        /**
         * 百搭单据最新状态
         */
        baidaFormStatus?: number;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [从政采云导入合同（全链路二期报销单使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/262410) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/listFromZCY`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractListFromZcyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/listFromZCY',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [从政采云导入合同（全链路二期报销单使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/262410) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/listFromZCY`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractListFromZcyPostRequestConfig: ZlbApiExpensePurchaseContractListFromZcyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/listFromZCY',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractListFromZcyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [从政采云导入合同（全链路二期报销单使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/262410) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/listFromZCY`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractListFromZcyPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractListFromZcyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractListFromZcyPostResponse>(
    prepare(zlbApiExpensePurchaseContractListFromZcyPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractListFromZcyPost.requestConfig =
  zlbApiExpensePurchaseContractListFromZcyPostRequestConfig;

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/311386) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/expense-detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export type ZlbApiExpensePurchaseContractExpenseDetailZcyPostRequest = number[];

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/311386) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/expense-detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractExpenseDetailZcyPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 订单号
     */
    orderCode?: string;
    /**
     * 订单编号列表 适用于办公设备家具购置报销单、政府购买服务、通用采购
     */
    orderCodeList?: string[];
    /**
     * 订单唯一编号
     */
    uniqueCode?: string;
    /**
     * 合同id
     */
    contractId?: number;
    /**
     * 合同编号
     */
    contractCode?: string;
    /**
     * 合同名称
     */
    contractName?: string;
    /**
     * 申请单编号（用印申请当做申请单）
     */
    applyFormCode?: string;
    /**
     * 报销单编号（报销单合同）
     */
    expenseFormCode?: string;
    /**
     * 合同金额（分）
     */
    amount?: number;
    /**
     * 甲方名称(采购单位)
     */
    firstPartyName?: string;
    /**
     * 甲方联系人姓名
     */
    firstPartyContact?: string;
    /**
     * 甲方联系人电话
     */
    firstPartyPhone?: string;
    /**
     * 乙方姓名(供应商)
     */
    secondPartyName?: string;
    /**
     * 乙方联系人姓名
     */
    secondPartyContact?: string;
    /**
     * 乙方联系人电话
     */
    secondPartyPhone?: string;
    /**
     * 合同内容明细
     */
    detail?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
     */
    status?: number;
    /**
     * 合同状态名称
     */
    statusDesc?: string;
    /**
     * 数据源来源：0手动添加 1政采云 3报销单
     */
    dataSource?: number;
    /**
     * 附件信息
     */
    attachment?: {
      /**
       * 1 文档信息 2 附件 3
       */
      contractType?: number;
      /**
       * 文件id
       */
      fileId?: string;
      /**
       * 文件名称
       */
      name?: string;
      /**
       * 文件类型
       */
      type?: string;
      /**
       * 文件URL
       */
      url?: string;
    }[];
    /**
     * 分期类型  1 一次性付款 2分期付款
     */
    stagingType?: number;
    /**
     * 支付期数
     */
    stagingContractList?: {
      /**
       * 支付期数编码
       */
      periodCode?: string;
      /**
       * 支付期数
       */
      stagingCount?: number;
      /**
       * 金额
       */
      amount?: number;
      /**
       * 支付时间
       */
      payTime?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 支付比例
       */
      payProportion?: string;
      /**
       * 报销单唯一编码（主键）（未报销为空）
       */
      expenseFormCode?: string;
      /**
       * 报销单业务编码（未报销为空）
       */
      expenseBusinesssCode?: string;
      /**
       * 报销类型
       * -1:百搭单据 其他：报销单类型
       */
      expenseFormType?: number;
    }[];
    /**
     * 订单编号（ID字符串）
     */
    orderNo?: string;
    /**
     * 供应商银行账号
     */
    supBankAccount?: string;
    /**
     * 供应商银行账号，多收款人需要根据账户+收款人+收款银行聚合
     */
    supBankAccountPlaintext?: string;
    /**
     * 供应商银行名称
     */
    supBankName?: string;
    /**
     * 供应商银行开户人名称
     */
    supBankPerson?: string;
    /**
     * 账户code，采购场景从合同获取的供应商收款信息入库支付账户表，返回accountCode
     */
    accountCode?: string;
    /**
     * 履约保证金
     */
    performanceBond?: number;
    /**
     * 资产管理条款
     */
    managementTerms?: number;
    /**
     * 已报销金额记录
     */
    expenseAmountRecordDTOS?: {
      /**
       * 报销单businessCode
       */
      businessCode?: string;
      /**
       * 报销金额记录
       */
      expenseAmountRecord?: number;
    }[];
    /**
     * 合同剩余可报销金额
     */
    contractRemainingAmount?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/311386) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/expense-detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractExpenseDetailZcyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/expense-detail-zcy',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/311386) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/expense-detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractExpenseDetailZcyPostRequestConfig: ZlbApiExpensePurchaseContractExpenseDetailZcyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/expense-detail-zcy',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractExpenseDetailZcyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [合同详情-zcy↗](http://yapi.cai-inc.com/project/3621/interface/api/311386) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/expense-detail-zcy`
 * @更新时间 `2024-08-12 17:43:06`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractExpenseDetailZcyPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractExpenseDetailZcyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractExpenseDetailZcyPostResponse>(
    prepare(zlbApiExpensePurchaseContractExpenseDetailZcyPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractExpenseDetailZcyPost.requestConfig =
  zlbApiExpensePurchaseContractExpenseDetailZcyPostRequestConfig;

/**
 * 接口 [业务报销记录 1 合同 2 订单 ....↗](http://yapi.cai-inc.com/project/3621/interface/api/372026) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/business-records`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractBusinessRecordsPostRequest {
  /**
   * 合同编号
   */
  businessCode: string;
  /**
   * 合同金额（分）
   */
  amount: number;
  /**
   * 业务类型
   */
  businessType?: number;
}

/**
 * 接口 [业务报销记录 1 合同 2 订单 ....↗](http://yapi.cai-inc.com/project/3621/interface/api/372026) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/business-records`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractBusinessRecordsPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 剩余金额
     */
    balanceAmount?: number;
    /**
     * 报销记录
     */
    contractRemainingList?: {
      /**
       * 发起人姓名
       */
      userName?: string;
      /**
       * 报销订单号
       */
      businessCode?: string;
      /**
       * 本次报销金额
       */
      remainingAmount?: number;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [业务报销记录 1 合同 2 订单 ....↗](http://yapi.cai-inc.com/project/3621/interface/api/372026) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/business-records`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractBusinessRecordsPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/business-records',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [业务报销记录 1 合同 2 订单 ....↗](http://yapi.cai-inc.com/project/3621/interface/api/372026) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/business-records`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractBusinessRecordsPostRequestConfig: ZlbApiExpensePurchaseContractBusinessRecordsPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/business-records',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractBusinessRecordsPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [业务报销记录 1 合同 2 订单 ....↗](http://yapi.cai-inc.com/project/3621/interface/api/372026) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/business-records`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractBusinessRecordsPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractBusinessRecordsPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractBusinessRecordsPostResponse>(
    prepare(zlbApiExpensePurchaseContractBusinessRecordsPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractBusinessRecordsPost.requestConfig =
  zlbApiExpensePurchaseContractBusinessRecordsPostRequestConfig;

/**
 * 接口 [update↗](http://yapi.cai-inc.com/project/3621/interface/api/454970) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/update`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractUpdatePostRequest {
  /**
   * 合同编号
   */
  contractCode: string;
  /**
   * 合同唯一编号
   */
  uniqueCode: string;
  attachment: {
    /**
     * 1 文档信息 2 附件 3
     */
    contractType?: number;
    /**
     * 文件id
     */
    fileId?: string;
    /**
     * 文件名称
     */
    name?: string;
    /**
     * 文件类型
     */
    type?: string;
    /**
     * 文件URL
     */
    url?: string;
  };
}

/**
 * 接口 [update↗](http://yapi.cai-inc.com/project/3621/interface/api/454970) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/update`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractUpdatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [update↗](http://yapi.cai-inc.com/project/3621/interface/api/454970) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/update`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractUpdatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [update↗](http://yapi.cai-inc.com/project/3621/interface/api/454970) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/update`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractUpdatePostRequestConfig: ZlbApiExpensePurchaseContractUpdatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/update',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractUpdatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [update↗](http://yapi.cai-inc.com/project/3621/interface/api/454970) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `POST /zlb/api/expense/purchase/contract/update`
 * @更新时间 `2024-08-12 17:43:08`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractUpdatePost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractUpdatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractUpdatePostResponse>(
    prepare(zlbApiExpensePurchaseContractUpdatePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractUpdatePost.requestConfig =
  zlbApiExpensePurchaseContractUpdatePostRequestConfig;

/**
 * 接口 [运营机构使用↗](http://yapi.cai-inc.com/project/3621/interface/api/523050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail-operate`
 * @更新时间 `2024-08-12 17:43:09`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractDetailOperateGetRequest {
  uniqueCode: string;
}

/**
 * 接口 [运营机构使用↗](http://yapi.cai-inc.com/project/3621/interface/api/523050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail-operate`
 * @更新时间 `2024-08-12 17:43:09`
 * @项目ID 3621
 */
export interface ZlbApiExpensePurchaseContractDetailOperateGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 订单号
     */
    orderCode?: string;
    /**
     * 订单编号列表 适用于办公设备家具购置报销单、政府购买服务、通用采购
     */
    orderCodeList?: string[];
    /**
     * 订单唯一编号
     */
    uniqueCode?: string;
    /**
     * 合同id
     */
    contractId?: number;
    /**
     * 合同编号
     */
    contractCode?: string;
    /**
     * 合同名称
     */
    contractName?: string;
    /**
     * 申请单编号（用印申请当做申请单）
     */
    applyFormCode?: string;
    /**
     * 报销单编号（报销单合同）
     */
    expenseFormCode?: string;
    /**
     * 合同金额（分）
     */
    amount?: number;
    /**
     * 甲方名称(采购单位)
     */
    firstPartyName?: string;
    /**
     * 甲方联系人姓名
     */
    firstPartyContact?: string;
    /**
     * 甲方联系人电话
     */
    firstPartyPhone?: string;
    /**
     * 乙方姓名(供应商)
     */
    secondPartyName?: string;
    /**
     * 乙方联系人姓名
     */
    secondPartyContact?: string;
    /**
     * 乙方联系人电话
     */
    secondPartyPhone?: string;
    /**
     * 合同内容明细
     */
    detail?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
     */
    status?: number;
    /**
     * 合同状态名称
     */
    statusDesc?: string;
    /**
     * 数据源来源：0手动添加 1政采云 3报销单
     */
    dataSource?: number;
    /**
     * 附件信息
     */
    attachment?: {
      /**
       * 1 文档信息 2 附件 3
       */
      contractType?: number;
      /**
       * 文件id
       */
      fileId?: string;
      /**
       * 文件名称
       */
      name?: string;
      /**
       * 文件类型
       */
      type?: string;
      /**
       * 文件URL
       */
      url?: string;
    }[];
    /**
     * 分期类型  1 一次性付款 2分期付款
     */
    stagingType?: number;
    /**
     * 支付期数
     */
    stagingContractList?: {
      /**
       * 支付期数编码
       */
      periodCode?: string;
      /**
       * 支付期数
       */
      stagingCount?: number;
      /**
       * 金额
       */
      amount?: number;
      /**
       * 支付时间
       */
      payTime?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 支付比例
       */
      payProportion?: string;
      /**
       * 报销单唯一编码（主键）（未报销为空）
       */
      expenseFormCode?: string;
      /**
       * 报销单业务编码（未报销为空）
       */
      expenseBusinesssCode?: string;
      /**
       * 报销类型
       * -1:百搭单据 其他：报销单类型
       */
      expenseFormType?: number;
    }[];
    /**
     * 订单编号（ID字符串）
     */
    orderNo?: string;
    /**
     * 供应商银行账号
     */
    supBankAccount?: string;
    /**
     * 供应商银行账号，多收款人需要根据账户+收款人+收款银行聚合
     */
    supBankAccountPlaintext?: string;
    /**
     * 供应商银行名称
     */
    supBankName?: string;
    /**
     * 供应商银行开户人名称
     */
    supBankPerson?: string;
    /**
     * 账户code，采购场景从合同获取的供应商收款信息入库支付账户表，返回accountCode
     */
    accountCode?: string;
    /**
     * 履约保证金
     */
    performanceBond?: number;
    /**
     * 资产管理条款
     */
    managementTerms?: number;
    /**
     * 已报销金额记录
     */
    expenseAmountRecordDTOS?: {
      /**
       * 报销单businessCode
       */
      businessCode?: string;
      /**
       * 报销金额记录
       */
      expenseAmountRecord?: number;
    }[];
    /**
     * 合同剩余可报销金额
     */
    contractRemainingAmount?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [运营机构使用↗](http://yapi.cai-inc.com/project/3621/interface/api/523050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail-operate`
 * @更新时间 `2024-08-12 17:43:09`
 * @项目ID 3621
 */
type ZlbApiExpensePurchaseContractDetailOperateGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/purchase/contract/detail-operate',
    'data',
    string,
    'uniqueCode',
    false
  >
>;

/**
 * 接口 [运营机构使用↗](http://yapi.cai-inc.com/project/3621/interface/api/523050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail-operate`
 * @更新时间 `2024-08-12 17:43:09`
 * @项目ID 3621
 */
const zlbApiExpensePurchaseContractDetailOperateGetRequestConfig: ZlbApiExpensePurchaseContractDetailOperateGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: '/zlb/api/expense/purchase/contract/detail-operate',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: ['uniqueCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePurchaseContractDetailOperateGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [运营机构使用↗](http://yapi.cai-inc.com/project/3621/interface/api/523050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [合同↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_44079)
 * @请求头 `GET /zlb/api/expense/purchase/contract/detail-operate`
 * @更新时间 `2024-08-12 17:43:09`
 * @项目ID 3621
 */
export const zlbApiExpensePurchaseContractDetailOperateGet = /*#__PURE__*/ (
  requestData: ZlbApiExpensePurchaseContractDetailOperateGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePurchaseContractDetailOperateGetResponse>(
    prepare(zlbApiExpensePurchaseContractDetailOperateGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePurchaseContractDetailOperateGet.requestConfig =
  zlbApiExpensePurchaseContractDetailOperateGetRequestConfig;

const mockUrl_0_1_0_8 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_8 = '' as any;
const prodUrl_0_1_0_8 = '' as any;
const dataKey_0_1_0_8 = 'data' as any;

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254684) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/save`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export interface ZlbApiWageApplySavePostRequest {
  /**
   * 唯一单号
   */
  wageFormCode?: string;
  /**
   * 申报单业务单号
   */
  wageFormBusinessCode?: string;
  /**
   * 年
   */
  year?: number;
  /**
   * 月份
   */
  month?: number;
  /**
   * 申报次数
   */
  times?: number;
  /**
   * 本次申报使用的工资模板编号
   */
  wageIssueTemplateCode: string;
  /**
   * 工资明细附件
   */
  wageDetailAttach?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  };
  /**
   * 附件列表
   */
  wageAttachList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 备注
   */
  remark?: string;
}

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254684) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/save`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export interface ZlbApiWageApplySavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254684) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/save`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
type ZlbApiWageApplySavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254684) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/save`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
const zlbApiWageApplySavePostRequestConfig: ZlbApiWageApplySavePostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_8,
  devUrl: devUrl_0_1_0_8,
  prodUrl: prodUrl_0_1_0_8,
  path: '/zlb/api/wage/apply/save',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbApiWageApplySavePost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254684) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/save`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export const zlbApiWageApplySavePost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplySavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplySavePostResponse>(
    prepare(zlbApiWageApplySavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplySavePost.requestConfig = zlbApiWageApplySavePostRequestConfig;

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254686) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/submit`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export interface ZlbApiWageApplySubmitPostRequest {
  /**
   * 唯一单号
   */
  wageFormCode?: string;
  /**
   * 申报单业务单号
   */
  wageFormBusinessCode?: string;
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month: number;
  /**
   * 申报次数
   */
  times: number;
  /**
   * 本次申报使用的工资模板编号
   */
  wageIssueTemplateCode: string;
  /**
   * 工资明细附件
   */
  wageDetailAttach: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  };
  /**
   * 附件OosId列表
   */
  wageAttachList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 备注
   */
  remark?: string;
  /**
   * 工作流编号
   */
  workflowBusinessNo: string;
}

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254686) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/submit`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export interface ZlbApiWageApplySubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254686) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/submit`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
type ZlbApiWageApplySubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254686) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/submit`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
const zlbApiWageApplySubmitPostRequestConfig: ZlbApiWageApplySubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/wage/apply/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiWageApplySubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/254686) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/submit`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export const zlbApiWageApplySubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplySubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplySubmitPostResponse>(
    prepare(zlbApiWageApplySubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplySubmitPost.requestConfig = zlbApiWageApplySubmitPostRequestConfig;

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/254692) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/reject`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyRejectPostRequest {
  /**
   * 唯一单号
   */
  wageFormCode: string;
}

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/254692) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/reject`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyRejectPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/254692) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/reject`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
type ZlbApiWageApplyRejectPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/reject',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/254692) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/reject`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
const zlbApiWageApplyRejectPostRequestConfig: ZlbApiWageApplyRejectPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/wage/apply/reject',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiWageApplyRejectPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/254692) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/reject`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export const zlbApiWageApplyRejectPost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplyRejectPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplyRejectPostResponse>(
    prepare(zlbApiWageApplyRejectPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplyRejectPost.requestConfig = zlbApiWageApplyRejectPostRequestConfig;

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/254694) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/delete`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyDeletePostRequest {
  /**
   * 唯一单号
   */
  wageFormCode: string;
}

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/254694) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/delete`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/254694) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/delete`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
type ZlbApiWageApplyDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/254694) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/delete`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
const zlbApiWageApplyDeletePostRequestConfig: ZlbApiWageApplyDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/wage/apply/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiWageApplyDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/254694) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/delete`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export const zlbApiWageApplyDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplyDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplyDeletePostResponse>(
    prepare(zlbApiWageApplyDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplyDeletePost.requestConfig = zlbApiWageApplyDeletePostRequestConfig;

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/255618) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/detail`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyDetailPostRequest {
  /**
   * 唯一单号
   */
  wageFormCode: string;
}

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/255618) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/detail`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyDetailPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 主键id
     */
    id?: number;
    /**
     * 唯一单号
     */
    wageFormCode?: string;
    /**
     * 申报单业务单号
     */
    wageFormBusinessCode?: string;
    /**
     * 年
     */
    year?: number;
    /**
     * 月份
     */
    month?: number;
    /**
     * 申报次数
     */
    times?: number;
    /**
     * 本次申报使用的工资模板编号
     */
    wageIssueTemplateCode?: string;
    /**
     * 创建人id
     */
    operatorId?: number;
    /**
     * 创建人名称
     */
    operatorName?: string;
    /**
     * 单位id
     */
    operatorOrgId?: number;
    /**
     * 单位名
     */
    operatorOrgName?: string;
    /**
     * 申报单状态-前端展示(单据+支付)
     */
    declarationStatus?:
      | 'FORM_REJECT'
      | 'FORM_UN_SUBMIT'
      | 'WAIT_APPROVAL'
      | 'FORM_AUDIT'
      | 'PAY_WAIT'
      | 'PAY_PAYING'
      | 'PAY_PART_FAIL'
      | 'PAY_ALL_FAIL'
      | 'PAY_COMPLETED';
    /**
     * 申报状态描述
     */
    statusDesc?: string;
    /**
     * 支付状态  0-待支付,1-支付中,2-部分失败,3-全部失败，4-已完成
     */
    payStatus?: 'WAIT' | 'PAYING' | 'PART_FAIL' | 'ALL_FAIL' | 'COMPLETED';
    /**
     * 审批状态
     */
    auditStatus?: 'WAIT_APPROVAL' | 'WAIT_AUDIT' | 'PASS' | 'REJECT';
    auditStatusDesc?: string;
    /**
     * 工资明细附件
     */
    wageDetailAttach?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    };
    /**
     * 附件列表
     */
    wageAttachList?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 备注
     */
    remark?: string;
    /**
     * 删除标志
     */
    isDelete?: number;
    /**
     * 创建时间
     */
    rAddTime?: string;
    /**
     * 更新时间
     */
    rModifiedTime?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/255618) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/detail`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
type ZlbApiWageApplyDetailPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/detail',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/255618) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/detail`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
const zlbApiWageApplyDetailPostRequestConfig: ZlbApiWageApplyDetailPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/wage/apply/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiWageApplyDetailPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/255618) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/detail`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export const zlbApiWageApplyDetailPost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplyDetailPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplyDetailPostResponse>(
    prepare(zlbApiWageApplyDetailPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplyDetailPost.requestConfig = zlbApiWageApplyDetailPostRequestConfig;

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255626) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/list`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyListPostRequest {
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month?: number;
  /**
   * 申报次数
   */
  times?: number;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 申报单状态
   */
  declarationStatusList?: (
    | 'FORM_REJECT'
    | 'FORM_UN_SUBMIT'
    | 'WAIT_APPROVAL'
    | 'FORM_AUDIT'
    | 'PAY_WAIT'
    | 'PAY_PAYING'
    | 'PAY_PART_FAIL'
    | 'PAY_ALL_FAIL'
    | 'PAY_COMPLETED'
  )[];
  /**
   * 申报单号
   */
  wageFormBusinessCode?: string;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255626) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/list`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键id
       */
      id?: number;
      /**
       * 唯一单号
       */
      wageFormCode?: string;
      /**
       * 申报单业务单号
       */
      wageFormBusinessCode?: string;
      /**
       * 年
       */
      year?: number;
      /**
       * 月份
       */
      month?: number;
      /**
       * 申报次数
       */
      times?: number;
      /**
       * 本次申报使用的工资模板编号
       */
      wageIssueTemplateCode?: string;
      /**
       * 创建人id
       */
      operatorId?: number;
      /**
       * 创建人名称
       */
      operatorName?: string;
      /**
       * 单位id
       */
      operatorOrgId?: number;
      /**
       * 单位名
       */
      operatorOrgName?: string;
      /**
       * 申报单状态-前端展示(单据+支付)
       */
      declarationStatus?:
        | 'FORM_REJECT'
        | 'FORM_UN_SUBMIT'
        | 'WAIT_APPROVAL'
        | 'FORM_AUDIT'
        | 'PAY_WAIT'
        | 'PAY_PAYING'
        | 'PAY_PART_FAIL'
        | 'PAY_ALL_FAIL'
        | 'PAY_COMPLETED';
      /**
       * 申报状态描述
       */
      statusDesc?: string;
      /**
       * 支付状态  0-待支付,1-支付中,2-部分失败,3-全部失败，4-已完成
       */
      payStatus?: 'WAIT' | 'PAYING' | 'PART_FAIL' | 'ALL_FAIL' | 'COMPLETED';
      /**
       * 审批状态
       */
      auditStatus?: 'WAIT_APPROVAL' | 'WAIT_AUDIT' | 'PASS' | 'REJECT';
      auditStatusDesc?: string;
      /**
       * 工资明细附件
       */
      wageDetailAttach?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      };
      /**
       * 附件列表
       */
      wageAttachList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 备注
       */
      remark?: string;
      /**
       * 删除标志
       */
      isDelete?: number;
      /**
       * 创建时间
       */
      rAddTime?: string;
      /**
       * 更新时间
       */
      rModifiedTime?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255626) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/list`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
type ZlbApiWageApplyListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255626) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/list`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
const zlbApiWageApplyListPostRequestConfig: ZlbApiWageApplyListPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_8,
  devUrl: devUrl_0_1_0_8,
  prodUrl: prodUrl_0_1_0_8,
  path: '/zlb/api/wage/apply/list',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbApiWageApplyListPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255626) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/list`
 * @更新时间 `2022-06-13 19:26:32`
 * @项目ID 3621
 */
export const zlbApiWageApplyListPost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplyListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplyListPostResponse>(
    prepare(zlbApiWageApplyListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplyListPost.requestConfig = zlbApiWageApplyListPostRequestConfig;

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255634) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/audit/list`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyAuditListPostRequest {
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month: number;
  /**
   * 申报次数
   */
  times: number;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 审批状态
   */
  auditStatusList?: ('WAIT_APPROVAL' | 'WAIT_AUDIT' | 'PASS' | 'REJECT')[];
  /**
   * 申报单号
   */
  wageFormBusinessCode?: string;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255634) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/audit/list`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyAuditListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键id
       */
      id?: number;
      /**
       * 唯一单号
       */
      wageFormCode?: string;
      /**
       * 申报单业务单号
       */
      wageFormBusinessCode?: string;
      /**
       * 年
       */
      year?: number;
      /**
       * 月份
       */
      month?: number;
      /**
       * 申报次数
       */
      times?: number;
      /**
       * 本次申报使用的工资模板编号
       */
      wageIssueTemplateCode?: string;
      /**
       * 创建人id
       */
      operatorId?: number;
      /**
       * 创建人名称
       */
      operatorName?: string;
      /**
       * 单位id
       */
      operatorOrgId?: number;
      /**
       * 单位名
       */
      operatorOrgName?: string;
      /**
       * 申报单状态-前端展示(单据+支付)
       */
      declarationStatus?:
        | 'FORM_REJECT'
        | 'FORM_UN_SUBMIT'
        | 'WAIT_APPROVAL'
        | 'FORM_AUDIT'
        | 'PAY_WAIT'
        | 'PAY_PAYING'
        | 'PAY_PART_FAIL'
        | 'PAY_ALL_FAIL'
        | 'PAY_COMPLETED';
      /**
       * 申报状态描述
       */
      statusDesc?: string;
      /**
       * 支付状态  0-待支付,1-支付中,2-部分失败,3-全部失败，4-已完成
       */
      payStatus?: 'WAIT' | 'PAYING' | 'PART_FAIL' | 'ALL_FAIL' | 'COMPLETED';
      /**
       * 审批状态
       */
      auditStatus?: 'WAIT_APPROVAL' | 'WAIT_AUDIT' | 'PASS' | 'REJECT';
      auditStatusDesc?: string;
      /**
       * 工资明细附件
       */
      wageDetailAttach?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      };
      /**
       * 附件列表
       */
      wageAttachList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 备注
       */
      remark?: string;
      /**
       * 删除标志
       */
      isDelete?: number;
      /**
       * 创建时间
       */
      rAddTime?: string;
      /**
       * 更新时间
       */
      rModifiedTime?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255634) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/audit/list`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
type ZlbApiWageApplyAuditListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/audit/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255634) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/audit/list`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
const zlbApiWageApplyAuditListPostRequestConfig: ZlbApiWageApplyAuditListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/wage/apply/audit/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiWageApplyAuditListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/255634) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/audit/list`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export const zlbApiWageApplyAuditListPost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplyAuditListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplyAuditListPostResponse>(
    prepare(zlbApiWageApplyAuditListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplyAuditListPost.requestConfig = zlbApiWageApplyAuditListPostRequestConfig;

/**
 * 接口 [申报单次数↗](http://yapi.cai-inc.com/project/3621/interface/api/255642) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/times`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyTimesPostRequest {
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month: number;
}

/**
 * 接口 [申报单次数↗](http://yapi.cai-inc.com/project/3621/interface/api/255642) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/times`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyTimesPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单次数↗](http://yapi.cai-inc.com/project/3621/interface/api/255642) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/times`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
type ZlbApiWageApplyTimesPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/times',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单次数↗](http://yapi.cai-inc.com/project/3621/interface/api/255642) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/times`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
const zlbApiWageApplyTimesPostRequestConfig: ZlbApiWageApplyTimesPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_8,
  devUrl: devUrl_0_1_0_8,
  prodUrl: prodUrl_0_1_0_8,
  path: '/zlb/api/wage/apply/times',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbApiWageApplyTimesPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [申报单次数↗](http://yapi.cai-inc.com/project/3621/interface/api/255642) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/times`
 * @更新时间 `2022-06-13 19:26:33`
 * @项目ID 3621
 */
export const zlbApiWageApplyTimesPost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplyTimesPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplyTimesPostResponse>(
    prepare(zlbApiWageApplyTimesPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplyTimesPost.requestConfig = zlbApiWageApplyTimesPostRequestConfig;

/**
 * 接口 [export↗](http://yapi.cai-inc.com/project/3621/interface/api/255666) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/export`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyExportPostRequest {
  /**
   * 唯一单号
   */
  wageFormCode: string;
}

/**
 * 接口 [export↗](http://yapi.cai-inc.com/project/3621/interface/api/255666) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/export`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyExportPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [export↗](http://yapi.cai-inc.com/project/3621/interface/api/255666) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/export`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
type ZlbApiWageApplyExportPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/export',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [export↗](http://yapi.cai-inc.com/project/3621/interface/api/255666) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/export`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
const zlbApiWageApplyExportPostRequestConfig: ZlbApiWageApplyExportPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/wage/apply/export',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiWageApplyExportPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [export↗](http://yapi.cai-inc.com/project/3621/interface/api/255666) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/export`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
export const zlbApiWageApplyExportPost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplyExportPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplyExportPostResponse>(
    prepare(zlbApiWageApplyExportPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplyExportPost.requestConfig = zlbApiWageApplyExportPostRequestConfig;

/**
 * 接口 [geOptionStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/257594) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/status/list`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyStatusListPostRequest {
  /**
   * 1 已完成 2 未完成
   */
  completionStatus?: number;
  /**
   * 1 申报列表 2 审批列表
   */
  formType: number;
}

/**
 * 接口 [geOptionStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/257594) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/status/list`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
export interface ZlbApiWageApplyStatusListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    code?: number;
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [geOptionStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/257594) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/status/list`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
type ZlbApiWageApplyStatusListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/wage/apply/status/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [geOptionStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/257594) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/status/list`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
const zlbApiWageApplyStatusListPostRequestConfig: ZlbApiWageApplyStatusListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/wage/apply/status/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiWageApplyStatusListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [geOptionStatus↗](http://yapi.cai-inc.com/project/3621/interface/api/257594) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/wage/apply/status/list`
 * @更新时间 `2022-06-13 19:26:34`
 * @项目ID 3621
 */
export const zlbApiWageApplyStatusListPost = /*#__PURE__*/ (
  requestData: ZlbApiWageApplyStatusListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiWageApplyStatusListPostResponse>(
    prepare(zlbApiWageApplyStatusListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiWageApplyStatusListPost.requestConfig = zlbApiWageApplyStatusListPostRequestConfig;

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304898) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/audit/list`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyAuditListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month?: number;
  /**
   * 申报次数
   */
  times?: number;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 审批状态
   */
  auditStatusList?: number[];
  /**
   * 申报单号
   */
  wageFormBusinessCode?: string;
  /**
   * app端搜索条件(事由、申请人、单号模糊查询)
   */
  reason?: string;
}

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304898) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/audit/list`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyAuditListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键id
       */
      id?: number;
      /**
       * 唯一单号
       */
      wageFormCode?: string;
      /**
       * 申报单业务单号
       */
      wageFormBusinessCode?: string;
      /**
       * 年
       */
      year?: number;
      /**
       * 月份
       */
      month?: number;
      /**
       * 申报次数
       */
      times?: number;
      /**
       * 本次申报使用的工资模板编号
       */
      wageIssueTemplateCode?: string;
      /**
       * 本次申报使用的工资模板业务编号
       */
      wageTemplateBusinessCode?: string;
      /**
       * 本次申报使用的工资模板名称,详情中需要
       */
      wageIssueTemplateName?: string;
      /**
       * 创建人id
       */
      operatorId?: number;
      /**
       * 创建人名称
       */
      operatorName?: string;
      /**
       * 单位id
       */
      operatorOrgId?: number;
      /**
       * 单位名
       */
      operatorOrgName?: string;
      /**
       * 申报单状态-前端展示(单据+支付)
       */
      declarationStatus?: '-1' | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
      /**
       * 申报状态描述
       */
      statusDesc?: string;
      /**
       * 支付状态  0-待支付,1-支付中,2-部分失败,3-全部失败，4-已完成
       */
      payStatus?: 0 | 1 | 2 | 3 | 4 | 5;
      /**
       * 审批状态
       */
      auditStatus?: 0 | 1 | 2 | 3;
      /**
       * 审批节点类型
       */
      taskNodeEvent?: number;
      auditStatusDesc?: string;
      /**
       * 工资明细附件
       */
      wageDetailAttachList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 附件列表
       */
      wageAttachList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 导入任务单号
       */
      importSerialCode?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 删除标志
       */
      isDelete?: number;
      /**
       * 创建时间
       */
      rAddTime?: string;
      /**
       * 更新时间
       */
      rModifiedTime?: string;
      operateButton?: {
        /**
         * 查看
         */
        view?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 是否可以审批
         */
        canAudit?: boolean;
        /**
         * 是否可以撤回
         */
        revoke?: boolean;
        /**
         * 是否可以作废
         */
        nullify?: boolean;
        /**
         * 是否可以重新提交
         */
        reSubmit?: boolean;
      };
      /**
       * 工作流信息
       */
      workflowInfo?: {
        workflowProcessKey?: string;
        workflowModelId?: number;
        workflowVersion?: number;
        auditNodeList?: {
          auditOperatorList?: {
            operatorId?: number;
            operatorName?: string;
            institutionId?: number;
            institutionName?: string;
            auditRemark?: string;
            auditStatus?: number;
            auditTime?: string;
            signAttachment?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            };
            oneselfHistorySignAttachment?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            };
            addAuditWay?: number;
            addAuditOperator?: string;
            comment?: {
              commentContent?: string;
              operatorId?: number;
              operatorName?: string;
              commentCode?: string;
              commentTime?: number;
              pictureAttachments?: {
                fileId?: string;
                type?: string;
                name?: string;
                size?: number;
                bizCode?: string;
                url?: string;
                sizeDesc?: string;
              }[];
              otherAttachments?: {
                fileId?: string;
                type?: string;
                name?: string;
                size?: number;
                bizCode?: string;
                url?: string;
                sizeDesc?: string;
              }[];
              remove?: boolean;
            };
            operatorType?: number;
          }[];
          userRangeType?: number;
          userRangeTypeNew?: number;
          userRangeValues?: string[];
          userRangeValuesNew?: string[];
          personCount?: number;
          auditStatus?: number;
          auditTime?: string;
          auditDesc?: string;
          auditType?: number;
          eventType?: number;
          nodeType?: number;
          nodeKey?: string;
          nodeName?: string;
          checkStrategy?: number;
          departmentId?: number;
          institutionSelfDtos?: {
            /**
             * 机构编码
             */
            code?: string;
            /**
             * 机构名称
             */
            name?: string;
            userType?: string;
            /**
             * 租户编码（区划编码）
             */
            tenantCode?: string;
            /**
             * 租户编码名称（区划名称）
             */
            tenantName?: string;
            uniqueKey?: string;
            parentInstitution?: {
              parentCode?: number;
              parentName?: string;
            };
          }[];
          commonAuditorList?: {
            displayName?: string;
            userId?: number;
            operatorId?: number;
            code?: string;
            gender?: number;
            institutionId?: number;
            institution?: {
              id?: number;
              createdAt?: number;
              updatedAt?: number;
              creatorId?: string;
              modifierId?: string;
              extFields?: string;
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string;
              tags?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              divisionCode?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
            };
            deptName?: string;
          }[];
          bizProperty?: string;
          comment?: {
            commentContent?: string;
            operatorId?: number;
            operatorName?: string;
            commentCode?: string;
            commentTime?: number;
            pictureAttachments?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            otherAttachments?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            remove?: boolean;
          };
        }[];
        applyOperatorId?: number;
        applyOperatorName?: string;
        applyTime?: string;
        applyRemark?: string;
        isAddTaskAccess?: number;
        isEnableSign?: boolean;
        signConfig?: number;
        currentBizProperty?: string;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304898) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/audit/list`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyAuditListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/audit/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304898) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/audit/list`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyAuditListPostRequestConfig: ZlbApiExpenseWageApplyAuditListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/audit/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyAuditListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304898) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/audit/list`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyAuditListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyAuditListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyAuditListPostResponse>(
    prepare(zlbApiExpenseWageApplyAuditListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyAuditListPost.requestConfig =
  zlbApiExpenseWageApplyAuditListPostRequestConfig;

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/304906) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/delete`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyDeletePostRequest {
  /**
   * 唯一单号
   */
  wageFormCode: string;
}

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/304906) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/delete`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/304906) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/delete`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/304906) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/delete`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyDeletePostRequestConfig: ZlbApiExpenseWageApplyDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/3621/interface/api/304906) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/delete`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyDeletePostResponse>(
    prepare(zlbApiExpenseWageApplyDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyDeletePost.requestConfig = zlbApiExpenseWageApplyDeletePostRequestConfig;

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/304914) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/detail`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyDetailPostRequest {
  /**
   * 唯一单号
   */
  wageFormCode: string;
}

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/304914) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/detail`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyDetailPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 主键id
     */
    id?: number;
    /**
     * 唯一单号
     */
    wageFormCode?: string;
    /**
     * 申报单业务单号
     */
    wageFormBusinessCode?: string;
    /**
     * 年
     */
    year?: number;
    /**
     * 月份
     */
    month?: number;
    /**
     * 申报次数
     */
    times?: number;
    /**
     * 本次申报使用的工资模板编号
     */
    wageIssueTemplateCode?: string;
    /**
     * 本次申报使用的工资模板业务编号
     */
    wageTemplateBusinessCode?: string;
    /**
     * 本次申报使用的工资模板名称,详情中需要
     */
    wageIssueTemplateName?: string;
    /**
     * 创建人id
     */
    operatorId?: number;
    /**
     * 创建人名称
     */
    operatorName?: string;
    /**
     * 单位id
     */
    operatorOrgId?: number;
    /**
     * 单位名
     */
    operatorOrgName?: string;
    /**
     * 申报单状态-前端展示(单据+支付)
     */
    declarationStatus?: '-1' | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
    /**
     * 申报状态描述
     */
    statusDesc?: string;
    /**
     * 支付状态  0-待支付,1-支付中,2-部分失败,3-全部失败，4-已完成
     */
    payStatus?: 0 | 1 | 2 | 3 | 4 | 5;
    /**
     * 审批状态
     */
    auditStatus?: 0 | 1 | 2 | 3;
    /**
     * 审批节点类型
     */
    taskNodeEvent?: number;
    auditStatusDesc?: string;
    /**
     * 工资明细附件
     */
    wageDetailAttachList?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 附件列表
     */
    wageAttachList?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 导入任务单号
     */
    importSerialCode?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 删除标志
     */
    isDelete?: number;
    /**
     * 创建时间
     */
    rAddTime?: string;
    /**
     * 更新时间
     */
    rModifiedTime?: string;
    operateButton?: {
      /**
       * 查看
       */
      view?: boolean;
      /**
       * 编辑
       */
      edit?: boolean;
      /**
       * 删除
       */
      remove?: boolean;
      /**
       * 是否可以审批
       */
      canAudit?: boolean;
      /**
       * 是否可以撤回
       */
      revoke?: boolean;
      /**
       * 是否可以作废
       */
      nullify?: boolean;
      /**
       * 是否可以重新提交
       */
      reSubmit?: boolean;
    };
    /**
     * 工作流信息
     */
    workflowInfo?: {
      workflowProcessKey?: string;
      workflowModelId?: number;
      workflowVersion?: number;
      auditNodeList?: {
        auditOperatorList?: {
          operatorId?: number;
          operatorName?: string;
          institutionId?: number;
          institutionName?: string;
          auditRemark?: string;
          auditStatus?: number;
          auditTime?: string;
          signAttachment?: {
            fileId?: string;
            type?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          oneselfHistorySignAttachment?: {
            fileId?: string;
            type?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          addAuditWay?: number;
          addAuditOperator?: string;
          comment?: {
            commentContent?: string;
            operatorId?: number;
            operatorName?: string;
            commentCode?: string;
            commentTime?: number;
            pictureAttachments?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            otherAttachments?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            remove?: boolean;
          };
          operatorType?: number;
        }[];
        userRangeType?: number;
        userRangeTypeNew?: number;
        userRangeValues?: string[];
        userRangeValuesNew?: string[];
        personCount?: number;
        auditStatus?: number;
        auditTime?: string;
        auditDesc?: string;
        auditType?: number;
        eventType?: number;
        nodeType?: number;
        nodeKey?: string;
        nodeName?: string;
        checkStrategy?: number;
        departmentId?: number;
        institutionSelfDtos?: {
          /**
           * 机构编码
           */
          code?: string;
          /**
           * 机构名称
           */
          name?: string;
          userType?: string;
          /**
           * 租户编码（区划编码）
           */
          tenantCode?: string;
          /**
           * 租户编码名称（区划名称）
           */
          tenantName?: string;
          uniqueKey?: string;
          parentInstitution?: {
            parentCode?: number;
            parentName?: string;
          };
        }[];
        commonAuditorList?: {
          displayName?: string;
          userId?: number;
          operatorId?: number;
          code?: string;
          gender?: number;
          institutionId?: number;
          institution?: {
            id?: number;
            createdAt?: number;
            updatedAt?: number;
            creatorId?: string;
            modifierId?: string;
            extFields?: string;
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string;
            tags?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            divisionCode?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
          };
          deptName?: string;
        }[];
        bizProperty?: string;
        comment?: {
          commentContent?: string;
          operatorId?: number;
          operatorName?: string;
          commentCode?: string;
          commentTime?: number;
          pictureAttachments?: {
            fileId?: string;
            type?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          otherAttachments?: {
            fileId?: string;
            type?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          remove?: boolean;
        };
      }[];
      applyOperatorId?: number;
      applyOperatorName?: string;
      applyTime?: string;
      applyRemark?: string;
      isAddTaskAccess?: number;
      isEnableSign?: boolean;
      signConfig?: number;
      currentBizProperty?: string;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/304914) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/detail`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyDetailPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/detail',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/304914) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/detail`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyDetailPostRequestConfig: ZlbApiExpenseWageApplyDetailPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyDetailPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取申报单详情↗](http://yapi.cai-inc.com/project/3621/interface/api/304914) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/detail`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyDetailPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyDetailPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyDetailPostResponse>(
    prepare(zlbApiExpenseWageApplyDetailPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyDetailPost.requestConfig = zlbApiExpenseWageApplyDetailPostRequestConfig;

/**
 * 接口 [导出申报单明细↗](http://yapi.cai-inc.com/project/3621/interface/api/304922) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/export`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyExportPostRequest {
  /**
   * 唯一单号
   */
  wageFormCode: string;
}

/**
 * 接口 [导出申报单明细↗](http://yapi.cai-inc.com/project/3621/interface/api/304922) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/export`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyExportPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [导出申报单明细↗](http://yapi.cai-inc.com/project/3621/interface/api/304922) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/export`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyExportPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/export',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导出申报单明细↗](http://yapi.cai-inc.com/project/3621/interface/api/304922) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/export`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyExportPostRequestConfig: ZlbApiExpenseWageApplyExportPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/export',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyExportPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导出申报单明细↗](http://yapi.cai-inc.com/project/3621/interface/api/304922) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/export`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyExportPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyExportPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyExportPostResponse>(
    prepare(zlbApiExpenseWageApplyExportPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyExportPost.requestConfig = zlbApiExpenseWageApplyExportPostRequestConfig;

/**
 * 接口 [根据完成状态和报表状态获取对应的状态列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304930) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/status/list`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyStatusListPostRequest {
  /**
   * 1 已完成 2 未完成
   */
  completionStatus?: number;
  /**
   * 1 申报列表 2 审批列表
   */
  formType: number;
}

/**
 * 接口 [根据完成状态和报表状态获取对应的状态列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304930) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/status/list`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyStatusListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    code?: number;
    desc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据完成状态和报表状态获取对应的状态列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304930) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/status/list`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyStatusListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/status/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据完成状态和报表状态获取对应的状态列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304930) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/status/list`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyStatusListPostRequestConfig: ZlbApiExpenseWageApplyStatusListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/status/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyStatusListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据完成状态和报表状态获取对应的状态列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304930) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/status/list`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyStatusListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyStatusListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyStatusListPostResponse>(
    prepare(zlbApiExpenseWageApplyStatusListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyStatusListPost.requestConfig =
  zlbApiExpenseWageApplyStatusListPostRequestConfig;

/**
 * 接口 [获取某年某月的申请次数列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304938) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/times`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyTimesPostRequest {
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month: number;
  /**
   * 机构ID
   */
  orgId?: number;
}

/**
 * 接口 [获取某年某月的申请次数列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304938) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/times`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyTimesPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取某年某月的申请次数列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304938) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/times`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyTimesPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/times',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [获取某年某月的申请次数列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304938) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/times`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyTimesPostRequestConfig: ZlbApiExpenseWageApplyTimesPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/times',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyTimesPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取某年某月的申请次数列表↗](http://yapi.cai-inc.com/project/3621/interface/api/304938) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/times`
 * @更新时间 `2024-02-26 09:46:36`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyTimesPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyTimesPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyTimesPostResponse>(
    prepare(zlbApiExpenseWageApplyTimesPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyTimesPost.requestConfig = zlbApiExpenseWageApplyTimesPostRequestConfig;

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304946) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/list`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month?: number;
  /**
   * 申报次数
   */
  times?: number;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 申报单状态
   */
  declarationStatusList?: number[];
  /**
   * 申报单号
   */
  wageFormBusinessCode?: string;
  /**
   * 机构ID；为了跟申请单报销单保持一致，命名成单数
   */
  orgId?: number[];
  /**
   * 发起人姓名
   */
  operatorName?: string;
  /**
   * 单位统一社会信用代码
   */
  creditCode?: string;
}

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304946) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/list`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键id
       */
      id?: number;
      /**
       * 唯一单号
       */
      wageFormCode?: string;
      /**
       * 申报单业务单号
       */
      wageFormBusinessCode?: string;
      /**
       * 年
       */
      year?: number;
      /**
       * 月份
       */
      month?: number;
      /**
       * 申报次数
       */
      times?: number;
      /**
       * 本次申报使用的工资模板编号
       */
      wageIssueTemplateCode?: string;
      /**
       * 本次申报使用的工资模板业务编号
       */
      wageTemplateBusinessCode?: string;
      /**
       * 本次申报使用的工资模板名称,详情中需要
       */
      wageIssueTemplateName?: string;
      /**
       * 创建人id
       */
      operatorId?: number;
      /**
       * 创建人名称
       */
      operatorName?: string;
      /**
       * 单位id
       */
      operatorOrgId?: number;
      /**
       * 单位名
       */
      operatorOrgName?: string;
      /**
       * 申报单状态-前端展示(单据+支付)
       */
      declarationStatus?: '-1' | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
      /**
       * 申报状态描述
       */
      statusDesc?: string;
      /**
       * 支付状态  0-待支付,1-支付中,2-部分失败,3-全部失败，4-已完成
       */
      payStatus?: 0 | 1 | 2 | 3 | 4 | 5;
      /**
       * 审批状态
       */
      auditStatus?: 0 | 1 | 2 | 3;
      /**
       * 审批节点类型
       */
      taskNodeEvent?: number;
      auditStatusDesc?: string;
      /**
       * 工资明细附件
       */
      wageDetailAttachList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 附件列表
       */
      wageAttachList?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 导入任务单号
       */
      importSerialCode?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 删除标志
       */
      isDelete?: number;
      /**
       * 创建时间
       */
      rAddTime?: string;
      /**
       * 更新时间
       */
      rModifiedTime?: string;
      operateButton?: {
        /**
         * 查看
         */
        view?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 是否可以审批
         */
        canAudit?: boolean;
        /**
         * 是否可以撤回
         */
        revoke?: boolean;
        /**
         * 是否可以作废
         */
        nullify?: boolean;
        /**
         * 是否可以重新提交
         */
        reSubmit?: boolean;
      };
      /**
       * 工作流信息
       */
      workflowInfo?: {
        workflowProcessKey?: string;
        workflowModelId?: number;
        workflowVersion?: number;
        auditNodeList?: {
          auditOperatorList?: {
            operatorId?: number;
            operatorName?: string;
            institutionId?: number;
            institutionName?: string;
            auditRemark?: string;
            auditStatus?: number;
            auditTime?: string;
            signAttachment?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            };
            oneselfHistorySignAttachment?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            };
            addAuditWay?: number;
            addAuditOperator?: string;
            comment?: {
              commentContent?: string;
              operatorId?: number;
              operatorName?: string;
              commentCode?: string;
              commentTime?: number;
              pictureAttachments?: {
                fileId?: string;
                type?: string;
                name?: string;
                size?: number;
                bizCode?: string;
                url?: string;
                sizeDesc?: string;
              }[];
              otherAttachments?: {
                fileId?: string;
                type?: string;
                name?: string;
                size?: number;
                bizCode?: string;
                url?: string;
                sizeDesc?: string;
              }[];
              remove?: boolean;
            };
            operatorType?: number;
          }[];
          userRangeType?: number;
          userRangeTypeNew?: number;
          userRangeValues?: string[];
          userRangeValuesNew?: string[];
          personCount?: number;
          auditStatus?: number;
          auditTime?: string;
          auditDesc?: string;
          auditType?: number;
          eventType?: number;
          nodeType?: number;
          nodeKey?: string;
          nodeName?: string;
          checkStrategy?: number;
          departmentId?: number;
          institutionSelfDtos?: {
            /**
             * 机构编码
             */
            code?: string;
            /**
             * 机构名称
             */
            name?: string;
            userType?: string;
            /**
             * 租户编码（区划编码）
             */
            tenantCode?: string;
            /**
             * 租户编码名称（区划名称）
             */
            tenantName?: string;
            uniqueKey?: string;
            parentInstitution?: {
              parentCode?: number;
              parentName?: string;
            };
          }[];
          commonAuditorList?: {
            displayName?: string;
            userId?: number;
            operatorId?: number;
            code?: string;
            gender?: number;
            institutionId?: number;
            institution?: {
              id?: number;
              createdAt?: number;
              updatedAt?: number;
              creatorId?: string;
              modifierId?: string;
              extFields?: string;
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string;
              tags?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              divisionCode?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
            };
            deptName?: string;
          }[];
          bizProperty?: string;
          comment?: {
            commentContent?: string;
            operatorId?: number;
            operatorName?: string;
            commentCode?: string;
            commentTime?: number;
            pictureAttachments?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            otherAttachments?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            remove?: boolean;
          };
        }[];
        applyOperatorId?: number;
        applyOperatorName?: string;
        applyTime?: string;
        applyRemark?: string;
        isAddTaskAccess?: number;
        isEnableSign?: boolean;
        signConfig?: number;
        currentBizProperty?: string;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304946) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/list`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304946) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/list`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyListPostRequestConfig: ZlbApiExpenseWageApplyListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报单列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/304946) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/list`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyListPostResponse>(
    prepare(zlbApiExpenseWageApplyListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyListPost.requestConfig = zlbApiExpenseWageApplyListPostRequestConfig;

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/304954) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/reject`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyRejectPostRequest {
  /**
   * 唯一单号
   */
  wageFormCode: string;
}

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/304954) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/reject`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyRejectPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/304954) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/reject`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyRejectPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/reject',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/304954) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/reject`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyRejectPostRequestConfig: ZlbApiExpenseWageApplyRejectPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/reject',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyRejectPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报单驳回↗](http://yapi.cai-inc.com/project/3621/interface/api/304954) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/reject`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyRejectPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyRejectPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyRejectPostResponse>(
    prepare(zlbApiExpenseWageApplyRejectPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyRejectPost.requestConfig = zlbApiExpenseWageApplyRejectPostRequestConfig;

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304962) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/save`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplySavePostRequest {
  /**
   * 唯一单号
   */
  wageFormCode?: string;
  /**
   * 申报单业务单号
   */
  wageFormBusinessCode?: string;
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month: number;
  /**
   * 申报次数
   */
  times: number;
  /**
   * 工资明细附件
   */
  wageDetailAttachList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 附件列表
   */
  wageAttachList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 备注
   */
  remark?: string;
  /**
   * 导入任务单号
   */
  importSerialCode?: string;
  /**
   * 工资模板业务编号
   */
  wageTemplateBusinessCode?: string;
}

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304962) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/save`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplySavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304962) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/save`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplySavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304962) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/save`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplySavePostRequestConfig: ZlbApiExpenseWageApplySavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplySavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304962) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/save`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplySavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplySavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplySavePostResponse>(
    prepare(zlbApiExpenseWageApplySavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplySavePost.requestConfig = zlbApiExpenseWageApplySavePostRequestConfig;

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304970) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/submit`
 * @更新时间 `2024-02-26 09:46:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplySubmitPostRequest {
  /**
   * 唯一单号
   */
  wageFormCode?: string;
  /**
   * 申报单业务单号
   */
  wageFormBusinessCode?: string;
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month: number;
  /**
   * 申报次数
   */
  times: number;
  /**
   * 工资明细附件
   */
  wageDetailAttachList: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 附件OosId列表
   */
  wageAttachList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 备注
   */
  remark?: string;
  /**
   * 导入任务编号
   */
  importSerialCode: string;
  /**
   * 本次申报使用的工资模板编号
   */
  wageTemplateBusinessCode: string;
  /**
   * 工作流数据
   */
  workflowInfo?: {
    bizId?: string;
    bizType?: string;
    businessCode?: string;
    subType?: string;
    processDefineKey?: string;
    processModelId?: number;
    version?: number;
    auditInfos?: {
      taskDefineKey?: string;
      operatorIds?: number[];
      nodeType?: number;
      eventType?: number;
      auditType?: number;
      departmentId?: number;
    }[];
    extConditions?: {
      key?: {};
    };
    context?: string;
    operatorId?: number;
    remark?: string;
  };
}

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304970) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/submit`
 * @更新时间 `2024-02-26 09:46:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplySubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304970) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/submit`
 * @更新时间 `2024-02-26 09:46:38`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplySubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304970) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/submit`
 * @更新时间 `2024-02-26 09:46:38`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplySubmitPostRequestConfig: ZlbApiExpenseWageApplySubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplySubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/304970) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/submit`
 * @更新时间 `2024-02-26 09:46:38`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplySubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplySubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplySubmitPostResponse>(
    prepare(zlbApiExpenseWageApplySubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplySubmitPost.requestConfig = zlbApiExpenseWageApplySubmitPostRequestConfig;

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/353890) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/nullify`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyNullifyPostRequest {
  /**
   * 唯一单号
   */
  wageFormCode: string;
}

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/353890) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/nullify`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyNullifyPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/353890) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/nullify`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyNullifyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/nullify',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/353890) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/nullify`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyNullifyPostRequestConfig: ZlbApiExpenseWageApplyNullifyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/nullify',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyNullifyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/353890) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/nullify`
 * @更新时间 `2024-02-26 09:46:35`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyNullifyPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyNullifyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyNullifyPostResponse>(
    prepare(zlbApiExpenseWageApplyNullifyPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyNullifyPost.requestConfig = zlbApiExpenseWageApplyNullifyPostRequestConfig;

/**
 * 接口 [校验申报次数是否可用↗](http://yapi.cai-inc.com/project/3621/interface/api/353898) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/check-times`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyCheckTimesPostRequest {
  /**
   * 年
   */
  year: number;
  /**
   * 月份
   */
  month: number;
  /**
   * 次数
   */
  times: number;
}

/**
 * 接口 [校验申报次数是否可用↗](http://yapi.cai-inc.com/project/3621/interface/api/353898) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/check-times`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWageApplyCheckTimesPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [校验申报次数是否可用↗](http://yapi.cai-inc.com/project/3621/interface/api/353898) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/check-times`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
type ZlbApiExpenseWageApplyCheckTimesPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/wage/apply/check-times',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [校验申报次数是否可用↗](http://yapi.cai-inc.com/project/3621/interface/api/353898) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/check-times`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
const zlbApiExpenseWageApplyCheckTimesPostRequestConfig: ZlbApiExpenseWageApplyCheckTimesPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: '/zlb/api/expense/wage/apply/check-times',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWageApplyCheckTimesPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验申报次数是否可用↗](http://yapi.cai-inc.com/project/3621/interface/api/353898) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工资发放-工资申报↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47508)
 * @请求头 `POST /zlb/api/expense/wage/apply/check-times`
 * @更新时间 `2024-02-26 09:46:37`
 * @项目ID 3621
 */
export const zlbApiExpenseWageApplyCheckTimesPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWageApplyCheckTimesPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWageApplyCheckTimesPostResponse>(
    prepare(zlbApiExpenseWageApplyCheckTimesPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWageApplyCheckTimesPost.requestConfig =
  zlbApiExpenseWageApplyCheckTimesPostRequestConfig;

const mockUrl_0_1_0_9 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_9 = '' as any;
const prodUrl_0_1_0_9 = '' as any;
const dataKey_0_1_0_9 = 'data' as any;

/**
 * 接口 [获取主管列表↗](http://yapi.cai-inc.com/project/3621/interface/api/265314) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/getCharge/list`
 * @更新时间 `2024-02-26 09:45:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseUserGetChargeListGetRequest {
  /**
   * 机构id
   */
  institutionId: string;
  /**
   * 部门id
   */
  departmentId: string;
}

/**
 * 接口 [获取主管列表↗](http://yapi.cai-inc.com/project/3621/interface/api/265314) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/getCharge/list`
 * @更新时间 `2024-02-26 09:45:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseUserGetChargeListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    userId?: number;
    operatorId?: number;
    realName?: string;
    gender?: string;
    status?: string;
    source?: string;
    departmentNames?: string[];
    jobAttributes?: string;
    departmentId?: number;
    institutionId?: number;
    remark?: string;
    institution?: {
      /**
       * 实体主键 [关键字段]
       */
      id?: number;
      /**
       * 记录创建时间
       */
      createdAt?: string;
      /**
       * 记录更新时间
       */
      updatedAt?: string;
      /**
       * 创建用户
       */
      creatorId?: number;
      /**
       * 更新用户
       */
      modifierId?: number;
      /**
       * 机构名称
       */
      name?: string;
      /**
       * 机构简称
       */
      shortName?: string;
      /**
       * 组织机构代码
       */
      orgCode?: string;
      /**
       * 社会统一信用代码
       */
      creditCode?: string;
      /**
       * 机构扫描附件
       */
      bizAttaches?: string[];
      /**
       * 机构标记
       */
      tags?: string[];
      /**
       * 住所省地址编码
       */
      provinceCode?: string;
      /**
       * 住所省地址名称
       */
      provinceName?: string;
      /**
       * 住所市地址编码
       */
      cityCode?: string;
      /**
       * 住所市地址名称
       */
      cityName?: string;
      /**
       * 住所区地址编码
       */
      regionCode?: string;
      /**
       * 住所区地址名称
       */
      regionName?: string;
      /**
       * 住所详细地址
       */
      address?: string;
      /**
       * 机构状态
       */
      status?: number;
      /**
       * 排序码
       */
      displayOrder?: number;
      /**
       * 外部创建时间
       */
      outCreatedAt?: string;
      /**
       * 机构所属行政区划
       */
      divisionCode?: string;
      /**
       * 机构所属行政区划
       */
      divisionName?: string;
      /**
       * 机构全称
       */
      fullName?: string;
      /**
       * 邮政编码
       */
      postalCode?: string;
      /**
       * 来源
       */
      source?: number;
      /**
       * 组织code
       * 第三方业务实体唯一code
       */
      organizationCode?: string;
      /**
       * 单位级别
       */
      institutionLevel?: number;
      /**
       * 标签
       */
      tagCodes?: string;
      operators?: {
        /**
         * 人员id
         */
        operatorId: number;
        /**
         * 人员名称
         */
        operatorName: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
         */
        userType?: number;
        userId?: number;
        userName?: string;
        bankCardInfo?: {
          /**
           * 银行代码
           */
          bankCode: string;
          /**
           * 银行名字
           */
          bankName: string;
          /**
           * 账户名称
           */
          accountName: string;
          /**
           * 银行账号
           */
          bankAccount: string;
          /**
           * 银行账号 脱敏
           */
          bankAccountDesc?: string;
          /**
           * 卡号保存的唯一标识
           */
          accountCode?: string;
        };
        /**
         * 同一个人员，绑定的id
         */
        bindOperatorId?: number;
        /**
         * 用户类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type: number;
        /**
         * 用户职级,
         * 内部用户的职级，外部用户关联内部用户，取内部用户职级
         * 否则去外部用户职级
         */
        userRank?: string;
        /**
         * 手机号
         */
        mobile?: string;
        /**
         * 证件号码
         */
        idCard?: string;
        /**
         * 证件类型
         */
        idType?: number;
        /**
         * 性别
         */
        gender?: number;
      }[];
      tenantCode?: string;
      tenantName?: string;
      userTypeName?: string;
      parentInstitutionName?: string;
      userTypes?: string[];
      operatorCount?: number;
      departmentCount?: number;
      parentInstitution?: {
        id?: number;
        createdAt?: number;
        updatedAt?: number;
        creatorId?: string;
        modifierId?: string;
        extFields?: string;
        name?: string;
        shortName?: string;
        orgCode?: string;
        creditCode?: string;
        bizAttaches?: string;
        tags?: string;
        provinceCode?: string;
        provinceName?: string;
        cityCode?: string;
        cityName?: string;
        regionCode?: string;
        regionName?: string;
        address?: string;
        status?: number;
        displayOrder?: number;
        outCreatedAt?: string;
        divisionCode?: string;
        fullName?: string;
        postalCode?: string;
        source?: number;
        organizationCode?: string;
        institutionLevel?: number;
      };
      /**
       * 是否删除 0：未删除 1：已删除
       */
      isDeleted?: number;
    };
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取主管列表↗](http://yapi.cai-inc.com/project/3621/interface/api/265314) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/getCharge/list`
 * @更新时间 `2024-02-26 09:45:46`
 * @项目ID 3621
 */
type ZlbApiExpenseUserGetChargeListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/user/getCharge/list',
    'data',
    string,
    'institutionId' | 'departmentId',
    false
  >
>;

/**
 * 接口 [获取主管列表↗](http://yapi.cai-inc.com/project/3621/interface/api/265314) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/getCharge/list`
 * @更新时间 `2024-02-26 09:45:46`
 * @项目ID 3621
 */
const zlbApiExpenseUserGetChargeListGetRequestConfig: ZlbApiExpenseUserGetChargeListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/zlb/api/expense/user/getCharge/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: ['institutionId', 'departmentId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseUserGetChargeListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取主管列表↗](http://yapi.cai-inc.com/project/3621/interface/api/265314) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/getCharge/list`
 * @更新时间 `2024-02-26 09:45:46`
 * @项目ID 3621
 */
export const zlbApiExpenseUserGetChargeListGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseUserGetChargeListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseUserGetChargeListGetResponse>(
    prepare(zlbApiExpenseUserGetChargeListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseUserGetChargeListGet.requestConfig = zlbApiExpenseUserGetChargeListGetRequestConfig;

/**
 * 接口 [查询关联机构↗](http://yapi.cai-inc.com/project/3621/interface/api/266754) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/relationInstitution/list`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseUserRelationInstitutionListGetRequest {
  /**
   * 机构id
   */
  institutionId: string;
  /**
   * 用户类别
   */
  userType: string;
}

/**
 * 接口 [查询关联机构↗](http://yapi.cai-inc.com/project/3621/interface/api/266754) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/relationInstitution/list`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseUserRelationInstitutionListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 实体主键 [关键字段]
     */
    id?: number;
    /**
     * 记录创建时间
     */
    createdAt?: string;
    /**
     * 记录更新时间
     */
    updatedAt?: string;
    /**
     * 创建用户
     */
    creatorId?: number;
    /**
     * 更新用户
     */
    modifierId?: number;
    /**
     * 机构名称
     */
    name?: string;
    /**
     * 机构简称
     */
    shortName?: string;
    /**
     * 组织机构代码
     */
    orgCode?: string;
    /**
     * 社会统一信用代码
     */
    creditCode?: string;
    /**
     * 机构扫描附件
     */
    bizAttaches?: string[];
    /**
     * 机构标记
     */
    tags?: string[];
    /**
     * 住所省地址编码
     */
    provinceCode?: string;
    /**
     * 住所省地址名称
     */
    provinceName?: string;
    /**
     * 住所市地址编码
     */
    cityCode?: string;
    /**
     * 住所市地址名称
     */
    cityName?: string;
    /**
     * 住所区地址编码
     */
    regionCode?: string;
    /**
     * 住所区地址名称
     */
    regionName?: string;
    /**
     * 住所详细地址
     */
    address?: string;
    /**
     * 机构状态
     */
    status?: number;
    /**
     * 排序码
     */
    displayOrder?: number;
    /**
     * 外部创建时间
     */
    outCreatedAt?: string;
    /**
     * 机构所属行政区划
     */
    divisionCode?: string;
    /**
     * 机构所属行政区划
     */
    divisionName?: string;
    /**
     * 机构全称
     */
    fullName?: string;
    /**
     * 邮政编码
     */
    postalCode?: string;
    /**
     * 来源
     */
    source?: number;
    /**
     * 组织code
     * 第三方业务实体唯一code
     */
    organizationCode?: string;
    /**
     * 单位级别
     */
    institutionLevel?: number;
    /**
     * 标签
     */
    tagCodes?: string;
    operators?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
    }[];
    tenantCode?: string;
    tenantName?: string;
    userTypeName?: string;
    parentInstitutionName?: string;
    userTypes?: string[];
    operatorCount?: number;
    departmentCount?: number;
    parentInstitution?: {
      id?: number;
      createdAt?: number;
      updatedAt?: number;
      creatorId?: string;
      modifierId?: string;
      extFields?: string;
      name?: string;
      shortName?: string;
      orgCode?: string;
      creditCode?: string;
      bizAttaches?: string;
      tags?: string;
      provinceCode?: string;
      provinceName?: string;
      cityCode?: string;
      cityName?: string;
      regionCode?: string;
      regionName?: string;
      address?: string;
      status?: number;
      displayOrder?: number;
      outCreatedAt?: string;
      divisionCode?: string;
      fullName?: string;
      postalCode?: string;
      source?: number;
      organizationCode?: string;
      institutionLevel?: number;
    };
    /**
     * 是否删除 0：未删除 1：已删除
     */
    isDeleted?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询关联机构↗](http://yapi.cai-inc.com/project/3621/interface/api/266754) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/relationInstitution/list`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
type ZlbApiExpenseUserRelationInstitutionListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/user/relationInstitution/list',
    'data',
    string,
    'institutionId' | 'userType',
    false
  >
>;

/**
 * 接口 [查询关联机构↗](http://yapi.cai-inc.com/project/3621/interface/api/266754) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/relationInstitution/list`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
const zlbApiExpenseUserRelationInstitutionListGetRequestConfig: ZlbApiExpenseUserRelationInstitutionListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/zlb/api/expense/user/relationInstitution/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: ['institutionId', 'userType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseUserRelationInstitutionListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询关联机构↗](http://yapi.cai-inc.com/project/3621/interface/api/266754) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/relationInstitution/list`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
export const zlbApiExpenseUserRelationInstitutionListGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseUserRelationInstitutionListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseUserRelationInstitutionListGetResponse>(
    prepare(zlbApiExpenseUserRelationInstitutionListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseUserRelationInstitutionListGet.requestConfig =
  zlbApiExpenseUserRelationInstitutionListGetRequestConfig;

/**
 * 接口 [获取政采云工号↗](http://yapi.cai-inc.com/project/3621/interface/api/547874) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/get/job-number`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseUserGetJobNumberGetRequest {}

/**
 * 接口 [获取政采云工号↗](http://yapi.cai-inc.com/project/3621/interface/api/547874) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/get/job-number`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseUserGetJobNumberGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取政采云工号↗](http://yapi.cai-inc.com/project/3621/interface/api/547874) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/get/job-number`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
type ZlbApiExpenseUserGetJobNumberGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/user/get/job-number',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取政采云工号↗](http://yapi.cai-inc.com/project/3621/interface/api/547874) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/get/job-number`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
const zlbApiExpenseUserGetJobNumberGetRequestConfig: ZlbApiExpenseUserGetJobNumberGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/zlb/api/expense/user/get/job-number',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseUserGetJobNumberGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取政采云工号↗](http://yapi.cai-inc.com/project/3621/interface/api/547874) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [报销查询-用户中心接口（业务侧包一层情况下使用）↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_47762)
 * @请求头 `GET /zlb/api/expense/user/get/job-number`
 * @更新时间 `2024-02-26 09:45:47`
 * @项目ID 3621
 */
export const zlbApiExpenseUserGetJobNumberGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseUserGetJobNumberGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseUserGetJobNumberGetResponse>(
    prepare(zlbApiExpenseUserGetJobNumberGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseUserGetJobNumberGet.requestConfig = zlbApiExpenseUserGetJobNumberGetRequestConfig;

const mockUrl_0_1_0_10 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_10 = '' as any;
const prodUrl_0_1_0_10 = '' as any;
const dataKey_0_1_0_10 = 'data' as any;

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286002) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init`
 * @更新时间 `2024-12-18 17:18:57`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInitGetRequest {
  /**
   * 区划code
   */
  districtCode?: string;
  /**
   * 业务类型
   */
  businessType?: string;
}

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286002) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init`
 * @更新时间 `2024-12-18 17:18:57`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInitGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 大标题
     */
    headline?: string;
    /**
     * 配置项列表
     */
    configItemList?: {
      /**
       * 配置key
       */
      itemKey?: string;
      /**
       * 配置名称
       */
      itemName?: string;
      /**
       * 选项模式(后期拓展)
       * radio、checkbox
       */
      optionMode?: string;
      /**
       * 配置选项信息列表
       */
      configOptionList?: {
        /**
         * 选项key
         */
        optionKey?: string;
        /**
         * 选项名称
         */
        optionName?: string;
        /**
         * 启用状态
         */
        enable?: boolean;
        /**
         * 是否可编辑
         */
        edit?: boolean;
        /**
         * 是否强制必填
         */
        required?: boolean;
      }[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286002) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init`
 * @更新时间 `2024-12-18 17:18:57`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigInitGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/init',
    'data',
    string,
    'districtCode' | 'businessType',
    false
  >
>;

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286002) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init`
 * @更新时间 `2024-12-18 17:18:57`
 * @项目ID 3621
 */
const zlbApiExpenseConfigInitGetRequestConfig: ZlbApiExpenseConfigInitGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/init',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: ['districtCode', 'businessType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigInitGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286002) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init`
 * @更新时间 `2024-12-18 17:18:57`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigInitGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigInitGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigInitGetResponse>(
    prepare(zlbApiExpenseConfigInitGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigInitGet.requestConfig = zlbApiExpenseConfigInitGetRequestConfig;

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286010) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigEditPostRequest {
  /**
   * 区划code
   */
  districtCode: string;
  businessConfig: {
    /**
     * 业务类型（前端给的是页面上的预算场景code）
     */
    businessType: string;
    /**
     * 配置项列表
     */
    configList: {
      /**
       * 配置key
       */
      itemKey: string;
      /**
       * 选项是否生效
       */
      enable: boolean;
      /**
       * 选项key
       */
      optionKey?: string[];
      /**
       * 扩展信息
       */
      configExtendList?: {
        /**
         * 选项 key
         */
        optionKey?: string;
        /**
         * 是否强制必填
         */
        required?: boolean;
      }[];
    }[];
  }[];
}

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286010) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigEditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286010) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigEditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/edit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286010) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
const zlbApiExpenseConfigEditPostRequestConfig: ZlbApiExpenseConfigEditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/edit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigEditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/286010) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigEditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigEditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigEditPostResponse>(
    prepare(zlbApiExpenseConfigEditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigEditPost.requestConfig = zlbApiExpenseConfigEditPostRequestConfig;

/**
 * 接口 [配置中心菜单;场景相关配置->公务出行\/培训\/会议↗](http://yapi.cai-inc.com/project/3621/interface/api/369458) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/menu`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigMenuGetRequest {}

/**
 * 接口 [配置中心菜单;场景相关配置->公务出行\/培训\/会议↗](http://yapi.cai-inc.com/project/3621/interface/api/369458) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/menu`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigMenuGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 菜单编码
     */
    code?: string;
    /**
     * 菜单描述
     */
    desc?: string;
    /**
     * 下级菜单
     */
    children?: {
      /**
       * 菜单编码
       */
      code?: string;
      /**
       * 菜单描述
       */
      desc?: string;
      /**
       * 下级菜单
       */
      children?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [配置中心菜单;场景相关配置->公务出行\/培训\/会议↗](http://yapi.cai-inc.com/project/3621/interface/api/369458) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/menu`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigMenuGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/menu',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [配置中心菜单;场景相关配置->公务出行\/培训\/会议↗](http://yapi.cai-inc.com/project/3621/interface/api/369458) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/menu`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
const zlbApiExpenseConfigMenuGetRequestConfig: ZlbApiExpenseConfigMenuGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/menu',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigMenuGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [配置中心菜单;场景相关配置->公务出行\/培训\/会议↗](http://yapi.cai-inc.com/project/3621/interface/api/369458) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/menu`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigMenuGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseConfigMenuGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigMenuGetResponse>(
    prepare(zlbApiExpenseConfigMenuGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigMenuGet.requestConfig = zlbApiExpenseConfigMenuGetRequestConfig;

/**
 * 接口 [修改某个场景的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369490) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigEditSceneConfigPostRequest {
  /**
   * 场景相关配置的code
   */
  subTypeCode?: string;
  /**
   * 配置的类型：跨部门/必须关联申请单/模板
   */
  configCode?: string;
  /**
   * 配置详情
   */
  configValue?: {};
  type?: string;
}

/**
 * 接口 [修改某个场景的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369490) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigEditSceneConfigPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [修改某个场景的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369490) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigEditSceneConfigPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/edit-scene-config',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [修改某个场景的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369490) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
const zlbApiExpenseConfigEditSceneConfigPostRequestConfig: ZlbApiExpenseConfigEditSceneConfigPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/edit-scene-config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigEditSceneConfigPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [修改某个场景的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369490) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigEditSceneConfigPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigEditSceneConfigPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigEditSceneConfigPostResponse>(
    prepare(zlbApiExpenseConfigEditSceneConfigPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigEditSceneConfigPost.requestConfig =
  zlbApiExpenseConfigEditSceneConfigPostRequestConfig;

/**
 * 接口 [获取所有业务场景↗](http://yapi.cai-inc.com/project/3621/interface/api/369930) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business-scene`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigBusinessSceneGetRequest {}

/**
 * 接口 [获取所有业务场景↗](http://yapi.cai-inc.com/project/3621/interface/api/369930) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business-scene`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigBusinessSceneGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 主业务编号
     */
    mainCode?: number;
    /**
     * 主业务名称
     */
    mainName?: string;
    /**
     * 次级业务编号
     */
    subCode?: number;
    /**
     * 次级业务名称
     */
    subName?: string;
    /**
     * 查询配置是的code
     */
    subTypeCode?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取所有业务场景↗](http://yapi.cai-inc.com/project/3621/interface/api/369930) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business-scene`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigBusinessSceneGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/business-scene',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取所有业务场景↗](http://yapi.cai-inc.com/project/3621/interface/api/369930) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business-scene`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
const zlbApiExpenseConfigBusinessSceneGetRequestConfig: ZlbApiExpenseConfigBusinessSceneGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/business-scene',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigBusinessSceneGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取所有业务场景↗](http://yapi.cai-inc.com/project/3621/interface/api/369930) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business-scene`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigBusinessSceneGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseConfigBusinessSceneGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigBusinessSceneGetResponse>(
    prepare(zlbApiExpenseConfigBusinessSceneGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigBusinessSceneGet.requestConfig =
  zlbApiExpenseConfigBusinessSceneGetRequestConfig;

/**
 * 接口 [查询某个具体场景的所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369938) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigSceneConfigListPostRequest {
  /**
   * 类型编码
   */
  typeCode?: string;
  /**
   * 子类型编码列表
   */
  subTypeCodeList?: string[];
}

/**
 * 接口 [查询某个具体场景的所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369938) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigSceneConfigListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 场景相关配置的code
     */
    subTypeCode?: string;
    /**
     * 配置的类型：跨部门/必须关联申请单/模板
     */
    configCode?: string;
    /**
     * 配置详情
     */
    configValue?: {};
    type?: string;
    /**
     * 子配置
     */
    children?: {
      /**
       * 场景相关配置的code
       */
      subTypeCode?: string;
      /**
       * 配置的类型：跨部门/必须关联申请单/模板
       */
      configCode?: string;
      /**
       * 配置详情
       */
      configValue?: {};
      type?: string;
      /**
       * 子配置
       */
      children?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询某个具体场景的所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369938) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigSceneConfigListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/scene-config-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询某个具体场景的所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369938) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
const zlbApiExpenseConfigSceneConfigListPostRequestConfig: ZlbApiExpenseConfigSceneConfigListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/scene-config-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigSceneConfigListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询某个具体场景的所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369938) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigSceneConfigListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigSceneConfigListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigSceneConfigListPostResponse>(
    prepare(zlbApiExpenseConfigSceneConfigListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigSceneConfigListPost.requestConfig =
  zlbApiExpenseConfigSceneConfigListPostRequestConfig;

/**
 * 接口 [查询某个具体场景的某个配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369946) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigSceneConfigPostRequest {
  /**
   * business-scene返回的subTypeCode
   */
  subTypeCode?: string;
  /**
   * 配置项,EXPENSE_RELATED_APPLY 报销单是否必须关联申请单；TRANS_DEPARTMENT 是否支持跨部门申请
   */
  configCode?:
    | 'EXPENSE_RELATED_APPLY'
    | 'TRANS_DEPARTMENT'
    | 'SUMMARY_CONFIG'
    | 'ENABLE_SIGN_CONFIG'
    | 'SIGN_CONFIG'
    | 'ENABLE_REVOCATION_CONFIG'
    | 'APPLY_URGE_REIMBURSE'
    | 'EXPENSE_ATTACMENT'
    | 'EXPENSE_WITHOUT_INVOICE'
    | 'DETAIL_RECEPTION_LIST'
    | 'ALLOW_ASSOCIATION_WORK_PLAN'
    | 'CASH_REPUSH_AUDIT_CONFIG'
    | 'APPLY_FORM_SCOPE'
    | 'SMART_EXPENSE_CONFIG';
  /**
   * 查询条件
   */
  itemKey?: string;
}

/**
 * 接口 [查询某个具体场景的某个配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369946) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigSceneConfigPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 场景相关配置的code
     */
    subTypeCode?: string;
    /**
     * 配置的类型：跨部门/必须关联申请单/模板
     */
    configCode?: string;
    /**
     * 配置详情
     */
    configValue?: {};
    type?: string;
    /**
     * 子配置
     */
    children?: {
      /**
       * 场景相关配置的code
       */
      subTypeCode?: string;
      /**
       * 配置的类型：跨部门/必须关联申请单/模板
       */
      configCode?: string;
      /**
       * 配置详情
       */
      configValue?: {};
      type?: string;
      /**
       * 子配置
       */
      children?: {}[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询某个具体场景的某个配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369946) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigSceneConfigPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/scene-config',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询某个具体场景的某个配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369946) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
const zlbApiExpenseConfigSceneConfigPostRequestConfig: ZlbApiExpenseConfigSceneConfigPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/scene-config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigSceneConfigPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询某个具体场景的某个配置↗](http://yapi.cai-inc.com/project/3621/interface/api/369946) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/scene-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigSceneConfigPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigSceneConfigPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigSceneConfigPostResponse>(
    prepare(zlbApiExpenseConfigSceneConfigPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigSceneConfigPost.requestConfig = zlbApiExpenseConfigSceneConfigPostRequestConfig;

/**
 * 接口 [查询平台级所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371914) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/platform-config-list`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigPlatformConfigListGetRequest {}

/**
 * 接口 [查询平台级所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371914) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/platform-config-list`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigPlatformConfigListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 场景相关配置的code
     */
    subTypeCode?: string;
    /**
     * 配置的类型：跨部门/必须关联申请单/模板
     */
    configCode?: string;
    /**
     * 配置详情
     */
    configValue?: {};
    type?: string;
    /**
     * 子配置
     */
    children?: {
      /**
       * 场景相关配置的code
       */
      subTypeCode?: string;
      /**
       * 配置的类型：跨部门/必须关联申请单/模板
       */
      configCode?: string;
      /**
       * 配置详情
       */
      configValue?: {};
      type?: string;
      /**
       * 子配置
       */
      children?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询平台级所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371914) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/platform-config-list`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigPlatformConfigListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/platform-config-list',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询平台级所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371914) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/platform-config-list`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
const zlbApiExpenseConfigPlatformConfigListGetRequestConfig: ZlbApiExpenseConfigPlatformConfigListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/platform-config-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigPlatformConfigListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询平台级所有配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371914) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/platform-config-list`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigPlatformConfigListGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseConfigPlatformConfigListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigPlatformConfigListGetResponse>(
    prepare(zlbApiExpenseConfigPlatformConfigListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigPlatformConfigListGet.requestConfig =
  zlbApiExpenseConfigPlatformConfigListGetRequestConfig;

/**
 * 接口 [修改某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371922) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigEditPlatformConfigPostRequest {
  /**
   * 场景相关配置的code
   */
  subTypeCode?: string;
  /**
   * 配置的类型：跨部门/必须关联申请单/模板
   */
  configCode?: string;
  /**
   * 配置详情
   */
  configValue?: {};
  type?: string;
}

/**
 * 接口 [修改某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371922) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigEditPlatformConfigPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [修改某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371922) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigEditPlatformConfigPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/edit-platform-config',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [修改某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371922) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
const zlbApiExpenseConfigEditPlatformConfigPostRequestConfig: ZlbApiExpenseConfigEditPlatformConfigPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/edit-platform-config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigEditPlatformConfigPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [修改某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/371922) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigEditPlatformConfigPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigEditPlatformConfigPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigEditPlatformConfigPostResponse>(
    prepare(zlbApiExpenseConfigEditPlatformConfigPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigEditPlatformConfigPost.requestConfig =
  zlbApiExpenseConfigEditPlatformConfigPostRequestConfig;

/**
 * 接口 [查询某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/381722) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigPlatformConfigPostRequest {
  /**
   * business-scene返回的subTypeCode
   */
  subTypeCode?: string;
  /**
   * 配置项,EXPENSE_RELATED_APPLY 报销单是否必须关联申请单；TRANS_DEPARTMENT 是否支持跨部门申请
   */
  configCode?:
    | 'EXPENSE_RELATED_APPLY'
    | 'TRANS_DEPARTMENT'
    | 'SUMMARY_CONFIG'
    | 'ENABLE_SIGN_CONFIG'
    | 'SIGN_CONFIG'
    | 'ENABLE_REVOCATION_CONFIG'
    | 'APPLY_URGE_REIMBURSE'
    | 'EXPENSE_ATTACMENT'
    | 'EXPENSE_WITHOUT_INVOICE'
    | 'DETAIL_RECEPTION_LIST'
    | 'ALLOW_ASSOCIATION_WORK_PLAN'
    | 'CASH_REPUSH_AUDIT_CONFIG'
    | 'APPLY_FORM_SCOPE'
    | 'SMART_EXPENSE_CONFIG';
  /**
   * 查询条件
   */
  itemKey?: string;
}

/**
 * 接口 [查询某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/381722) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigPlatformConfigPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 场景相关配置的code
     */
    subTypeCode?: string;
    /**
     * 配置的类型：跨部门/必须关联申请单/模板
     */
    configCode?: string;
    /**
     * 配置详情
     */
    configValue?: {};
    type?: string;
    /**
     * 子配置
     */
    children?: {
      /**
       * 场景相关配置的code
       */
      subTypeCode?: string;
      /**
       * 配置的类型：跨部门/必须关联申请单/模板
       */
      configCode?: string;
      /**
       * 配置详情
       */
      configValue?: {};
      type?: string;
      /**
       * 子配置
       */
      children?: {}[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/381722) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigPlatformConfigPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/platform-config',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/381722) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
const zlbApiExpenseConfigPlatformConfigPostRequestConfig: ZlbApiExpenseConfigPlatformConfigPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/platform-config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigPlatformConfigPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询某个平台级配置↗](http://yapi.cai-inc.com/project/3621/interface/api/381722) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/platform-config`
 * @更新时间 `2024-12-18 17:19:00`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigPlatformConfigPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigPlatformConfigPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigPlatformConfigPostResponse>(
    prepare(zlbApiExpenseConfigPlatformConfigPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigPlatformConfigPost.requestConfig =
  zlbApiExpenseConfigPlatformConfigPostRequestConfig;

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414922) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init-list`
 * @更新时间 `2023-02-27 09:42:30`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInitListGetRequest {
  /**
   * 区划code
   */
  districtCode?: string;
  /**
   * 业务类型
   */
  businessTypeList?: string;
}

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414922) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init-list`
 * @更新时间 `2023-02-27 09:42:30`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInitListGetResponse {
  success?: boolean;
  /**
   * [{"businessType":"","configList":[{"headline":"","configItemList":[{"itemKey":"","itemName":"","optionMode":"","configOptionList":[{"optionKey":"","optionName":"","enable":false}]}]}]}]
   */
  result?: {
    businessType?: string;
    /**
     * [{"headline":"","configItemList":[{"itemKey":"","itemName":"","optionMode":"","configOptionList":[{"optionKey":"","optionName":"","enable":false}]}]}]
     */
    configList?: {
      headline?: string;
      /**
       * [{"itemKey":"","itemName":"","optionMode":"","configOptionList":[{"optionKey":"","optionName":"","enable":false}]}]
       */
      configItemList?: {
        itemKey?: string;
        itemName?: string;
        optionMode?: string;
        /**
         * [{"optionKey":"","optionName":"","enable":false}]
         */
        configOptionList?: {
          optionKey?: string;
          optionName?: string;
          enable?: boolean;
        }[];
      }[];
    }[];
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414922) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init-list`
 * @更新时间 `2023-02-27 09:42:30`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigInitListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/init-list',
    'data',
    string,
    'districtCode' | 'businessTypeList',
    false
  >
>;

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414922) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init-list`
 * @更新时间 `2023-02-27 09:42:30`
 * @项目ID 3621
 */
const zlbApiExpenseConfigInitListGetRequestConfig: ZlbApiExpenseConfigInitListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/init-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: ['districtCode', 'businessTypeList'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigInitListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414922) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/init-list`
 * @更新时间 `2023-02-27 09:42:30`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigInitListGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigInitListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigInitListGetResponse>(
    prepare(zlbApiExpenseConfigInitListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigInitListGet.requestConfig = zlbApiExpenseConfigInitListGetRequestConfig;

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414930) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/config/init-new`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInitNewGetRequest {
  /**
   * 区划code
   */
  districtCode?: string;
  /**
   * 业务类型
   */
  businessType?: string;
}

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414930) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/config/init-new`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInitNewGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 大标题
     */
    headline?: string;
    /**
     * 配置项列表
     */
    configItemList?: {
      /**
       * 配置key
       */
      itemKey?: string;
      /**
       * 配置名称
       */
      itemName?: string;
      /**
       * 选项模式(后期拓展)
       * radio、checkbox
       */
      optionMode?: string;
      /**
       * 配置选项信息列表
       */
      configOptionList?: {
        /**
         * 选项key
         */
        optionKey?: string;
        /**
         * 选项名称
         */
        optionName?: string;
        /**
         * 启用状态
         */
        enable?: boolean;
        /**
         * 是否可编辑
         */
        edit?: boolean;
        /**
         * 是否强制必填
         */
        required?: boolean;
      }[];
    }[];
  }[][];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414930) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/config/init-new`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigInitNewGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/init-new',
    'data',
    string,
    'districtCode' | 'businessType',
    false
  >
>;

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414930) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/config/init-new`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
const zlbApiExpenseConfigInitNewGetRequestConfig: ZlbApiExpenseConfigInitNewGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/init-new',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: ['districtCode', 'businessType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigInitNewGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414930) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/config/init-new`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigInitNewGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigInitNewGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigInitNewGetResponse>(
    prepare(zlbApiExpenseConfigInitNewGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigInitNewGet.requestConfig = zlbApiExpenseConfigInitNewGetRequestConfig;

/**
 * 接口 [批量配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414938) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigEditListPostRequest {
  /**
   * 区划code
   */
  districtCode: string;
  /**
   * 配置项
   */
  configEditList: {
    /**
     * 业务类型（前端给的是页面上的预算场景code）
     */
    businessType: string;
    /**
     * 配置项列表
     */
    configList: {
      /**
       * 配置key
       */
      itemKey: string;
      /**
       * 选项是否生效
       */
      enable: boolean;
      /**
       * 选项key
       */
      optionKey?: string[];
      /**
       * 扩展信息
       */
      configExtendList?: {
        /**
         * 选项 key
         */
        optionKey?: string;
        /**
         * 是否强制必填
         */
        required?: boolean;
      }[];
    }[];
  }[];
  /**
   * 差旅费用类型配置项
   */
  travelFeeConfigList?: {
    /**
     * 业务类型
     */
    businessType: string;
    /**
     * 费用类型配置项
     */
    itemConfigList: {
      /**
       * 配置key
       */
      parentItemKey?: string;
      /**
       * 配置key
       */
      itemKey?: string;
      /**
       * 配置名称
       */
      itemName?: string;
      /**
       * 启用状态
       */
      enable?: boolean;
    }[];
  }[];
}

/**
 * 接口 [批量配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414938) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigEditListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [批量配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414938) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigEditListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/edit-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [批量配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414938) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
const zlbApiExpenseConfigEditListPostRequestConfig: ZlbApiExpenseConfigEditListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/edit-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigEditListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [批量配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414938) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/edit-list`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigEditListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigEditListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigEditListPostResponse>(
    prepare(zlbApiExpenseConfigEditListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigEditListPost.requestConfig = zlbApiExpenseConfigEditListPostRequestConfig;

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415890) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/init-list`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInitListPostRequest {
  /**
   * 区划code
   */
  districtCode?: string;
  /**
   * 配置type列表
   */
  businessTypeList: string[];
}

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415890) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/init-list`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInitListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 业务类型
     */
    businessType?: string;
    /**
     * 业务类型名称
     */
    businessTypeDesc?: string;
    /**
     * 配置项列表
     */
    itemConfigList?: {
      /**
       * 配置key
       */
      itemKey?: string;
      /**
       * 配置名称
       */
      itemName?: string;
      /**
       * 启用状态
       */
      enable?: boolean;
      /**
       * 配置key
       */
      parentItemKey?: string;
      /**
       * 是否可以修改名字
       */
      canEditName?: boolean;
      /**
       * 配置项展示类型
       */
      itemMode?: string;
      configSort?: number;
      /**
       * 子配置
       */
      children?: {
        /**
         * 配置key
         */
        itemKey?: string;
        /**
         * 配置名称
         */
        itemName?: string;
        /**
         * 启用状态
         */
        enable?: boolean;
        /**
         * 配置key
         */
        parentItemKey?: string;
        /**
         * 是否可以修改名字
         */
        canEditName?: boolean;
        /**
         * 配置项展示类型
         */
        itemMode?: string;
        configSort?: number;
        /**
         * 子配置
         */
        children?: {}[];
      }[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415890) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/init-list`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigInitListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/init-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415890) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/init-list`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
const zlbApiExpenseConfigInitListPostRequestConfig: ZlbApiExpenseConfigInitListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/init-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigInitListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [批量配置页面初始化接口↗](http://yapi.cai-inc.com/project/3621/interface/api/415890) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/init-list`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigInitListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigInitListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigInitListPostResponse>(
    prepare(zlbApiExpenseConfigInitListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigInitListPost.requestConfig = zlbApiExpenseConfigInitListPostRequestConfig;

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515570) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/invoice-page`
 * @更新时间 `2023-08-15 15:52:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInvoicePagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 交易信息编码
   */
  tradeCode?: string;
}

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515570) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/invoice-page`
 * @更新时间 `2023-08-15 15:52:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigInvoicePagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 原图
       */
      originalAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 原始图片地址
       */
      originalUrl?: string;
      /**
       * 版式文件
       */
      formatAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 版式文件图片地址
       */
      formatUrl?: string;
      /**
       * 文件类型
       */
      fileType?: string;
      /**
       * 票据种类
       */
      invoiceType?: string;
      /**
       * 票据种类描述
       */
      invoiceTypeDesc?: string;
      /**
       * 开票日期
       */
      issueDate?: string;
      /**
       * 验真状态
       */
      realStatus?: number;
      /**
       * 验真状态描述
       */
      realStatusDesc?: string;
      /**
       * 消费金额
       */
      totalAmount?: number;
      /**
       * 平台发票id
       */
      platformInvoiceId?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderCode?: string;
      /**
       * 订单编号 for 会议/培训/办公用品采购
       */
      orderId?: number;
      /**
       * 发票代码
       */
      invoiceCode?: string;
      /**
       * 发票号码
       */
      invoiceNo?: string;
      /**
       * 票据来源
       */
      dataSource?: string;
      /**
       * 发票图片地址
       */
      imageUrl?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515570) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/invoice-page`
 * @更新时间 `2023-08-15 15:52:37`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigInvoicePagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/invoice-page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515570) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/invoice-page`
 * @更新时间 `2023-08-15 15:52:37`
 * @项目ID 3621
 */
const zlbApiExpenseConfigInvoicePagePostRequestConfig: ZlbApiExpenseConfigInvoicePagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/invoice-page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigInvoicePagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [发票列表↗](http://yapi.cai-inc.com/project/3621/interface/api/515570) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/invoice-page`
 * @更新时间 `2023-08-15 15:52:37`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigInvoicePagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigInvoicePagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigInvoicePagePostResponse>(
    prepare(zlbApiExpenseConfigInvoicePagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigInvoicePagePost.requestConfig = zlbApiExpenseConfigInvoicePagePostRequestConfig;

/**
 * 接口 [businessRuleInitConfig↗](http://yapi.cai-inc.com/project/3621/interface/api/578634) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2023-11-22 11:37:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigBusinessRuleInitGetRequest {}

/**
 * 接口 [businessRuleInitConfig↗](http://yapi.cai-inc.com/project/3621/interface/api/578634) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2023-11-22 11:37:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigBusinessRuleInitGetResponse {
  success?: boolean;
  result?: {
    /**
     * 大标题
     */
    headline?: string;
    /**
     * 配置项列表
     */
    configItemList?: {
      /**
       * 配置key
       */
      itemKey?: string;
      /**
       * 配置名称
       */
      itemName?: string;
      /**
       * 选项模式(后期拓展)
       * radio、checkbox
       */
      optionMode?: string;
      /**
       * 配置选项信息列表
       */
      configOptionList?: {
        /**
         * 选项key
         */
        optionKey?: string;
        /**
         * 选项名称
         */
        optionName?: string;
        /**
         * 启用状态
         */
        enable?: boolean;
        /**
         * 是否可编辑
         */
        edit?: boolean;
      }[];
    }[];
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [businessRuleInitConfig↗](http://yapi.cai-inc.com/project/3621/interface/api/578634) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2023-11-22 11:37:26`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigBusinessRuleInitGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/business/rule/init',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [businessRuleInitConfig↗](http://yapi.cai-inc.com/project/3621/interface/api/578634) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2023-11-22 11:37:26`
 * @项目ID 3621
 */
const zlbApiExpenseConfigBusinessRuleInitGetRequestConfig: ZlbApiExpenseConfigBusinessRuleInitGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/business/rule/init',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigBusinessRuleInitGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [businessRuleInitConfig↗](http://yapi.cai-inc.com/project/3621/interface/api/578634) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2023-11-22 11:37:26`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigBusinessRuleInitGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseConfigBusinessRuleInitGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigBusinessRuleInitGetResponse>(
    prepare(zlbApiExpenseConfigBusinessRuleInitGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigBusinessRuleInitGet.requestConfig =
  zlbApiExpenseConfigBusinessRuleInitGetRequestConfig;

/**
 * 接口 [单位管理 配置项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/578642) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigBusinessRuleInitPostRequest {
  /**
   * 配置ID
   */
  configId?: string;
  /**
   * 配置ID类型
   */
  configType?: 'DEFAULT' | 'DISTRICT' | 'INSTITUTION' | 'USER_ID' | 'OPERATOR_ID';
  /**
   * 报销业务类型
   */
  businessType?:
    | 'CONFIG_TRAVEL'
    | 'CONFIG_MEET'
    | 'CONFIG_TRAINING'
    | 'CONFIG_RECEPTION'
    | 'CONFIG_BAIDA_DISTRICT'
    | 'ALLOW_ASSOCIATION_WORK_PLAN'
    | 'CONFIG_GENERAL_FORM'
    | 'ORDINARY_FEE_TYPE'
    | 'SPECIAL_FEE_TYPE'
    | 'EXPATRIATE_FEE_TYPE'
    | 'OUT_FEE_TYPE'
    | 'OUT_TRAINING_FEE_TYPE'
    | 'CONTINUE_EDUCATE_FEE_TYPE';
}

/**
 * 接口 [单位管理 配置项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/578642) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigBusinessRuleInitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 大标题
     */
    headline?: string;
    /**
     * 配置项列表
     */
    configItemList?: {
      /**
       * 配置key
       */
      itemKey?: string;
      /**
       * 配置名称
       */
      itemName?: string;
      /**
       * 选项模式(后期拓展)
       * radio、checkbox
       */
      optionMode?: string;
      /**
       * 配置选项信息列表
       */
      configOptionList?: {
        /**
         * 选项key
         */
        optionKey?: string;
        /**
         * 选项名称
         */
        optionName?: string;
        /**
         * 启用状态
         */
        enable?: boolean;
        /**
         * 是否可编辑
         */
        edit?: boolean;
        /**
         * 是否强制必填
         */
        required?: boolean;
      }[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单位管理 配置项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/578642) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigBusinessRuleInitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/business/rule/init',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [单位管理 配置项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/578642) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
const zlbApiExpenseConfigBusinessRuleInitPostRequestConfig: ZlbApiExpenseConfigBusinessRuleInitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/business/rule/init',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigBusinessRuleInitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单位管理 配置项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/578642) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/init`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigBusinessRuleInitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigBusinessRuleInitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigBusinessRuleInitPostResponse>(
    prepare(zlbApiExpenseConfigBusinessRuleInitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigBusinessRuleInitPost.requestConfig =
  zlbApiExpenseConfigBusinessRuleInitPostRequestConfig;

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/582330) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/edit`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigBusinessRuleEditPostRequest {
  /**
   * 配置ID 区划传租户ID 单位传机构ID
   * 目前仅支持单位维度
   */
  configId: string;
  /**
   * 配置类型
   */
  configType: number;
  /**
   * 配置项
   */
  configEditList: {
    /**
     * 业务类型（前端给的是页面上的预算场景code）
     */
    businessType: string;
    /**
     * 配置项列表
     */
    configList: {
      /**
       * 配置key
       */
      itemKey: string;
      /**
       * 选项是否生效
       */
      enable: boolean;
      /**
       * 选项key
       */
      optionKey?: string[];
      /**
       * 扩展信息
       */
      configExtendList?: {
        /**
         * 选项 key
         */
        optionKey?: string;
        /**
         * 是否强制必填
         */
        required?: boolean;
      }[];
    }[];
  }[];
}

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/582330) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/edit`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigBusinessRuleEditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/582330) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/edit`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigBusinessRuleEditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/business/rule/edit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/582330) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/edit`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
const zlbApiExpenseConfigBusinessRuleEditPostRequestConfig: ZlbApiExpenseConfigBusinessRuleEditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/business/rule/edit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigBusinessRuleEditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [配置项修改接口↗](http://yapi.cai-inc.com/project/3621/interface/api/582330) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/business/rule/edit`
 * @更新时间 `2024-12-18 17:18:59`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigBusinessRuleEditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigBusinessRuleEditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigBusinessRuleEditPostResponse>(
    prepare(zlbApiExpenseConfigBusinessRuleEditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigBusinessRuleEditPost.requestConfig =
  zlbApiExpenseConfigBusinessRuleEditPostRequestConfig;

/**
 * 接口 [工作计划关联关系状态↗](http://yapi.cai-inc.com/project/3621/interface/api/589954) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/work-plan-rel-status`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigWorkPlanRelStatusGetRequest {}

/**
 * 接口 [工作计划关联关系状态↗](http://yapi.cai-inc.com/project/3621/interface/api/589954) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/work-plan-rel-status`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigWorkPlanRelStatusGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [工作计划关联关系状态↗](http://yapi.cai-inc.com/project/3621/interface/api/589954) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/work-plan-rel-status`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigWorkPlanRelStatusGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/work-plan-rel-status',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [工作计划关联关系状态↗](http://yapi.cai-inc.com/project/3621/interface/api/589954) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/work-plan-rel-status`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
const zlbApiExpenseConfigWorkPlanRelStatusGetRequestConfig: ZlbApiExpenseConfigWorkPlanRelStatusGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/work-plan-rel-status',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigWorkPlanRelStatusGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [工作计划关联关系状态↗](http://yapi.cai-inc.com/project/3621/interface/api/589954) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `GET /zlb/api/expense/config/work-plan-rel-status`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigWorkPlanRelStatusGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseConfigWorkPlanRelStatusGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigWorkPlanRelStatusGetResponse>(
    prepare(zlbApiExpenseConfigWorkPlanRelStatusGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigWorkPlanRelStatusGet.requestConfig =
  zlbApiExpenseConfigWorkPlanRelStatusGetRequestConfig;

/**
 * 接口 [获取某个平台级摘要的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/706730) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/query-summary-config-enable`
 * @更新时间 `2024-12-18 17:19:01`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigQuerySummaryConfigEnablePostRequest {
  /**
   * business-scene返回的subTypeCode
   */
  subTypeCode?: string;
  /**
   * 配置项,EXPENSE_RELATED_APPLY 报销单是否必须关联申请单；TRANS_DEPARTMENT 是否支持跨部门申请
   */
  configCode?:
    | 'EXPENSE_RELATED_APPLY'
    | 'TRANS_DEPARTMENT'
    | 'SUMMARY_CONFIG'
    | 'ENABLE_SIGN_CONFIG'
    | 'SIGN_CONFIG'
    | 'ENABLE_REVOCATION_CONFIG'
    | 'APPLY_URGE_REIMBURSE'
    | 'EXPENSE_ATTACMENT'
    | 'EXPENSE_WITHOUT_INVOICE'
    | 'DETAIL_RECEPTION_LIST'
    | 'ALLOW_ASSOCIATION_WORK_PLAN'
    | 'CASH_REPUSH_AUDIT_CONFIG'
    | 'APPLY_FORM_SCOPE'
    | 'SMART_EXPENSE_CONFIG';
  /**
   * 查询条件
   */
  itemKey?: string;
}

/**
 * 接口 [获取某个平台级摘要的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/706730) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/query-summary-config-enable`
 * @更新时间 `2024-12-18 17:19:01`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigQuerySummaryConfigEnablePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取某个平台级摘要的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/706730) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/query-summary-config-enable`
 * @更新时间 `2024-12-18 17:19:01`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigQuerySummaryConfigEnablePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/query-summary-config-enable',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [获取某个平台级摘要的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/706730) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/query-summary-config-enable`
 * @更新时间 `2024-12-18 17:19:01`
 * @项目ID 3621
 */
const zlbApiExpenseConfigQuerySummaryConfigEnablePostRequestConfig: ZlbApiExpenseConfigQuerySummaryConfigEnablePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/query-summary-config-enable',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigQuerySummaryConfigEnablePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取某个平台级摘要的配置↗](http://yapi.cai-inc.com/project/3621/interface/api/706730) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/query-summary-config-enable`
 * @更新时间 `2024-12-18 17:19:01`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigQuerySummaryConfigEnablePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigQuerySummaryConfigEnablePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigQuerySummaryConfigEnablePostResponse>(
    prepare(zlbApiExpenseConfigQuerySummaryConfigEnablePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigQuerySummaryConfigEnablePost.requestConfig =
  zlbApiExpenseConfigQuerySummaryConfigEnablePostRequestConfig;

/**
 * 接口 [配置项查询 目前权限类仅支持【全局、区划、机构】↗](http://yapi.cai-inc.com/project/3621/interface/api/739138) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/query`
 * @更新时间 `2024-12-13 14:48:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigRuleOptionQueryPostRequest {
  /**
   * 所属业务
   */
  businessType?: string;
  /**
   * 配置权限 id，全局 = -1、区划 = id、机构 = id
   */
  configId?: string;
  /**
   * 配置权限类型，1 = 全局、2 = 区划、3 = 机构
   */
  configType?: number;
  /**
   * 配置条目 key
   */
  itemKey?: string;
  /**
   * 操作项 keu
   */
  optionKey?: string[];
}

/**
 * 接口 [配置项查询 目前权限类仅支持【全局、区划、机构】↗](http://yapi.cai-inc.com/project/3621/interface/api/739138) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/query`
 * @更新时间 `2024-12-13 14:48:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigRuleOptionQueryPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 选项key
     */
    optionKey?: string;
    /**
     * 选项名称
     */
    optionName?: string;
    /**
     * 启用状态
     */
    enable?: boolean;
    /**
     * 是否可编辑
     */
    edit?: boolean;
    /**
     * 是否强制必填
     */
    required?: boolean;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [配置项查询 目前权限类仅支持【全局、区划、机构】↗](http://yapi.cai-inc.com/project/3621/interface/api/739138) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/query`
 * @更新时间 `2024-12-13 14:48:16`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigRuleOptionQueryPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/rule-option/query',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [配置项查询 目前权限类仅支持【全局、区划、机构】↗](http://yapi.cai-inc.com/project/3621/interface/api/739138) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/query`
 * @更新时间 `2024-12-13 14:48:16`
 * @项目ID 3621
 */
const zlbApiExpenseConfigRuleOptionQueryPostRequestConfig: ZlbApiExpenseConfigRuleOptionQueryPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/rule-option/query',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigRuleOptionQueryPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [配置项查询 目前权限类仅支持【全局、区划、机构】↗](http://yapi.cai-inc.com/project/3621/interface/api/739138) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/query`
 * @更新时间 `2024-12-13 14:48:16`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigRuleOptionQueryPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigRuleOptionQueryPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigRuleOptionQueryPostResponse>(
    prepare(zlbApiExpenseConfigRuleOptionQueryPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigRuleOptionQueryPost.requestConfig =
  zlbApiExpenseConfigRuleOptionQueryPostRequestConfig;

/**
 * 接口 [配置项查询 从用户的【机构id】出发向上查找↗](http://yapi.cai-inc.com/project/3621/interface/api/739146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/user/query`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigRuleOptionUserQueryPostRequest {
  /**
   * 场景值
   */
  sceneKey?: string;
  /**
   * 单据类型
   */
  formKey?: string;
}

/**
 * 接口 [配置项查询 从用户的【机构id】出发向上查找↗](http://yapi.cai-inc.com/project/3621/interface/api/739146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/user/query`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export interface ZlbApiExpenseConfigRuleOptionUserQueryPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 配置条目 key
     */
    itemKey?: string;
    /**
     * 配置条目 名称
     */
    itemName?: string;
    /**
     * 选项 key
     */
    optionKey?: string;
    /**
     * 选项 名称
     */
    optionName?: string;
    /**
     * 启用状态
     */
    enable?: boolean;
    /**
     * 是否强制必填
     * true = 必填
     * null = 未配置
     */
    required?: boolean;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [配置项查询 从用户的【机构id】出发向上查找↗](http://yapi.cai-inc.com/project/3621/interface/api/739146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/user/query`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
type ZlbApiExpenseConfigRuleOptionUserQueryPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/config/rule-option/user/query',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [配置项查询 从用户的【机构id】出发向上查找↗](http://yapi.cai-inc.com/project/3621/interface/api/739146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/user/query`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
const zlbApiExpenseConfigRuleOptionUserQueryPostRequestConfig: ZlbApiExpenseConfigRuleOptionUserQueryPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/zlb/api/expense/config/rule-option/user/query',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseConfigRuleOptionUserQueryPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [配置项查询 从用户的【机构id】出发向上查找↗](http://yapi.cai-inc.com/project/3621/interface/api/739146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [区划配置↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48155)
 * @请求头 `POST /zlb/api/expense/config/rule-option/user/query`
 * @更新时间 `2024-12-18 17:18:58`
 * @项目ID 3621
 */
export const zlbApiExpenseConfigRuleOptionUserQueryPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseConfigRuleOptionUserQueryPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseConfigRuleOptionUserQueryPostResponse>(
    prepare(zlbApiExpenseConfigRuleOptionUserQueryPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseConfigRuleOptionUserQueryPost.requestConfig =
  zlbApiExpenseConfigRuleOptionUserQueryPostRequestConfig;

const mockUrl_0_1_0_11 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_11 = '' as any;
const prodUrl_0_1_0_11 = '' as any;
const dataKey_0_1_0_11 = 'data' as any;

/**
 * 接口 [根据userIdList查询收款卡列表(只获取公务卡、个人卡、外部人员卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/290978) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
export type ZlbApiExpensePayQueryBankCardPostRequest = number[];

/**
 * 接口 [根据userIdList查询收款卡列表(只获取公务卡、个人卡、外部人员卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/290978) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
export interface ZlbApiExpensePayQueryBankCardPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 用户名称
     */
    userName?: string;
    /**
     * 用户ID
     */
    userId?: number;
    /**
     * 用户ID
     */
    operatorId?: number;
    /**
     * 人员来源 1-系统内部；2-外部人员
     */
    userSource?: 1 | 2;
    userType?: number;
    type?: number;
    /**
     * 账号编码
     */
    accountCode?: string;
    /**
     * 财政区划代码
     */
    finaDivCode?: string;
    /**
     * 单位代码
     */
    companyCode?: string;
    /**
     * 单位名称
     */
    companyName?: string;
    /**
     * 银行代码
     */
    bankCode?: string;
    /**
     * 银行行号
     */
    bankNo?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 支行名称
     */
    bankBranchName?: string;
    /**
     * 银行账户
     */
    accountNo?: string;
    /**
     * 账户名称
     */
    accountName?: string;
    /**
     * 账户状态
     * 0-未启用；1-启用
     */
    accountStatus?: number;
    /**
     * 账户类型
     * 1-公务卡；2-个人卡；7-外部人员卡
     */
    accountType?: number;
    /**
     * 账户类型名称
     * 公务卡；个人卡；外部人员卡
     */
    accountTypeName?: string;
    /**
     * 是否默认 0-否；1-是
     */
    isDefault?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据userIdList查询收款卡列表(只获取公务卡、个人卡、外部人员卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/290978) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
type ZlbApiExpensePayQueryBankCardPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/pay/query/bank-card',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据userIdList查询收款卡列表(只获取公务卡、个人卡、外部人员卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/290978) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
const zlbApiExpensePayQueryBankCardPostRequestConfig: ZlbApiExpensePayQueryBankCardPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_11,
    devUrl: devUrl_0_1_0_11,
    prodUrl: prodUrl_0_1_0_11,
    path: '/zlb/api/expense/pay/query/bank-card',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePayQueryBankCardPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据userIdList查询收款卡列表(只获取公务卡、个人卡、外部人员卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/290978) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
export const zlbApiExpensePayQueryBankCardPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePayQueryBankCardPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePayQueryBankCardPostResponse>(
    prepare(zlbApiExpensePayQueryBankCardPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePayQueryBankCardPost.requestConfig = zlbApiExpensePayQueryBankCardPostRequestConfig;

/**
 * 接口 [根据用户id查询卡号(每人只获取一张卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/555498) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/single-bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
export type ZlbApiExpensePayQuerySingleBankCardPostRequest = number[];

/**
 * 接口 [根据用户id查询卡号(每人只获取一张卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/555498) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/single-bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
export interface ZlbApiExpensePayQuerySingleBankCardPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 用户名称
     */
    userName?: string;
    /**
     * 用户ID
     */
    userId?: number;
    /**
     * 用户ID
     */
    operatorId?: number;
    /**
     * 人员来源 1-系统内部；2-外部人员
     */
    userSource?: 1 | 2;
    userType?: number;
    type?: number;
    /**
     * 账号编码
     */
    accountCode?: string;
    /**
     * 财政区划代码
     */
    finaDivCode?: string;
    /**
     * 单位代码
     */
    companyCode?: string;
    /**
     * 单位名称
     */
    companyName?: string;
    /**
     * 银行代码
     */
    bankCode?: string;
    /**
     * 银行行号
     */
    bankNo?: string;
    /**
     * 银行名称
     */
    bankName?: string;
    /**
     * 支行名称
     */
    bankBranchName?: string;
    /**
     * 银行账户
     */
    accountNo?: string;
    /**
     * 账户名称
     */
    accountName?: string;
    /**
     * 账户状态
     * 0-未启用；1-启用
     */
    accountStatus?: number;
    /**
     * 账户类型
     * 1-公务卡；2-个人卡；7-外部人员卡
     */
    accountType?: number;
    /**
     * 账户类型名称
     * 公务卡；个人卡；外部人员卡
     */
    accountTypeName?: string;
    /**
     * 是否默认 0-否；1-是
     */
    isDefault?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据用户id查询卡号(每人只获取一张卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/555498) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/single-bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
type ZlbApiExpensePayQuerySingleBankCardPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/pay/query/single-bank-card',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据用户id查询卡号(每人只获取一张卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/555498) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/single-bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
const zlbApiExpensePayQuerySingleBankCardPostRequestConfig: ZlbApiExpensePayQuerySingleBankCardPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_11,
    devUrl: devUrl_0_1_0_11,
    prodUrl: prodUrl_0_1_0_11,
    path: '/zlb/api/expense/pay/query/single-bank-card',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePayQuerySingleBankCardPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据用户id查询卡号(每人只获取一张卡)↗](http://yapi.cai-inc.com/project/3621/interface/api/555498) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [PayController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48296)
 * @请求头 `POST /zlb/api/expense/pay/query/single-bank-card`
 * @更新时间 `2024-02-26 09:44:35`
 * @项目ID 3621
 */
export const zlbApiExpensePayQuerySingleBankCardPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePayQuerySingleBankCardPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePayQuerySingleBankCardPostResponse>(
    prepare(zlbApiExpensePayQuerySingleBankCardPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePayQuerySingleBankCardPost.requestConfig =
  zlbApiExpensePayQuerySingleBankCardPostRequestConfig;

const mockUrl_0_1_0_12 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_12 = '' as any;
const prodUrl_0_1_0_12 = '' as any;
const dataKey_0_1_0_12 = 'data' as any;

/**
 * 接口 [保存批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300730) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/save`
 * @更新时间 `2024-04-02 14:40:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeSavePostRequest {
  /**
   * 批量发放唯一编号
   */
  batchDistributeCode?: string;
  /**
   * 单据类型：0-个人；1-企业；
   */
  batchDistributeType: number;
  /**
   * 单位名称
   */
  orgName: string;
  /**
   * 单位ID
   */
  orgId: number;
  /**
   * 部门名称
   */
  departmentName?: string;
  /**
   * 部门ID
   */
  departmentId?: number;
  /**
   * 事由
   */
  reason: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 默认附件列表
   */
  normalAttachmentList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 批量发放审批单附件
   */
  auditAttachmentList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 是否惠企利民单据 0-不是；1-是
   */
  isToPersonEnterpriseMark?: number;
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
  }[];
}

/**
 * 接口 [保存批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300730) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/save`
 * @更新时间 `2024-04-02 14:40:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 批量发放唯一编号
     */
    batchDistributeCode?: string;
    /**
     * 单据编号
     */
    businessCode?: string;
    /**
     * 单据类型：0-个人；1-企业；
     */
    batchDistributeType?: number;
    batchDistributeTypeDesc?: string;
    /**
     * 发起人ID
     */
    operatorId?: number;
    /**
     * 发起人姓名
     */
    operatorName?: string;
    /**
     * 单位名称
     */
    orgName?: string;
    /**
     * 单位ID
     */
    orgId?: number;
    /**
     * 部门名称
     */
    departmentName?: string;
    /**
     * 部门ID
     */
    departmentId?: number;
    /**
     * 事由
     */
    reason?: string;
    /**
     * 发放总金额
     */
    distributeAmount?: number;
    /**
     * 发放状态：0-未提交；1-支付中；3-支付成功；4-支付失败；
     */
    distributeStatus?: number;
    distributeStatusDesc?: string;
    /**
     * 提交时间
     */
    submitTime?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 批次信息
     */
    batchesROList?: {
      /**
       * 批量发放唯一编号
       */
      batchDistributeCode?: string;
      /**
       * 明细批次编号
       */
      batchCode?: string;
      /**
       * 批次
       */
      batchNumber?: number;
    }[];
    /**
     * 默认附件列表
     */
    normalAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 批量发放审批单附件
     */
    auditAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 工作流信息
     */
    workflowInfo?: {
      workflowProcessKey?: string;
      workflowModelId?: number;
      workflowVersion?: number;
      auditNodeList?: {
        auditOperatorList?: {
          operatorId?: number;
          operatorName?: string;
          institutionId?: number;
          institutionName?: string;
          auditRemark?: string;
          auditStatus?: number;
          auditTime?: string;
          signAttachment?: {
            fileId?: string;
            type?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          oneselfHistorySignAttachment?: {
            fileId?: string;
            type?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          };
          addAuditWay?: number;
          addAuditOperator?: string;
          comment?: {
            commentContent?: string;
            operatorId?: number;
            operatorName?: string;
            commentCode?: string;
            commentTime?: number;
            pictureAttachments?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            otherAttachments?: {
              fileId?: string;
              type?: string;
              name?: string;
              size?: number;
              bizCode?: string;
              url?: string;
              sizeDesc?: string;
            }[];
            remove?: boolean;
          };
          operatorType?: number;
        }[];
        userRangeType?: number;
        userRangeTypeNew?: number;
        userRangeValues?: string[];
        userRangeValuesNew?: string[];
        personCount?: number;
        auditStatus?: number;
        auditTime?: string;
        auditDesc?: string;
        auditType?: number;
        eventType?: number;
        nodeType?: number;
        nodeKey?: string;
        nodeName?: string;
        checkStrategy?: number;
        departmentId?: number;
        institutionSelfDtos?: {
          code?: string;
          name?: string;
          userType?: string;
          tenantCode?: string;
          tenantName?: string;
          uniqueKey?: string;
          parentInstitution?: {
            parentCode?: number;
            parentName?: string;
          };
        }[];
        commonAuditorList?: {
          displayName?: string;
          userId?: number;
          operatorId?: number;
          code?: string;
          gender?: number;
          institutionId?: number;
          institution?: {
            id?: number;
            createdAt?: number;
            updatedAt?: number;
            creatorId?: string;
            modifierId?: string;
            extFields?: string;
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string;
            tags?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            divisionCode?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
          };
          deptName?: string;
        }[];
        bizProperty?: string;
        comment?: {
          commentContent?: string;
          operatorId?: number;
          operatorName?: string;
          commentCode?: string;
          commentTime?: number;
          pictureAttachments?: {
            fileId?: string;
            type?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          otherAttachments?: {
            fileId?: string;
            type?: string;
            name?: string;
            size?: number;
            bizCode?: string;
            url?: string;
            sizeDesc?: string;
          }[];
          remove?: boolean;
        };
      }[];
      applyOperatorId?: number;
      applyOperatorName?: string;
      applyTime?: string;
      applyRemark?: string;
      isAddTaskAccess?: number;
      isEnableSign?: boolean;
      signConfig?: number;
      availableRejectNodeList?: {
        nodeName?: string;
        nodeKey?: string;
        operatorNames?: string[];
      }[];
      currentBizProperty?: string;
    };
    /**
     * 是否开启工作流 true-开启；false-未开启
     */
    enableWorkflow?: boolean;
    /**
     * 支付更正记录
     */
    payChangeInfoROList?: {
      /**
       * 支付金额
       */
      amount?: number;
      /**
       * 原支付令号
       */
      oldThirdTradeNo?: string;
      /**
       * 更正支付令号
       * 注：支付退款的情况为空
       */
      newThirdTradeNo?: string;
      /**
       * 更正前预算信息
       */
      oldBudgetInfoRO?: {
        /**
         * 预算年度
         */
        year?: number;
        /**
         * 预算指标文号
         */
        budgetNo?: string;
        /**
         * 主预算id
         */
        mainBudgetCode?: number;
        /**
         * 指标编号
         */
        budgetUk?: string;
        /**
         * 部门支出经济分类名称
         */
        depExpendEconomicClassifyName?: string;
        /**
         * 总金额
         */
        totalAmount?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
        /**
         * 可用额度
         */
        quotaAvailableAmount?: number;
        /**
         * 预算占用金额
         */
        budgetAmount?: number;
        /**
         * 预算项目名称
         */
        projectName?: string;
        /**
         * 预算详情id
         */
        financialBudgetDetailId?: string;
        /**
         * 资金性质
         */
        fundsNatureName?: string;
        /**
         * 支出功能分类科目名称
         */
        expendFunctionClassifySubjectName?: string;
        /**
         * 是否包含政府采购预算，0:是、1：否
         */
        containsGovPurchaseBudget?: number;
        /**
         * 预算额度id
         */
        budgetQuotaId?: string;
        /**
         * 原先申请预算金额
         */
        originalAmount?: number;
        /**
         * 支付限额经济分类主键
         */
        budgetPlanClassifyUk?: string;
        /**
         * 支付限额经济分类编码
         */
        budgetPlanClassifyCode?: string;
        /**
         * 支付限额经济分类名称
         */
        budgetPlanClassifyName?: string;
        /**
         * 支付限额经济分类总金额
         */
        budgetPlanClassifyTotalAmount?: number;
        /**
         * 支付限额经济分类可用金额
         */
        budgetPlanClassifyAvailableAmount?: number;
        /**
         * 采购文号
         */
        purchaseNo?: string;
      };
      /**
       * 更正后预算信息
       */
      newBudgetInfoRO?: {
        /**
         * 预算年度
         */
        year?: number;
        /**
         * 预算指标文号
         */
        budgetNo?: string;
        /**
         * 主预算id
         */
        mainBudgetCode?: number;
        /**
         * 指标编号
         */
        budgetUk?: string;
        /**
         * 部门支出经济分类名称
         */
        depExpendEconomicClassifyName?: string;
        /**
         * 总金额
         */
        totalAmount?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
        /**
         * 可用额度
         */
        quotaAvailableAmount?: number;
        /**
         * 预算占用金额
         */
        budgetAmount?: number;
        /**
         * 预算项目名称
         */
        projectName?: string;
        /**
         * 预算详情id
         */
        financialBudgetDetailId?: string;
        /**
         * 资金性质
         */
        fundsNatureName?: string;
        /**
         * 支出功能分类科目名称
         */
        expendFunctionClassifySubjectName?: string;
        /**
         * 是否包含政府采购预算，0:是、1：否
         */
        containsGovPurchaseBudget?: number;
        /**
         * 预算额度id
         */
        budgetQuotaId?: string;
        /**
         * 原先申请预算金额
         */
        originalAmount?: number;
        /**
         * 支付限额经济分类主键
         */
        budgetPlanClassifyUk?: string;
        /**
         * 支付限额经济分类编码
         */
        budgetPlanClassifyCode?: string;
        /**
         * 支付限额经济分类名称
         */
        budgetPlanClassifyName?: string;
        /**
         * 支付限额经济分类总金额
         */
        budgetPlanClassifyTotalAmount?: number;
        /**
         * 支付限额经济分类可用金额
         */
        budgetPlanClassifyAvailableAmount?: number;
        /**
         * 采购文号
         */
        purchaseNo?: string;
      };
    }[];
    /**
     * 支付变更状态
     * 0-无变更；1-已更正；2-已退款
     */
    payChangeType?: number;
    /**
     * 是否惠企利民
     */
    isToPersonEnterpriseMark?: number;
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 占用金额
       */
      amount?: number;
    }[];
    /**
     * 按钮展示
     */
    operateButton?: {
      /**
       * 撤回
       */
      withdrawn?: boolean;
      /**
       * 加签
       */
      signature?: boolean;
      /**
       * 通过
       */
      pass?: boolean;
      /**
       * 驳回
       */
      reject?: boolean;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300730) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/save`
 * @更新时间 `2024-04-02 14:40:16`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300730) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/save`
 * @更新时间 `2024-04-02 14:40:16`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeSavePostRequestConfig: ZlbApiExpenseBatchDistributeSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300730) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/save`
 * @更新时间 `2024-04-02 14:40:16`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeSavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeSavePostResponse>(
    prepare(zlbApiExpenseBatchDistributeSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeSavePost.requestConfig =
  zlbApiExpenseBatchDistributeSavePostRequestConfig;

/**
 * 接口 [查询批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300738) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query/{batchDistributeCode}`
 * @更新时间 `2024-10-18 11:52:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeQueryBatchDistributeCodeGetRequest {
  repay?: string;
  identity?: string;
  batchDistributeCode: string;
}

/**
 * 接口 [查询批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300738) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query/{batchDistributeCode}`
 * @更新时间 `2024-10-18 11:52:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeQueryBatchDistributeCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 批量发放唯一编号
     */
    batchDistributeCode?: string;
    /**
     * 单据编号
     */
    businessCode?: string;
    /**
     * 业务类型
     */
    businessType?: string;
    /**
     * 单据类型：0-个人；1-企业；
     */
    batchDistributeType?: number;
    batchDistributeTypeDesc?: string;
    /**
     * 发起人ID
     */
    operatorId?: number;
    /**
     * 发起人姓名
     */
    operatorName?: string;
    /**
     * 单位名称
     */
    orgName?: string;
    /**
     * 单位ID
     */
    orgId?: number;
    /**
     * 部门名称
     */
    departmentName?: string;
    /**
     * 部门ID
     */
    departmentId?: number;
    /**
     * 事由
     */
    reason?: string;
    /**
     * 发放总金额
     */
    distributeAmount?: number;
    /**
     * 发放状态：0-未提交；1-支付中；3-支付成功；4-支付失败；
     */
    distributeStatus?: number;
    distributeStatusDesc?: string;
    /**
     * 报销单状态(针对批量报销，移动端展示需要)
     */
    expenseFormStatus?: number;
    /**
     * 报销单状态描述(针对批量报销，移动端展示需要)
     */
    expenseFormStatusDesc?: string;
    /**
     * 提交时间
     */
    submitTime?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 批次信息
     */
    batchesROList?: {
      /**
       * 批量发放唯一编号
       */
      batchDistributeCode?: string;
      /**
       * 明细批次编号
       */
      batchCode?: string;
      /**
       * 批次
       */
      batchNumber?: number;
    }[];
    /**
     * 默认附件列表
     */
    normalAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 批量发放审批单附件
     */
    auditAttachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 工作流信息
     */
    workflowInfo?: {
      /**
       * 工作流的唯一key
       */
      workflowProcessKey?: string;
      /**
       * 工作流模型id
       */
      workflowModelId?: number;
      /**
       * 工作流版本
       */
      workflowVersion?: number;
      /**
       * 审核节点列表
       */
      auditNodeList?: {
        /**
         * 审核人列表
         */
        auditOperatorList?: {
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 审批意见
           */
          auditRemark?: string;
          /**
           * 审批状态：0-待审批，1-审批通过，2-审批驳回
           */
          auditStatus?: number;
          /**
           * 审核时间
           */
          auditTime?: string;
          /**
           * 签名附件
           */
          signAttachment?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 业务编号
             */
            bizNo?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          };
          /**
           * 最新的个人历史签名附件
           */
          oneselfHistorySignAttachment?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 业务编号
             */
            bizNo?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          };
          /**
           * 加签方式：-1-未加签，0-后加签（作废，由于历史是0，后续统一为2），1-前加签，2-后加签
           */
          addAuditWay?: number;
          /**
           * 加签者
           */
          addAuditOperator?: string;
          /**
           * 工作流评论信息
           */
          comment?: {
            /**
             * 评论内容
             */
            commentContent?: string;
            /**
             * 评论人ID
             */
            operatorId?: number;
            /**
             * 评论人名字
             */
            operatorName?: string;
            /**
             * 评论唯一代码
             */
            commentCode?: string;
            /**
             * 评论时间
             */
            commentTime?: number;
            /**
             * 图片附件集合
             */
            pictureAttachments?: {
              /**
               * 附件OssId
               */
              fileId?: string;
              /**
               * 附件类型
               */
              type?: string;
              /**
               * 业务编号
               */
              bizNo?: string;
              /**
               * 附件名称
               */
              name?: string;
              /**
               * 附件大小
               */
              size?: number;
              /**
               * 桶的key
               */
              bizCode?: string;
              /**
               * 下载文件的url
               */
              url?: string;
              /**
               * 文件大小描述
               */
              sizeDesc?: string;
            }[];
            /**
             * 其他附件集合
             */
            otherAttachments?: {
              /**
               * 附件OssId
               */
              fileId?: string;
              /**
               * 附件类型
               */
              type?: string;
              /**
               * 业务编号
               */
              bizNo?: string;
              /**
               * 附件名称
               */
              name?: string;
              /**
               * 附件大小
               */
              size?: number;
              /**
               * 桶的key
               */
              bizCode?: string;
              /**
               * 下载文件的url
               */
              url?: string;
              /**
               * 文件大小描述
               */
              sizeDesc?: string;
            }[];
            /**
             * 是否可以删除该评论
             */
            remove?: boolean;
          };
          /**
           * 操作人类型
           */
          operatorType?: number;
        }[];
        /**
         * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
         */
        userRangeType?: number;
        userRangeTypeNew?: number;
        /**
         * 动态审核人类型
         */
        userRangeValues?: string[];
        userRangeValuesNew?: string[];
        /**
         * 审核人数(总人数)
         */
        personCount?: number;
        /**
         * 审核状态：0-待审批，1-已审批，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 审核描述
         */
        auditDesc?: string;
        /**
         * 审批类型：0-或签，1-会签，2-依次审批
         */
        auditType?: number;
        /**
         * 事件类型：0-审批，1-审核，2-出纳，3-抄送 98-提交人 99-评论
         */
        eventType?: number;
        /**
         * 是否自选:0-指定，1-自选
         */
        nodeType?: number;
        /**
         * 节点key
         */
        nodeKey?: string;
        /**
         * 节点名称
         */
        nodeName?: string;
        /**
         * 策略
         * cn.gov.zcy.workflow.enums.CheckStrategyEnum
         */
        checkStrategy?: number;
        /**
         * 部门id （为了获取部门主管）
         */
        departmentId?: number;
        /**
         * 机构
         */
        institutionSelfDtos?: {
          /**
           * 机构编码
           */
          code?: string;
          /**
           * 机构名称
           */
          name?: string;
          userType?: string;
          /**
           * 租户编码（区划编码）
           */
          tenantCode?: string;
          /**
           * 租户编码名称（区划名称）
           */
          tenantName?: string;
          uniqueKey?: string;
          parentInstitution?: {
            parentCode?: number;
            parentName?: string;
          };
        }[];
        /**
         * 常用审核人列表
         */
        commonAuditorList?: {
          displayName?: string;
          userId?: number;
          operatorId?: number;
          code?: string;
          gender?: number;
          institutionId?: number;
          institution?: {
            id?: number;
            createdAt?: number;
            updatedAt?: number;
            creatorId?: string;
            modifierId?: string;
            extFields?: string;
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string;
            tags?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            divisionCode?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
          };
          deptName?: string;
        }[];
        /**
         * 业务属性json
         */
        bizProperty?: string;
        /**
         * 工作流评论信息
         */
        comment?: {
          /**
           * 评论内容
           */
          commentContent?: string;
          /**
           * 评论人ID
           */
          operatorId?: number;
          /**
           * 评论人名字
           */
          operatorName?: string;
          /**
           * 评论唯一代码
           */
          commentCode?: string;
          /**
           * 评论时间
           */
          commentTime?: number;
          /**
           * 图片附件集合
           */
          pictureAttachments?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 业务编号
             */
            bizNo?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          }[];
          /**
           * 其他附件集合
           */
          otherAttachments?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 业务编号
             */
            bizNo?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          }[];
          /**
           * 是否可以删除该评论
           */
          remove?: boolean;
        };
      }[];
      /**
       * 申请人操作人id
       */
      applyOperatorId?: number;
      /**
       * 申请人名称
       */
      applyOperatorName?: string;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 申请备注
       */
      applyRemark?: string;
      /**
       * 是否能加签 0-否 1-是
       */
      isAddTaskAccess?: number;
      /**
       * 工作流是否开启签名：true-开启；false-未开启
       */
      isEnableSign?: boolean;
      /**
       * 签名配置：0-使用上次签名；1-每次重新签名；
       */
      signConfig?: number;
      /**
       * 当前节点可驳回节点列表
       */
      availableRejectNodeList?: {
        /**
         * 节点名
         */
        nodeName?: string;
        /**
         * 节点uk
         */
        nodeKey?: string;
        /**
         * 节点操作人名字集合
         */
        operatorNames?: string[];
      }[];
      /**
       * 实例当前节点业务属性
       */
      currentBizProperty?: string;
    };
    /**
     * 是否开启工作流 true-开启；false-未开启
     */
    enableWorkflow?: boolean;
    /**
     * 支付更正记录
     */
    payChangeInfoROList?: {
      /**
       * 支付金额
       */
      amount?: number;
      /**
       * 原支付令号
       */
      oldThirdTradeNo?: string;
      /**
       * 更正支付令号
       * 注：支付退款的情况为空
       */
      newThirdTradeNo?: string;
      /**
       * 更正前预算信息
       */
      oldBudgetInfoRO?: {
        /**
         * 预算年度
         */
        year?: number;
        /**
         * 预算指标文号
         */
        budgetNo?: string;
        /**
         * 主预算id
         */
        mainBudgetCode?: number;
        /**
         * 指标编号
         */
        budgetUk?: string;
        /**
         * 部门支出经济分类名称
         */
        depExpendEconomicClassifyName?: string;
        /**
         * 总金额
         */
        totalAmount?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
        /**
         * 可用额度
         */
        quotaAvailableAmount?: number;
        /**
         * 预算占用金额
         */
        budgetAmount?: number;
        /**
         * 预算项目名称
         */
        projectName?: string;
        /**
         * 预算详情id
         */
        financialBudgetDetailId?: string;
        /**
         * 资金性质
         */
        fundsNatureName?: string;
        /**
         * 支出功能分类科目名称
         */
        expendFunctionClassifySubjectName?: string;
        /**
         * 是否包含政府采购预算，0:是、1：否
         */
        containsGovPurchaseBudget?: number;
        /**
         * 预算额度id
         */
        budgetQuotaId?: string;
        /**
         * 原先申请预算金额
         */
        originalAmount?: number;
        /**
         * 支付限额经济分类主键
         */
        budgetPlanClassifyUk?: string;
        /**
         * 支付限额经济分类编码
         */
        budgetPlanClassifyCode?: string;
        /**
         * 支付限额经济分类名称
         */
        budgetPlanClassifyName?: string;
        /**
         * 支付限额经济分类总金额
         */
        budgetPlanClassifyTotalAmount?: number;
        /**
         * 支付限额经济分类可用金额
         */
        budgetPlanClassifyAvailableAmount?: number;
        /**
         * 采购文号
         */
        purchaseNo?: string;
        /**
         * 匹配第三方推送的申报单预算关联信息的发放明细
         */
        distributeDetailList?: {
          /**
           * 批量发放唯一编号
           */
          batchDistributeCode?: string;
          /**
           * 发放明细唯一编号
           */
          distributeDetailCode?: string;
          /**
           * 明细批次编号
           */
          batchCode?: string;
          /**
           * 银行账户 脱敏
           */
          accountNo?: string;
          /**
           * 银行账户
           */
          accountNoDesc?: string;
          /**
           * 账户名称
           */
          accountName?: string;
          /**
           * 应付金额
           */
          payAmount?: number;
          /**
           * 银行代码
           */
          bankCode?: string;
          /**
           * 银行名字
           */
          bankName?: string;
          /**
           * 银行支行code
           */
          bankNo?: string;
          /**
           * 银行支行名称
           */
          bankBranchName?: string;
          /**
           * 社会统一信用代码
           */
          creditCode?: string;
          /**
           * 身份证
           */
          idCard?: string;
          idCardDesc?: string;
          /**
           * 支付状态：0-待支付，1-支付中，2-支付成功，3-支付失败；
           */
          payStatus?: number;
          payStatusDesc?: string;
          /**
           * 是否推送（0-未推送，1-已推送）
           */
          isRepush?: number;
          operateButton?: {
            /**
             * 编辑
             */
            edit?: boolean;
            /**
             * 查看
             */
            detail?: boolean;
            /**
             * 删除
             */
            delete?: boolean;
          };
        }[];
        /**
         * 部门名称 (2024年08月05日补充, 补充页面展示字段)
         */
        depName?: string;
        /**
         * 支出项 (2024年08月05日补充, 补充页面展示字段)
         */
        expenditureItem?: string;
      };
      /**
       * 更正后预算信息
       */
      newBudgetInfoRO?: {
        /**
         * 预算年度
         */
        year?: number;
        /**
         * 预算指标文号
         */
        budgetNo?: string;
        /**
         * 主预算id
         */
        mainBudgetCode?: number;
        /**
         * 指标编号
         */
        budgetUk?: string;
        /**
         * 部门支出经济分类名称
         */
        depExpendEconomicClassifyName?: string;
        /**
         * 总金额
         */
        totalAmount?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
        /**
         * 可用额度
         */
        quotaAvailableAmount?: number;
        /**
         * 预算占用金额
         */
        budgetAmount?: number;
        /**
         * 预算项目名称
         */
        projectName?: string;
        /**
         * 预算详情id
         */
        financialBudgetDetailId?: string;
        /**
         * 资金性质
         */
        fundsNatureName?: string;
        /**
         * 支出功能分类科目名称
         */
        expendFunctionClassifySubjectName?: string;
        /**
         * 是否包含政府采购预算，0:是、1：否
         */
        containsGovPurchaseBudget?: number;
        /**
         * 预算额度id
         */
        budgetQuotaId?: string;
        /**
         * 原先申请预算金额
         */
        originalAmount?: number;
        /**
         * 支付限额经济分类主键
         */
        budgetPlanClassifyUk?: string;
        /**
         * 支付限额经济分类编码
         */
        budgetPlanClassifyCode?: string;
        /**
         * 支付限额经济分类名称
         */
        budgetPlanClassifyName?: string;
        /**
         * 支付限额经济分类总金额
         */
        budgetPlanClassifyTotalAmount?: number;
        /**
         * 支付限额经济分类可用金额
         */
        budgetPlanClassifyAvailableAmount?: number;
        /**
         * 采购文号
         */
        purchaseNo?: string;
        /**
         * 匹配第三方推送的申报单预算关联信息的发放明细
         */
        distributeDetailList?: {
          /**
           * 批量发放唯一编号
           */
          batchDistributeCode?: string;
          /**
           * 发放明细唯一编号
           */
          distributeDetailCode?: string;
          /**
           * 明细批次编号
           */
          batchCode?: string;
          /**
           * 银行账户 脱敏
           */
          accountNo?: string;
          /**
           * 银行账户
           */
          accountNoDesc?: string;
          /**
           * 账户名称
           */
          accountName?: string;
          /**
           * 应付金额
           */
          payAmount?: number;
          /**
           * 银行代码
           */
          bankCode?: string;
          /**
           * 银行名字
           */
          bankName?: string;
          /**
           * 银行支行code
           */
          bankNo?: string;
          /**
           * 银行支行名称
           */
          bankBranchName?: string;
          /**
           * 社会统一信用代码
           */
          creditCode?: string;
          /**
           * 身份证
           */
          idCard?: string;
          idCardDesc?: string;
          /**
           * 支付状态：0-待支付，1-支付中，2-支付成功，3-支付失败；
           */
          payStatus?: number;
          payStatusDesc?: string;
          /**
           * 是否推送（0-未推送，1-已推送）
           */
          isRepush?: number;
          operateButton?: {
            /**
             * 编辑
             */
            edit?: boolean;
            /**
             * 查看
             */
            detail?: boolean;
            /**
             * 删除
             */
            delete?: boolean;
          };
        }[];
        /**
         * 部门名称 (2024年08月05日补充, 补充页面展示字段)
         */
        depName?: string;
        /**
         * 支出项 (2024年08月05日补充, 补充页面展示字段)
         */
        expenditureItem?: string;
      };
      /**
       * 更正前限额信息
       */
      oldBpcInfo?: {
        /**
         * 限额主键
         */
        uk?: string;
        /**
         * 支付限额：格式：部门经济分类_采购文号_项目名称
         */
        name?: string;
      };
      /**
       * 更正后限额信息
       */
      newBpcInfo?: {
        /**
         * 限额主键
         */
        uk?: string;
        /**
         * 支付限额：格式：部门经济分类_采购文号_项目名称
         */
        name?: string;
      };
      /**
       * 兑付模块-申报单核销状态   0-未核销  1-已核销   默认: 0{@link  PayChangeDeclarationRefundCheckStatusEnum}
       */
      declarationRefundCheckStatus?: number;
      /**
       * 交易变更唯一code
       */
      changeCode?: string;
    }[];
    /**
     * 支付变更状态
     * 0-无变更；1-已更正；2-已退款
     */
    payChangeType?: number;
    /**
     * 是否惠企利民
     */
    isToPersonEnterpriseMark?: number;
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 占用金额
       */
      amount?: number;
      /**
       * 科目uk 级联
       */
      subjectUkHierarchy?: string[];
      /**
       * 科目名称级联
       */
      subjectNameHierarchy?: string[];
    }[];
    /**
     * 是否为二次推送
     */
    isRepush?: number;
    /**
     * 财务驳回原因(全部支付失败时, 批量报销单可以财务驳回整个单据)
     */
    rejectFinanceReason?: string;
    /**
     * 按钮展示
     */
    operateButton?: {
      /**
       * 撤回
       */
      withdrawn?: boolean;
      /**
       * 加签
       */
      signature?: boolean;
      /**
       * 通过
       */
      pass?: boolean;
      /**
       * 驳回
       */
      reject?: boolean;
      /**
       * 批量报销-驳回
       */
      rejectFinance?: boolean;
    };
    /**
     * 用户角色 2-审核人  3-审批人
     */
    userRole?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300738) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query/{batchDistributeCode}`
 * @更新时间 `2024-10-18 11:52:24`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeQueryBatchDistributeCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/query/{batchDistributeCode}',
    'data',
    'batchDistributeCode',
    'repay' | 'identity',
    false
  >
>;

/**
 * 接口 [查询批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300738) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query/{batchDistributeCode}`
 * @更新时间 `2024-10-18 11:52:24`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeQueryBatchDistributeCodeGetRequestConfig: ZlbApiExpenseBatchDistributeQueryBatchDistributeCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/query/{batchDistributeCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: ['batchDistributeCode'],
    queryNames: ['repay', 'identity'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeQueryBatchDistributeCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询批量发放基本信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300738) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query/{batchDistributeCode}`
 * @更新时间 `2024-10-18 11:52:24`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeQueryBatchDistributeCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeQueryBatchDistributeCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeQueryBatchDistributeCodeGetResponse>(
    prepare(zlbApiExpenseBatchDistributeQueryBatchDistributeCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeQueryBatchDistributeCodeGet.requestConfig =
  zlbApiExpenseBatchDistributeQueryBatchDistributeCodeGetRequestConfig;

/**
 * 接口 [查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300746) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-page`
 * @更新时间 `2024-08-29 15:49:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeQueryPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 业务类型(兼容旧入参)
   */
  businessType?: string;
  /**
   * 业务类型(多选, 如批量报销页面, 同时查询批量发放+批量报销)
   */
  businessTypeList?: string[];
  /**
   * 发起人名字
   */
  operatorName?: string;
  /**
   * 部门ID
   */
  departmentId?: number;
  /**
   * 发放状态：0-未提交；1-支付中；2-支付成功；3-支付失败；
   */
  distributeStatusList?: number[];
  /**
   * 申请事由
   */
  reason?: string;
  /**
   * 起始时间
   */
  beginTime?: number;
  /**
   * 结束时间
   */
  endTime?: number;
}

/**
 * 接口 [查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300746) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-page`
 * @更新时间 `2024-08-29 15:49:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeQueryPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 批量发放唯一编号
       */
      batchDistributeCode?: string;
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 批量发放类型
       */
      businessType?: string;
      /**
       * 单据类型：0-个人；1-企业；
       */
      batchDistributeType?: number;
      batchDistributeTypeDesc?: string;
      /**
       * 发起人ID
       */
      operatorId?: number;
      /**
       * 发起人姓名
       */
      operatorName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 单位ID
       */
      orgId?: number;
      /**
       * 部门名称
       */
      departmentName?: string;
      /**
       * 部门ID
       */
      departmentId?: number;
      /**
       * 事由
       */
      reason?: string;
      /**
       * 发放总金额
       */
      distributeAmount?: number;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 批量发放单据状态
       */
      distributeStatus?: 0 | 1 | 2 | 3 | 4 | 5;
      distributeStatusDesc?: string;
      /**
       * 支付变更 0-未变更，1-已变更；2-已退款
       */
      payChangeStatus?: number;
      /**
       * 是否重复推送：0-否，1-是
       */
      isRepush?: number;
      operateButton?: {
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 查看
         */
        detail?: boolean;
        /**
         * 删除
         */
        delete?: boolean;
        /**
         * 再次发放
         */
        againDistribute?: boolean;
        /**
         * 打印
         */
        print?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300746) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-page`
 * @更新时间 `2024-08-29 15:49:16`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeQueryPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/query-page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300746) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-page`
 * @更新时间 `2024-08-29 15:49:16`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeQueryPagePostRequestConfig: ZlbApiExpenseBatchDistributeQueryPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/query-page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeQueryPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/300746) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-page`
 * @更新时间 `2024-08-29 15:49:16`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeQueryPagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeQueryPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeQueryPagePostResponse>(
    prepare(zlbApiExpenseBatchDistributeQueryPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeQueryPagePost.requestConfig =
  zlbApiExpenseBatchDistributeQueryPagePostRequestConfig;

/**
 * 接口 [删除批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/300754) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/delete/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeleteBatchDistributeCodePostRequest {
  batchDistributeCode: string;
}

/**
 * 接口 [删除批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/300754) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/delete/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeleteBatchDistributeCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/300754) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/delete/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeDeleteBatchDistributeCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/delete/{batchDistributeCode}',
    'data',
    'batchDistributeCode',
    string,
    false
  >
>;

/**
 * 接口 [删除批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/300754) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/delete/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeDeleteBatchDistributeCodePostRequestConfig: ZlbApiExpenseBatchDistributeDeleteBatchDistributeCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/delete/{batchDistributeCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: ['batchDistributeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeDeleteBatchDistributeCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/300754) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/delete/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeDeleteBatchDistributeCodePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeDeleteBatchDistributeCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeDeleteBatchDistributeCodePostResponse>(
    prepare(zlbApiExpenseBatchDistributeDeleteBatchDistributeCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeDeleteBatchDistributeCodePost.requestConfig =
  zlbApiExpenseBatchDistributeDeleteBatchDistributeCodePostRequestConfig;

/**
 * 接口 [再次发放时，下一步查询（一个批量发放存在几个批次）↗](http://yapi.cai-inc.com/project/3621/interface/api/300762) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query-batches/{batchDistributeCode}`
 * @更新时间 `2022-09-21 15:42:52`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGetRequest {
  batchDistributeCode: string;
}

/**
 * 接口 [再次发放时，下一步查询（一个批量发放存在几个批次）↗](http://yapi.cai-inc.com/project/3621/interface/api/300762) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query-batches/{batchDistributeCode}`
 * @更新时间 `2022-09-21 15:42:52`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 批量发放唯一编号
     */
    batchDistributeCode?: string;
    /**
     * 明细批次编号
     */
    batchCode?: string;
    /**
     * 批次
     */
    batchNumber?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [再次发放时，下一步查询（一个批量发放存在几个批次）↗](http://yapi.cai-inc.com/project/3621/interface/api/300762) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query-batches/{batchDistributeCode}`
 * @更新时间 `2022-09-21 15:42:52`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/query-batches/{batchDistributeCode}',
    'data',
    'batchDistributeCode',
    string,
    false
  >
>;

/**
 * 接口 [再次发放时，下一步查询（一个批量发放存在几个批次）↗](http://yapi.cai-inc.com/project/3621/interface/api/300762) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query-batches/{batchDistributeCode}`
 * @更新时间 `2022-09-21 15:42:52`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGetRequestConfig: ZlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/query-batches/{batchDistributeCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: ['batchDistributeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [再次发放时，下一步查询（一个批量发放存在几个批次）↗](http://yapi.cai-inc.com/project/3621/interface/api/300762) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/query-batches/{batchDistributeCode}`
 * @更新时间 `2022-09-21 15:42:52`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGetResponse>(
    prepare(
      zlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGetRequestConfig,
      requestData,
    ),
    ...args,
  );
};

zlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGet.requestConfig =
  zlbApiExpenseBatchDistributeQueryBatchesBatchDistributeCodeGetRequestConfig;

/**
 * 接口 [查询批次总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/300818) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-amount/{batchCode}`
 * @更新时间 `2023-03-08 13:55:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGetRequest {
  batchCode: string;
}

/**
 * 接口 [查询批次总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/300818) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-amount/{batchCode}`
 * @更新时间 `2023-03-08 13:55:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGetResponse {
  success?: boolean;
  result?: number;
  code?: string;
  message?: string;
}

/**
 * 接口 [查询批次总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/300818) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-amount/{batchCode}`
 * @更新时间 `2023-03-08 13:55:39`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/batch/query-amount/{batchCode}',
    'data',
    'batchCode',
    string,
    false
  >
>;

/**
 * 接口 [查询批次总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/300818) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-amount/{batchCode}`
 * @更新时间 `2023-03-08 13:55:39`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGetRequestConfig: ZlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/batch/query-amount/{batchCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: ['batchCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询批次总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/300818) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-amount/{batchCode}`
 * @更新时间 `2023-03-08 13:55:39`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGetResponse>(
    prepare(zlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGet.requestConfig =
  zlbApiExpenseBatchDistributeBatchQueryAmountBatchCodeGetRequestConfig;

/**
 * 接口 [批量发放发起支付↗](http://yapi.cai-inc.com/project/3621/interface/api/300914) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/batch-distribute/apply-pay`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeApplyPayPostRequest {
  /**
   * 发放编号
   */
  batchDistributeCode: string;
  /**
   * 摘要字段
   */
  summary: string;
  /**
   * 支付方式：1：国库支付 3：自有资金支付
   */
  payMode: number;
  /**
   * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
   *       3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
   */
  payStrategy?: number;
  /**
   * 预算信息
   */
  budgetInfoPO?: {
    /**
     * 主预算编号
     */
    mainBudgetCode: number;
    /**
     * 指标编号
     */
    budgetUk: string;
    /**
     * 预算支付限额分类
     */
    budgetPlanClassifyUk: string;
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 预算额度id
     */
    budgetQuotaId?: string;
    /**
     * 发放明细
     */
    distributeDetailCodeList?: string[];
  }[];
  /**
   * 是否忽略警告（弱控）
   */
  isIgnoreWarning?: boolean;
  /**
   * 付款账户
   */
  accountCode?: string;
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
  }[];
}

/**
 * 接口 [批量发放发起支付↗](http://yapi.cai-inc.com/project/3621/interface/api/300914) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/batch-distribute/apply-pay`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeApplyPayPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态 0：通过 1：警告 2：强控
     */
    checkStatus?: number;
    /**
     * 预算校验结果
     */
    budgetCheckResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
      /**
       * 预算指标ID
       */
      mainBudgetCode?: number;
      /**
       * 指标编号
       */
      budgetUk?: string;
      /**
       * 预算编号(展示)
       */
      financialBudgetDetailId?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 额度ID
       */
      budgetQuotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag?: boolean;
      /**
       * 占用总金额
       */
      budgetTotalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 报销单行程校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 可用金额
         */
        availableAmount?: number;
        /**
         * 校验状态 0：通过 1：警告 2：强控
         */
        checkStatus?: number;
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [批量发放发起支付↗](http://yapi.cai-inc.com/project/3621/interface/api/300914) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/batch-distribute/apply-pay`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeApplyPayPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/apply-pay',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [批量发放发起支付↗](http://yapi.cai-inc.com/project/3621/interface/api/300914) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/batch-distribute/apply-pay`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeApplyPayPostRequestConfig: ZlbApiExpenseBatchDistributeApplyPayPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/apply-pay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeApplyPayPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [批量发放发起支付↗](http://yapi.cai-inc.com/project/3621/interface/api/300914) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/batch-distribute/apply-pay`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeApplyPayPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeApplyPayPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeApplyPayPostResponse>(
    prepare(zlbApiExpenseBatchDistributeApplyPayPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeApplyPayPost.requestConfig =
  zlbApiExpenseBatchDistributeApplyPayPostRequestConfig;

/**
 * 接口 [批量发放支付信息查询（支付配置、预算、代收款信息）↗](http://yapi.cai-inc.com/project/3621/interface/api/300922) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-payment`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeQueryPaymentPostRequest {
  /**
   * 批量发放唯一编号
   */
  batchDistributeCode: string;
  /**
   * 批次号
   */
  batchCode?: string;
}

/**
 * 接口 [批量发放支付信息查询（支付配置、预算、代收款信息）↗](http://yapi.cai-inc.com/project/3621/interface/api/300922) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-payment`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeQueryPaymentPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 摘要字段
     */
    summary?: string;
    /**
     * 支付方式：1：国库支付 3：自有资金支付
     */
    payMode?: number;
    payModeDesc?: string;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     *       3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategy?: number;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     *       3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategyName?: string;
    /**
     * 批量发放代发账户
     */
    payAccountRO?: {
      /**
       * accountCode
       */
      accountCode?: string;
      /**
       * 户名
       */
      accountName?: string;
      /**
       * 开户银行
       */
      bankName?: string;
      /**
       * 账号
       */
      accountNo?: string;
      /**
       * 金额
       */
      amount?: number;
    };
    /**
     * 预算信息
     */
    distributeBudgetInfoROS?: {
      /**
       * 预算年度
       */
      year?: number;
      /**
       * 预算指标文号
       */
      budgetNo?: string;
      /**
       * 主预算id
       */
      mainBudgetCode?: number;
      /**
       * 指标编号
       */
      budgetUk?: string;
      /**
       * 部门支出经济分类名称
       */
      depExpendEconomicClassifyName?: string;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 可用额度
       */
      quotaAvailableAmount?: number;
      /**
       * 预算占用金额
       */
      budgetAmount?: number;
      /**
       * 预算项目名称
       */
      projectName?: string;
      /**
       * 预算详情id
       */
      financialBudgetDetailId?: string;
      /**
       * 资金性质
       */
      fundsNatureName?: string;
      /**
       * 支出功能分类科目名称
       */
      expendFunctionClassifySubjectName?: string;
      /**
       * 是否包含政府采购预算，0:是、1：否
       */
      containsGovPurchaseBudget?: number;
      /**
       * 预算额度id
       */
      budgetQuotaId?: string;
      /**
       * 原先申请预算金额
       */
      originalAmount?: number;
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
      /**
       * 支付限额经济分类总金额
       */
      budgetPlanClassifyTotalAmount?: number;
      /**
       * 支付限额经济分类可用金额
       */
      budgetPlanClassifyAvailableAmount?: number;
      /**
       * 采购文号
       */
      purchaseNo?: string;
      /**
       * 匹配第三方推送的申报单预算关联信息的发放明细
       */
      distributeDetailList?: {
        /**
         * 批量发放唯一编号
         */
        batchDistributeCode?: string;
        /**
         * 发放明细唯一编号
         */
        distributeDetailCode?: string;
        /**
         * 明细批次编号
         */
        batchCode?: string;
        /**
         * 银行账户 脱敏
         */
        accountNo?: string;
        /**
         * 银行账户
         */
        accountNoDesc?: string;
        /**
         * 账户名称
         */
        accountName?: string;
        /**
         * 应付金额
         */
        payAmount?: number;
        /**
         * 银行代码
         */
        bankCode?: string;
        /**
         * 银行名字
         */
        bankName?: string;
        /**
         * 银行支行code
         */
        bankNo?: string;
        /**
         * 银行支行名称
         */
        bankBranchName?: string;
        /**
         * 社会统一信用代码
         */
        creditCode?: string;
        /**
         * 身份证
         */
        idCard?: string;
        idCardDesc?: string;
        /**
         * 支付状态：0-待支付，1-支付中，2-支付成功，3-支付失败；
         */
        payStatus?: number;
        payStatusDesc?: string;
        /**
         * 是否推送（0-未推送，1-已推送）
         */
        isRepush?: number;
        operateButton?: {
          /**
           * 编辑
           */
          edit?: boolean;
          /**
           * 查看
           */
          detail?: boolean;
          /**
           * 删除
           */
          delete?: boolean;
        };
      }[];
      /**
       * 部门名称 (2024年08月05日补充, 补充页面展示字段)
       */
      depName?: string;
      /**
       * 支出项 (2024年08月05日补充, 补充页面展示字段)
       */
      expenditureItem?: string;
    }[];
    /**
     * 批次金额
     */
    batchAmount?: number;
    /**
     * 批次成功金额
     */
    batchSuccessAmount?: number;
    /**
     * 预算占用金额
     */
    budgetAmount?: number;
    /**
     * 非财政资金结算平台, 付款账户信息
     */
    distributePayAccountRO?: {
      /**
       * 付款人唯一code
       */
      accountUniqueCode?: string;
      /**
       * 付款人账户
       */
      accountNo?: string;
      /**
       * 付款户名
       */
      accountName?: string;
      /**
       * 银行名字
       */
      bankName?: string;
      /**
       * 付款卡号
       */
      accountCode?: string;
      /**
       * 付款金额
       */
      amount?: number;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [批量发放支付信息查询（支付配置、预算、代收款信息）↗](http://yapi.cai-inc.com/project/3621/interface/api/300922) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-payment`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeQueryPaymentPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/query-payment',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [批量发放支付信息查询（支付配置、预算、代收款信息）↗](http://yapi.cai-inc.com/project/3621/interface/api/300922) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-payment`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeQueryPaymentPostRequestConfig: ZlbApiExpenseBatchDistributeQueryPaymentPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/query-payment',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeQueryPaymentPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [批量发放支付信息查询（支付配置、预算、代收款信息）↗](http://yapi.cai-inc.com/project/3621/interface/api/300922) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/query-payment`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeQueryPaymentPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeQueryPaymentPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeQueryPaymentPostResponse>(
    prepare(zlbApiExpenseBatchDistributeQueryPaymentPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeQueryPaymentPost.requestConfig =
  zlbApiExpenseBatchDistributeQueryPaymentPostRequestConfig;

/**
 * 接口 [查询批量发放支付结果↗](http://yapi.cai-inc.com/project/3621/interface/api/305554) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-pay-result/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGetRequest {
  batchDistributeCode: string;
}

/**
 * 接口 [查询批量发放支付结果↗](http://yapi.cai-inc.com/project/3621/interface/api/305554) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-pay-result/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 批量发放金额
     */
    amount?: number;
    /**
     * 需要支付的金额
     */
    needPayAmount?: number;
    /**
     * 批次支付记录
     */
    batchesPayResultROList?: {
      /**
       * 批次中明细总数
       */
      total?: number;
      /**
       * 支付成功数
       */
      successTotal?: number;
      /**
       * 支付失败数
       */
      failTotal?: number;
      /**
       * 批次成功金额
       */
      successAmount?: number;
      /**
       * 批次失败金额
       */
      failAmount?: number;
      batchNumber?: number;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询批量发放支付结果↗](http://yapi.cai-inc.com/project/3621/interface/api/305554) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-pay-result/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:18`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/batch/query-pay-result/{batchDistributeCode}',
    'data',
    'batchDistributeCode',
    string,
    false
  >
>;

/**
 * 接口 [查询批量发放支付结果↗](http://yapi.cai-inc.com/project/3621/interface/api/305554) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-pay-result/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:18`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGetRequestConfig: ZlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/batch/query-pay-result/{batchDistributeCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: ['batchDistributeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询批量发放支付结果↗](http://yapi.cai-inc.com/project/3621/interface/api/305554) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/batch/query-pay-result/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:18`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGetResponse>(
    prepare(
      zlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGetRequestConfig,
      requestData,
    ),
    ...args,
  );
};

zlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGet.requestConfig =
  zlbApiExpenseBatchDistributeBatchQueryPayResultBatchDistributeCodeGetRequestConfig;

/**
 * 接口 [运营机构查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/464810) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/operation/query-page`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeOperationQueryPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 机构id
   */
  orgId: number[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 发起人名字
   */
  operatorName?: string;
  /**
   * 部门ID
   */
  departmentId?: number;
  /**
   * 发放状态：0-未提交；1-支付中；2-支付成功；3-支付失败；
   */
  distributeStatusList?: number[];
  /**
   * 申请事由
   */
  reason?: string;
  /**
   * 起始时间
   */
  beginTime?: number;
  /**
   * 结束时间
   */
  endTime?: number;
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
}

/**
 * 接口 [运营机构查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/464810) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/operation/query-page`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeOperationQueryPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 批量发放唯一编号
       */
      batchDistributeCode?: string;
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据类型：0-个人；1-企业；
       */
      batchDistributeType?: number;
      batchDistributeTypeDesc?: string;
      /**
       * 发起人ID
       */
      operatorId?: number;
      /**
       * 发起人姓名
       */
      operatorName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 单位ID
       */
      orgId?: number;
      /**
       * 部门名称
       */
      departmentName?: string;
      /**
       * 部门ID
       */
      departmentId?: number;
      /**
       * 事由
       */
      reason?: string;
      /**
       * 发放总金额
       */
      distributeAmount?: number;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 批量发放单据状态
       */
      distributeStatus?: 0 | 1 | 2 | 3 | 4 | 5;
      distributeStatusDesc?: string;
      operateButton?: {
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 查看
         */
        detail?: boolean;
        /**
         * 删除
         */
        delete?: boolean;
        /**
         * 再次发放
         */
        againDistribute?: boolean;
        /**
         * 打印
         */
        print?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [运营机构查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/464810) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/operation/query-page`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeOperationQueryPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/operation/query-page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [运营机构查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/464810) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/operation/query-page`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeOperationQueryPagePostRequestConfig: ZlbApiExpenseBatchDistributeOperationQueryPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/operation/query-page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeOperationQueryPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [运营机构查询批量发放列表信息↗](http://yapi.cai-inc.com/project/3621/interface/api/464810) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/operation/query-page`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeOperationQueryPagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeOperationQueryPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeOperationQueryPagePostResponse>(
    prepare(zlbApiExpenseBatchDistributeOperationQueryPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeOperationQueryPagePost.requestConfig =
  zlbApiExpenseBatchDistributeOperationQueryPagePostRequestConfig;

/**
 * 接口 [批量发放提交↗](http://yapi.cai-inc.com/project/3621/interface/api/483498) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/submit`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeSubmitPostRequest {
  /**
   * 发放编号
   */
  batchDistributeCode: string;
  /**
   * 摘要字段
   */
  summary: string;
  /**
   * 支付方式：1：国库支付 3：自有资金支付
   */
  payMode: number;
  /**
   * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
   *       3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
   */
  payStrategy?: number;
  /**
   * 增加付款人信息(针对自有资金支付场景)
   */
  distributePayAccountPO?: {
    /**
     * 付款账户accountCode，传递支付系统的银行卡的accountCode
     */
    accountCode: string;
    /**
     * 付款金额
     */
    payAmount?: number;
  };
  /**
   * 预算信息
   */
  budgetInfoPO?: {
    /**
     * 主预算编号
     */
    mainBudgetCode: number;
    /**
     * 指标编号
     */
    budgetUk: string;
    /**
     * 预算支付限额分类
     */
    budgetPlanClassifyUk: string;
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 预算额度id
     */
    budgetQuotaId?: string;
    /**
     * 发放明细
     */
    distributeDetailCodeList?: string[];
  }[];
  /**
   * 是否忽略警告（弱控）
   */
  isIgnoreWarning?: boolean;
  /**
   * 拆解账户、代发账户
   */
  accountCode?: string;
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
    /**
     * 科目uk 级联
     */
    subjectUkHierarchy?: string[];
    /**
     * 科目名称级联
     */
    subjectNameHierarchy?: string[];
  }[];
  /**
   * 是否开启工作流 true-开启；false-未开启
   */
  enableWorkflow?: boolean;
  /**
   * 工作流提交信息
   */
  workflowInfo?: {
    /**
     * 业务标识
     */
    bizId?: string;
    /**
     * 必填, 业务场景
     */
    bizType?: string;
    /**
     * 业务编码
     */
    businessCode?: string;
    /**
     * 子类型
     */
    subType?: string;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: string;
    /**
     * 必填, 工作流模型ID
     */
    processModelId?: number;
    /**
     * 必填, 工作流模型版本
     */
    version?: number;
    /**
     * 节点审批信息
     */
    auditInfos?: {
      /**
       * 节点Key
       */
      taskDefineKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 审批人的操作员ID
       */
      operatorIds?: number[];
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 业务扩展数据
       */
      bizProperty?: string;
      /**
       * 节点审核状态
       */
      auditStatus?: number;
    }[];
    /**
     * 扩展条件，for百搭
     */
    extConditions?: {
      key?: {};
    };
    /**
     * 业务上下文
     */
    context?: string;
    /**
     * 当前操作入Id
     */
    operatorId?: number;
    /**
     * 备注
     */
    remark?: string;
  };
}

/**
 * 接口 [批量发放提交↗](http://yapi.cai-inc.com/project/3621/interface/api/483498) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/submit`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态 0：通过 1：警告 2：强控
     */
    checkStatus?: number;
    /**
     * 预算校验结果
     */
    budgetCheckResultRO?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
      /**
       * 预算指标ID
       */
      mainBudgetCode?: number;
      /**
       * 指标编号
       */
      budgetUk?: string;
      /**
       * 预算编号(展示)
       */
      financialBudgetDetailId?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 额度ID
       */
      budgetQuotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag?: boolean;
      /**
       * 占用总金额
       */
      budgetTotalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 报销单行程校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 可用金额
         */
        availableAmount?: number;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [批量发放提交↗](http://yapi.cai-inc.com/project/3621/interface/api/483498) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/submit`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [批量发放提交↗](http://yapi.cai-inc.com/project/3621/interface/api/483498) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/submit`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeSubmitPostRequestConfig: ZlbApiExpenseBatchDistributeSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [批量发放提交↗](http://yapi.cai-inc.com/project/3621/interface/api/483498) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/submit`
 * @更新时间 `2024-09-10 10:09:41`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeSubmitPostResponse>(
    prepare(zlbApiExpenseBatchDistributeSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeSubmitPost.requestConfig =
  zlbApiExpenseBatchDistributeSubmitPostRequestConfig;

/**
 * 接口 [校验明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528170) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/check-detail/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGetRequest {
  batchDistributeCode: string;
}

/**
 * 接口 [校验明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528170) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/check-detail/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [校验明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528170) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/check-detail/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/check-detail/{batchDistributeCode}',
    'data',
    'batchDistributeCode',
    string,
    false
  >
>;

/**
 * 接口 [校验明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528170) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/check-detail/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGetRequestConfig: ZlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/check-detail/{batchDistributeCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: ['batchDistributeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528170) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `GET /zlb/api/expense/batch-distribute/check-detail/{batchDistributeCode}`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGetResponse>(
    prepare(
      zlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGetRequestConfig,
      requestData,
    ),
    ...args,
  );
};

zlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGet.requestConfig =
  zlbApiExpenseBatchDistributeCheckDetailBatchDistributeCodeGetRequestConfig;

/**
 * 接口 [查看指标关联的明细↗](http://yapi.cai-inc.com/project/3621/interface/api/561970) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/budget/detail-rel/page`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeBudgetDetailRelPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 预算唯一编码 (废弃)
   */
  mainBudgetCode?: number;
  /**
   * 指标编号
   */
  budgetUk: string;
  /**
   * 批次号
   */
  batchNo: string;
  /**
   * 收款户名
   */
  accountName?: string;
  /**
   * 收款账号
   */
  accountNo?: string;
}

/**
 * 接口 [查看指标关联的明细↗](http://yapi.cai-inc.com/project/3621/interface/api/561970) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/budget/detail-rel/page`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeBudgetDetailRelPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 批量发放唯一编号
       */
      batchDistributeCode?: string;
      /**
       * 发放明细唯一编号
       */
      distributeDetailCode?: string;
      /**
       * 明细批次编号
       */
      batchCode?: string;
      /**
       * 银行账户 脱敏
       */
      accountNo?: string;
      /**
       * 银行账户
       */
      accountNoDesc?: string;
      /**
       * 账户名称
       */
      accountName?: string;
      /**
       * 应付金额
       */
      payAmount?: number;
      /**
       * 银行代码
       */
      bankCode?: string;
      /**
       * 银行名字
       */
      bankName?: string;
      /**
       * 银行支行code
       */
      bankNo?: string;
      /**
       * 银行支行名称
       */
      bankBranchName?: string;
      /**
       * 社会统一信用代码
       */
      creditCode?: string;
      /**
       * 身份证
       */
      idCard?: string;
      idCardDesc?: string;
      /**
       * 支付状态：0-待支付，1-支付中，2-支付成功，3-支付失败；
       */
      payStatus?: number;
      payStatusDesc?: string;
      operateButton?: {
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 查看
         */
        detail?: boolean;
        /**
         * 删除
         */
        delete?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查看指标关联的明细↗](http://yapi.cai-inc.com/project/3621/interface/api/561970) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/budget/detail-rel/page`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeBudgetDetailRelPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/budget/detail-rel/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查看指标关联的明细↗](http://yapi.cai-inc.com/project/3621/interface/api/561970) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/budget/detail-rel/page`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeBudgetDetailRelPagePostRequestConfig: ZlbApiExpenseBatchDistributeBudgetDetailRelPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/budget/detail-rel/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeBudgetDetailRelPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查看指标关联的明细↗](http://yapi.cai-inc.com/project/3621/interface/api/561970) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/budget/detail-rel/page`
 * @更新时间 `2024-04-02 14:40:17`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeBudgetDetailRelPagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeBudgetDetailRelPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeBudgetDetailRelPagePostResponse>(
    prepare(zlbApiExpenseBatchDistributeBudgetDetailRelPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeBudgetDetailRelPagePost.requestConfig =
  zlbApiExpenseBatchDistributeBudgetDetailRelPagePostRequestConfig;

/**
 * 接口 [明细拆分↗](http://yapi.cai-inc.com/project/3621/interface/api/633322) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-disassemble`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDetailDisassemblePostRequest {
  /**
   * 拆分明细
   */
  disassemblePOList: {
    /**
     * 批量发放明细编码
     */
    distributeDetailCode: string;
    /**
     * 拆分金额列表
     */
    disassembleAmountList: {
      /**
       * 前端唯一标识
       */
      indexNo?: string;
      /**
       * 拆分金额
       */
      payAmount?: number;
    }[];
  }[];
}

/**
 * 接口 [明细拆分↗](http://yapi.cai-inc.com/project/3621/interface/api/633322) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-disassemble`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDetailDisassemblePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 批量发放明细编码
     */
    distributeDetailCode?: string;
    /**
     * 拆分后的明细列表
     */
    disassembleDetailList?: {
      /**
       * 前端唯一标识
       */
      indexNo?: string;
      /**
       * 拆分金额
       */
      payAmount?: number;
      /**
       * 明细编码
       */
      distributeDetailCode?: string;
      /**
       * 账户名称
       */
      accountName?: string;
      /**
       * 银行账户
       */
      accountNo?: string;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [明细拆分↗](http://yapi.cai-inc.com/project/3621/interface/api/633322) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-disassemble`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeDetailDisassemblePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/detail-disassemble',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [明细拆分↗](http://yapi.cai-inc.com/project/3621/interface/api/633322) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-disassemble`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeDetailDisassemblePostRequestConfig: ZlbApiExpenseBatchDistributeDetailDisassemblePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/detail-disassemble',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeDetailDisassemblePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [明细拆分↗](http://yapi.cai-inc.com/project/3621/interface/api/633322) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-disassemble`
 * @更新时间 `2024-04-02 14:40:20`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeDetailDisassemblePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeDetailDisassemblePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeDetailDisassemblePostResponse>(
    prepare(zlbApiExpenseBatchDistributeDetailDisassemblePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeDetailDisassemblePost.requestConfig =
  zlbApiExpenseBatchDistributeDetailDisassemblePostRequestConfig;

/**
 * 接口 [发放明细删除校验↗](http://yapi.cai-inc.com/project/3621/interface/api/634162) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-delete/check`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
export type ZlbApiExpenseBatchDistributeDetailDeleteCheckPostRequest = string[];

/**
 * 接口 [发放明细删除校验↗](http://yapi.cai-inc.com/project/3621/interface/api/634162) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-delete/check`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDetailDeleteCheckPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验状态：0-通过，1-存在异常
     */
    checkStatus?: number;
    /**
     * 校验警告描述
     */
    checkWarningDesc?: string;
    /**
     * 申报单唯一编码
     */
    detailCodeList?: string[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [发放明细删除校验↗](http://yapi.cai-inc.com/project/3621/interface/api/634162) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-delete/check`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeDetailDeleteCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/detail-delete/check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [发放明细删除校验↗](http://yapi.cai-inc.com/project/3621/interface/api/634162) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-delete/check`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeDetailDeleteCheckPostRequestConfig: ZlbApiExpenseBatchDistributeDetailDeleteCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: '/zlb/api/expense/batch-distribute/detail-delete/check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeDetailDeleteCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [发放明细删除校验↗](http://yapi.cai-inc.com/project/3621/interface/api/634162) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_48504)
 * @请求头 `POST /zlb/api/expense/batch-distribute/detail-delete/check`
 * @更新时间 `2024-04-02 14:40:19`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeDetailDeleteCheckPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeDetailDeleteCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeDetailDeleteCheckPostResponse>(
    prepare(zlbApiExpenseBatchDistributeDetailDeleteCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeDetailDeleteCheckPost.requestConfig =
  zlbApiExpenseBatchDistributeDetailDeleteCheckPostRequestConfig;

const mockUrl_0_1_0_13 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_13 = '' as any;
const prodUrl_0_1_0_13 = '' as any;
const dataKey_0_1_0_13 = 'data' as any;

/**
 * 接口 [查询关联关系管理列表(分页)↗](http://yapi.cai-inc.com/project/3621/interface/api/352146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/page`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManagePagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 关联单位
   */
  correlationOrgId?: number;
  /**
   * 关联单位统一社会信用代码
   */
  correlationCreditCode?: string;
  /**
   * 关联部门
   */
  correlationDeptId?: number;
  /**
   * 目标单位
   */
  targetOrgId?: number;
  /**
   * 目标单位统一社会信用代码
   */
  targetCreditCode?: string;
  /**
   * 状态 0：启用 1：停用
   */
  status?: number;
  /**
   * 起始时间
   */
  startDate?: number;
  /**
   * 截止时间
   */
  endDate?: number;
}

/**
 * 接口 [查询关联关系管理列表(分页)↗](http://yapi.cai-inc.com/project/3621/interface/api/352146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/page`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManagePagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 唯一关系唯一code
       */
      orgRelationCode?: string;
      /**
       * 目标单位id
       */
      targetOrgId?: number;
      /**
       * 目标单位名称
       */
      targetOrgName?: string;
      /**
       * 创建时间
       */
      createTime?: number;
      /**
       * 最近编辑时间
       */
      modifyTime?: number;
      /**
       * 状态 0：启用 1：停用 描述
       */
      statusName?: string;
      /**
       * 状态 0：启用 1：停用 值
       */
      status?: number;
      /**
       * 最近编辑人
       */
      operatorName?: string;
      /**
       * 单位id
       */
      correlationOrgId?: number;
      /**
       * 关联单位Name
       */
      correlationOrgName?: string;
      /**
       * 关联单位或部门
       */
      correlationDeptList?: {
        /**
         * 部门id
         */
        id?: number;
        /**
         * 部门名称
         */
        name?: string;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询关联关系管理列表(分页)↗](http://yapi.cai-inc.com/project/3621/interface/api/352146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/page`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManagePagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询关联关系管理列表(分页)↗](http://yapi.cai-inc.com/project/3621/interface/api/352146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/page`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManagePagePostRequestConfig: ZlbApiExpenseOrgRelationManagePagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManagePagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询关联关系管理列表(分页)↗](http://yapi.cai-inc.com/project/3621/interface/api/352146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/page`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManagePagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManagePagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManagePagePostResponse>(
    prepare(zlbApiExpenseOrgRelationManagePagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManagePagePost.requestConfig =
  zlbApiExpenseOrgRelationManagePagePostRequestConfig;

/**
 * 接口 [保存新增↗](http://yapi.cai-inc.com/project/3621/interface/api/352154) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/save`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageSavePostRequest {
  /**
   * 唯一code 传则新增，反之则更新
   */
  orgRelationCode?: string;
  /**
   * 目标单位
   */
  targetOrgId: number;
  /**
   * 目标单位
   */
  targetOrgName: string;
  /**
   * 关联单位列表
   */
  correlationOrgList?: {
    /**
     * 关联单位id
     */
    orgId: number;
    orgName: string;
    /**
     * 关联单位 统一社会信用代码
     */
    correlationCreditCode: string;
    /**
     * 部门 list
     */
    deptList?: {
      id?: number;
      name?: string;
    }[];
  }[];
  /**
   * 0:启用/1:停用
   */
  status: number;
  /**
   * 强制提交/覆盖
   */
  forceSubmit?: boolean;
}

/**
 * 接口 [保存新增↗](http://yapi.cai-inc.com/project/3621/interface/api/352154) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/save`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存新增↗](http://yapi.cai-inc.com/project/3621/interface/api/352154) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/save`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存新增↗](http://yapi.cai-inc.com/project/3621/interface/api/352154) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/save`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageSavePostRequestConfig: ZlbApiExpenseOrgRelationManageSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存新增↗](http://yapi.cai-inc.com/project/3621/interface/api/352154) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/save`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageSavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageSavePostResponse>(
    prepare(zlbApiExpenseOrgRelationManageSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageSavePost.requestConfig =
  zlbApiExpenseOrgRelationManageSavePostRequestConfig;

/**
 * 接口 [关系启用\/停用↗](http://yapi.cai-inc.com/project/3621/interface/api/352162) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/relationEnableOrDisable`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageRelationEnableOrDisablePostRequest {
  /**
   * orgRelationCode
   */
  orgRelationCode?: string;
  /**
   * 0：启用 1:停用 删除接口则无需传参
   */
  status?: number;
}

/**
 * 接口 [关系启用\/停用↗](http://yapi.cai-inc.com/project/3621/interface/api/352162) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/relationEnableOrDisable`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageRelationEnableOrDisablePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [关系启用\/停用↗](http://yapi.cai-inc.com/project/3621/interface/api/352162) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/relationEnableOrDisable`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageRelationEnableOrDisablePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/relationEnableOrDisable',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [关系启用\/停用↗](http://yapi.cai-inc.com/project/3621/interface/api/352162) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/relationEnableOrDisable`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageRelationEnableOrDisablePostRequestConfig: ZlbApiExpenseOrgRelationManageRelationEnableOrDisablePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/relationEnableOrDisable',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageRelationEnableOrDisablePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [关系启用\/停用↗](http://yapi.cai-inc.com/project/3621/interface/api/352162) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/relationEnableOrDisable`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageRelationEnableOrDisablePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageRelationEnableOrDisablePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageRelationEnableOrDisablePostResponse>(
    prepare(zlbApiExpenseOrgRelationManageRelationEnableOrDisablePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageRelationEnableOrDisablePost.requestConfig =
  zlbApiExpenseOrgRelationManageRelationEnableOrDisablePostRequestConfig;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3621/interface/api/352170) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/delete`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageDeletePostRequest {
  /**
   * orgRelationCode
   */
  orgRelationCode?: string;
  /**
   * 0：启用 1:停用 删除接口则无需传参
   */
  status?: number;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3621/interface/api/352170) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/delete`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3621/interface/api/352170) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/delete`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3621/interface/api/352170) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/delete`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageDeletePostRequestConfig: ZlbApiExpenseOrgRelationManageDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除↗](http://yapi.cai-inc.com/project/3621/interface/api/352170) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `POST /zlb/api/expense/org/relation/manage/delete`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageDeletePostResponse>(
    prepare(zlbApiExpenseOrgRelationManageDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageDeletePost.requestConfig =
  zlbApiExpenseOrgRelationManageDeletePostRequestConfig;

/**
 * 接口 [根据当前单位查询关联单位↗](http://yapi.cai-inc.com/project/3621/interface/api/352178) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationOrg`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryCorrelationOrgGetRequest {
  /**
   * 当前单位
   */
  orgId: string;
}

/**
 * 接口 [根据当前单位查询关联单位↗](http://yapi.cai-inc.com/project/3621/interface/api/352178) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationOrg`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryCorrelationOrgGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 机构id
     */
    orgId?: number;
    /**
     * 机构名称
     */
    orgName?: string;
    /**
     * 部门id
     */
    deptId?: number;
    /**
     * 部门名称
     */
    deptName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据当前单位查询关联单位↗](http://yapi.cai-inc.com/project/3621/interface/api/352178) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationOrg`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageQueryCorrelationOrgGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/queryCorrelationOrg',
    'data',
    string,
    'orgId',
    false
  >
>;

/**
 * 接口 [根据当前单位查询关联单位↗](http://yapi.cai-inc.com/project/3621/interface/api/352178) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationOrg`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageQueryCorrelationOrgGetRequestConfig: ZlbApiExpenseOrgRelationManageQueryCorrelationOrgGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/queryCorrelationOrg',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: ['orgId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageQueryCorrelationOrgGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据当前单位查询关联单位↗](http://yapi.cai-inc.com/project/3621/interface/api/352178) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationOrg`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageQueryCorrelationOrgGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageQueryCorrelationOrgGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageQueryCorrelationOrgGetResponse>(
    prepare(zlbApiExpenseOrgRelationManageQueryCorrelationOrgGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageQueryCorrelationOrgGet.requestConfig =
  zlbApiExpenseOrgRelationManageQueryCorrelationOrgGetRequestConfig;

/**
 * 接口 [查询单位关系详情↗](http://yapi.cai-inc.com/project/3621/interface/api/353018) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryOne`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryOneGetRequest {
  /**
   * 唯一code
   */
  orgRelationCode?: string;
}

/**
 * 接口 [查询单位关系详情↗](http://yapi.cai-inc.com/project/3621/interface/api/353018) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryOne`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryOneGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 唯一关系唯一code
     */
    orgRelationCode?: string;
    /**
     * 目标单位id
     */
    targetOrgId?: number;
    /**
     * 目标单位名称
     */
    targetOrgName?: string;
    /**
     * 创建时间
     */
    createTime?: number;
    /**
     * 最近编辑时间
     */
    modifyTime?: number;
    /**
     * 状态 0：启用 1：停用 值
     */
    status?: number;
    /**
     * 关联单位或部门
     */
    correlationOrgList?: {
      /**
       * 关联单位id
       */
      orgId?: number;
      orgName?: string;
      correlationCreditCode?: string;
      /**
       * 机构关系部门list
       */
      deptList?: {
        /**
         * 部门id
         */
        id?: number;
        /**
         * 部门名称
         */
        name?: string;
      }[];
      /**
       * 关联机构的全部部门
       */
      correlationAllDeptList?: {
        /**
         * 部门id
         */
        id?: number;
        /**
         * 部门名称
         */
        name?: string;
        /**
         * 上级部门
         */
        parentId?: number;
        /**
         * 挂载层次
         */
        hierarchy?: string;
        /**
         * 是否叶子
         */
        isLeaf?: number;
        /**
         * 下级部门
         */
        children?: {
          /**
           * 部门id
           */
          id?: number;
          /**
           * 部门名称
           */
          name?: string;
          /**
           * 上级部门
           */
          parentId?: number;
          /**
           * 挂载层次
           */
          hierarchy?: string;
          /**
           * 是否叶子
           */
          isLeaf?: number;
          /**
           * 下级部门
           */
          children?: {}[];
        }[];
      }[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单位关系详情↗](http://yapi.cai-inc.com/project/3621/interface/api/353018) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryOne`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageQueryOneGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/queryOne',
    'data',
    string,
    'orgRelationCode',
    false
  >
>;

/**
 * 接口 [查询单位关系详情↗](http://yapi.cai-inc.com/project/3621/interface/api/353018) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryOne`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageQueryOneGetRequestConfig: ZlbApiExpenseOrgRelationManageQueryOneGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/queryOne',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: ['orgRelationCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageQueryOneGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单位关系详情↗](http://yapi.cai-inc.com/project/3621/interface/api/353018) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryOne`
 * @更新时间 `2024-02-26 09:46:08`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageQueryOneGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageQueryOneGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageQueryOneGetResponse>(
    prepare(zlbApiExpenseOrgRelationManageQueryOneGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageQueryOneGet.requestConfig =
  zlbApiExpenseOrgRelationManageQueryOneGetRequestConfig;

/**
 * 接口 [查询关系单位列表模糊搜索↗](http://yapi.cai-inc.com/project/3621/interface/api/353090) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryRelationOrgListLike`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGetRequest {
  /**
   * 名称
   */
  name: string;
  /**
   * 类型 1:关联单位 2:目标单位
   */
  type: string;
}

/**
 * 接口 [查询关系单位列表模糊搜索↗](http://yapi.cai-inc.com/project/3621/interface/api/353090) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryRelationOrgListLike`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 机构id
     */
    orgId?: number;
    /**
     * 机构名称
     */
    orgName?: string;
    /**
     * 部门id
     */
    deptId?: number;
    /**
     * 部门名称
     */
    deptName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询关系单位列表模糊搜索↗](http://yapi.cai-inc.com/project/3621/interface/api/353090) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryRelationOrgListLike`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/queryRelationOrgListLike',
    'data',
    string,
    'name' | 'type',
    false
  >
>;

/**
 * 接口 [查询关系单位列表模糊搜索↗](http://yapi.cai-inc.com/project/3621/interface/api/353090) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryRelationOrgListLike`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGetRequestConfig: ZlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/queryRelationOrgListLike',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: ['name', 'type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询关系单位列表模糊搜索↗](http://yapi.cai-inc.com/project/3621/interface/api/353090) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryRelationOrgListLike`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGetResponse>(
    prepare(zlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGet.requestConfig =
  zlbApiExpenseOrgRelationManageQueryRelationOrgListLikeGetRequestConfig;

/**
 * 接口 [查询关联部门列表（单位or统一社会信用代码）↗](http://yapi.cai-inc.com/project/3621/interface/api/354538) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationDeptList`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryCorrelationDeptListGetRequest {
  /**
   * 关联机构id
   */
  orgId?: string;
  /**
   * 关联社会信用代码
   */
  creditCode?: string;
}

/**
 * 接口 [查询关联部门列表（单位or统一社会信用代码）↗](http://yapi.cai-inc.com/project/3621/interface/api/354538) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationDeptList`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryCorrelationDeptListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 机构id
     */
    orgId?: number;
    /**
     * 机构名称
     */
    orgName?: string;
    /**
     * 部门id
     */
    deptId?: number;
    /**
     * 部门名称
     */
    deptName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询关联部门列表（单位or统一社会信用代码）↗](http://yapi.cai-inc.com/project/3621/interface/api/354538) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationDeptList`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageQueryCorrelationDeptListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/queryCorrelationDeptList',
    'data',
    string,
    'orgId' | 'creditCode',
    false
  >
>;

/**
 * 接口 [查询关联部门列表（单位or统一社会信用代码）↗](http://yapi.cai-inc.com/project/3621/interface/api/354538) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationDeptList`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageQueryCorrelationDeptListGetRequestConfig: ZlbApiExpenseOrgRelationManageQueryCorrelationDeptListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/queryCorrelationDeptList',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: ['orgId', 'creditCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageQueryCorrelationDeptListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询关联部门列表（单位or统一社会信用代码）↗](http://yapi.cai-inc.com/project/3621/interface/api/354538) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryCorrelationDeptList`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageQueryCorrelationDeptListGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageQueryCorrelationDeptListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageQueryCorrelationDeptListGetResponse>(
    prepare(zlbApiExpenseOrgRelationManageQueryCorrelationDeptListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageQueryCorrelationDeptListGet.requestConfig =
  zlbApiExpenseOrgRelationManageQueryCorrelationDeptListGetRequestConfig;

/**
 * 接口 [查询所有机构(启用、停用、已删除)↗](http://yapi.cai-inc.com/project/3621/interface/api/355114) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryAllInstitution`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryAllInstitutionGetRequest {
  /**
   * 模糊匹配
   */
  name: string;
  /**
   * true：只查询启用的单位 false：查询所有
   */
  queryOnlyEnable: string;
}

/**
 * 接口 [查询所有机构(启用、停用、已删除)↗](http://yapi.cai-inc.com/project/3621/interface/api/355114) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryAllInstitution`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryAllInstitutionGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 实体主键 [关键字段]
     */
    id?: number;
    /**
     * 记录创建时间
     */
    createdAt?: string;
    /**
     * 记录更新时间
     */
    updatedAt?: string;
    /**
     * 创建用户
     */
    creatorId?: number;
    /**
     * 更新用户
     */
    modifierId?: number;
    /**
     * 机构名称
     */
    name?: string;
    /**
     * 机构简称
     */
    shortName?: string;
    /**
     * 组织机构代码
     */
    orgCode?: string;
    /**
     * 社会统一信用代码
     */
    creditCode?: string;
    /**
     * 机构扫描附件
     */
    bizAttaches?: string[];
    /**
     * 机构标记
     */
    tags?: string[];
    /**
     * 住所省地址编码
     */
    provinceCode?: string;
    /**
     * 住所省地址名称
     */
    provinceName?: string;
    /**
     * 住所市地址编码
     */
    cityCode?: string;
    /**
     * 住所市地址名称
     */
    cityName?: string;
    /**
     * 住所区地址编码
     */
    regionCode?: string;
    /**
     * 住所区地址名称
     */
    regionName?: string;
    /**
     * 住所详细地址
     */
    address?: string;
    /**
     * 机构状态
     */
    status?: number;
    /**
     * 排序码
     */
    displayOrder?: number;
    /**
     * 外部创建时间
     */
    outCreatedAt?: string;
    /**
     * 机构所属行政区划
     */
    divisionCode?: string;
    /**
     * 机构所属行政区划
     */
    divisionName?: string;
    /**
     * 机构全称
     */
    fullName?: string;
    /**
     * 邮政编码
     */
    postalCode?: string;
    /**
     * 来源
     */
    source?: number;
    /**
     * 组织code
     * 第三方业务实体唯一code
     */
    organizationCode?: string;
    /**
     * 单位级别
     */
    institutionLevel?: number;
    /**
     * 标签
     */
    tagCodes?: string;
    operators?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
    }[];
    tenantCode?: string;
    tenantName?: string;
    userTypeName?: string;
    parentInstitutionName?: string;
    userTypes?: string[];
    operatorCount?: number;
    departmentCount?: number;
    parentInstitution?: {
      id?: number;
      createdAt?: number;
      updatedAt?: number;
      creatorId?: string;
      modifierId?: string;
      extFields?: string;
      name?: string;
      shortName?: string;
      orgCode?: string;
      creditCode?: string;
      bizAttaches?: string;
      tags?: string;
      provinceCode?: string;
      provinceName?: string;
      cityCode?: string;
      cityName?: string;
      regionCode?: string;
      regionName?: string;
      address?: string;
      status?: number;
      displayOrder?: number;
      outCreatedAt?: string;
      divisionCode?: string;
      fullName?: string;
      postalCode?: string;
      source?: number;
      organizationCode?: string;
      institutionLevel?: number;
    };
    /**
     * 是否删除 0：未删除 1：已删除
     */
    isDeleted?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询所有机构(启用、停用、已删除)↗](http://yapi.cai-inc.com/project/3621/interface/api/355114) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryAllInstitution`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageQueryAllInstitutionGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/queryAllInstitution',
    'data',
    string,
    'name' | 'queryOnlyEnable',
    false
  >
>;

/**
 * 接口 [查询所有机构(启用、停用、已删除)↗](http://yapi.cai-inc.com/project/3621/interface/api/355114) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryAllInstitution`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageQueryAllInstitutionGetRequestConfig: ZlbApiExpenseOrgRelationManageQueryAllInstitutionGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/queryAllInstitution',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: ['name', 'queryOnlyEnable'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageQueryAllInstitutionGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询所有机构(启用、停用、已删除)↗](http://yapi.cai-inc.com/project/3621/interface/api/355114) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryAllInstitution`
 * @更新时间 `2024-02-26 09:46:09`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageQueryAllInstitutionGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageQueryAllInstitutionGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageQueryAllInstitutionGetResponse>(
    prepare(zlbApiExpenseOrgRelationManageQueryAllInstitutionGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageQueryAllInstitutionGet.requestConfig =
  zlbApiExpenseOrgRelationManageQueryAllInstitutionGetRequestConfig;

/**
 * 接口 [机构id查询部门列表↗](http://yapi.cai-inc.com/project/3621/interface/api/358522) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryDeptListByOrgId`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGetRequest {
  /**
   * 机构id
   */
  orgId: string;
}

/**
 * 接口 [机构id查询部门列表↗](http://yapi.cai-inc.com/project/3621/interface/api/358522) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryDeptListByOrgId`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 部门id
     */
    id?: number;
    /**
     * 部门名称
     */
    name?: string;
    /**
     * 上级部门
     */
    parentId?: number;
    /**
     * 挂载层次
     */
    hierarchy?: string;
    /**
     * 是否叶子
     */
    isLeaf?: number;
    /**
     * 下级部门
     */
    children?: {
      /**
       * 部门id
       */
      id?: number;
      /**
       * 部门名称
       */
      name?: string;
      /**
       * 上级部门
       */
      parentId?: number;
      /**
       * 挂载层次
       */
      hierarchy?: string;
      /**
       * 是否叶子
       */
      isLeaf?: number;
      /**
       * 下级部门
       */
      children?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [机构id查询部门列表↗](http://yapi.cai-inc.com/project/3621/interface/api/358522) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryDeptListByOrgId`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/queryDeptListByOrgId',
    'data',
    string,
    'orgId',
    false
  >
>;

/**
 * 接口 [机构id查询部门列表↗](http://yapi.cai-inc.com/project/3621/interface/api/358522) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryDeptListByOrgId`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGetRequestConfig: ZlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/queryDeptListByOrgId',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: ['orgId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [机构id查询部门列表↗](http://yapi.cai-inc.com/project/3621/interface/api/358522) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryDeptListByOrgId`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGetResponse>(
    prepare(zlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGet.requestConfig =
  zlbApiExpenseOrgRelationManageQueryDeptListByOrgIdGetRequestConfig;

/**
 * 接口 [查询已删除的↗](http://yapi.cai-inc.com/project/3621/interface/api/358722) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryInstitutionDeleted`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryInstitutionDeletedGetRequest {
  /**
   * 模糊匹配
   */
  name: string;
  /**
   * true：查询已删除 false：查询未删除
   */
  haveDeleted: string;
}

/**
 * 接口 [查询已删除的↗](http://yapi.cai-inc.com/project/3621/interface/api/358722) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryInstitutionDeleted`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOrgRelationManageQueryInstitutionDeletedGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 实体主键 [关键字段]
     */
    id?: number;
    /**
     * 记录创建时间
     */
    createdAt?: string;
    /**
     * 记录更新时间
     */
    updatedAt?: string;
    /**
     * 创建用户
     */
    creatorId?: number;
    /**
     * 更新用户
     */
    modifierId?: number;
    /**
     * 机构名称
     */
    name?: string;
    /**
     * 机构简称
     */
    shortName?: string;
    /**
     * 组织机构代码
     */
    orgCode?: string;
    /**
     * 社会统一信用代码
     */
    creditCode?: string;
    /**
     * 机构扫描附件
     */
    bizAttaches?: string[];
    /**
     * 机构标记
     */
    tags?: string[];
    /**
     * 住所省地址编码
     */
    provinceCode?: string;
    /**
     * 住所省地址名称
     */
    provinceName?: string;
    /**
     * 住所市地址编码
     */
    cityCode?: string;
    /**
     * 住所市地址名称
     */
    cityName?: string;
    /**
     * 住所区地址编码
     */
    regionCode?: string;
    /**
     * 住所区地址名称
     */
    regionName?: string;
    /**
     * 住所详细地址
     */
    address?: string;
    /**
     * 机构状态
     */
    status?: number;
    /**
     * 排序码
     */
    displayOrder?: number;
    /**
     * 外部创建时间
     */
    outCreatedAt?: string;
    /**
     * 机构所属行政区划
     */
    divisionCode?: string;
    /**
     * 机构所属行政区划
     */
    divisionName?: string;
    /**
     * 机构全称
     */
    fullName?: string;
    /**
     * 邮政编码
     */
    postalCode?: string;
    /**
     * 来源
     */
    source?: number;
    /**
     * 组织code
     * 第三方业务实体唯一code
     */
    organizationCode?: string;
    /**
     * 单位级别
     */
    institutionLevel?: number;
    /**
     * 标签
     */
    tagCodes?: string;
    operators?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
    }[];
    tenantCode?: string;
    tenantName?: string;
    userTypeName?: string;
    parentInstitutionName?: string;
    userTypes?: string[];
    operatorCount?: number;
    departmentCount?: number;
    parentInstitution?: {
      id?: number;
      createdAt?: number;
      updatedAt?: number;
      creatorId?: string;
      modifierId?: string;
      extFields?: string;
      name?: string;
      shortName?: string;
      orgCode?: string;
      creditCode?: string;
      bizAttaches?: string;
      tags?: string;
      provinceCode?: string;
      provinceName?: string;
      cityCode?: string;
      cityName?: string;
      regionCode?: string;
      regionName?: string;
      address?: string;
      status?: number;
      displayOrder?: number;
      outCreatedAt?: string;
      divisionCode?: string;
      fullName?: string;
      postalCode?: string;
      source?: number;
      organizationCode?: string;
      institutionLevel?: number;
    };
    /**
     * 是否删除 0：未删除 1：已删除
     */
    isDeleted?: number;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询已删除的↗](http://yapi.cai-inc.com/project/3621/interface/api/358722) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryInstitutionDeleted`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
type ZlbApiExpenseOrgRelationManageQueryInstitutionDeletedGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/org/relation/manage/queryInstitutionDeleted',
    'data',
    string,
    'name' | 'haveDeleted',
    false
  >
>;

/**
 * 接口 [查询已删除的↗](http://yapi.cai-inc.com/project/3621/interface/api/358722) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryInstitutionDeleted`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
const zlbApiExpenseOrgRelationManageQueryInstitutionDeletedGetRequestConfig: ZlbApiExpenseOrgRelationManageQueryInstitutionDeletedGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: '/zlb/api/expense/org/relation/manage/queryInstitutionDeleted',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: ['name', 'haveDeleted'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOrgRelationManageQueryInstitutionDeletedGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询已删除的↗](http://yapi.cai-inc.com/project/3621/interface/api/358722) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [单位关系管理↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_49578)
 * @请求头 `GET /zlb/api/expense/org/relation/manage/queryInstitutionDeleted`
 * @更新时间 `2024-02-26 09:46:10`
 * @项目ID 3621
 */
export const zlbApiExpenseOrgRelationManageQueryInstitutionDeletedGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOrgRelationManageQueryInstitutionDeletedGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOrgRelationManageQueryInstitutionDeletedGetResponse>(
    prepare(zlbApiExpenseOrgRelationManageQueryInstitutionDeletedGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOrgRelationManageQueryInstitutionDeletedGet.requestConfig =
  zlbApiExpenseOrgRelationManageQueryInstitutionDeletedGetRequestConfig;

const mockUrl_0_1_0_14 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_14 = '' as any;
const prodUrl_0_1_0_14 = '' as any;
const dataKey_0_1_0_14 = 'data' as any;

/**
 * 接口 [指标列表查询，报销侧选择指标时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383522) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetQueryBudgetPostRequest {
  /**
   * 机构id
   */
  orgId: number;
  /**
   * 部门id
   */
  departmentId: number;
  /**
   * 报销场景code
   */
  reimburseType: string;
  /**
   * 政府支出经济分类编码
   */
  govExpendEconomicClassifyCode?: string;
  /**
   * 部门支出经济分类编码
   */
  depExpendEconomicClassifyCode?: string;
  /**
   * 部门支出经济分类编码(工资发放使用)
   */
  depExpendEconomicClassifyCodes?: string[];
  /**
   * 部门经济分类名称
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 是否包含政府采购（0：不包含，1：包含）
   */
  containsGovPurchaseBudget?: number;
  /**
   * 项目 | 部门经济分类名称
   */
  projectDepName?: string;
  /**
   * 年份,默认当前年份
   */
  year?: number;
  /**
   * 报销金额(传了将过滤金额低于报销金额的额度，一般传1)
   */
  amount?: number;
  /**
   * 单据编号，用于查询已冻结的预算，重新计算可用金额；报销单业务使用
   */
  formCode?: string;
  /**
   * 关预算的键，单收款人为单据号，多收款人为payRecordCode
   */
  businessIdList?: string[];
  /**
   * 惠企利民标识 01-利民，02-惠企（新增）
   */
  toPersonEnterpriseMark?: string;
  /**
   * 预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 资金性质以什么开头
   * 单位资金传3
   */
  fundsNatureStartWith?: string;
  /**
   * 场景无关联预算时，是否返回所有预算，百搭业务返回所有预算. 暂针对企业兑付场景下, 内部设置为true, 未配置时, 可以查询全量
   */
  returnAllWhenNotHaveRelation?: boolean;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [指标列表查询，报销侧选择指标时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383522) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetQueryBudgetPostResponse {
  success?: boolean;
  result?: {
    /**
     * 预算ID
     */
    budgetId?: number;
    /**
     * 预算Uk
     */
    budgetUk?: string;
    /**
     * 内网预算详情id
     */
    financialBudgetDetailId?: string;
    /**
     * 年份
     */
    year?: number;
    /**
     * 财政区划
     */
    financialDistrictCode?: string;
    /**
     * 预算单位
     */
    orgCode?: string;
    /**
     * 部门
     */
    depId?: number;
    /**
     * 部门
     */
    depName?: string;
    /**
     * 指标文号
     */
    budgetNo?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 经济科目名称
     */
    depExpendEconomicClassifyName?: string;
    /**
     * 是否包含政府采购预算，0：否 1:是
     */
    containsGovPurchaseBudget?: number;
    /**
     * 指标金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 资金性质代码
     */
    fundsNatureCode?: string;
    /**
     * 资金性质名称
     */
    fundsNatureName?: string;
    /**
     * 支出功能分类科目名称
     */
    expendFunctionClassifySubjectName?: string;
    /**
     * 项目类别代码（3：项目支出，其它数值为基本支出）
     */
    programCategoryCode?: string;
    /**
     * 是否下级部门可用 1：是 0：否
     */
    isSubUse?: number;
    /**
     * 支出项
     */
    expenditureItem?: string;
    /**
     * * 实施金额
     */
    implementAmount?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [指标列表查询，报销侧选择指标时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383522) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetQueryBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/query-budget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [指标列表查询，报销侧选择指标时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383522) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetQueryBudgetPostRequestConfig: ZlbApiExpenseBudgetQueryBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_14,
    devUrl: devUrl_0_1_0_14,
    prodUrl: prodUrl_0_1_0_14,
    path: '/zlb/api/expense/budget/query-budget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetQueryBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [指标列表查询，报销侧选择指标时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383522) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetQueryBudgetPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetQueryBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetQueryBudgetPostResponse>(
    prepare(zlbApiExpenseBudgetQueryBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetQueryBudgetPost.requestConfig = zlbApiExpenseBudgetQueryBudgetPostRequestConfig;

/**
 * 接口 [额度列表查询，报销侧选择额度时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383530) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-quota`
 * @更新时间 `2024-12-10 17:47:55`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetQueryQuotaPostRequest {
  /**
   * 额度名称
   */
  quotaName?: string;
  /**
   * 资金性质（0：财政资金 1：自有资金）
   */
  fundsNature?: number;
  /**
   * 部门经济分类
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 报销场景code
   */
  reimburseType: string;
  /**
   * 机构id
   */
  orgId: number;
  /**
   * 部门id
   */
  departmentId: number;
  /**
   * 年份,默认当前年份
   */
  year?: number;
  /**
   * 报销金额(传了将过滤金额低于报销金额的额度，一般传1)
   */
  amount?: number;
  /**
   * 单据编号，用于查询已冻结的预算，重新计算可用金额；报销单业务使用
   */
  formCode?: string;
  /**
   * 关预算的键，单收款人为单据号，多收款人为payRecordCode
   */
  businessIdList?: string[];
}

/**
 * 接口 [额度列表查询，报销侧选择额度时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383530) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-quota`
 * @更新时间 `2024-12-10 17:47:55`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetQueryQuotaPostResponse {
  success?: boolean;
  result?: {
    /**
     * 额度id
     */
    quotaId?: string;
    /**
     * 额度名称
     */
    quotaName?: string;
    /**
     * 资金性质（0：财政资金 1：自有资金）
     */
    fundsNature?: number;
    /**
     * 资金性质名称
     */
    fundsNatureName?: string;
    /**
     * 项目类别（1：基本支出，2：项目支出）
     */
    projectCategory?: number;
    /**
     * 部门经济分类
     */
    depExpendEconomicClassifyName?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 部门id
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 额度总金额
     */
    totalAmount?: number;
    /**
     * 额度可用金额
     */
    availableAmount?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [额度列表查询，报销侧选择额度时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383530) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-quota`
 * @更新时间 `2024-12-10 17:47:55`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetQueryQuotaPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/query-quota',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [额度列表查询，报销侧选择额度时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383530) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-quota`
 * @更新时间 `2024-12-10 17:47:55`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetQueryQuotaPostRequestConfig: ZlbApiExpenseBudgetQueryQuotaPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_14,
    devUrl: devUrl_0_1_0_14,
    prodUrl: prodUrl_0_1_0_14,
    path: '/zlb/api/expense/budget/query-quota',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetQueryQuotaPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [额度列表查询，报销侧选择额度时使用↗](http://yapi.cai-inc.com/project/3621/interface/api/383530) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-quota`
 * @更新时间 `2024-12-10 17:47:55`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetQueryQuotaPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetQueryQuotaPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetQueryQuotaPostResponse>(
    prepare(zlbApiExpenseBudgetQueryQuotaPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetQueryQuotaPost.requestConfig = zlbApiExpenseBudgetQueryQuotaPostRequestConfig;

/**
 * 接口 [根据指标查支付限额↗](http://yapi.cai-inc.com/project/3621/interface/api/596522) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget-plan-classify`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetQueryBudgetPlanClassifyPostRequest {
  /**
   * 单号
   */
  formCode?: string;
  /**
   * 前端忽略
   */
  bizCodeList?: string[];
  /**
   * 指标UK
   */
  budgetUkList: string[];
}

/**
 * 接口 [根据指标查支付限额↗](http://yapi.cai-inc.com/project/3621/interface/api/596522) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget-plan-classify`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetQueryBudgetPlanClassifyPostResponse {
  success?: boolean;
  result?: {
    key?: {
      /**
       * 预算指标ID
       */
      budgetId?: number;
      /**
       * 指标部门经济UK
       */
      budgetPlanClassifyUk?: string;
      /**
       * 预算指标UK
       */
      budgetUk?: string;
      /**
       * 年份
       */
      year?: number;
      /**
       * 区划编码
       */
      financialDistrictCode?: string;
      /**
       * 一体化指标ID
       */
      financialBudgetDetailId?: string;
      /**
       * 一体化的支付限额ID(该字段区分是否为同一支付限额)
       */
      financialBudgetPlanId?: string;
      /**
       * 部门经济科目编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 部门经济科目名称
       */
      budgetPlanClassifyName?: string;
      /**
       * 支付方式编码
       */
      payModeCode?: string;
      /**
       * 支付类型编码
       */
      payTypeCode?: string;
      /**
       * 采购文号
       */
      purchaseNo?: string;
      /**
       * 是否采购1是0否
       */
      isPurchase?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
    }[];
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [根据指标查支付限额↗](http://yapi.cai-inc.com/project/3621/interface/api/596522) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget-plan-classify`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetQueryBudgetPlanClassifyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/query-budget-plan-classify',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据指标查支付限额↗](http://yapi.cai-inc.com/project/3621/interface/api/596522) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget-plan-classify`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetQueryBudgetPlanClassifyPostRequestConfig: ZlbApiExpenseBudgetQueryBudgetPlanClassifyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_14,
    devUrl: devUrl_0_1_0_14,
    prodUrl: prodUrl_0_1_0_14,
    path: '/zlb/api/expense/budget/query-budget-plan-classify',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetQueryBudgetPlanClassifyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据指标查支付限额↗](http://yapi.cai-inc.com/project/3621/interface/api/596522) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50251)
 * @请求头 `POST /zlb/api/expense/budget/query-budget-plan-classify`
 * @更新时间 `2024-12-10 17:47:54`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetQueryBudgetPlanClassifyPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetQueryBudgetPlanClassifyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetQueryBudgetPlanClassifyPostResponse>(
    prepare(zlbApiExpenseBudgetQueryBudgetPlanClassifyPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetQueryBudgetPlanClassifyPost.requestConfig =
  zlbApiExpenseBudgetQueryBudgetPlanClassifyPostRequestConfig;

const mockUrl_0_1_0_15 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_15 = '' as any;
const prodUrl_0_1_0_15 = '' as any;
const dataKey_0_1_0_15 = 'data' as any;

/**
 * 接口 [删除我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383890) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `PUT /zlb/api/expense/fee/delete/{feeCode}`
 * @更新时间 `2024-09-26 14:35:21`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeDeleteFeeCodePutRequest {
  /**
   * 删除费用code
   */
  feeCode: string;
}

/**
 * 接口 [删除我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383890) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `PUT /zlb/api/expense/fee/delete/{feeCode}`
 * @更新时间 `2024-09-26 14:35:21`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeDeleteFeeCodePutResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383890) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `PUT /zlb/api/expense/fee/delete/{feeCode}`
 * @更新时间 `2024-09-26 14:35:21`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeDeleteFeeCodePutRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/delete/{feeCode}',
    'data',
    'feeCode',
    string,
    false
  >
>;

/**
 * 接口 [删除我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383890) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `PUT /zlb/api/expense/fee/delete/{feeCode}`
 * @更新时间 `2024-09-26 14:35:21`
 * @项目ID 3621
 */
const zlbApiExpenseFeeDeleteFeeCodePutRequestConfig: ZlbApiExpenseFeeDeleteFeeCodePutRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/delete/{feeCode}',
    method: Method.PUT,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: ['feeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeDeleteFeeCodePut',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383890) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `PUT /zlb/api/expense/fee/delete/{feeCode}`
 * @更新时间 `2024-09-26 14:35:21`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeDeleteFeeCodePut = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeDeleteFeeCodePutRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeDeleteFeeCodePutResponse>(
    prepare(zlbApiExpenseFeeDeleteFeeCodePutRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeDeleteFeeCodePut.requestConfig = zlbApiExpenseFeeDeleteFeeCodePutRequestConfig;

/**
 * 接口 [修改费用金额↗](http://yapi.cai-inc.com/project/3621/interface/api/383898) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/updateFeeAmount`
 * @更新时间 `2024-02-26 09:45:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeUpdateFeeAmountPostRequest {
  /**
   * 批量修改历史记录
   */
  modifyFeeAmountPOList: {
    /**
     * 费用code
     */
    feeCode: string;
    /**
     * 原始金额
     */
    originalAmount?: number;
    /**
     * 修改后金额
     */
    updateAmount?: number;
    /**
     * 修改备注
     */
    remark?: string;
  }[];
}

/**
 * 接口 [修改费用金额↗](http://yapi.cai-inc.com/project/3621/interface/api/383898) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/updateFeeAmount`
 * @更新时间 `2024-02-26 09:45:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeUpdateFeeAmountPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [修改费用金额↗](http://yapi.cai-inc.com/project/3621/interface/api/383898) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/updateFeeAmount`
 * @更新时间 `2024-02-26 09:45:22`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeUpdateFeeAmountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/updateFeeAmount',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [修改费用金额↗](http://yapi.cai-inc.com/project/3621/interface/api/383898) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/updateFeeAmount`
 * @更新时间 `2024-02-26 09:45:22`
 * @项目ID 3621
 */
const zlbApiExpenseFeeUpdateFeeAmountPostRequestConfig: ZlbApiExpenseFeeUpdateFeeAmountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/updateFeeAmount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeUpdateFeeAmountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [修改费用金额↗](http://yapi.cai-inc.com/project/3621/interface/api/383898) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/updateFeeAmount`
 * @更新时间 `2024-02-26 09:45:22`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeUpdateFeeAmountPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeUpdateFeeAmountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeUpdateFeeAmountPostResponse>(
    prepare(zlbApiExpenseFeeUpdateFeeAmountPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeUpdateFeeAmountPost.requestConfig =
  zlbApiExpenseFeeUpdateFeeAmountPostRequestConfig;

/**
 * 接口 [查询我的费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/383906) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/records`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordsPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 费用类型
   */
  feeTypeLists?: number[];
  /**
   * 开始时间
   */
  startTime?: string;
  /**
   * 结束时间
   */
  endTime?: string;
  /**
   * 费用状态
   */
  feeSatusLists?: number[];
}

/**
 * 接口 [查询我的费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/383906) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/records`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordsPostResponse {
  success?: boolean;
  result?: {
    total?: number;
    data?: {
      /**
       * 费用code
       */
      feeCode?: string;
      /**
       * 费用名称
       */
      feeName?: string;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 费用类型
       */
      feeType: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用发生时间
       */
      consumeTime?: string;
      /**
       * 费用发生时间
       */
      consumeTimeDesc?: string;
      /**
       * 货币金额
       */
      amount: number;
      /**
       * 允许的最大金额
       */
      allowMaxAmount?: number;
      /**
       * 消费城市区划
       */
      districtCode?: string;
      /**
       * 消费城市三级区划code
       */
      allDistrictCodes?: string[];
      /**
       * 消费城市名称
       */
      districtName?: string;
      /**
       * 消费城市三级区划名称
       */
      allDistrictNames?: string[];
      /**
       * 关联的发票编号
       */
      invoiceCodes?: string[];
      /**
       * 关联发票的url
       */
      imageUrl?: string;
      /**
       * 浙里半票的url
       */
      zlbImageUrl?: string;
      /**
       * 关联的出差人
       */
      accompanyPerson?: {
        /**
         * 人员id
         */
        operatorId: number;
        /**
         * 人员名称
         */
        operatorName: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
         */
        userType?: number;
        userId?: number;
        userName?: string;
        bankCardInfo?: {
          /**
           * 银行代码
           */
          bankCode: string;
          /**
           * 银行名字
           */
          bankName: string;
          /**
           * 账户名称
           */
          accountName: string;
          /**
           * 银行账号
           */
          bankAccount: string;
          /**
           * 银行账号 脱敏
           */
          bankAccountDesc?: string;
          /**
           * 卡号保存的唯一标识
           */
          accountCode?: string;
        };
        /**
         * 同一个人员，绑定的id
         */
        bindOperatorId?: number;
        /**
         * 用户类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type: number;
        /**
         * 用户职级,
         * 内部用户的职级，外部用户关联内部用户，取内部用户职级
         * 否则去外部用户职级
         */
        userRank?: string;
        /**
         * 手机号
         */
        mobile?: string;
        /**
         * 证件号码
         */
        idCard?: string;
        /**
         * 证件类型
         */
        idType?: number;
        /**
         * 性别
         */
        gender?: number;
        /**
         * 同行人费用code
         */
        feeCode?: string;
      }[];
      /**
       * 出差人
       */
      travelerName?: {
        /**
         * 人员id
         */
        operatorId: number;
        /**
         * 人员名称
         */
        operatorName: string;
        /**
         * 机构id
         */
        institutionId?: number;
        /**
         * 机构名称
         */
        institutionName?: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
         */
        userType?: number;
        userId?: number;
        userName?: string;
        bankCardInfo?: {
          /**
           * 银行代码
           */
          bankCode: string;
          /**
           * 银行名字
           */
          bankName: string;
          /**
           * 账户名称
           */
          accountName: string;
          /**
           * 银行账号
           */
          bankAccount: string;
          /**
           * 银行账号 脱敏
           */
          bankAccountDesc?: string;
          /**
           * 卡号保存的唯一标识
           */
          accountCode?: string;
        };
        /**
         * 同一个人员，绑定的id
         */
        bindOperatorId?: number;
        /**
         * 用户类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type: number;
        /**
         * 用户职级,
         * 内部用户的职级，外部用户关联内部用户，取内部用户职级
         * 否则去外部用户职级
         */
        userRank?: string;
        /**
         * 手机号
         */
        mobile?: string;
        /**
         * 证件号码
         */
        idCard?: string;
        /**
         * 证件类型
         */
        idType?: number;
        /**
         * 性别
         */
        gender?: number;
        /**
         * 同行人费用code
         */
        feeCode?: string;
      }[];
      /**
       * 材料数据
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
      /**
       * 费用附件
       */
      attachments?: {
        fileId: string;
        fileType?: string;
        fileName: string;
        fileSize?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        downloadUrl?: string;
      }[];
      /**
       * 关联的报销单号
       */
      expenseFormCode?: string;
      /**
       * 费用状态描述
       */
      feeStatusDesc?: string;
      /**
       * 费用状态
       */
      feeStatus?: number;
      /**
       * 是否删除
       */
      canDelete?: boolean;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 发票是否验真
       */
      invoiceIsCheck?: boolean;
      /**
       * 发票验真描述
       */
      invoiceIsCheckDesc?: string;
      /**
       * 时长
       */
      travelDay?: number;
      /**
       * 时长描述
       */
      travelDayDesc?: string;
      /**
       * 是否费用有修改
       */
      feeModifyStatus?: boolean;
      /**
       * 费用调整记录
       */
      feeModifyRecordROS?: {
        /**
         * 原金额
         */
        originalAmount?: number;
        /**
         * 调整原因
         */
        updateReason?: string;
        /**
         * 更新人名字
         */
        updateOperatorName?: string;
        /**
         * 调整后金额
         */
        updateAmount?: number;
        /**
         * 调整时间
         */
        updateTime?: number;
      }[];
      /**
       * 打印时使用的fileId
       */
      printFileId?: string;
      /**
       * 费用备注
       */
      remark?: string;
      /**
       * 发票附件类型
       */
      attachmentMimeType?: string;
      /**
       * 发票状态
       */
      realStatus?: number;
      /**
       * 发票状态描述
       */
      realStatusDesc?: string;
      /**
       * 详细扩展信息
       */
      detailExtendDTO?: {
        /**
         * 详细列表页
         */
        expenseFeeDetailInfoList?: {
          /**
           * 前端需要参数
           */
          indexNo?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          userType?: number;
          type?: number;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 原始信息（当前补贴）
           */
          originalInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
          /**
           * 重复补贴
           */
          conflictInfoList?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          }[];
          /**
           * 费用种类
           */
          feeCategory?: number;
          /**
           * 实际补贴金额
           */
          amount?: number;
          /**
           * 原始计算金额
           */
          originalAmount?: number;
          /**
           * 调整前金额
           */
          beforeChangeAmount?: number;
          /**
           * 冲突的金额
           */
          conflictAmount?: number;
          /**
           * 扣减金额
           */
          reductionAmount?: number;
          /**
           * 最大允许金额
           */
          allowMaxAmount?: number;
          /**
           * 备注
           */
          remark?: string;
          /**
           * 是否发生变更
           */
          isChanged?: boolean;
        }[];
        /**
         * 冲突展示列表页
         */
        expenseFeeConflictList?: {
          /**
           * 业务编码
           */
          businessCode?: string;
          /**
           * 单据编号
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: number;
          /**
           * 业务类型
           */
          businessType?: number;
          /**
           * 业务类型描述
           */
          businessTypeDesc?: string;
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 冲突信息
           */
          conflictInfo?: {
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 金额
             */
            amount?: number;
            /**
             * 区划code
             */
            districtCode?: string;
            /**
             * 区划名称
             */
            districtName?: string;
            /**
             * 是否派车
             */
            arrangeCar?: boolean;
            /**
             * 省内
             */
            innerProvince?: boolean;
            /**
             * 冲突业务编码
             */
            businessCode?: string;
            /**
             * 冲突单据编号
             */
            formCode?: string;
            /**
             * 冲突业务类型
             */
            businessType?: number;
            /**
             * 冲突业务类型描述
             */
            businessTypeDesc?: number;
            /**
             * 凭票报销
             */
            useInvoice?: boolean;
            /**
             * 扣减百分比
             */
            deductionPercent?: number;
            /**
             * 开启休息日扣减
             */
            enableRestDayDeduction?: boolean;
          };
        }[];
        /**
         * 调整后金额
         */
        currentAmount?: number;
        /**
         * 原始金额
         */
        originalAmount?: number;
        /**
         * 费用类型
         */
        feeType?: number;
        /**
         * 火车金额
         */
        trainAmount?: number;
        /**
         * 总金额相等
         */
        totalAmountEquals?: boolean;
      };
      /**
       * 是否有版式文件
       */
      hasFormatFile?: boolean;
      amountDesc?: string;
      beginCity?: string;
      endCity?: string;
      /**
       * 由于beginCity endCity 在票据设置时使用，不清楚具体用来干啥，故不动他
       * 新增 printBeginCity printEndCity
       * 费用代码要优化了，现在掺杂了很多业务
       */
      printBeginCity?: string;
      printEndCity?: string;
      departureTime?: string;
      /**
       * 招待人数
       */
      entertainPeopleNumDesc?: string;
      /**
       * 招待时间
       */
      entertainDateDesc?: string;
      /**
       * 住宿天数
       */
      accommodationDaysDesc?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询我的费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/383906) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/records`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeRecordsPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/records',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询我的费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/383906) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/records`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
const zlbApiExpenseFeeRecordsPostRequestConfig: ZlbApiExpenseFeeRecordsPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/records',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeRecordsPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询我的费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/383906) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/records`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeRecordsPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeRecordsPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeRecordsPostResponse>(
    prepare(zlbApiExpenseFeeRecordsPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeRecordsPost.requestConfig = zlbApiExpenseFeeRecordsPostRequestConfig;

/**
 * 接口 [我的费用详情↗](http://yapi.cai-inc.com/project/3621/interface/api/383914) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/detail/{feeCode}`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordDetailFeeCodeGetRequest {
  /**
   * 费用code
   */
  feeCode: string;
}

/**
 * 接口 [我的费用详情↗](http://yapi.cai-inc.com/project/3621/interface/api/383914) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/detail/{feeCode}`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordDetailFeeCodeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType?: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用名称
     */
    feeName?: string;
    /**
     * 费用发生时间
     */
    consumeTime?: string;
    /**
     * 货币代码
     */
    currencyCode?: string;
    /**
     * 货币金额
     */
    amount?: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCode?: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments?: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的报销单号
     */
    expenseFormCode?: string;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 发票状态
     */
    realStatus?: number;
    /**
     * 发票状态描述
     */
    realStatusDesc?: string;
    /**
     * 是否可以修改金额
     * 默认是可以修改
     */
    canChangeAmount?: boolean;
    /**
     * 费用信息是否已完善
     * true-已完善，false-未完善
     */
    feeInfoComplete?: boolean;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [我的费用详情↗](http://yapi.cai-inc.com/project/3621/interface/api/383914) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/detail/{feeCode}`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeRecordDetailFeeCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/record/detail/{feeCode}',
    'data',
    'feeCode',
    string,
    false
  >
>;

/**
 * 接口 [我的费用详情↗](http://yapi.cai-inc.com/project/3621/interface/api/383914) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/detail/{feeCode}`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
const zlbApiExpenseFeeRecordDetailFeeCodeGetRequestConfig: ZlbApiExpenseFeeRecordDetailFeeCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/record/detail/{feeCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: ['feeCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeRecordDetailFeeCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [我的费用详情↗](http://yapi.cai-inc.com/project/3621/interface/api/383914) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/detail/{feeCode}`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeRecordDetailFeeCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeRecordDetailFeeCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeRecordDetailFeeCodeGetResponse>(
    prepare(zlbApiExpenseFeeRecordDetailFeeCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeRecordDetailFeeCodeGet.requestConfig =
  zlbApiExpenseFeeRecordDetailFeeCodeGetRequestConfig;

/**
 * 接口 [根据行程信息自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383922) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByRecord`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordGenByRecordPostRequest {
  /**
   * 行程信息
   */
  itineraryPOS?: {
    /**
     * 前端生成的编号
     */
    indexNo?: string;
    /**
     * 行程单编号
     * 更新时必填
     */
    itineraryCode?: string;
    /**
     * 原行程单号
     */
    originalItineraryCode?: string;
    /**
     * 出差人列表
     */
    accompanyList: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 开始上下午
     */
    beginTag: number;
    /**
     * 结束时间
     */
    endTime: string;
    /**
     * 结束上下午
     */
    endTag: number;
    /**
     * 出差天数
     */
    travelDay: number;
    /**
     * 是否派车 0不派车 1派车
     */
    arrangeCar: number;
    /**
     * 派车信息
     */
    arrangeCarPO?: {
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag: number;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag: number;
      /**
       * 派车天数
       */
      arrangeCarDay: number;
      /**
       * 乘车人
       */
      passengerList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
    };
    /**
     * 出发城市code
     */
    beginCityCode: string;
    /**
     * 出发城市名称
     */
    beginCityName: string;
    /**
     * 目的城市列表
     */
    endCityList: {
      /**
       * 目的城市code
       */
      endCityCode: string;
      /**
       * 目的城市名称
       */
      endCityName: string;
    }[];
    /**
     * 住宿天数
     */
    accommodationDay: number;
  }[];
  /**
   * 会议类型
   */
  tripType?: number;
  /**
   * 火车费用信息
   */
  trainFeePOS?: {
    /**
     * 唯一标识
     */
    indexNo: string;
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 记录的费用名称，用于自定义
     */
    feeName?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType: number;
    /**
     * 费用发生时间
     */
    consumeTime: string;
    /**
     * 货币金额
     */
    amount: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCodes: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的单号
     */
    formCode?: string;
    /**
     * 单据类型：1-申请单，2-报销单
     */
    formType?: number;
    /**
     * 修改金额历史
     */
    modifyFeeAmountDTO?: {
      /**
       * 原始金额
       */
      originalAmount: number;
      /**
       * 修改后金额
       */
      updateAmount: number;
      /**
       * 修改备注
       */
      updateReason?: string;
      /**
       * 原始账户
       */
      originalAccount?: string;
      /**
       * 修改后账户
       */
      updateAccount?: string;
    };
    /**
     * 原始的feeRecordId
     */
    originalFeeId?: number;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 明细说明
     */
    remark?: string;
    /**
     * 明细数据
     */
    detailExtendDTO?: {
      /**
       * 详细列表页
       */
      expenseFeeDetailInfoList?: {
        /**
         * 前端需要参数
         */
        indexNo?: string;
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
        /**
         * 人员来源 1-系统内部；2-外部人员
         */
        userSource?: 1 | 2;
        userType?: number;
        type?: number;
        /**
         * 日期
         */
        date?: string;
        /**
         * 日期描述
         */
        dateDesc?: string;
        /**
         * 原始信息（当前补贴）
         */
        originalInfo?: {
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 区划code
           */
          districtCode?: string;
          /**
           * 区划名称
           */
          districtName?: string;
          /**
           * 是否派车
           */
          arrangeCar?: boolean;
          /**
           * 省内
           */
          innerProvince?: boolean;
          /**
           * 冲突业务编码
           */
          businessCode?: string;
          /**
           * 冲突单据编号
           */
          formCode?: string;
          /**
           * 冲突业务类型
           */
          businessType?: number;
          /**
           * 冲突业务类型描述
           */
          businessTypeDesc?: number;
          /**
           * 凭票报销
           */
          useInvoice?: boolean;
          /**
           * 扣减百分比
           */
          deductionPercent?: number;
          /**
           * 开启休息日扣减
           */
          enableRestDayDeduction?: boolean;
        };
        /**
         * 重复补贴
         */
        conflictInfoList?: {
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 区划code
           */
          districtCode?: string;
          /**
           * 区划名称
           */
          districtName?: string;
          /**
           * 是否派车
           */
          arrangeCar?: boolean;
          /**
           * 省内
           */
          innerProvince?: boolean;
          /**
           * 冲突业务编码
           */
          businessCode?: string;
          /**
           * 冲突单据编号
           */
          formCode?: string;
          /**
           * 冲突业务类型
           */
          businessType?: number;
          /**
           * 冲突业务类型描述
           */
          businessTypeDesc?: number;
          /**
           * 凭票报销
           */
          useInvoice?: boolean;
          /**
           * 扣减百分比
           */
          deductionPercent?: number;
          /**
           * 开启休息日扣减
           */
          enableRestDayDeduction?: boolean;
        }[];
        /**
         * 费用种类
         */
        feeCategory?: number;
        /**
         * 实际补贴金额
         */
        amount?: number;
        /**
         * 原始计算金额
         */
        originalAmount?: number;
        /**
         * 调整前金额
         */
        beforeChangeAmount?: number;
        /**
         * 冲突的金额
         */
        conflictAmount?: number;
        /**
         * 扣减金额
         */
        reductionAmount?: number;
        /**
         * 最大允许金额
         */
        allowMaxAmount?: number;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否发生变更
         */
        isChanged?: boolean;
      }[];
      /**
       * 冲突展示列表页
       */
      expenseFeeConflictList?: {
        /**
         * 业务编码
         */
        businessCode?: string;
        /**
         * 单据编号
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: number;
        /**
         * 业务类型
         */
        businessType?: number;
        /**
         * 业务类型描述
         */
        businessTypeDesc?: string;
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
        /**
         * 日期
         */
        date?: string;
        /**
         * 日期描述
         */
        dateDesc?: string;
        /**
         * 冲突信息
         */
        conflictInfo?: {
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 区划code
           */
          districtCode?: string;
          /**
           * 区划名称
           */
          districtName?: string;
          /**
           * 是否派车
           */
          arrangeCar?: boolean;
          /**
           * 省内
           */
          innerProvince?: boolean;
          /**
           * 冲突业务编码
           */
          businessCode?: string;
          /**
           * 冲突单据编号
           */
          formCode?: string;
          /**
           * 冲突业务类型
           */
          businessType?: number;
          /**
           * 冲突业务类型描述
           */
          businessTypeDesc?: number;
          /**
           * 凭票报销
           */
          useInvoice?: boolean;
          /**
           * 扣减百分比
           */
          deductionPercent?: number;
          /**
           * 开启休息日扣减
           */
          enableRestDayDeduction?: boolean;
        };
      }[];
      /**
       * 调整后金额
       */
      currentAmount?: number;
      /**
       * 原始金额
       */
      originalAmount?: number;
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 火车金额
       */
      trainAmount?: number;
      /**
       * 总金额相等
       */
      totalAmountEquals?: boolean;
    };
    /**
     * 交易信息编码 for 会议培训多收款人
     */
    tradeCode?: string;
  }[];
  /**
   * 单据code,本次调用的报销单code
   */
  formCode?: string;
  /**
   * 所有的费用列表
   */
  expenseFeePOList?: {
    /**
     * 唯一标识
     */
    indexNo: string;
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 记录的费用名称，用于自定义
     */
    feeName?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType: number;
    /**
     * 费用发生时间
     */
    consumeTime: string;
    /**
     * 货币金额
     */
    amount: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCodes: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的单号
     */
    formCode?: string;
    /**
     * 单据类型：1-申请单，2-报销单
     */
    formType?: number;
    /**
     * 修改金额历史
     */
    modifyFeeAmountDTO?: {
      /**
       * 原始金额
       */
      originalAmount: number;
      /**
       * 修改后金额
       */
      updateAmount: number;
      /**
       * 修改备注
       */
      updateReason?: string;
      /**
       * 原始账户
       */
      originalAccount?: string;
      /**
       * 修改后账户
       */
      updateAccount?: string;
    };
    /**
     * 原始的feeRecordId
     */
    originalFeeId?: number;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 明细说明
     */
    remark?: string;
    /**
     * 明细数据
     */
    detailExtendDTO?: {
      /**
       * 详细列表页
       */
      expenseFeeDetailInfoList?: {
        /**
         * 前端需要参数
         */
        indexNo?: string;
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
        /**
         * 人员来源 1-系统内部；2-外部人员
         */
        userSource?: 1 | 2;
        userType?: number;
        type?: number;
        /**
         * 日期
         */
        date?: string;
        /**
         * 日期描述
         */
        dateDesc?: string;
        /**
         * 原始信息（当前补贴）
         */
        originalInfo?: {
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 区划code
           */
          districtCode?: string;
          /**
           * 区划名称
           */
          districtName?: string;
          /**
           * 是否派车
           */
          arrangeCar?: boolean;
          /**
           * 省内
           */
          innerProvince?: boolean;
          /**
           * 冲突业务编码
           */
          businessCode?: string;
          /**
           * 冲突单据编号
           */
          formCode?: string;
          /**
           * 冲突业务类型
           */
          businessType?: number;
          /**
           * 冲突业务类型描述
           */
          businessTypeDesc?: number;
          /**
           * 凭票报销
           */
          useInvoice?: boolean;
          /**
           * 扣减百分比
           */
          deductionPercent?: number;
          /**
           * 开启休息日扣减
           */
          enableRestDayDeduction?: boolean;
        };
        /**
         * 重复补贴
         */
        conflictInfoList?: {
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 区划code
           */
          districtCode?: string;
          /**
           * 区划名称
           */
          districtName?: string;
          /**
           * 是否派车
           */
          arrangeCar?: boolean;
          /**
           * 省内
           */
          innerProvince?: boolean;
          /**
           * 冲突业务编码
           */
          businessCode?: string;
          /**
           * 冲突单据编号
           */
          formCode?: string;
          /**
           * 冲突业务类型
           */
          businessType?: number;
          /**
           * 冲突业务类型描述
           */
          businessTypeDesc?: number;
          /**
           * 凭票报销
           */
          useInvoice?: boolean;
          /**
           * 扣减百分比
           */
          deductionPercent?: number;
          /**
           * 开启休息日扣减
           */
          enableRestDayDeduction?: boolean;
        }[];
        /**
         * 费用种类
         */
        feeCategory?: number;
        /**
         * 实际补贴金额
         */
        amount?: number;
        /**
         * 原始计算金额
         */
        originalAmount?: number;
        /**
         * 调整前金额
         */
        beforeChangeAmount?: number;
        /**
         * 冲突的金额
         */
        conflictAmount?: number;
        /**
         * 扣减金额
         */
        reductionAmount?: number;
        /**
         * 最大允许金额
         */
        allowMaxAmount?: number;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否发生变更
         */
        isChanged?: boolean;
      }[];
      /**
       * 冲突展示列表页
       */
      expenseFeeConflictList?: {
        /**
         * 业务编码
         */
        businessCode?: string;
        /**
         * 单据编号
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: number;
        /**
         * 业务类型
         */
        businessType?: number;
        /**
         * 业务类型描述
         */
        businessTypeDesc?: string;
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
        /**
         * 日期
         */
        date?: string;
        /**
         * 日期描述
         */
        dateDesc?: string;
        /**
         * 冲突信息
         */
        conflictInfo?: {
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 区划code
           */
          districtCode?: string;
          /**
           * 区划名称
           */
          districtName?: string;
          /**
           * 是否派车
           */
          arrangeCar?: boolean;
          /**
           * 省内
           */
          innerProvince?: boolean;
          /**
           * 冲突业务编码
           */
          businessCode?: string;
          /**
           * 冲突单据编号
           */
          formCode?: string;
          /**
           * 冲突业务类型
           */
          businessType?: number;
          /**
           * 冲突业务类型描述
           */
          businessTypeDesc?: number;
          /**
           * 凭票报销
           */
          useInvoice?: boolean;
          /**
           * 扣减百分比
           */
          deductionPercent?: number;
          /**
           * 开启休息日扣减
           */
          enableRestDayDeduction?: boolean;
        };
      }[];
      /**
       * 调整后金额
       */
      currentAmount?: number;
      /**
       * 原始金额
       */
      originalAmount?: number;
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 火车金额
       */
      trainAmount?: number;
      /**
       * 总金额相等
       */
      totalAmountEquals?: boolean;
    };
    /**
     * 交易信息编码 for 会议培训多收款人
     */
    tradeCode?: string;
  }[];
}

/**
 * 接口 [根据行程信息自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383922) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByRecord`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordGenByRecordPostResponse {
  success?: boolean;
  result?: {
    /**
     * 伙食补贴
     */
    allowanceEat?: {
      /**
       * 费用父级code
       */
      feeParentType?: number;
      /**
       * 费用父级描述
       */
      feeParentTypeDesc?: string;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 货币金额
       */
      totalAmount?: number;
      /**
       * 每个人的费用
       */
      expenseFeeGenPersonROList?: {
        /**
         * 费用类型
         */
        feeType?: number;
        /**
         * 费用类型描述
         */
        feeTypeDesc?: string;
        /**
         * 用户id
         */
        operatorId?: number;
        /**
         * 陪同人员
         */
        accompanyPerson?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 用户名称
         */
        operatorName?: string;
        /**
         * 时长
         */
        travelDay?: number;
        /**
         * 时长描述
         */
        travelDayDesc?: string;
        /**
         * 费用金额
         */
        amount?: number;
        /**
         * 货币编码
         */
        currencyCode?: string;
        /**
         * 相关材料信息
         */
        materialInfo?: {
          /**
           * 凭票报销伙食类补贴信息
           */
          allowanceMaterialByInvoiceDTO?: {
            /**
             * 关联行程编号
             */
            associateItineraryList: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
            }[];
            /**
             * 补贴发生日期
             */
            allowanceHappenDates: string[];
            /**
             * 城市名称s(无用，纯属兼容前端，别删除)
             */
            endCityName?: string;
          };
          /**
           * 住宿类材料信息
           */
          hotelMaterialDTO?: {
            /**
             * 酒店入住开始时间
             */
            hotelEnterTime?: string;
            /**
             * 酒店入住结束时间
             */
            hotelLeaveTime?: string;
            /**
             * 住宿天数
             */
            accommodationDays?: number;
          };
          /**
           * 交通类材料信息
           */
          trafficMaterialDTO?: {
            /**
             * 座位类别
             */
            seatType?: number;
            /**
             * 座位枚举描述
             */
            seatDesc?: string;
            /**
             * 出发地区划code
             */
            fromDistrictCode: string;
            /**
             * 出发地区划名称
             */
            fromDistrictName: string;
            /**
             * 结束地区划code
             */
            endDistrictCode: string;
            /**
             * 结束地区划名称
             */
            endDistrictName: string;
            /**
             * 火车时长码
             */
            trainDurationCode?: number;
            /**
             * 火车时长
             */
            trainDurationDesc?: string;
            /**
             * 出发日期
             */
            departureTime: string;
            /**
             * 公里数
             */
            mileage: number;
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
          };
          /**
           * 补贴类材料
           */
          allowanceMaterialDTO?: {
            /**
             * 总的费用金额
             */
            totalAmount?: number;
            /**
             * 费用标准细项
             */
            itemList?: {
              /**
               * 标准金额
               */
              standardAmount?: number;
              /**
               * 时间-天数
               */
              days?: number;
              /**
               * 费用描述
               */
              ruleDesc?: string;
            }[];
            /**
             * 火车补贴伙食费用细项
             */
            trainAllowanceMaterialDTOS?: {
              /**
               * 火车天数
               */
              trainHours?: number;
              /**
               * 火车补贴金额
               */
              trainStanardAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 用户ID
               */
              operatorId?: number;
              /**
               * 人员来源 1-系统内部；2-外部人员
               */
              userSource?: 1 | 2;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
            }[];
            /**
             * 火车总额度
             */
            trainTotalAmount?: number;
            /**
             * 是否派车
             */
            isCar?: boolean;
            /**
             * 派车铺贴计算
             */
            carAllowanceMaterialDTOS?: {
              /**
               * 派车天数
               */
              carDays?: number;
              /**
               * 派车金额
               */
              carStandardtotalAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
            }[];
          };
          /**
           * 通用类材料信息
           */
          meetingOrTrainMaterialDTO?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 会议类型
             */
            meetingType?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
            /**
             * 培训人员
             */
            trainingPerson?: string;
            /**
             * 培训人员职级
             */
            trainingPersonLevel?: number;
            /**
             * 培训人员职级
             */
            trainingPersonLevelDesc?: string;
            /**
             * 培训时长
             */
            trainingHour?: number;
          };
          /**
           * 业务招待材料信息
           */
          businessEntertainingMaterial?: {
            /**
             * 招待日期
             */
            entertainDate?: string;
            /**
             * 招待形式
             */
            entertainForm: 1 | 2 | 3;
            /**
             * 招待形式描述
             */
            entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
            /**
             * 招待人数
             */
            entertainPeopleNum: number;
            /**
             * 招待事由
             */
            entertainReason: string;
          };
          /**
           * 交通费-租车费材料信息
           */
          rentCarFeeMaterial?: {
            /**
             * 租车申请单信息
             */
            rentCarApplyForm?: {
              /**
               * 业务单据号
               */
              businessNo?: string;
              /**
               * 申请编号
               */
              applyFormCode?: string;
              /**
               * 用车人（前端回显）
               */
              carUserList?: {
                /**
                 * 人员id
                 */
                operatorId: number;
                /**
                 * 人员名称
                 */
                operatorName: string;
                /**
                 * 机构id
                 */
                institutionId?: number;
                /**
                 * 机构名称
                 */
                institutionName?: string;
                /**
                 * 外部人员职级
                 * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
                 */
                outerUserRank?: number;
                /**
                 * 人员类型
                 * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
                 */
                userType?: number;
                userId?: number;
                userName?: string;
                bankCardInfo?: {
                  /**
                   * 银行代码
                   */
                  bankCode: string;
                  /**
                   * 银行名字
                   */
                  bankName: string;
                  /**
                   * 账户名称
                   */
                  accountName: string;
                  /**
                   * 银行账号
                   */
                  bankAccount: string;
                  /**
                   * 银行账号 脱敏
                   */
                  bankAccountDesc?: string;
                  /**
                   * 卡号保存的唯一标识
                   */
                  accountCode?: string;
                };
                /**
                 * 同一个人员，绑定的id
                 */
                bindOperatorId?: number;
                /**
                 * 用户类型
                 * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
                 */
                type: number;
                /**
                 * 用户职级,
                 * 内部用户的职级，外部用户关联内部用户，取内部用户职级
                 * 否则去外部用户职级
                 */
                userRank?: string;
                /**
                 * 手机号
                 */
                mobile?: string;
                /**
                 * 证件号码
                 */
                idCard?: string;
                /**
                 * 证件类型
                 */
                idType?: number;
                /**
                 * 性别
                 */
                gender?: number;
                /**
                 * 同行人费用code
                 */
                feeCode?: string;
              }[];
              /**
               * 预计金额（前端回显）
               */
              planAmount?: number;
              /**
               * 申请事由（前端回显）
               */
              applyReason?: string;
              /**
               * 经办人名称（前端回显）
               */
              operatorName?: string;
              /**
               * 目的地列表（前端回显）
               */
              endCityList?: {
                /**
                 * 目的城市code
                 */
                endCityCode: string;
                /**
                 * 目的城市名称
                 */
                endCityName: string;
              }[];
            }[];
            /**
             * 目的地
             */
            destination?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
            /**
             * 消费日期
             */
            consumeDate?: string[];
          };
          /**
           * 基础行程类信息
           */
          batchItineraryMaterialDTO?: {
            /**
             * 行程基本信息
             */
            itineraryMaterialDTOList?: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
              /**
               * 起始区划code
               */
              startDistrictCode: string;
              /**
               * 出发地名称
               */
              startDistrictName?: string;
              /**
               * 结束区划code
               */
              endDistrictCode: string;
              /**
               * 结束地点名称
               */
              endDistrictName?: string;
              /**
               * 人数
               */
              operatorIds?: number[];
            }[];
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
            /**
             * 人数
             */
            operatorIds?: number[];
          };
          /**
           * 修改备注
           */
          remark?: string;
          /**
           * 费用说明
           */
          feeDesc?: string;
          /**
           * 是否多票
           */
          multiInvoice?: boolean;
          /**
           * 关联的单据的编号
           */
          associateFormList?: {
            /**
             * 单据code
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: string;
          }[];
        };
        /**
         * 详细信息
         */
        detailExtendDTO?: {
          /**
           * 详细列表页
           */
          expenseFeeDetailInfoList?: {
            /**
             * 前端需要参数
             */
            indexNo?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            userType?: number;
            type?: number;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 原始信息（当前补贴）
             */
            originalInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
            /**
             * 重复补贴
             */
            conflictInfoList?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            }[];
            /**
             * 费用种类
             */
            feeCategory?: number;
            /**
             * 实际补贴金额
             */
            amount?: number;
            /**
             * 原始计算金额
             */
            originalAmount?: number;
            /**
             * 调整前金额
             */
            beforeChangeAmount?: number;
            /**
             * 冲突的金额
             */
            conflictAmount?: number;
            /**
             * 扣减金额
             */
            reductionAmount?: number;
            /**
             * 最大允许金额
             */
            allowMaxAmount?: number;
            /**
             * 备注
             */
            remark?: string;
            /**
             * 是否发生变更
             */
            isChanged?: boolean;
          }[];
          /**
           * 冲突展示列表页
           */
          expenseFeeConflictList?: {
            /**
             * 业务编码
             */
            businessCode?: string;
            /**
             * 单据编号
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: number;
            /**
             * 业务类型
             */
            businessType?: number;
            /**
             * 业务类型描述
             */
            businessTypeDesc?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 冲突信息
             */
            conflictInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
          }[];
          /**
           * 调整后金额
           */
          currentAmount?: number;
          /**
           * 原始金额
           */
          originalAmount?: number;
          /**
           * 费用类型
           */
          feeType?: number;
          /**
           * 火车金额
           */
          trainAmount?: number;
          /**
           * 总金额相等
           */
          totalAmountEquals?: boolean;
        };
        userType?: number;
      }[];
    };
    /**
     * 公杂补贴
     */
    allowanceIncidental?: {
      /**
       * 费用父级code
       */
      feeParentType?: number;
      /**
       * 费用父级描述
       */
      feeParentTypeDesc?: string;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 货币金额
       */
      totalAmount?: number;
      /**
       * 每个人的费用
       */
      expenseFeeGenPersonROList?: {
        /**
         * 费用类型
         */
        feeType?: number;
        /**
         * 费用类型描述
         */
        feeTypeDesc?: string;
        /**
         * 用户id
         */
        operatorId?: number;
        /**
         * 陪同人员
         */
        accompanyPerson?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 用户名称
         */
        operatorName?: string;
        /**
         * 时长
         */
        travelDay?: number;
        /**
         * 时长描述
         */
        travelDayDesc?: string;
        /**
         * 费用金额
         */
        amount?: number;
        /**
         * 货币编码
         */
        currencyCode?: string;
        /**
         * 相关材料信息
         */
        materialInfo?: {
          /**
           * 凭票报销伙食类补贴信息
           */
          allowanceMaterialByInvoiceDTO?: {
            /**
             * 关联行程编号
             */
            associateItineraryList: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
            }[];
            /**
             * 补贴发生日期
             */
            allowanceHappenDates: string[];
            /**
             * 城市名称s(无用，纯属兼容前端，别删除)
             */
            endCityName?: string;
          };
          /**
           * 住宿类材料信息
           */
          hotelMaterialDTO?: {
            /**
             * 酒店入住开始时间
             */
            hotelEnterTime?: string;
            /**
             * 酒店入住结束时间
             */
            hotelLeaveTime?: string;
            /**
             * 住宿天数
             */
            accommodationDays?: number;
          };
          /**
           * 交通类材料信息
           */
          trafficMaterialDTO?: {
            /**
             * 座位类别
             */
            seatType?: number;
            /**
             * 座位枚举描述
             */
            seatDesc?: string;
            /**
             * 出发地区划code
             */
            fromDistrictCode: string;
            /**
             * 出发地区划名称
             */
            fromDistrictName: string;
            /**
             * 结束地区划code
             */
            endDistrictCode: string;
            /**
             * 结束地区划名称
             */
            endDistrictName: string;
            /**
             * 火车时长码
             */
            trainDurationCode?: number;
            /**
             * 火车时长
             */
            trainDurationDesc?: string;
            /**
             * 出发日期
             */
            departureTime: string;
            /**
             * 公里数
             */
            mileage: number;
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
          };
          /**
           * 补贴类材料
           */
          allowanceMaterialDTO?: {
            /**
             * 总的费用金额
             */
            totalAmount?: number;
            /**
             * 费用标准细项
             */
            itemList?: {
              /**
               * 标准金额
               */
              standardAmount?: number;
              /**
               * 时间-天数
               */
              days?: number;
              /**
               * 费用描述
               */
              ruleDesc?: string;
            }[];
            /**
             * 火车补贴伙食费用细项
             */
            trainAllowanceMaterialDTOS?: {
              /**
               * 火车天数
               */
              trainHours?: number;
              /**
               * 火车补贴金额
               */
              trainStanardAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 用户ID
               */
              operatorId?: number;
              /**
               * 人员来源 1-系统内部；2-外部人员
               */
              userSource?: 1 | 2;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
            }[];
            /**
             * 火车总额度
             */
            trainTotalAmount?: number;
            /**
             * 是否派车
             */
            isCar?: boolean;
            /**
             * 派车铺贴计算
             */
            carAllowanceMaterialDTOS?: {
              /**
               * 派车天数
               */
              carDays?: number;
              /**
               * 派车金额
               */
              carStandardtotalAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
            }[];
          };
          /**
           * 通用类材料信息
           */
          meetingOrTrainMaterialDTO?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 会议类型
             */
            meetingType?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
            /**
             * 培训人员
             */
            trainingPerson?: string;
            /**
             * 培训人员职级
             */
            trainingPersonLevel?: number;
            /**
             * 培训人员职级
             */
            trainingPersonLevelDesc?: string;
            /**
             * 培训时长
             */
            trainingHour?: number;
          };
          /**
           * 业务招待材料信息
           */
          businessEntertainingMaterial?: {
            /**
             * 招待日期
             */
            entertainDate?: string;
            /**
             * 招待形式
             */
            entertainForm: 1 | 2 | 3;
            /**
             * 招待形式描述
             */
            entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
            /**
             * 招待人数
             */
            entertainPeopleNum: number;
            /**
             * 招待事由
             */
            entertainReason: string;
          };
          /**
           * 交通费-租车费材料信息
           */
          rentCarFeeMaterial?: {
            /**
             * 租车申请单信息
             */
            rentCarApplyForm?: {
              /**
               * 业务单据号
               */
              businessNo?: string;
              /**
               * 申请编号
               */
              applyFormCode?: string;
              /**
               * 用车人（前端回显）
               */
              carUserList?: {
                /**
                 * 人员id
                 */
                operatorId: number;
                /**
                 * 人员名称
                 */
                operatorName: string;
                /**
                 * 机构id
                 */
                institutionId?: number;
                /**
                 * 机构名称
                 */
                institutionName?: string;
                /**
                 * 外部人员职级
                 * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
                 */
                outerUserRank?: number;
                /**
                 * 人员类型
                 * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
                 */
                userType?: number;
                userId?: number;
                userName?: string;
                bankCardInfo?: {
                  /**
                   * 银行代码
                   */
                  bankCode: string;
                  /**
                   * 银行名字
                   */
                  bankName: string;
                  /**
                   * 账户名称
                   */
                  accountName: string;
                  /**
                   * 银行账号
                   */
                  bankAccount: string;
                  /**
                   * 银行账号 脱敏
                   */
                  bankAccountDesc?: string;
                  /**
                   * 卡号保存的唯一标识
                   */
                  accountCode?: string;
                };
                /**
                 * 同一个人员，绑定的id
                 */
                bindOperatorId?: number;
                /**
                 * 用户类型
                 * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
                 */
                type: number;
                /**
                 * 用户职级,
                 * 内部用户的职级，外部用户关联内部用户，取内部用户职级
                 * 否则去外部用户职级
                 */
                userRank?: string;
                /**
                 * 手机号
                 */
                mobile?: string;
                /**
                 * 证件号码
                 */
                idCard?: string;
                /**
                 * 证件类型
                 */
                idType?: number;
                /**
                 * 性别
                 */
                gender?: number;
                /**
                 * 同行人费用code
                 */
                feeCode?: string;
              }[];
              /**
               * 预计金额（前端回显）
               */
              planAmount?: number;
              /**
               * 申请事由（前端回显）
               */
              applyReason?: string;
              /**
               * 经办人名称（前端回显）
               */
              operatorName?: string;
              /**
               * 目的地列表（前端回显）
               */
              endCityList?: {
                /**
                 * 目的城市code
                 */
                endCityCode: string;
                /**
                 * 目的城市名称
                 */
                endCityName: string;
              }[];
            }[];
            /**
             * 目的地
             */
            destination?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
            /**
             * 消费日期
             */
            consumeDate?: string[];
          };
          /**
           * 基础行程类信息
           */
          batchItineraryMaterialDTO?: {
            /**
             * 行程基本信息
             */
            itineraryMaterialDTOList?: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
              /**
               * 起始区划code
               */
              startDistrictCode: string;
              /**
               * 出发地名称
               */
              startDistrictName?: string;
              /**
               * 结束区划code
               */
              endDistrictCode: string;
              /**
               * 结束地点名称
               */
              endDistrictName?: string;
              /**
               * 人数
               */
              operatorIds?: number[];
            }[];
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
            /**
             * 人数
             */
            operatorIds?: number[];
          };
          /**
           * 修改备注
           */
          remark?: string;
          /**
           * 费用说明
           */
          feeDesc?: string;
          /**
           * 是否多票
           */
          multiInvoice?: boolean;
          /**
           * 关联的单据的编号
           */
          associateFormList?: {
            /**
             * 单据code
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: string;
          }[];
        };
        /**
         * 详细信息
         */
        detailExtendDTO?: {
          /**
           * 详细列表页
           */
          expenseFeeDetailInfoList?: {
            /**
             * 前端需要参数
             */
            indexNo?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            userType?: number;
            type?: number;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 原始信息（当前补贴）
             */
            originalInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
            /**
             * 重复补贴
             */
            conflictInfoList?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            }[];
            /**
             * 费用种类
             */
            feeCategory?: number;
            /**
             * 实际补贴金额
             */
            amount?: number;
            /**
             * 原始计算金额
             */
            originalAmount?: number;
            /**
             * 调整前金额
             */
            beforeChangeAmount?: number;
            /**
             * 冲突的金额
             */
            conflictAmount?: number;
            /**
             * 扣减金额
             */
            reductionAmount?: number;
            /**
             * 最大允许金额
             */
            allowMaxAmount?: number;
            /**
             * 备注
             */
            remark?: string;
            /**
             * 是否发生变更
             */
            isChanged?: boolean;
          }[];
          /**
           * 冲突展示列表页
           */
          expenseFeeConflictList?: {
            /**
             * 业务编码
             */
            businessCode?: string;
            /**
             * 单据编号
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: number;
            /**
             * 业务类型
             */
            businessType?: number;
            /**
             * 业务类型描述
             */
            businessTypeDesc?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 冲突信息
             */
            conflictInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
          }[];
          /**
           * 调整后金额
           */
          currentAmount?: number;
          /**
           * 原始金额
           */
          originalAmount?: number;
          /**
           * 费用类型
           */
          feeType?: number;
          /**
           * 火车金额
           */
          trainAmount?: number;
          /**
           * 总金额相等
           */
          totalAmountEquals?: boolean;
        };
        userType?: number;
      }[];
    };
    /**
     * 会议培训 - 住宿费
     */
    hotelFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 会议培训 - 伙食费
     */
    eatFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 会议培训 - 其他费
     */
    otherFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 会议 - 所有
     */
    allFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 培训 - 综合定额
     */
    comprehensiveFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 培训 - 场地、资料、交通费
     */
    mixFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: null;
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: null;
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: null;
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: null;
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: null;
        /**
         * 修改备注
         */
        remark?: null;
        /**
         * 费用说明
         */
        feeDesc?: null;
        /**
         * 是否多票
         */
        multiInvoice?: null;
        /**
         * 关联的单据的编号
         */
        associateFormList?: null;
      };
    };
  };
  code?: null;
  message?: null;
}

/**
 * 接口 [根据行程信息自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383922) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByRecord`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeRecordGenByRecordPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/record/genByRecord',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据行程信息自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383922) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByRecord`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
const zlbApiExpenseFeeRecordGenByRecordPostRequestConfig: ZlbApiExpenseFeeRecordGenByRecordPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/record/genByRecord',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeRecordGenByRecordPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据行程信息自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383922) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByRecord`
 * @更新时间 `2024-09-26 14:35:22`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeRecordGenByRecordPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeRecordGenByRecordPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeRecordGenByRecordPostResponse>(
    prepare(zlbApiExpenseFeeRecordGenByRecordPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeRecordGenByRecordPost.requestConfig =
  zlbApiExpenseFeeRecordGenByRecordPostRequestConfig;

/**
 * 接口 [生成会议和培训费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383930) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByMeetingOrTrain`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordGenByMeetingOrTrainPostRequest {
  /**
   * 4-一类会议、5-二类会议、6-三类会议、27-其他会议；7-一类培训、8-二类培训；
   */
  businessType?:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 32
    | 29
    | 30
    | 33
    | 35;
  /**
   * 天数
   */
  dayCount?: number;
  /**
   * 人数
   */
  personCount?: number;
}

/**
 * 接口 [生成会议和培训费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383930) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByMeetingOrTrain`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordGenByMeetingOrTrainPostResponse {
  success?: boolean;
  result?: {
    /**
     * 伙食补贴
     */
    allowanceEat?: {
      /**
       * 费用父级code
       */
      feeParentType?: number;
      /**
       * 费用父级描述
       */
      feeParentTypeDesc?: string;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 货币金额
       */
      totalAmount?: number;
      /**
       * 每个人的费用
       */
      expenseFeeGenPersonROList?: {
        /**
         * 费用类型
         */
        feeType?: number;
        /**
         * 费用类型描述
         */
        feeTypeDesc?: string;
        /**
         * 用户id
         */
        operatorId?: number;
        /**
         * 陪同人员
         */
        accompanyPerson?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 用户名称
         */
        operatorName?: string;
        /**
         * 时长
         */
        travelDay?: number;
        /**
         * 时长描述
         */
        travelDayDesc?: string;
        /**
         * 费用金额
         */
        amount?: number;
        /**
         * 货币编码
         */
        currencyCode?: string;
        /**
         * 相关材料信息
         */
        materialInfo?: {
          /**
           * 凭票报销伙食类补贴信息
           */
          allowanceMaterialByInvoiceDTO?: {
            /**
             * 关联行程编号
             */
            associateItineraryList: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
            }[];
            /**
             * 补贴发生日期
             */
            allowanceHappenDates: string[];
            /**
             * 城市名称s(无用，纯属兼容前端，别删除)
             */
            endCityName?: string;
          };
          /**
           * 住宿类材料信息
           */
          hotelMaterialDTO?: {
            /**
             * 酒店入住开始时间
             */
            hotelEnterTime?: string;
            /**
             * 酒店入住结束时间
             */
            hotelLeaveTime?: string;
            /**
             * 住宿天数
             */
            accommodationDays?: number;
          };
          /**
           * 交通类材料信息
           */
          trafficMaterialDTO?: {
            /**
             * 座位类别
             */
            seatType?: number;
            /**
             * 座位枚举描述
             */
            seatDesc?: string;
            /**
             * 出发地区划code
             */
            fromDistrictCode: string;
            /**
             * 出发地区划名称
             */
            fromDistrictName: string;
            /**
             * 结束地区划code
             */
            endDistrictCode: string;
            /**
             * 结束地区划名称
             */
            endDistrictName: string;
            /**
             * 火车时长码
             */
            trainDurationCode?: number;
            /**
             * 火车时长
             */
            trainDurationDesc?: string;
            /**
             * 出发日期
             */
            departureTime: string;
            /**
             * 公里数
             */
            mileage: number;
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
          };
          /**
           * 补贴类材料
           */
          allowanceMaterialDTO?: {
            /**
             * 总的费用金额
             */
            totalAmount?: number;
            /**
             * 费用标准细项
             */
            itemList?: {
              /**
               * 标准金额
               */
              standardAmount?: number;
              /**
               * 时间-天数
               */
              days?: number;
              /**
               * 费用描述
               */
              ruleDesc?: string;
            }[];
            /**
             * 火车补贴伙食费用细项
             */
            trainAllowanceMaterialDTOS?: {
              /**
               * 火车天数
               */
              trainHours?: number;
              /**
               * 火车补贴金额
               */
              trainStanardAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 用户ID
               */
              operatorId?: number;
              /**
               * 人员来源 1-系统内部；2-外部人员
               */
              userSource?: 1 | 2;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
            }[];
            /**
             * 火车总额度
             */
            trainTotalAmount?: number;
            /**
             * 是否派车
             */
            isCar?: boolean;
            /**
             * 派车铺贴计算
             */
            carAllowanceMaterialDTOS?: {
              /**
               * 派车天数
               */
              carDays?: number;
              /**
               * 派车金额
               */
              carStandardtotalAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
            }[];
          };
          /**
           * 通用类材料信息
           */
          meetingOrTrainMaterialDTO?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 会议类型
             */
            meetingType?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
            /**
             * 培训人员
             */
            trainingPerson?: string;
            /**
             * 培训人员职级
             */
            trainingPersonLevel?: number;
            /**
             * 培训人员职级
             */
            trainingPersonLevelDesc?: string;
            /**
             * 培训时长
             */
            trainingHour?: number;
          };
          /**
           * 业务招待材料信息
           */
          businessEntertainingMaterial?: {
            /**
             * 招待日期
             */
            entertainDate?: string;
            /**
             * 招待形式
             */
            entertainForm: 1 | 2 | 3;
            /**
             * 招待形式描述
             */
            entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
            /**
             * 招待人数
             */
            entertainPeopleNum: number;
            /**
             * 招待事由
             */
            entertainReason: string;
          };
          /**
           * 交通费-租车费材料信息
           */
          rentCarFeeMaterial?: {
            /**
             * 租车申请单信息
             */
            rentCarApplyForm?: {
              /**
               * 业务单据号
               */
              businessNo?: string;
              /**
               * 申请编号
               */
              applyFormCode?: string;
              /**
               * 用车人（前端回显）
               */
              carUserList?: {
                /**
                 * 人员id
                 */
                operatorId: number;
                /**
                 * 人员名称
                 */
                operatorName: string;
                /**
                 * 机构id
                 */
                institutionId?: number;
                /**
                 * 机构名称
                 */
                institutionName?: string;
                /**
                 * 外部人员职级
                 * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
                 */
                outerUserRank?: number;
                /**
                 * 人员类型
                 * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
                 */
                userType?: number;
                userId?: number;
                userName?: string;
                bankCardInfo?: {
                  /**
                   * 银行代码
                   */
                  bankCode: string;
                  /**
                   * 银行名字
                   */
                  bankName: string;
                  /**
                   * 账户名称
                   */
                  accountName: string;
                  /**
                   * 银行账号
                   */
                  bankAccount: string;
                  /**
                   * 银行账号 脱敏
                   */
                  bankAccountDesc?: string;
                  /**
                   * 卡号保存的唯一标识
                   */
                  accountCode?: string;
                };
                /**
                 * 同一个人员，绑定的id
                 */
                bindOperatorId?: number;
                /**
                 * 用户类型
                 * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
                 */
                type: number;
                /**
                 * 用户职级,
                 * 内部用户的职级，外部用户关联内部用户，取内部用户职级
                 * 否则去外部用户职级
                 */
                userRank?: string;
                /**
                 * 手机号
                 */
                mobile?: string;
                /**
                 * 证件号码
                 */
                idCard?: string;
                /**
                 * 证件类型
                 */
                idType?: number;
                /**
                 * 性别
                 */
                gender?: number;
                /**
                 * 同行人费用code
                 */
                feeCode?: string;
              }[];
              /**
               * 预计金额（前端回显）
               */
              planAmount?: number;
              /**
               * 申请事由（前端回显）
               */
              applyReason?: string;
              /**
               * 经办人名称（前端回显）
               */
              operatorName?: string;
              /**
               * 目的地列表（前端回显）
               */
              endCityList?: {
                /**
                 * 目的城市code
                 */
                endCityCode: string;
                /**
                 * 目的城市名称
                 */
                endCityName: string;
              }[];
            }[];
            /**
             * 目的地
             */
            destination?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
            /**
             * 消费日期
             */
            consumeDate?: string[];
          };
          /**
           * 基础行程类信息
           */
          batchItineraryMaterialDTO?: {
            /**
             * 行程基本信息
             */
            itineraryMaterialDTOList?: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
              /**
               * 起始区划code
               */
              startDistrictCode: string;
              /**
               * 出发地名称
               */
              startDistrictName?: string;
              /**
               * 结束区划code
               */
              endDistrictCode: string;
              /**
               * 结束地点名称
               */
              endDistrictName?: string;
              /**
               * 人数
               */
              operatorIds?: number[];
            }[];
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
            /**
             * 人数
             */
            operatorIds?: number[];
          };
          /**
           * 修改备注
           */
          remark?: string;
          /**
           * 费用说明
           */
          feeDesc?: string;
          /**
           * 是否多票
           */
          multiInvoice?: boolean;
          /**
           * 关联的单据的编号
           */
          associateFormList?: {
            /**
             * 单据code
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: string;
          }[];
        };
        /**
         * 详细信息
         */
        detailExtendDTO?: {
          /**
           * 详细列表页
           */
          expenseFeeDetailInfoList?: {
            /**
             * 前端需要参数
             */
            indexNo?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            userType?: number;
            type?: number;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 原始信息（当前补贴）
             */
            originalInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
            /**
             * 重复补贴
             */
            conflictInfoList?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            }[];
            /**
             * 费用种类
             */
            feeCategory?: number;
            /**
             * 实际补贴金额
             */
            amount?: number;
            /**
             * 原始计算金额
             */
            originalAmount?: number;
            /**
             * 调整前金额
             */
            beforeChangeAmount?: number;
            /**
             * 冲突的金额
             */
            conflictAmount?: number;
            /**
             * 扣减金额
             */
            reductionAmount?: number;
            /**
             * 最大允许金额
             */
            allowMaxAmount?: number;
            /**
             * 备注
             */
            remark?: string;
            /**
             * 是否发生变更
             */
            isChanged?: boolean;
          }[];
          /**
           * 冲突展示列表页
           */
          expenseFeeConflictList?: {
            /**
             * 业务编码
             */
            businessCode?: string;
            /**
             * 单据编号
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: number;
            /**
             * 业务类型
             */
            businessType?: number;
            /**
             * 业务类型描述
             */
            businessTypeDesc?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 冲突信息
             */
            conflictInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
          }[];
          /**
           * 调整后金额
           */
          currentAmount?: number;
          /**
           * 原始金额
           */
          originalAmount?: number;
          /**
           * 费用类型
           */
          feeType?: number;
          /**
           * 火车金额
           */
          trainAmount?: number;
          /**
           * 总金额相等
           */
          totalAmountEquals?: boolean;
        };
        userType?: number;
      }[];
    };
    /**
     * 公杂补贴
     */
    allowanceIncidental?: {
      /**
       * 费用父级code
       */
      feeParentType?: number;
      /**
       * 费用父级描述
       */
      feeParentTypeDesc?: string;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 货币金额
       */
      totalAmount?: number;
      /**
       * 每个人的费用
       */
      expenseFeeGenPersonROList?: {
        /**
         * 费用类型
         */
        feeType?: number;
        /**
         * 费用类型描述
         */
        feeTypeDesc?: string;
        /**
         * 用户id
         */
        operatorId?: number;
        /**
         * 陪同人员
         */
        accompanyPerson?: {
          /**
           * 人员id
           */
          operatorId: number;
          /**
           * 人员名称
           */
          operatorName: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
           */
          userType?: number;
          userId?: number;
          userName?: string;
          bankCardInfo?: {
            /**
             * 银行代码
             */
            bankCode: string;
            /**
             * 银行名字
             */
            bankName: string;
            /**
             * 账户名称
             */
            accountName: string;
            /**
             * 银行账号
             */
            bankAccount: string;
            /**
             * 银行账号 脱敏
             */
            bankAccountDesc?: string;
            /**
             * 卡号保存的唯一标识
             */
            accountCode?: string;
          };
          /**
           * 同一个人员，绑定的id
           */
          bindOperatorId?: number;
          /**
           * 用户类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type: number;
          /**
           * 用户职级,
           * 内部用户的职级，外部用户关联内部用户，取内部用户职级
           * 否则去外部用户职级
           */
          userRank?: string;
          /**
           * 手机号
           */
          mobile?: string;
          /**
           * 证件号码
           */
          idCard?: string;
          /**
           * 证件类型
           */
          idType?: number;
          /**
           * 性别
           */
          gender?: number;
          /**
           * 同行人费用code
           */
          feeCode?: string;
        }[];
        /**
         * 用户名称
         */
        operatorName?: string;
        /**
         * 时长
         */
        travelDay?: number;
        /**
         * 时长描述
         */
        travelDayDesc?: string;
        /**
         * 费用金额
         */
        amount?: number;
        /**
         * 货币编码
         */
        currencyCode?: string;
        /**
         * 相关材料信息
         */
        materialInfo?: {
          /**
           * 凭票报销伙食类补贴信息
           */
          allowanceMaterialByInvoiceDTO?: {
            /**
             * 关联行程编号
             */
            associateItineraryList: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
            }[];
            /**
             * 补贴发生日期
             */
            allowanceHappenDates: string[];
            /**
             * 城市名称s(无用，纯属兼容前端，别删除)
             */
            endCityName?: string;
          };
          /**
           * 住宿类材料信息
           */
          hotelMaterialDTO?: {
            /**
             * 酒店入住开始时间
             */
            hotelEnterTime?: string;
            /**
             * 酒店入住结束时间
             */
            hotelLeaveTime?: string;
            /**
             * 住宿天数
             */
            accommodationDays?: number;
          };
          /**
           * 交通类材料信息
           */
          trafficMaterialDTO?: {
            /**
             * 座位类别
             */
            seatType?: number;
            /**
             * 座位枚举描述
             */
            seatDesc?: string;
            /**
             * 出发地区划code
             */
            fromDistrictCode: string;
            /**
             * 出发地区划名称
             */
            fromDistrictName: string;
            /**
             * 结束地区划code
             */
            endDistrictCode: string;
            /**
             * 结束地区划名称
             */
            endDistrictName: string;
            /**
             * 火车时长码
             */
            trainDurationCode?: number;
            /**
             * 火车时长
             */
            trainDurationDesc?: string;
            /**
             * 出发日期
             */
            departureTime: string;
            /**
             * 公里数
             */
            mileage: number;
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
          };
          /**
           * 补贴类材料
           */
          allowanceMaterialDTO?: {
            /**
             * 总的费用金额
             */
            totalAmount?: number;
            /**
             * 费用标准细项
             */
            itemList?: {
              /**
               * 标准金额
               */
              standardAmount?: number;
              /**
               * 时间-天数
               */
              days?: number;
              /**
               * 费用描述
               */
              ruleDesc?: string;
            }[];
            /**
             * 火车补贴伙食费用细项
             */
            trainAllowanceMaterialDTOS?: {
              /**
               * 火车天数
               */
              trainHours?: number;
              /**
               * 火车补贴金额
               */
              trainStanardAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
              /**
               * 用户ID
               */
              operatorId?: number;
              /**
               * 人员来源 1-系统内部；2-外部人员
               */
              userSource?: 1 | 2;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
            }[];
            /**
             * 火车总额度
             */
            trainTotalAmount?: number;
            /**
             * 是否派车
             */
            isCar?: boolean;
            /**
             * 派车铺贴计算
             */
            carAllowanceMaterialDTOS?: {
              /**
               * 派车天数
               */
              carDays?: number;
              /**
               * 派车金额
               */
              carStandardtotalAmount?: number;
              /**
               * 规则描述
               */
              ruleDesc?: string;
            }[];
          };
          /**
           * 通用类材料信息
           */
          meetingOrTrainMaterialDTO?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 会议类型
             */
            meetingType?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
            /**
             * 培训人员
             */
            trainingPerson?: string;
            /**
             * 培训人员职级
             */
            trainingPersonLevel?: number;
            /**
             * 培训人员职级
             */
            trainingPersonLevelDesc?: string;
            /**
             * 培训时长
             */
            trainingHour?: number;
          };
          /**
           * 业务招待材料信息
           */
          businessEntertainingMaterial?: {
            /**
             * 招待日期
             */
            entertainDate?: string;
            /**
             * 招待形式
             */
            entertainForm: 1 | 2 | 3;
            /**
             * 招待形式描述
             */
            entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
            /**
             * 招待人数
             */
            entertainPeopleNum: number;
            /**
             * 招待事由
             */
            entertainReason: string;
          };
          /**
           * 交通费-租车费材料信息
           */
          rentCarFeeMaterial?: {
            /**
             * 租车申请单信息
             */
            rentCarApplyForm?: {
              /**
               * 业务单据号
               */
              businessNo?: string;
              /**
               * 申请编号
               */
              applyFormCode?: string;
              /**
               * 用车人（前端回显）
               */
              carUserList?: {
                /**
                 * 人员id
                 */
                operatorId: number;
                /**
                 * 人员名称
                 */
                operatorName: string;
                /**
                 * 机构id
                 */
                institutionId?: number;
                /**
                 * 机构名称
                 */
                institutionName?: string;
                /**
                 * 外部人员职级
                 * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
                 */
                outerUserRank?: number;
                /**
                 * 人员类型
                 * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
                 */
                userType?: number;
                userId?: number;
                userName?: string;
                bankCardInfo?: {
                  /**
                   * 银行代码
                   */
                  bankCode: string;
                  /**
                   * 银行名字
                   */
                  bankName: string;
                  /**
                   * 账户名称
                   */
                  accountName: string;
                  /**
                   * 银行账号
                   */
                  bankAccount: string;
                  /**
                   * 银行账号 脱敏
                   */
                  bankAccountDesc?: string;
                  /**
                   * 卡号保存的唯一标识
                   */
                  accountCode?: string;
                };
                /**
                 * 同一个人员，绑定的id
                 */
                bindOperatorId?: number;
                /**
                 * 用户类型
                 * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
                 */
                type: number;
                /**
                 * 用户职级,
                 * 内部用户的职级，外部用户关联内部用户，取内部用户职级
                 * 否则去外部用户职级
                 */
                userRank?: string;
                /**
                 * 手机号
                 */
                mobile?: string;
                /**
                 * 证件号码
                 */
                idCard?: string;
                /**
                 * 证件类型
                 */
                idType?: number;
                /**
                 * 性别
                 */
                gender?: number;
                /**
                 * 同行人费用code
                 */
                feeCode?: string;
              }[];
              /**
               * 预计金额（前端回显）
               */
              planAmount?: number;
              /**
               * 申请事由（前端回显）
               */
              applyReason?: string;
              /**
               * 经办人名称（前端回显）
               */
              operatorName?: string;
              /**
               * 目的地列表（前端回显）
               */
              endCityList?: {
                /**
                 * 目的城市code
                 */
                endCityCode: string;
                /**
                 * 目的城市名称
                 */
                endCityName: string;
              }[];
            }[];
            /**
             * 目的地
             */
            destination?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
            /**
             * 消费日期
             */
            consumeDate?: string[];
          };
          /**
           * 基础行程类信息
           */
          batchItineraryMaterialDTO?: {
            /**
             * 行程基本信息
             */
            itineraryMaterialDTOList?: {
              /**
               * 行程序列编号（行程模块前端生成的唯一键）
               */
              indexNo?: string;
              /**
               * 行程编码(没有可不填)
               */
              itineraryCode?: string;
              /**
               * 起始区划code
               */
              startDistrictCode: string;
              /**
               * 出发地名称
               */
              startDistrictName?: string;
              /**
               * 结束区划code
               */
              endDistrictCode: string;
              /**
               * 结束地点名称
               */
              endDistrictName?: string;
              /**
               * 人数
               */
              operatorIds?: number[];
            }[];
            /**
             * 自驾是否往返
             */
            isRoundTrip: boolean;
            /**
             * 人数
             */
            operatorIds?: number[];
          };
          /**
           * 修改备注
           */
          remark?: string;
          /**
           * 费用说明
           */
          feeDesc?: string;
          /**
           * 是否多票
           */
          multiInvoice?: boolean;
          /**
           * 关联的单据的编号
           */
          associateFormList?: {
            /**
             * 单据code
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: string;
          }[];
        };
        /**
         * 详细信息
         */
        detailExtendDTO?: {
          /**
           * 详细列表页
           */
          expenseFeeDetailInfoList?: {
            /**
             * 前端需要参数
             */
            indexNo?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            userType?: number;
            type?: number;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 原始信息（当前补贴）
             */
            originalInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
            /**
             * 重复补贴
             */
            conflictInfoList?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            }[];
            /**
             * 费用种类
             */
            feeCategory?: number;
            /**
             * 实际补贴金额
             */
            amount?: number;
            /**
             * 原始计算金额
             */
            originalAmount?: number;
            /**
             * 调整前金额
             */
            beforeChangeAmount?: number;
            /**
             * 冲突的金额
             */
            conflictAmount?: number;
            /**
             * 扣减金额
             */
            reductionAmount?: number;
            /**
             * 最大允许金额
             */
            allowMaxAmount?: number;
            /**
             * 备注
             */
            remark?: string;
            /**
             * 是否发生变更
             */
            isChanged?: boolean;
          }[];
          /**
           * 冲突展示列表页
           */
          expenseFeeConflictList?: {
            /**
             * 业务编码
             */
            businessCode?: string;
            /**
             * 单据编号
             */
            formCode?: string;
            /**
             * 单据类型
             */
            formType?: number;
            /**
             * 业务类型
             */
            businessType?: number;
            /**
             * 业务类型描述
             */
            businessTypeDesc?: string;
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 日期
             */
            date?: string;
            /**
             * 日期描述
             */
            dateDesc?: string;
            /**
             * 冲突信息
             */
            conflictInfo?: {
              /**
               * 日期
               */
              date?: string;
              /**
               * 日期描述
               */
              dateDesc?: string;
              /**
               * 金额
               */
              amount?: number;
              /**
               * 区划code
               */
              districtCode?: string;
              /**
               * 区划名称
               */
              districtName?: string;
              /**
               * 是否派车
               */
              arrangeCar?: boolean;
              /**
               * 省内
               */
              innerProvince?: boolean;
              /**
               * 冲突业务编码
               */
              businessCode?: string;
              /**
               * 冲突单据编号
               */
              formCode?: string;
              /**
               * 冲突业务类型
               */
              businessType?: number;
              /**
               * 冲突业务类型描述
               */
              businessTypeDesc?: number;
              /**
               * 凭票报销
               */
              useInvoice?: boolean;
              /**
               * 扣减百分比
               */
              deductionPercent?: number;
              /**
               * 开启休息日扣减
               */
              enableRestDayDeduction?: boolean;
            };
          }[];
          /**
           * 调整后金额
           */
          currentAmount?: number;
          /**
           * 原始金额
           */
          originalAmount?: number;
          /**
           * 费用类型
           */
          feeType?: number;
          /**
           * 火车金额
           */
          trainAmount?: number;
          /**
           * 总金额相等
           */
          totalAmountEquals?: boolean;
        };
        userType?: number;
      }[];
    };
    /**
     * 会议培训 - 住宿费
     */
    hotelFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 会议培训 - 伙食费
     */
    eatFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 会议培训 - 其他费
     */
    otherFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 会议 - 所有
     */
    allFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 培训 - 综合定额
     */
    comprehensiveFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: {
            /**
             * 派车天数
             */
            carDays?: number;
            /**
             * 派车金额
             */
            carStandardtotalAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
          }[];
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 会议类型
           */
          meetingType?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
          /**
           * 培训人员
           */
          trainingPerson?: string;
          /**
           * 培训人员职级
           */
          trainingPersonLevel?: number;
          /**
           * 培训人员职级
           */
          trainingPersonLevelDesc?: string;
          /**
           * 培训时长
           */
          trainingHour?: number;
        };
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: {
          /**
           * 招待日期
           */
          entertainDate?: string;
          /**
           * 招待形式
           */
          entertainForm: 1 | 2 | 3;
          /**
           * 招待形式描述
           */
          entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
          /**
           * 招待人数
           */
          entertainPeopleNum: number;
          /**
           * 招待事由
           */
          entertainReason: string;
        };
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: {
          /**
           * 租车申请单信息
           */
          rentCarApplyForm?: {
            /**
             * 业务单据号
             */
            businessNo?: string;
            /**
             * 申请编号
             */
            applyFormCode?: string;
            /**
             * 用车人（前端回显）
             */
            carUserList?: {
              /**
               * 人员id
               */
              operatorId: number;
              /**
               * 人员名称
               */
              operatorName: string;
              /**
               * 机构id
               */
              institutionId?: number;
              /**
               * 机构名称
               */
              institutionName?: string;
              /**
               * 外部人员职级
               * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
               */
              outerUserRank?: number;
              /**
               * 人员类型
               * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
               */
              userType?: number;
              userId?: number;
              userName?: string;
              bankCardInfo?: {
                /**
                 * 银行代码
                 */
                bankCode: string;
                /**
                 * 银行名字
                 */
                bankName: string;
                /**
                 * 账户名称
                 */
                accountName: string;
                /**
                 * 银行账号
                 */
                bankAccount: string;
                /**
                 * 银行账号 脱敏
                 */
                bankAccountDesc?: string;
                /**
                 * 卡号保存的唯一标识
                 */
                accountCode?: string;
              };
              /**
               * 同一个人员，绑定的id
               */
              bindOperatorId?: number;
              /**
               * 用户类型
               * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
               */
              type: number;
              /**
               * 用户职级,
               * 内部用户的职级，外部用户关联内部用户，取内部用户职级
               * 否则去外部用户职级
               */
              userRank?: string;
              /**
               * 手机号
               */
              mobile?: string;
              /**
               * 证件号码
               */
              idCard?: string;
              /**
               * 证件类型
               */
              idType?: number;
              /**
               * 性别
               */
              gender?: number;
              /**
               * 同行人费用code
               */
              feeCode?: string;
            }[];
            /**
             * 预计金额（前端回显）
             */
            planAmount?: number;
            /**
             * 申请事由（前端回显）
             */
            applyReason?: string;
            /**
             * 经办人名称（前端回显）
             */
            operatorName?: string;
            /**
             * 目的地列表（前端回显）
             */
            endCityList?: {
              /**
               * 目的城市code
               */
              endCityCode: string;
              /**
               * 目的城市名称
               */
              endCityName: string;
            }[];
          }[];
          /**
           * 目的地
           */
          destination?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
          /**
           * 消费日期
           */
          consumeDate?: string[];
        };
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: {
          /**
           * 行程基本信息
           */
          itineraryMaterialDTOList?: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
            /**
             * 起始区划code
             */
            startDistrictCode: string;
            /**
             * 出发地名称
             */
            startDistrictName?: string;
            /**
             * 结束区划code
             */
            endDistrictCode: string;
            /**
             * 结束地点名称
             */
            endDistrictName?: string;
            /**
             * 人数
             */
            operatorIds?: number[];
          }[];
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
          /**
           * 人数
           */
          operatorIds?: number[];
        };
        /**
         * 修改备注
         */
        remark?: string;
        /**
         * 费用说明
         */
        feeDesc?: string;
        /**
         * 是否多票
         */
        multiInvoice?: boolean;
        /**
         * 关联的单据的编号
         */
        associateFormList?: {
          /**
           * 单据code
           */
          formCode?: string;
          /**
           * 单据类型
           */
          formType?: string;
        }[];
      };
    };
    /**
     * 培训 - 场地、资料、交通费
     */
    mixFee?: {
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
      /**
       * 费用金额
       */
      feeAmount?: number;
      /**
       * 人员operatorId
       */
      operatorId?: number;
      /**
       * 货币编码
       */
      currencyCode?: string;
      /**
       * 相关材料信息
       */
      materialInfo?: {
        /**
         * 凭票报销伙食类补贴信息
         */
        allowanceMaterialByInvoiceDTO?: {
          /**
           * 关联行程编号
           */
          associateItineraryList: {
            /**
             * 行程序列编号（行程模块前端生成的唯一键）
             */
            indexNo?: string;
            /**
             * 行程编码(没有可不填)
             */
            itineraryCode?: string;
          }[];
          /**
           * 补贴发生日期
           */
          allowanceHappenDates: string[];
          /**
           * 城市名称s(无用，纯属兼容前端，别删除)
           */
          endCityName?: string;
        };
        /**
         * 住宿类材料信息
         */
        hotelMaterialDTO?: {
          /**
           * 酒店入住开始时间
           */
          hotelEnterTime?: string;
          /**
           * 酒店入住结束时间
           */
          hotelLeaveTime?: string;
          /**
           * 住宿天数
           */
          accommodationDays?: number;
        };
        /**
         * 交通类材料信息
         */
        trafficMaterialDTO?: {
          /**
           * 座位类别
           */
          seatType?: number;
          /**
           * 座位枚举描述
           */
          seatDesc?: string;
          /**
           * 出发地区划code
           */
          fromDistrictCode: string;
          /**
           * 出发地区划名称
           */
          fromDistrictName: string;
          /**
           * 结束地区划code
           */
          endDistrictCode: string;
          /**
           * 结束地区划名称
           */
          endDistrictName: string;
          /**
           * 火车时长码
           */
          trainDurationCode?: number;
          /**
           * 火车时长
           */
          trainDurationDesc?: string;
          /**
           * 出发日期
           */
          departureTime: string;
          /**
           * 公里数
           */
          mileage: number;
          /**
           * 自驾是否往返
           */
          isRoundTrip: boolean;
        };
        /**
         * 补贴类材料
         */
        allowanceMaterialDTO?: {
          /**
           * 总的费用金额
           */
          totalAmount?: number;
          /**
           * 费用标准细项
           */
          itemList?: {
            /**
             * 标准金额
             */
            standardAmount?: number;
            /**
             * 时间-天数
             */
            days?: number;
            /**
             * 费用描述
             */
            ruleDesc?: string;
          }[];
          /**
           * 火车补贴伙食费用细项
           */
          trainAllowanceMaterialDTOS?: {
            /**
             * 火车天数
             */
            trainHours?: number;
            /**
             * 火车补贴金额
             */
            trainStanardAmount?: number;
            /**
             * 规则描述
             */
            ruleDesc?: string;
            /**
             * 用户ID
             */
            operatorId?: number;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
          }[];
          /**
           * 火车总额度
           */
          trainTotalAmount?: number;
          /**
           * 是否派车
           */
          isCar?: boolean;
          /**
           * 派车铺贴计算
           */
          carAllowanceMaterialDTOS?: null;
        };
        /**
         * 通用类材料信息
         */
        meetingOrTrainMaterialDTO?: null;
        /**
         * 业务招待材料信息
         */
        businessEntertainingMaterial?: null;
        /**
         * 交通费-租车费材料信息
         */
        rentCarFeeMaterial?: null;
        /**
         * 基础行程类信息
         */
        batchItineraryMaterialDTO?: null;
        /**
         * 修改备注
         */
        remark?: null;
        /**
         * 费用说明
         */
        feeDesc?: null;
        /**
         * 是否多票
         */
        multiInvoice?: null;
        /**
         * 关联的单据的编号
         */
        associateFormList?: null;
      };
    };
  };
  code?: null;
  message?: null;
}

/**
 * 接口 [生成会议和培训费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383930) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByMeetingOrTrain`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeRecordGenByMeetingOrTrainPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/record/genByMeetingOrTrain',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [生成会议和培训费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383930) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByMeetingOrTrain`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
const zlbApiExpenseFeeRecordGenByMeetingOrTrainPostRequestConfig: ZlbApiExpenseFeeRecordGenByMeetingOrTrainPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/record/genByMeetingOrTrain',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeRecordGenByMeetingOrTrainPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [生成会议和培训费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383930) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/record/genByMeetingOrTrain`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeRecordGenByMeetingOrTrainPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeRecordGenByMeetingOrTrainPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeRecordGenByMeetingOrTrainPostResponse>(
    prepare(zlbApiExpenseFeeRecordGenByMeetingOrTrainPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeRecordGenByMeetingOrTrainPost.requestConfig =
  zlbApiExpenseFeeRecordGenByMeetingOrTrainPostRequestConfig;

/**
 * 接口 [根据发票获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383938) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByInvoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenFeeByInvoiceGetRequest {
  invoiceCode?: string;
  businessCode?: string;
}

/**
 * 接口 [根据发票获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383938) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByInvoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenFeeByInvoiceGetResponse {
  success?: boolean;
  result?: {
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType?: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用名称
     */
    feeName?: string;
    /**
     * 费用发生时间
     */
    consumeTime?: string;
    /**
     * 货币代码
     */
    currencyCode?: string;
    /**
     * 货币金额
     */
    amount?: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCode?: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments?: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的报销单号
     */
    expenseFormCode?: string;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 发票状态
     */
    realStatus?: number;
    /**
     * 发票状态描述
     */
    realStatusDesc?: string;
    /**
     * 是否可以修改金额
     * 默认是可以修改
     */
    canChangeAmount?: boolean;
    /**
     * 费用信息是否已完善
     * true-已完善，false-未完善
     */
    feeInfoComplete?: boolean;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [根据发票获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383938) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByInvoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGenFeeByInvoiceGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/genFeeByInvoice',
    'data',
    string,
    'invoiceCode' | 'businessCode',
    false
  >
>;

/**
 * 接口 [根据发票获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383938) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByInvoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGenFeeByInvoiceGetRequestConfig: ZlbApiExpenseFeeExpenseFormGenFeeByInvoiceGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/genFeeByInvoice',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: ['invoiceCode', 'businessCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGenFeeByInvoiceGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据发票获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383938) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByInvoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGenFeeByInvoiceGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGenFeeByInvoiceGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGenFeeByInvoiceGetResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGenFeeByInvoiceGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGenFeeByInvoiceGet.requestConfig =
  zlbApiExpenseFeeExpenseFormGenFeeByInvoiceGetRequestConfig;

/**
 * 接口 [根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383946) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenByInvoicePostRequest {
  /**
   * 发票code
   */
  platformInvoiceIdList?: string[];
  /**
   * 票据来源：zlb-浙里报 zlbp-浙里办票
   */
  businessCode?: string;
  /**
   * 神坑需求--
   * 人员映射不上时，强制要求行程唯一人员情况下，
   * 映射人员信息，后来小心
   */
  operatorInfoDTO?: {
    /**
     * 人员id
     */
    operatorId: number;
    /**
     * 人员名称
     */
    operatorName: string;
    /**
     * 机构id
     */
    institutionId?: number;
    /**
     * 机构名称
     */
    institutionName?: string;
    /**
     * 外部人员职级
     * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
     */
    outerUserRank?: number;
    /**
     * 人员类型
     * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
     */
    userType?: number;
    userId?: number;
    userName?: string;
    bankCardInfo?: {
      /**
       * 银行代码
       */
      bankCode: string;
      /**
       * 银行名字
       */
      bankName: string;
      /**
       * 账户名称
       */
      accountName: string;
      /**
       * 银行账号
       */
      bankAccount: string;
      /**
       * 银行账号 脱敏
       */
      bankAccountDesc?: string;
      /**
       * 卡号保存的唯一标识
       */
      accountCode?: string;
    };
    /**
     * 同一个人员，绑定的id
     */
    bindOperatorId?: number;
    /**
     * 用户类型
     * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
     */
    type: number;
    /**
     * 用户职级,
     * 内部用户的职级，外部用户关联内部用户，取内部用户职级
     * 否则去外部用户职级
     */
    userRank?: string;
    /**
     * 手机号
     */
    mobile?: string;
    /**
     * 证件号码
     */
    idCard?: string;
    /**
     * 证件类型
     */
    idType?: number;
    /**
     * 性别
     */
    gender?: number;
    /**
     * 同行人费用code
     */
    feeCode?: string;
  };
  /**
   * 多票费用的时候传
   */
  feeType?: number;
  /**
   * 多票费用的时候传
   */
  feeTypeDesc?: string;
}

/**
 * 接口 [根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383946) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenByInvoicePostResponse {
  success?: boolean;
  result?: {
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType?: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用名称
     */
    feeName?: string;
    /**
     * 费用发生时间
     */
    consumeTime?: string;
    /**
     * 货币代码
     */
    currencyCode?: string;
    /**
     * 货币金额
     */
    amount?: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCode?: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments?: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的报销单号
     */
    expenseFormCode?: string;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 发票状态
     */
    realStatus?: number;
    /**
     * 发票状态描述
     */
    realStatusDesc?: string;
    /**
     * 是否可以修改金额
     * 默认是可以修改
     */
    canChangeAmount?: boolean;
    /**
     * 费用信息是否已完善
     * true-已完善，false-未完善
     */
    feeInfoComplete?: boolean;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383946) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGenByInvoicePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expense-form/gen-by-invoice',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383946) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGenByInvoicePostRequestConfig: ZlbApiExpenseFeeExpenseFormGenByInvoicePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expense-form/gen-by-invoice',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGenByInvoicePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383946) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGenByInvoicePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGenByInvoicePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGenByInvoicePostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGenByInvoicePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGenByInvoicePost.requestConfig =
  zlbApiExpenseFeeExpenseFormGenByInvoicePostRequestConfig;

/**
 * 接口 [根据费用代码获取修改费用信息↗](http://yapi.cai-inc.com/project/3621/interface/api/383954) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/getModifyFeeRecords`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGetRequest {
  /**
   * 费用code
   */
  feeCode?: string;
  /**
   * 业务类型 1-申请单，2-报销单[FormTypeEnum]
   * APPLY_FORM :1-申请单、2-报销单
   * EXPENSE_FORM :EXPENSE_FORM
   * OUT_APPLY_FORM :之前场景OA专用
   * WAGE_FORM :WAGE_FORM
   * THIRD_APPLY_FORM :THIRD_APPLY_FORM
   * NIGHT_MEAL_FEE_FORM :NIGHT_MEAL_FEE_FORM
   * BATCH_DISTRIBUTE :BATCH_DISTRIBUTE
   * NIGHT_MEAL_PAY_FORM :NIGHT_MEAL_PAY_FORM
   * OVERTIME_APPLY_FORM :OVERTIME_APPLY_FORM
   * WORK_PLAN_FORM :WORK_PLAN_FORM
   * RENTAL_APPLY_FORM :RENTAL_APPLY_FORM
   * USE_CAR_APPLY_FORM :USE_CAR_APPLY_FORM
   * INVEST_PAYMENT :INVEST_PAYMENT
   * REST_FORM :REST_FORM
   * OA_LEAVE :OA_LEAVE
   * NONE_TYPE :NONE_TYPE
   */
  formType?: string;
  /**
   * 单据code
   */
  formCode?: string;
}

/**
 * 接口 [根据费用代码获取修改费用信息↗](http://yapi.cai-inc.com/project/3621/interface/api/383954) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/getModifyFeeRecords`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGetResponse {
  success?: boolean;
  result?: {
    /**
     * 修改人员id
     */
    operatorId?: number;
    /**
     * 修改人员名称
     */
    operatorName?: string;
    /**
     * 修改时间
     */
    modifyDate?: string;
    /**
     * 调整前总金额
     */
    originalAllAmount?: number;
    /**
     * 调整后总金额
     */
    modifyAllAmount?: number;
    /**
     * 总金额调整原因
     */
    sumFeeRemark?: string;
    /**
     * 修改明细
     */
    modifyFeeDTOS?: {
      /**
       * 修改前金额
       */
      originalAmount?: number;
      /**
       * 修改后金额
       */
      modifyAmount?: number;
      /**
       * 修改原因
       */
      modifyRemark?: string;
      /**
       * 费用类型
       */
      feeType?:
        | 1001
        | 1002
        | 2001
        | 2002
        | 2003
        | 2004
        | 2005
        | 2006
        | 2007
        | 2008
        | 2009
        | 3001
        | 300101
        | 3002
        | 4001
        | 5001
        | 5000
        | 5002
        | 5003
        | 5004
        | 5005
        | 5006
        | 5007
        | 5008
        | 5009
        | 5010
        | 5011
        | 5012
        | 6000
        | 6001
        | 6002
        | 6003
        | 7000
        | 7001
        | 7002
        | 7003
        | 7004
        | 7005
        | 8888
        | 8001
        | 8002
        | 8003
        | 9999;
      /**
       * 费用类型描述
       */
      feeTypeDesc?: string;
    }[];
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据费用代码获取修改费用信息↗](http://yapi.cai-inc.com/project/3621/interface/api/383954) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/getModifyFeeRecords`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/getModifyFeeRecords',
    'data',
    string,
    'feeCode' | 'formType' | 'formCode',
    false
  >
>;

/**
 * 接口 [根据费用代码获取修改费用信息↗](http://yapi.cai-inc.com/project/3621/interface/api/383954) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/getModifyFeeRecords`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGetRequestConfig: ZlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/getModifyFeeRecords',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: ['feeCode', 'formType', 'formCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据费用代码获取修改费用信息↗](http://yapi.cai-inc.com/project/3621/interface/api/383954) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/getModifyFeeRecords`
 * @更新时间 `2024-09-26 14:35:23`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGetResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGet.requestConfig =
  zlbApiExpenseFeeExpenseFormGetModifyFeeRecordsGetRequestConfig;

/**
 * 接口 [根据订单编号生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383962) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByThirdOrderNo`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPostRequest {
  /**
   * 费用订单列表
   */
  feeOrderPOList?: {
    /**
     * 三方订单号
     */
    thirdOrderNo: string;
    /**
     * 订单类型
     */
    orderType: number;
    /**
     * 平台订单号
     */
    platformOrderNo: string;
    /**
     * 按照人员进行过滤
     * 不填，不过滤
     */
    operatorIdList?: number[];
  }[];
}

/**
 * 接口 [根据订单编号生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383962) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByThirdOrderNo`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPostResponse {
  success?: boolean;
  result?: {
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType?: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用名称
     */
    feeName?: string;
    /**
     * 费用发生时间
     */
    consumeTime?: string;
    /**
     * 货币代码
     */
    currencyCode?: string;
    /**
     * 货币金额
     */
    amount?: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCode?: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments?: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的报销单号
     */
    expenseFormCode?: string;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 发票状态
     */
    realStatus?: number;
    /**
     * 发票状态描述
     */
    realStatusDesc?: string;
    /**
     * 是否可以修改金额
     * 默认是可以修改
     */
    canChangeAmount?: boolean;
    /**
     * 费用信息是否已完善
     * true-已完善，false-未完善
     */
    feeInfoComplete?: boolean;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据订单编号生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383962) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByThirdOrderNo`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/genFeeByThirdOrderNo',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据订单编号生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383962) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByThirdOrderNo`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPostRequestConfig: ZlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/genFeeByThirdOrderNo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据订单编号生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383962) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByThirdOrderNo`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPost.requestConfig =
  zlbApiExpenseFeeExpenseFormGenFeeByThirdOrderNoPostRequestConfig;

/**
 * 接口 [根据订单编号自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383970) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCode/{applyFormCode}`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGetRequest {
  applyFormCode: string;
}

/**
 * 接口 [根据订单编号自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383970) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCode/{applyFormCode}`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType?: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用名称
     */
    feeName?: string;
    /**
     * 费用发生时间
     */
    consumeTime?: string;
    /**
     * 货币代码
     */
    currencyCode?: string;
    /**
     * 货币金额
     */
    amount?: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCode?: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments?: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的报销单号
     */
    expenseFormCode?: string;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 发票状态
     */
    realStatus?: number;
    /**
     * 发票状态描述
     */
    realStatusDesc?: string;
    /**
     * 是否可以修改金额
     * 默认是可以修改
     */
    canChangeAmount?: boolean;
    /**
     * 费用信息是否已完善
     * true-已完善，false-未完善
     */
    feeInfoComplete?: boolean;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据订单编号自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383970) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCode/{applyFormCode}`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/genFeeByApplyFormCode/{applyFormCode}',
    'data',
    'applyFormCode',
    string,
    false
  >
>;

/**
 * 接口 [根据订单编号自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383970) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCode/{applyFormCode}`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGetRequestConfig: ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/genFeeByApplyFormCode/{applyFormCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: ['applyFormCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据订单编号自动生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383970) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCode/{applyFormCode}`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGetResponse>(
    prepare(
      zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGetRequestConfig,
      requestData,
    ),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGet.requestConfig =
  zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodeApplyFormCodeGetRequestConfig;

/**
 * 接口 [讲课费校验↗](http://yapi.cai-inc.com/project/3621/interface/api/383978) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/teachFeeCheck`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormTeachFeeCheckPostRequest {
  /**
   * 金额
   */
  amount: number;
  /**
   * 培训人员职级
   */
  trainingPersonLevel: number;
  /**
   * 学时
   */
  trainingHour: number;
  /**
   * 培训天数
   */
  trainingDay: number;
  /**
   * 唯一编码
   */
  uniqueCode?: string;
}

/**
 * 接口 [讲课费校验↗](http://yapi.cai-inc.com/project/3621/interface/api/383978) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/teachFeeCheck`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormTeachFeeCheckPostResponse {
  success?: boolean;
  result?: {
    /**
     * 校验结果
     */
    result?: boolean;
    /**
     * 最大学时
     */
    maxTrainingHour?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
    /**
     * 唯一编码
     */
    uniqueCode?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [讲课费校验↗](http://yapi.cai-inc.com/project/3621/interface/api/383978) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/teachFeeCheck`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormTeachFeeCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/teachFeeCheck',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [讲课费校验↗](http://yapi.cai-inc.com/project/3621/interface/api/383978) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/teachFeeCheck`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormTeachFeeCheckPostRequestConfig: ZlbApiExpenseFeeExpenseFormTeachFeeCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/teachFeeCheck',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormTeachFeeCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [讲课费校验↗](http://yapi.cai-inc.com/project/3621/interface/api/383978) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/teachFeeCheck`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormTeachFeeCheckPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormTeachFeeCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormTeachFeeCheckPostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormTeachFeeCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormTeachFeeCheckPost.requestConfig =
  zlbApiExpenseFeeExpenseFormTeachFeeCheckPostRequestConfig;

/**
 * 接口 [计算短途包干费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383986) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormCalculateShortDistancePostRequest {
  /**
   * 起始区划code
   */
  startDistrictCode: string;
  /**
   * 出发地名称
   */
  startDistrictName?: string;
  /**
   * 结束区划code
   */
  endDistrictCode: string;
  /**
   * 结束地点名称
   */
  endDistrictName?: string;
  /**
   * 人数
   */
  operatorIds?: number[];
}

/**
 * 接口 [计算短途包干费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383986) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormCalculateShortDistancePostResponse {
  success?: boolean;
  result?: number;
  code?: string;
  message?: string;
}

/**
 * 接口 [计算短途包干费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383986) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormCalculateShortDistancePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/calculateShortDistance',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [计算短途包干费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383986) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormCalculateShortDistancePostRequestConfig: ZlbApiExpenseFeeExpenseFormCalculateShortDistancePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/calculateShortDistance',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormCalculateShortDistancePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [计算短途包干费用↗](http://yapi.cai-inc.com/project/3621/interface/api/383986) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormCalculateShortDistancePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormCalculateShortDistancePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormCalculateShortDistancePostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormCalculateShortDistancePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormCalculateShortDistancePost.requestConfig =
  zlbApiExpenseFeeExpenseFormCalculateShortDistancePostRequestConfig;

/**
 * 接口 [计算办公设备家具采购申请单限额↗](http://yapi.cai-inc.com/project/3621/interface/api/383994) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateFurnitureEequipment`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPostRequest {
  /**
   * 用户级别（办公家具填写）
   * 1-厅级 2-处级 3-处以下
   */
  userRank?: 1 | 2 | 3;
  /**
   * 资产品目
   */
  propertyItem: string;
  /**
   * 资产类型
   * 1-办公家具 2-办公设备
   */
  propertyType: string;
  /**
   * 会议桌时的容纳人数
   */
  userCount?: number;
}

/**
 * 接口 [计算办公设备家具采购申请单限额↗](http://yapi.cai-inc.com/project/3621/interface/api/383994) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateFurnitureEequipment`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPostResponse {
  success?: boolean;
  result?: number;
  code?: string;
  message?: string;
}

/**
 * 接口 [计算办公设备家具采购申请单限额↗](http://yapi.cai-inc.com/project/3621/interface/api/383994) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateFurnitureEequipment`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/calculateFurnitureEequipment',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [计算办公设备家具采购申请单限额↗](http://yapi.cai-inc.com/project/3621/interface/api/383994) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateFurnitureEequipment`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPostRequestConfig: ZlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/calculateFurnitureEequipment',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [计算办公设备家具采购申请单限额↗](http://yapi.cai-inc.com/project/3621/interface/api/383994) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/calculateFurnitureEequipment`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPost.requestConfig =
  zlbApiExpenseFeeExpenseFormCalculateFurnitureEequipmentPostRequestConfig;

/**
 * 接口 [根据费控规则获取文案↗](http://yapi.cai-inc.com/project/3621/interface/api/384002) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getNoteByFeeRule`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGetNoteByFeeRulePostRequest {
  /**
   * 出差类型
   */
  businessType: number;
  /**
   * 单据发起人operatorId
   * 公司使用浙里报，这个字段修改为传当前费用人员ID（可能是外部人员或者司机）
   */
  operatorId?: number;
  /**
   * 行程地址code列表
   */
  itineraryCityList: {
    /**
     * 出发地code
     */
    beginCityCode: string;
    /**
     * 目的地code
     */
    endCityCode: string;
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 截止时间
     */
    endTime: string;
  }[];
}

/**
 * 接口 [根据费控规则获取文案↗](http://yapi.cai-inc.com/project/3621/interface/api/384002) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getNoteByFeeRule`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGetNoteByFeeRulePostResponse {
  success?: boolean;
  result?: {
    key?: string[];
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [根据费控规则获取文案↗](http://yapi.cai-inc.com/project/3621/interface/api/384002) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getNoteByFeeRule`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGetNoteByFeeRulePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/getNoteByFeeRule',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据费控规则获取文案↗](http://yapi.cai-inc.com/project/3621/interface/api/384002) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getNoteByFeeRule`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGetNoteByFeeRulePostRequestConfig: ZlbApiExpenseFeeExpenseFormGetNoteByFeeRulePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/getNoteByFeeRule',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGetNoteByFeeRulePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据费控规则获取文案↗](http://yapi.cai-inc.com/project/3621/interface/api/384002) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getNoteByFeeRule`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGetNoteByFeeRulePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGetNoteByFeeRulePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGetNoteByFeeRulePostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGetNoteByFeeRulePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGetNoteByFeeRulePost.requestConfig =
  zlbApiExpenseFeeExpenseFormGetNoteByFeeRulePostRequestConfig;

/**
 * 接口 [根据申请单编号自动批量生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/384010) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCodes`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPostRequest {
  /**
   * 申请单编号
   */
  applyFormCodes?: string[];
}

/**
 * 接口 [根据申请单编号自动批量生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/384010) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCodes`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPostResponse {
  success?: boolean;
  result?: {
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType?: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用名称
     */
    feeName?: string;
    /**
     * 费用发生时间
     */
    consumeTime?: string;
    /**
     * 货币代码
     */
    currencyCode?: string;
    /**
     * 货币金额
     */
    amount?: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCode?: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments?: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的报销单号
     */
    expenseFormCode?: string;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 发票状态
     */
    realStatus?: number;
    /**
     * 发票状态描述
     */
    realStatusDesc?: string;
    /**
     * 是否可以修改金额
     * 默认是可以修改
     */
    canChangeAmount?: boolean;
    /**
     * 费用信息是否已完善
     * true-已完善，false-未完善
     */
    feeInfoComplete?: boolean;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据申请单编号自动批量生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/384010) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCodes`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/genFeeByApplyFormCodes',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据申请单编号自动批量生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/384010) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCodes`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPostRequestConfig: ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/genFeeByApplyFormCodes',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据申请单编号自动批量生成费用↗](http://yapi.cai-inc.com/project/3621/interface/api/384010) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/genFeeByApplyFormCodes`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPost.requestConfig =
  zlbApiExpenseFeeExpenseFormGenFeeByApplyFormCodesPostRequestConfig;

/**
 * 接口 [根据报销单号获取费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/384018) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/feeList/{expenseFormCode}`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordFeeListExpenseFormCodeGetRequest {
  expenseFormCode: string;
}

/**
 * 接口 [根据报销单号获取费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/384018) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/feeList/{expenseFormCode}`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeRecordFeeListExpenseFormCodeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 费用code
     */
    feeCode?: string;
    /**
     * 费用名称
     */
    feeName?: string;
    /**
     * 人员operatorId
     */
    operatorId?: number;
    /**
     * 费用类型
     */
    feeType: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用发生时间
     */
    consumeTime?: string;
    /**
     * 费用发生时间
     */
    consumeTimeDesc?: string;
    /**
     * 货币金额
     */
    amount: number;
    /**
     * 允许的最大金额
     */
    allowMaxAmount?: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市三级区划code
     */
    allDistrictCodes?: string[];
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 消费城市三级区划名称
     */
    allDistrictNames?: string[];
    /**
     * 关联的发票编号
     */
    invoiceCodes?: string[];
    /**
     * 关联发票的url
     */
    imageUrl?: string;
    /**
     * 浙里半票的url
     */
    zlbImageUrl?: string;
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 出差人
     */
    travelerName?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments?: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的报销单号
     */
    expenseFormCode?: string;
    /**
     * 费用状态描述
     */
    feeStatusDesc?: string;
    /**
     * 费用状态
     */
    feeStatus?: number;
    /**
     * 是否删除
     */
    canDelete?: boolean;
    /**
     * 机构名称
     */
    orgName?: string;
    /**
     * 发票是否验真
     */
    invoiceIsCheck?: boolean;
    /**
     * 发票验真描述
     */
    invoiceIsCheckDesc?: string;
    /**
     * 时长
     */
    travelDay?: number;
    /**
     * 时长描述
     */
    travelDayDesc?: string;
    /**
     * 是否费用有修改
     */
    feeModifyStatus?: boolean;
    /**
     * 费用调整记录
     */
    feeModifyRecordROS?: {
      /**
       * 原金额
       */
      originalAmount?: number;
      /**
       * 调整原因
       */
      updateReason?: string;
      /**
       * 更新人名字
       */
      updateOperatorName?: string;
      /**
       * 调整后金额
       */
      updateAmount?: number;
      /**
       * 调整时间
       */
      updateTime?: number;
    }[];
    /**
     * 打印时使用的fileId
     */
    printFileId?: string;
    /**
     * 费用备注
     */
    remark?: string;
    /**
     * 发票附件类型
     */
    attachmentMimeType?: string;
    /**
     * 发票状态
     */
    realStatus?: number;
    /**
     * 发票状态描述
     */
    realStatusDesc?: string;
    /**
     * 详细扩展信息
     */
    detailExtendDTO?: {
      /**
       * 详细列表页
       */
      expenseFeeDetailInfoList?: {
        /**
         * 前端需要参数
         */
        indexNo?: string;
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
        /**
         * 人员来源 1-系统内部；2-外部人员
         */
        userSource?: 1 | 2;
        userType?: number;
        type?: number;
        /**
         * 日期
         */
        date?: string;
        /**
         * 日期描述
         */
        dateDesc?: string;
        /**
         * 原始信息（当前补贴）
         */
        originalInfo?: {
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 区划code
           */
          districtCode?: string;
          /**
           * 区划名称
           */
          districtName?: string;
          /**
           * 是否派车
           */
          arrangeCar?: boolean;
          /**
           * 省内
           */
          innerProvince?: boolean;
          /**
           * 冲突业务编码
           */
          businessCode?: string;
          /**
           * 冲突单据编号
           */
          formCode?: string;
          /**
           * 冲突业务类型
           */
          businessType?: number;
          /**
           * 冲突业务类型描述
           */
          businessTypeDesc?: number;
          /**
           * 凭票报销
           */
          useInvoice?: boolean;
          /**
           * 扣减百分比
           */
          deductionPercent?: number;
          /**
           * 开启休息日扣减
           */
          enableRestDayDeduction?: boolean;
        };
        /**
         * 重复补贴
         */
        conflictInfoList?: {
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 区划code
           */
          districtCode?: string;
          /**
           * 区划名称
           */
          districtName?: string;
          /**
           * 是否派车
           */
          arrangeCar?: boolean;
          /**
           * 省内
           */
          innerProvince?: boolean;
          /**
           * 冲突业务编码
           */
          businessCode?: string;
          /**
           * 冲突单据编号
           */
          formCode?: string;
          /**
           * 冲突业务类型
           */
          businessType?: number;
          /**
           * 冲突业务类型描述
           */
          businessTypeDesc?: number;
          /**
           * 凭票报销
           */
          useInvoice?: boolean;
          /**
           * 扣减百分比
           */
          deductionPercent?: number;
          /**
           * 开启休息日扣减
           */
          enableRestDayDeduction?: boolean;
        }[];
        /**
         * 费用种类
         */
        feeCategory?: number;
        /**
         * 实际补贴金额
         */
        amount?: number;
        /**
         * 原始计算金额
         */
        originalAmount?: number;
        /**
         * 调整前金额
         */
        beforeChangeAmount?: number;
        /**
         * 冲突的金额
         */
        conflictAmount?: number;
        /**
         * 扣减金额
         */
        reductionAmount?: number;
        /**
         * 最大允许金额
         */
        allowMaxAmount?: number;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 是否发生变更
         */
        isChanged?: boolean;
      }[];
      /**
       * 冲突展示列表页
       */
      expenseFeeConflictList?: {
        /**
         * 业务编码
         */
        businessCode?: string;
        /**
         * 单据编号
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: number;
        /**
         * 业务类型
         */
        businessType?: number;
        /**
         * 业务类型描述
         */
        businessTypeDesc?: string;
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
        /**
         * 日期
         */
        date?: string;
        /**
         * 日期描述
         */
        dateDesc?: string;
        /**
         * 冲突信息
         */
        conflictInfo?: {
          /**
           * 日期
           */
          date?: string;
          /**
           * 日期描述
           */
          dateDesc?: string;
          /**
           * 金额
           */
          amount?: number;
          /**
           * 区划code
           */
          districtCode?: string;
          /**
           * 区划名称
           */
          districtName?: string;
          /**
           * 是否派车
           */
          arrangeCar?: boolean;
          /**
           * 省内
           */
          innerProvince?: boolean;
          /**
           * 冲突业务编码
           */
          businessCode?: string;
          /**
           * 冲突单据编号
           */
          formCode?: string;
          /**
           * 冲突业务类型
           */
          businessType?: number;
          /**
           * 冲突业务类型描述
           */
          businessTypeDesc?: number;
          /**
           * 凭票报销
           */
          useInvoice?: boolean;
          /**
           * 扣减百分比
           */
          deductionPercent?: number;
          /**
           * 开启休息日扣减
           */
          enableRestDayDeduction?: boolean;
        };
      }[];
      /**
       * 调整后金额
       */
      currentAmount?: number;
      /**
       * 原始金额
       */
      originalAmount?: number;
      /**
       * 费用类型
       */
      feeType?: number;
      /**
       * 火车金额
       */
      trainAmount?: number;
      /**
       * 总金额相等
       */
      totalAmountEquals?: boolean;
    };
    /**
     * 是否有版式文件
     */
    hasFormatFile?: boolean;
    amountDesc?: string;
    beginCity?: string;
    endCity?: string;
    /**
     * 由于beginCity endCity 在票据设置时使用，不清楚具体用来干啥，故不动他
     * 新增 printBeginCity printEndCity
     * 费用代码要优化了，现在掺杂了很多业务
     */
    printBeginCity?: string;
    printEndCity?: string;
    departureTime?: string;
    /**
     * 招待人数
     */
    entertainPeopleNumDesc?: string;
    /**
     * 招待时间
     */
    entertainDateDesc?: string;
    /**
     * 住宿天数
     */
    accommodationDaysDesc?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据报销单号获取费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/384018) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/feeList/{expenseFormCode}`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeRecordFeeListExpenseFormCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/record/feeList/{expenseFormCode}',
    'data',
    'expenseFormCode',
    string,
    false
  >
>;

/**
 * 接口 [根据报销单号获取费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/384018) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/feeList/{expenseFormCode}`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
const zlbApiExpenseFeeRecordFeeListExpenseFormCodeGetRequestConfig: ZlbApiExpenseFeeRecordFeeListExpenseFormCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/record/feeList/{expenseFormCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: ['expenseFormCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeRecordFeeListExpenseFormCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据报销单号获取费用列表↗](http://yapi.cai-inc.com/project/3621/interface/api/384018) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/record/feeList/{expenseFormCode}`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeRecordFeeListExpenseFormCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeRecordFeeListExpenseFormCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeRecordFeeListExpenseFormCodeGetResponse>(
    prepare(zlbApiExpenseFeeRecordFeeListExpenseFormCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeRecordFeeListExpenseFormCodeGet.requestConfig =
  zlbApiExpenseFeeRecordFeeListExpenseFormCodeGetRequestConfig;

/**
 * 接口 [根据行程获取数据↗](http://yapi.cai-inc.com/project/3621/interface/api/384026) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getFeeInvoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGetFeeInvoicePostRequest {
  /**
   * 行程信息
   */
  itineraryPOList?: {
    /**
     * 前端生成的编号
     */
    indexNo?: string;
    /**
     * 行程单编号
     * 更新时必填
     */
    itineraryCode?: string;
    /**
     * 原行程单号
     */
    originalItineraryCode?: string;
    /**
     * 出差人列表
     */
    accompanyList: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 开始上下午
     */
    beginTag: number;
    /**
     * 结束时间
     */
    endTime: string;
    /**
     * 结束上下午
     */
    endTag: number;
    /**
     * 出差天数
     */
    travelDay: number;
    /**
     * 是否派车 0不派车 1派车
     */
    arrangeCar: number;
    /**
     * 派车信息
     */
    arrangeCarPO?: {
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag: number;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag: number;
      /**
       * 派车天数
       */
      arrangeCarDay: number;
      /**
       * 乘车人
       */
      passengerList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
    };
    /**
     * 出发城市code
     */
    beginCityCode: string;
    /**
     * 出发城市名称
     */
    beginCityName: string;
    /**
     * 目的城市列表
     */
    endCityList: {
      /**
       * 目的城市code
       */
      endCityCode: string;
      /**
       * 目的城市名称
       */
      endCityName: string;
    }[];
    /**
     * 住宿天数
     */
    accommodationDay: number;
  }[];
  /**
   * 业务类型
   */
  businessType?: number;
}

/**
 * 接口 [根据行程获取数据↗](http://yapi.cai-inc.com/project/3621/interface/api/384026) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getFeeInvoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGetFeeInvoicePostResponse {
  success?: boolean;
  result?: string[];
  code?: string;
  message?: string;
}

/**
 * 接口 [根据行程获取数据↗](http://yapi.cai-inc.com/project/3621/interface/api/384026) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getFeeInvoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGetFeeInvoicePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/getFeeInvoice',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据行程获取数据↗](http://yapi.cai-inc.com/project/3621/interface/api/384026) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getFeeInvoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGetFeeInvoicePostRequestConfig: ZlbApiExpenseFeeExpenseFormGetFeeInvoicePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/getFeeInvoice',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGetFeeInvoicePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据行程获取数据↗](http://yapi.cai-inc.com/project/3621/interface/api/384026) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getFeeInvoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGetFeeInvoicePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGetFeeInvoicePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGetFeeInvoicePostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGetFeeInvoicePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGetFeeInvoicePost.requestConfig =
  zlbApiExpenseFeeExpenseFormGetFeeInvoicePostRequestConfig;

/**
 * 接口 [通用费用计算接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414250) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/calculate-fee`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormCalculateFeePostRequest {
  /**
   * 费用类型
   */
  feeCode:
    | 1001
    | 1002
    | 2001
    | 2002
    | 2003
    | 2004
    | 2005
    | 2006
    | 2007
    | 2008
    | 2009
    | 3001
    | 300101
    | 3002
    | 4001
    | 5001
    | 5000
    | 5002
    | 5003
    | 5004
    | 5005
    | 5006
    | 5007
    | 5008
    | 5009
    | 5010
    | 5011
    | 5012
    | 6000
    | 6001
    | 6002
    | 6003
    | 7000
    | 7001
    | 7002
    | 7003
    | 7004
    | 7005
    | 8888
    | 8001
    | 8002
    | 8003
    | 9999;
  /**
   * 自驾 - 公里数
   */
  mileage?: number;
  /**
   * 自驾是否往返
   */
  isRoundTrip?: boolean;
}

/**
 * 接口 [通用费用计算接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414250) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/calculate-fee`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormCalculateFeePostResponse {
  success?: boolean;
  result?: {
    /**
     * 费用类型
     */
    feeCode?:
      | 1001
      | 1002
      | 2001
      | 2002
      | 2003
      | 2004
      | 2005
      | 2006
      | 2007
      | 2008
      | 2009
      | 3001
      | 300101
      | 3002
      | 4001
      | 5001
      | 5000
      | 5002
      | 5003
      | 5004
      | 5005
      | 5006
      | 5007
      | 5008
      | 5009
      | 5010
      | 5011
      | 5012
      | 6000
      | 6001
      | 6002
      | 6003
      | 7000
      | 7001
      | 7002
      | 7003
      | 7004
      | 7005
      | 8888
      | 8001
      | 8002
      | 8003
      | 9999;
    /**
     * 结果金额
     */
    amount?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [通用费用计算接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414250) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/calculate-fee`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormCalculateFeePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expense-form/calculate-fee',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [通用费用计算接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414250) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/calculate-fee`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormCalculateFeePostRequestConfig: ZlbApiExpenseFeeExpenseFormCalculateFeePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expense-form/calculate-fee',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormCalculateFeePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [通用费用计算接口↗](http://yapi.cai-inc.com/project/3621/interface/api/414250) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/calculate-fee`
 * @更新时间 `2024-09-26 14:35:25`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormCalculateFeePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormCalculateFeePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormCalculateFeePostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormCalculateFeePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormCalculateFeePost.requestConfig =
  zlbApiExpenseFeeExpenseFormCalculateFeePostRequestConfig;

/**
 * 接口 [根据行程判断是否凭票↗](http://yapi.cai-inc.com/project/3621/interface/api/458202) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getEatFeeInvoiceInfo`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPostRequest {
  /**
   * 行程信息
   */
  itineraryPOList?: {
    /**
     * 前端生成的编号
     */
    indexNo?: string;
    /**
     * 行程单编号
     * 更新时必填
     */
    itineraryCode?: string;
    /**
     * 原行程单号
     */
    originalItineraryCode?: string;
    /**
     * 出差人列表
     */
    accompanyList: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 开始上下午
     */
    beginTag: number;
    /**
     * 结束时间
     */
    endTime: string;
    /**
     * 结束上下午
     */
    endTag: number;
    /**
     * 出差天数
     */
    travelDay: number;
    /**
     * 是否派车 0不派车 1派车
     */
    arrangeCar: number;
    /**
     * 派车信息
     */
    arrangeCarPO?: {
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag: number;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag: number;
      /**
       * 派车天数
       */
      arrangeCarDay: number;
      /**
       * 乘车人
       */
      passengerList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
    };
    /**
     * 出发城市code
     */
    beginCityCode: string;
    /**
     * 出发城市名称
     */
    beginCityName: string;
    /**
     * 目的城市列表
     */
    endCityList: {
      /**
       * 目的城市code
       */
      endCityCode: string;
      /**
       * 目的城市名称
       */
      endCityName: string;
    }[];
    /**
     * 住宿天数
     */
    accommodationDay: number;
  }[];
  /**
   * 业务类型
   */
  businessType?: number;
}

/**
 * 接口 [根据行程判断是否凭票↗](http://yapi.cai-inc.com/project/3621/interface/api/458202) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getEatFeeInvoiceInfo`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPostResponse {
  success?: boolean;
  result?: {
    /**
     * 行程编号list
     */
    indexNoList?: string[];
    /**
     * 备注信息
     */
    noteInfo?: string[];
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [根据行程判断是否凭票↗](http://yapi.cai-inc.com/project/3621/interface/api/458202) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getEatFeeInvoiceInfo`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/getEatFeeInvoiceInfo',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据行程判断是否凭票↗](http://yapi.cai-inc.com/project/3621/interface/api/458202) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getEatFeeInvoiceInfo`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPostRequestConfig: ZlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/getEatFeeInvoiceInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据行程判断是否凭票↗](http://yapi.cai-inc.com/project/3621/interface/api/458202) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/getEatFeeInvoiceInfo`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPost.requestConfig =
  zlbApiExpenseFeeExpenseFormGetEatFeeInvoiceInfoPostRequestConfig;

/**
 * 接口 [按照发票类型转换成费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/544522) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/get-feeType`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeGetFeeTypeGetRequest {
  /**
   * 发票类型
   */
  invoiceType?: string;
  /**
   * 发票平台id
   */
  platformInvoiceId?: string;
  /**
   * 内容
   */
  subItem?: string;
}

/**
 * 接口 [按照发票类型转换成费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/544522) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/get-feeType`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeGetFeeTypeGetResponse {
  success?: boolean;
  result?: {
    /**
     * 费用类型
     */
    feeType?: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用父类型
     */
    feeParentType?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [按照发票类型转换成费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/544522) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/get-feeType`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeGetFeeTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/get-feeType',
    'data',
    string,
    'invoiceType' | 'platformInvoiceId' | 'subItem',
    false
  >
>;

/**
 * 接口 [按照发票类型转换成费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/544522) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/get-feeType`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
const zlbApiExpenseFeeGetFeeTypeGetRequestConfig: ZlbApiExpenseFeeGetFeeTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/get-feeType',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: ['invoiceType', 'platformInvoiceId', 'subItem'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeGetFeeTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [按照发票类型转换成费用类型↗](http://yapi.cai-inc.com/project/3621/interface/api/544522) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `GET /zlb/api/expense/fee/get-feeType`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeGetFeeTypeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeGetFeeTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeGetFeeTypeGetResponse>(
    prepare(zlbApiExpenseFeeGetFeeTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeGetFeeTypeGet.requestConfig = zlbApiExpenseFeeGetFeeTypeGetRequestConfig;

/**
 * 接口 [计算短途包干费用 批量↗](http://yapi.cai-inc.com/project/3621/interface/api/655242) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/batch/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePostRequest {
  /**
   * 行程基本信息
   */
  shortDistancePOList?: {
    /**
     * 起始区划code
     */
    startDistrictCode: string;
    /**
     * 出发地名称
     */
    startDistrictName?: string;
    /**
     * 结束区划code
     */
    endDistrictCode: string;
    /**
     * 结束地点名称
     */
    endDistrictName?: string;
    /**
     * 人数
     */
    operatorIds?: number[];
  }[];
  /**
   * 人数
   */
  operatorIds?: number[];
  /**
   * 是否往返
   */
  travelBack: boolean;
}

/**
 * 接口 [计算短途包干费用 批量↗](http://yapi.cai-inc.com/project/3621/interface/api/655242) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/batch/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePostResponse {
  success?: boolean;
  result?: {
    /**
     * 费用金额
     */
    totalAmount?: number;
    itineraryInfoROList?: {
      /**
       * 起始区划code
       */
      startDistrictCode?: string;
      /**
       * 出发地名称
       */
      startDistrictName?: string;
      /**
       * 结束地点名称
       */
      endDistrictName?: string;
      /**
       * 结束区划code
       */
      endDistrictCode?: string;
      /**
       * 费用标准
       */
      amount?: number;
    }[];
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [计算短途包干费用 批量↗](http://yapi.cai-inc.com/project/3621/interface/api/655242) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/batch/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expenseForm/batch/calculateShortDistance',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [计算短途包干费用 批量↗](http://yapi.cai-inc.com/project/3621/interface/api/655242) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/batch/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePostRequestConfig: ZlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expenseForm/batch/calculateShortDistance',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [计算短途包干费用 批量↗](http://yapi.cai-inc.com/project/3621/interface/api/655242) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expenseForm/batch/calculateShortDistance`
 * @更新时间 `2024-09-26 14:35:24`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePost.requestConfig =
  zlbApiExpenseFeeExpenseFormBatchCalculateShortDistancePostRequestConfig;

/**
 * 接口 [一般事项根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/707554) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGeneralGenByInvoicePostRequest {
  /**
   * 发票code
   */
  platformInvoiceIdList?: string[];
  /**
   * 票据来源：zlb-浙里报 zlbp-浙里办票
   */
  businessCode?: string;
  /**
   * 神坑需求--
   * 人员映射不上时，强制要求行程唯一人员情况下，
   * 映射人员信息，后来小心
   */
  operatorInfoDTO?: {
    /**
     * 人员id
     */
    operatorId: number;
    /**
     * 人员名称
     */
    operatorName: string;
    /**
     * 机构id
     */
    institutionId?: number;
    /**
     * 机构名称
     */
    institutionName?: string;
    /**
     * 外部人员职级
     * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
     */
    outerUserRank?: number;
    /**
     * 人员类型
     * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
     */
    userType?: number;
    userId?: number;
    userName?: string;
    bankCardInfo?: {
      /**
       * 银行代码
       */
      bankCode: string;
      /**
       * 银行名字
       */
      bankName: string;
      /**
       * 账户名称
       */
      accountName: string;
      /**
       * 银行账号
       */
      bankAccount: string;
      /**
       * 银行账号 脱敏
       */
      bankAccountDesc?: string;
      /**
       * 卡号保存的唯一标识
       */
      accountCode?: string;
    };
    /**
     * 同一个人员，绑定的id
     */
    bindOperatorId?: number;
    /**
     * 用户类型
     * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
     */
    type: number;
    /**
     * 用户职级,
     * 内部用户的职级，外部用户关联内部用户，取内部用户职级
     * 否则去外部用户职级
     */
    userRank?: string;
    /**
     * 手机号
     */
    mobile?: string;
    /**
     * 证件号码
     */
    idCard?: string;
    /**
     * 证件类型
     */
    idType?: number;
    /**
     * 性别
     */
    gender?: number;
    /**
     * 同行人费用code
     */
    feeCode?: string;
  };
  /**
   * 多票费用的时候传
   */
  feeType?: number;
  /**
   * 多票费用的时候传
   */
  feeTypeDesc?: string;
}

/**
 * 接口 [一般事项根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/707554) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGeneralGenByInvoicePostResponse {
  success?: boolean;
  result?: {
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType?: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用名称
     */
    feeName?: string;
    /**
     * 费用发生时间
     */
    consumeTime?: string;
    /**
     * 货币代码
     */
    currencyCode?: string;
    /**
     * 货币金额
     */
    amount?: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCode?: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments?: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的报销单号
     */
    expenseFormCode?: string;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 发票状态
     */
    realStatus?: number;
    /**
     * 发票状态描述
     */
    realStatusDesc?: string;
    /**
     * 是否可以修改金额
     * 默认是可以修改
     */
    canChangeAmount?: boolean;
    /**
     * 费用信息是否已完善
     * true-已完善，false-未完善
     */
    feeInfoComplete?: boolean;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [一般事项根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/707554) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGeneralGenByInvoicePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expense-form/general/gen-by-invoice',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [一般事项根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/707554) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGeneralGenByInvoicePostRequestConfig: ZlbApiExpenseFeeExpenseFormGeneralGenByInvoicePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expense-form/general/gen-by-invoice',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGeneralGenByInvoicePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [一般事项根据发票列表获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/707554) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-invoice`
 * @更新时间 `2024-09-26 14:35:26`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGeneralGenByInvoicePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGeneralGenByInvoicePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGeneralGenByInvoicePostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGeneralGenByInvoicePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGeneralGenByInvoicePost.requestConfig =
  zlbApiExpenseFeeExpenseFormGeneralGenByInvoicePostRequestConfig;

/**
 * 接口 [一般事项根据扣款凭证获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/710186) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-debit-note`
 * @更新时间 `2024-11-04 11:23:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePostRequest {
  /**
   * 扣款凭证code
   */
  formCodeList: string[];
}

/**
 * 接口 [一般事项根据扣款凭证获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/710186) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-debit-note`
 * @更新时间 `2024-11-04 11:23:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePostResponse {
  success?: boolean;
  result?: {
    /**
     * 记录的费用code
     */
    feeCode?: string;
    /**
     * 所属机构id
     */
    operatorOrgId?: number;
    /**
     * 所属机构名称
     */
    operatorOrgName?: string;
    /**
     * 费用类型
     */
    feeType?: number;
    /**
     * 费用类型描述
     */
    feeTypeDesc?: string;
    /**
     * 费用名称
     */
    feeName?: string;
    /**
     * 费用发生时间
     */
    consumeTime?: string;
    /**
     * 货币代码
     */
    currencyCode?: string;
    /**
     * 货币金额
     */
    amount?: number;
    /**
     * 消费城市区划
     */
    districtCode?: string;
    /**
     * 消费城市名称
     */
    districtName?: string;
    /**
     * 关联的发票编号
     */
    invoiceCode?: string[];
    /**
     * 关联的出差人
     */
    accompanyPerson?: {
      /**
       * 人员id
       */
      operatorId: number;
      /**
       * 人员名称
       */
      operatorName: string;
      /**
       * 机构id
       */
      institutionId?: number;
      /**
       * 机构名称
       */
      institutionName?: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
       */
      userType?: number;
      userId?: number;
      userName?: string;
      bankCardInfo?: {
        /**
         * 银行代码
         */
        bankCode: string;
        /**
         * 银行名字
         */
        bankName: string;
        /**
         * 账户名称
         */
        accountName: string;
        /**
         * 银行账号
         */
        bankAccount: string;
        /**
         * 银行账号 脱敏
         */
        bankAccountDesc?: string;
        /**
         * 卡号保存的唯一标识
         */
        accountCode?: string;
      };
      /**
       * 同一个人员，绑定的id
       */
      bindOperatorId?: number;
      /**
       * 用户类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type: number;
      /**
       * 用户职级,
       * 内部用户的职级，外部用户关联内部用户，取内部用户职级
       * 否则去外部用户职级
       */
      userRank?: string;
      /**
       * 手机号
       */
      mobile?: string;
      /**
       * 证件号码
       */
      idCard?: string;
      /**
       * 证件类型
       */
      idType?: number;
      /**
       * 性别
       */
      gender?: number;
      /**
       * 同行人费用code
       */
      feeCode?: string;
    }[];
    /**
     * 材料数据
     */
    materialInfo?: {
      /**
       * 凭票报销伙食类补贴信息
       */
      allowanceMaterialByInvoiceDTO?: {
        /**
         * 关联行程编号
         */
        associateItineraryList: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
        }[];
        /**
         * 补贴发生日期
         */
        allowanceHappenDates: string[];
        /**
         * 城市名称s(无用，纯属兼容前端，别删除)
         */
        endCityName?: string;
      };
      /**
       * 住宿类材料信息
       */
      hotelMaterialDTO?: {
        /**
         * 酒店入住开始时间
         */
        hotelEnterTime?: string;
        /**
         * 酒店入住结束时间
         */
        hotelLeaveTime?: string;
        /**
         * 住宿天数
         */
        accommodationDays?: number;
      };
      /**
       * 交通类材料信息
       */
      trafficMaterialDTO?: {
        /**
         * 座位类别
         */
        seatType?: number;
        /**
         * 座位枚举描述
         */
        seatDesc?: string;
        /**
         * 出发地区划code
         */
        fromDistrictCode: string;
        /**
         * 出发地区划名称
         */
        fromDistrictName: string;
        /**
         * 结束地区划code
         */
        endDistrictCode: string;
        /**
         * 结束地区划名称
         */
        endDistrictName: string;
        /**
         * 火车时长码
         */
        trainDurationCode?: number;
        /**
         * 火车时长
         */
        trainDurationDesc?: string;
        /**
         * 出发日期
         */
        departureTime: string;
        /**
         * 公里数
         */
        mileage: number;
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
      };
      /**
       * 补贴类材料
       */
      allowanceMaterialDTO?: {
        /**
         * 总的费用金额
         */
        totalAmount?: number;
        /**
         * 费用标准细项
         */
        itemList?: {
          /**
           * 标准金额
           */
          standardAmount?: number;
          /**
           * 时间-天数
           */
          days?: number;
          /**
           * 费用描述
           */
          ruleDesc?: string;
        }[];
        /**
         * 火车补贴伙食费用细项
         */
        trainAllowanceMaterialDTOS?: {
          /**
           * 火车天数
           */
          trainHours?: number;
          /**
           * 火车补贴金额
           */
          trainStanardAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
          /**
           * 用户ID
           */
          operatorId?: number;
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
        }[];
        /**
         * 火车总额度
         */
        trainTotalAmount?: number;
        /**
         * 是否派车
         */
        isCar?: boolean;
        /**
         * 派车铺贴计算
         */
        carAllowanceMaterialDTOS?: {
          /**
           * 派车天数
           */
          carDays?: number;
          /**
           * 派车金额
           */
          carStandardtotalAmount?: number;
          /**
           * 规则描述
           */
          ruleDesc?: string;
        }[];
      };
      /**
       * 通用类材料信息
       */
      meetingOrTrainMaterialDTO?: {
        /**
         * 标准金额
         */
        standardAmount?: number;
        /**
         * 时间-天数
         */
        days?: number;
        /**
         * 会议类型
         */
        meetingType?: number;
        /**
         * 费用描述
         */
        ruleDesc?: string;
        /**
         * 培训人员
         */
        trainingPerson?: string;
        /**
         * 培训人员职级
         */
        trainingPersonLevel?: number;
        /**
         * 培训人员职级
         */
        trainingPersonLevelDesc?: string;
        /**
         * 培训时长
         */
        trainingHour?: number;
      };
      /**
       * 业务招待材料信息
       */
      businessEntertainingMaterial?: {
        /**
         * 招待日期
         */
        entertainDate?: string;
        /**
         * 招待形式
         */
        entertainForm: 1 | 2 | 3;
        /**
         * 招待形式描述
         */
        entertainFormDesc?: '自助餐' | '桌餐' | '商务餐';
        /**
         * 招待人数
         */
        entertainPeopleNum: number;
        /**
         * 招待事由
         */
        entertainReason: string;
      };
      /**
       * 交通费-租车费材料信息
       */
      rentCarFeeMaterial?: {
        /**
         * 租车申请单信息
         */
        rentCarApplyForm?: {
          /**
           * 业务单据号
           */
          businessNo?: string;
          /**
           * 申请编号
           */
          applyFormCode?: string;
          /**
           * 用车人（前端回显）
           */
          carUserList?: {
            /**
             * 人员id
             */
            operatorId: number;
            /**
             * 人员名称
             */
            operatorName: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 外部人员职级
             * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
             */
            outerUserRank?: number;
            /**
             * 人员类型
             * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、 6-司机 99-其他
             */
            userType?: number;
            userId?: number;
            userName?: string;
            bankCardInfo?: {
              /**
               * 银行代码
               */
              bankCode: string;
              /**
               * 银行名字
               */
              bankName: string;
              /**
               * 账户名称
               */
              accountName: string;
              /**
               * 银行账号
               */
              bankAccount: string;
              /**
               * 银行账号 脱敏
               */
              bankAccountDesc?: string;
              /**
               * 卡号保存的唯一标识
               */
              accountCode?: string;
            };
            /**
             * 同一个人员，绑定的id
             */
            bindOperatorId?: number;
            /**
             * 用户类型
             * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
             */
            type: number;
            /**
             * 用户职级,
             * 内部用户的职级，外部用户关联内部用户，取内部用户职级
             * 否则去外部用户职级
             */
            userRank?: string;
            /**
             * 手机号
             */
            mobile?: string;
            /**
             * 证件号码
             */
            idCard?: string;
            /**
             * 证件类型
             */
            idType?: number;
            /**
             * 性别
             */
            gender?: number;
            /**
             * 同行人费用code
             */
            feeCode?: string;
          }[];
          /**
           * 预计金额（前端回显）
           */
          planAmount?: number;
          /**
           * 申请事由（前端回显）
           */
          applyReason?: string;
          /**
           * 经办人名称（前端回显）
           */
          operatorName?: string;
          /**
           * 目的地列表（前端回显）
           */
          endCityList?: {
            /**
             * 目的城市code
             */
            endCityCode: string;
            /**
             * 目的城市名称
             */
            endCityName: string;
          }[];
        }[];
        /**
         * 目的地
         */
        destination?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 消费日期
         */
        consumeDate?: string[];
      };
      /**
       * 基础行程类信息
       */
      batchItineraryMaterialDTO?: {
        /**
         * 行程基本信息
         */
        itineraryMaterialDTOList?: {
          /**
           * 行程序列编号（行程模块前端生成的唯一键）
           */
          indexNo?: string;
          /**
           * 行程编码(没有可不填)
           */
          itineraryCode?: string;
          /**
           * 起始区划code
           */
          startDistrictCode: string;
          /**
           * 出发地名称
           */
          startDistrictName?: string;
          /**
           * 结束区划code
           */
          endDistrictCode: string;
          /**
           * 结束地点名称
           */
          endDistrictName?: string;
          /**
           * 人数
           */
          operatorIds?: number[];
        }[];
        /**
         * 自驾是否往返
         */
        isRoundTrip: boolean;
        /**
         * 人数
         */
        operatorIds?: number[];
      };
      /**
       * 修改备注
       */
      remark?: string;
      /**
       * 费用说明
       */
      feeDesc?: string;
      /**
       * 是否多票
       */
      multiInvoice?: boolean;
      /**
       * 关联的单据的编号
       */
      associateFormList?: {
        /**
         * 单据code
         */
        formCode?: string;
        /**
         * 单据类型
         */
        formType?: string;
      }[];
    };
    /**
     * 费用附件
     */
    attachments?: {
      fileId: string;
      fileType?: string;
      fileName: string;
      fileSize?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      downloadUrl?: string;
    }[];
    /**
     * 关联的报销单号
     */
    expenseFormCode?: string;
    /**
     * 平台订单编号
     */
    platformOrderNo?: string;
    /**
     * 发票状态
     */
    realStatus?: number;
    /**
     * 发票状态描述
     */
    realStatusDesc?: string;
    /**
     * 是否可以修改金额
     * 默认是可以修改
     */
    canChangeAmount?: boolean;
    /**
     * 费用信息是否已完善
     * true-已完善，false-未完善
     */
    feeInfoComplete?: boolean;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [一般事项根据扣款凭证获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/710186) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-debit-note`
 * @更新时间 `2024-11-04 11:23:49`
 * @项目ID 3621
 */
type ZlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/fee/expense-form/general/gen-by-debit-note',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [一般事项根据扣款凭证获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/710186) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-debit-note`
 * @更新时间 `2024-11-04 11:23:49`
 * @项目ID 3621
 */
const zlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePostRequestConfig: ZlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: '/zlb/api/expense/fee/expense-form/general/gen-by-debit-note',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [一般事项根据扣款凭证获取费用↗](http://yapi.cai-inc.com/project/3621/interface/api/710186) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [我的费用↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_50265)
 * @请求头 `POST /zlb/api/expense/fee/expense-form/general/gen-by-debit-note`
 * @更新时间 `2024-11-04 11:23:49`
 * @项目ID 3621
 */
export const zlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePostResponse>(
    prepare(zlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePost.requestConfig =
  zlbApiExpenseFeeExpenseFormGeneralGenByDebitNotePostRequestConfig;

const mockUrl_0_1_0_16 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_16 = '' as any;
const prodUrl_0_1_0_16 = '' as any;
const dataKey_0_1_0_16 = 'data' as any;

/**
 * 接口 [查询预算审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/431282) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/list`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 项目编码
   */
  projectCode?: string;
  /**
   * 审报状态（-1：驳回，0：待填报，1：待审核，2：通过）
   */
  reportStatus?: number;
  /**
   * 履约填报状态（0：待填报，1：已填报）
   */
  promiseFillInStatus?: number;
  /**
   * 报备时间
   */
  rAddTime?: string;
}

/**
 * 接口 [查询预算审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/431282) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/list`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 审报code
       */
      reportCode?: string;
      /**
       * 事项code
       */
      eventCode?: string;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 项目编码
       */
      projectCode?: string;
      /**
       * 项目类别
       */
      projectCategory?: string;
      /**
       * 目录编码
       */
      catalogCode?: string;
      /**
       * 申报事项
       */
      catalogName?: string;
      /**
       * 预算金额
       */
      amount?: number;
      /**
       * 审报状态（0：待填报，1：待审核，2：通过，3：驳回）
       */
      reportStatus?: number;
      /**
       * 履约填报状态（0：待填报，1：已填报）
       */
      promiseFillInStatus?: number;
      promiseFillInStatusDesc?: string;
      /**
       * 审报状态描述
       */
      reportStatusDesc?: string;
      operateButton?: {
        /**
         * 查看按钮
         */
        detail?: boolean;
        /**
         * 编辑按钮
         */
        edit?: boolean;
        /**
         * 删除按钮
         */
        remove?: boolean;
        /**
         * 填报按钮
         */
        report?: boolean;
        /**
         * 重新填报按钮
         */
        newReport?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询预算审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/431282) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/list`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetReportListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/report/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询预算审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/431282) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/list`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetReportListPostRequestConfig: ZlbApiExpenseBudgetReportListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: '/zlb/api/expense/budget/report/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetReportListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询预算审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/431282) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/list`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetReportListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetReportListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetReportListPostResponse>(
    prepare(zlbApiExpenseBudgetReportListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetReportListPost.requestConfig = zlbApiExpenseBudgetReportListPostRequestConfig;

/**
 * 接口 [查询审报详情↗](http://yapi.cai-inc.com/project/3621/interface/api/431290) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/detail/{reportCode}`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportDetailReportCodeGetRequest {
  reportCode: string;
}

/**
 * 接口 [查询审报详情↗](http://yapi.cai-inc.com/project/3621/interface/api/431290) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/detail/{reportCode}`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportDetailReportCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 业务code
     */
    reportCode?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 项目编码
     */
    projectCode?: string;
    /**
     * 项目类别
     */
    projectCategory?: string;
    /**
     * 项目类型
     */
    projectType?: number;
    /**
     * 项目类型描述
     */
    projectTypeDesc?: string;
    /**
     * 项目开始时间
     */
    projectStartTime?: string;
    /**
     * 项目结束时间
     */
    projectEndTime?: string;
    /**
     * 项目负责人
     */
    projectMainPerson?: string;
    /**
     * 联系电话
     */
    phone?: string;
    /**
     * 预算金额
     */
    amount?: number;
    /**
     * 测算依据
     */
    evaluativeBasis?: string;
    /**
     * 项目概况
     */
    projectIntroduction?: string;
    /**
     * 绩效目标
     */
    performanceGoals?: string;
    /**
     * 审报状态（0：待填报，1：待审核，2：通过，3：驳回）
     */
    reportStatus?: number;
    /**
     * 履约填报状态（0：待填报，1：已填报）
     */
    promiseFillInStatus?: number;
    /**
     * 绩效指标
     */
    performanceBudget?: {
      /**
       * 审报业务code
       */
      reportCode?: string;
      /**
       * 一级指标
       */
      oneName: string;
      /**
       * 二级指标
       */
      twoName: string;
      /**
       * 三级指标
       */
      threeName: string;
      /**
       * 指标内容
       */
      budgetContent: string;
      /**
       * 指标值
       */
      budgetValue: string;
      /**
       * 备注
       */
      remark: string;
      /**
       * 预计完成时间
       */
      estimateTime: string;
      /**
       * 实际完成时间
       */
      realTime?: string;
      /**
       * 指标占比
       */
      proportion: number;
      /**
       * 完成情况
       */
      rate: string;
      /**
       * 评分
       */
      grade?: number;
      /**
       * 评分说明
       */
      gradeDesc?: string;
      /**
       * 排序
       */
      sort: number;
    }[];
    /**
     * 是否展示变更按钮
     */
    isChange?: boolean;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询审报详情↗](http://yapi.cai-inc.com/project/3621/interface/api/431290) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/detail/{reportCode}`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetReportDetailReportCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/report/detail/{reportCode}',
    'data',
    'reportCode',
    string,
    false
  >
>;

/**
 * 接口 [查询审报详情↗](http://yapi.cai-inc.com/project/3621/interface/api/431290) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/detail/{reportCode}`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetReportDetailReportCodeGetRequestConfig: ZlbApiExpenseBudgetReportDetailReportCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: '/zlb/api/expense/budget/report/detail/{reportCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: ['reportCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetReportDetailReportCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询审报详情↗](http://yapi.cai-inc.com/project/3621/interface/api/431290) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/detail/{reportCode}`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetReportDetailReportCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetReportDetailReportCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetReportDetailReportCodeGetResponse>(
    prepare(zlbApiExpenseBudgetReportDetailReportCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetReportDetailReportCodeGet.requestConfig =
  zlbApiExpenseBudgetReportDetailReportCodeGetRequestConfig;

/**
 * 接口 [删除审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431298) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/delete`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportDeletePostRequest {
  reportCode: string;
}

/**
 * 接口 [删除审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431298) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/delete`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431298) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/delete`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetReportDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/report/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431298) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/delete`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetReportDeletePostRequestConfig: ZlbApiExpenseBudgetReportDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: '/zlb/api/expense/budget/report/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetReportDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431298) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/delete`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetReportDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetReportDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetReportDeletePostResponse>(
    prepare(zlbApiExpenseBudgetReportDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetReportDeletePost.requestConfig =
  zlbApiExpenseBudgetReportDeletePostRequestConfig;

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431306) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportEditPostRequest {
  /**
   * 业务code
   */
  reportCode: string;
  /**
   * 项目类型
   */
  projectType: number;
  /**
   * 项目开始时间
   */
  projectStartTime: string;
  /**
   * 项目结束时间
   */
  projectEndTime: string;
  /**
   * 项目负责人
   */
  projectMainPerson: string;
  /**
   * 联系电话
   */
  phone: string;
  /**
   * 预算金额
   */
  amount: number;
  /**
   * 绩效目标
   */
  performanceGoals: string;
  /**
   * 绩效指标
   */
  performanceBudget: {
    /**
     * 审报业务code
     */
    reportCode?: string;
    /**
     * 一级指标
     */
    oneName: string;
    /**
     * 二级指标
     */
    twoName: string;
    /**
     * 三级指标
     */
    threeName: string;
    /**
     * 指标内容
     */
    budgetContent: string;
    /**
     * 指标值
     */
    budgetValue: string;
    /**
     * 备注
     */
    remark: string;
    /**
     * 预计完成时间
     */
    estimateTime: string;
    /**
     * 实际完成时间
     */
    realTime?: string;
    /**
     * 指标占比
     */
    proportion: number;
    /**
     * 完成情况
     */
    rate: string;
    /**
     * 评分
     */
    grade?: number;
    /**
     * 评分说明
     */
    gradeDesc?: string;
    /**
     * 排序
     */
    sort: number;
  }[];
}

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431306) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportEditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431306) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetReportEditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/report/edit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431306) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetReportEditPostRequestConfig: ZlbApiExpenseBudgetReportEditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: '/zlb/api/expense/budget/report/edit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetReportEditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/431306) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetReportEditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetReportEditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetReportEditPostResponse>(
    prepare(zlbApiExpenseBudgetReportEditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetReportEditPost.requestConfig = zlbApiExpenseBudgetReportEditPostRequestConfig;

/**
 * 接口 [变更审报金额↗](http://yapi.cai-inc.com/project/3621/interface/api/431314) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/change-amount`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportChangeAmountPostRequest {
  reportCode: string;
  /**
   * 变更金额
   */
  amount: number;
  userInfoDTO?: {
    /**
     * 用户ID
     */
    userId?: number;
    /**
     * 操作员ID
     */
    operatorId?: number;
    /**
     * 用户类别
     * 需手动获取
     */
    userType?: string;
    /**
     * 操作员姓名
     */
    operatorName?: string;
    /**
     * 机构ID
     */
    institutionId?: number;
    tenantCode?: string;
    /**
     * 用户来源：1、系统内部人员；2-外部人员
     */
    userSource?: number;
    bankCardInfo?: {
      /**
       * 银行代码
       */
      bankCode: string;
      /**
       * 银行名字
       */
      bankName: string;
      /**
       * 账户名称
       */
      accountName: string;
      /**
       * 银行账号
       */
      bankAccount: string;
      /**
       * 银行账号 脱敏
       */
      bankAccountDesc?: string;
      /**
       * 卡号保存的唯一标识
       */
      accountCode?: string;
    };
    /**
     * 区分是否为宁波用户
     */
    isNingBo?: boolean;
  };
}

/**
 * 接口 [变更审报金额↗](http://yapi.cai-inc.com/project/3621/interface/api/431314) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/change-amount`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportChangeAmountPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [变更审报金额↗](http://yapi.cai-inc.com/project/3621/interface/api/431314) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/change-amount`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetReportChangeAmountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/report/change-amount',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [变更审报金额↗](http://yapi.cai-inc.com/project/3621/interface/api/431314) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/change-amount`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetReportChangeAmountPostRequestConfig: ZlbApiExpenseBudgetReportChangeAmountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: '/zlb/api/expense/budget/report/change-amount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetReportChangeAmountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [变更审报金额↗](http://yapi.cai-inc.com/project/3621/interface/api/431314) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/change-amount`
 * @更新时间 `2024-02-26 09:46:15`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetReportChangeAmountPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetReportChangeAmountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetReportChangeAmountPostResponse>(
    prepare(zlbApiExpenseBudgetReportChangeAmountPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetReportChangeAmountPost.requestConfig =
  zlbApiExpenseBudgetReportChangeAmountPostRequestConfig;

/**
 * 接口 [查询审报项目类型↗](http://yapi.cai-inc.com/project/3621/interface/api/431642) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/query-project-type`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportQueryProjectTypeGetRequest {}

/**
 * 接口 [查询审报项目类型↗](http://yapi.cai-inc.com/project/3621/interface/api/431642) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/query-project-type`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportQueryProjectTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    projectType?: number;
    projectTypeName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询审报项目类型↗](http://yapi.cai-inc.com/project/3621/interface/api/431642) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/query-project-type`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetReportQueryProjectTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/report/query-project-type',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询审报项目类型↗](http://yapi.cai-inc.com/project/3621/interface/api/431642) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/query-project-type`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetReportQueryProjectTypeGetRequestConfig: ZlbApiExpenseBudgetReportQueryProjectTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: '/zlb/api/expense/budget/report/query-project-type',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetReportQueryProjectTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询审报项目类型↗](http://yapi.cai-inc.com/project/3621/interface/api/431642) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `GET /zlb/api/expense/budget/report/query-project-type`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetReportQueryProjectTypeGet = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseBudgetReportQueryProjectTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetReportQueryProjectTypeGetResponse>(
    prepare(zlbApiExpenseBudgetReportQueryProjectTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetReportQueryProjectTypeGet.requestConfig =
  zlbApiExpenseBudgetReportQueryProjectTypeGetRequestConfig;

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/493242) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit-promise-fill`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportEditPromiseFillPostRequest {
  /**
   * 业务code
   */
  reportCode: string;
  /**
   * 项目类型
   */
  projectType: number;
  /**
   * 项目开始时间
   */
  projectStartTime: string;
  /**
   * 项目结束时间
   */
  projectEndTime: string;
  /**
   * 项目负责人
   */
  projectMainPerson: string;
  /**
   * 联系电话
   */
  phone: string;
  /**
   * 预算金额
   */
  amount: number;
  /**
   * 绩效目标
   */
  performanceGoals: string;
  /**
   * 绩效指标
   */
  performanceBudget: {
    /**
     * 审报业务code
     */
    reportCode?: string;
    /**
     * 一级指标
     */
    oneName: string;
    /**
     * 二级指标
     */
    twoName: string;
    /**
     * 三级指标
     */
    threeName: string;
    /**
     * 指标内容
     */
    budgetContent: string;
    /**
     * 指标值
     */
    budgetValue: string;
    /**
     * 备注
     */
    remark: string;
    /**
     * 预计完成时间
     */
    estimateTime: string;
    /**
     * 实际完成时间
     */
    realTime?: string;
    /**
     * 指标占比
     */
    proportion: number;
    /**
     * 完成情况
     */
    rate: string;
    /**
     * 评分
     */
    grade?: number;
    /**
     * 评分说明
     */
    gradeDesc?: string;
    /**
     * 排序
     */
    sort: number;
  }[];
}

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/493242) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit-promise-fill`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportEditPromiseFillPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/493242) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit-promise-fill`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetReportEditPromiseFillPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/report/edit-promise-fill',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/493242) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit-promise-fill`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetReportEditPromiseFillPostRequestConfig: ZlbApiExpenseBudgetReportEditPromiseFillPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: '/zlb/api/expense/budget/report/edit-promise-fill',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetReportEditPromiseFillPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑审报↗](http://yapi.cai-inc.com/project/3621/interface/api/493242) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/edit-promise-fill`
 * @更新时间 `2024-02-26 09:46:16`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetReportEditPromiseFillPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetReportEditPromiseFillPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetReportEditPromiseFillPostResponse>(
    prepare(zlbApiExpenseBudgetReportEditPromiseFillPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetReportEditPromiseFillPost.requestConfig =
  zlbApiExpenseBudgetReportEditPromiseFillPostRequestConfig;

/**
 * 接口 [查询预算履约审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/497810) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/query-promise-page`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportQueryPromisePagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 项目编码
   */
  projectCode?: string;
  /**
   * 审报状态（-1：驳回，0：待填报，1：待审核，2：通过）
   */
  reportStatus?: number;
  /**
   * 履约填报状态（0：待填报，1：已填报）
   */
  promiseFillInStatus?: number;
  /**
   * 报备时间
   */
  rAddTime?: string;
}

/**
 * 接口 [查询预算履约审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/497810) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/query-promise-page`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetReportQueryPromisePagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 审报code
       */
      reportCode?: string;
      /**
       * 事项code
       */
      eventCode?: string;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 项目编码
       */
      projectCode?: string;
      /**
       * 项目类别
       */
      projectCategory?: string;
      /**
       * 目录编码
       */
      catalogCode?: string;
      /**
       * 申报事项
       */
      catalogName?: string;
      /**
       * 预算金额
       */
      amount?: number;
      /**
       * 审报状态（0：待填报，1：待审核，2：通过，3：驳回）
       */
      reportStatus?: number;
      /**
       * 履约填报状态（0：待填报，1：已填报）
       */
      promiseFillInStatus?: number;
      promiseFillInStatusDesc?: string;
      /**
       * 审报状态描述
       */
      reportStatusDesc?: string;
      operateButton?: {
        /**
         * 查看按钮
         */
        detail?: boolean;
        /**
         * 编辑按钮
         */
        edit?: boolean;
        /**
         * 删除按钮
         */
        remove?: boolean;
        /**
         * 填报按钮
         */
        report?: boolean;
        /**
         * 重新填报按钮
         */
        newReport?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询预算履约审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/497810) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/query-promise-page`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetReportQueryPromisePagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget/report/query-promise-page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询预算履约审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/497810) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/query-promise-page`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetReportQueryPromisePagePostRequestConfig: ZlbApiExpenseBudgetReportQueryPromisePagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: '/zlb/api/expense/budget/report/query-promise-page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetReportQueryPromisePagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询预算履约审报列表↗](http://yapi.cai-inc.com/project/3621/interface/api/497810) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [BudgetReportController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_51236)
 * @请求头 `POST /zlb/api/expense/budget/report/query-promise-page`
 * @更新时间 `2024-02-26 09:46:14`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetReportQueryPromisePagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetReportQueryPromisePagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetReportQueryPromisePagePostResponse>(
    prepare(zlbApiExpenseBudgetReportQueryPromisePagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetReportQueryPromisePagePost.requestConfig =
  zlbApiExpenseBudgetReportQueryPromisePagePostRequestConfig;

const mockUrl_0_1_0_17 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_17 = '' as any;
const prodUrl_0_1_0_17 = '' as any;
const dataKey_0_1_0_17 = 'data' as any;

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/483482) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit-list`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowAuditListPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 审批状态
   */
  auditStatusList?: number[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 部门ID
   */
  departmentId?: number;
  /**
   * 申请事由
   */
  reason?: string;
  /**
   * 起始时间
   */
  beginTime?: number;
  /**
   * 结束时间
   */
  endTime?: number;
  /**
   * 发起人名字
   */
  operatorName?: string;
}

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/483482) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit-list`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowAuditListPostResponse {
  success?: boolean;
  result?: {
    total?: number;
    data?: {
      /**
       * 批量发放唯一编号
       */
      batchDistributeCode?: string;
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 单据类型：0-个人；1-企业；
       */
      batchDistributeType?: number;
      batchDistributeTypeDesc?: string;
      /**
       * 发起人ID
       */
      operatorId?: number;
      /**
       * 发起人姓名
       */
      operatorName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 单位ID
       */
      orgId?: number;
      /**
       * 部门名称
       */
      departmentName?: string;
      /**
       * 部门ID
       */
      departmentId?: number;
      /**
       * 事由
       */
      reason?: string;
      /**
       * 发放总金额
       */
      distributeAmount?: number;
      /**
       * 提交时间
       */
      submitTime?: string;
      /**
       * 审核状态
       */
      auditStatus?: 0 | 1 | 2 | 3;
      /**
       * 审核状态描述
       */
      auditStatusDesc?: string;
      /**
       * 审批节点类型
       */
      taskNodeEvent?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/483482) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit-list`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeWorkflowAuditListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/workflow/audit-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/483482) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit-list`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeWorkflowAuditListPostRequestConfig: ZlbApiExpenseBatchDistributeWorkflowAuditListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_17,
    devUrl: devUrl_0_1_0_17,
    prodUrl: prodUrl_0_1_0_17,
    path: '/zlb/api/expense/batch-distribute/workflow/audit-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeWorkflowAuditListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审批列表分页↗](http://yapi.cai-inc.com/project/3621/interface/api/483482) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit-list`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeWorkflowAuditListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeWorkflowAuditListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeWorkflowAuditListPostResponse>(
    prepare(zlbApiExpenseBatchDistributeWorkflowAuditListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeWorkflowAuditListPost.requestConfig =
  zlbApiExpenseBatchDistributeWorkflowAuditListPostRequestConfig;

/**
 * 接口 [审核↗](http://yapi.cai-inc.com/project/3621/interface/api/483490) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowAuditPostRequest {
  /**
   * 工作流审核数据
   */
  workflowInfo?: {
    /**
     * 业务单号
     */
    bizId?: string;
    /**
     * 业务场景
     */
    bizType?: string;
    /**
     * 业务子类型
     */
    subType?: string;
    /**
     * 审核意见
     */
    auditRemark?: string;
    /**
     * 审核状态：1-通过；2-驳回；
     */
    executeType: number;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: string;
    /**
     * 当前节点key
     */
    currentNodeKey: string;
    /**
     * 操作人
     */
    operatorId?: number;
    /**
     * 业务字段
     */
    context?: string;
    /**
     * 事件类型：0-审批，1-审核，2-出纳
     */
    eventType: number;
    /**
     * 签名附件
     */
    signAttachment?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
    };
  };
  /**
   * 批量发放唯一编号
   */
  batchDistributeCode?: string;
}

/**
 * 接口 [审核↗](http://yapi.cai-inc.com/project/3621/interface/api/483490) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowAuditPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [审核↗](http://yapi.cai-inc.com/project/3621/interface/api/483490) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeWorkflowAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/workflow/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审核↗](http://yapi.cai-inc.com/project/3621/interface/api/483490) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeWorkflowAuditPostRequestConfig: ZlbApiExpenseBatchDistributeWorkflowAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_17,
    devUrl: devUrl_0_1_0_17,
    prodUrl: prodUrl_0_1_0_17,
    path: '/zlb/api/expense/batch-distribute/workflow/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeWorkflowAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审核↗](http://yapi.cai-inc.com/project/3621/interface/api/483490) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/audit`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeWorkflowAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeWorkflowAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeWorkflowAuditPostResponse>(
    prepare(zlbApiExpenseBatchDistributeWorkflowAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeWorkflowAuditPost.requestConfig =
  zlbApiExpenseBatchDistributeWorkflowAuditPostRequestConfig;

/**
 * 接口 [查询批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/484882) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/query`
 * @更新时间 `2023-06-16 15:31:01`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowQueryPostRequest {
  /**
   * 业务单号
   */
  businessNo?: string;
  /**
   * 单据类型：1-申请单，2-报销单，4-工资发放申请单
   */
  formType?: string;
  /**
   * 工作流业务key
   */
  workflowProcessKey: string;
  /**
   * 工作流模型id
   */
  workflowModelId?: string;
  /**
   * 工作流版本号
   */
  workflowVersion?: string;
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 金额
   */
  amount?: string;
  /**
   * 部门ID
   */
  departmentId?: string;
}

/**
 * 接口 [查询批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/484882) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/query`
 * @更新时间 `2023-06-16 15:31:01`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowQueryPostResponse {
  success?: boolean;
  result?: {
    auditNodeList?: {
      auditOperatorList?: {
        operatorId?: number;
        operatorName?: string;
        institutionId?: number;
        institutionName?: string;
        auditRemark?: string;
        auditStatus?: number;
        auditTime?: string;
        signAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        oneselfHistorySignAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
      }[];
      userRangeType?: number;
      userRangeTypeNew?: number;
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      personCount?: number;
      auditStatus?: number;
      auditTime?: string;
      auditDesc?: string;
      auditType?: number;
      eventType?: number;
      nodeType?: number;
      nodeKey?: string;
      nodeName?: string;
      checkStrategy?: number;
      departmentId?: number;
      institutionSelfDtos?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      commonAuditorList?: {
        displayName?: string;
        userId?: number;
        operatorId?: number;
        code?: string;
        gender?: number;
        institutionId?: number;
        institution?: {
          id?: number;
          createdAt?: number;
          updatedAt?: number;
          creatorId?: string;
          modifierId?: string;
          extFields?: string;
          name?: string;
          shortName?: string;
          orgCode?: string;
          creditCode?: string;
          bizAttaches?: string;
          tags?: string;
          provinceCode?: string;
          provinceName?: string;
          cityCode?: string;
          cityName?: string;
          regionCode?: string;
          regionName?: string;
          address?: string;
          status?: number;
          displayOrder?: number;
          outCreatedAt?: string;
          divisionCode?: string;
          fullName?: string;
          postalCode?: string;
          source?: number;
          organizationCode?: string;
          institutionLevel?: number;
        };
        deptName?: string;
      }[];
    }[];
    workflowProcessKey?: string;
    workflowModelId?: number;
    workflowVersion?: number;
    applyOperatorId?: number;
    applyOperatorName?: string;
    applyTime?: string;
    applyRemark?: string;
    isAddTaskAccess?: number;
    formType?: number;
    isEnableSign?: boolean;
    signConfig?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/484882) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/query`
 * @更新时间 `2023-06-16 15:31:01`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeWorkflowQueryPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/workflow/query',
    'data',
    string,
    | 'businessNo'
    | 'formType'
    | 'workflowProcessKey'
    | 'workflowModelId'
    | 'workflowVersion'
    | 'formCode'
    | 'amount'
    | 'departmentId',
    false
  >
>;

/**
 * 接口 [查询批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/484882) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/query`
 * @更新时间 `2023-06-16 15:31:01`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeWorkflowQueryPostRequestConfig: ZlbApiExpenseBatchDistributeWorkflowQueryPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_17,
    devUrl: devUrl_0_1_0_17,
    prodUrl: prodUrl_0_1_0_17,
    path: '/zlb/api/expense/batch-distribute/workflow/query',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_17,
    paramNames: [],
    queryNames: [
      'businessNo',
      'formType',
      'workflowProcessKey',
      'workflowModelId',
      'workflowVersion',
      'formCode',
      'amount',
      'departmentId',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeWorkflowQueryPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/484882) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/query`
 * @更新时间 `2023-06-16 15:31:01`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeWorkflowQueryPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeWorkflowQueryPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeWorkflowQueryPostResponse>(
    prepare(zlbApiExpenseBatchDistributeWorkflowQueryPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeWorkflowQueryPost.requestConfig =
  zlbApiExpenseBatchDistributeWorkflowQueryPostRequestConfig;

/**
 * 接口 [撤回工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/488706) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/revoke`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowRevokePostRequest {
  batchDistributeCode: string;
  /**
   * 可选, 备注：审批意见&撤回说明
   */
  remark?: string;
}

/**
 * 接口 [撤回工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/488706) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/revoke`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowRevokePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [撤回工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/488706) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/revoke`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeWorkflowRevokePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/workflow/revoke',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [撤回工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/488706) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/revoke`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeWorkflowRevokePostRequestConfig: ZlbApiExpenseBatchDistributeWorkflowRevokePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_17,
    devUrl: devUrl_0_1_0_17,
    prodUrl: prodUrl_0_1_0_17,
    path: '/zlb/api/expense/batch-distribute/workflow/revoke',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeWorkflowRevokePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [撤回工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/488706) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/revoke`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeWorkflowRevokePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeWorkflowRevokePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeWorkflowRevokePostResponse>(
    prepare(zlbApiExpenseBatchDistributeWorkflowRevokePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeWorkflowRevokePost.requestConfig =
  zlbApiExpenseBatchDistributeWorkflowRevokePostRequestConfig;

/**
 * 接口 [addTask↗](http://yapi.cai-inc.com/project/3621/interface/api/488802) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/add-task`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowAddTaskPostRequest {
  /**
   * 业务标识
   */
  bizId: string;
  /**
   * 当前审批节点key
   */
  curTaskDefineKey?: string;
  /**
   * 加签人
   */
  operatorIds?: number[];
  /**
   * 必填, 业务场景
   */
  bizType: string;
  /**
   * 必填, 子类型
   */
  subType?: string;
  /**
   * 必填, 前加签 后加签
   */
  countersignType?: number;
  remark?: string;
  /**
   * 业务上下文
   */
  context?: string;
  operatorId?: number;
}

/**
 * 接口 [addTask↗](http://yapi.cai-inc.com/project/3621/interface/api/488802) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/add-task`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeWorkflowAddTaskPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [addTask↗](http://yapi.cai-inc.com/project/3621/interface/api/488802) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/add-task`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeWorkflowAddTaskPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/workflow/add-task',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [addTask↗](http://yapi.cai-inc.com/project/3621/interface/api/488802) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/add-task`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeWorkflowAddTaskPostRequestConfig: ZlbApiExpenseBatchDistributeWorkflowAddTaskPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_17,
    devUrl: devUrl_0_1_0_17,
    prodUrl: prodUrl_0_1_0_17,
    path: '/zlb/api/expense/batch-distribute/workflow/add-task',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeWorkflowAddTaskPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [addTask↗](http://yapi.cai-inc.com/project/3621/interface/api/488802) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放工作流↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52218)
 * @请求头 `POST /zlb/api/expense/batch-distribute/workflow/add-task`
 * @更新时间 `2023-06-21 15:19:33`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeWorkflowAddTaskPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeWorkflowAddTaskPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeWorkflowAddTaskPostResponse>(
    prepare(zlbApiExpenseBatchDistributeWorkflowAddTaskPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeWorkflowAddTaskPost.requestConfig =
  zlbApiExpenseBatchDistributeWorkflowAddTaskPostRequestConfig;

const mockUrl_0_1_0_18 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_18 = '' as any;
const prodUrl_0_1_0_18 = '' as any;
const dataKey_0_1_0_18 = 'data' as any;

/**
 * 接口 [app单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502370) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form`
 * @更新时间 `2024-11-14 13:49:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageAppFormPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 审核状态
   */
  auditStatusList?: (0 | 1 | 2)[];
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 不查询的单据类型
   */
  excludeFormType?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 业务单据类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
}

/**
 * 接口 [app单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502370) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form`
 * @更新时间 `2024-11-14 13:49:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageAppFormPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [app单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502370) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form`
 * @更新时间 `2024-11-14 13:49:47`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageAppFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/app/form',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [app单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502370) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form`
 * @更新时间 `2024-11-14 13:49:47`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageAppFormPostRequestConfig: ZlbApiExpenseSearchPageAppFormPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/app/form',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageAppFormPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [app单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502370) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form`
 * @更新时间 `2024-11-14 13:49:47`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageAppFormPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageAppFormPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageAppFormPostResponse>(
    prepare(zlbApiExpenseSearchPageAppFormPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageAppFormPost.requestConfig = zlbApiExpenseSearchPageAppFormPostRequestConfig;

/**
 * 接口 [app审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502378) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageAppFormAuditPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 审核状态
   */
  auditStatusList?: (0 | 1 | 2)[];
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 不查询的单据类型
   */
  excludeFormType?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 业务单据类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
}

/**
 * 接口 [app审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502378) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageAppFormAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [app审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502378) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageAppFormAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/app/form-audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [app审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502378) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageAppFormAuditPostRequestConfig: ZlbApiExpenseSearchPageAppFormAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/app/form-audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageAppFormAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [app审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502378) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageAppFormAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageAppFormAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageAppFormAuditPostResponse>(
    prepare(zlbApiExpenseSearchPageAppFormAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageAppFormAuditPost.requestConfig =
  zlbApiExpenseSearchPageAppFormAuditPostRequestConfig;

/**
 * 接口 [web单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502386) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 发起人id
   */
  submitterIdList?: number[];
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 机构ID列表
   */
  orgIdList?: number[];
  /**
   * 部门ID列表
   */
  deptIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否已打印
   */
  printStatus?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 场景类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 申请支付时间范围
   */
  payApplyTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 支付状态
   */
  payStatusList?: (0 | 10 | 20 | 30 | 31 | 50)[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 金额范围
   */
  amountRange?: {
    /**
     * 最小金额
     */
    minAmount?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
  };
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 是否有可用金额（采购场景）
   * true：有可用金额；false：无可用金额
   */
  isRemaining?: boolean;
  /**
   * 是否是测试单据
   */
  isTestForm?: boolean;
  /**
   * 采购状态
   */
  purchaseStatus?: number;
  /**
   * 支付渠道
   */
  payMode?: number;
  /**
   * 是否是管理员
   */
  isAdmin?: boolean;
  /**
   * 支付完成时间
   */
  payFinishTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 同行人
   */
  accompanyList?: number[];
  /**
   * 仅查看待复核数据
   */
  onlyViewRecheck?: boolean;
  /**
   * 绑定的报销单
   */
  bindExpenseFormList?: string[];
  /**
   * 绑定的申请单
   */
  bindApplyFormList?: string[];
}

/**
 * 接口 [web单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502386) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [web单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502386) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageWebFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/web/form',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [web单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502386) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageWebFormPostRequestConfig: ZlbApiExpenseSearchPageWebFormPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/web/form',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageWebFormPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [web单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502386) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageWebFormPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageWebFormPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageWebFormPostResponse>(
    prepare(zlbApiExpenseSearchPageWebFormPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageWebFormPost.requestConfig = zlbApiExpenseSearchPageWebFormPostRequestConfig;

/**
 * 接口 [web审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502394) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormAuditPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 发起人id
   */
  submitterIdList?: number[];
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 机构ID列表
   */
  orgIdList?: number[];
  /**
   * 部门ID列表
   */
  deptIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否已打印
   */
  printStatus?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 场景类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 申请支付时间范围
   */
  payApplyTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 支付状态
   */
  payStatusList?: (0 | 10 | 20 | 30 | 31 | 50)[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 金额范围
   */
  amountRange?: {
    /**
     * 最小金额
     */
    minAmount?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
  };
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 是否有可用金额（采购场景）
   * true：有可用金额；false：无可用金额
   */
  isRemaining?: boolean;
  /**
   * 是否是测试单据
   */
  isTestForm?: boolean;
  /**
   * 采购状态
   */
  purchaseStatus?: number;
  /**
   * 支付渠道
   */
  payMode?: number;
  /**
   * 是否是管理员
   */
  isAdmin?: boolean;
  /**
   * 支付完成时间
   */
  payFinishTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 同行人
   */
  accompanyList?: number[];
  /**
   * 仅查看待复核数据
   */
  onlyViewRecheck?: boolean;
  /**
   * 绑定的报销单
   */
  bindExpenseFormList?: string[];
  /**
   * 绑定的申请单
   */
  bindApplyFormList?: string[];
}

/**
 * 接口 [web审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502394) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [web审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502394) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageWebFormAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/web/form-audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [web审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502394) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageWebFormAuditPostRequestConfig: ZlbApiExpenseSearchPageWebFormAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/web/form-audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageWebFormAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [web审核列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502394) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageWebFormAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageWebFormAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageWebFormAuditPostResponse>(
    prepare(zlbApiExpenseSearchPageWebFormAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageWebFormAuditPost.requestConfig =
  zlbApiExpenseSearchPageWebFormAuditPostRequestConfig;

/**
 * 接口 [web出纳列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502402) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-cashier`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormCashierPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 发起人id
   */
  submitterIdList?: number[];
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 机构ID列表
   */
  orgIdList?: number[];
  /**
   * 部门ID列表
   */
  deptIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否已打印
   */
  printStatus?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 场景类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 申请支付时间范围
   */
  payApplyTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 支付状态
   */
  payStatusList?: (0 | 10 | 20 | 30 | 31 | 50)[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 金额范围
   */
  amountRange?: {
    /**
     * 最小金额
     */
    minAmount?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
  };
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 是否有可用金额（采购场景）
   * true：有可用金额；false：无可用金额
   */
  isRemaining?: boolean;
  /**
   * 是否是测试单据
   */
  isTestForm?: boolean;
  /**
   * 采购状态
   */
  purchaseStatus?: number;
  /**
   * 支付渠道
   */
  payMode?: number;
  /**
   * 是否是管理员
   */
  isAdmin?: boolean;
  /**
   * 支付完成时间
   */
  payFinishTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 同行人
   */
  accompanyList?: number[];
  /**
   * 仅查看待复核数据
   */
  onlyViewRecheck?: boolean;
  /**
   * 绑定的报销单
   */
  bindExpenseFormList?: string[];
  /**
   * 绑定的申请单
   */
  bindApplyFormList?: string[];
}

/**
 * 接口 [web出纳列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502402) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-cashier`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormCashierPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [web出纳列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502402) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-cashier`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageWebFormCashierPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/web/form-cashier',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [web出纳列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502402) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-cashier`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageWebFormCashierPostRequestConfig: ZlbApiExpenseSearchPageWebFormCashierPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/web/form-cashier',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageWebFormCashierPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [web出纳列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502402) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-cashier`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageWebFormCashierPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageWebFormCashierPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageWebFormCashierPostResponse>(
    prepare(zlbApiExpenseSearchPageWebFormCashierPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageWebFormCashierPost.requestConfig =
  zlbApiExpenseSearchPageWebFormCashierPostRequestConfig;

/**
 * 接口 [web财务列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502410) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-finance`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormFinancePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 发起人id
   */
  submitterIdList?: number[];
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 机构ID列表
   */
  orgIdList?: number[];
  /**
   * 部门ID列表
   */
  deptIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否已打印
   */
  printStatus?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 场景类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 申请支付时间范围
   */
  payApplyTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 支付状态
   */
  payStatusList?: (0 | 10 | 20 | 30 | 31 | 50)[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 金额范围
   */
  amountRange?: {
    /**
     * 最小金额
     */
    minAmount?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
  };
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 是否有可用金额（采购场景）
   * true：有可用金额；false：无可用金额
   */
  isRemaining?: boolean;
  /**
   * 是否是测试单据
   */
  isTestForm?: boolean;
  /**
   * 采购状态
   */
  purchaseStatus?: number;
  /**
   * 支付渠道
   */
  payMode?: number;
  /**
   * 是否是管理员
   */
  isAdmin?: boolean;
  /**
   * 支付完成时间
   */
  payFinishTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 同行人
   */
  accompanyList?: number[];
  /**
   * 仅查看待复核数据
   */
  onlyViewRecheck?: boolean;
  /**
   * 绑定的报销单
   */
  bindExpenseFormList?: string[];
  /**
   * 绑定的申请单
   */
  bindApplyFormList?: string[];
}

/**
 * 接口 [web财务列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502410) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-finance`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormFinancePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [web财务列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502410) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-finance`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageWebFormFinancePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/web/form-finance',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [web财务列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502410) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-finance`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageWebFormFinancePostRequestConfig: ZlbApiExpenseSearchPageWebFormFinancePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/web/form-finance',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageWebFormFinancePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [web财务列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502410) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-finance`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageWebFormFinancePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageWebFormFinancePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageWebFormFinancePostResponse>(
    prepare(zlbApiExpenseSearchPageWebFormFinancePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageWebFormFinancePost.requestConfig =
  zlbApiExpenseSearchPageWebFormFinancePostRequestConfig;

/**
 * 接口 [web运营列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502418) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-operate`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormOperatePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 发起人id
   */
  submitterIdList?: number[];
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 机构ID列表
   */
  orgIdList?: number[];
  /**
   * 部门ID列表
   */
  deptIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否已打印
   */
  printStatus?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 场景类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 申请支付时间范围
   */
  payApplyTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 支付状态
   */
  payStatusList?: (0 | 10 | 20 | 30 | 31 | 50)[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 金额范围
   */
  amountRange?: {
    /**
     * 最小金额
     */
    minAmount?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
  };
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 是否有可用金额（采购场景）
   * true：有可用金额；false：无可用金额
   */
  isRemaining?: boolean;
  /**
   * 是否是测试单据
   */
  isTestForm?: boolean;
  /**
   * 采购状态
   */
  purchaseStatus?: number;
  /**
   * 支付渠道
   */
  payMode?: number;
  /**
   * 是否是管理员
   */
  isAdmin?: boolean;
  /**
   * 支付完成时间
   */
  payFinishTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 同行人
   */
  accompanyList?: number[];
  /**
   * 仅查看待复核数据
   */
  onlyViewRecheck?: boolean;
  /**
   * 绑定的报销单
   */
  bindExpenseFormList?: string[];
  /**
   * 绑定的申请单
   */
  bindApplyFormList?: string[];
}

/**
 * 接口 [web运营列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502418) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-operate`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormOperatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [web运营列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502418) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-operate`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageWebFormOperatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/web/form-operate',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [web运营列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502418) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-operate`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageWebFormOperatePostRequestConfig: ZlbApiExpenseSearchPageWebFormOperatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/web/form-operate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageWebFormOperatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [web运营列表↗](http://yapi.cai-inc.com/project/3621/interface/api/502418) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-operate`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageWebFormOperatePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageWebFormOperatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageWebFormOperatePostResponse>(
    prepare(zlbApiExpenseSearchPageWebFormOperatePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageWebFormOperatePost.requestConfig =
  zlbApiExpenseSearchPageWebFormOperatePostRequestConfig;

/**
 * 接口 [web审核列表_copy↗](http://yapi.cai-inc.com/project/3621/interface/api/510626) 的 **请求类型**
 *
 * @状态 未完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit_1691112904237`
 * @更新时间 `2023-08-04 09:35:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormAudit_1691112904237PostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  /**
   * 发起人id
   */
  submitterIdList?: number[];
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 机构ID列表
   */
  orgIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否已打印
   */
  printStatus?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 单据类型
   */
  formTypeList?: string[];
  /**
   * 场景类型
   */
  sceneTypeList?: string[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据状态
   */
  formStatusList?: number[];
  /**
   * 支付状态
   */
  payStatusList?: number[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 发起人
   */
  userTypeList?: number[];
  /**
   * 金额范围
   */
  amountRange?: {
    /**
     * 最小金额
     */
    minAmount?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
  };
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否是测试单据
   */
  isTestForm?: boolean;
}

/**
 * 接口 [web审核列表_copy↗](http://yapi.cai-inc.com/project/3621/interface/api/510626) 的 **返回类型**
 *
 * @状态 未完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit_1691112904237`
 * @更新时间 `2023-08-04 09:35:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormAudit_1691112904237PostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'generalForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?: '申请单' | '报销单' | '工资申报' | '收入登记' | '用印申请' | '普通业务' | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资'
        | '收入'
        | '批量发放'
        | '资产管理'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'generalForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
        }[];
      }[];
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行人' | '转交' | '抄送';
      }[];
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [web审核列表_copy↗](http://yapi.cai-inc.com/project/3621/interface/api/510626) 的 **请求配置的类型**
 *
 * @状态 未完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit_1691112904237`
 * @更新时间 `2023-08-04 09:35:04`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageWebFormAudit_1691112904237PostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/web/form-audit_1691112904237',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [web审核列表_copy↗](http://yapi.cai-inc.com/project/3621/interface/api/510626) 的 **请求配置**
 *
 * @状态 未完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit_1691112904237`
 * @更新时间 `2023-08-04 09:35:04`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageWebFormAudit_1691112904237PostRequestConfig: ZlbApiExpenseSearchPageWebFormAudit_1691112904237PostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/web/form-audit_1691112904237',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageWebFormAudit_1691112904237Post',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [web审核列表_copy↗](http://yapi.cai-inc.com/project/3621/interface/api/510626) 的 **请求函数**
 *
 * @状态 未完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-audit_1691112904237`
 * @更新时间 `2023-08-04 09:35:04`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageWebFormAudit_1691112904237Post = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageWebFormAudit_1691112904237PostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageWebFormAudit_1691112904237PostResponse>(
    prepare(zlbApiExpenseSearchPageWebFormAudit_1691112904237PostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageWebFormAudit_1691112904237Post.requestConfig =
  zlbApiExpenseSearchPageWebFormAudit_1691112904237PostRequestConfig;

/**
 * 接口 [查询收款账户复核的单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545570) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-receiver-recheck`
 * @更新时间 `2023-10-08 16:43:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageAppFormReceiverRecheckPostRequest {
  /**
   * 复核状态 1-待复核 2-已复核
   */
  status?: number;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询收款账户复核的单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545570) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-receiver-recheck`
 * @更新时间 `2023-10-08 16:43:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageAppFormReceiverRecheckPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一code
       */
      formCode?: string;
      /**
       * 单据业务单号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'generalForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '资产管理'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 单据事由
       */
      reason?: string;
      /**
       * 提交人
       */
      submitterName?: string;
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 前端展示时间
       */
      time?: string;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 用户类别
       */
      userTypeList?: (1 | 2 | 3 | 4)[];
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 操作按钮
       */
      button?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核
         */
        recheck?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询收款账户复核的单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545570) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-receiver-recheck`
 * @更新时间 `2023-10-08 16:43:42`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageAppFormReceiverRecheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/app/form-receiver-recheck',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询收款账户复核的单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545570) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-receiver-recheck`
 * @更新时间 `2023-10-08 16:43:42`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageAppFormReceiverRecheckPostRequestConfig: ZlbApiExpenseSearchPageAppFormReceiverRecheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/app/form-receiver-recheck',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageAppFormReceiverRecheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询收款账户复核的单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/545570) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/form-receiver-recheck`
 * @更新时间 `2023-10-08 16:43:42`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageAppFormReceiverRecheckPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageAppFormReceiverRecheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageAppFormReceiverRecheckPostResponse>(
    prepare(zlbApiExpenseSearchPageAppFormReceiverRecheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageAppFormReceiverRecheckPost.requestConfig =
  zlbApiExpenseSearchPageAppFormReceiverRecheckPostRequestConfig;

/**
 * 接口 [web采购专项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-purchase`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormPurchasePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 发起人id
   */
  submitterIdList?: number[];
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 机构ID列表
   */
  orgIdList?: number[];
  /**
   * 部门ID列表
   */
  deptIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否已打印
   */
  printStatus?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 场景类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 申请支付时间范围
   */
  payApplyTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 支付状态
   */
  payStatusList?: (0 | 10 | 20 | 30 | 31 | 50)[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 金额范围
   */
  amountRange?: {
    /**
     * 最小金额
     */
    minAmount?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
  };
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 是否有可用金额（采购场景）
   * true：有可用金额；false：无可用金额
   */
  isRemaining?: boolean;
  /**
   * 是否是测试单据
   */
  isTestForm?: boolean;
  /**
   * 采购状态
   */
  purchaseStatus?: number;
  /**
   * 支付渠道
   */
  payMode?: number;
  /**
   * 是否是管理员
   */
  isAdmin?: boolean;
  /**
   * 支付完成时间
   */
  payFinishTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 同行人
   */
  accompanyList?: number[];
  /**
   * 仅查看待复核数据
   */
  onlyViewRecheck?: boolean;
  /**
   * 绑定的报销单
   */
  bindExpenseFormList?: string[];
  /**
   * 绑定的申请单
   */
  bindApplyFormList?: string[];
}

/**
 * 接口 [web采购专项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-purchase`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebFormPurchasePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [web采购专项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-purchase`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageWebFormPurchasePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/web/form-purchase',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [web采购专项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-purchase`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageWebFormPurchasePostRequestConfig: ZlbApiExpenseSearchPageWebFormPurchasePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/web/form-purchase',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageWebFormPurchasePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [web采购专项列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/form-purchase`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageWebFormPurchasePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageWebFormPurchasePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageWebFormPurchasePostResponse>(
    prepare(zlbApiExpenseSearchPageWebFormPurchasePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageWebFormPurchasePost.requestConfig =
  zlbApiExpenseSearchPageWebFormPurchasePostRequestConfig;

/**
 * 接口 [web夜餐费单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/night-meal-pay`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebNightMealPayPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 发起人id
   */
  submitterIdList?: number[];
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 机构ID列表
   */
  orgIdList?: number[];
  /**
   * 部门ID列表
   */
  deptIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否已打印
   */
  printStatus?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 场景类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 申请支付时间范围
   */
  payApplyTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 支付状态
   */
  payStatusList?: (0 | 10 | 20 | 30 | 31 | 50)[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 金额范围
   */
  amountRange?: {
    /**
     * 最小金额
     */
    minAmount?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
  };
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 是否有可用金额（采购场景）
   * true：有可用金额；false：无可用金额
   */
  isRemaining?: boolean;
  /**
   * 是否是测试单据
   */
  isTestForm?: boolean;
  /**
   * 采购状态
   */
  purchaseStatus?: number;
  /**
   * 支付渠道
   */
  payMode?: number;
  /**
   * 是否是管理员
   */
  isAdmin?: boolean;
  /**
   * 支付完成时间
   */
  payFinishTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 同行人
   */
  accompanyList?: number[];
  /**
   * 仅查看待复核数据
   */
  onlyViewRecheck?: boolean;
  /**
   * 绑定的报销单
   */
  bindExpenseFormList?: string[];
  /**
   * 绑定的申请单
   */
  bindApplyFormList?: string[];
}

/**
 * 接口 [web夜餐费单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/night-meal-pay`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebNightMealPayPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [web夜餐费单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/night-meal-pay`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageWebNightMealPayPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/web/night-meal-pay',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [web夜餐费单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/night-meal-pay`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageWebNightMealPayPostRequestConfig: ZlbApiExpenseSearchPageWebNightMealPayPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/web/night-meal-pay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageWebNightMealPayPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [web夜餐费单据列表↗](http://yapi.cai-inc.com/project/3621/interface/api/624058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/night-meal-pay`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageWebNightMealPayPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageWebNightMealPayPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageWebNightMealPayPostResponse>(
    prepare(zlbApiExpenseSearchPageWebNightMealPayPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageWebNightMealPayPost.requestConfig =
  zlbApiExpenseSearchPageWebNightMealPayPostRequestConfig;

/**
 * 接口 [记账凭证相关单据查询↗](http://yapi.cai-inc.com/project/3621/interface/api/641682) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/act-voucher`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebActVoucherPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 融合搜索字段 - 事由&单据号
   */
  fusionField?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 发起人id
   */
  submitterIdList?: number[];
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 机构ID列表
   */
  orgIdList?: number[];
  /**
   * 部门ID列表
   */
  deptIdList?: number[];
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否已打印
   */
  printStatus?: boolean;
  /**
   * 校验状态（预警等级）
   */
  checkStatus?: number;
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 场景类型
   */
  sceneTypeList?: (
    | 'TRAVEL'
    | 'MEETING'
    | 'TRAIN'
    | 'P_OFFICE'
    | 'SEAL'
    | 'RECEPTION'
    | 'GENERAL'
    | 'TENDER'
    | 'P_GENERAL'
    | 'P_GOV'
    | 'P_FURNITURE'
    | 'MULTI_MEETING'
    | 'MULTI_TRAIN'
    | 'PUBLIC_PAYMENT'
    | 'WAGE'
    | 'INCOME'
    | 'BATCH_DISTRIBUTE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY'
    | 'BUDGET_FILL_ORDER'
    | 'WORK_SUMMARY'
    | 'OVERTIME_APPLY'
    | 'REPLENISH_APPLY'
    | 'LEAVE'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'RENTAL_APPLY'
    | 'USE_CAR_APPLY'
    | 'RENTAL_SETTLEMENT'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BUDGET_ADJUST_ORDER'
    | 'INVEST_PAYMENT'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'REST_FORM'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'DEBIT_NOTE_FORM'
    | 'CARRY_PAYMENT_FORM'
    | 'TRANSFER_FUND_FORM'
    | 'NULL_TYPE'
  )[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 申请支付时间范围
   */
  payApplyTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据状态
   */
  formStatusList?: (0 | 10 | 20 | 30 | 40 | 100 | 999)[];
  /**
   * 支付状态
   */
  payStatusList?: (0 | 10 | 20 | 30 | 31 | 50)[];
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 发起人
   */
  userTypeList?: (1 | 2 | 3 | 4)[];
  /**
   * 金额范围
   */
  amountRange?: {
    /**
     * 最小金额
     */
    minAmount?: number;
    /**
     * 最大金额
     */
    maxAmount?: number;
  };
  /**
   * 是否已关联报销单
   */
  isAssociate?: boolean;
  /**
   * 是否需要报销
   */
  isNeedExpense?: boolean;
  /**
   * 是否有可用金额（采购场景）
   * true：有可用金额；false：无可用金额
   */
  isRemaining?: boolean;
  /**
   * 是否是测试单据
   */
  isTestForm?: boolean;
  /**
   * 采购状态
   */
  purchaseStatus?: number;
  /**
   * 支付渠道
   */
  payMode?: number;
  /**
   * 是否是管理员
   */
  isAdmin?: boolean;
  /**
   * 支付完成时间
   */
  payFinishTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 同行人
   */
  accompanyList?: number[];
  /**
   * 仅查看待复核数据
   */
  onlyViewRecheck?: boolean;
  /**
   * 绑定的报销单
   */
  bindExpenseFormList?: string[];
  /**
   * 绑定的申请单
   */
  bindApplyFormList?: string[];
}

/**
 * 接口 [记账凭证相关单据查询↗](http://yapi.cai-inc.com/project/3621/interface/api/641682) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/act-voucher`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageWebActVoucherPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据编码
       */
      formCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 支付记录编码，用于生产凭证
       */
      paymentCode?: string;
      /**
       * 支付id
       */
      payId?: string;
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 支付金额
       */
      payAmount?: number;
      /**
       * 收款账户名
       */
      receiverAccountName?: string;
      /**
       * 收款账号
       */
      receiverAccountNo?: string;
      /**
       * 收款账号
       */
      desensitizeReceiverAccountNo?: string;
      /**
       * 收款银行
       */
      receiverBankName?: string;
      /**
       * 支付账户名
       */
      payerAccountName?: string;
      /**
       * 支付账号
       */
      payerAccountNo?: string;
      /**
       * 支付账号
       */
      desensitizePayerAccountNo?: string;
      /**
       * 支付完成时间
       */
      payCompleteTime?: string;
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * 传输状态
       */
      transferStatus?: number;
      /**
       * 传输状态描述
       */
      transferStatusDesc?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [记账凭证相关单据查询↗](http://yapi.cai-inc.com/project/3621/interface/api/641682) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/act-voucher`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageWebActVoucherPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/web/act-voucher',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [记账凭证相关单据查询↗](http://yapi.cai-inc.com/project/3621/interface/api/641682) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/act-voucher`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageWebActVoucherPostRequestConfig: ZlbApiExpenseSearchPageWebActVoucherPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/web/act-voucher',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageWebActVoucherPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [记账凭证相关单据查询↗](http://yapi.cai-inc.com/project/3621/interface/api/641682) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/web/act-voucher`
 * @更新时间 `2024-11-14 13:49:49`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageWebActVoucherPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageWebActVoucherPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageWebActVoucherPostResponse>(
    prepare(zlbApiExpenseSearchPageWebActVoucherPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageWebActVoucherPost.requestConfig =
  zlbApiExpenseSearchPageWebActVoucherPostRequestConfig;

/**
 * 接口 [一般事项报销申请列表↗](http://yapi.cai-inc.com/project/3621/interface/api/660050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/general-expense/apply`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageGeneralExpenseApplyPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 单据类型
   */
  formTypeList?: (
    | 'APPLY_FORM'
    | 'EXPENSE_FORM'
    | 'WAGE_APPLY_FORM'
    | 'INCOME_APPLY_FORM'
    | 'SEAL_APPLY_FORM'
    | 'TENDER'
    | 'BATCH_DISTRIBUTE'
    | 'BATCH_DISTRIBUTE_CASH'
    | 'BATCH_DISTRIBUTE_EXPENSE'
    | 'ASSET_MANAGEMENT'
    | 'OVERTIME_PAY_FORM'
    | 'BUDGET_FILL_ORDER'
    | 'BUDGET_PERFORM_REPORT_ORDER'
    | 'BUDGET_PERFORM_FILL_ORDER'
    | 'BUDGET_PROJECT_REPORT_ORDER'
    | 'OVERTIME_APPLY_FORM'
    | 'BUDGET_ADJUST_ORDER'
    | 'BUDGET_OTHER_FUND_ORDER'
    | 'WORK_SUMMARY_FORM'
    | 'REPLENISH_APPLY_FORM'
    | 'LEAVE_FORM'
    | 'RENTAL_APPLY_FORM'
    | 'RENTAL_SETTLEMENT_FORM'
    | 'USE_CAR_APPLY_FORM'
    | 'INVEST_PAYMENT_FORM'
    | 'REST_FORM'
    | 'generalForm'
    | 'projectPurchaseApplyForm'
    | 'baidaApplyForm'
    | 'baidaExpenseForm'
    | 'UN_KNOWN'
  )[];
  /**
   * 时间范围
   */
  timeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 事由
   */
  reason?: string;
}

/**
 * 接口 [一般事项报销申请列表↗](http://yapi.cai-inc.com/project/3621/interface/api/660050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/general-expense/apply`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageGeneralExpenseApplyPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [一般事项报销申请列表↗](http://yapi.cai-inc.com/project/3621/interface/api/660050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/general-expense/apply`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageGeneralExpenseApplyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/general-expense/apply',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [一般事项报销申请列表↗](http://yapi.cai-inc.com/project/3621/interface/api/660050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/general-expense/apply`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageGeneralExpenseApplyPostRequestConfig: ZlbApiExpenseSearchPageGeneralExpenseApplyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/general-expense/apply',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageGeneralExpenseApplyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [一般事项报销申请列表↗](http://yapi.cai-inc.com/project/3621/interface/api/660050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/general-expense/apply`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageGeneralExpenseApplyPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageGeneralExpenseApplyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageGeneralExpenseApplyPostResponse>(
    prepare(zlbApiExpenseSearchPageGeneralExpenseApplyPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageGeneralExpenseApplyPost.requestConfig =
  zlbApiExpenseSearchPageGeneralExpenseApplyPostRequestConfig;

/**
 * 接口 [app单据收款账户复核列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/676210) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/receiver-recheck-page`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageAppReceiverRecheckPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 复核状态 1-待复核 2-已复核
   */
  status?: number;
}

/**
 * 接口 [app单据收款账户复核列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/676210) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/receiver-recheck-page`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageAppReceiverRecheckPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务编号
       */
      businessCode?: string;
      /**
       * 单据类型
       */
      formType?:
        | 'APPLY_FORM'
        | 'EXPENSE_FORM'
        | 'WAGE_APPLY_FORM'
        | 'INCOME_APPLY_FORM'
        | 'SEAL_APPLY_FORM'
        | 'TENDER'
        | 'BATCH_DISTRIBUTE'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY_FORM'
        | 'BUDGET_FILL_ORDER'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'OVERTIME_APPLY_FORM'
        | 'BUDGET_ADJUST_ORDER'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'WORK_SUMMARY_FORM'
        | 'REPLENISH_APPLY_FORM'
        | 'LEAVE_FORM'
        | 'RENTAL_APPLY_FORM'
        | 'RENTAL_SETTLEMENT_FORM'
        | 'USE_CAR_APPLY_FORM'
        | 'INVEST_PAYMENT_FORM'
        | 'REST_FORM'
        | 'generalForm'
        | 'projectPurchaseApplyForm'
        | 'baidaApplyForm'
        | 'baidaExpenseForm'
        | 'UN_KNOWN';
      /**
       * 单据类型名称
       */
      formTypeDesc?:
        | '申请单'
        | '报销单'
        | '工资申报'
        | '收入登记'
        | '用印申请'
        | '招标书'
        | '批量发放'
        | '企业兑付'
        | '批量报销'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报'
        | '加班申请单'
        | '预算调剂申请单'
        | '预算其他资金指标申报单'
        | '工作总结'
        | '补签'
        | '请假'
        | '租车申请'
        | '租赁结算'
        | '用车申请'
        | '项目支付'
        | '其他资金'
        | '普通业务'
        | '普通业务'
        | '申请单'
        | '报销单'
        | '';
      /**
       * 场景类型
       */
      sceneType?:
        | 'TRAVEL'
        | 'MEETING'
        | 'TRAIN'
        | 'P_OFFICE'
        | 'SEAL'
        | 'RECEPTION'
        | 'GENERAL'
        | 'TENDER'
        | 'P_GENERAL'
        | 'P_GOV'
        | 'P_FURNITURE'
        | 'MULTI_MEETING'
        | 'MULTI_TRAIN'
        | 'PUBLIC_PAYMENT'
        | 'WAGE'
        | 'INCOME'
        | 'BATCH_DISTRIBUTE'
        | 'ASSET_MANAGEMENT'
        | 'OVERTIME_PAY'
        | 'BUDGET_FILL_ORDER'
        | 'WORK_SUMMARY'
        | 'OVERTIME_APPLY'
        | 'REPLENISH_APPLY'
        | 'LEAVE'
        | 'BUDGET_PERFORM_REPORT_ORDER'
        | 'BUDGET_PERFORM_FILL_ORDER'
        | 'BUDGET_PROJECT_REPORT_ORDER'
        | 'RENTAL_APPLY'
        | 'USE_CAR_APPLY'
        | 'RENTAL_SETTLEMENT'
        | 'BATCH_DISTRIBUTE_CASH'
        | 'BUDGET_ADJUST_ORDER'
        | 'INVEST_PAYMENT'
        | 'BATCH_DISTRIBUTE_EXPENSE'
        | 'REST_FORM'
        | 'BUDGET_OTHER_FUND_ORDER'
        | 'DEBIT_NOTE_FORM'
        | 'CARRY_PAYMENT_FORM'
        | 'TRANSFER_FUND_FORM'
        | 'NULL_TYPE';
      /**
       * 场景类型名称
       */
      sceneTypeDesc?:
        | '公务出行'
        | '会议活动'
        | '学习培训'
        | '办公用品'
        | '用印申请'
        | '公务接待'
        | '一般事项'
        | '招标书'
        | '通用采购'
        | '购买服务'
        | '设备家具'
        | '会议活动'
        | '学习培训'
        | '公共事业缴费'
        | '工资申报'
        | '收入登记'
        | '批量发放'
        | '资产管理'
        | '夜餐费发放'
        | '预算填报'
        | '工作总结'
        | '加班申请'
        | '补签'
        | '请假'
        | '预算绩效申报'
        | '预算绩效填报'
        | '预算项目申报单'
        | '租车申请'
        | '用车申请'
        | '租赁结算'
        | '企业兑付'
        | '预算调剂'
        | '投资支付'
        | '批量报销'
        | '其他资金'
        | '预算其他资金指标申报单'
        | '借款凭证单据'
        | '托收结转支付单据'
        | '子账户转账单据'
        | '';
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 单据业务类型名称
       */
      businessTypeDesc?: string;
      /**
       * 单据校验状态（预警等级）
       */
      checkStatus?: number;
      /**
       * 单据校验状态名称（预警等级）
       */
      checkStatusDesc?: string;
      /**
       * 关联单据
       */
      bindFormList?: {
        /**
         * 单据类型
         */
        formType?:
          | 'APPLY_FORM'
          | 'EXPENSE_FORM'
          | 'WAGE_APPLY_FORM'
          | 'INCOME_APPLY_FORM'
          | 'SEAL_APPLY_FORM'
          | 'TENDER'
          | 'BATCH_DISTRIBUTE'
          | 'BATCH_DISTRIBUTE_CASH'
          | 'BATCH_DISTRIBUTE_EXPENSE'
          | 'ASSET_MANAGEMENT'
          | 'OVERTIME_PAY_FORM'
          | 'BUDGET_FILL_ORDER'
          | 'BUDGET_PERFORM_REPORT_ORDER'
          | 'BUDGET_PERFORM_FILL_ORDER'
          | 'BUDGET_PROJECT_REPORT_ORDER'
          | 'OVERTIME_APPLY_FORM'
          | 'BUDGET_ADJUST_ORDER'
          | 'BUDGET_OTHER_FUND_ORDER'
          | 'WORK_SUMMARY_FORM'
          | 'REPLENISH_APPLY_FORM'
          | 'LEAVE_FORM'
          | 'RENTAL_APPLY_FORM'
          | 'RENTAL_SETTLEMENT_FORM'
          | 'USE_CAR_APPLY_FORM'
          | 'INVEST_PAYMENT_FORM'
          | 'REST_FORM'
          | 'generalForm'
          | 'projectPurchaseApplyForm'
          | 'baidaApplyForm'
          | 'baidaExpenseForm'
          | 'UN_KNOWN';
        /**
         * 单据信息
         */
        formInfoList?: {
          /**
           * 单据唯一编号
           */
          formCode?: string;
          /**
           * 单据业务编号
           */
          businessCode?: string;
          /**
           * 场景类型
           */
          sceneType?:
            | 'TRAVEL'
            | 'MEETING'
            | 'TRAIN'
            | 'P_OFFICE'
            | 'SEAL'
            | 'RECEPTION'
            | 'GENERAL'
            | 'TENDER'
            | 'P_GENERAL'
            | 'P_GOV'
            | 'P_FURNITURE'
            | 'MULTI_MEETING'
            | 'MULTI_TRAIN'
            | 'PUBLIC_PAYMENT'
            | 'WAGE'
            | 'INCOME'
            | 'BATCH_DISTRIBUTE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY'
            | 'BUDGET_FILL_ORDER'
            | 'WORK_SUMMARY'
            | 'OVERTIME_APPLY'
            | 'REPLENISH_APPLY'
            | 'LEAVE'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'RENTAL_APPLY'
            | 'USE_CAR_APPLY'
            | 'RENTAL_SETTLEMENT'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BUDGET_ADJUST_ORDER'
            | 'INVEST_PAYMENT'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'REST_FORM'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'DEBIT_NOTE_FORM'
            | 'CARRY_PAYMENT_FORM'
            | 'TRANSFER_FUND_FORM'
            | 'NULL_TYPE';
          /**
           * 单据业务类型
           */
          businessType?: string;
          /**
           * 单据类型
           */
          formType?:
            | 'APPLY_FORM'
            | 'EXPENSE_FORM'
            | 'WAGE_APPLY_FORM'
            | 'INCOME_APPLY_FORM'
            | 'SEAL_APPLY_FORM'
            | 'TENDER'
            | 'BATCH_DISTRIBUTE'
            | 'BATCH_DISTRIBUTE_CASH'
            | 'BATCH_DISTRIBUTE_EXPENSE'
            | 'ASSET_MANAGEMENT'
            | 'OVERTIME_PAY_FORM'
            | 'BUDGET_FILL_ORDER'
            | 'BUDGET_PERFORM_REPORT_ORDER'
            | 'BUDGET_PERFORM_FILL_ORDER'
            | 'BUDGET_PROJECT_REPORT_ORDER'
            | 'OVERTIME_APPLY_FORM'
            | 'BUDGET_ADJUST_ORDER'
            | 'BUDGET_OTHER_FUND_ORDER'
            | 'WORK_SUMMARY_FORM'
            | 'REPLENISH_APPLY_FORM'
            | 'LEAVE_FORM'
            | 'RENTAL_APPLY_FORM'
            | 'RENTAL_SETTLEMENT_FORM'
            | 'USE_CAR_APPLY_FORM'
            | 'INVEST_PAYMENT_FORM'
            | 'REST_FORM'
            | 'generalForm'
            | 'projectPurchaseApplyForm'
            | 'baidaApplyForm'
            | 'baidaExpenseForm'
            | 'UN_KNOWN';
        }[];
      }[];
      /**
       * 事由
       */
      reason?: string;
      /**
       * 摘要
       */
      summaryList?: {
        /**
         * 标题
         */
        title?: string;
        /**
         * 内容
         */
        content?: string;
      }[];
      /**
       * 支付摘要
       */
      paymentPurpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据来源
       */
      formSource?: 1 | 2 | 3 | 4;
      /**
       * 单据来源名称
       */
      formSourceDesc?: '浙里报' | 'OA' | '浙里干部之家' | 'OA';
      /**
       * 提交人operatorId
       */
      submitterId?: number;
      /**
       * 提交人名称
       */
      submitterName?: string;
      /**
       * 用户类别
       */
      userTagList?: {
        /**
         * key
         */
        key?: 1 | 2 | 3 | 4;
        /**
         * 描述
         */
        desc?: '本人' | '同行' | '转交' | '抄送';
      }[];
      /**
       * 发起单位ID
       */
      orgId?: number;
      /**
       * 发起单位名称
       */
      orgName?: string;
      /**
       * 发起部门ID
       */
      deptId?: number;
      /**
       * 发起部门名称
       */
      deptName?: string;
      /**
       * 添加时间
       */
      addTime?: number;
      /**
       * 发起时间
       */
      timeDesc?: string;
      /**
       * app发起时间
       */
      appTimeDesc?: string;
      /**
       * 支付申请时间
       */
      payApplyTimeDesc?: string;
      /**
       * 支付完成时间
       */
      payFinishTimeDesc?: string;
      /**
       * 支付渠道
       */
      payMode?: 1 | 2 | 3 | 5;
      /**
       * 支付渠道描述
       */
      payModeDesc?:
        | '国库集中支付'
        | '单位资金支付'
        | '非财政资金结算平台'
        | 'CBS跨银行现金管理平台';
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 打印状态
       */
      printStatus?: '-1' | 0 | 1 | 2 | 3;
      /**
       * 打印状态描述
       */
      printStatusDesc?: '-' | '未打印' | '财务已打印' | '经办人已打印' | '财务和经办人均已打印';
      /**
       * 审核/审批状态
       */
      auditStatus?: 0 | 1 | 2;
      /**
       * 审核/审批状态名称
       */
      auditStatusDesc?: '待处理' | '通过' | '驳回';
      /**
       * 审核/审批节点
       */
      auditEvent?: 0 | 1 | 3;
      /**
       * 审核/审批节点名称
       */
      auditEventDesc?: '审批' | '审核' | '抄送';
      /**
       * 工作流流程编号
       */
      workflowProcessNo?: string;
      /**
       * 当前节点
       */
      currentNodeList?: {
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员名称
         */
        operatorName?: string;
      }[];
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 备注
       */
      remark?: string;
      /**
       * 收入预算
       */
      incomeBudgetAmount?: number;
      /**
       * 支出预算
       */
      expendBudgetAmount?: number;
      /**
       * 单据扩展数据
       */
      formExtendDataDTO?: {
        /**
         * 用车申请扩展数据
         */
        rentalApplyExtendData?: {
          /**
           * 出发地
           */
          beginCityName?: string;
        };
        /**
         * 其他资金扩展数据
         */
        restFormExtendDateDTO?: {
          /**
           * 关联的单据类型
           */
          associateFormList?: {
            formCode?: string;
            formType?: string;
            businessCode?: string;
          }[];
          /**
           * 账户类型
           */
          accountEntityList?: {
            /**
             * 账户编码（支付中心账号唯一编码）
             */
            accountCode?: string;
            /**
             * 账户名称
             */
            accountName?: string;
            /**
             * 银行卡名称
             */
            bankName?: string;
            /**
             * 账户账号
             */
            accountNo?: string;
            /**
             * 账户类型：1-收款，2-付款
             */
            accountType?: number;
          }[];
        };
      };
      /**
       * 支付记录
       */
      paymentRecordList?: {
        /**
         * 支付记录编码，用于生产凭证
         */
        paymentCode?: string;
        /**
         * 支付id
         */
        payId?: string;
        /**
         * 支付金额
         */
        payAmount?: number;
        /**
         * 收款账户名
         */
        receiverAccountName?: string;
        /**
         * 收款账号
         */
        receiverAccountNo?: string;
        /**
         * 收款银行
         */
        receiverBankName?: string;
        /**
         * 支付账户名
         */
        payerAccountName?: string;
        /**
         * 支付账号
         */
        payerAccountNo?: string;
        /**
         * 支付完成时间
         */
        payCompleteTime?: string;
        /**
         * 记账凭证扩展数据
         */
        actVoucherFormExtendDataDTO?: {
          /**
           * 传输状态
           */
          transferStatus?: number;
          /**
           * 传输状态描述
           */
          transferStatusDesc?: string;
        };
      }[];
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [app单据收款账户复核列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/676210) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/receiver-recheck-page`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageAppReceiverRecheckPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/app/receiver-recheck-page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [app单据收款账户复核列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/676210) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/receiver-recheck-page`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageAppReceiverRecheckPagePostRequestConfig: ZlbApiExpenseSearchPageAppReceiverRecheckPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/app/receiver-recheck-page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageAppReceiverRecheckPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [app单据收款账户复核列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/676210) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/app/receiver-recheck-page`
 * @更新时间 `2024-11-14 13:49:48`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageAppReceiverRecheckPagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageAppReceiverRecheckPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageAppReceiverRecheckPagePostResponse>(
    prepare(zlbApiExpenseSearchPageAppReceiverRecheckPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageAppReceiverRecheckPagePost.requestConfig =
  zlbApiExpenseSearchPageAppReceiverRecheckPagePostRequestConfig;

/**
 * 接口 [单位其他资金支付指令列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705650) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds-directive`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageUnitOtherFundsDirectivePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 单位
   */
  orgId?: number;
  /**
   * 支付状态
   */
  payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 保存时间
   */
  saveTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 往来单位
   */
  counterpartyOrgName?: string;
  /**
   * 发起人姓名
   */
  submitterName?: string;
  /**
   * 仅展示支票业务
   */
  showCheque?: boolean;
}

/**
 * 接口 [单位其他资金支付指令列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705650) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds-directive`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageUnitOtherFundsDirectivePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一code
       */
      formCode?: string;
      /**
       * 单据业务单号
       */
      businessCode?: string;
      /**
       * 业务类型 1其他资金普通业务 2其他资金子户转账 3其他资金支票业务
       */
      businessType?: string;
      /**
       * 机构id
       */
      orgId?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 发起人id
       */
      submitterId?: number;
      /**
       * 发起人姓名
       */
      submitterName?: string;
      /**
       * 事由
       */
      reason?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
      /**
       * 保存时间
       */
      saveTime?: string;
      /**
       * 申请支付时间
       */
      payApplyTime?: string;
      /**
       * 支付状态
       */
      payStatus?: 0 | 10 | 20 | 30 | 31 | 50;
      /**
       * 支付状态描述
       */
      payStatusDesc?: '-' | '待支付' | '支付中' | '部分失败' | '支付失败' | '支付成功';
      /**
       * 按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单位其他资金支付指令列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705650) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds-directive`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageUnitOtherFundsDirectivePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/unit-other-funds-directive',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [单位其他资金支付指令列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705650) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds-directive`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageUnitOtherFundsDirectivePostRequestConfig: ZlbApiExpenseSearchPageUnitOtherFundsDirectivePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/unit-other-funds-directive',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageUnitOtherFundsDirectivePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单位其他资金支付指令列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705650) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds-directive`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageUnitOtherFundsDirectivePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageUnitOtherFundsDirectivePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageUnitOtherFundsDirectivePostResponse>(
    prepare(zlbApiExpenseSearchPageUnitOtherFundsDirectivePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageUnitOtherFundsDirectivePost.requestConfig =
  zlbApiExpenseSearchPageUnitOtherFundsDirectivePostRequestConfig;

/**
 * 接口 [单位其他资金列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705666) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageUnitOtherFundsPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 单据编号
   */
  businessCode?: string;
  /**
   * 保存时间
   */
  saveTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 事由
   */
  reason?: string;
  /**
   * 往来单位
   */
  counterpartyOrgName?: string;
}

/**
 * 接口 [单位其他资金列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705666) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageUnitOtherFundsPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一code
       */
      formCode?: string;
      /**
       * 单据业务单号
       */
      businessCode?: string;
      /**
       * 业务类型 1其他资金普通业务 2其他资金子户转账 3其他资金支票业务
       */
      businessType?: string;
      /**
       * 机构id
       */
      orgId?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 发起人id
       */
      submitterId?: number;
      /**
       * 发起人姓名
       */
      submitterName?: string;
      /**
       * 事由
       */
      reason?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 往来单位
       */
      counterpartyOrgName?: string;
      /**
       * 保存时间
       */
      saveTime?: string;
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单位其他资金列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705666) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageUnitOtherFundsPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/unit-other-funds',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [单位其他资金列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705666) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageUnitOtherFundsPostRequestConfig: ZlbApiExpenseSearchPageUnitOtherFundsPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/unit-other-funds',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageUnitOtherFundsPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单位其他资金列表↗](http://yapi.cai-inc.com/project/3621/interface/api/705666) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/unit-other-funds`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageUnitOtherFundsPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageUnitOtherFundsPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageUnitOtherFundsPostResponse>(
    prepare(zlbApiExpenseSearchPageUnitOtherFundsPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageUnitOtherFundsPost.requestConfig =
  zlbApiExpenseSearchPageUnitOtherFundsPostRequestConfig;

/**
 * 接口 [扣款凭证查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710170) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/debit-note`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageDebitNotePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 用途
   */
  purpose?: string;
  /**
   * 保存时间
   */
  saveTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 状态
   */
  status?: number;
  /**
   * 收款户名
   */
  accountReceiverName?: string;
  /**
   * 业务编号
   */
  businessCode?: string;
  /**
   * 机构ID
   */
  institutionIdList?: number[];
  /**
   * 仅未关联报销单，即未列支出
   */
  onlyNotExpense?: boolean;
  /**
   * 未关联的单据
   */
  notAssociatedFormType?: string[];
}

/**
 * 接口 [扣款凭证查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710170) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/debit-note`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageDebitNotePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一code
       */
      formCode?: string;
      /**
       * 单据业务单号
       */
      businessCode?: string;
      /**
       * 机构id
       */
      orgId?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 事由
       */
      purpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 创建时间
       */
      createTime?: number;
      /**
       * 收款账户名
       */
      receiverAccountName?: string;
      /**
       * 收款账号
       */
      receiverAccountNo?: string;
      /**
       * 收款银行
       */
      receiverBankName?: string;
      /**
       * 支付账户名
       */
      payerAccountName?: string;
      /**
       * 支付账号
       */
      payerAccountNo?: string;
      /**
       * 支付银行
       */
      payerBankName?: string;
      associateItemList?: {
        /**
         * 关联的单据唯一编号
         */
        associateFormCode?: string;
        /**
         * 关联单据的业务编号
         */
        associateBusinessCode?: string;
        /**
         * 关联单据的类型
         */
        associateFormType?: string;
        /**
         * 关连关系类型
         * 1- 结转 2-列支出
         */
        associateType?: number;
      }[];
      /**
       * 按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [扣款凭证查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710170) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/debit-note`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageDebitNotePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/debit-note',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [扣款凭证查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710170) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/debit-note`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageDebitNotePostRequestConfig: ZlbApiExpenseSearchPageDebitNotePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/debit-note',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageDebitNotePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [扣款凭证查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710170) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/debit-note`
 * @更新时间 `2024-11-14 13:49:50`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageDebitNotePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageDebitNotePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageDebitNotePostResponse>(
    prepare(zlbApiExpenseSearchPageDebitNotePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageDebitNotePost.requestConfig =
  zlbApiExpenseSearchPageDebitNotePostRequestConfig;

/**
 * 接口 [结转支付查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710178) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/carry-payment`
 * @更新时间 `2024-11-14 13:49:51`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageCarryPaymentPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 标签页类型
   */
  tagType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  /**
   * 用途
   */
  purpose?: string;
  /**
   * 保存时间
   */
  saveTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 状态
   */
  status?: number;
  /**
   * 收款户名
   */
  accountReceiverName?: string;
  /**
   * 业务编号
   */
  businessCode?: string;
  /**
   * 机构ID
   */
  institutionIdList?: number[];
  /**
   * 仅未关联报销单，即未列支出
   */
  onlyNotExpense?: boolean;
  /**
   * 未关联的单据
   */
  notAssociatedFormType?: string[];
}

/**
 * 接口 [结转支付查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710178) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/carry-payment`
 * @更新时间 `2024-11-14 13:49:51`
 * @项目ID 3621
 */
export interface ZlbApiExpenseSearchPageCarryPaymentPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据唯一code
       */
      formCode?: string;
      /**
       * 单据业务单号
       */
      businessCode?: string;
      /**
       * 单据业务类型
       */
      businessType?: string;
      /**
       * 机构id
       */
      orgId?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 事由
       */
      purpose?: string;
      /**
       * 单据金额
       */
      amount?: number;
      /**
       * 创建时间
       */
      createTime?: number;
      /**
       * 单据状态
       */
      formStatus?: 0 | 10 | 20 | 30 | 40 | 100 | 999;
      /**
       * 单据状态名称
       */
      formStatusDesc?: '未提交' | '待审核' | '已驳回' | '结算中' | '已完成' | '已作废' | '';
      /**
       * 收款账户名
       */
      receiverAccountName?: string;
      /**
       * 收款账号
       */
      receiverAccountNo?: string;
      /**
       * 收款银行
       */
      receiverBankName?: string;
      /**
       * 支付账户名
       */
      payerAccountName?: string;
      /**
       * 支付账号
       */
      payerAccountNo?: string;
      /**
       * 支付银行
       */
      payerBankName?: string;
      /**
       * 按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 去采购
         */
        purchase?: boolean;
        /**
         * 去报销
         */
        expense?: boolean;
        /**
         * 去预订
         */
        reserve?: boolean;
        /**
         * 去处理（审核）
         */
        audit?: boolean;
        /**
         * 去处理（审批）
         */
        approval?: boolean;
        /**
         * 处理（出纳结算/app审批审核）
         */
        handle?: boolean;
        /**
         * 重置
         */
        resume?: boolean;
        /**
         * 打印
         */
        print?: boolean;
        /**
         * 工资A3打印
         */
        printA3?: boolean;
        /**
         * 工资A4打印
         */
        printA4?: boolean;
        /**
         * 支票打印
         */
        chequePrint?: boolean;
        /**
         * 添加代理人
         */
        addAgent?: boolean;
        /**
         * 复核订正账户
         */
        recheckCorrAcc?: boolean;
        /**
         * 无需报销
         */
        noNeedExpense?: boolean;
        /**
         * 需要报销
         */
        needExpense?: boolean;
        /**
         * 是否可转交
         */
        transfer?: boolean;
        /**
         * 发起支付
         */
        pay?: boolean;
        /**
         * 登记
         */
        register?: boolean;
      };
      /**
       * 关联的item
       */
      associateItemList?: {
        /**
         * 关联的单据唯一编号
         */
        associateFormCode?: string;
        /**
         * 关联单据的业务编号
         */
        associateBusinessCode?: string;
        /**
         * 关联单据的类型
         */
        associateFormType?: string;
        /**
         * 关连关系类型
         * 1- 结转 2-列支出
         */
        associateType?: number;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [结转支付查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710178) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/carry-payment`
 * @更新时间 `2024-11-14 13:49:51`
 * @项目ID 3621
 */
type ZlbApiExpenseSearchPageCarryPaymentPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/search/page/carry-payment',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [结转支付查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710178) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/carry-payment`
 * @更新时间 `2024-11-14 13:49:51`
 * @项目ID 3621
 */
const zlbApiExpenseSearchPageCarryPaymentPostRequestConfig: ZlbApiExpenseSearchPageCarryPaymentPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: '/zlb/api/expense/search/page/carry-payment',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseSearchPageCarryPaymentPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [结转支付查询列表↗](http://yapi.cai-inc.com/project/3621/interface/api/710178) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [search-列表查询接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_52589)
 * @请求头 `POST /zlb/api/expense/search/page/carry-payment`
 * @更新时间 `2024-11-14 13:49:51`
 * @项目ID 3621
 */
export const zlbApiExpenseSearchPageCarryPaymentPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseSearchPageCarryPaymentPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseSearchPageCarryPaymentPostResponse>(
    prepare(zlbApiExpenseSearchPageCarryPaymentPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseSearchPageCarryPaymentPost.requestConfig =
  zlbApiExpenseSearchPageCarryPaymentPostRequestConfig;

const mockUrl_0_1_0_19 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_19 = '' as any;
const prodUrl_0_1_0_19 = '' as any;
const dataKey_0_1_0_19 = 'data' as any;

/**
 * 接口 [冲突校验↗](http://yapi.cai-inc.com/project/3621/interface/api/526594) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/check`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeConflictCheckPostRequest {
  /**
   * 明细单号列表
   */
  formCodeList?: string[];
}

/**
 * 接口 [冲突校验↗](http://yapi.cai-inc.com/project/3621/interface/api/526594) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/check`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeConflictCheckPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [冲突校验↗](http://yapi.cai-inc.com/project/3621/interface/api/526594) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/check`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeConflictCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/conflict/check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [冲突校验↗](http://yapi.cai-inc.com/project/3621/interface/api/526594) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/check`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeConflictCheckPostRequestConfig: ZlbApiExpenseOvertimeNightMealFeeConflictCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/conflict/check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeConflictCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [冲突校验↗](http://yapi.cai-inc.com/project/3621/interface/api/526594) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/check`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeConflictCheckPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeConflictCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeConflictCheckPostResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeConflictCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeConflictCheckPost.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeConflictCheckPostRequestConfig;

/**
 * 接口 [夜餐费明细删除↗](http://yapi.cai-inc.com/project/3621/interface/api/526602) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/delete`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeDeletePostRequest {
  /**
   * 明细单号
   */
  formCode?: string;
  /**
   * 明细单号
   */
  formCodeList?: string[];
}

/**
 * 接口 [夜餐费明细删除↗](http://yapi.cai-inc.com/project/3621/interface/api/526602) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/delete`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [夜餐费明细删除↗](http://yapi.cai-inc.com/project/3621/interface/api/526602) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/delete`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [夜餐费明细删除↗](http://yapi.cai-inc.com/project/3621/interface/api/526602) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/delete`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeDeletePostRequestConfig: ZlbApiExpenseOvertimeNightMealFeeDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [夜餐费明细删除↗](http://yapi.cai-inc.com/project/3621/interface/api/526602) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/delete`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeDeletePostResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeDeletePost.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeDeletePostRequestConfig;

/**
 * 接口 [冲突列表↗](http://yapi.cai-inc.com/project/3621/interface/api/526610) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/list`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeConflictListPostRequest {
  /**
   * 明细单号
   */
  formCode?: string;
}

/**
 * 接口 [冲突列表↗](http://yapi.cai-inc.com/project/3621/interface/api/526610) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/list`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeConflictListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 场景类型
     */
    sceneType?: number;
    /**
     * 场景类型描述
     */
    sceneTypeDesc?: string;
    conflictFormList?: {
      /**
       * 场景类型
       */
      sceneType?: number;
      /**
       * 场景类型描述
       */
      sceneTypeDesc?: string;
      /**
       * code
       */
      formCode?: string;
      /**
       * 编号
       */
      businessCode?: string;
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [冲突列表↗](http://yapi.cai-inc.com/project/3621/interface/api/526610) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/list`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeConflictListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/conflict/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [冲突列表↗](http://yapi.cai-inc.com/project/3621/interface/api/526610) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/list`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeConflictListPostRequestConfig: ZlbApiExpenseOvertimeNightMealFeeConflictListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/conflict/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeConflictListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [冲突列表↗](http://yapi.cai-inc.com/project/3621/interface/api/526610) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/conflict/list`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeConflictListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeConflictListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeConflictListPostResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeConflictListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeConflictListPost.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeConflictListPostRequestConfig;

/**
 * 接口 [夜餐费明细详情↗](http://yapi.cai-inc.com/project/3621/interface/api/526618) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/detail`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeDetailGetRequest {
  /**
   * 加班人姓名
   */
  formCode?: string;
  /**
   * 是否脱敏
   * true-脱敏，false-不脱敏
   */
  desensitize?: string;
}

/**
 * 接口 [夜餐费明细详情↗](http://yapi.cai-inc.com/project/3621/interface/api/526618) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/detail`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeDetailGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 明细单号
     */
    formCode?: string;
    /**
     * 编号
     */
    businessCode?: string;
    /**
     * 基础信息
     */
    basicInfo?: {
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 关联的发放单号
       */
      payFormCode?: string;
      /**
       * 关联的发放单编号
       */
      payFormBusinessCode?: string;
      /**
       * 关联的发放单发放状态
       */
      issuanceStatus?: '-1' | 0 | 1 | 2 | 3 | 4;
      /**
       * 加班人id
       */
      overtimeOperatorId?: number;
      /**
       * 加班人名字
       */
      overtimeOperatorName?: string;
      /**
       * 加班开始时间
       */
      beginTime?: {
        /**
         * 开始时间
         */
        time?: string;
        /**
         * 开始上下午
         */
        tag?: '-1' | 0 | 1 | 2 | 3;
      };
      /**
       * 加班结束时间
       */
      endTime?: {
        /**
         * 开始时间
         */
        time?: string;
        /**
         * 开始上下午
         */
        tag?: '-1' | 0 | 1 | 2 | 3;
      };
      /**
       * 加班时间
       */
      overtimeDesc?: string;
      /**
       * 加班事由
       */
      reason?: string;
      /**
       * 备注
       */
      remark?: string;
    };
    /**
     * 夜餐费信息
     */
    feeInfo?: {
      /**
       * 发放标准
       */
      standardList?: {
        /**
         * 夜餐费标准(单位)
         */
        payStandardDesc?: string;
        /**
         * 折算夜餐费次数
         */
        times?: number;
      }[];
      /**
       * 合计发放金额
       */
      amount?: number;
    };
    /**
     * 冲突信息
     */
    conflictInfoList?: {
      /**
       * 冲突code
       */
      formCode?: string;
      /**
       * 事由
       */
      conflictFormReason?: string;
      /**
       * 冲突时间
       */
      conflictTime?: string;
      /**
       * 单据类型
       */
      sceneType?: number;
      /**
       * 单据类型
       */
      sceneTypeDesc?: string;
      /**
       * 单据编号
       */
      businessCode?: string;
    }[];
    /**
     * 收款信息
     */
    receiverInfo?: {
      /**
       * 收款记录Code
       */
      receiverCode?: string;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 银行卡信息
       */
      bankCardInfo?: {
        /**
         * 银行卡唯一标识
         */
        accountCode?: string;
        /**
         * 银行代码
         */
        bankCode?: string;
        /**
         * 银行名称
         */
        bankName?: string;
        /**
         * 支行代码
         */
        subBankCode?: string;
        /**
         * 支行名称
         */
        subBankName?: string;
        /**
         * 账户名
         */
        accountName?: string;
        /**
         * 银行账号
         */
        accountNo?: string;
        /**
         * 账号类别
         * 个人卡、公务卡、对公卡
         */
        cardType?: number;
        /**
         * 所属人id
         */
        operatorId?: number;
        /**
         * 所属人员类别
         */
        userType?: number;
        /**
         * 所属人机构id
         */
        institutionId?: number;
      };
      /**
       * 调整信息
       */
      receiverModifyInfoList?: {
        /**
         * 调整人名字
         */
        updateOperatorName?: string;
        /**
         * 调整原因
         */
        updateReason?: string;
        /**
         * 调整时间
         */
        updateTime?: number;
        /**
         * 原金额
         */
        originalAmount?: number;
        /**
         * 调整后金额
         */
        updateAmount?: number;
      }[];
    };
    /**
     * 流转记录
     */
    eventList?: {
      /**
       * 流转记录code
       */
      recordCode?: string;
      /**
       * 展示状态
       */
      checkStatus?: 'PASS' | 'WARN' | 'FORCE' | 'PROMPT';
      /**
       * 事件名
       */
      name?: string;
      /**
       * 操作时间
       */
      timeDesc?: string;
      /**
       * 备注内容
       */
      content?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [夜餐费明细详情↗](http://yapi.cai-inc.com/project/3621/interface/api/526618) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/detail`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeDetailGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/detail',
    'data',
    string,
    'formCode' | 'desensitize',
    false
  >
>;

/**
 * 接口 [夜餐费明细详情↗](http://yapi.cai-inc.com/project/3621/interface/api/526618) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/detail`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeDetailGetRequestConfig: ZlbApiExpenseOvertimeNightMealFeeDetailGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/detail',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: ['formCode', 'desensitize'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeDetailGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [夜餐费明细详情↗](http://yapi.cai-inc.com/project/3621/interface/api/526618) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/detail`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeDetailGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeDetailGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeDetailGetResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeDetailGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeDetailGet.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeDetailGetRequestConfig;

/**
 * 接口 [夜餐费调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/526634) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/update-record`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeUpdateRecordGetRequest {
  /**
   * 费用编号
   */
  formCode: string;
}

/**
 * 接口 [夜餐费调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/526634) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/update-record`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeUpdateRecordGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 修改备注
     */
    updateReason?: string;
    /**
     * 原始金额
     */
    originAmount?: number;
    /**
     * 修改后金额
     */
    updateAmount?: number;
    /**
     * 调整人
     */
    operatorId?: number;
    /**
     * 调整人
     */
    operatorName?: string;
    /**
     * 调整时间
     */
    timeDesc?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [夜餐费调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/526634) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/update-record`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeUpdateRecordGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/update-record',
    'data',
    string,
    'formCode',
    false
  >
>;

/**
 * 接口 [夜餐费调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/526634) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/update-record`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeUpdateRecordGetRequestConfig: ZlbApiExpenseOvertimeNightMealFeeUpdateRecordGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/update-record',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: ['formCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeUpdateRecordGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [夜餐费调整记录↗](http://yapi.cai-inc.com/project/3621/interface/api/526634) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/night-meal-fee/update-record`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeUpdateRecordGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeUpdateRecordGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeUpdateRecordGetResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeUpdateRecordGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeUpdateRecordGet.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeUpdateRecordGetRequestConfig;

/**
 * 接口 [夜餐费明细保存↗](http://yapi.cai-inc.com/project/3621/interface/api/526642) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/save`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeSavePostRequest {
  /**
   * 单据编号
   */
  formCode?: string;
  /**
   * 修改参数
   */
  modifyInfo?: {
    /**
     * 修改备注
     */
    updateReason: string;
    /**
     * 原始金额
     */
    originAmount?: number;
    /**
     * 修改后金额
     */
    updateAmount?: number;
  };
  /**
   * 收款信息
   */
  receiverInfoCmd: {
    /**
     * 前端唯一值
     */
    indexNo?: string;
    /**
     * 收款记录code
     */
    receiverCode?: string;
    /**
     * 收款银行卡code
     */
    accountCode: string;
    /**
     * 收款金额
     */
    amount: number;
    /**
     * 收款人id
     */
    receiverId: number;
    /**
     * 收款人姓名
     */
    receiverName?: string;
    /**
     * 修改备注
     */
    updateReason?: string;
    /**
     * 简单银行卡，无支付银行卡code时使用
     */
    simpleBankCardCmd: {
      /**
       * 账户code
       */
      accountCode?: string;
      /**
       * 收款人opId
       */
      operatorId?: number;
      /**
       * 收款户名
       */
      accountName: string;
      /**
       * 收款账户
       */
      accountNo: string;
      /**
       * 收款银行
       */
      bankName: string;
    };
  };
}

/**
 * 接口 [夜餐费明细保存↗](http://yapi.cai-inc.com/project/3621/interface/api/526642) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/save`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [夜餐费明细保存↗](http://yapi.cai-inc.com/project/3621/interface/api/526642) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/save`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [夜餐费明细保存↗](http://yapi.cai-inc.com/project/3621/interface/api/526642) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/save`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeSavePostRequestConfig: ZlbApiExpenseOvertimeNightMealFeeSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [夜餐费明细保存↗](http://yapi.cai-inc.com/project/3621/interface/api/526642) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/save`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeSavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeSavePostResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeSavePost.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeSavePostRequestConfig;

/**
 * 接口 [初始化夜餐费发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526650) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/init`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export type ZlbApiExpenseOvertimePayFormInitPostRequest = string[];

/**
 * 接口 [初始化夜餐费发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526650) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/init`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormInitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 基本信息
     */
    basicInfo?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务单号
       */
      businessCode?: string;
      /**
       * 操作人
       */
      operatorId?: number;
      /**
       * 操作人
       */
      operatorName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 事由
       */
      reason?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 单据状态
       */
      formStatus?: 0 | 1 | 2 | 3 | 4 | 5;
      /**
       * 单据状态文案
       */
      formStatusName?: '未提交' | '审核中' | '已驳回' | '结算中' | '已完成' | '支付失败';
      /**
       * 单据支付状态
       */
      formPayStatus?: 0 | 1 | 2 | 3 | 4;
      /**
       * 单据支付状态文案
       */
      formPayStatusName?: '待支付' | '支付中' | '支付成功' | '支付失败' | '部分成功';
      /**
       * 机构id
       */
      orgId?: number;
      /**
       * 机构名称
       */
      orgName?: string;
    };
    /**
     * 发放明细
     */
    issuanceInfoList?: {
      /**
       * 收款记录Code
       */
      receiverCode?: string;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 银行卡信息
       */
      bankCardInfo?: {
        /**
         * 银行卡唯一标识
         */
        accountCode?: string;
        /**
         * 银行代码
         */
        bankCode?: string;
        /**
         * 银行名称
         */
        bankName?: string;
        /**
         * 支行代码
         */
        subBankCode?: string;
        /**
         * 支行名称
         */
        subBankName?: string;
        /**
         * 账户名
         */
        accountName?: string;
        /**
         * 银行账号
         */
        accountNo?: string;
        /**
         * 账号类别
         * 个人卡、公务卡、对公卡
         */
        cardType?: number;
        /**
         * 所属人id
         */
        operatorId?: number;
        /**
         * 所属人员类别
         */
        userType?: number;
        /**
         * 所属人机构id
         */
        institutionId?: number;
      };
      /**
       * 支付状态
       */
      payStatus?: number;
      payStatusDesc?: string;
      /**
       * 关联的夜餐费明细编号
       */
      nightMealFeeDetailCodeList?: string[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [初始化夜餐费发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526650) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/init`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimePayFormInitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/pay-form/init',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [初始化夜餐费发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526650) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/init`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimePayFormInitPostRequestConfig: ZlbApiExpenseOvertimePayFormInitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/pay-form/init',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimePayFormInitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化夜餐费发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526650) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/init`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimePayFormInitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimePayFormInitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimePayFormInitPostResponse>(
    prepare(zlbApiExpenseOvertimePayFormInitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimePayFormInitPost.requestConfig =
  zlbApiExpenseOvertimePayFormInitPostRequestConfig;

/**
 * 接口 [查询单个发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526658) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/pay-form/info`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormInfoGetRequest {
  /**
   * 单据code
   */
  formCode: string;
  /**
   * 是否需要鉴权
   * true-鉴权；false-不鉴权
   */
  needAuth?: string;
  /**
   * 人员身份
   * default :DEFAULT
   * handler :HANDLER
   * auditor :AUDITOR
   * operation :OPERATION
   * special :仅有打印权限
   * readonly :READ_ONLY
   * finance :FINANCE
   * financeReplenish :FINANCE_REPLENISH
   * tenant :TENANT
   */
  identity?: string;
  /**
   * 是否需要脱敏
   * true-脱敏；false-不脱敏
   */
  desensitize?: string;
}

/**
 * 接口 [查询单个发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526658) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/pay-form/info`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 基本信息
     */
    basicInfo?: {
      /**
       * 单据唯一编号
       */
      formCode?: string;
      /**
       * 单据业务单号
       */
      businessCode?: string;
      /**
       * 操作人
       */
      operatorId?: number;
      /**
       * 操作人
       */
      operatorName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 事由
       */
      reason?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 单据状态
       */
      formStatus?: 0 | 1 | 2 | 3 | 4 | 5;
      /**
       * 单据状态文案
       */
      formStatusName?: '未提交' | '审核中' | '已驳回' | '结算中' | '已完成' | '支付失败';
      /**
       * 单据支付状态
       */
      formPayStatus?: 0 | 1 | 2 | 3 | 4;
      /**
       * 单据支付状态文案
       */
      formPayStatusName?: '待支付' | '支付中' | '支付成功' | '支付失败' | '部分成功';
      /**
       * 机构id
       */
      orgId?: number;
      /**
       * 机构名称
       */
      orgName?: string;
    };
    /**
     * 附件信息
     */
    attachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22;
    }[];
    /**
     * 发放明细
     */
    issuanceInfoList?: {
      /**
       * 收款记录Code
       */
      receiverCode?: string;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 银行卡信息
       */
      bankCardInfo?: {
        /**
         * 银行卡唯一标识
         */
        accountCode?: string;
        /**
         * 银行代码
         */
        bankCode?: string;
        /**
         * 银行名称
         */
        bankName?: string;
        /**
         * 支行代码
         */
        subBankCode?: string;
        /**
         * 支行名称
         */
        subBankName?: string;
        /**
         * 账户名
         */
        accountName?: string;
        /**
         * 银行账号
         */
        accountNo?: string;
        /**
         * 账号类别
         * 个人卡、公务卡、对公卡
         */
        cardType?: number;
        /**
         * 所属人id
         */
        operatorId?: number;
        /**
         * 所属人员类别
         */
        userType?: number;
        /**
         * 所属人机构id
         */
        institutionId?: number;
      };
      /**
       * 支付状态
       */
      payStatus?: number;
      payStatusDesc?: string;
      /**
       * 关联的夜餐费明细编号
       */
      nightMealFeeDetailCodeList?: string[];
    }[];
    /**
     * 支付明细
     */
    payInfo?: {
      /**
       * * 支付方式
       * 1：国库支付，3：非财政资金网银结算，4：库集中支付+非财政资金结算
       * 宁波：1-国库集中支付 （NbPayChannelEnum）；2-单位资金支付（一体化分散模式）
       */
      payMode?: number;
      /**
       * 支付类型名，{@link PayModeEnum}
       */
      payModeName?: string;
      /**
       * 支付类型
       * 国库：	0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"
       * 宁波：11-财政零余额支付；12-单位零余额支付；3-单位资金支付（一体化分散模式）  （NbPayTypeEnum）
       */
      payStrategy?: number;
      /**
       * 支付类型
       * 国库：	0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"
       * 宁波：11-财政零余额支付；12-单位零余额支付；3-单位资金支付（一体化分散模式）  （NbPayTypeEnum）
       */
      payStrategyName?: string;
      /**
       * 摘要
       */
      summary?: string;
      /**
       * 付款账户信息，当为自有资金支付的时候并且是财务角色的时候才会返回
       */
      expenseFormPayAccountRO?: {
        /**
         * 付款人唯一code
         */
        accountUniqueCode?: string;
        /**
         * 付款人账户
         */
        accountNo?: string;
        /**
         * 付款户名
         */
        accountName?: string;
        /**
         * 银行名字
         */
        bankName?: string;
        /**
         * 付款卡号
         */
        accountCode?: string;
        /**
         * 付款金额
         */
        amount?: number;
      };
      /**
       * 支付明细 (具体见下面)
       *   非宁波才有
       */
      expenseFormPayInfos?: {
        /**
         * 收款人姓名
         */
        receiveUserName?: string;
        /**
         * 收款方式：收款银行名称
         */
        receiveBankName?: string;
        /**
         * 收款方式：收款账号
         */
        receiveAccountNo?: string;
        /**
         * 应付金额
         */
        payAmount?: number;
        /**
         * 支付令
         */
        thirdTradeNo?: string;
        /**
         * 三方流水号
         */
        thirdPayFlowNo?: string;
        /**
         * 支付状态 0:待支付 1:支付中 2:支付成功 3:支付失败
         */
        payStatus?: number;
        /**
         * 支付状态描述
         */
        payStatusDesc?: string;
        /**
         * 失败原因
         */
        failureReason?: string;
        /**
         * 操作人ID
         */
        operatorId?: number;
        /**
         * receiverCode
         */
        receiverCode?: string;
        /**
         * 银行卡号
         */
        accountCode?: string;
        /**
         * 人员来源 1-系统内部；2-外部人员
         */
        userSource?: 1 | 2;
        /**
         * 外部人员id
         */
        outerUser?: number;
        /**
         * 预算指标数据
         */
        budgetInfoROList?: {
          /**
           * 预算年度
           */
          year?: number;
          /**
           * 预算指标文号
           */
          budgetNo?: string;
          /**
           * 主预算id
           */
          mainBudgetCode?: number;
          /**
           * 预算指标编号
           */
          budgetUk?: string;
          /**
           * 部门支出经济分类名称
           */
          depExpendEconomicClassifyName?: string;
          /**
           * 总金额
           */
          totalAmount?: number;
          /**
           * 可用金额
           */
          availableAmount?: number;
          /**
           * 可用额度
           */
          quotaAvailableAmount?: number;
          /**
           * 预算占用金额
           */
          budgetAmount?: number;
          /**
           * 预算项目名称
           */
          projectName?: string;
          /**
           * 预算详情id
           */
          financialBudgetDetailId?: string;
          /**
           * 资金性质
           */
          fundsNatureName?: string;
          /**
           * 支出功能分类科目名称
           */
          expendFunctionClassifySubjectName?: string;
          /**
           * 是否包含政府采购预算，0:是、1：否
           */
          containsGovPurchaseBudget?: number;
          /**
           * 预算额度id
           */
          budgetQuotaId?: string;
          /**
           * 交易信息唯一编码code for 会议/培训多收款人
           */
          tradeCode?: string;
          /**
           * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
           */
          serialNumber?: number;
          /**
           * 支付记录code for 会议/培训多收款人
           */
          payRecordCode?: string;
          /**
           * 支出内容
           */
          expenditureItem?: string;
          /**
           * 所属部门
           */
          depName?: string;
          /**
           * 支付限额经济分类主键
           */
          budgetPlanClassifyUk?: string;
          /**
           * 支付限额经济分类编码
           */
          budgetPlanClassifyCode?: string;
          /**
           * 支付限额经济分类名称
           */
          budgetPlanClassifyName?: string;
          /**
           * 采购文号
           */
          purchaseNo?: string;
          /**
           * 支付限额经济分类总金额
           */
          budgetPlanClassifyTotalAmount?: number;
          /**
           * 支付限额经济分类可用金额
           */
          budgetPlanClassifyAvailableAmount?: number;
        }[];
        /**
         * 预算指标数据
         */
        quotaInfoROList?: {
          /**
           * 预算额度id
           */
          quotaId?: string;
          /**
           * 预算额度名称
           */
          quotaName?: string;
          /**
           * 年度
           */
          year?: number;
          /**
           * 资金性质（0：财政资金 1：自有资金）
           */
          fundsNature?: number;
          /**
           * 资金性质名称
           */
          fundsNatureName?: string;
          /**
           * 项目类别（1：基本支出，2：项目支出）
           */
          projectCategory?: number;
          /**
           * 部门支出经济分类名称 对应项目类别1
           */
          depExpendEconomicClassifyName?: string;
          /**
           * 项目名称 对应项目类别2
           */
          projectName?: string;
          /**
           * 总金额（分）
           */
          totalAmount?: number;
          /**
           * 可用额度（分）
           */
          availableAmount?: number;
          /**
           * 占用额度
           */
          budgetAmount?: number;
          /**
           * 交易信息唯一编码code for 会议/培训多收款人
           */
          tradeCode?: string;
          /**
           * 支付记录code for 会议/培训多收款人
           */
          payRecordCode?: string;
          /**
           * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
           */
          serialNumber?: number;
        }[];
        /**
         * 多收款人支付记录code
         */
        payRecordCode?: string;
        /**
         * 支付中心payID
         */
        payId?: string;
        /**
         * 支付类型描述
         */
        payStrategy?: number;
        /**
         * 支付类型描述
         */
        payStrategyName?: string;
        /**
         * 操作按钮
         */
        operatorButton?: {
          /**
           * 撤回
           */
          withdrawn?: boolean;
        };
      }[];
      /**
       * 宁波收款明细
       */
      receiverPayInfoDTOS?: {
        /**
         * 收款卡基本信息
         */
        expenseFormReceiverRO?: {
          /**
           * 操作人ID
           */
          operatorId: number;
          /**
           * 记录ID
           */
          accountCode?: string;
          /**
           * 收款金额
           */
          amount: number;
          /**
           * 收款人姓名
           */
          receiverName: string;
          /**
           * 银行卡类型
           * 1-公务卡，2-银行卡
           */
          cardType?: number;
          /**
           * 添加途径
           * 1-个人添加，2-单位添加
           */
          cardLevel?: number;
          /**
           * 卡号
           */
          cardNo?: string;
          /**
           * 收款人Code
           */
          receiverCode?: string;
          /**
           * 银行code
           */
          bankCode?: string;
          /**
           * 银行名字
           */
          bankName?: string;
          /**
           * 银行名字
           */
          bankBranchAliasName?: string;
          /**
           * 支行名称
           */
          bankBranchName?: string;
          /**
           * 支行code
           */
          bankBranchCode?: string;
          /**
           * 绑定银行卡状态：0-未绑定，1-绑定
           */
          bindStatus?: number;
          /**
           * 原收款金额
           */
          originalAmount?: number;
          /**
           * 调整原因
           */
          updateReason?: string;
          /**
           * 费用调整记录
           */
          feeModifyRecordROS?: {
            /**
             * 原金额
             */
            originalAmount?: number;
            /**
             * 调整原因
             */
            updateReason?: string;
            /**
             * 更新人名字
             */
            updateOperatorName?: string;
            /**
             * 调整后金额
             */
            updateAmount?: number;
            /**
             * 调整时间
             */
            updateTime?: number;
          }[];
          /**
           * 人员来源 1-系统内部；2-外部人员
           */
          userSource?: 1 | 2;
          isSnapshot?: number;
          userType?: number;
          type?: number;
          payStatus?: number;
          /**
           * 类型
           */
          fundsObjectType?:
            | 1
            | 11
            | 12
            | 13
            | 14
            | 19
            | 2
            | 21
            | 22
            | 23
            | 24
            | 3
            | 31
            | 32
            | 4
            | 41
            | 42;
          /**
           * 往来资金对象类型描述
           */
          fundsObjectTypeDesc?: string;
        };
        /**
         * 个人卡报销
         */
        personalCardExpenseDTOS?: {
          /**
           * 消费记录code
           */
          consumptionRecordCode?: string;
          /**
           * 消费金额
           */
          amount?: number;
          /**
           * 支付明细
           */
          expenseFormPayInfoList?: {
            /**
             * 收款人姓名
             */
            receiveUserName?: string;
            /**
             * 收款方式：收款银行名称
             */
            receiveBankName?: string;
            /**
             * 收款方式：收款账号
             */
            receiveAccountNo?: string;
            /**
             * 应付金额
             */
            payAmount?: number;
            /**
             * 支付令
             */
            thirdTradeNo?: string;
            /**
             * 三方流水号
             */
            thirdPayFlowNo?: string;
            /**
             * 支付状态 0:待支付 1:支付中 2:支付成功 3:支付失败
             */
            payStatus?: number;
            /**
             * 支付状态描述
             */
            payStatusDesc?: string;
            /**
             * 失败原因
             */
            failureReason?: string;
            /**
             * 操作人ID
             */
            operatorId?: number;
            /**
             * receiverCode
             */
            receiverCode?: string;
            /**
             * 银行卡号
             */
            accountCode?: string;
            /**
             * 人员来源 1-系统内部；2-外部人员
             */
            userSource?: 1 | 2;
            /**
             * 外部人员id
             */
            outerUser?: number;
            /**
             * 预算指标数据
             */
            budgetInfoROList?: {
              /**
               * 预算年度
               */
              year?: number;
              /**
               * 预算指标文号
               */
              budgetNo?: string;
              /**
               * 主预算id
               */
              mainBudgetCode?: number;
              /**
               * 预算指标编号
               */
              budgetUk?: string;
              /**
               * 部门支出经济分类名称
               */
              depExpendEconomicClassifyName?: string;
              /**
               * 总金额
               */
              totalAmount?: number;
              /**
               * 可用金额
               */
              availableAmount?: number;
              /**
               * 可用额度
               */
              quotaAvailableAmount?: number;
              /**
               * 预算占用金额
               */
              budgetAmount?: number;
              /**
               * 预算项目名称
               */
              projectName?: string;
              /**
               * 预算详情id
               */
              financialBudgetDetailId?: string;
              /**
               * 资金性质
               */
              fundsNatureName?: string;
              /**
               * 支出功能分类科目名称
               */
              expendFunctionClassifySubjectName?: string;
              /**
               * 是否包含政府采购预算，0:是、1：否
               */
              containsGovPurchaseBudget?: number;
              /**
               * 预算额度id
               */
              budgetQuotaId?: string;
              /**
               * 交易信息唯一编码code for 会议/培训多收款人
               */
              tradeCode?: string;
              /**
               * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
               */
              serialNumber?: number;
              /**
               * 支付记录code for 会议/培训多收款人
               */
              payRecordCode?: string;
              /**
               * 支出内容
               */
              expenditureItem?: string;
              /**
               * 所属部门
               */
              depName?: string;
              /**
               * 支付限额经济分类主键
               */
              budgetPlanClassifyUk?: string;
              /**
               * 支付限额经济分类编码
               */
              budgetPlanClassifyCode?: string;
              /**
               * 支付限额经济分类名称
               */
              budgetPlanClassifyName?: string;
              /**
               * 采购文号
               */
              purchaseNo?: string;
              /**
               * 支付限额经济分类总金额
               */
              budgetPlanClassifyTotalAmount?: number;
              /**
               * 支付限额经济分类可用金额
               */
              budgetPlanClassifyAvailableAmount?: number;
            }[];
            /**
             * 预算指标数据
             */
            quotaInfoROList?: {
              /**
               * 预算额度id
               */
              quotaId?: string;
              /**
               * 预算额度名称
               */
              quotaName?: string;
              /**
               * 年度
               */
              year?: number;
              /**
               * 资金性质（0：财政资金 1：自有资金）
               */
              fundsNature?: number;
              /**
               * 资金性质名称
               */
              fundsNatureName?: string;
              /**
               * 项目类别（1：基本支出，2：项目支出）
               */
              projectCategory?: number;
              /**
               * 部门支出经济分类名称 对应项目类别1
               */
              depExpendEconomicClassifyName?: string;
              /**
               * 项目名称 对应项目类别2
               */
              projectName?: string;
              /**
               * 总金额（分）
               */
              totalAmount?: number;
              /**
               * 可用额度（分）
               */
              availableAmount?: number;
              /**
               * 占用额度
               */
              budgetAmount?: number;
              /**
               * 交易信息唯一编码code for 会议/培训多收款人
               */
              tradeCode?: string;
              /**
               * 支付记录code for 会议/培训多收款人
               */
              payRecordCode?: string;
              /**
               * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
               */
              serialNumber?: number;
            }[];
            /**
             * 多收款人支付记录code
             */
            payRecordCode?: string;
            /**
             * 支付中心payID
             */
            payId?: string;
            /**
             * 支付类型描述
             */
            payStrategy?: number;
            /**
             * 支付类型描述
             */
            payStrategyName?: string;
            /**
             * 操作按钮
             */
            operatorButton?: {
              /**
               * 撤回
               */
              withdrawn?: boolean;
            };
          }[];
        }[];
        /**
         * 收款人支付状态
         */
        receiverPayStatus?: number;
        /**
         * 收款人支付状态描述
         */
        receiverPayStatusDesc?: string;
      }[];
      /**
       * 报销单支付是否变更 0-否，1-已变更
       */
      payChangeStatus?: number;
      /**
       * 支付更正记录
       */
      expensePayChangeInfoROList?: {
        /**
         * 支付金额
         */
        amount?: number;
        /**
         * 原支付令号
         */
        oldThirdTradeNo?: string;
        /**
         * 更正支付令号
         * 注：支付退款的情况为空
         */
        newThirdTradeNo?: string;
        /**
         * 更正前预算信息
         */
        oldBudgetInfoRO?: {
          /**
           * 预算年度
           */
          year?: number;
          /**
           * 预算指标文号
           */
          budgetNo?: string;
          /**
           * 主预算id
           */
          mainBudgetCode?: number;
          /**
           * 预算指标编号
           */
          budgetUk?: string;
          /**
           * 部门支出经济分类名称
           */
          depExpendEconomicClassifyName?: string;
          /**
           * 总金额
           */
          totalAmount?: number;
          /**
           * 可用金额
           */
          availableAmount?: number;
          /**
           * 可用额度
           */
          quotaAvailableAmount?: number;
          /**
           * 预算占用金额
           */
          budgetAmount?: number;
          /**
           * 预算项目名称
           */
          projectName?: string;
          /**
           * 预算详情id
           */
          financialBudgetDetailId?: string;
          /**
           * 资金性质
           */
          fundsNatureName?: string;
          /**
           * 支出功能分类科目名称
           */
          expendFunctionClassifySubjectName?: string;
          /**
           * 是否包含政府采购预算，0:是、1：否
           */
          containsGovPurchaseBudget?: number;
          /**
           * 预算额度id
           */
          budgetQuotaId?: string;
          /**
           * 交易信息唯一编码code for 会议/培训多收款人
           */
          tradeCode?: string;
          /**
           * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
           */
          serialNumber?: number;
          /**
           * 支付记录code for 会议/培训多收款人
           */
          payRecordCode?: string;
          /**
           * 支出内容
           */
          expenditureItem?: string;
          /**
           * 所属部门
           */
          depName?: string;
          /**
           * 支付限额经济分类主键
           */
          budgetPlanClassifyUk?: string;
          /**
           * 支付限额经济分类编码
           */
          budgetPlanClassifyCode?: string;
          /**
           * 支付限额经济分类名称
           */
          budgetPlanClassifyName?: string;
          /**
           * 采购文号
           */
          purchaseNo?: string;
          /**
           * 支付限额经济分类总金额
           */
          budgetPlanClassifyTotalAmount?: number;
          /**
           * 支付限额经济分类可用金额
           */
          budgetPlanClassifyAvailableAmount?: number;
        };
        /**
         * 更正后预算信息
         */
        newBudgetInfoRO?: {
          /**
           * 预算年度
           */
          year?: number;
          /**
           * 预算指标文号
           */
          budgetNo?: string;
          /**
           * 主预算id
           */
          mainBudgetCode?: number;
          /**
           * 预算指标编号
           */
          budgetUk?: string;
          /**
           * 部门支出经济分类名称
           */
          depExpendEconomicClassifyName?: string;
          /**
           * 总金额
           */
          totalAmount?: number;
          /**
           * 可用金额
           */
          availableAmount?: number;
          /**
           * 可用额度
           */
          quotaAvailableAmount?: number;
          /**
           * 预算占用金额
           */
          budgetAmount?: number;
          /**
           * 预算项目名称
           */
          projectName?: string;
          /**
           * 预算详情id
           */
          financialBudgetDetailId?: string;
          /**
           * 资金性质
           */
          fundsNatureName?: string;
          /**
           * 支出功能分类科目名称
           */
          expendFunctionClassifySubjectName?: string;
          /**
           * 是否包含政府采购预算，0:是、1：否
           */
          containsGovPurchaseBudget?: number;
          /**
           * 预算额度id
           */
          budgetQuotaId?: string;
          /**
           * 交易信息唯一编码code for 会议/培训多收款人
           */
          tradeCode?: string;
          /**
           * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
           */
          serialNumber?: number;
          /**
           * 支付记录code for 会议/培训多收款人
           */
          payRecordCode?: string;
          /**
           * 支出内容
           */
          expenditureItem?: string;
          /**
           * 所属部门
           */
          depName?: string;
          /**
           * 支付限额经济分类主键
           */
          budgetPlanClassifyUk?: string;
          /**
           * 支付限额经济分类编码
           */
          budgetPlanClassifyCode?: string;
          /**
           * 支付限额经济分类名称
           */
          budgetPlanClassifyName?: string;
          /**
           * 采购文号
           */
          purchaseNo?: string;
          /**
           * 支付限额经济分类总金额
           */
          budgetPlanClassifyTotalAmount?: number;
          /**
           * 支付限额经济分类可用金额
           */
          budgetPlanClassifyAvailableAmount?: number;
        };
        /**
         * 更正前限额信息
         */
        oldBpcInfo?: {
          /**
           * 限额主键
           */
          uk?: string;
          /**
           * 支付限额：格式：部门经济分类_采购文号_项目名称
           */
          name?: string;
        };
        /**
         * 更正后限额信息
         */
        newBpcInfo?: {
          /**
           * 限额主键
           */
          uk?: string;
          /**
           * 支付限额：格式：部门经济分类_采购文号_项目名称
           */
          name?: string;
        };
      }[];
    };
    /**
     * 预算信息
     */
    budgetInfo?: {
      /**
       * 预算配置
       */
      budgetFlag?: boolean;
      /**
       * 冻结预算总金额
       */
      frozenBudgetTotalAmount?: number;
      /**
       * 预算指标信息
       */
      budgetInfoList?: {
        /**
         * 预算年度
         */
        year?: number;
        /**
         * 预算指标文号
         */
        budgetNo?: string;
        /**
         * 主预算id
         */
        mainBudgetCode?: number;
        /**
         * 预算指标编号
         */
        budgetUk?: string;
        /**
         * 部门支出经济分类名称
         */
        depExpendEconomicClassifyName?: string;
        /**
         * 总金额
         */
        totalAmount?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
        /**
         * 可用额度
         */
        quotaAvailableAmount?: number;
        /**
         * 预算占用金额
         */
        budgetAmount?: number;
        /**
         * 预算项目名称
         */
        projectName?: string;
        /**
         * 预算详情id
         */
        financialBudgetDetailId?: string;
        /**
         * 资金性质
         */
        fundsNatureName?: string;
        /**
         * 支出功能分类科目名称
         */
        expendFunctionClassifySubjectName?: string;
        /**
         * 是否包含政府采购预算，0:是、1：否
         */
        containsGovPurchaseBudget?: number;
        /**
         * 预算额度id
         */
        budgetQuotaId?: string;
        /**
         * 交易信息唯一编码code for 会议/培训多收款人
         */
        tradeCode?: string;
        /**
         * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
         */
        serialNumber?: number;
        /**
         * 支付记录code for 会议/培训多收款人
         */
        payRecordCode?: string;
        /**
         * 支出内容
         */
        expenditureItem?: string;
        /**
         * 所属部门
         */
        depName?: string;
        /**
         * 支付限额经济分类主键
         */
        budgetPlanClassifyUk?: string;
        /**
         * 支付限额经济分类编码
         */
        budgetPlanClassifyCode?: string;
        /**
         * 支付限额经济分类名称
         */
        budgetPlanClassifyName?: string;
        /**
         * 采购文号
         */
        purchaseNo?: string;
        /**
         * 支付限额经济分类总金额
         */
        budgetPlanClassifyTotalAmount?: number;
        /**
         * 支付限额经济分类可用金额
         */
        budgetPlanClassifyAvailableAmount?: number;
      }[];
      /**
       * 预算额度信息
       */
      quotaInfoList?: {
        /**
         * 预算额度id
         */
        quotaId?: string;
        /**
         * 预算额度名称
         */
        quotaName?: string;
        /**
         * 年度
         */
        year?: number;
        /**
         * 资金性质（0：财政资金 1：自有资金）
         */
        fundsNature?: number;
        /**
         * 资金性质名称
         */
        fundsNatureName?: string;
        /**
         * 项目类别（1：基本支出，2：项目支出）
         */
        projectCategory?: number;
        /**
         * 部门支出经济分类名称 对应项目类别1
         */
        depExpendEconomicClassifyName?: string;
        /**
         * 项目名称 对应项目类别2
         */
        projectName?: string;
        /**
         * 总金额（分）
         */
        totalAmount?: number;
        /**
         * 可用额度（分）
         */
        availableAmount?: number;
        /**
         * 占用额度
         */
        budgetAmount?: number;
        /**
         * 交易信息唯一编码code for 会议/培训多收款人
         */
        tradeCode?: string;
        /**
         * 支付记录code for 会议/培训多收款人
         */
        payRecordCode?: string;
        /**
         * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
         */
        serialNumber?: number;
      }[];
    };
    /**
     * 工作流信息
     */
    workflowInfo?: {
      /**
       * 是否开启工作流
       * true-开启；false-未开启
       */
      enableWorkflow?: boolean;
      /**
       * 工作流流程信息
       */
      workflowInstanceInfo?: {
        /**
         * 工作流的唯一key
         */
        workflowProcessKey?: string;
        /**
         * 工作流模型id
         */
        workflowModelId?: number;
        /**
         * 工作流版本
         */
        workflowVersion?: number;
        /**
         * 审核节点列表
         */
        auditNodeList?: {
          /**
           * 审核人列表
           */
          auditOperatorList?: {
            /**
             * 人员id
             */
            operatorId?: number;
            /**
             * 人员名称
             */
            operatorName?: string;
            /**
             * 机构id
             */
            institutionId?: number;
            /**
             * 机构名称
             */
            institutionName?: string;
            /**
             * 审批意见
             */
            auditRemark?: string;
            /**
             * 审批状态：0-待审批，1-审批通过，2-审批驳回
             */
            auditStatus?: number;
            /**
             * 审核时间
             */
            auditTime?: string;
            /**
             * 签名附件
             */
            signAttachment?: {
              /**
               * 附件OssId
               */
              fileId?: string;
              /**
               * 附件类型
               */
              type?: string;
              /**
               * 业务编号
               */
              bizNo?: string;
              /**
               * 附件名称
               */
              name?: string;
              /**
               * 附件大小
               */
              size?: number;
              /**
               * 桶的key
               */
              bizCode?: string;
              /**
               * 下载文件的url
               */
              url?: string;
              /**
               * 文件大小描述
               */
              sizeDesc?: string;
            };
            /**
             * 最新的个人历史签名附件
             */
            oneselfHistorySignAttachment?: {
              /**
               * 附件OssId
               */
              fileId?: string;
              /**
               * 附件类型
               */
              type?: string;
              /**
               * 业务编号
               */
              bizNo?: string;
              /**
               * 附件名称
               */
              name?: string;
              /**
               * 附件大小
               */
              size?: number;
              /**
               * 桶的key
               */
              bizCode?: string;
              /**
               * 下载文件的url
               */
              url?: string;
              /**
               * 文件大小描述
               */
              sizeDesc?: string;
            };
            /**
             * 加签方式：-1-未加签，0-后加签（作废，由于历史是0，后续统一为2），1-前加签，2-后加签
             */
            addAuditWay?: number;
            /**
             * 加签者
             */
            addAuditOperator?: string;
            /**
             * 工作流评论信息
             */
            comment?: {
              /**
               * 评论内容
               */
              commentContent?: string;
              /**
               * 评论人ID
               */
              operatorId?: number;
              /**
               * 评论人名字
               */
              operatorName?: string;
              /**
               * 评论唯一代码
               */
              commentCode?: string;
              /**
               * 评论时间
               */
              commentTime?: number;
              /**
               * 图片附件集合
               */
              pictureAttachments?: {
                /**
                 * 附件OssId
                 */
                fileId?: string;
                /**
                 * 附件类型
                 */
                type?: string;
                /**
                 * 业务编号
                 */
                bizNo?: string;
                /**
                 * 附件名称
                 */
                name?: string;
                /**
                 * 附件大小
                 */
                size?: number;
                /**
                 * 桶的key
                 */
                bizCode?: string;
                /**
                 * 下载文件的url
                 */
                url?: string;
                /**
                 * 文件大小描述
                 */
                sizeDesc?: string;
              }[];
              /**
               * 其他附件集合
               */
              otherAttachments?: {
                /**
                 * 附件OssId
                 */
                fileId?: string;
                /**
                 * 附件类型
                 */
                type?: string;
                /**
                 * 业务编号
                 */
                bizNo?: string;
                /**
                 * 附件名称
                 */
                name?: string;
                /**
                 * 附件大小
                 */
                size?: number;
                /**
                 * 桶的key
                 */
                bizCode?: string;
                /**
                 * 下载文件的url
                 */
                url?: string;
                /**
                 * 文件大小描述
                 */
                sizeDesc?: string;
              }[];
              /**
               * 是否可以删除该评论
               */
              remove?: boolean;
            };
            /**
             * 操作人类型
             */
            operatorType?: number;
          }[];
          /**
           * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
           */
          userRangeType?: number;
          userRangeTypeNew?: number;
          /**
           * 动态审核人类型
           */
          userRangeValues?: string[];
          userRangeValuesNew?: string[];
          /**
           * 审核人数(总人数)
           */
          personCount?: number;
          /**
           * 审核状态：0-待审批，1-已审批，2-审批驳回
           */
          auditStatus?: number;
          /**
           * 审核时间
           */
          auditTime?: string;
          /**
           * 审核描述
           */
          auditDesc?: string;
          /**
           * 审批类型：0-或签，1-会签，2-依次审批
           */
          auditType?: number;
          /**
           * 事件类型：0-审批，1-审核，2-出纳，3-抄送 98-提交人 99-评论
           */
          eventType?: number;
          /**
           * 是否自选:0-指定，1-自选
           */
          nodeType?: number;
          /**
           * 节点key
           */
          nodeKey?: string;
          /**
           * 节点名称
           */
          nodeName?: string;
          /**
           * 策略
           * cn.gov.zcy.workflow.enums.CheckStrategyEnum
           */
          checkStrategy?: number;
          /**
           * 部门id （为了获取部门主管）
           */
          departmentId?: number;
          /**
           * 机构
           */
          institutionSelfDtos?: {
            /**
             * 机构编码
             */
            code?: string;
            /**
             * 机构名称
             */
            name?: string;
            userType?: string;
            /**
             * 租户编码（区划编码）
             */
            tenantCode?: string;
            /**
             * 租户编码名称（区划名称）
             */
            tenantName?: string;
            uniqueKey?: string;
            parentInstitution?: {
              parentCode?: number;
              parentName?: string;
            };
          }[];
          /**
           * 常用审核人列表
           */
          commonAuditorList?: {
            displayName?: string;
            userId?: number;
            operatorId?: number;
            code?: string;
            gender?: number;
            institutionId?: number;
            institution?: {
              id?: number;
              createdAt?: number;
              updatedAt?: number;
              creatorId?: string;
              modifierId?: string;
              extFields?: string;
              name?: string;
              shortName?: string;
              orgCode?: string;
              creditCode?: string;
              bizAttaches?: string;
              tags?: string;
              provinceCode?: string;
              provinceName?: string;
              cityCode?: string;
              cityName?: string;
              regionCode?: string;
              regionName?: string;
              address?: string;
              status?: number;
              displayOrder?: number;
              outCreatedAt?: string;
              divisionCode?: string;
              fullName?: string;
              postalCode?: string;
              source?: number;
              organizationCode?: string;
              institutionLevel?: number;
            };
            deptName?: string;
          }[];
          /**
           * 业务属性json
           */
          bizProperty?: string;
          /**
           * 工作流评论信息
           */
          comment?: {
            /**
             * 评论内容
             */
            commentContent?: string;
            /**
             * 评论人ID
             */
            operatorId?: number;
            /**
             * 评论人名字
             */
            operatorName?: string;
            /**
             * 评论唯一代码
             */
            commentCode?: string;
            /**
             * 评论时间
             */
            commentTime?: number;
            /**
             * 图片附件集合
             */
            pictureAttachments?: {
              /**
               * 附件OssId
               */
              fileId?: string;
              /**
               * 附件类型
               */
              type?: string;
              /**
               * 业务编号
               */
              bizNo?: string;
              /**
               * 附件名称
               */
              name?: string;
              /**
               * 附件大小
               */
              size?: number;
              /**
               * 桶的key
               */
              bizCode?: string;
              /**
               * 下载文件的url
               */
              url?: string;
              /**
               * 文件大小描述
               */
              sizeDesc?: string;
            }[];
            /**
             * 其他附件集合
             */
            otherAttachments?: {
              /**
               * 附件OssId
               */
              fileId?: string;
              /**
               * 附件类型
               */
              type?: string;
              /**
               * 业务编号
               */
              bizNo?: string;
              /**
               * 附件名称
               */
              name?: string;
              /**
               * 附件大小
               */
              size?: number;
              /**
               * 桶的key
               */
              bizCode?: string;
              /**
               * 下载文件的url
               */
              url?: string;
              /**
               * 文件大小描述
               */
              sizeDesc?: string;
            }[];
            /**
             * 是否可以删除该评论
             */
            remove?: boolean;
          };
        }[];
        /**
         * 申请人操作人id
         */
        applyOperatorId?: number;
        /**
         * 申请人名称
         */
        applyOperatorName?: string;
        /**
         * 申请时间
         */
        applyTime?: string;
        /**
         * 申请备注
         */
        applyRemark?: string;
        /**
         * 是否能加签 0-否 1-是
         */
        isAddTaskAccess?: number;
        /**
         * 工作流是否开启签名：true-开启；false-未开启
         */
        isEnableSign?: boolean;
        /**
         * 签名配置：0-使用上次签名；1-每次重新签名；
         */
        signConfig?: number;
        /**
         * 当前节点可驳回节点列表
         */
        availableRejectNodeList?: {
          /**
           * 节点名
           */
          nodeName?: string;
          /**
           * 节点uk
           */
          nodeKey?: string;
          /**
           * 节点操作人名字集合
           */
          operatorNames?: string[];
        }[];
        /**
         * 实例当前节点业务属性
         */
        currentBizProperty?: string;
      };
    };
    /**
     * 支付更正记录
     */
    payChangeInfoList?: {
      /**
       * 支付金额
       */
      amount?: number;
      /**
       * 原支付令号
       */
      oldThirdTradeNo?: string;
      /**
       * 更正支付令号
       * 注：支付退款的情况为空
       */
      newThirdTradeNo?: string;
      /**
       * 更正前预算信息
       */
      oldBudgetInfoRO?: {
        /**
         * 预算年度
         */
        year?: number;
        /**
         * 预算指标文号
         */
        budgetNo?: string;
        /**
         * 主预算id
         */
        mainBudgetCode?: number;
        /**
         * 预算指标编号
         */
        budgetUk?: string;
        /**
         * 部门支出经济分类名称
         */
        depExpendEconomicClassifyName?: string;
        /**
         * 总金额
         */
        totalAmount?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
        /**
         * 可用额度
         */
        quotaAvailableAmount?: number;
        /**
         * 预算占用金额
         */
        budgetAmount?: number;
        /**
         * 预算项目名称
         */
        projectName?: string;
        /**
         * 预算详情id
         */
        financialBudgetDetailId?: string;
        /**
         * 资金性质
         */
        fundsNatureName?: string;
        /**
         * 支出功能分类科目名称
         */
        expendFunctionClassifySubjectName?: string;
        /**
         * 是否包含政府采购预算，0:是、1：否
         */
        containsGovPurchaseBudget?: number;
        /**
         * 预算额度id
         */
        budgetQuotaId?: string;
        /**
         * 交易信息唯一编码code for 会议/培训多收款人
         */
        tradeCode?: string;
        /**
         * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
         */
        serialNumber?: number;
        /**
         * 支付记录code for 会议/培训多收款人
         */
        payRecordCode?: string;
        /**
         * 支出内容
         */
        expenditureItem?: string;
        /**
         * 所属部门
         */
        depName?: string;
        /**
         * 支付限额经济分类主键
         */
        budgetPlanClassifyUk?: string;
        /**
         * 支付限额经济分类编码
         */
        budgetPlanClassifyCode?: string;
        /**
         * 支付限额经济分类名称
         */
        budgetPlanClassifyName?: string;
        /**
         * 采购文号
         */
        purchaseNo?: string;
        /**
         * 支付限额经济分类总金额
         */
        budgetPlanClassifyTotalAmount?: number;
        /**
         * 支付限额经济分类可用金额
         */
        budgetPlanClassifyAvailableAmount?: number;
      };
      /**
       * 更正后预算信息
       */
      newBudgetInfoRO?: {
        /**
         * 预算年度
         */
        year?: number;
        /**
         * 预算指标文号
         */
        budgetNo?: string;
        /**
         * 主预算id
         */
        mainBudgetCode?: number;
        /**
         * 预算指标编号
         */
        budgetUk?: string;
        /**
         * 部门支出经济分类名称
         */
        depExpendEconomicClassifyName?: string;
        /**
         * 总金额
         */
        totalAmount?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
        /**
         * 可用额度
         */
        quotaAvailableAmount?: number;
        /**
         * 预算占用金额
         */
        budgetAmount?: number;
        /**
         * 预算项目名称
         */
        projectName?: string;
        /**
         * 预算详情id
         */
        financialBudgetDetailId?: string;
        /**
         * 资金性质
         */
        fundsNatureName?: string;
        /**
         * 支出功能分类科目名称
         */
        expendFunctionClassifySubjectName?: string;
        /**
         * 是否包含政府采购预算，0:是、1：否
         */
        containsGovPurchaseBudget?: number;
        /**
         * 预算额度id
         */
        budgetQuotaId?: string;
        /**
         * 交易信息唯一编码code for 会议/培训多收款人
         */
        tradeCode?: string;
        /**
         * 多收款人展示预算明细号（其实就是序列号，产品硬要个明细号）
         */
        serialNumber?: number;
        /**
         * 支付记录code for 会议/培训多收款人
         */
        payRecordCode?: string;
        /**
         * 支出内容
         */
        expenditureItem?: string;
        /**
         * 所属部门
         */
        depName?: string;
        /**
         * 支付限额经济分类主键
         */
        budgetPlanClassifyUk?: string;
        /**
         * 支付限额经济分类编码
         */
        budgetPlanClassifyCode?: string;
        /**
         * 支付限额经济分类名称
         */
        budgetPlanClassifyName?: string;
        /**
         * 采购文号
         */
        purchaseNo?: string;
        /**
         * 支付限额经济分类总金额
         */
        budgetPlanClassifyTotalAmount?: number;
        /**
         * 支付限额经济分类可用金额
         */
        budgetPlanClassifyAvailableAmount?: number;
      };
      /**
       * 更正前限额信息
       */
      oldBpcInfo?: {
        /**
         * 限额主键
         */
        uk?: string;
        /**
         * 支付限额：格式：部门经济分类_采购文号_项目名称
         */
        name?: string;
      };
      /**
       * 更正后限额信息
       */
      newBpcInfo?: {
        /**
         * 限额主键
         */
        uk?: string;
        /**
         * 支付限额：格式：部门经济分类_采购文号_项目名称
         */
        name?: string;
      };
    }[];
    /**
     * 代发户信息
     */
    transitionalReceiverInfo?: {
      /**
       * 收款记录Code
       */
      receiverCode?: string;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 支付状态
       */
      payStatus?: number;
      /**
       * 支付状态描述
       */
      payStatusDesc?: string;
      /**
       * 银行卡信息
       */
      bankCardInfo?: {
        /**
         * 银行卡唯一标识
         */
        accountCode?: string;
        /**
         * 银行代码
         */
        bankCode?: string;
        /**
         * 银行名称
         */
        bankName?: string;
        /**
         * 支行代码
         */
        subBankCode?: string;
        /**
         * 支行名称
         */
        subBankName?: string;
        /**
         * 账户名
         */
        accountName?: string;
        /**
         * 银行账号
         */
        accountNo?: string;
        /**
         * 账号类别
         * 个人卡、公务卡、对公卡
         */
        cardType?: number;
        /**
         * 所属人id
         */
        operatorId?: number;
        /**
         * 所属人员类别
         */
        userType?: number;
        /**
         * 所属人机构id
         */
        institutionId?: number;
      };
    };
    /**
     * 按钮信息
     */
    operateButton?: {
      /**
       * 编辑
       */
      edit?: boolean;
      /**
       * 删除
       */
      delete?: boolean;
      /**
       * 作废
       */
      discard?: boolean;
      /**
       * 去采购
       */
      purchase?: boolean;
      /**
       * 去报销
       */
      expense?: boolean;
      /**
       * 去预订
       */
      reserve?: boolean;
      /**
       * 去处理
       */
      handle?: boolean;
      /**
       * 重新发起
       */
      restart?: boolean;
      /**
       * 撤回
       */
      withdrawn?: boolean;
      /**
       * 加签
       */
      signature?: boolean;
      /**
       * 通过
       */
      pass?: boolean;
      /**
       * 驳回
       */
      reject?: boolean;
      /**
       * 打印
       */
      print?: boolean;
      /**
       * 驳回
       */
      rejectFinance?: boolean;
      /**
       * 重新支付
       */
      repayFinance?: boolean;
      /**
       * 复核订正账户
       */
      recheckCorrAcc?: boolean;
      /**
       * 评论
       */
      comment?: boolean;
    };
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: {
      /**
       * 部门ID
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 项目编号
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 科目编号
       */
      subjectUk?: string;
      /**
       * 科目名称
       */
      subjectName?: string;
      /**
       * 预算填报记录编号
       */
      budgetProjectRecordUk?: string;
      /**
       * 占用金额
       */
      amount?: number;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 操作人，后端使用
       */
      operatorId?: number;
      /**
       * 科目级联uk
       */
      subjectUkHierarchy?: string[];
      /**
       * 科目级联
       */
      subjectNameHierarchy?: string[];
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单个发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526658) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/pay-form/info`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimePayFormInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/pay-form/info',
    'data',
    string,
    'formCode' | 'needAuth' | 'identity' | 'desensitize',
    false
  >
>;

/**
 * 接口 [查询单个发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526658) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/pay-form/info`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimePayFormInfoGetRequestConfig: ZlbApiExpenseOvertimePayFormInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/pay-form/info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: ['formCode', 'needAuth', 'identity', 'desensitize'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimePayFormInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单个发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526658) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/pay-form/info`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimePayFormInfoGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimePayFormInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimePayFormInfoGetResponse>(
    prepare(zlbApiExpenseOvertimePayFormInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimePayFormInfoGet.requestConfig =
  zlbApiExpenseOvertimePayFormInfoGetRequestConfig;

/**
 * 接口 [保存发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526666) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/save`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormSavePostRequest {
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 是否忽略弱控
   */
  isIgnoreWarning?: boolean;
  /**
   * 基本信息
   */
  basicInfo?: {
    /**
     * 操作人
     */
    operatorId?: number;
    /**
     * 操作人
     */
    operatorName?: string;
    /**
     * 部门ID
     */
    deptId?: number;
    /**
     * 部门名称
     */
    deptName?: string;
    /**
     * 事由
     */
    reason?: string;
    /**
     * 备注
     */
    remark?: string;
  };
  /**
   * 附件信息
   */
  attachmentList?: {
    /**
     * 附件业务子类型
     */
    subBizType?:
      | 1
      | 2
      | 3
      | 4
      | 5
      | 6
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 19
      | 20
      | 21
      | 22;
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 链接
     */
    url?: string;
    /**
     * oss桶的key
     */
    bucketKey?: string;
  }[];
  /**
   * 发放明细
   */
  receiverInfoList?: {
    /**
     * 收款记录Code
     */
    receiverCode?: string;
    /**
     * 收款金额
     */
    amount?: number;
    /**
     * 银行卡信息
     */
    bankCardInfo?: {
      /**
       * 账户code
       */
      accountCode?: string;
      /**
       * 收款人opId
       */
      operatorId?: number;
      /**
       * 收款户名
       */
      accountName: string;
      /**
       * 收款账户
       */
      accountNo: string;
      /**
       * 收款银行
       */
      bankName: string;
    };
    /**
     * 关联的夜餐费明细编号
     */
    nightMealFeeDetailCodeList?: string[];
  }[];
  /**
   * 支付信息
   */
  payInfo?: {
    /**
     * 支付方式(1：国库支付，3：非财政资金网银结算，4：库集中支付+非财政资金结算
     */
    payMode?: number;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategy?: number;
    /**
     * 变更支付方式说明
     */
    changePayModeReason?: string;
    /**
     * 摘要
     */
    summary?: string;
    /**
     * 宁波收款明细PO
     */
    receiverPayInfoQueryList?: {
      /**
       * 收款卡基本信息
       */
      receiverPO?: {
        /**
         * 操作人ID
         */
        operatorId: number;
        /**
         * 账号code
         */
        accountCode?: string;
        /**
         * 收款金额
         */
        amount: number;
        /**
         * 原收款金额
         */
        originalAmount?: number;
        /**
         * 收款人姓名
         */
        receiverName: string;
        /**
         * 前端数组下标
         */
        indexNo: string;
        /**
         * 收款人Code
         */
        receiverCode?: string;
        /**
         * 调整原因
         */
        updateReason?: string;
        /**
         * 费用更新金额
         */
        modifyFeeAmountDTO?: {
          /**
           * 原始金额
           */
          originalAmount: number;
          /**
           * 修改后金额
           */
          updateAmount: number;
          /**
           * 修改备注
           */
          updateReason?: string;
          /**
           * 原始账户
           */
          originalAccount?: string;
          /**
           * 修改后账户
           */
          updateAccount?: string;
        };
        /**
         * 人员来源 1-系统内部；2-外部人员
         */
        userSource?: 1 | 2;
        userType?: number;
        /**
         * 用户类型
         */
        type?: number;
        /**
         * 类型
         */
        fundsObjectType?:
          | 1
          | 11
          | 12
          | 13
          | 14
          | 19
          | 2
          | 21
          | 22
          | 23
          | 24
          | 3
          | 31
          | 32
          | 4
          | 41
          | 42;
      };
      /**
       * 个人卡报销
       */
      personalCardExpenseQueryList?: {
        /**
         * 前端下标
         */
        indexNo: string;
        /**
         * 消费金额
         */
        amount?: number;
        /**
         * 拆分的金额
         */
        splitAmount?: number[];
        /**
         * 报销里的消费记录主键
         */
        consumptionRecordCode?: string;
        /**
         * 拆分金额
         */
        splitAmountDetail?: {
          /**
           * 拆分金额
           */
          amount: number;
          /**
           * 支付类型
           */
          payStrategy:
            | 'FINA_ZERO_PAY'
            | 'UNIT_ZERO_PAY'
            | 'UNIT_FUND_PAY'
            | 'FINA_SPLIT_PAY'
            | 'AUTH_NORMAL_PAY'
            | 'DIRECTLY_NORMAL_PAY'
            | 'AUTH_BUSINESS_CARD_PAY'
            | 'AUTH_PERSONAL_BATCH_PAY'
            | 'AUTH_ENTERPRISE_BATCH_PAY'
            | 'FINA_AND_FUND_PAY'
            | 'UNIT_FUND_NORMAL_PAY'
            | 'UNIT_FUND_OFF_CARD_PAY'
            | 'NB_FINA_ZERO_PAY'
            | 'NB_UNIT_ZERO_PAY'
            | 'NB_UNIT_FUND_PAY'
            | 'NB_FINA_SPLIT_PAY'
            | 'CBS_NORMAL_PAY'
            | 'CBS_BATCH_PAY';
          /**
           * 支付类型名称
           */
          payStrategyName?: string;
        }[];
      }[];
    }[];
  };
  /**
   * 预算信息
   */
  budgetInfo?: {
    /**
     * 主预算编号
     */
    mainBudgetCode: number;
    /**
     * 预算指标编号
     */
    budgetUk: string;
    /**
     * 预算支付限额分类
     */
    budgetPlanClassifyUk: string;
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 交易信息 for 会议/培训多收款人
     */
    tradeCode?: string;
    /**
     * 支付记录信息code
     */
    payRecordCode?: string;
  }[];
  /**
   * 收款人，普通/授权支付时必传
   */
  transitionalReceiverInfo?: {
    /**
     * 收款银行卡code
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount?: number;
  };
  /**
   * 审批信息
   */
  workflowInfo?: {
    /**
     * 是否开启工作流 true-开启；false-未开启
     */
    enableWorkflow?: boolean;
    /**
     * 工作流信息
     */
    workflowSubmitPO?: {
      /**
       * 业务标识
       */
      bizId?: string;
      /**
       * 必填, 业务场景
       */
      bizType?: string;
      /**
       * 业务编码
       */
      businessCode?: string;
      /**
       * 子类型
       */
      subType?: string;
      /**
       * 必填, 工作流类型Key
       */
      processDefineKey?: string;
      /**
       * 必填, 工作流模型ID
       */
      processModelId?: number;
      /**
       * 必填, 工作流模型版本
       */
      version?: number;
      /**
       * 节点审批信息
       */
      auditInfos?: {
        /**
         * 节点Key
         */
        taskDefineKey?: string;
        /**
         * 节点名称
         */
        nodeName?: string;
        /**
         * 审批人的操作员ID
         */
        operatorIds?: number[];
        /**
         * 是否自选:0-指定，1-自选
         */
        nodeType?: number;
        /**
         * 事件类型：0-审批，1-审核，2-出纳
         */
        eventType?: number;
        /**
         * 审批类型：0-或签，1-会签，2-依次审批
         */
        auditType?: number;
        /**
         * 部门id （为了获取部门主管）
         */
        departmentId?: number;
        /**
         * 业务扩展数据
         */
        bizProperty?: string;
        /**
         * 节点审核状态
         */
        auditStatus?: number;
      }[];
      /**
       * 扩展条件，for百搭
       */
      extConditions?: {
        key?: {};
      };
      /**
       * 业务上下文
       */
      context?: string;
      /**
       * 当前操作入Id
       */
      operatorId?: number;
      /**
       * 备注
       */
      remark?: string;
    };
  };
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
    /**
     * 科目级联uk
     */
    subjectUkHierarchy?: string[];
    /**
     * 科目级联
     */
    subjectNameHierarchy?: string[];
  }[];
}

/**
 * 接口 [保存发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526666) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/save`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单号
     */
    code?: {
      /**
       * 唯一编号
       */
      formCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
    };
    /**
     * 支付摘要
     */
    summary?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526666) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/save`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimePayFormSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/pay-form/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526666) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/save`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimePayFormSavePostRequestConfig: ZlbApiExpenseOvertimePayFormSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/pay-form/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimePayFormSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526666) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/save`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimePayFormSavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimePayFormSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimePayFormSavePostResponse>(
    prepare(zlbApiExpenseOvertimePayFormSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimePayFormSavePost.requestConfig =
  zlbApiExpenseOvertimePayFormSavePostRequestConfig;

/**
 * 接口 [提交发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526674) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/submit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormSubmitPostRequest {
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 是否忽略弱控
   */
  isIgnoreWarning?: boolean;
  /**
   * 基本信息
   */
  basicInfo?: {
    /**
     * 操作人
     */
    operatorId?: number;
    /**
     * 操作人
     */
    operatorName?: string;
    /**
     * 部门ID
     */
    deptId?: number;
    /**
     * 部门名称
     */
    deptName?: string;
    /**
     * 事由
     */
    reason?: string;
    /**
     * 备注
     */
    remark?: string;
  };
  /**
   * 附件信息
   */
  attachmentList?: {
    /**
     * 附件业务子类型
     */
    subBizType?:
      | 1
      | 2
      | 3
      | 4
      | 5
      | 6
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 19
      | 20
      | 21
      | 22;
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 链接
     */
    url?: string;
    /**
     * oss桶的key
     */
    bucketKey?: string;
  }[];
  /**
   * 发放明细
   */
  receiverInfoList?: {
    /**
     * 收款记录Code
     */
    receiverCode?: string;
    /**
     * 收款金额
     */
    amount?: number;
    /**
     * 银行卡信息
     */
    bankCardInfo?: {
      /**
       * 账户code
       */
      accountCode?: string;
      /**
       * 收款人opId
       */
      operatorId?: number;
      /**
       * 收款户名
       */
      accountName: string;
      /**
       * 收款账户
       */
      accountNo: string;
      /**
       * 收款银行
       */
      bankName: string;
    };
    /**
     * 关联的夜餐费明细编号
     */
    nightMealFeeDetailCodeList?: string[];
  }[];
  /**
   * 支付信息
   */
  payInfo?: {
    /**
     * 支付方式(1：国库支付，3：非财政资金网银结算，4：库集中支付+非财政资金结算
     */
    payMode?: number;
    /**
     * 支付类型（0：授权支付申请，1：直接支付申请，2：授权个人公务卡报销，
     * 3：授权批量支付（个人）申请，4：授权批量支付（涉企）申请"）
     */
    payStrategy?: number;
    /**
     * 变更支付方式说明
     */
    changePayModeReason?: string;
    /**
     * 摘要
     */
    summary?: string;
    /**
     * 宁波收款明细PO
     */
    receiverPayInfoQueryList?: {
      /**
       * 收款卡基本信息
       */
      receiverPO?: {
        /**
         * 操作人ID
         */
        operatorId: number;
        /**
         * 账号code
         */
        accountCode?: string;
        /**
         * 收款金额
         */
        amount: number;
        /**
         * 原收款金额
         */
        originalAmount?: number;
        /**
         * 收款人姓名
         */
        receiverName: string;
        /**
         * 前端数组下标
         */
        indexNo: string;
        /**
         * 收款人Code
         */
        receiverCode?: string;
        /**
         * 调整原因
         */
        updateReason?: string;
        /**
         * 费用更新金额
         */
        modifyFeeAmountDTO?: {
          /**
           * 原始金额
           */
          originalAmount: number;
          /**
           * 修改后金额
           */
          updateAmount: number;
          /**
           * 修改备注
           */
          updateReason?: string;
          /**
           * 原始账户
           */
          originalAccount?: string;
          /**
           * 修改后账户
           */
          updateAccount?: string;
        };
        /**
         * 人员来源 1-系统内部；2-外部人员
         */
        userSource?: 1 | 2;
        userType?: number;
        /**
         * 用户类型
         */
        type?: number;
        /**
         * 类型
         */
        fundsObjectType?:
          | 1
          | 11
          | 12
          | 13
          | 14
          | 19
          | 2
          | 21
          | 22
          | 23
          | 24
          | 3
          | 31
          | 32
          | 4
          | 41
          | 42;
      };
      /**
       * 个人卡报销
       */
      personalCardExpenseQueryList?: {
        /**
         * 前端下标
         */
        indexNo: string;
        /**
         * 消费金额
         */
        amount?: number;
        /**
         * 拆分的金额
         */
        splitAmount?: number[];
        /**
         * 报销里的消费记录主键
         */
        consumptionRecordCode?: string;
        /**
         * 拆分金额
         */
        splitAmountDetail?: {
          /**
           * 拆分金额
           */
          amount: number;
          /**
           * 支付类型
           */
          payStrategy:
            | 'FINA_ZERO_PAY'
            | 'UNIT_ZERO_PAY'
            | 'UNIT_FUND_PAY'
            | 'FINA_SPLIT_PAY'
            | 'AUTH_NORMAL_PAY'
            | 'DIRECTLY_NORMAL_PAY'
            | 'AUTH_BUSINESS_CARD_PAY'
            | 'AUTH_PERSONAL_BATCH_PAY'
            | 'AUTH_ENTERPRISE_BATCH_PAY'
            | 'FINA_AND_FUND_PAY'
            | 'UNIT_FUND_NORMAL_PAY'
            | 'UNIT_FUND_OFF_CARD_PAY'
            | 'NB_FINA_ZERO_PAY'
            | 'NB_UNIT_ZERO_PAY'
            | 'NB_UNIT_FUND_PAY'
            | 'NB_FINA_SPLIT_PAY'
            | 'CBS_NORMAL_PAY'
            | 'CBS_BATCH_PAY';
          /**
           * 支付类型名称
           */
          payStrategyName?: string;
        }[];
      }[];
    }[];
  };
  /**
   * 预算信息
   */
  budgetInfo?: {
    /**
     * 主预算编号
     */
    mainBudgetCode: number;
    /**
     * 预算指标编号
     */
    budgetUk: string;
    /**
     * 预算支付限额分类
     */
    budgetPlanClassifyUk: string;
    /**
     * 预算金额
     */
    budgetAmount: number;
    /**
     * 交易信息 for 会议/培训多收款人
     */
    tradeCode?: string;
    /**
     * 支付记录信息code
     */
    payRecordCode?: string;
  }[];
  /**
   * 收款人，普通/授权支付时必传
   */
  transitionalReceiverInfo?: {
    /**
     * 收款银行卡code
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount?: number;
  };
  /**
   * 审批信息
   */
  workflowInfo?: {
    /**
     * 是否开启工作流 true-开启；false-未开启
     */
    enableWorkflow?: boolean;
    /**
     * 工作流信息
     */
    workflowSubmitPO?: {
      /**
       * 业务标识
       */
      bizId?: string;
      /**
       * 必填, 业务场景
       */
      bizType?: string;
      /**
       * 业务编码
       */
      businessCode?: string;
      /**
       * 子类型
       */
      subType?: string;
      /**
       * 必填, 工作流类型Key
       */
      processDefineKey?: string;
      /**
       * 必填, 工作流模型ID
       */
      processModelId?: number;
      /**
       * 必填, 工作流模型版本
       */
      version?: number;
      /**
       * 节点审批信息
       */
      auditInfos?: {
        /**
         * 节点Key
         */
        taskDefineKey?: string;
        /**
         * 节点名称
         */
        nodeName?: string;
        /**
         * 审批人的操作员ID
         */
        operatorIds?: number[];
        /**
         * 是否自选:0-指定，1-自选
         */
        nodeType?: number;
        /**
         * 事件类型：0-审批，1-审核，2-出纳
         */
        eventType?: number;
        /**
         * 审批类型：0-或签，1-会签，2-依次审批
         */
        auditType?: number;
        /**
         * 部门id （为了获取部门主管）
         */
        departmentId?: number;
        /**
         * 业务扩展数据
         */
        bizProperty?: string;
        /**
         * 节点审核状态
         */
        auditStatus?: number;
      }[];
      /**
       * 扩展条件，for百搭
       */
      extConditions?: {
        key?: {};
      };
      /**
       * 业务上下文
       */
      context?: string;
      /**
       * 当前操作入Id
       */
      operatorId?: number;
      /**
       * 备注
       */
      remark?: string;
    };
  };
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
    /**
     * 科目级联uk
     */
    subjectUkHierarchy?: string[];
    /**
     * 科目级联
     */
    subjectNameHierarchy?: string[];
  }[];
}

/**
 * 接口 [提交发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526674) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/submit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单据code
     */
    code?: {
      /**
       * 唯一编号
       */
      formCode?: string;
      /**
       * 业务单号
       */
      businessCode?: string;
    };
    /**
     * 校验状态 0：通过 1：警告 2：强控
     */
    checkStatus?: number;
    /**
     * 预算校验结果
     */
    budgetCheckResult?: {
      /**
       * 校验状态 0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 消息提示
       */
      msg?: string;
      /**
       * 预算指标ID
       */
      mainBudgetCode?: number;
      /**
       * 预算编号(展示)
       */
      financialBudgetDetailId?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 额度ID
       */
      budgetQuotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * TRUE使用指标，FALSE使用额度
       */
      budgetFlag?: boolean;
      /**
       * 占用总金额
       */
      budgetTotalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 支付限额经济分类主键
       */
      budgetPlanClassifyUk?: string;
      /**
       * 支付限额经济分类编码
       */
      budgetPlanClassifyCode?: string;
      /**
       * 支付限额经济分类名称
       */
      budgetPlanClassifyName?: string;
      /**
       * 支付限额经济分类可用金额
       */
      budgetPlanClassifyAvailableAmount?: number;
    }[];
    /**
     * 预算项目校验结果
     */
    budgetProjectCheckResultRO?: {
      /**
       * 预项目整体校验结果  0：通过 1：警告 2：强控
       */
      checkStatus?: number;
      /**
       * 报销单预算项目校验结果详情
       */
      checkResultInfoROS?: {
        /**
         * 预算填报记录编号
         */
        budgetProjectRecordUk?: string;
        /**
         * 项目校验状态 0：通过 1：警告 2：强控
         */
        projectCheckStatus?: number;
        /**
         * 科目校验状态 0：通过 1：警告 2：强控
         */
        subjectCheckStatus?: number;
        /**
         * 科目校验描述
         */
        subjectCheckDesc?: string;
        /**
         * 金额校验状态 0：通过 1：警告 2：强控
         */
        amountCheckStatus?: number;
        /**
         * 可用金额
         */
        availableAmount?: number;
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526674) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/submit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimePayFormSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/pay-form/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526674) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/submit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimePayFormSubmitPostRequestConfig: ZlbApiExpenseOvertimePayFormSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/pay-form/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimePayFormSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526674) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/submit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimePayFormSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimePayFormSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimePayFormSubmitPostResponse>(
    prepare(zlbApiExpenseOvertimePayFormSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimePayFormSubmitPost.requestConfig =
  zlbApiExpenseOvertimePayFormSubmitPostRequestConfig;

/**
 * 接口 [审核发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526682) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/audit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormAuditPostRequest {
  /**
   * 夜餐费发放单code
   */
  formCode?: string;
  /**
   * 工作流审核数据
   */
  workflowInfo?: {
    /**
     * 是否开启工作流 true-开启；false-未开启
     */
    enableWorkflow?: boolean;
    /**
     * 工作流信息
     */
    workflowAuditPO?: {
      /**
       * 业务单号
       */
      bizId?: string;
      /**
       * 业务场景
       */
      bizType?: string;
      /**
       * 业务子类型
       */
      subType?: string;
      /**
       * 审核意见
       */
      auditRemark?: string;
      /**
       * 审核状态：1-通过；2-驳回；
       */
      executeType: number;
      /**
       * 必填, 工作流类型Key
       */
      processDefineKey?: string;
      /**
       * 当前节点key
       */
      currentNodeKey: string;
      /**
       * 操作人
       */
      operatorId?: number;
      /**
       * 业务字段
       */
      context?: string;
      /**
       * 事件类型：0-审批，1-审核，2-出纳，3-抄送
       */
      eventType: number;
      /**
       * 驳回节点Key
       */
      rejectNodeKey?: string;
      /**
       * 签名附件
       */
      signAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 业务编号
         */
        bizNo?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
    };
  };
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 占用金额
     */
    amount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 操作人，后端使用
     */
    operatorId?: number;
    /**
     * 科目级联uk
     */
    subjectUkHierarchy?: string[];
    /**
     * 科目级联
     */
    subjectNameHierarchy?: string[];
  }[];
}

/**
 * 接口 [审核发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526682) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/audit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [审核发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526682) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/audit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimePayFormAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/pay-form/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审核发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526682) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/audit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimePayFormAuditPostRequestConfig: ZlbApiExpenseOvertimePayFormAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/pay-form/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimePayFormAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审核发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/526682) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/audit`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimePayFormAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimePayFormAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimePayFormAuditPostResponse>(
    prepare(zlbApiExpenseOvertimePayFormAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimePayFormAuditPost.requestConfig =
  zlbApiExpenseOvertimePayFormAuditPostRequestConfig;

/**
 * 接口 [夜餐费明细合并为发放明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528250) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/merge`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export type ZlbApiExpenseOvertimeNightMealFeeMergePostRequest = string[];

/**
 * 接口 [夜餐费明细合并为发放明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528250) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/merge`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeMergePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 收款记录Code
     */
    receiverCode?: string;
    /**
     * 收款金额
     */
    amount?: number;
    /**
     * 银行卡信息
     */
    bankCardInfo?: {
      /**
       * 银行卡唯一标识
       */
      accountCode?: string;
      /**
       * 银行代码
       */
      bankCode?: string;
      /**
       * 银行名称
       */
      bankName?: string;
      /**
       * 支行代码
       */
      subBankCode?: string;
      /**
       * 支行名称
       */
      subBankName?: string;
      /**
       * 账户名
       */
      accountName?: string;
      /**
       * 银行账号
       */
      accountNo?: string;
      /**
       * 账号类别
       * 个人卡、公务卡、对公卡
       */
      cardType?: number;
      /**
       * 所属人id
       */
      operatorId?: number;
      /**
       * 所属人员类别
       */
      userType?: number;
      /**
       * 所属人机构id
       */
      institutionId?: number;
    };
    /**
     * 支付状态
     */
    payStatus?: number;
    payStatusDesc?: string;
    /**
     * 关联的夜餐费明细编号
     */
    nightMealFeeDetailCodeList?: string[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [夜餐费明细合并为发放明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528250) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/merge`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeMergePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/merge',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [夜餐费明细合并为发放明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528250) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/merge`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeMergePostRequestConfig: ZlbApiExpenseOvertimeNightMealFeeMergePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/merge',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeMergePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [夜餐费明细合并为发放明细↗](http://yapi.cai-inc.com/project/3621/interface/api/528250) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/merge`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeMergePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeMergePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeMergePostResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeMergePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeMergePost.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeMergePostRequestConfig;

/**
 * 接口 [根据夜餐费明细codeList查询列表接口↗](http://yapi.cai-inc.com/project/3621/interface/api/528258) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list-by-code`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export type ZlbApiExpenseOvertimeNightMealFeeListByCodePostRequest = string[];

/**
 * 接口 [根据夜餐费明细codeList查询列表接口↗](http://yapi.cai-inc.com/project/3621/interface/api/528258) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list-by-code`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeListByCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 明细单号
     */
    formCode?: string;
    /**
     * 明细编号
     */
    businessCode?: string;
    /**
     * 加班人
     */
    overtimeOperatorName?: string;
    /**
     * 加班事由
     */
    reason?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 加班开始时间
     */
    startOvertimeDesc?: string;
    /**
     * 加班结束时间
     */
    endOvertimeDesc?: string;
    /**
     * 创建时间
     */
    createTime?: string;
    /**
     * 创建时间(已格式化)
     */
    createTimeDesc?: string;
    /**
     * 是否冲突
     */
    isConflict?: boolean;
    /**
     * 金额
     */
    amount?: number;
    /**
     * 发放状态 1-未提交、2-支付中、3-支付成功、4-支付失败
     */
    issuanceStatus?: number;
    issuanceStatusDesc?: string;
    /**
     * 发放单号
     */
    payFormCode?: string;
    /**
     * 操作按钮
     */
    operateButton?: {
      /**
       * 查询
       */
      detail?: boolean;
      /**
       * 编辑
       */
      edit?: boolean;
      /**
       * 删除
       */
      remove?: boolean;
      /**
       * 查看发放单
       */
      nightMealFeePayForm?: boolean;
    };
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据夜餐费明细codeList查询列表接口↗](http://yapi.cai-inc.com/project/3621/interface/api/528258) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list-by-code`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeListByCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/list-by-code',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据夜餐费明细codeList查询列表接口↗](http://yapi.cai-inc.com/project/3621/interface/api/528258) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list-by-code`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeListByCodePostRequestConfig: ZlbApiExpenseOvertimeNightMealFeeListByCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/list-by-code',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeListByCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据夜餐费明细codeList查询列表接口↗](http://yapi.cai-inc.com/project/3621/interface/api/528258) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list-by-code`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeListByCodePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeListByCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeListByCodePostResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeListByCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeListByCodePost.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeListByCodePostRequestConfig;

/**
 * 接口 [夜餐费费用变更↗](http://yapi.cai-inc.com/project/3621/interface/api/528994) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/fee/modify`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeFeeModifyPostRequest {
  /**
   * 单据编号
   */
  formCode?: string;
  /**
   * 修改参数
   */
  modifyInfo?: {
    /**
     * 修改备注
     */
    updateReason: string;
    /**
     * 原始金额
     */
    originAmount?: number;
    /**
     * 修改后金额
     */
    updateAmount?: number;
  };
}

/**
 * 接口 [夜餐费费用变更↗](http://yapi.cai-inc.com/project/3621/interface/api/528994) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/fee/modify`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeFeeModifyPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [夜餐费费用变更↗](http://yapi.cai-inc.com/project/3621/interface/api/528994) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/fee/modify`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeFeeModifyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/fee/modify',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [夜餐费费用变更↗](http://yapi.cai-inc.com/project/3621/interface/api/528994) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/fee/modify`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeFeeModifyPostRequestConfig: ZlbApiExpenseOvertimeNightMealFeeFeeModifyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/fee/modify',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeFeeModifyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [夜餐费费用变更↗](http://yapi.cai-inc.com/project/3621/interface/api/528994) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/fee/modify`
 * @更新时间 `2024-11-22 14:06:49`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeFeeModifyPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeFeeModifyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeFeeModifyPostResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeFeeModifyPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeFeeModifyPost.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeFeeModifyPostRequestConfig;

/**
 * 接口 [夜餐费明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/530010) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 加班人姓名
   */
  overtimeOperatorName?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 发放状态
   */
  issuanceStatus?: number;
  /**
   * 是否冲突
   */
  isConflict?: boolean;
  /**
   * 加班时间范围
   */
  overtimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
  /**
   * 创建时间
   */
  addTimeRange?: {
    /**
     * 起始时间
     */
    beginTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
  };
}

/**
 * 接口 [夜餐费明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/530010) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNightMealFeeListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 明细单号
       */
      formCode?: string;
      /**
       * 明细编号
       */
      businessCode?: string;
      /**
       * 加班人
       */
      overtimeOperatorName?: string;
      /**
       * 加班事由
       */
      reason?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 加班开始时间
       */
      startOvertimeDesc?: string;
      /**
       * 加班结束时间
       */
      endOvertimeDesc?: string;
      /**
       * 创建时间
       */
      createTime?: string;
      /**
       * 创建时间(已格式化)
       */
      createTimeDesc?: string;
      /**
       * 是否冲突
       */
      isConflict?: boolean;
      /**
       * 金额
       */
      amount?: number;
      /**
       * 发放状态 1-未提交、2-支付中、3-支付成功、4-支付失败
       */
      issuanceStatus?: number;
      issuanceStatusDesc?: string;
      /**
       * 发放单号
       */
      payFormCode?: string;
      /**
       * 操作按钮
       */
      operateButton?: {
        /**
         * 查询
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        remove?: boolean;
        /**
         * 查看发放单
         */
        nightMealFeePayForm?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [夜餐费明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/530010) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNightMealFeeListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/night-meal-fee/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [夜餐费明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/530010) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNightMealFeeListPostRequestConfig: ZlbApiExpenseOvertimeNightMealFeeListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/night-meal-fee/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNightMealFeeListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [夜餐费明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/530010) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/night-meal-fee/list`
 * @更新时间 `2024-11-22 14:06:48`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNightMealFeeListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNightMealFeeListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNightMealFeeListPostResponse>(
    prepare(zlbApiExpenseOvertimeNightMealFeeListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNightMealFeeListPost.requestConfig =
  zlbApiExpenseOvertimeNightMealFeeListPostRequestConfig;

/**
 * 接口 [删除发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/535386) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/delete`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormDeletePostRequest {
  /**
   * 明细单号
   */
  formCode?: string;
  /**
   * 明细单号
   */
  formCodeList?: string[];
}

/**
 * 接口 [删除发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/535386) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/delete`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimePayFormDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/535386) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/delete`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimePayFormDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/pay-form/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/535386) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/delete`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimePayFormDeletePostRequestConfig: ZlbApiExpenseOvertimePayFormDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/pay-form/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimePayFormDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除发放单↗](http://yapi.cai-inc.com/project/3621/interface/api/535386) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/pay-form/delete`
 * @更新时间 `2024-11-22 14:06:50`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimePayFormDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimePayFormDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimePayFormDeletePostResponse>(
    prepare(zlbApiExpenseOvertimePayFormDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimePayFormDeletePost.requestConfig =
  zlbApiExpenseOvertimePayFormDeletePostRequestConfig;

/**
 * 接口 [查询加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590330) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/info`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeInfoGetRequest {
  /**
   * 单据code
   */
  formCode: string;
  /**
   * 是否需要鉴权
   * true-鉴权；false-不鉴权
   */
  needAuth?: string;
  /**
   * 人员身份
   * default :DEFAULT
   * handler :HANDLER
   * auditor :AUDITOR
   * operation :OPERATION
   * special :仅有打印权限
   * readonly :READ_ONLY
   * finance :FINANCE
   * financeReplenish :FINANCE_REPLENISH
   * tenant :TENANT
   */
  identity?: string;
  /**
   * 是否需要脱敏
   * true-脱敏；false-不脱敏
   */
  desensitize?: string;
}

/**
 * 接口 [查询加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590330) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/info`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申请单号
     */
    formCode?: string;
    /**
     * 申请单编号
     */
    businessCode?: string;
    /**
     * 简报列表
     */
    briefReportList?: {
      /**
       * 简报状态
       */
      status?: 0 | 1 | 2 | 3;
      /**
       * 简报详情
       */
      detailList?: {
        /**
         * 简报标题
         */
        title?: string;
        /**
         * 简报原因
         */
        reason?: string;
        /**
         * 定位锚点
         * 1-行程
         */
        position?: 1 | 2 | 3;
      }[];
    }[];
    /**
     * 基本信息
     */
    basicInfo?: {
      /**
       * 单据状态
       */
      formStatus?: number;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 加班信息
       */
      overtimeInfoList?: {
        /**
         * 加班人id
         */
        operatorId?: number;
        /**
         * 加班人名字
         */
        operatorName?: string;
        /**
         * 加班开始时间
         */
        beginTime?: {
          /**
           * 开始时间
           */
          time?: string;
          /**
           * 开始上下午
           */
          tag?: '-1' | 0 | 1 | 2 | 3;
        };
        /**
         * 加班结束时间
         */
        endTime?: {
          /**
           * 开始时间
           */
          time?: string;
          /**
           * 开始上下午
           */
          tag?: '-1' | 0 | 1 | 2 | 3;
        };
        /**
         * 加班时长（小时）
         */
        overtimeHours?: string;
        /**
         * 计算规则
         */
        ruleList?: string[];
        /**
         * 核算方式
         */
        deductionType?: number;
        /**
         * 冲突校验结果
         */
        checkResult?: {
          /**
           * 提示状态
           */
          status?: 0 | 1 | 2 | 3;
          /**
           * 提示文案
           */
          msg?: string;
        };
      }[];
      /**
       * 加班事由
       */
      reason?: string;
      /**
       * 备注
       */
      remark?: string;
    };
    /**
     * 收款确认信息
     */
    bankCardList?: {
      /**
       * 收款人userId
       */
      userId?: number;
      /**
       * 收款人id
       */
      operatorId?: number;
      /**
       * 银行卡账户名
       */
      accountName?: string;
      /**
       * 银行卡账号
       */
      accountNo?: string;
      /**
       * 银行卡code
       */
      accountCode?: string;
      /**
       * 银行代码
       */
      bankCode?: string;
      /**
       * 银行名称
       */
      bankName?: string;
      /**
       * 账号类别
       */
      cardType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    }[];
    /**
     * 附件信息
     */
    attachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 附件业务类型
       */
      subBizType?:
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
        | 7
        | 8
        | 9
        | 10
        | 11
        | 12
        | 13
        | 14
        | 15
        | 16
        | 17
        | 18
        | 19
        | 20
        | 21
        | 22;
    }[];
    /**
     * 按钮信息
     */
    operateButton?: {
      /**
       * 编辑
       */
      edit?: boolean;
      /**
       * 删除
       */
      delete?: boolean;
      /**
       * 作废
       */
      discard?: boolean;
      /**
       * 去采购
       */
      purchase?: boolean;
      /**
       * 去报销
       */
      expense?: boolean;
      /**
       * 去预订
       */
      reserve?: boolean;
      /**
       * 去处理
       */
      handle?: boolean;
      /**
       * 重新发起
       */
      restart?: boolean;
      /**
       * 撤回
       */
      withdrawn?: boolean;
      /**
       * 加签
       */
      signature?: boolean;
      /**
       * 通过
       */
      pass?: boolean;
      /**
       * 驳回
       */
      reject?: boolean;
      /**
       * 打印
       */
      print?: boolean;
      /**
       * 驳回
       */
      rejectFinance?: boolean;
      /**
       * 重新支付
       */
      repayFinance?: boolean;
      /**
       * 复核订正账户
       */
      recheckCorrAcc?: boolean;
      /**
       * 评论
       */
      comment?: boolean;
    };
    /**
     * 工作流信息
     */
    workflowInfo?: {
      /**
       * 工作流的唯一key
       */
      workflowProcessKey?: string;
      /**
       * 工作流模型id
       */
      workflowModelId?: number;
      /**
       * 工作流版本
       */
      workflowVersion?: number;
      /**
       * 审核节点列表
       */
      auditNodeList?: {
        /**
         * 审核人列表
         */
        auditOperatorList?: {
          /**
           * 人员id
           */
          operatorId?: number;
          /**
           * 人员名称
           */
          operatorName?: string;
          /**
           * 机构id
           */
          institutionId?: number;
          /**
           * 机构名称
           */
          institutionName?: string;
          /**
           * 审批意见
           */
          auditRemark?: string;
          /**
           * 审批状态：0-待审批，1-审批通过，2-审批驳回
           */
          auditStatus?: number;
          /**
           * 审核时间
           */
          auditTime?: string;
          /**
           * 签名附件
           */
          signAttachment?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 业务编号
             */
            bizNo?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          };
          /**
           * 最新的个人历史签名附件
           */
          oneselfHistorySignAttachment?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 业务编号
             */
            bizNo?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          };
          /**
           * 加签方式：-1-未加签，0-后加签（作废，由于历史是0，后续统一为2），1-前加签，2-后加签
           */
          addAuditWay?: number;
          /**
           * 加签者
           */
          addAuditOperator?: string;
          /**
           * 工作流评论信息
           */
          comment?: {
            /**
             * 评论内容
             */
            commentContent?: string;
            /**
             * 评论人ID
             */
            operatorId?: number;
            /**
             * 评论人名字
             */
            operatorName?: string;
            /**
             * 评论唯一代码
             */
            commentCode?: string;
            /**
             * 评论时间
             */
            commentTime?: number;
            /**
             * 图片附件集合
             */
            pictureAttachments?: {
              /**
               * 附件OssId
               */
              fileId?: string;
              /**
               * 附件类型
               */
              type?: string;
              /**
               * 业务编号
               */
              bizNo?: string;
              /**
               * 附件名称
               */
              name?: string;
              /**
               * 附件大小
               */
              size?: number;
              /**
               * 桶的key
               */
              bizCode?: string;
              /**
               * 下载文件的url
               */
              url?: string;
              /**
               * 文件大小描述
               */
              sizeDesc?: string;
            }[];
            /**
             * 其他附件集合
             */
            otherAttachments?: {
              /**
               * 附件OssId
               */
              fileId?: string;
              /**
               * 附件类型
               */
              type?: string;
              /**
               * 业务编号
               */
              bizNo?: string;
              /**
               * 附件名称
               */
              name?: string;
              /**
               * 附件大小
               */
              size?: number;
              /**
               * 桶的key
               */
              bizCode?: string;
              /**
               * 下载文件的url
               */
              url?: string;
              /**
               * 文件大小描述
               */
              sizeDesc?: string;
            }[];
            /**
             * 是否可以删除该评论
             */
            remove?: boolean;
          };
          /**
           * 操作人类型
           */
          operatorType?: number;
        }[];
        /**
         * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
         */
        userRangeType?: number;
        userRangeTypeNew?: number;
        /**
         * 动态审核人类型
         */
        userRangeValues?: string[];
        userRangeValuesNew?: string[];
        /**
         * 审核人数(总人数)
         */
        personCount?: number;
        /**
         * 审核状态：0-待审批，1-已审批，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 审核描述
         */
        auditDesc?: string;
        /**
         * 审批类型：0-或签，1-会签，2-依次审批
         */
        auditType?: number;
        /**
         * 事件类型：0-审批，1-审核，2-出纳，3-抄送 98-提交人 99-评论
         */
        eventType?: number;
        /**
         * 是否自选:0-指定，1-自选
         */
        nodeType?: number;
        /**
         * 节点key
         */
        nodeKey?: string;
        /**
         * 节点名称
         */
        nodeName?: string;
        /**
         * 策略
         * cn.gov.zcy.workflow.enums.CheckStrategyEnum
         */
        checkStrategy?: number;
        /**
         * 部门id （为了获取部门主管）
         */
        departmentId?: number;
        /**
         * 机构
         */
        institutionSelfDtos?: {
          /**
           * 机构编码
           */
          code?: string;
          /**
           * 机构名称
           */
          name?: string;
          userType?: string;
          /**
           * 租户编码（区划编码）
           */
          tenantCode?: string;
          /**
           * 租户编码名称（区划名称）
           */
          tenantName?: string;
          uniqueKey?: string;
          parentInstitution?: {
            parentCode?: number;
            parentName?: string;
          };
        }[];
        /**
         * 常用审核人列表
         */
        commonAuditorList?: {
          displayName?: string;
          userId?: number;
          operatorId?: number;
          code?: string;
          gender?: number;
          institutionId?: number;
          institution?: {
            id?: number;
            createdAt?: number;
            updatedAt?: number;
            creatorId?: string;
            modifierId?: string;
            extFields?: string;
            name?: string;
            shortName?: string;
            orgCode?: string;
            creditCode?: string;
            bizAttaches?: string;
            tags?: string;
            provinceCode?: string;
            provinceName?: string;
            cityCode?: string;
            cityName?: string;
            regionCode?: string;
            regionName?: string;
            address?: string;
            status?: number;
            displayOrder?: number;
            outCreatedAt?: string;
            divisionCode?: string;
            fullName?: string;
            postalCode?: string;
            source?: number;
            organizationCode?: string;
            institutionLevel?: number;
          };
          deptName?: string;
        }[];
        /**
         * 业务属性json
         */
        bizProperty?: string;
        /**
         * 工作流评论信息
         */
        comment?: {
          /**
           * 评论内容
           */
          commentContent?: string;
          /**
           * 评论人ID
           */
          operatorId?: number;
          /**
           * 评论人名字
           */
          operatorName?: string;
          /**
           * 评论唯一代码
           */
          commentCode?: string;
          /**
           * 评论时间
           */
          commentTime?: number;
          /**
           * 图片附件集合
           */
          pictureAttachments?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 业务编号
             */
            bizNo?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          }[];
          /**
           * 其他附件集合
           */
          otherAttachments?: {
            /**
             * 附件OssId
             */
            fileId?: string;
            /**
             * 附件类型
             */
            type?: string;
            /**
             * 业务编号
             */
            bizNo?: string;
            /**
             * 附件名称
             */
            name?: string;
            /**
             * 附件大小
             */
            size?: number;
            /**
             * 桶的key
             */
            bizCode?: string;
            /**
             * 下载文件的url
             */
            url?: string;
            /**
             * 文件大小描述
             */
            sizeDesc?: string;
          }[];
          /**
           * 是否可以删除该评论
           */
          remove?: boolean;
        };
      }[];
      /**
       * 申请人操作人id
       */
      applyOperatorId?: number;
      /**
       * 申请人名称
       */
      applyOperatorName?: string;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 申请备注
       */
      applyRemark?: string;
      /**
       * 是否能加签 0-否 1-是
       */
      isAddTaskAccess?: number;
      /**
       * 工作流是否开启签名：true-开启；false-未开启
       */
      isEnableSign?: boolean;
      /**
       * 签名配置：0-使用上次签名；1-每次重新签名；
       */
      signConfig?: number;
      /**
       * 当前节点可驳回节点列表
       */
      availableRejectNodeList?: {
        /**
         * 节点名
         */
        nodeName?: string;
        /**
         * 节点uk
         */
        nodeKey?: string;
        /**
         * 节点操作人名字集合
         */
        operatorNames?: string[];
      }[];
      /**
       * 实例当前节点业务属性
       */
      currentBizProperty?: string;
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590330) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/info`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/info',
    'data',
    string,
    'formCode' | 'needAuth' | 'identity' | 'desensitize',
    false
  >
>;

/**
 * 接口 [查询加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590330) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/info`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeInfoGetRequestConfig: ZlbApiExpenseOvertimeInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: ['formCode', 'needAuth', 'identity', 'desensitize'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590330) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `GET /zlb/api/expense/overtime/info`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeInfoGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeInfoGetResponse>(
    prepare(zlbApiExpenseOvertimeInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeInfoGet.requestConfig = zlbApiExpenseOvertimeInfoGetRequestConfig;

/**
 * 接口 [删除加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590338) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/delete`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeDeletePostRequest {
  /**
   * 明细单号
   */
  formCode?: string;
  /**
   * 明细单号
   */
  formCodeList?: string[];
}

/**
 * 接口 [删除加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590338) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/delete`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590338) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/delete`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590338) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/delete`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeDeletePostRequestConfig: ZlbApiExpenseOvertimeDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590338) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/delete`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeDeletePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeDeletePostResponse>(
    prepare(zlbApiExpenseOvertimeDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeDeletePost.requestConfig = zlbApiExpenseOvertimeDeletePostRequestConfig;

/**
 * 接口 [保存加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590346) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/save`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeSavePostRequest {
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 是否忽略弱控
   */
  isIgnoreWarning?: boolean;
  /**
   * 时间冲突原因
   */
  conflictReason?: string;
  /**
   * 基本信息
   */
  basicInfo?: {
    /**
     * 加班信息
     */
    overtimeInfoList: {
      /**
       * 前端唯一值
       */
      indexNo: string;
      /**
       * 加班明细code
       */
      overtimeInfoCode?: string;
      /**
       * 加班人opId
       */
      operatorId: number;
      /**
       * 加班人名称
       */
      operatorName: string;
      /**
       * 加班开始时间
       */
      beginTime: {
        /**
         * 时间参数
         */
        time: string;
        /**
         * 上下午标签
         */
        tag?: '-1' | 0 | 1 | 2 | 3;
      };
      /**
       * 加班结束时间
       */
      endTime: {
        /**
         * 时间参数
         */
        time: string;
        /**
         * 上下午标签
         */
        tag?: '-1' | 0 | 1 | 2 | 3;
      };
      /**
       * 加班核算方式
       * -1-未开启核算，1-计为调休，2-计为夜餐费
       */
      deductionType: number;
    }[];
    /**
     * 部门ID
     */
    deptId: number;
    /**
     * 部门名称
     */
    deptName: string;
    /**
     * 加班事由
     */
    reason: string;
    /**
     * 备注
     */
    remark?: string;
  };
  /**
   * 收款信息
   */
  bankCardList?: {
    /**
     * 账户code
     */
    accountCode?: string;
    /**
     * 收款人opId
     */
    operatorId?: number;
    /**
     * 收款户名
     */
    accountName: string;
    /**
     * 收款账户
     */
    accountNo: string;
    /**
     * 收款银行
     */
    bankName: string;
  }[];
  /**
   * 附件信息
   */
  attachmentList?: {
    /**
     * 附件业务子类型
     */
    subBizType?:
      | 1
      | 2
      | 3
      | 4
      | 5
      | 6
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 19
      | 20
      | 21
      | 22;
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 链接
     */
    url?: string;
    /**
     * oss桶的key
     */
    bucketKey?: string;
  }[];
  /**
   * 工作流信息
   */
  workflowInfo?: {
    /**
     * 业务标识
     */
    bizId?: string;
    /**
     * 必填, 业务场景
     */
    bizType?: string;
    /**
     * 业务编码
     */
    businessCode?: string;
    /**
     * 子类型
     */
    subType?: string;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: string;
    /**
     * 必填, 工作流模型ID
     */
    processModelId?: number;
    /**
     * 必填, 工作流模型版本
     */
    version?: number;
    /**
     * 节点审批信息
     */
    auditInfos?: {
      /**
       * 节点Key
       */
      taskDefineKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 审批人的操作员ID
       */
      operatorIds?: number[];
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 业务扩展数据
       */
      bizProperty?: string;
      /**
       * 节点审核状态
       */
      auditStatus?: number;
    }[];
    /**
     * 扩展条件，for百搭
     */
    extConditions?: {
      key?: {};
    };
    /**
     * 业务上下文
     */
    context?: string;
    /**
     * 当前操作入Id
     */
    operatorId?: number;
    /**
     * 备注
     */
    remark?: string;
  };
}

/**
 * 接口 [保存加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590346) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/save`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590346) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/save`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590346) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/save`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeSavePostRequestConfig: ZlbApiExpenseOvertimeSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590346) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/save`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeSavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeSavePostResponse>(
    prepare(zlbApiExpenseOvertimeSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeSavePost.requestConfig = zlbApiExpenseOvertimeSavePostRequestConfig;

/**
 * 接口 [提交加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590354) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/submit`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeSubmitPostRequest {
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 是否忽略弱控
   */
  isIgnoreWarning?: boolean;
  /**
   * 时间冲突原因
   */
  conflictReason?: string;
  /**
   * 基本信息
   */
  basicInfo?: {
    /**
     * 加班信息
     */
    overtimeInfoList: {
      /**
       * 前端唯一值
       */
      indexNo: string;
      /**
       * 加班明细code
       */
      overtimeInfoCode?: string;
      /**
       * 加班人opId
       */
      operatorId: number;
      /**
       * 加班人名称
       */
      operatorName: string;
      /**
       * 加班开始时间
       */
      beginTime: {
        /**
         * 时间参数
         */
        time: string;
        /**
         * 上下午标签
         */
        tag?: '-1' | 0 | 1 | 2 | 3;
      };
      /**
       * 加班结束时间
       */
      endTime: {
        /**
         * 时间参数
         */
        time: string;
        /**
         * 上下午标签
         */
        tag?: '-1' | 0 | 1 | 2 | 3;
      };
      /**
       * 加班核算方式
       * -1-未开启核算，1-计为调休，2-计为夜餐费
       */
      deductionType: number;
    }[];
    /**
     * 部门ID
     */
    deptId: number;
    /**
     * 部门名称
     */
    deptName: string;
    /**
     * 加班事由
     */
    reason: string;
    /**
     * 备注
     */
    remark?: string;
  };
  /**
   * 收款信息
   */
  bankCardList?: {
    /**
     * 账户code
     */
    accountCode?: string;
    /**
     * 收款人opId
     */
    operatorId?: number;
    /**
     * 收款户名
     */
    accountName: string;
    /**
     * 收款账户
     */
    accountNo: string;
    /**
     * 收款银行
     */
    bankName: string;
  }[];
  /**
   * 附件信息
   */
  attachmentList?: {
    /**
     * 附件业务子类型
     */
    subBizType?:
      | 1
      | 2
      | 3
      | 4
      | 5
      | 6
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 19
      | 20
      | 21
      | 22;
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 链接
     */
    url?: string;
    /**
     * oss桶的key
     */
    bucketKey?: string;
  }[];
  /**
   * 工作流信息
   */
  workflowInfo?: {
    /**
     * 业务标识
     */
    bizId?: string;
    /**
     * 必填, 业务场景
     */
    bizType?: string;
    /**
     * 业务编码
     */
    businessCode?: string;
    /**
     * 子类型
     */
    subType?: string;
    /**
     * 必填, 工作流类型Key
     */
    processDefineKey?: string;
    /**
     * 必填, 工作流模型ID
     */
    processModelId?: number;
    /**
     * 必填, 工作流模型版本
     */
    version?: number;
    /**
     * 节点审批信息
     */
    auditInfos?: {
      /**
       * 节点Key
       */
      taskDefineKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 审批人的操作员ID
       */
      operatorIds?: number[];
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 业务扩展数据
       */
      bizProperty?: string;
      /**
       * 节点审核状态
       */
      auditStatus?: number;
    }[];
    /**
     * 扩展条件，for百搭
     */
    extConditions?: {
      key?: {};
    };
    /**
     * 业务上下文
     */
    context?: string;
    /**
     * 当前操作入Id
     */
    operatorId?: number;
    /**
     * 备注
     */
    remark?: string;
  };
}

/**
 * 接口 [提交加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590354) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/submit`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单号
     */
    formCode?: string;
    /**
     * 校验状态
     */
    checkStatus?: 0 | 1 | 2 | 3;
    /**
     * 时间冲突校验结果
     */
    timeCheckResult?: {
      /**
       * 提示状态
       */
      status?: 0 | 1 | 2 | 3;
      /**
       * 提示文案
       */
      msg?: string;
    };
    /**
     * 时间冲突校验信息列表
     */
    timeCheckInfoList?: {
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 校验状态
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 警告信息
       */
      warningInfo?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590354) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/submit`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590354) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/submit`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeSubmitPostRequestConfig: ZlbApiExpenseOvertimeSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590354) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/submit`
 * @更新时间 `2024-11-22 14:06:46`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeSubmitPostResponse>(
    prepare(zlbApiExpenseOvertimeSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeSubmitPost.requestConfig = zlbApiExpenseOvertimeSubmitPostRequestConfig;

/**
 * 接口 [审核加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590362) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/audit`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeAuditPostRequest {
  /**
   * 单据code
   */
  formCode?: string;
  /**
   * 工作流审核数据
   */
  workflowInfo?: {
    /**
     * 是否开启工作流 true-开启；false-未开启
     */
    enableWorkflow?: boolean;
    /**
     * 工作流信息
     */
    workflowAuditPO?: {
      /**
       * 业务单号
       */
      bizId?: string;
      /**
       * 业务场景
       */
      bizType?: string;
      /**
       * 业务子类型
       */
      subType?: string;
      /**
       * 审核意见
       */
      auditRemark?: string;
      /**
       * 审核状态：1-通过；2-驳回；
       */
      executeType: number;
      /**
       * 必填, 工作流类型Key
       */
      processDefineKey?: string;
      /**
       * 当前节点key
       */
      currentNodeKey: string;
      /**
       * 操作人
       */
      operatorId?: number;
      /**
       * 业务字段
       */
      context?: string;
      /**
       * 事件类型：0-审批，1-审核，2-出纳，3-抄送
       */
      eventType: number;
      /**
       * 驳回节点Key
       */
      rejectNodeKey?: string;
      /**
       * 签名附件
       */
      signAttachment?: {
        /**
         * 附件OssId
         */
        fileId?: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 业务编号
         */
        bizNo?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
    };
  };
}

/**
 * 接口 [审核加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590362) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/audit`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [审核加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590362) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/audit`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审核加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590362) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/audit`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeAuditPostRequestConfig: ZlbApiExpenseOvertimeAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审核加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590362) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/audit`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeAuditPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeAuditPostResponse>(
    prepare(zlbApiExpenseOvertimeAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeAuditPost.requestConfig = zlbApiExpenseOvertimeAuditPostRequestConfig;

/**
 * 接口 [作废加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590426) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/nullify/{code}`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNullifyCodePostRequest {
  /**
   * 加班单code
   */
  code: string;
}

/**
 * 接口 [作废加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590426) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/nullify/{code}`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeNullifyCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [作废加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590426) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/nullify/{code}`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeNullifyCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/nullify/{code}',
    'data',
    'code',
    string,
    false
  >
>;

/**
 * 接口 [作废加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590426) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/nullify/{code}`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeNullifyCodePostRequestConfig: ZlbApiExpenseOvertimeNullifyCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/nullify/{code}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: ['code'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeNullifyCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [作废加班单↗](http://yapi.cai-inc.com/project/3621/interface/api/590426) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/nullify/{code}`
 * @更新时间 `2024-11-22 14:06:47`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeNullifyCodePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeNullifyCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeNullifyCodePostResponse>(
    prepare(zlbApiExpenseOvertimeNullifyCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeNullifyCodePost.requestConfig =
  zlbApiExpenseOvertimeNullifyCodePostRequestConfig;

/**
 * 接口 [初始化加班申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/626610) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/init`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
export type ZlbApiExpenseOvertimeInitPostRequest = number[];

/**
 * 接口 [初始化加班申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/626610) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/init`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeInitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 加班人id
     */
    operatorId?: number;
    /**
     * 加班开始时间
     */
    beginTime?: {
      /**
       * 开始时间
       */
      time?: string;
      /**
       * 开始上下午
       */
      tag?: '-1' | 0 | 1 | 2 | 3;
    };
    /**
     * 加班结束时间
     */
    endTime?: {
      /**
       * 开始时间
       */
      time?: string;
      /**
       * 开始上下午
       */
      tag?: '-1' | 0 | 1 | 2 | 3;
    };
    /**
     * 加班时长（小时）
     */
    overtimeHours?: string;
    /**
     * 计算规则
     */
    ruleList?: string[];
    /**
     * 核算方式
     */
    deductionTypeList?: ('-1' | 1 | 2)[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [初始化加班申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/626610) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/init`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeInitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/init',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [初始化加班申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/626610) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/init`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeInitPostRequestConfig: ZlbApiExpenseOvertimeInitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/init',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeInitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [初始化加班申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/626610) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/init`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeInitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeInitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeInitPostResponse>(
    prepare(zlbApiExpenseOvertimeInitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeInitPost.requestConfig = zlbApiExpenseOvertimeInitPostRequestConfig;

/**
 * 接口 [加班申请单加班时长计算↗](http://yapi.cai-inc.com/project/3621/interface/api/626618) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/calculate-hours`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
export type ZlbApiExpenseOvertimeCalculateHoursPostRequest = {
  /**
   * 前端唯一值
   */
  indexNo: string;
  /**
   * 加班人opId
   */
  operatorId: number;
  /**
   * 加班开始时间
   */
  beginTime: {
    /**
     * 时间参数
     */
    time: string;
    /**
     * 上下午标签
     */
    tag?: '-1' | 0 | 1 | 2 | 3;
  };
  /**
   * 加班结束时间
   */
  endTime: {
    /**
     * 时间参数
     */
    time: string;
    /**
     * 上下午标签
     */
    tag?: '-1' | 0 | 1 | 2 | 3;
  };
}[];

/**
 * 接口 [加班申请单加班时长计算↗](http://yapi.cai-inc.com/project/3621/interface/api/626618) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/calculate-hours`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
export interface ZlbApiExpenseOvertimeCalculateHoursPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * indexNo
     */
    indexNo?: string;
    /**
     * 时长
     */
    hours?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [加班申请单加班时长计算↗](http://yapi.cai-inc.com/project/3621/interface/api/626618) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/calculate-hours`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
type ZlbApiExpenseOvertimeCalculateHoursPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/overtime/calculate-hours',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加班申请单加班时长计算↗](http://yapi.cai-inc.com/project/3621/interface/api/626618) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/calculate-hours`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
const zlbApiExpenseOvertimeCalculateHoursPostRequestConfig: ZlbApiExpenseOvertimeCalculateHoursPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: '/zlb/api/expense/overtime/calculate-hours',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseOvertimeCalculateHoursPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加班申请单加班时长计算↗](http://yapi.cai-inc.com/project/3621/interface/api/626618) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [加班服务↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53037)
 * @请求头 `POST /zlb/api/expense/overtime/calculate-hours`
 * @更新时间 `2024-11-22 14:06:45`
 * @项目ID 3621
 */
export const zlbApiExpenseOvertimeCalculateHoursPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseOvertimeCalculateHoursPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseOvertimeCalculateHoursPostResponse>(
    prepare(zlbApiExpenseOvertimeCalculateHoursPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseOvertimeCalculateHoursPost.requestConfig =
  zlbApiExpenseOvertimeCalculateHoursPostRequestConfig;

const mockUrl_0_1_0_20 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_20 = '' as any;
const prodUrl_0_1_0_20 = '' as any;
const dataKey_0_1_0_20 = 'data' as any;

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/546682) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/import/submit`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseReceptionImportSubmitPostRequest {
  /**
   * 文件id
   */
  fileId: string;
  /**
   * 任务类型
   * {@link cn.gov.zlb.finance.expense.domain.enums.ReceptionImportTypeEnum}
   */
  taskType: number;
}

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/546682) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/import/submit`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseReceptionImportSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/546682) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/import/submit`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
type ZlbApiExpenseReceptionImportSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/reception/import/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/546682) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/import/submit`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
const zlbApiExpenseReceptionImportSubmitPostRequestConfig: ZlbApiExpenseReceptionImportSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: '/zlb/api/expense/reception/import/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseReceptionImportSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/546682) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/import/submit`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
export const zlbApiExpenseReceptionImportSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseReceptionImportSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseReceptionImportSubmitPostResponse>(
    prepare(zlbApiExpenseReceptionImportSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseReceptionImportSubmitPost.requestConfig =
  zlbApiExpenseReceptionImportSubmitPostRequestConfig;

/**
 * 接口 [根据任务序列号查询任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/546690) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/result`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseReceptionImportResultGetRequest {
  /**
   * 任务序列号
   */
  serialCode: string;
}

/**
 * 接口 [根据任务序列号查询任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/546690) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/result`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseReceptionImportResultGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总条数
     */
    totalNum?: number;
    /**
     * 状态
     */
    status?: number;
    /**
     * 成功条数
     */
    successNum?: number;
    /**
     * 失败条数
     */
    failNum?: number;
    /**
     * 失败文件id
     */
    failFileId?: string;
    /**
     * 失败文件地址
     */
    failFileUrl?: string;
    /**
     * 是否全部成功
     */
    isSuccess?: boolean;
    /**
     * 导入的人员信息
     */
    personInfo?: {
      /**
       * 姓名
       */
      name?: string;
      /**
       * 职级类型 1-省部级、2-厅局级、99-其他
       */
      level?: number;
      /**
       * 职级名称
       */
      levelName?: string;
      /**
       * 来访人员职务
       */
      visitorDuty?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据任务序列号查询任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/546690) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/result`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
type ZlbApiExpenseReceptionImportResultGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/reception/import/result',
    'data',
    string,
    'serialCode',
    false
  >
>;

/**
 * 接口 [根据任务序列号查询任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/546690) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/result`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
const zlbApiExpenseReceptionImportResultGetRequestConfig: ZlbApiExpenseReceptionImportResultGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: '/zlb/api/expense/reception/import/result',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: ['serialCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseReceptionImportResultGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据任务序列号查询任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/546690) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/result`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
export const zlbApiExpenseReceptionImportResultGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseReceptionImportResultGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseReceptionImportResultGetResponse>(
    prepare(zlbApiExpenseReceptionImportResultGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseReceptionImportResultGet.requestConfig =
  zlbApiExpenseReceptionImportResultGetRequestConfig;

/**
 * 接口 [获取导入模板↗](http://yapi.cai-inc.com/project/3621/interface/api/546698) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/template`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseReceptionImportTemplateGetRequest {
  /**
   * 1来访信息模版 2接待信息模版
   */
  type: string;
}

/**
 * 接口 [获取导入模板↗](http://yapi.cai-inc.com/project/3621/interface/api/546698) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/template`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
export interface ZlbApiExpenseReceptionImportTemplateGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取导入模板↗](http://yapi.cai-inc.com/project/3621/interface/api/546698) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/template`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
type ZlbApiExpenseReceptionImportTemplateGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/reception/import/template',
    'data',
    string,
    'type',
    false
  >
>;

/**
 * 接口 [获取导入模板↗](http://yapi.cai-inc.com/project/3621/interface/api/546698) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/template`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
const zlbApiExpenseReceptionImportTemplateGetRequestConfig: ZlbApiExpenseReceptionImportTemplateGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: '/zlb/api/expense/reception/import/template',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: ['type'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseReceptionImportTemplateGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取导入模板↗](http://yapi.cai-inc.com/project/3621/interface/api/546698) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `GET /zlb/api/expense/reception/import/template`
 * @更新时间 `2024-06-04 16:04:38`
 * @项目ID 3621
 */
export const zlbApiExpenseReceptionImportTemplateGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseReceptionImportTemplateGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseReceptionImportTemplateGetResponse>(
    prepare(zlbApiExpenseReceptionImportTemplateGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseReceptionImportTemplateGet.requestConfig =
  zlbApiExpenseReceptionImportTemplateGetRequestConfig;

/**
 * 接口 [公务接待人员导出↗](http://yapi.cai-inc.com/project/3621/interface/api/549330) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/export`
 * @更新时间 `2024-06-04 16:04:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseReceptionExportPostRequest {
  /**
   * 人员类型 1-来访人员 2-接待人员
   */
  type: number;
  /**
   * 单号
   * "
   */
  formCode: string;
  /**
   * 单据类型
   */
  formType: number;
}

/**
 * 接口 [公务接待人员导出↗](http://yapi.cai-inc.com/project/3621/interface/api/549330) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/export`
 * @更新时间 `2024-06-04 16:04:39`
 * @项目ID 3621
 */
export interface ZlbApiExpenseReceptionExportPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [公务接待人员导出↗](http://yapi.cai-inc.com/project/3621/interface/api/549330) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/export`
 * @更新时间 `2024-06-04 16:04:39`
 * @项目ID 3621
 */
type ZlbApiExpenseReceptionExportPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/reception/export',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [公务接待人员导出↗](http://yapi.cai-inc.com/project/3621/interface/api/549330) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/export`
 * @更新时间 `2024-06-04 16:04:39`
 * @项目ID 3621
 */
const zlbApiExpenseReceptionExportPostRequestConfig: ZlbApiExpenseReceptionExportPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: '/zlb/api/expense/reception/export',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseReceptionExportPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [公务接待人员导出↗](http://yapi.cai-inc.com/project/3621/interface/api/549330) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [公务接待导入相关↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53425)
 * @请求头 `POST /zlb/api/expense/reception/export`
 * @更新时间 `2024-06-04 16:04:39`
 * @项目ID 3621
 */
export const zlbApiExpenseReceptionExportPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseReceptionExportPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseReceptionExportPostResponse>(
    prepare(zlbApiExpenseReceptionExportPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseReceptionExportPost.requestConfig = zlbApiExpenseReceptionExportPostRequestConfig;

const mockUrl_0_1_0_21 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_21 = '' as any;
const prodUrl_0_1_0_21 = '' as any;
const dataKey_0_1_0_21 = 'data' as any;

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/549194) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/submit`
 * @更新时间 `2024-02-26 09:44:52`
 * @项目ID 3621
 */
export interface ZlbApiExpenseImportsSubmitPostRequest {
  /**
   * 待导入的文件ossId
   */
  fileId: string;
  /**
   * 导入任务类型
   */
  taskType: 'ImportOverTime';
}

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/549194) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/submit`
 * @更新时间 `2024-02-26 09:44:52`
 * @项目ID 3621
 */
export interface ZlbApiExpenseImportsSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/549194) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/submit`
 * @更新时间 `2024-02-26 09:44:52`
 * @项目ID 3621
 */
type ZlbApiExpenseImportsSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/imports/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/549194) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/submit`
 * @更新时间 `2024-02-26 09:44:52`
 * @项目ID 3621
 */
const zlbApiExpenseImportsSubmitPostRequestConfig: ZlbApiExpenseImportsSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: '/zlb/api/expense/imports/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseImportsSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/549194) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/submit`
 * @更新时间 `2024-02-26 09:44:52`
 * @项目ID 3621
 */
export const zlbApiExpenseImportsSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseImportsSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseImportsSubmitPostResponse>(
    prepare(zlbApiExpenseImportsSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseImportsSubmitPost.requestConfig = zlbApiExpenseImportsSubmitPostRequestConfig;

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/549202) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/result`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export interface ZlbApiExpenseImportsResultPostRequest {
  /**
   * 任务编号
   */
  serialCode: string;
  /**
   * 任务类型
   */
  taskType?: string;
}

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/549202) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/result`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export interface ZlbApiExpenseImportsResultPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 导入总条数
     */
    totalNum?: number;
    /**
     * 成功条数
     */
    successNum?: number;
    /**
     * 失败条数
     */
    failNum?: number;
    /**
     * 重复次数
     */
    repeatNum?: number;
    /**
     * 失败的完整fileId
     */
    failFileId?: string;
    /**
     * 序列号
     */
    serialCode?: string;
    /**
     * 导入信息
     */
    message?: string;
    /**
     * 任务状态 0-失败 1-成功
     */
    status?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/549202) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/result`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
type ZlbApiExpenseImportsResultPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/imports/result',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/549202) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/result`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
const zlbApiExpenseImportsResultPostRequestConfig: ZlbApiExpenseImportsResultPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: '/zlb/api/expense/imports/result',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseImportsResultPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/549202) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/result`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export const zlbApiExpenseImportsResultPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseImportsResultPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseImportsResultPostResponse>(
    prepare(zlbApiExpenseImportsResultPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseImportsResultPost.requestConfig = zlbApiExpenseImportsResultPostRequestConfig;

/**
 * 接口 [加班单据确认导入↗](http://yapi.cai-inc.com/project/3621/interface/api/549338) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/over-time/confirm`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export interface ZlbApiExpenseImportsOverTimeConfirmPostRequest {
  /**
   * 任务编号
   */
  serialCode: string;
  /**
   * 任务类型
   */
  taskType?: string;
}

/**
 * 接口 [加班单据确认导入↗](http://yapi.cai-inc.com/project/3621/interface/api/549338) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/over-time/confirm`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export interface ZlbApiExpenseImportsOverTimeConfirmPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [加班单据确认导入↗](http://yapi.cai-inc.com/project/3621/interface/api/549338) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/over-time/confirm`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
type ZlbApiExpenseImportsOverTimeConfirmPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/imports/over-time/confirm',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加班单据确认导入↗](http://yapi.cai-inc.com/project/3621/interface/api/549338) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/over-time/confirm`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
const zlbApiExpenseImportsOverTimeConfirmPostRequestConfig: ZlbApiExpenseImportsOverTimeConfirmPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: '/zlb/api/expense/imports/over-time/confirm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseImportsOverTimeConfirmPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加班单据确认导入↗](http://yapi.cai-inc.com/project/3621/interface/api/549338) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [Excel 导入↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53464)
 * @请求头 `POST /zlb/api/expense/imports/over-time/confirm`
 * @更新时间 `2024-02-26 09:44:53`
 * @项目ID 3621
 */
export const zlbApiExpenseImportsOverTimeConfirmPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseImportsOverTimeConfirmPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseImportsOverTimeConfirmPostResponse>(
    prepare(zlbApiExpenseImportsOverTimeConfirmPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseImportsOverTimeConfirmPost.requestConfig =
  zlbApiExpenseImportsOverTimeConfirmPostRequestConfig;

const mockUrl_0_1_0_22 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_22 = '' as any;
const prodUrl_0_1_0_22 = '' as any;
const dataKey_0_1_0_22 = 'data' as any;

/**
 * 接口 [根据审批类型获取当前用户的常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551978) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `GET /zlb/api/expense/approval/comment/list`
 * @更新时间 `2023-10-18 17:32:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApprovalCommentListGetRequest {
  /**
   * 审批类型，1-通过，2-驳回
   */
  approvalType: string;
  /**
   * 是否需要查询系统内部审批意见 0-否，1-是
   */
  isNeedSystem?: string;
}

/**
 * 接口 [根据审批类型获取当前用户的常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551978) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `GET /zlb/api/expense/approval/comment/list`
 * @更新时间 `2023-10-18 17:32:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApprovalCommentListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 意见id
     */
    id?: number;
    /**
     * 审批意见
     */
    approvalUsualComment?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据审批类型获取当前用户的常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551978) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `GET /zlb/api/expense/approval/comment/list`
 * @更新时间 `2023-10-18 17:32:00`
 * @项目ID 3621
 */
type ZlbApiExpenseApprovalCommentListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/approval/comment/list',
    'data',
    string,
    'approvalType' | 'isNeedSystem',
    false
  >
>;

/**
 * 接口 [根据审批类型获取当前用户的常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551978) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `GET /zlb/api/expense/approval/comment/list`
 * @更新时间 `2023-10-18 17:32:00`
 * @项目ID 3621
 */
const zlbApiExpenseApprovalCommentListGetRequestConfig: ZlbApiExpenseApprovalCommentListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_22,
    devUrl: devUrl_0_1_0_22,
    prodUrl: prodUrl_0_1_0_22,
    path: '/zlb/api/expense/approval/comment/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_22,
    paramNames: [],
    queryNames: ['approvalType', 'isNeedSystem'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApprovalCommentListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据审批类型获取当前用户的常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551978) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `GET /zlb/api/expense/approval/comment/list`
 * @更新时间 `2023-10-18 17:32:00`
 * @项目ID 3621
 */
export const zlbApiExpenseApprovalCommentListGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApprovalCommentListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApprovalCommentListGetResponse>(
    prepare(zlbApiExpenseApprovalCommentListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApprovalCommentListGet.requestConfig =
  zlbApiExpenseApprovalCommentListGetRequestConfig;

/**
 * 接口 [保存常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551986) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `POST /zlb/api/expense/approval/comment/save`
 * @更新时间 `2023-10-18 17:32:01`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApprovalCommentSavePostRequest {
  /**
   * 审批意见
   */
  approvalUsualComments?: {
    /**
     * 意见id
     */
    id?: number;
    /**
     * 审批意见
     */
    approvalUsualComment?: string;
  }[];
  /**
   * 审批类型 1-通过，2-驳回
   */
  approvalType?: number;
}

/**
 * 接口 [保存常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551986) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `POST /zlb/api/expense/approval/comment/save`
 * @更新时间 `2023-10-18 17:32:01`
 * @项目ID 3621
 */
export interface ZlbApiExpenseApprovalCommentSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551986) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `POST /zlb/api/expense/approval/comment/save`
 * @更新时间 `2023-10-18 17:32:01`
 * @项目ID 3621
 */
type ZlbApiExpenseApprovalCommentSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/approval/comment/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551986) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `POST /zlb/api/expense/approval/comment/save`
 * @更新时间 `2023-10-18 17:32:01`
 * @项目ID 3621
 */
const zlbApiExpenseApprovalCommentSavePostRequestConfig: ZlbApiExpenseApprovalCommentSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_22,
    devUrl: devUrl_0_1_0_22,
    prodUrl: prodUrl_0_1_0_22,
    path: '/zlb/api/expense/approval/comment/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseApprovalCommentSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存常用审批意见↗](http://yapi.cai-inc.com/project/3621/interface/api/551986) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作流审批意见接口↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53513)
 * @请求头 `POST /zlb/api/expense/approval/comment/save`
 * @更新时间 `2023-10-18 17:32:01`
 * @项目ID 3621
 */
export const zlbApiExpenseApprovalCommentSavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseApprovalCommentSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseApprovalCommentSavePostResponse>(
    prepare(zlbApiExpenseApprovalCommentSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseApprovalCommentSavePost.requestConfig =
  zlbApiExpenseApprovalCommentSavePostRequestConfig;

const mockUrl_0_1_0_24 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_24 = '' as any;
const prodUrl_0_1_0_24 = '' as any;
const dataKey_0_1_0_24 = 'data' as any;

/**
 * 接口 [申报单确认↗](http://yapi.cai-inc.com/project/3621/interface/api/561954) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/confirm`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeclarationDetailConfirmPostRequest {
  /**
   * 批量发放唯一编码
   */
  batchDistributeCode: string;
  /**
   * 申报单明细编码集合
   */
  declarationCodeList: string[];
}

/**
 * 接口 [申报单确认↗](http://yapi.cai-inc.com/project/3621/interface/api/561954) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/confirm`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeclarationDetailConfirmPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单确认↗](http://yapi.cai-inc.com/project/3621/interface/api/561954) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/confirm`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeDeclarationDetailConfirmPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/declaration-detail/confirm',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单确认↗](http://yapi.cai-inc.com/project/3621/interface/api/561954) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/confirm`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeDeclarationDetailConfirmPostRequestConfig: ZlbApiExpenseBatchDistributeDeclarationDetailConfirmPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: '/zlb/api/expense/batch-distribute/declaration-detail/confirm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeDeclarationDetailConfirmPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报单确认↗](http://yapi.cai-inc.com/project/3621/interface/api/561954) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/confirm`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeDeclarationDetailConfirmPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeDeclarationDetailConfirmPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeDeclarationDetailConfirmPostResponse>(
    prepare(zlbApiExpenseBatchDistributeDeclarationDetailConfirmPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeDeclarationDetailConfirmPost.requestConfig =
  zlbApiExpenseBatchDistributeDeclarationDetailConfirmPostRequestConfig;

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/563026) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/select`
 * @更新时间 `2023-11-08 11:46:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeclarationDetailSelectPostRequest {
  /**
   * 批量发放唯一编码
   */
  batchDistributeCode: string;
  /**
   * 政策唯一编码
   */
  policyCode?: string;
  /**
   * 申报单位编码
   */
  orgCreditCode?: string;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/563026) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/select`
 * @更新时间 `2023-11-08 11:46:18`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeclarationDetailSelectPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 申报明细code
       */
      declarationCode?: string;
      /**
       * 政策名称
       */
      policyName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 收款账户类型
       */
      accountTypeDesc?: string;
      /**
       * 收款账户类型 1：对私 2：对公
       */
      receiverAccountType?: number;
      /**
       * 收款人户名
       */
      receiverAccountName?: string;
      /**
       * 收款人身份证号
       */
      receiverIdCard?: string;
      /**
       * 申报单位统一社会代码
       */
      declarationCreditCode?: string;
      /**
       * 收款账户
       */
      receiverAccountNo?: string;
      /**
       * 收款银行名称
       */
      receiverBankName?: string;
      /**
       * 申报金额
       */
      declarationAmount?: number;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 兑付时间
       */
      paySuccessTime?: string;
      /**
       * 申报明细状态
       */
      declarationStatus?: number;
      /**
       * 申报明细状态描述
       */
      declarationStatusDesc?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/563026) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/select`
 * @更新时间 `2023-11-08 11:46:18`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeDeclarationDetailSelectPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/declaration-detail/select',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/563026) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/select`
 * @更新时间 `2023-11-08 11:46:18`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeDeclarationDetailSelectPostRequestConfig: ZlbApiExpenseBatchDistributeDeclarationDetailSelectPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: '/zlb/api/expense/batch-distribute/declaration-detail/select',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeDeclarationDetailSelectPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/563026) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/select`
 * @更新时间 `2023-11-08 11:46:18`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeDeclarationDetailSelectPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeDeclarationDetailSelectPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeDeclarationDetailSelectPostResponse>(
    prepare(zlbApiExpenseBatchDistributeDeclarationDetailSelectPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeDeclarationDetailSelectPost.requestConfig =
  zlbApiExpenseBatchDistributeDeclarationDetailSelectPostRequestConfig;

/**
 * 接口 [查询申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/563034) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/query`
 * @更新时间 `2023-11-08 11:46:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeclarationDetailQueryPostRequest {
  /**
   * 批量发放唯一编码
   */
  batchDistributeCode: string;
  /**
   * 政策唯一编码
   */
  policyCode?: string;
  /**
   * 申报单位唯一编码
   */
  orgCreditCode?: string;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/563034) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/query`
 * @更新时间 `2023-11-08 11:46:26`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeclarationDetailQueryPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 申报明细code
       */
      declarationCode?: string;
      /**
       * 政策名称
       */
      policyName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 收款账户类型
       */
      accountTypeDesc?: string;
      /**
       * 收款账户类型 1：对私 2：对公
       */
      receiverAccountType?: number;
      /**
       * 收款人户名
       */
      receiverAccountName?: string;
      /**
       * 收款人身份证号
       */
      receiverIdCard?: string;
      /**
       * 申报单位统一社会代码
       */
      declarationCreditCode?: string;
      /**
       * 收款账户
       */
      receiverAccountNo?: string;
      /**
       * 收款银行名称
       */
      receiverBankName?: string;
      /**
       * 申报金额
       */
      declarationAmount?: number;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 兑付时间
       */
      paySuccessTime?: string;
      /**
       * 申报明细状态
       */
      declarationStatus?: number;
      /**
       * 申报明细状态描述
       */
      declarationStatusDesc?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/563034) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/query`
 * @更新时间 `2023-11-08 11:46:26`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeDeclarationDetailQueryPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/declaration-detail/query',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/563034) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/query`
 * @更新时间 `2023-11-08 11:46:26`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeDeclarationDetailQueryPostRequestConfig: ZlbApiExpenseBatchDistributeDeclarationDetailQueryPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: '/zlb/api/expense/batch-distribute/declaration-detail/query',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeDeclarationDetailQueryPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/563034) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/query`
 * @更新时间 `2023-11-08 11:46:26`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeDeclarationDetailQueryPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeDeclarationDetailQueryPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeDeclarationDetailQueryPostResponse>(
    prepare(zlbApiExpenseBatchDistributeDeclarationDetailQueryPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeDeclarationDetailQueryPost.requestConfig =
  zlbApiExpenseBatchDistributeDeclarationDetailQueryPostRequestConfig;

/**
 * 接口 [兑付单退款核销↗](http://yapi.cai-inc.com/project/3621/interface/api/716690) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/refund-check`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPostRequest {
  /**
   * 批量发放唯一编码
   */
  batchDistributeCode: string;
  /**
   * 需要退款的申报单code列表
   */
  declarationCodeList: string[];
  /**
   * 需要退款的支付变更记录列表
   */
  payChangeCodeList: string[];
  /**
   * 退款核销原因(预留)
   */
  refundReason?: string;
}

/**
 * 接口 [兑付单退款核销↗](http://yapi.cai-inc.com/project/3621/interface/api/716690) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/refund-check`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [兑付单退款核销↗](http://yapi.cai-inc.com/project/3621/interface/api/716690) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/refund-check`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
type ZlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/batch-distribute/declaration-detail/refund-check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [兑付单退款核销↗](http://yapi.cai-inc.com/project/3621/interface/api/716690) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/refund-check`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
const zlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPostRequestConfig: ZlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: '/zlb/api/expense/batch-distribute/declaration-detail/refund-check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [兑付单退款核销↗](http://yapi.cai-inc.com/project/3621/interface/api/716690) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [批量发放申报明细↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53711)
 * @请求头 `POST /zlb/api/expense/batch-distribute/declaration-detail/refund-check`
 * @更新时间 `2024-10-16 19:32:44`
 * @项目ID 3621
 */
export const zlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPostResponse>(
    prepare(zlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPost.requestConfig =
  zlbApiExpenseBatchDistributeDeclarationDetailRefundCheckPostRequestConfig;

const mockUrl_0_1_0_25 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_25 = '' as any;
const prodUrl_0_1_0_25 = '' as any;
const dataKey_0_1_0_25 = 'data' as any;

/**
 * 接口 [申报明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/558354) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/paging`
 * @更新时间 `2024-10-16 19:55:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationPagingGetRequest {
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 申报编号
   */
  declarationBizCode?: string;
  /**
   * 申报明细code
   */
  declarationCode?: string;
  /**
   * 申报单位统一社会信用代码
   * 「已废弃」
   */
  orgCreditCode?: string;
  /**
   * 申报单位名称
   * 2024年07月04日添加: 由于申报单批量导入可能未填政策编号、统一社会信用代码，查询接口进行修改
   */
  declarationOrgName?: string;
  /**
   * 政策分类代码
   * 「已废弃」
   */
  policyCode?: string;
  /**
   * 政策名称
   * 2024年07月04日添加: 由于申报单批量导入可能未填政策编号、统一社会信用代码，查询接口进行修改
   */
  policyName?: string;
  /**
   * 起始时间
   */
  beginTime?: string;
  /**
   * 截止时间
   */
  endTime?: string;
  /**
   * 状态：0-"待兑付"，1-"兑付中"，2-"已兑付"，3-"已作废" 4-兑付失败(仅能精确传入, 实际查询待兑付+支付失败数据)
   */
  'declarationStatusList[0]'?: string;
  /**
   * 账户类型
   * 1.对公 2.对私
   */
  receiverAccountType?: string;
  /**
   * 身份证是否需要脱敏
   */
  idCardDesensitization?: string;
  /**
   * 银行卡号是否需要脱敏
   */
  accountNoDesensitization?: string;
  /**
   * 是否重推 0 否 1 是
   */
  isRepush?: string;
  /**
   * 转交的状态, 后端内部使用
   * {@link  cn.gov.zlb.declaration.enums.TransferStatusEnum#code}
   */
  transferStatus?: string;
}

/**
 * 接口 [申报明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/558354) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/paging`
 * @更新时间 `2024-10-16 19:55:16`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationPagingGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 申报明细code
       */
      declarationCode?: string;
      /**
       * 政策名称
       */
      policyName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 收款账户类型
       */
      accountTypeDesc?: string;
      /**
       * 收款人户名
       */
      receiverAccountName?: string;
      /**
       * 收款人身份证号
       */
      receiverIdCard?: string;
      /**
       * 收款账户
       */
      receiverAccountNo?: string;
      /**
       * 收款账户类型 1：对私 2：对公
       */
      receiverAccountType?: number;
      /**
       * 收款银行名称
       */
      receiverBankName?: string;
      /**
       * 申报金额
       */
      declarationAmount?: number;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 兑付时间
       */
      paySuccessTime?: string;
      /**
       * 申报明细状态
       */
      declarationStatus?: number;
      /**
       * 申报明细状态描述
       */
      declarationStatusDesc?: string;
      /**
       * 申报单位名称
       */
      declarationOrgName?: string;
      /**
       * 申报单位统一社会信用代码
       */
      declarationOrgCreditCode?: string;
      /**
       * 申报编号
       */
      declarationBizCode?: string;
      /**
       * *
       * 支行名字
       */
      subBankName?: string;
      /**
       * 是否重推 0否 1是
       */
      isRepush?: number;
      /**
       * 原单申报明细code
       */
      originalDeclarationCode?: string;
      /**
       * 新单申报明细code
       */
      newDeclarationCode?: string;
      /**
       * 关联发放单
       */
      batchDistributeCode?: string;
      /**
       * 作废原因
       */
      reason?: string;
      /**
       * 支付状态 0:未支付 1:支付成功 2:支付失败{@link cn.gov.zlb.declaration.enums.DeclarationPayStatusEnum}
       */
      payStatus?: number;
      /**
       * 转交状态  0-无  1-转交 2-退回
       * {@link  cn.gov.zlb.declaration.enums.TransferStatusEnum#getCode()}
       */
      transferStatus?: number;
      /**
       * 资金申拨标识 0否 1是
       */
      fundApplyDisburseFlag?: number;
      /**
       * 退回原因
       */
      sendBackReason?: string;
      /**
       * 操作按钮
       */
      declarationButton?: {
        /**
         * 作废
         */
        canInvaild?: boolean;
        /**
         * 查看原单
         */
        canOriginalDeclaration?: boolean;
        /**
         * 查看新单
         */
        canNewDeclaration?: boolean;
        /**
         * 查看发放单
         */
        canDistributeForm?: boolean;
        /**
         * 是否可以转交
         */
        canTransfer?: boolean;
        /**
         * 是否可以退回
         */
        canSendBack?: boolean;
        /**
         * 是否可以资金申拨
         */
        canFundApplyDisburse?: boolean;
      };
      /**
       * 标签列表(展示展示如二次发放, 移交, 退回等标签)
       */
      labelList?: {
        /**
         * 展示名称
         */
        displayName?: string;
        /**
         * 能否hover
         */
        canHover?: boolean;
        /**
         * hover展示的文本
         */
        hoverContent?: string;
        /**
         * 如果需要标签有不同的级别对应颜色, 则进行配置{@link cn.gov.zlb.declaration.enums.LabelLevelEnum#code}
         */
        level?: string;
        /**
         * 类型, 预留{@link cn.gov.zlb.declaration.enums.LabelTypeEnum#code}
         */
        type?: string;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
    /**
     * 最后一次更新
     */
    lastSyncTime?: string;
    /**
     * 身份证是否需要脱敏
     */
    idCardDesensitization?: boolean;
    /**
     * 银行卡号是否需要脱敏
     */
    accountNoDesensitization?: boolean;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/558354) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/paging`
 * @更新时间 `2024-10-16 19:55:16`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationPagingGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/paging',
    'data',
    string,
    | 'pageSize'
    | 'pageNo'
    | 'declarationBizCode'
    | 'declarationCode'
    | 'orgCreditCode'
    | 'declarationOrgName'
    | 'policyCode'
    | 'policyName'
    | 'beginTime'
    | 'endTime'
    | 'declarationStatusList[0]'
    | 'receiverAccountType'
    | 'idCardDesensitization'
    | 'accountNoDesensitization'
    | 'isRepush'
    | 'transferStatus',
    false
  >
>;

/**
 * 接口 [申报明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/558354) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/paging`
 * @更新时间 `2024-10-16 19:55:16`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationPagingGetRequestConfig: ZlbApiExpenseDeclarationPagingGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/paging',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [
      'pageSize',
      'pageNo',
      'declarationBizCode',
      'declarationCode',
      'orgCreditCode',
      'declarationOrgName',
      'policyCode',
      'policyName',
      'beginTime',
      'endTime',
      'declarationStatusList[0]',
      'receiverAccountType',
      'idCardDesensitization',
      'accountNoDesensitization',
      'isRepush',
      'transferStatus',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationPagingGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报明细列表↗](http://yapi.cai-inc.com/project/3621/interface/api/558354) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/paging`
 * @更新时间 `2024-10-16 19:55:16`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationPagingGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationPagingGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationPagingGetResponse>(
    prepare(zlbApiExpenseDeclarationPagingGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationPagingGet.requestConfig = zlbApiExpenseDeclarationPagingGetRequestConfig;

/**
 * 接口 [获取业务类型分类↗](http://yapi.cai-inc.com/project/3621/interface/api/558362) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/get-biz-category`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationGetBizCategoryGetRequest {
  /**
   * 关键字
   */
  keyword?: string;
  /**
   * 业务类型
   * 1 :POLICY_CATEGORY
   * 2 :ORG_CATEGORY
   */
  bizType: string;
}

/**
 * 接口 [获取业务类型分类↗](http://yapi.cai-inc.com/project/3621/interface/api/558362) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/get-biz-category`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationGetBizCategoryGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 业务分类代码
     */
    categoryCode?: string;
    /**
     * 业务分类名字
     */
    categoryName?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取业务类型分类↗](http://yapi.cai-inc.com/project/3621/interface/api/558362) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/get-biz-category`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationGetBizCategoryGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/get-biz-category',
    'data',
    string,
    'keyword' | 'bizType',
    false
  >
>;

/**
 * 接口 [获取业务类型分类↗](http://yapi.cai-inc.com/project/3621/interface/api/558362) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/get-biz-category`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationGetBizCategoryGetRequestConfig: ZlbApiExpenseDeclarationGetBizCategoryGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/get-biz-category',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: ['keyword', 'bizType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationGetBizCategoryGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取业务类型分类↗](http://yapi.cai-inc.com/project/3621/interface/api/558362) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/get-biz-category`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationGetBizCategoryGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationGetBizCategoryGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationGetBizCategoryGetResponse>(
    prepare(zlbApiExpenseDeclarationGetBizCategoryGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationGetBizCategoryGet.requestConfig =
  zlbApiExpenseDeclarationGetBizCategoryGetRequestConfig;

/**
 * 接口 [手动同步申报数据↗](http://yapi.cai-inc.com/project/3621/interface/api/558370) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/manual-sync-data`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationManualSyncDataPostRequest {}

/**
 * 接口 [手动同步申报数据↗](http://yapi.cai-inc.com/project/3621/interface/api/558370) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/manual-sync-data`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationManualSyncDataPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [手动同步申报数据↗](http://yapi.cai-inc.com/project/3621/interface/api/558370) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/manual-sync-data`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationManualSyncDataPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/manual-sync-data',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [手动同步申报数据↗](http://yapi.cai-inc.com/project/3621/interface/api/558370) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/manual-sync-data`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationManualSyncDataPostRequestConfig: ZlbApiExpenseDeclarationManualSyncDataPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/manual-sync-data',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationManualSyncDataPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [手动同步申报数据↗](http://yapi.cai-inc.com/project/3621/interface/api/558370) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/manual-sync-data`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationManualSyncDataPost = /*#__PURE__*/ (
  requestData?: ZlbApiExpenseDeclarationManualSyncDataPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationManualSyncDataPostResponse>(
    prepare(zlbApiExpenseDeclarationManualSyncDataPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationManualSyncDataPost.requestConfig =
  zlbApiExpenseDeclarationManualSyncDataPostRequestConfig;

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/632042) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-invalid`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationDetailInvalidPostRequest {
  /**
   * 申报单编码
   */
  declarationCodeList: string[];
  /**
   * 作废原因
   */
  reason?: string;
}

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/632042) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-invalid`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationDetailInvalidPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/632042) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-invalid`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationDetailInvalidPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/detail-invalid',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/632042) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-invalid`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationDetailInvalidPostRequestConfig: ZlbApiExpenseDeclarationDetailInvalidPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/detail-invalid',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationDetailInvalidPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报单作废↗](http://yapi.cai-inc.com/project/3621/interface/api/632042) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-invalid`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationDetailInvalidPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationDetailInvalidPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationDetailInvalidPostResponse>(
    prepare(zlbApiExpenseDeclarationDetailInvalidPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationDetailInvalidPost.requestConfig =
  zlbApiExpenseDeclarationDetailInvalidPostRequestConfig;

/**
 * 接口 [提交批量发放申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/671522) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/submit`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationSubmitPostRequest {
  /**
   * 导入任务单号(用于查询任务关联的申报明细, 更新机构id等方式进行后置关联)
   */
  importSerialCode: string;
}

/**
 * 接口 [提交批量发放申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/671522) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/submit`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交批量发放申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/671522) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/submit`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交批量发放申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/671522) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/submit`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationSubmitPostRequestConfig: ZlbApiExpenseDeclarationSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交批量发放申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/671522) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/submit`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationSubmitPostResponse>(
    prepare(zlbApiExpenseDeclarationSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationSubmitPost.requestConfig = zlbApiExpenseDeclarationSubmitPostRequestConfig;

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/678898) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/select`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationSelectPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 批量发放唯一编码
   */
  batchDistributeCode: string;
  /**
   * 账户类型(1.对公 2.对私)
   */
  declarationAccountType?: number;
  /**
   * 政策唯一编码名称
   */
  policyName?: string;
  /**
   * 申报单位名称
   */
  declarationOrgName?: string;
  /**
   * 是否重推 0 否 1 是
   */
  isRepush?: number;
  /**
   * 查询类型 1未关联的申请单 2已关联的申请单
   * 默认查询已关联
   */
  queryType?: number;
  /**
   * 针对退款核销时, 仅查询已兑付申报单增加
   * 状态：0-"待兑付"，1-"兑付中"，2-"已兑付"，3-"已作废" 4-兑付失败(仅能精确传入, 实际查询待兑付+支付失败数据)
   */
  declarationStatusList?: number[];
  /**
   * 收款人姓名(精确查找)
   */
  receiverName?: string;
  /**
   * 收款银行账号(精确查找)
   */
  receiverBankCard?: string;
}

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/678898) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/select`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationSelectPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 申报明细code
       */
      declarationCode?: string;
      /**
       * 政策名称
       */
      policyName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 收款账户类型
       */
      accountTypeDesc?: string;
      /**
       * 收款账户类型 1：对私 2：对公
       */
      receiverAccountType?: number;
      /**
       * 收款人户名
       */
      receiverAccountName?: string;
      /**
       * 收款人身份证号
       */
      receiverIdCard?: string;
      /**
       * 申报单位统一社会代码
       */
      declarationOrgCreditCode?: string;
      /**
       * 收款账户
       */
      receiverAccountNo?: string;
      /**
       * 收款银行名称
       */
      receiverBankName?: string;
      /**
       * 分行名称
       */
      subBankName?: string;
      /**
       * 申报金额
       */
      declarationAmount?: number;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 兑付时间
       */
      paySuccessTime?: string;
      /**
       * 申报明细状态
       */
      declarationStatus?: number;
      /**
       * 支付状态 0:未支付 1:支付成功 2:支付失败{@link cn.gov.zlb.declaration.enums.DeclarationPayStatusEnum}
       */
      payStatus?: number;
      /**
       * 申报明细状态描述
       */
      declarationStatusDesc?: string;
      /**
       * 申报编号
       */
      declarationBizCode?: string;
      /**
       * 是否重推 0 否 1 是
       */
      isRepush?: number;
      /**
       * 资金申拨标识 0否 1是
       */
      fundApplyDisburseFlag?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/678898) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/select`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationSelectPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/select',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/678898) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/select`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationSelectPostRequestConfig: ZlbApiExpenseDeclarationSelectPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/select',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationSelectPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [选择申报单↗](http://yapi.cai-inc.com/project/3621/interface/api/678898) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/select`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationSelectPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationSelectPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationSelectPostResponse>(
    prepare(zlbApiExpenseDeclarationSelectPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationSelectPost.requestConfig = zlbApiExpenseDeclarationSelectPostRequestConfig;

/**
 * 接口 [分页查询转交信息↗](http://yapi.cai-inc.com/project/3621/interface/api/683842) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/transfer-paging`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationTransferPagingGetRequest {
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 申报编号
   */
  declarationBizCode?: string;
  /**
   * 申报明细code
   */
  declarationCode?: string;
  /**
   * 申报单位统一社会信用代码
   * 「已废弃」
   */
  orgCreditCode?: string;
  /**
   * 申报单位名称
   * 2024年07月04日添加: 由于申报单批量导入可能未填政策编号、统一社会信用代码，查询接口进行修改
   */
  declarationOrgName?: string;
  /**
   * 政策分类代码
   * 「已废弃」
   */
  policyCode?: string;
  /**
   * 政策名称
   * 2024年07月04日添加: 由于申报单批量导入可能未填政策编号、统一社会信用代码，查询接口进行修改
   */
  policyName?: string;
  /**
   * 起始时间
   */
  beginTime?: string;
  /**
   * 截止时间
   */
  endTime?: string;
  /**
   * 状态：0-"待兑付"，1-"兑付中"，2-"已兑付"，3-"已作废" 4-兑付失败(仅能精确传入, 实际查询待兑付+支付失败数据)
   */
  'declarationStatusList[0]'?: string;
  /**
   * 账户类型
   * 1.对公 2.对私
   */
  receiverAccountType?: string;
  /**
   * 身份证是否需要脱敏
   */
  idCardDesensitization?: string;
  /**
   * 银行卡号是否需要脱敏
   */
  accountNoDesensitization?: string;
  /**
   * 是否重推 0 否 1 是
   */
  isRepush?: string;
  /**
   * 转交的状态, 后端内部使用
   * {@link  cn.gov.zlb.declaration.enums.TransferStatusEnum#code}
   */
  transferStatus?: string;
}

/**
 * 接口 [分页查询转交信息↗](http://yapi.cai-inc.com/project/3621/interface/api/683842) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/transfer-paging`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationTransferPagingGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 申报明细code
       */
      declarationCode?: string;
      /**
       * 政策名称
       */
      policyName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 收款账户类型
       */
      accountTypeDesc?: string;
      /**
       * 收款人户名
       */
      receiverAccountName?: string;
      /**
       * 收款人身份证号
       */
      receiverIdCard?: string;
      /**
       * 收款账户
       */
      receiverAccountNo?: string;
      /**
       * 收款账户类型 1：对私 2：对公
       */
      receiverAccountType?: number;
      /**
       * 收款银行名称
       */
      receiverBankName?: string;
      /**
       * 申报金额
       */
      declarationAmount?: number;
      /**
       * 申请时间
       */
      applyTime?: string;
      /**
       * 兑付时间
       */
      paySuccessTime?: string;
      /**
       * 申报明细状态
       */
      declarationStatus?: number;
      /**
       * 申报明细状态描述
       */
      declarationStatusDesc?: string;
      /**
       * 申报单位名称
       */
      declarationOrgName?: string;
      /**
       * 申报单位统一社会信用代码
       */
      declarationOrgCreditCode?: string;
      /**
       * 申报编号
       */
      declarationBizCode?: string;
      /**
       * *
       * 支行名字
       */
      subBankName?: string;
      /**
       * 是否重推 0否 1是
       */
      isRepush?: number;
      /**
       * 原单申报明细code
       */
      originalDeclarationCode?: string;
      /**
       * 新单申报明细code
       */
      newDeclarationCode?: string;
      /**
       * 关联发放单
       */
      batchDistributeCode?: string;
      /**
       * 作废原因
       */
      reason?: string;
      /**
       * 支付状态 0:未支付 1:支付成功 2:支付失败{@link cn.gov.zlb.declaration.enums.DeclarationPayStatusEnum}
       */
      payStatus?: number;
      /**
       * 转交状态  0-无  1-转交 2-退回
       * {@link  cn.gov.zlb.declaration.enums.TransferStatusEnum#getCode()}
       */
      transferStatus?: number;
      /**
       * 资金申拨标识 0否 1是
       */
      fundApplyDisburseFlag?: number;
      /**
       * 退回原因
       */
      sendBackReason?: string;
      /**
       * 操作按钮
       */
      declarationButton?: {
        /**
         * 作废
         */
        canInvaild?: boolean;
        /**
         * 查看原单
         */
        canOriginalDeclaration?: boolean;
        /**
         * 查看新单
         */
        canNewDeclaration?: boolean;
        /**
         * 查看发放单
         */
        canDistributeForm?: boolean;
        /**
         * 是否可以转交
         */
        canTransfer?: boolean;
        /**
         * 是否可以退回
         */
        canSendBack?: boolean;
        /**
         * 是否可以资金申拨
         */
        canFundApplyDisburse?: boolean;
      };
      /**
       * 标签列表(展示展示如二次发放, 移交, 退回等标签)
       */
      labelList?: {
        /**
         * 展示名称
         */
        displayName?: string;
        /**
         * 能否hover
         */
        canHover?: boolean;
        /**
         * hover展示的文本
         */
        hoverContent?: string;
        /**
         * 如果需要标签有不同的级别对应颜色, 则进行配置{@link cn.gov.zlb.declaration.enums.LabelLevelEnum#code}
         */
        level?: string;
        /**
         * 类型, 预留{@link cn.gov.zlb.declaration.enums.LabelTypeEnum#code}
         */
        type?: string;
      }[];
      /**
       * 操作人（系统时为-1）
       */
      operatorId?: number;
      /**
       * 操作人名称
       */
      operatorName?: string;
      /**
       * 目标机构id
       */
      toOrgId?: number;
      /**
       * 目标机构名称
       */
      toOrgName?: string;
      /**
       * 转交时间
       */
      transferTime?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
    /**
     * 最后一次更新
     */
    lastSyncTime?: string;
    /**
     * 身份证是否需要脱敏
     */
    idCardDesensitization?: boolean;
    /**
     * 银行卡号是否需要脱敏
     */
    accountNoDesensitization?: boolean;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [分页查询转交信息↗](http://yapi.cai-inc.com/project/3621/interface/api/683842) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/transfer-paging`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationTransferPagingGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/transfer-paging',
    'data',
    string,
    | 'pageSize'
    | 'pageNo'
    | 'declarationBizCode'
    | 'declarationCode'
    | 'orgCreditCode'
    | 'declarationOrgName'
    | 'policyCode'
    | 'policyName'
    | 'beginTime'
    | 'endTime'
    | 'declarationStatusList[0]'
    | 'receiverAccountType'
    | 'idCardDesensitization'
    | 'accountNoDesensitization'
    | 'isRepush'
    | 'transferStatus',
    false
  >
>;

/**
 * 接口 [分页查询转交信息↗](http://yapi.cai-inc.com/project/3621/interface/api/683842) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/transfer-paging`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationTransferPagingGetRequestConfig: ZlbApiExpenseDeclarationTransferPagingGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/transfer-paging',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [
      'pageSize',
      'pageNo',
      'declarationBizCode',
      'declarationCode',
      'orgCreditCode',
      'declarationOrgName',
      'policyCode',
      'policyName',
      'beginTime',
      'endTime',
      'declarationStatusList[0]',
      'receiverAccountType',
      'idCardDesensitization',
      'accountNoDesensitization',
      'isRepush',
      'transferStatus',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationTransferPagingGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [分页查询转交信息↗](http://yapi.cai-inc.com/project/3621/interface/api/683842) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/transfer-paging`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationTransferPagingGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationTransferPagingGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationTransferPagingGetResponse>(
    prepare(zlbApiExpenseDeclarationTransferPagingGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationTransferPagingGet.requestConfig =
  zlbApiExpenseDeclarationTransferPagingGetRequestConfig;

/**
 * 接口 [搜索可转交的单位↗](http://yapi.cai-inc.com/project/3621/interface/api/683850) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/search-can-transfer-org`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationSearchCanTransferOrgGetRequest {
  /**
   * 统一社会信用代码(精确查询)
   * 废弃（合同到orgName中, 使用同一个字段进行判断）
   */
  creditCode?: string;
  /**
   * 机构名称或统一社会信用代码, 模糊查询
   */
  orgName?: string;
}

/**
 * 接口 [搜索可转交的单位↗](http://yapi.cai-inc.com/project/3621/interface/api/683850) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/search-can-transfer-org`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationSearchCanTransferOrgGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 机构id
     */
    orgId?: number;
    /**
     * 机构名称
     */
    orgName?: string;
    /**
     * 社会统一信用代码
     */
    creditCode?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [搜索可转交的单位↗](http://yapi.cai-inc.com/project/3621/interface/api/683850) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/search-can-transfer-org`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationSearchCanTransferOrgGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/search-can-transfer-org',
    'data',
    string,
    'creditCode' | 'orgName',
    false
  >
>;

/**
 * 接口 [搜索可转交的单位↗](http://yapi.cai-inc.com/project/3621/interface/api/683850) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/search-can-transfer-org`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationSearchCanTransferOrgGetRequestConfig: ZlbApiExpenseDeclarationSearchCanTransferOrgGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/search-can-transfer-org',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: ['creditCode', 'orgName'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationSearchCanTransferOrgGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [搜索可转交的单位↗](http://yapi.cai-inc.com/project/3621/interface/api/683850) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `GET /zlb/api/expense/declaration/search-can-transfer-org`
 * @更新时间 `2024-10-16 19:48:04`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationSearchCanTransferOrgGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationSearchCanTransferOrgGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationSearchCanTransferOrgGetResponse>(
    prepare(zlbApiExpenseDeclarationSearchCanTransferOrgGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationSearchCanTransferOrgGet.requestConfig =
  zlbApiExpenseDeclarationSearchCanTransferOrgGetRequestConfig;

/**
 * 接口 [转交↗](http://yapi.cai-inc.com/project/3621/interface/api/683858) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-transfer`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationDetailTransferPostRequest {
  /**
   * 申报单编码(为了批量预留结构)
   */
  declarationCodeList: string[];
  /**
   * 转交的目的机构
   */
  toOrgId: number;
}

/**
 * 接口 [转交↗](http://yapi.cai-inc.com/project/3621/interface/api/683858) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-transfer`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationDetailTransferPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 结果, 区分 0-失败, 1-全部成功, 2-部分成功
     * {@link cn.gov.zlb.declaration.enums.OperateWithNumResultEnum#code}
     */
    result?: number;
    /**
     * 成功数量
     */
    successCount?: number;
    /**
     * 失败数量
     */
    failCount?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [转交↗](http://yapi.cai-inc.com/project/3621/interface/api/683858) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-transfer`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationDetailTransferPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/detail-transfer',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [转交↗](http://yapi.cai-inc.com/project/3621/interface/api/683858) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-transfer`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationDetailTransferPostRequestConfig: ZlbApiExpenseDeclarationDetailTransferPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/detail-transfer',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationDetailTransferPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [转交↗](http://yapi.cai-inc.com/project/3621/interface/api/683858) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-transfer`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationDetailTransferPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationDetailTransferPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationDetailTransferPostResponse>(
    prepare(zlbApiExpenseDeclarationDetailTransferPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationDetailTransferPost.requestConfig =
  zlbApiExpenseDeclarationDetailTransferPostRequestConfig;

/**
 * 接口 [退回↗](http://yapi.cai-inc.com/project/3621/interface/api/683866) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-send-back`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationDetailSendBackPostRequest {
  /**
   * 申报单编码(为了批量预留结构)
   */
  declarationCodeList: string[];
  reason: string;
}

/**
 * 接口 [退回↗](http://yapi.cai-inc.com/project/3621/interface/api/683866) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-send-back`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationDetailSendBackPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 结果, 区分 0-失败, 1-全部成功, 2-部分成功
     * {@link cn.gov.zlb.declaration.enums.OperateWithNumResultEnum#code}
     */
    result?: number;
    /**
     * 成功数量
     */
    successCount?: number;
    /**
     * 失败数量
     */
    failCount?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [退回↗](http://yapi.cai-inc.com/project/3621/interface/api/683866) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-send-back`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationDetailSendBackPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/detail-send-back',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [退回↗](http://yapi.cai-inc.com/project/3621/interface/api/683866) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-send-back`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationDetailSendBackPostRequestConfig: ZlbApiExpenseDeclarationDetailSendBackPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/detail-send-back',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationDetailSendBackPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [退回↗](http://yapi.cai-inc.com/project/3621/interface/api/683866) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-send-back`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationDetailSendBackPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationDetailSendBackPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationDetailSendBackPostResponse>(
    prepare(zlbApiExpenseDeclarationDetailSendBackPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationDetailSendBackPost.requestConfig =
  zlbApiExpenseDeclarationDetailSendBackPostRequestConfig;

/**
 * 接口 [资金申拨↗](http://yapi.cai-inc.com/project/3621/interface/api/683874) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-fund-apply-disburse`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationDetailFundApplyDisbursePostRequest {
  /**
   * 申报单编码(为了批量预留结构)
   */
  declarationCodeList: string[];
}

/**
 * 接口 [资金申拨↗](http://yapi.cai-inc.com/project/3621/interface/api/683874) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-fund-apply-disburse`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationDetailFundApplyDisbursePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 结果, 区分 0-失败, 1-全部成功, 2-部分成功
     * {@link cn.gov.zlb.declaration.enums.OperateWithNumResultEnum#code}
     */
    result?: number;
    /**
     * 成功数量
     */
    successCount?: number;
    /**
     * 失败数量
     */
    failCount?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [资金申拨↗](http://yapi.cai-inc.com/project/3621/interface/api/683874) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-fund-apply-disburse`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationDetailFundApplyDisbursePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/detail-fund-apply-disburse',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [资金申拨↗](http://yapi.cai-inc.com/project/3621/interface/api/683874) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-fund-apply-disburse`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationDetailFundApplyDisbursePostRequestConfig: ZlbApiExpenseDeclarationDetailFundApplyDisbursePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: '/zlb/api/expense/declaration/detail-fund-apply-disburse',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationDetailFundApplyDisbursePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [资金申拨↗](http://yapi.cai-inc.com/project/3621/interface/api/683874) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationDetailController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_53741)
 * @请求头 `POST /zlb/api/expense/declaration/detail-fund-apply-disburse`
 * @更新时间 `2024-10-16 19:48:05`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationDetailFundApplyDisbursePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationDetailFundApplyDisbursePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationDetailFundApplyDisbursePostResponse>(
    prepare(zlbApiExpenseDeclarationDetailFundApplyDisbursePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationDetailFundApplyDisbursePost.requestConfig =
  zlbApiExpenseDeclarationDetailFundApplyDisbursePostRequestConfig;

const mockUrl_0_1_0_26 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_26 = '' as any;
const prodUrl_0_1_0_26 = '' as any;
const dataKey_0_1_0_26 = 'data' as any;

/**
 * 接口 [保存工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579010) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/save`
 * @更新时间 `2024-05-20 20:01:34`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanSavePostRequest {
  /**
   * 工作计划code
   */
  workPlanCode?: string;
  /**
   * 类型
   */
  businessType:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 29
    | 30;
  /**
   * 工作部门id`
   */
  deptId: number;
  /**
   * 工作部门名称
   */
  deptName: string;
  /**
   * 申请事由
   */
  reason: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 行程信息
   */
  itineraryInfo?: {
    /**
     * 基本行程信息
     */
    basicItinerary?: {
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 行程信息编号
       */
      itineraryCode?: string;
      /**
       * 出差人列表
       */
      accompanyList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag?: number;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag?: number;
      /**
       * 出发地code
       */
      beginCityCode: string;
      /**
       * 出发地名称
       */
      beginCityName: string;
      /**
       * 结束地点
       */
      endCityCode: string;
      /**
       * 结束地点名称
       */
      endCityName: string;
      /**
       * 目的地列表
       */
      endCityList?: {
        /**
         * 目的城市code
         */
        endCityCode: string;
        /**
         * 目的城市名称
         */
        endCityName: string;
      }[];
      /**
       * 是否往返
       */
      travelBack: boolean;
      /**
       * 交通工具
       */
      trafficType?: 10 | 20 | 30 | 40 | 50 | 60 | 99;
    };
    /**
     * 行程额外信息
     */
    itineraryExtendInfo?: {
      /**
       * 是否往返
       */
      travelBack: boolean;
      /**
       * 交通工具
       */
      trafficType?: 10 | 20 | 30 | 40 | 50 | 60 | 99;
      /**
       * 交通工具描述
       */
      trafficTypeDesc?: string;
      /**
       * 预计金额
       */
      amount?: number;
    };
  };
  /**
   * 附件信息
   */
  attachmentList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 是否跳过弱控
   */
  isIgnoreWarning?: boolean;
}

/**
 * 接口 [保存工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579010) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/save`
 * @更新时间 `2024-05-20 20:01:34`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579010) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/save`
 * @更新时间 `2024-05-20 20:01:34`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkPlanSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/work-plan/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579010) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/save`
 * @更新时间 `2024-05-20 20:01:34`
 * @项目ID 3621
 */
const zlbApiExpenseWorkPlanSavePostRequestConfig: ZlbApiExpenseWorkPlanSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: '/zlb/api/expense/work-plan/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkPlanSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579010) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/save`
 * @更新时间 `2024-05-20 20:01:34`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkPlanSavePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkPlanSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkPlanSavePostResponse>(
    prepare(zlbApiExpenseWorkPlanSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkPlanSavePost.requestConfig = zlbApiExpenseWorkPlanSavePostRequestConfig;

/**
 * 接口 [提交工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579018) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/submit`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanSubmitPostRequest {
  /**
   * 工作计划code
   */
  workPlanCode?: string;
  /**
   * 类型
   */
  businessType:
    | 1
    | 2
    | 19
    | 20
    | 28
    | 4
    | 5
    | 6
    | 27
    | 31
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 29
    | 30;
  /**
   * 工作部门id`
   */
  deptId: number;
  /**
   * 工作部门名称
   */
  deptName: string;
  /**
   * 申请事由
   */
  reason: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 行程信息
   */
  itineraryInfo?: {
    /**
     * 基本行程信息
     */
    basicItinerary?: {
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 行程信息编号
       */
      itineraryCode?: string;
      /**
       * 出差人列表
       */
      accompanyList: {
        /**
         * 用户ID
         */
        userId?: number;
        /**
         * 操作员ID
         */
        operatorId: number;
        /**
         * 姓名
         */
        userName: string;
        /**
         * 外部人员职级
         * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
         */
        outerUserRank?: number;
        /**
         * 人员类型
         * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
         */
        userType?: number;
        /**
         * 类型
         * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
         */
        type?: number;
        /**
         * 是否隐藏人员类型显示
         */
        hideOperatorShowType?: boolean;
      }[];
      /**
       * 开始时间
       */
      beginTime: string;
      /**
       * 开始上下午
       * 上午-1，下午-2
       */
      beginTag?: number;
      /**
       * 结束时间
       */
      endTime: string;
      /**
       * 结束上下午
       * 上午-1，下午-2
       */
      endTag?: number;
      /**
       * 出发地code
       */
      beginCityCode: string;
      /**
       * 出发地名称
       */
      beginCityName: string;
      /**
       * 结束地点
       */
      endCityCode: string;
      /**
       * 结束地点名称
       */
      endCityName: string;
      /**
       * 目的地列表
       */
      endCityList?: {
        /**
         * 目的城市code
         */
        endCityCode: string;
        /**
         * 目的城市名称
         */
        endCityName: string;
      }[];
      /**
       * 是否往返
       */
      travelBack: boolean;
      /**
       * 交通工具
       */
      trafficType?: 10 | 20 | 30 | 40 | 50 | 60 | 99;
    };
    /**
     * 行程额外信息
     */
    itineraryExtendInfo?: {
      /**
       * 是否往返
       */
      travelBack: boolean;
      /**
       * 交通工具
       */
      trafficType?: 10 | 20 | 30 | 40 | 50 | 60 | 99;
      /**
       * 交通工具描述
       */
      trafficTypeDesc?: string;
      /**
       * 预计金额
       */
      amount?: number;
    };
  };
  /**
   * 附件信息
   */
  attachmentList?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
  }[];
  /**
   * 是否跳过弱控
   */
  isIgnoreWarning?: boolean;
}

/**
 * 接口 [提交工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579018) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/submit`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 校验结果
     */
    checkStatus?: number;
    /**
     * 校验失败信息列表
     * isSuccess为false时必填
     */
    checkInfoList?: {
      /**
       * 前端生成的编号
       */
      indexNo?: string;
      /**
       * 校验状态,目前默认为弱控
       * 0-通过 1-弱控 2-强控 3-提示
       */
      checkStatus?: 0 | 1 | 2 | 3;
      /**
       * 警告信息
       */
      warningInfo?: string[];
      /**
       * 唯一值
       */
      uniqueCode?: string[];
      /**
       * 是否参与校验
       * true-校验，false-不校验
       */
      isCheck?: boolean;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579018) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/submit`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkPlanSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/work-plan/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579018) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/submit`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
const zlbApiExpenseWorkPlanSubmitPostRequestConfig: ZlbApiExpenseWorkPlanSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: '/zlb/api/expense/work-plan/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkPlanSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579018) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/submit`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkPlanSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkPlanSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkPlanSubmitPostResponse>(
    prepare(zlbApiExpenseWorkPlanSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkPlanSubmitPost.requestConfig = zlbApiExpenseWorkPlanSubmitPostRequestConfig;

/**
 * 接口 [工作计划详情↗](http://yapi.cai-inc.com/project/3621/interface/api/579026) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `GET /zlb/api/expense/work-plan/info/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanInfoWorkPlanCodeGetRequest {
  workPlanCode: string;
}

/**
 * 接口 [工作计划详情↗](http://yapi.cai-inc.com/project/3621/interface/api/579026) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `GET /zlb/api/expense/work-plan/info/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanInfoWorkPlanCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 工作计划code
     */
    workPlanCode?: string;
    /**
     * 工作计划编号
     */
    businessCode?: string;
    /**
     * 工作计划单据类型
     */
    workPlanFormType?: number;
    /**
     * 工作计划类型
     */
    businessType?:
      | 1
      | 2
      | 19
      | 20
      | 28
      | 4
      | 5
      | 6
      | 27
      | 31
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 21
      | 22
      | 23
      | 24
      | 25
      | 26
      | 29
      | 30;
    businessTypeDesc?: string;
    /**
     * 经办人
     */
    operatorId?: number;
    /**
     * 经办人名称
     */
    operatorName?: string;
    /**
     * 机构id
     */
    deptId?: number;
    /**
     * 机构名称
     */
    deptName?: string;
    /**
     * 缘由
     */
    reason?: string;
    /**
     * 标题
     */
    title?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 状态
     */
    formStatus?: number;
    /**
     * 状态描述
     */
    formStatusDesc?: string;
    /**
     * 行程信息
     */
    itineraryInfo?: {
      /**
       * 基本行程信息
       */
      basicItinerary?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 行程信息编号
         */
        itineraryCode?: string;
        /**
         * 出差人列表
         */
        accompanyList: {
          /**
           * 用户ID
           */
          userId?: number;
          /**
           * 操作员ID
           */
          operatorId: number;
          /**
           * 姓名
           */
          userName: string;
          /**
           * 外部人员职级
           * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
           */
          outerUserRank?: number;
          /**
           * 人员类型
           * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
           */
          userType?: number;
          /**
           * 类型
           * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
           */
          type?: number;
          /**
           * 是否隐藏人员类型显示
           */
          hideOperatorShowType?: boolean;
        }[];
        /**
         * 开始时间
         */
        beginTime: string;
        /**
         * 开始上下午
         * 上午-1，下午-2
         */
        beginTag?: number;
        /**
         * 结束时间
         */
        endTime: string;
        /**
         * 结束上下午
         * 上午-1，下午-2
         */
        endTag?: number;
        /**
         * 出发地code
         */
        beginCityCode: string;
        /**
         * 出发地名称
         */
        beginCityName: string;
        /**
         * 结束地点
         */
        endCityCode: string;
        /**
         * 结束地点名称
         */
        endCityName: string;
        /**
         * 目的地列表
         */
        endCityList?: {
          /**
           * 目的城市code
           */
          endCityCode: string;
          /**
           * 目的城市名称
           */
          endCityName: string;
        }[];
        /**
         * 是否往返
         */
        travelBack: boolean;
        /**
         * 交通工具
         */
        trafficType?: 10 | 20 | 30 | 40 | 50 | 60 | 99;
      };
      /**
       * 行程额外信息
       */
      itineraryExtendInfo?: {
        /**
         * 是否往返
         */
        travelBack: boolean;
        /**
         * 交通工具
         */
        trafficType?: 10 | 20 | 30 | 40 | 50 | 60 | 99;
        /**
         * 交通工具描述
         */
        trafficTypeDesc?: string;
        /**
         * 预计金额
         */
        amount?: number;
      };
    };
    /**
     * 附件
     */
    attachmentList?: {
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
    }[];
    /**
     * 校验结果
     */
    checkResult?: {
      /**
       * 校验结果
       */
      checkStatus?: number;
      /**
       * 校验失败信息列表
       * isSuccess为false时必填
       */
      checkInfoList?: {
        /**
         * 前端生成的编号
         */
        indexNo?: string;
        /**
         * 校验状态,目前默认为弱控
         * 0-通过 1-弱控 2-强控 3-提示
         */
        checkStatus?: 0 | 1 | 2 | 3;
        /**
         * 警告信息
         */
        warningInfo?: string[];
        /**
         * 唯一值
         */
        uniqueCode?: string[];
        /**
         * 是否参与校验
         * true-校验，false-不校验
         */
        isCheck?: boolean;
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [工作计划详情↗](http://yapi.cai-inc.com/project/3621/interface/api/579026) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `GET /zlb/api/expense/work-plan/info/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkPlanInfoWorkPlanCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/work-plan/info/{workPlanCode}',
    'data',
    'workPlanCode',
    string,
    false
  >
>;

/**
 * 接口 [工作计划详情↗](http://yapi.cai-inc.com/project/3621/interface/api/579026) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `GET /zlb/api/expense/work-plan/info/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
const zlbApiExpenseWorkPlanInfoWorkPlanCodeGetRequestConfig: ZlbApiExpenseWorkPlanInfoWorkPlanCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: '/zlb/api/expense/work-plan/info/{workPlanCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: ['workPlanCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkPlanInfoWorkPlanCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [工作计划详情↗](http://yapi.cai-inc.com/project/3621/interface/api/579026) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `GET /zlb/api/expense/work-plan/info/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkPlanInfoWorkPlanCodeGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkPlanInfoWorkPlanCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkPlanInfoWorkPlanCodeGetResponse>(
    prepare(zlbApiExpenseWorkPlanInfoWorkPlanCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkPlanInfoWorkPlanCodeGet.requestConfig =
  zlbApiExpenseWorkPlanInfoWorkPlanCodeGetRequestConfig;

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/579034) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/nullify/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanNullifyWorkPlanCodePostRequest {
  /**
   * 工作计划单code
   */
  workPlanCode: string;
}

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/579034) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/nullify/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanNullifyWorkPlanCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/579034) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/nullify/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkPlanNullifyWorkPlanCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/work-plan/nullify/{workPlanCode}',
    'data',
    'workPlanCode',
    string,
    false
  >
>;

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/579034) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/nullify/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
const zlbApiExpenseWorkPlanNullifyWorkPlanCodePostRequestConfig: ZlbApiExpenseWorkPlanNullifyWorkPlanCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: '/zlb/api/expense/work-plan/nullify/{workPlanCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: ['workPlanCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkPlanNullifyWorkPlanCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [作废申请单↗](http://yapi.cai-inc.com/project/3621/interface/api/579034) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/nullify/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkPlanNullifyWorkPlanCodePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkPlanNullifyWorkPlanCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkPlanNullifyWorkPlanCodePostResponse>(
    prepare(zlbApiExpenseWorkPlanNullifyWorkPlanCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkPlanNullifyWorkPlanCodePost.requestConfig =
  zlbApiExpenseWorkPlanNullifyWorkPlanCodePostRequestConfig;

/**
 * 接口 [删除工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579042) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/delete/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanDeleteWorkPlanCodePostRequest {
  /**
   * 工作计划单code
   */
  workPlanCode: string;
}

/**
 * 接口 [删除工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579042) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/delete/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanDeleteWorkPlanCodePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579042) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/delete/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkPlanDeleteWorkPlanCodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/work-plan/delete/{workPlanCode}',
    'data',
    'workPlanCode',
    string,
    false
  >
>;

/**
 * 接口 [删除工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579042) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/delete/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
const zlbApiExpenseWorkPlanDeleteWorkPlanCodePostRequestConfig: ZlbApiExpenseWorkPlanDeleteWorkPlanCodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: '/zlb/api/expense/work-plan/delete/{workPlanCode}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: ['workPlanCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkPlanDeleteWorkPlanCodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/579042) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/delete/{workPlanCode}`
 * @更新时间 `2024-05-20 20:01:35`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkPlanDeleteWorkPlanCodePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkPlanDeleteWorkPlanCodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkPlanDeleteWorkPlanCodePostResponse>(
    prepare(zlbApiExpenseWorkPlanDeleteWorkPlanCodePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkPlanDeleteWorkPlanCodePost.requestConfig =
  zlbApiExpenseWorkPlanDeleteWorkPlanCodePostRequestConfig;

/**
 * 接口 [按照行程生成预计的总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/579050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/expected-fee/genByItinerary`
 * @更新时间 `2024-05-20 20:01:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanExpectedFeeGenByItineraryPostRequest {
  /**
   * 行程基本信息
   */
  itineraryInfo?: {
    /**
     * 前端生成的编号
     */
    indexNo?: string;
    /**
     * 行程信息编号
     */
    itineraryCode?: string;
    /**
     * 出差人列表
     */
    accompanyList: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
      /**
       * 外部人员职级
       * 1-省级及相当职级人员 2-正副厅长及相等职级人员 3-其余人员
       */
      outerUserRank?: number;
      /**
       * 人员类型
       * 1-同行人、2-接收人、3-费用、4-提交人、5-乘车人、99-其他
       */
      userType?: number;
      /**
       * 类型
       * 0- 单位内部人员,1-"工资发放人员,2-"司机人员" 3-"外部人员"
       */
      type?: number;
      /**
       * 是否隐藏人员类型显示
       */
      hideOperatorShowType?: boolean;
    }[];
    /**
     * 开始时间
     */
    beginTime: string;
    /**
     * 开始上下午
     * 上午-1，下午-2
     */
    beginTag?: number;
    /**
     * 结束时间
     */
    endTime: string;
    /**
     * 结束上下午
     * 上午-1，下午-2
     */
    endTag?: number;
    /**
     * 出发地code
     */
    beginCityCode: string;
    /**
     * 出发地名称
     */
    beginCityName: string;
    /**
     * 结束地点
     */
    endCityCode: string;
    /**
     * 结束地点名称
     */
    endCityName: string;
    /**
     * 目的地列表
     */
    endCityList?: {
      /**
       * 目的城市code
       */
      endCityCode: string;
      /**
       * 目的城市名称
       */
      endCityName: string;
    }[];
    /**
     * 是否往返
     */
    travelBack: boolean;
    /**
     * 交通工具
     */
    trafficType?: 10 | 20 | 30 | 40 | 50 | 60 | 99;
  };
  /**
   * 业务类型 1-普通出差 2-会议培训 3-外派
   */
  businessType?: number;
}

/**
 * 接口 [按照行程生成预计的总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/579050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/expected-fee/genByItinerary`
 * @更新时间 `2024-05-20 20:01:36`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanExpectedFeeGenByItineraryPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [按照行程生成预计的总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/579050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/expected-fee/genByItinerary`
 * @更新时间 `2024-05-20 20:01:36`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkPlanExpectedFeeGenByItineraryPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/work-plan/expected-fee/genByItinerary',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [按照行程生成预计的总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/579050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/expected-fee/genByItinerary`
 * @更新时间 `2024-05-20 20:01:36`
 * @项目ID 3621
 */
const zlbApiExpenseWorkPlanExpectedFeeGenByItineraryPostRequestConfig: ZlbApiExpenseWorkPlanExpectedFeeGenByItineraryPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: '/zlb/api/expense/work-plan/expected-fee/genByItinerary',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkPlanExpectedFeeGenByItineraryPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [按照行程生成预计的总金额↗](http://yapi.cai-inc.com/project/3621/interface/api/579050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/expected-fee/genByItinerary`
 * @更新时间 `2024-05-20 20:01:36`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkPlanExpectedFeeGenByItineraryPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkPlanExpectedFeeGenByItineraryPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkPlanExpectedFeeGenByItineraryPostResponse>(
    prepare(zlbApiExpenseWorkPlanExpectedFeeGenByItineraryPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkPlanExpectedFeeGenByItineraryPost.requestConfig =
  zlbApiExpenseWorkPlanExpectedFeeGenByItineraryPostRequestConfig;

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/579058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/page`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 事由
   */
  reason?: string;
  /**
   * 名称
   */
  name?: string;
  /**
   * 开始时间开始
   */
  beginTimeStart?: string;
  /**
   * 开始时间结束
   */
  beginTimeEnd?: string;
  /**
   * 结束时间开始
   */
  endTimeStart?: string;
  /**
   * 结束时间结束
   */
  endTimeEnd?: string;
  /**
   * 业务类型
   */
  businessType?: number;
  /**
   * 单据状态列表
   */
  formStatus?: number;
  /**
   * 业务单据编号
   */
  businessCode?: string;
  /**
   * 申请单业务编号
   */
  applyFormBusinessCode?: string;
  /**
   * 仅未关联
   */
  onlyNotAssociate?: boolean;
  /**
   * 是否是APP
   */
  isApp?: boolean;
  /**
   * 联合搜索
   */
  combinationSearch?: string;
  /**
   * 0-未知,1- 未关联，2- 已关联
   */
  associate?: number;
}

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/579058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/page`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 工作计划编号
       */
      workPlanCode?: string;
      /**
       * 业务编号
       */
      businessCode?: string;
      /**
       * 业务类型
       */
      businessType?: number;
      /**
       * 业务类型编码
       */
      businessTypeDesc?: string;
      /**
       * 事由
       */
      reason?: string;
      /**
       * 标题
       */
      title?: string;
      /**
       * 经办人id
       */
      operatorId?: number;
      /**
       * 经办人名称
       */
      operatorName?: string;
      /**
       * 发起时间单据保存时间
       */
      initiationTime?: string;
      /**
       * 申请单关联单号
       */
      applyFormCode?: string;
      /**
       * 申请单关联业务编号
       */
      applyFormBusinessCode?: string;
      /**
       * 单据状态
       */
      formStatus?: number;
      /**
       * 单据状态描述
       */
      formStatusDesc?: string;
      /**
       * 部门名称
       */
      deptName?: string;
      /**
       * 金额
       */
      amount?: number;
      /**
       * 按钮
       */
      button?: {
        /**
         * 查看
         */
        detail?: boolean;
        /**
         * 编辑
         */
        edit?: boolean;
        /**
         * 删除
         */
        delete?: boolean;
        /**
         * 作废
         */
        nullify?: boolean;
      };
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/579058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/page`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkPlanPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/work-plan/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/579058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/page`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
const zlbApiExpenseWorkPlanPagePostRequestConfig: ZlbApiExpenseWorkPlanPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: '/zlb/api/expense/work-plan/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkPlanPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询申请单列表↗](http://yapi.cai-inc.com/project/3621/interface/api/579058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/page`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkPlanPagePost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkPlanPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkPlanPagePostResponse>(
    prepare(zlbApiExpenseWorkPlanPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkPlanPagePost.requestConfig = zlbApiExpenseWorkPlanPagePostRequestConfig;

/**
 * 接口 [解除绑定↗](http://yapi.cai-inc.com/project/3621/interface/api/582354) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/un-bind`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanUnBindPostRequest {
  /**
   * 申请单code
   */
  applyFormCode: string;
  /**
   * 工作计划code
   */
  workPlanCode: string;
}

/**
 * 接口 [解除绑定↗](http://yapi.cai-inc.com/project/3621/interface/api/582354) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/un-bind`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
export interface ZlbApiExpenseWorkPlanUnBindPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [解除绑定↗](http://yapi.cai-inc.com/project/3621/interface/api/582354) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/un-bind`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
type ZlbApiExpenseWorkPlanUnBindPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/work-plan/un-bind',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [解除绑定↗](http://yapi.cai-inc.com/project/3621/interface/api/582354) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/un-bind`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
const zlbApiExpenseWorkPlanUnBindPostRequestConfig: ZlbApiExpenseWorkPlanUnBindPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: '/zlb/api/expense/work-plan/un-bind',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseWorkPlanUnBindPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [解除绑定↗](http://yapi.cai-inc.com/project/3621/interface/api/582354) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [工作计划↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54080)
 * @请求头 `POST /zlb/api/expense/work-plan/un-bind`
 * @更新时间 `2024-05-20 20:01:37`
 * @项目ID 3621
 */
export const zlbApiExpenseWorkPlanUnBindPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseWorkPlanUnBindPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseWorkPlanUnBindPostResponse>(
    prepare(zlbApiExpenseWorkPlanUnBindPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseWorkPlanUnBindPost.requestConfig = zlbApiExpenseWorkPlanUnBindPostRequestConfig;

const mockUrl_0_1_0_27 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_27 = '' as any;
const prodUrl_0_1_0_27 = '' as any;
const dataKey_0_1_0_27 = 'data' as any;

/**
 * 接口 [账单列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/601458) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [ExpensePublicBillController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54579)
 * @请求头 `POST /zlb/api/expense/public/bill/list`
 * @更新时间 `2024-07-17 20:22:02`
 * @项目ID 3621
 */
export interface ZlbApiExpensePublicBillListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 缴费项目
   * 1-水费 2-电费 3-燃气费 4-话费 5-邮费 6-过路费 7-五险一金(作废) 8-个税 9-社保 10-公积金 11-残保金 99-其他
   */
  paymentProjectType?: number;
  /**
   * 账单月份
   */
  billMonth?: number;
  /**
   * 缴费户名
   */
  paymentAccountName?: string;
  /**
   * 是否展示已报销的账单
   */
  filterReimbursedForm?: boolean;
  /**
   * 需要过滤的账单
   */
  excludePublicBillCodeList?: string[];
}

/**
 * 接口 [账单列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/601458) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [ExpensePublicBillController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54579)
 * @请求头 `POST /zlb/api/expense/public/bill/list`
 * @更新时间 `2024-07-17 20:22:02`
 * @项目ID 3621
 */
export interface ZlbApiExpensePublicBillListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 报销单code
       */
      formCode?: string;
      /**
       * 区划code
       */
      districtCode?: string;
      /**
       * 租户名称
       */
      districtName?: string;
      /**
       * 公共事业缴费code
       */
      publicBillCode?: string;
      /**
       * 缴费项目
       * 1-水费  2-电费 3-燃气费  4-话费 5-邮费 6-过路费
       */
      paymentProjectType: number;
      /**
       * 缴费项目描述
       */
      paymentProjectTypeDesc?: string;
      /**
       * 收费单位
       */
      chargeOrgName: string;
      /**
       * 缴费账户
       */
      paymentAccountName: string;
      /**
       * 账单月份
       */
      billMonth: string;
      /**
       * 金额：分
       */
      amount: number;
      /**
       * 扩展字段
       */
      extendFiled?: string;
      /**
       * 账单来源 0手动上传 1自动同步
       */
      origin?: number;
      /**
       * 关联的票据ID
       */
      platformInvoiceId?: string;
      /**
       * 单据唯一编码
       */
      expenseBusinessCode?: string;
      /**
       * 报销单状态
       */
      expenseFormStatus?: number;
      /**
       * 报销单状态
       */
      expenseFormStatusDesc?: string;
      /**
       * 是否开票 1已开票 0未开票
       */
      invoiceUrl?: number;
      /**
       * 账单附件
       */
      billAttachmentFileList?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
      }[];
      /**
       * 行程信息
       */
      publicBillItineraryList?: {
        /**
         * 入口信息
         */
        exStationName?: string;
        /**
         * 出口信息
         */
        enStationName?: string;
        /**
         * 通行日期起 yyyy/MM/dd
         */
        exTime?: string;
        /**
         * 通行日期止 yyyy/MM/dd
         */
        enTime?: string;
        /**
         * 开票金额，分
         */
        fee?: number;
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [账单列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/601458) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [ExpensePublicBillController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54579)
 * @请求头 `POST /zlb/api/expense/public/bill/list`
 * @更新时间 `2024-07-17 20:22:02`
 * @项目ID 3621
 */
type ZlbApiExpensePublicBillListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/public/bill/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [账单列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/601458) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [ExpensePublicBillController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54579)
 * @请求头 `POST /zlb/api/expense/public/bill/list`
 * @更新时间 `2024-07-17 20:22:02`
 * @项目ID 3621
 */
const zlbApiExpensePublicBillListPostRequestConfig: ZlbApiExpensePublicBillListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_27,
    devUrl: devUrl_0_1_0_27,
    prodUrl: prodUrl_0_1_0_27,
    path: '/zlb/api/expense/public/bill/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpensePublicBillListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [账单列表查询↗](http://yapi.cai-inc.com/project/3621/interface/api/601458) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [ExpensePublicBillController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54579)
 * @请求头 `POST /zlb/api/expense/public/bill/list`
 * @更新时间 `2024-07-17 20:22:02`
 * @项目ID 3621
 */
export const zlbApiExpensePublicBillListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpensePublicBillListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpensePublicBillListPostResponse>(
    prepare(zlbApiExpensePublicBillListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpensePublicBillListPost.requestConfig = zlbApiExpensePublicBillListPostRequestConfig;

const mockUrl_0_1_0_28 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_28 = '' as any;
const prodUrl_0_1_0_28 = '' as any;
const dataKey_0_1_0_28 = 'data' as any;

/**
 * 接口 [预算项目部门列表查询（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/department-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607754) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectDepartmentListPostRequest {
  /**
   * 机构ID
   */
  orgId?: number;
}

/**
 * 接口 [预算项目部门列表查询（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/department-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607754) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectDepartmentListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 百搭冗余字段:部门名称
     */
    label?: string;
    /**
     * 百搭冗余字段:部门ID
     */
    value?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [预算项目部门列表查询（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/department-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607754) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetProjectDepartmentListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget-project/department-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [预算项目部门列表查询（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/department-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607754) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetProjectDepartmentListPostRequestConfig: ZlbApiExpenseBudgetProjectDepartmentListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_28,
    devUrl: devUrl_0_1_0_28,
    prodUrl: prodUrl_0_1_0_28,
    path: '/zlb/api/expense/budget-project/department-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetProjectDepartmentListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [预算项目部门列表查询（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/department-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607754) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetProjectDepartmentListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetProjectDepartmentListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetProjectDepartmentListPostResponse>(
    prepare(zlbApiExpenseBudgetProjectDepartmentListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetProjectDepartmentListPost.requestConfig =
  zlbApiExpenseBudgetProjectDepartmentListPostRequestConfig;

/**
 * 接口 [根据预算部门查询项目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/project-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607762) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectProjectListPostRequest {
  /**
   * 机构ID
   */
  orgId?: number;
  /**
   * 部门ID
   */
  depId?: number;
  /**
   * 部门名称
   */
  depName?: string;
  /**
   * 经办人id、出差人id、同行人id 集合
   */
  operatorIdList?: number[];
  /**
   * 可选, 科目类别 income-收入 disburse-支出 不传默认disburse
   */
  subjectType?: string;
}

/**
 * 接口 [根据预算部门查询项目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/project-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607762) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectProjectListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 百搭冗余字段:项目名称
     */
    label?: string;
    /**
     * 百搭冗余字段:项目编号
     */
    value?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据预算部门查询项目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/project-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607762) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetProjectProjectListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget-project/project-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据预算部门查询项目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/project-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607762) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetProjectProjectListPostRequestConfig: ZlbApiExpenseBudgetProjectProjectListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_28,
    devUrl: devUrl_0_1_0_28,
    prodUrl: prodUrl_0_1_0_28,
    path: '/zlb/api/expense/budget-project/project-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetProjectProjectListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据预算部门查询项目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/project-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/607762) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:25:59`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetProjectProjectListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetProjectProjectListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetProjectProjectListPostResponse>(
    prepare(zlbApiExpenseBudgetProjectProjectListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetProjectProjectListPost.requestConfig =
  zlbApiExpenseBudgetProjectProjectListPostRequestConfig;

/**
 * 接口 [根据预算部门，项目列表查询科目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/subject-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/611386) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectSubjectListPostRequest {
  /**
   * 机构ID
   */
  orgId?: number;
  /**
   * 部门ID
   */
  depId?: number;
  /**
   * 部门名称
   */
  depName?: string;
  /**
   * 项目uk
   */
  projectUk?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 单据编号
   */
  formCode?: string;
  /**
   * 经办人id、出差人id、同行人id 集合
   */
  operatorIdList?: number[];
  /**
   * 可选, 科目类别 income-收入 disburse-支出 不传默认disburse
   */
  subjectType?: string;
}

/**
 * 接口 [根据预算部门，项目列表查询科目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/subject-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/611386) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectSubjectListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 百搭冗余字段: 科目名称
     */
    label?: string;
    /**
     * 百搭冗余字段: 科目编号
     */
    value?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据预算部门，项目列表查询科目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/subject-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/611386) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetProjectSubjectListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget-project/subject-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据预算部门，项目列表查询科目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/subject-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/611386) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetProjectSubjectListPostRequestConfig: ZlbApiExpenseBudgetProjectSubjectListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_28,
    devUrl: devUrl_0_1_0_28,
    prodUrl: prodUrl_0_1_0_28,
    path: '/zlb/api/expense/budget-project/subject-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetProjectSubjectListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据预算部门，项目列表查询科目列表（已迁至预算应用，新接口\/zlb\/budget\/ep\/project-use\/subject-list）↗](http://yapi.cai-inc.com/project/3621/interface/api/611386) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetProjectSubjectListPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetProjectSubjectListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetProjectSubjectListPostResponse>(
    prepare(zlbApiExpenseBudgetProjectSubjectListPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetProjectSubjectListPost.requestConfig =
  zlbApiExpenseBudgetProjectSubjectListPostRequestConfig;

/**
 * 接口 [预算项目部门列表查询（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675178) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectDepartmentListGetRequest {
  /**
   * 机构ID
   */
  orgId?: string;
}

/**
 * 接口 [预算项目部门列表查询（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675178) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectDepartmentListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 百搭冗余字段:部门名称
     */
    label?: string;
    /**
     * 百搭冗余字段:部门ID
     */
    value?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [预算项目部门列表查询（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675178) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetProjectDepartmentListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget-project/department-list',
    'data',
    string,
    'orgId',
    false
  >
>;

/**
 * 接口 [预算项目部门列表查询（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675178) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetProjectDepartmentListGetRequestConfig: ZlbApiExpenseBudgetProjectDepartmentListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_28,
    devUrl: devUrl_0_1_0_28,
    prodUrl: prodUrl_0_1_0_28,
    path: '/zlb/api/expense/budget-project/department-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_28,
    paramNames: [],
    queryNames: ['orgId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetProjectDepartmentListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [预算项目部门列表查询（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675178) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/department-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetProjectDepartmentListGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetProjectDepartmentListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetProjectDepartmentListGetResponse>(
    prepare(zlbApiExpenseBudgetProjectDepartmentListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetProjectDepartmentListGet.requestConfig =
  zlbApiExpenseBudgetProjectDepartmentListGetRequestConfig;

/**
 * 接口 [根据预算部门查询项目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675186) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectProjectListGetRequest {
  /**
   * 机构ID
   */
  orgId?: string;
  /**
   * 部门ID
   */
  depId?: string;
  /**
   * 部门名称
   */
  depName?: string;
  /**
   * 经办人id、出差人id、同行人id 集合
   */
  'operatorIdList[0]'?: string;
  /**
   * 可选, 科目类别 income-收入 disburse-支出 不传默认disburse
   */
  subjectType?: string;
}

/**
 * 接口 [根据预算部门查询项目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675186) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectProjectListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 百搭冗余字段:项目名称
     */
    label?: string;
    /**
     * 百搭冗余字段:项目编号
     */
    value?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据预算部门查询项目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675186) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetProjectProjectListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget-project/project-list',
    'data',
    string,
    'orgId' | 'depId' | 'depName' | 'operatorIdList[0]' | 'subjectType',
    false
  >
>;

/**
 * 接口 [根据预算部门查询项目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675186) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetProjectProjectListGetRequestConfig: ZlbApiExpenseBudgetProjectProjectListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_28,
    devUrl: devUrl_0_1_0_28,
    prodUrl: prodUrl_0_1_0_28,
    path: '/zlb/api/expense/budget-project/project-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_28,
    paramNames: [],
    queryNames: ['orgId', 'depId', 'depName', 'operatorIdList[0]', 'subjectType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetProjectProjectListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据预算部门查询项目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675186) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/project-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetProjectProjectListGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetProjectProjectListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetProjectProjectListGetResponse>(
    prepare(zlbApiExpenseBudgetProjectProjectListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetProjectProjectListGet.requestConfig =
  zlbApiExpenseBudgetProjectProjectListGetRequestConfig;

/**
 * 接口 [根据预算部门，项目列表查询科目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675194) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectSubjectListGetRequest {
  /**
   * 机构ID
   */
  orgId?: string;
  /**
   * 部门ID
   */
  depId?: string;
  /**
   * 部门名称
   */
  depName?: string;
  /**
   * 项目uk
   */
  projectUk?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 单据编号
   */
  formCode?: string;
  /**
   * 经办人id、出差人id、同行人id 集合
   */
  'operatorIdList[0]'?: string;
  /**
   * 可选, 科目类别 income-收入 disburse-支出 不传默认disburse
   */
  subjectType?: string;
}

/**
 * 接口 [根据预算部门，项目列表查询科目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675194) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export interface ZlbApiExpenseBudgetProjectSubjectListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 部门ID
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 项目编号
     */
    projectUk?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 科目编号
     */
    subjectUk?: string;
    /**
     * 科目名称
     */
    subjectName?: string;
    /**
     * 预算填报记录编号
     */
    budgetProjectRecordUk?: string;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 百搭冗余字段: 科目名称
     */
    label?: string;
    /**
     * 百搭冗余字段: 科目编号
     */
    value?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据预算部门，项目列表查询科目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675194) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
type ZlbApiExpenseBudgetProjectSubjectListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/budget-project/subject-list',
    'data',
    string,
    | 'orgId'
    | 'depId'
    | 'depName'
    | 'projectUk'
    | 'projectName'
    | 'formCode'
    | 'operatorIdList[0]'
    | 'subjectType',
    false
  >
>;

/**
 * 接口 [根据预算部门，项目列表查询科目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675194) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
const zlbApiExpenseBudgetProjectSubjectListGetRequestConfig: ZlbApiExpenseBudgetProjectSubjectListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_28,
    devUrl: devUrl_0_1_0_28,
    prodUrl: prodUrl_0_1_0_28,
    path: '/zlb/api/expense/budget-project/subject-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_28,
    paramNames: [],
    queryNames: [
      'orgId',
      'depId',
      'depName',
      'projectUk',
      'projectName',
      'formCode',
      'operatorIdList[0]',
      'subjectType',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseBudgetProjectSubjectListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据预算部门，项目列表查询科目列表（废弃）↗](http://yapi.cai-inc.com/project/3621/interface/api/675194) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算项目↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_54647)
 * @标签 `deprecated`
 * @请求头 `GET /zlb/api/expense/budget-project/subject-list`
 * @更新时间 `2024-06-26 19:26:00`
 * @项目ID 3621
 */
export const zlbApiExpenseBudgetProjectSubjectListGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseBudgetProjectSubjectListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseBudgetProjectSubjectListGetResponse>(
    prepare(zlbApiExpenseBudgetProjectSubjectListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseBudgetProjectSubjectListGet.requestConfig =
  zlbApiExpenseBudgetProjectSubjectListGetRequestConfig;

const mockUrl_0_1_0_29 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_29 = '' as any;
const prodUrl_0_1_0_29 = '' as any;
const dataKey_0_1_0_29 = 'data' as any;

/**
 * 接口 [获取申报单导入模版文件id↗](http://yapi.cai-inc.com/project/3621/interface/api/671498) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `GET /zlb/api/expense/declaration/import/get-template`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationImportGetTemplateGetRequest {
  declarationType?: string;
}

/**
 * 接口 [获取申报单导入模版文件id↗](http://yapi.cai-inc.com/project/3621/interface/api/671498) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `GET /zlb/api/expense/declaration/import/get-template`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationImportGetTemplateGetResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [获取申报单导入模版文件id↗](http://yapi.cai-inc.com/project/3621/interface/api/671498) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `GET /zlb/api/expense/declaration/import/get-template`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationImportGetTemplateGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/import/get-template',
    'data',
    string,
    'declarationType',
    false
  >
>;

/**
 * 接口 [获取申报单导入模版文件id↗](http://yapi.cai-inc.com/project/3621/interface/api/671498) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `GET /zlb/api/expense/declaration/import/get-template`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationImportGetTemplateGetRequestConfig: ZlbApiExpenseDeclarationImportGetTemplateGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: '/zlb/api/expense/declaration/import/get-template',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: ['declarationType'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationImportGetTemplateGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取申报单导入模版文件id↗](http://yapi.cai-inc.com/project/3621/interface/api/671498) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `GET /zlb/api/expense/declaration/import/get-template`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationImportGetTemplateGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationImportGetTemplateGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationImportGetTemplateGetResponse>(
    prepare(zlbApiExpenseDeclarationImportGetTemplateGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationImportGetTemplateGet.requestConfig =
  zlbApiExpenseDeclarationImportGetTemplateGetRequestConfig;

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/671506) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/submit`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationImportSubmitPostRequest {
  /**
   * 待导入的文件ossId
   */
  fileId: string;
  /**
   * 导入任务类型(暂时一种导入批量发放申报单4001，为后续预留)
   *
   * {@link  cn.gov.zlb.finance.expense.domain.enums.imports.TaskTypeEnum}
   */
  importType: number;
}

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/671506) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/submit`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationImportSubmitPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/671506) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/submit`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationImportSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/import/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/671506) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/submit`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationImportSubmitPostRequestConfig: ZlbApiExpenseDeclarationImportSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: '/zlb/api/expense/declaration/import/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationImportSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导入任务提交↗](http://yapi.cai-inc.com/project/3621/interface/api/671506) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/submit`
 * @更新时间 `2024-06-24 13:53:41`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationImportSubmitPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationImportSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationImportSubmitPostResponse>(
    prepare(zlbApiExpenseDeclarationImportSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationImportSubmitPost.requestConfig =
  zlbApiExpenseDeclarationImportSubmitPostRequestConfig;

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/671514) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/get-result`
 * @更新时间 `2024-06-24 13:53:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationImportGetResultPostRequest {
  /**
   * 任务编号
   */
  serialCode: string;
  /**
   * 任务类型
   */
  taskType?: string;
}

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/671514) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/get-result`
 * @更新时间 `2024-06-24 13:53:42`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationImportGetResultPostResponse {
  success?: boolean;
  result?: {
    /**
     * 导入总条数
     */
    totalNum?: number;
    /**
     * 成功条数
     */
    successNum?: number;
    /**
     * 失败条数
     */
    failNum?: number;
    /**
     * 重复次数
     */
    repeatNum?: number;
    /**
     * 失败的完整fileId
     */
    failFileId?: string;
    /**
     * 序列号
     */
    serialCode?: string;
    /**
     * 导入信息
     */
    message?: string;
    /**
     * 任务状态 0-失败 1-成功
     */
    status?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/671514) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/get-result`
 * @更新时间 `2024-06-24 13:53:42`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationImportGetResultPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/import/get-result',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/671514) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/get-result`
 * @更新时间 `2024-06-24 13:53:42`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationImportGetResultPostRequestConfig: ZlbApiExpenseDeclarationImportGetResultPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: '/zlb/api/expense/declaration/import/get-result',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationImportGetResultPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导入任务结果↗](http://yapi.cai-inc.com/project/3621/interface/api/671514) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [申报单导入控制类↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_55831)
 * @请求头 `POST /zlb/api/expense/declaration/import/get-result`
 * @更新时间 `2024-06-24 13:53:42`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationImportGetResultPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationImportGetResultPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationImportGetResultPostResponse>(
    prepare(zlbApiExpenseDeclarationImportGetResultPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationImportGetResultPost.requestConfig =
  zlbApiExpenseDeclarationImportGetResultPostRequestConfig;

const mockUrl_0_1_0_30 = 'http://yapi.cai-inc.com/mock/3621' as any;
const devUrl_0_1_0_30 = '' as any;
const prodUrl_0_1_0_30 = '' as any;
const dataKey_0_1_0_30 = 'data' as any;

/**
 * 接口 [获取租户以及单位的关联(前端进行分页) 参考运营管理- 费用标准↗](http://yapi.cai-inc.com/project/3621/interface/api/683890) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `GET /zlb/api/expense/declaration/transfer/config/get-relation/list`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationTransferConfigGetRelationListGetRequest {
  /**
   * 单位id(如果查询主体为某个单位的转交配置需要)
   */
  orgId?: string;
  /**
   * 租户code(如果查询主体为某个租户的转交配置需要)
   */
  tenantCode?: string;
}

/**
 * 接口 [获取租户以及单位的关联(前端进行分页) 参考运营管理- 费用标准↗](http://yapi.cai-inc.com/project/3621/interface/api/683890) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `GET /zlb/api/expense/declaration/transfer/config/get-relation/list`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationTransferConfigGetRelationListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 关联的单位列表
     */
    orgList?: {
      /**
       * 机构id
       */
      orgId?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 统一社会信用代码
       */
      creditCode?: string;
      /**
       * 租户code
       */
      tenantCode?: string;
      /**
       * 租户名称
       */
      tenantName?: string;
    }[];
    /**
     * 关联的租户列表
     */
    tenantList?: {
      /**
       * 租户编码
       */
      tenantCode?: string;
      /**
       * 租户名称
       */
      tenantName?: string;
      /**
       * 租户类型
       */
      tenantType?: string;
      /**
       * 租户类型展示项
       */
      tenantTypeName?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取租户以及单位的关联(前端进行分页) 参考运营管理- 费用标准↗](http://yapi.cai-inc.com/project/3621/interface/api/683890) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `GET /zlb/api/expense/declaration/transfer/config/get-relation/list`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationTransferConfigGetRelationListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/transfer/config/get-relation/list',
    'data',
    string,
    'orgId' | 'tenantCode',
    false
  >
>;

/**
 * 接口 [获取租户以及单位的关联(前端进行分页) 参考运营管理- 费用标准↗](http://yapi.cai-inc.com/project/3621/interface/api/683890) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `GET /zlb/api/expense/declaration/transfer/config/get-relation/list`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationTransferConfigGetRelationListGetRequestConfig: ZlbApiExpenseDeclarationTransferConfigGetRelationListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: '/zlb/api/expense/declaration/transfer/config/get-relation/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: ['orgId', 'tenantCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationTransferConfigGetRelationListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取租户以及单位的关联(前端进行分页) 参考运营管理- 费用标准↗](http://yapi.cai-inc.com/project/3621/interface/api/683890) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `GET /zlb/api/expense/declaration/transfer/config/get-relation/list`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationTransferConfigGetRelationListGet = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationTransferConfigGetRelationListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationTransferConfigGetRelationListGetResponse>(
    prepare(zlbApiExpenseDeclarationTransferConfigGetRelationListGetRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationTransferConfigGetRelationListGet.requestConfig =
  zlbApiExpenseDeclarationTransferConfigGetRelationListGetRequestConfig;

/**
 * 接口 [更新租户或单位关联关系(可能新增, 可能删除已有)↗](http://yapi.cai-inc.com/project/3621/interface/api/685770) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `POST /zlb/api/expense/declaration/transfer/config/update-bind`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationTransferConfigUpdateBindPostRequest {
  /**
   * 机构id(如果为单位配置可转交范围传入)
   */
  orgId?: number;
  /**
   * 租户编码(如果为租户配置可转交范围传入)
   */
  tenantCode?: string;
  /**
   * 更新后的租户code列表(针对租户时传入)
   */
  tenantCodeList?: string[];
  /**
   * 更新后的机构id列表(针对机构时传入)
   */
  orgIdList?: number[];
}

/**
 * 接口 [更新租户或单位关联关系(可能新增, 可能删除已有)↗](http://yapi.cai-inc.com/project/3621/interface/api/685770) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `POST /zlb/api/expense/declaration/transfer/config/update-bind`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
export interface ZlbApiExpenseDeclarationTransferConfigUpdateBindPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [更新租户或单位关联关系(可能新增, 可能删除已有)↗](http://yapi.cai-inc.com/project/3621/interface/api/685770) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `POST /zlb/api/expense/declaration/transfer/config/update-bind`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
type ZlbApiExpenseDeclarationTransferConfigUpdateBindPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/3621',
    '',
    '',
    '/zlb/api/expense/declaration/transfer/config/update-bind',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [更新租户或单位关联关系(可能新增, 可能删除已有)↗](http://yapi.cai-inc.com/project/3621/interface/api/685770) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `POST /zlb/api/expense/declaration/transfer/config/update-bind`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
const zlbApiExpenseDeclarationTransferConfigUpdateBindPostRequestConfig: ZlbApiExpenseDeclarationTransferConfigUpdateBindPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: '/zlb/api/expense/declaration/transfer/config/update-bind',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbApiExpenseDeclarationTransferConfigUpdateBindPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [更新租户或单位关联关系(可能新增, 可能删除已有)↗](http://yapi.cai-inc.com/project/3621/interface/api/685770) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [DeclarationTransferConfigController↗](http://yapi.cai-inc.com/project/3621/interface/api/cat_56074)
 * @请求头 `POST /zlb/api/expense/declaration/transfer/config/update-bind`
 * @更新时间 `2024-07-18 17:47:07`
 * @项目ID 3621
 */
export const zlbApiExpenseDeclarationTransferConfigUpdateBindPost = /*#__PURE__*/ (
  requestData: ZlbApiExpenseDeclarationTransferConfigUpdateBindPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbApiExpenseDeclarationTransferConfigUpdateBindPostResponse>(
    prepare(zlbApiExpenseDeclarationTransferConfigUpdateBindPostRequestConfig, requestData),
    ...args,
  );
};

zlbApiExpenseDeclarationTransferConfigUpdateBindPost.requestConfig =
  zlbApiExpenseDeclarationTransferConfigUpdateBindPostRequestConfig;

/* prettier-ignore-end */
